// Real data from Feishu tables
// Table 1: recruitment needs (tblEiMBFXcvSspQd)
// Table 2: candidates (tblWkwsoTIPhzusI)
// Generated: 2026-07-08

export interface FeishuNeed {
  id: string;
  dept: string;
  position: string;
  count: number;
  priority: 'P0' | 'P1' | 'P2';
  budget: string;
  status: string;
  recruiter: string;
  publish: string;
  received: number;
  target: string;
  city: string;
  subDept: string;
  startDate: string;
  endDate: string;
  jd: string;
  capabilityReq: string;
  interview1: string | null;
  interview2: string | null;
  interview3: string | null;
  reason: string;
  progress: string | number | null;
  inBudget: string | null;
}

export interface FeishuCandidate {
  id: number;
  name: string;
  role: string;
  company: string;
  years: number;
  edu: string;
  salary: string;
  match: number;
  tags: string[];
  stage: string;
  star: number;
  avatar: string;
  dept: string;
  city: string;
  age: string;
  gender: string;
  strengths: string;
  risks: string;
  aiEval: string;
  aiScreen: string;
  hrReview: string;
  interviewPos: string;
  interviewQ: string;
  capabilityMatch: string;
  created: string;
}

export const feishuNeeds: FeishuNeed[] = [
  {
    "id": "HC-2026-001",
    "dept": "养老及商业事业部 · 大客户业务部",
    "position": "大客户经理",
    "count": 1,
    "priority": "P2",
    "budget": "新增HC",
    "status": "已入职",
    "recruiter": "何雨菱",
    "publish": "宁波",
    "received": 0,
    "target": "2026-03-31",
    "city": "宁波",
    "subDept": "大客户业务部",
    "startDate": "2026-03-01",
    "endDate": "2026-03-31",
    "jd": "岗位职责：\n1. 市场调研与客户开发\n深度洞察家政服务市场动态，精准把握行业趋势与客户需求，通过专业的市场调研方法，挖掘潜在的头部客户资源；筛选并锁定具有战略价值的行业头部客户，凭借出色的商务拓展能力，成功签约并建立稳固的战略级合作关系，助力公司在高端家政服务市场占据领先地位。\n2. 解决方案输出\n根据不同客户的个性化需求，设计定制化的合作方案，确保服务方案精准贴合客户期望；独立撰写高质量的商业计划书及投标方案，突出公司服务优势与价值，以专业、严谨的方案呈现，提升公司在项目竞标中的中标率，为业务拓展奠定坚实基础。\n3. 谈判、合作落地与延续\n作为公司与合作单位的关键沟通桥梁，主导商务谈判，凭借卓越的沟通技巧与谈判能力，推动合同顺利签订，确保合作项目快速落地实施；在合作过程中，全程监控服务交付质量，及时协调解决可能出现的问题，保障客户满意度持续高位运行。同时，敏锐捕捉客户潜在需求，积极推动客户续约，并拓展增值服务销售，实现客户价值最大化与业务持续增长。\n4. 资源整合与跨界合作\n积极拓展内外部生态伙伴资源，与上下游企业、相关行业机构等建立广泛合作关系，整合各方优势资源，为公司业务发展提供有力支撑；基于资源整合成果，设计创新的跨界合作产品，打破传统家政服务边界，探索新的业务增长点，提升公司在多元化市场中的竞争力与影响力。\n \n任职要求：\n【专业背景】\n本科及以上学历，市场营销、商务管理、家政服务等相关专业优先，扎实的专业知识为业务拓展提供理论支撑。\n【工作经验】\n5年以上大客户销售或商务拓展经验，其中至少2年专注于家政服务、母婴行业、生活服务或相关领域，丰富的行业经验助力快速适应岗位需求。\n【客户资源】\n带有行业头部客户资源者优先，自带资源的候选人将直接为公司业务注入强大动力，加速市场拓展进程。\n【商务能力】\n精通商务谈判技巧，具备出色的沟通协调能力，能够与不同层级的客户及合作伙伴建立良好关系，推动合作顺利开展。\n熟练掌握市场调研方法与工具，善于从市场数据中挖掘有价值信息，为决策提供有力依据。\n【项目管理】\n具备优秀的项目管理能力，能够高效组织跨部门团队，确保合作项目按时、高质量交付，保障客户满意度。\n【创新思维】\n思维活跃，富有创新精神，善于跨界思考，能够结合市场趋势与公司资源，设计出具有竞争力的跨界合作产品，为公司开拓新的业务领域。\n【抗压能力】\n能够在高强度的工作环境中保持积极心态，具备出色的时间管理与任务优先级划分能力，确保各项工作有序推进。",
    "capabilityReq": "1. - 市场洞察能力\n- 简要定义：深度分析家政服务市场动态与客户需求，挖掘潜在头部客户资源的能力\n- 典型行为表现：通过专业市场调研方法把握行业趋势，筛选锁定具有战略价值的行业头部客户\n2. - 方案设计能力\n- 简要定义：根据客户个性化需求设计定制化合作方案并撰写高质量商业计划书及投标方案的能力\n- 典型行为表现：设计贴合客户期望的服务方案，独立撰写突出公司优势的投标方案以提升中标率\n3. - 商务谈判能力\n- 简要定义：主导商务谈判推动合同签订，监控服务交付质量并协调解决问题以保障客户满意度的能力\n- 典型行为表现：凭借沟通技巧与谈判能力促成合同签订，全程监控服务交付并及时协调解决合作问题\n4. - 资源整合能力\n- 简要定义：拓展内外部生态伙伴资源并整合优势资源，设计创新跨界合作产品的能力\n- 典型行为表现：与上下游企业及相关机构建立合作关系，基于资源整合设计跨界合作产品探索新业务增长点\n5. - 项目管理能力\n- 简要定义：高效组织跨部门团队确保合作项目按时、高质量交付的能力\n- 典型行为表现：组织跨部门团队推进项目，保障合作项目在规定时间内高质量完成交付",
    "interview1": "曾颖",
    "interview2": "杜雁玲",
    "interview3": "王彦强",
    "reason": "新增HC",
    "progress": "31",
    "inBudget": null
  },
  {
    "id": "HC-2026-002",
    "dept": "养老及商业事业部 · 大客户业务部",
    "position": "大客户经理",
    "count": 1,
    "priority": "P2",
    "budget": "",
    "status": "待招聘",
    "recruiter": "何雨菱",
    "publish": "",
    "received": 0,
    "target": "",
    "city": "",
    "subDept": "大客户业务部",
    "startDate": "",
    "endDate": "",
    "jd": "岗位职责：\n1. 市场调研与客户开发\n深度洞察家政服务市场动态，精准把握行业趋势与客户需求，通过专业的市场调研方法，挖掘潜在的头部客户资源；筛选并锁定具有战略价值的行业头部客户，凭借出色的商务拓展能力，成功签约并建立稳固的战略级合作关系，助力公司在高端家政服务市场占据领先地位。\n2. 解决方案输出\n根据不同客户的个性化需求，设计定制化的合作方案，确保服务方案精准贴合客户期望；独立撰写高质量的商业计划书及投标方案，突出公司服务优势与价值，以专业、严谨的方案呈现，提升公司在项目竞标中的中标率，为业务拓展奠定坚实基础。\n3. 谈判、合作落地与延续\n作为公司与合作单位的关键沟通桥梁，主导商务谈判，凭借卓越的沟通技巧与谈判能力，推动合同顺利签订，确保合作项目快速落地实施；在合作过程中，全程监控服务交付质量，及时协调解决可能出现的问题，保障客户满意度持续高位运行。同时，敏锐捕捉客户潜在需求，积极推动客户续约，并拓展增值服务销售，实现客户价值最大化与业务持续增长。\n4. 资源整合与跨界合作\n积极拓展内外部生态伙伴资源，与上下游企业、相关行业机构等建立广泛合作关系，整合各方优势资源，为公司业务发展提供有力支撑；基于资源整合成果，设计创新的跨界合作产品，打破传统家政服务边界，探索新的业务增长点，提升公司在多元化市场中的竞争力与影响力。\n \n任职要求：\n【专业背景】\n本科及以上学历，市场营销、商务管理、家政服务等相关专业优先，扎实的专业知识为业务拓展提供理论支撑。\n【工作经验】\n5年以上大客户销售或商务拓展经验，其中至少2年专注于家政服务、母婴行业、生活服务或相关领域，丰富的行业经验助力快速适应岗位需求。\n【客户资源】\n带有行业头部客户资源者优先，自带资源的候选人将直接为公司业务注入强大动力，加速市场拓展进程。\n【商务能力】\n精通商务谈判技巧，具备出色的沟通协调能力，能够与不同层级的客户及合作伙伴建立良好关系，推动合作顺利开展。\n熟练掌握市场调研方法与工具，善于从市场数据中挖掘有价值信息，为决策提供有力依据。\n【项目管理】\n具备优秀的项目管理能力，能够高效组织跨部门团队，确保合作项目按时、高质量交付，保障客户满意度。\n【创新思维】\n思维活跃，富有创新精神，善于跨界思考，能够结合市场趋势与公司资源，设计出具有竞争力的跨界合作产品，为公司开拓新的业务领域。\n【抗压能力】\n能够在高强度的工作环境中保持积极心态，具备出色的时间管理与任务优先级划分能力，确保各项工作有序推进。",
    "capabilityReq": "1. - 市场洞察能力\n- 简要定义：深度分析家政服务市场动态与客户需求，挖掘潜在头部客户资源的能力\n- 典型行为表现：通过专业市场调研方法把握行业趋势，筛选锁定具有战略价值的行业头部客户\n2. - 方案设计能力\n- 简要定义：根据客户个性化需求设计定制化合作方案并撰写高质量商业计划书及投标方案的能力\n- 典型行为表现：设计贴合客户期望的服务方案，独立撰写突出公司优势的投标方案以提升中标率\n3. - 商务谈判能力\n- 简要定义：主导商务谈判推动合同签订，监控服务交付质量并协调解决问题以保障客户满意度的能力\n- 典型行为表现：凭借沟通技巧与谈判能力促成合同签订，全程监控服务交付并及时协调解决合作问题\n4. - 资源整合能力\n- 简要定义：拓展内外部生态伙伴资源并整合优势资源，设计创新跨界合作产品的能力\n- 典型行为表现：与上下游企业及相关机构建立合作关系，基于资源整合设计跨界合作产品探索新业务增长点\n5. - 项目管理能力\n- 简要定义：高效组织跨部门团队确保合作项目按时、高质量交付的能力\n- 典型行为表现：组织跨部门团队推进项目，保障合作项目在规定时间内高质量完成交付",
    "interview1": null,
    "interview2": null,
    "interview3": null,
    "reason": "",
    "progress": "1",
    "inBudget": null
  },
  {
    "id": "HC-2026-003",
    "dept": "养老及商业事业部 · 大客户业务部",
    "position": "大客户经理",
    "count": 1,
    "priority": "P2",
    "budget": "",
    "status": "待招聘",
    "recruiter": "何雨菱",
    "publish": "",
    "received": 0,
    "target": "2026-03-31",
    "city": "",
    "subDept": "大客户业务部",
    "startDate": "2026-03-01",
    "endDate": "2026-03-31",
    "jd": "岗位职责：\n1. 市场调研与客户开发\n深度洞察家政服务市场动态，精准把握行业趋势与客户需求，通过专业的市场调研方法，挖掘潜在的头部客户资源；筛选并锁定具有战略价值的行业头部客户，凭借出色的商务拓展能力，成功签约并建立稳固的战略级合作关系，助力公司在高端家政服务市场占据领先地位。\n2. 解决方案输出\n根据不同客户的个性化需求，设计定制化的合作方案，确保服务方案精准贴合客户期望；独立撰写高质量的商业计划书及投标方案，突出公司服务优势与价值，以专业、严谨的方案呈现，提升公司在项目竞标中的中标率，为业务拓展奠定坚实基础。\n3. 谈判、合作落地与延续\n作为公司与合作单位的关键沟通桥梁，主导商务谈判，凭借卓越的沟通技巧与谈判能力，推动合同顺利签订，确保合作项目快速落地实施；在合作过程中，全程监控服务交付质量，及时协调解决可能出现的问题，保障客户满意度持续高位运行。同时，敏锐捕捉客户潜在需求，积极推动客户续约，并拓展增值服务销售，实现客户价值最大化与业务持续增长。\n4. 资源整合与跨界合作\n积极拓展内外部生态伙伴资源，与上下游企业、相关行业机构等建立广泛合作关系，整合各方优势资源，为公司业务发展提供有力支撑；基于资源整合成果，设计创新的跨界合作产品，打破传统家政服务边界，探索新的业务增长点，提升公司在多元化市场中的竞争力与影响力。\n \n任职要求：\n【专业背景】\n本科及以上学历，市场营销、商务管理、家政服务等相关专业优先，扎实的专业知识为业务拓展提供理论支撑。\n【工作经验】\n5年以上大客户销售或商务拓展经验，其中至少2年专注于家政服务、母婴行业、生活服务或相关领域，丰富的行业经验助力快速适应岗位需求。\n【客户资源】\n带有行业头部客户资源者优先，自带资源的候选人将直接为公司业务注入强大动力，加速市场拓展进程。\n【商务能力】\n精通商务谈判技巧，具备出色的沟通协调能力，能够与不同层级的客户及合作伙伴建立良好关系，推动合作顺利开展。\n熟练掌握市场调研方法与工具，善于从市场数据中挖掘有价值信息，为决策提供有力依据。\n【项目管理】\n具备优秀的项目管理能力，能够高效组织跨部门团队，确保合作项目按时、高质量交付，保障客户满意度。\n【创新思维】\n思维活跃，富有创新精神，善于跨界思考，能够结合市场趋势与公司资源，设计出具有竞争力的跨界合作产品，为公司开拓新的业务领域。\n【抗压能力】\n能够在高强度的工作环境中保持积极心态，具备出色的时间管理与任务优先级划分能力，确保各项工作有序推进。",
    "capabilityReq": "1. - 市场洞察能力\n- 简要定义：深度分析家政服务市场动态与客户需求，挖掘潜在头部客户资源的能力\n- 典型行为表现：通过专业市场调研方法把握行业趋势，筛选锁定具有战略价值的行业头部客户\n2. - 方案设计能力\n- 简要定义：根据客户个性化需求设计定制化合作方案并撰写高质量商业计划书及投标方案的能力\n- 典型行为表现：设计贴合客户期望的服务方案，独立撰写突出公司优势的投标方案以提升中标率\n3. - 商务谈判能力\n- 简要定义：主导商务谈判推动合同签订，监控服务交付质量并协调解决问题以保障客户满意度的能力\n- 典型行为表现：凭借沟通技巧与谈判能力促成合同签订，全程监控服务交付并及时协调解决合作问题\n4. - 资源整合能力\n- 简要定义：拓展内外部生态伙伴资源并整合优势资源，设计创新跨界合作产品的能力\n- 典型行为表现：与上下游企业及相关机构建立合作关系，基于资源整合设计跨界合作产品探索新业务增长点\n5. - 项目管理能力\n- 简要定义：高效组织跨部门团队确保合作项目按时、高质量交付的能力\n- 典型行为表现：组织跨部门团队推进项目，保障合作项目在规定时间内高质量完成交付",
    "interview1": null,
    "interview2": null,
    "interview3": null,
    "reason": "",
    "progress": "31",
    "inBudget": null
  },
  {
    "id": "HC-2026-004",
    "dept": "养老及商业事业部 · 综合渠道部",
    "position": "市场BD主管",
    "count": 1,
    "priority": "P2",
    "budget": "",
    "status": "暂停",
    "recruiter": "何雨菱",
    "publish": "",
    "received": 0,
    "target": "",
    "city": "",
    "subDept": "综合渠道部",
    "startDate": "2026-07-01",
    "endDate": "",
    "jd": "",
    "capabilityReq": "请提供需要提取能力维度的正文内容，以便我完成信息提取任务。",
    "interview1": null,
    "interview2": null,
    "interview3": null,
    "reason": "",
    "progress": "-46203",
    "inBudget": null
  },
  {
    "id": "HC-2026-005",
    "dept": "养老及商业事业部 · 综合渠道部",
    "position": "市场BD专员",
    "count": 1,
    "priority": "P2",
    "budget": "离职替补",
    "status": "已入职",
    "recruiter": "何雨菱",
    "publish": "上海",
    "received": 0,
    "target": "",
    "city": "上海",
    "subDept": "综合渠道部",
    "startDate": "",
    "endDate": "",
    "jd": "岗位职责\n1、根据公司现有渠道合作政策对接孕婴行业（包含且不仅限于孕婴摄影、母婴店、产后康复机构、奶粉厂家、月子中心、同行业家政机构、医院等）以及重点妇产医院附近相关行业的商家，通过商务谈判进行合作，拓展线索来源。\n2、对城市渠道合作的签约数，及渠道供给的线索数负责。\n3、维护合作渠道客情关系，提升线索数量及质量；\n4、定期进行产品及政策宣贯培训，保证公司政策及物料落地执行；\n5、与合作方进行日常活动方案的策划，跟进活动的落地执行力，确保活动执行效果；\n6、多形式的展开异业合作项目对接，进行资源整合，联动开发等获取更多的合作方资源；\n7、协调联动销售分区跟进合作方提供的线索转化情况，并定期进行复盘分析；\n8、负责整个城市异业合作的数据分析展示，掌握竞品和行业动向，为城市经理提供更多的市场信息\n\n岗位要求：\n1、大专及以上学历；\n2、至少1年渠道业务工作经验，有孕婴童行业渠道业务经验、产科等医药代表相关经验优先；\n3、熟悉当地孕婴市场家政市场或有相关行业资源者优先；\n4、具有较强的独立工作能力和社交技巧，较好的沟通能力、协调能力和团队合作能力；\n5、责任心强，思维跳跃，能适应互联网公司的工作节奏，注重工作的成长性，皮实。",
    "capabilityReq": "1. - 渠道拓展能力\n- 简要定义：对接孕婴行业及相关商家，通过商务谈判拓展线索来源的能力\n- 典型行为表现：根据公司渠道合作政策对接孕婴摄影、母婴店等商家进行合作；多形式展开异业合作项目对接，整合资源获取更多合作方资源\n2. - 客情维护能力\n- 简要定义：维护合作渠道客情关系，提升线索数量及质量的能力\n- 典型行为表现：定期进行产品及政策宣贯培训，保证公司政策及物料落地执行；与合作方策划日常活动方案并跟进落地执行力，确保活动效果\n3. - 数据复盘能力\n- 简要定义：协调跟进线索转化，进行数据分析与复盘的能力\n- 典型行为表现：协调联动销售分区跟进合作方提供的线索转化情况并定期复盘分析；负责城市异业合作的数据分析展示，掌握竞品和行业动向\n4. - 市场洞察能力\n- 简要定义：熟悉当地孕婴市场，掌握行业动态为决策提供信息的能力\n- 典型行为表现：熟悉当地孕婴市场或有相关行业资源；为城市经理提供更多基于竞品和行业动向的市场信息\n5. - 商务谈判能力\n- 简要定义：与合作商家进行商务谈判达成合作的能力\n- 典型行为表现：通过商务谈判与孕婴行业商家进行合作，拓展线索来源；在异业合作项目对接中进行谈判，实现资源整合与联动开发",
    "interview1": "徐晟",
    "interview2": "何雨菱",
    "interview3": null,
    "reason": "离职替补",
    "progress": "1",
    "inBudget": null
  },
  {
    "id": "HC-2026-006",
    "dept": "养老及商业事业部 · 综合渠道部",
    "position": "市场BD专员",
    "count": 1,
    "priority": "P2",
    "budget": "",
    "status": "待招聘",
    "recruiter": "何雨菱",
    "publish": "杭州",
    "received": 0,
    "target": "",
    "city": "杭州",
    "subDept": "综合渠道部",
    "startDate": "",
    "endDate": "",
    "jd": "岗位职责\n1、根据公司现有渠道合作政策对接孕婴行业（包含且不仅限于孕婴摄影、母婴店、产后康复机构、奶粉厂家、月子中心、同行业家政机构、医院等）以及重点妇产医院附近相关行业的商家，通过商务谈判进行合作，拓展线索来源。\n2、对城市渠道合作的签约数，及渠道供给的线索数负责。\n3、维护合作渠道客情关系，提升线索数量及质量；\n4、定期进行产品及政策宣贯培训，保证公司政策及物料落地执行；\n5、与合作方进行日常活动方案的策划，跟进活动的落地执行力，确保活动执行效果；\n6、多形式的展开异业合作项目对接，进行资源整合，联动开发等获取更多的合作方资源；\n7、协调联动销售分区跟进合作方提供的线索转化情况，并定期进行复盘分析；\n8、负责整个城市异业合作的数据分析展示，掌握竞品和行业动向，为城市经理提供更多的市场信息\n\n岗位要求：\n1、大专及以上学历；\n2、至少1年渠道业务工作经验，有孕婴童行业渠道业务经验、产科等医药代表相关经验优先；\n3、熟悉当地孕婴市场家政市场或有相关行业资源者优先；\n4、具有较强的独立工作能力和社交技巧，较好的沟通能力、协调能力和团队合作能力；\n5、责任心强，思维跳跃，能适应互联网公司的工作节奏，注重工作的成长性，皮实。",
    "capabilityReq": "1. - 渠道拓展能力\n- 简要定义：对接孕婴行业及相关商家，通过商务谈判拓展线索来源的能力\n- 典型行为表现：根据公司渠道合作政策对接孕婴摄影、母婴店等商家进行合作；多形式展开异业合作项目对接，整合资源获取更多合作方资源\n2. - 客情维护能力\n- 简要定义：维护合作渠道客情关系，提升线索数量及质量的能力\n- 典型行为表现：定期进行产品及政策宣贯培训，保证公司政策及物料落地执行；与合作方策划日常活动方案并跟进落地执行力，确保活动效果\n3. - 数据复盘能力\n- 简要定义：协调跟进线索转化，进行数据分析与复盘的能力\n- 典型行为表现：协调联动销售分区跟进合作方提供的线索转化情况并定期复盘分析；负责城市异业合作的数据分析展示，掌握竞品和行业动向\n4. - 市场洞察能力\n- 简要定义：熟悉当地孕婴市场，掌握行业动态为决策提供信息的能力\n- 典型行为表现：熟悉当地孕婴市场或有相关行业资源；为城市经理提供更多基于竞品和行业动向的市场信息\n5. - 商务谈判能力\n- 简要定义：与合作商家进行商务谈判达成合作的能力\n- 典型行为表现：通过商务谈判与孕婴行业商家进行合作，拓展线索来源；在异业合作项目对接中进行谈判，实现资源整合与联动开发",
    "interview1": "徐晟",
    "interview2": "何雨菱",
    "interview3": null,
    "reason": "",
    "progress": "1",
    "inBudget": null
  },
  {
    "id": "HC-2026-007",
    "dept": "养老及商业事业部 · 综合渠道部",
    "position": "市场BD专员",
    "count": 1,
    "priority": "P1",
    "budget": "换人储备",
    "status": "储备简历",
    "recruiter": "何雨菱",
    "publish": "青岛",
    "received": 0,
    "target": "",
    "city": "青岛",
    "subDept": "综合渠道部",
    "startDate": "",
    "endDate": "",
    "jd": "岗位职责\n1、根据公司现有渠道合作政策对接孕婴行业（包含且不仅限于孕婴摄影、母婴店、产后康复机构、奶粉厂家、月子中心、同行业家政机构、医院等）以及重点妇产医院附近相关行业的商家，通过商务谈判进行合作，拓展线索来源。\n2、对城市渠道合作的签约数，及渠道供给的线索数负责。\n3、维护合作渠道客情关系，提升线索数量及质量；\n4、定期进行产品及政策宣贯培训，保证公司政策及物料落地执行；\n5、与合作方进行日常活动方案的策划，跟进活动的落地执行力，确保活动执行效果；\n6、多形式的展开异业合作项目对接，进行资源整合，联动开发等获取更多的合作方资源；\n7、协调联动销售分区跟进合作方提供的线索转化情况，并定期进行复盘分析；\n8、负责整个城市异业合作的数据分析展示，掌握竞品和行业动向，为城市经理提供更多的市场信息\n\n岗位要求：\n1、大专及以上学历；\n2、至少1年渠道业务工作经验，有孕婴童行业渠道业务经验、产科等医药代表相关经验优先；\n3、熟悉当地孕婴市场家政市场或有相关行业资源者优先；\n4、具有较强的独立工作能力和社交技巧，较好的沟通能力、协调能力和团队合作能力；\n5、责任心强，思维跳跃，能适应互联网公司的工作节奏，注重工作的成长性，皮实。",
    "capabilityReq": "1. - 渠道拓展能力\n- 简要定义：对接孕婴行业及相关商家，通过商务谈判拓展线索来源的能力\n- 典型行为表现：根据公司渠道合作政策对接孕婴摄影、母婴店等商家进行合作；多形式展开异业合作项目对接，整合资源获取更多合作方资源\n2. - 客情维护能力\n- 简要定义：维护合作渠道客情关系，提升线索数量及质量的能力\n- 典型行为表现：定期进行产品及政策宣贯培训，保证公司政策及物料落地执行；与合作方策划日常活动方案并跟进落地执行力，确保活动效果\n3. - 数据复盘能力\n- 简要定义：协调跟进线索转化，进行数据分析与复盘的能力\n- 典型行为表现：协调联动销售分区跟进合作方提供的线索转化情况并定期复盘分析；负责城市异业合作的数据分析展示，掌握竞品和行业动向\n4. - 市场洞察能力\n- 简要定义：熟悉当地孕婴市场，掌握行业动态为决策提供信息的能力\n- 典型行为表现：熟悉当地孕婴市场或有相关行业资源；为城市经理提供更多基于竞品和行业动向的市场信息\n5. - 商务谈判能力\n- 简要定义：与合作商家进行商务谈判达成合作的能力\n- 典型行为表现：通过商务谈判与孕婴行业商家进行合作，拓展线索来源；在异业合作项目对接中进行谈判，实现资源整合与联动开发",
    "interview1": "徐晟",
    "interview2": "何雨菱",
    "interview3": null,
    "reason": "换人储备",
    "progress": "1",
    "inBudget": null
  },
  {
    "id": "HC-2026-008",
    "dept": "养老及商业事业部 · 综合渠道部",
    "position": "市场BD专员",
    "count": 1,
    "priority": "P1",
    "budget": "离职替补",
    "status": "待招聘",
    "recruiter": "何雨菱",
    "publish": "北京",
    "received": 0,
    "target": "",
    "city": "北京",
    "subDept": "综合渠道部",
    "startDate": "",
    "endDate": "",
    "jd": "岗位职责\n1、根据公司现有渠道合作政策对接孕婴行业（包含且不仅限于孕婴摄影、母婴店、产后康复机构、奶粉厂家、月子中心、同行业家政机构、医院等）以及重点妇产医院附近相关行业的商家，通过商务谈判进行合作，拓展线索来源。\n2、对城市渠道合作的签约数，及渠道供给的线索数负责。\n3、维护合作渠道客情关系，提升线索数量及质量；\n4、定期进行产品及政策宣贯培训，保证公司政策及物料落地执行；\n5、与合作方进行日常活动方案的策划，跟进活动的落地执行力，确保活动执行效果；\n6、多形式的展开异业合作项目对接，进行资源整合，联动开发等获取更多的合作方资源；\n7、协调联动销售分区跟进合作方提供的线索转化情况，并定期进行复盘分析；\n8、负责整个城市异业合作的数据分析展示，掌握竞品和行业动向，为城市经理提供更多的市场信息\n\n岗位要求：\n1、大专及以上学历；\n2、至少1年渠道业务工作经验，有孕婴童行业渠道业务经验、产科等医药代表相关经验优先；\n3、熟悉当地孕婴市场家政市场或有相关行业资源者优先；\n4、具有较强的独立工作能力和社交技巧，较好的沟通能力、协调能力和团队合作能力；\n5、责任心强，思维跳跃，能适应互联网公司的工作节奏，注重工作的成长性，皮实。",
    "capabilityReq": "1. - 渠道拓展能力\n- 简要定义：对接孕婴行业及相关商家，通过商务谈判拓展线索来源的能力\n- 典型行为表现：根据公司渠道合作政策对接孕婴摄影、母婴店等商家进行合作；多形式展开异业合作项目对接，整合资源获取更多合作方资源\n2. - 客情维护能力\n- 简要定义：维护合作渠道客情关系，提升线索数量及质量的能力\n- 典型行为表现：定期进行产品及政策宣贯培训，保证公司政策及物料落地执行；与合作方策划日常活动方案并跟进落地执行力，确保活动效果\n3. - 数据复盘能力\n- 简要定义：协调跟进线索转化，进行数据分析与复盘的能力\n- 典型行为表现：协调联动销售分区跟进合作方提供的线索转化情况并定期复盘分析；负责城市异业合作的数据分析展示，掌握竞品和行业动向\n4. - 市场洞察能力\n- 简要定义：熟悉当地孕婴市场，掌握行业动态为决策提供信息的能力\n- 典型行为表现：熟悉当地孕婴市场或有相关行业资源；为城市经理提供更多基于竞品和行业动向的市场信息\n5. - 商务谈判能力\n- 简要定义：与合作商家进行商务谈判达成合作的能力\n- 典型行为表现：通过商务谈判与孕婴行业商家进行合作，拓展线索来源；在异业合作项目对接中进行谈判，实现资源整合与联动开发",
    "interview1": "石磊",
    "interview2": "何雨菱",
    "interview3": null,
    "reason": "离职替补",
    "progress": "1",
    "inBudget": null
  },
  {
    "id": "HC-2026-009",
    "dept": "养老及商业事业部 · 综合渠道部",
    "position": "市场BD专员",
    "count": 1,
    "priority": "P0",
    "budget": "新增HC",
    "status": "待招聘",
    "recruiter": "何雨菱",
    "publish": "南京",
    "received": 0,
    "target": "",
    "city": "南京",
    "subDept": "综合渠道部",
    "startDate": "",
    "endDate": "",
    "jd": "岗位职责\n1、根据公司现有渠道合作政策对接孕婴行业（包含且不仅限于孕婴摄影、母婴店、产后康复机构、奶粉厂家、月子中心、同行业家政机构、医院等）以及重点妇产医院附近相关行业的商家，通过商务谈判进行合作，拓展线索来源。\n2、对城市渠道合作的签约数，及渠道供给的线索数负责。\n3、维护合作渠道客情关系，提升线索数量及质量；\n4、定期进行产品及政策宣贯培训，保证公司政策及物料落地执行；\n5、与合作方进行日常活动方案的策划，跟进活动的落地执行力，确保活动执行效果；\n6、多形式的展开异业合作项目对接，进行资源整合，联动开发等获取更多的合作方资源；\n7、协调联动销售分区跟进合作方提供的线索转化情况，并定期进行复盘分析；\n8、负责整个城市异业合作的数据分析展示，掌握竞品和行业动向，为城市经理提供更多的市场信息\n\n岗位要求：\n1、大专及以上学历；\n2、至少1年渠道业务工作经验，有孕婴童行业渠道业务经验、产科等医药代表相关经验优先；\n3、熟悉当地孕婴市场家政市场或有相关行业资源者优先；\n4、具有较强的独立工作能力和社交技巧，较好的沟通能力、协调能力和团队合作能力；\n5、责任心强，思维跳跃，能适应互联网公司的工作节奏，注重工作的成长性，皮实。",
    "capabilityReq": "1. - 渠道拓展能力\n- 简要定义：对接孕婴行业及相关商家，通过商务谈判拓展线索来源的能力\n- 典型行为表现：根据公司渠道合作政策对接孕婴摄影、母婴店等商家进行合作；多形式展开异业合作项目对接，整合资源获取更多合作方资源\n2. - 客情维护能力\n- 简要定义：维护合作渠道客情关系，提升线索数量及质量的能力\n- 典型行为表现：定期进行产品及政策宣贯培训，保证公司政策及物料落地执行；与合作方策划日常活动方案并跟进落地执行力，确保活动效果\n3. - 数据复盘能力\n- 简要定义：协调跟进线索转化，进行数据分析与复盘的能力\n- 典型行为表现：协调联动销售分区跟进合作方提供的线索转化情况并定期复盘分析；负责城市异业合作的数据分析展示，掌握竞品和行业动向\n4. - 市场洞察能力\n- 简要定义：熟悉当地孕婴市场，掌握行业动态为决策提供信息的能力\n- 典型行为表现：熟悉当地孕婴市场或有相关行业资源；为城市经理提供更多基于竞品和行业动向的市场信息\n5. - 商务谈判能力\n- 简要定义：与合作商家进行商务谈判达成合作的能力\n- 典型行为表现：通过商务谈判与孕婴行业商家进行合作，拓展线索来源；在异业合作项目对接中进行谈判，实现资源整合与联动开发",
    "interview1": "徐晟",
    "interview2": "何雨菱",
    "interview3": null,
    "reason": "新增HC",
    "progress": "1",
    "inBudget": null
  },
  {
    "id": "HC-2026-010",
    "dept": "养老及商业事业部 · 招商业务部",
    "position": "招商专员（地招）",
    "count": 1,
    "priority": "P2",
    "budget": "离职替补",
    "status": "招聘中",
    "recruiter": "何雨菱",
    "publish": "北京",
    "received": 0,
    "target": "",
    "city": "北京",
    "subDept": "招商业务部",
    "startDate": "",
    "endDate": "",
    "jd": "岗位职责：\n1、完成负责区域的劳动者招募任务；\n2、负责电话、企业微信跟进，邀约意向劳动者，劳动者考查接待，沟通，签约；\n3、参与完成公司举办的各类招商活动；\n4、分析行业内相关信息，所在区域市场信息，并提出建议；\n5、完成领导安排的各项工作安排；\n\n任职要求：\n1、大专学历以上，有电销资深经验者可放宽；\n2、市场营销类等相关专业；\n3、一年以上市场营销、家政招商工作经验；\n4、具备基本的销售常识、营销知识；\n5、良好的商务礼仪和表达能力，会使用office软件；",
    "capabilityReq": "1. - 客户开发能力\n- 简要定义：负责区域内劳动者招募及意向客户跟进签约的能力\n- 典型行为表现：电话、企业微信跟进邀约意向劳动者；接待劳动者考查并沟通签约\n2. - 活动执行能力\n- 简要定义：参与并执行公司各类招商活动的能力\n- 典型行为表现：参与完成公司举办的各类招商活动\n3. - 市场分析能力\n- 简要定义：分析行业及区域市场信息并提出建议的能力\n- 典型行为表现：分析行业内相关信息及所在区域市场信息，并提出建议\n4. - 商务沟通能力\n- 简要定义：具备良好商务礼仪和表达以开展业务沟通的能力\n- 典型行为表现：与劳动者进行有效沟通，展现良好商务礼仪\n5. - 软件操作能力\n- 简要定义：熟练使用office软件处理工作的能力\n- 典型行为表现：会使用office软件完成工作相关文档处理",
    "interview1": "韩悦",
    "interview2": "何雨菱",
    "interview3": null,
    "reason": "离职替补",
    "progress": "1",
    "inBudget": null
  },
  {
    "id": "HC-2026-011",
    "dept": "养老及商业事业部 · 招商业务部",
    "position": "招商专员（地招）",
    "count": 1,
    "priority": "P1",
    "budget": "离职替补",
    "status": "招聘中",
    "recruiter": "何雨菱",
    "publish": "郑州",
    "received": 0,
    "target": "",
    "city": "郑州",
    "subDept": "招商业务部",
    "startDate": "",
    "endDate": "",
    "jd": "岗位职责：\n1、完成负责区域的劳动者招募任务；\n2、负责电话、企业微信跟进，邀约意向劳动者，劳动者考查接待，沟通，签约；\n3、参与完成公司举办的各类招商活动；\n4、分析行业内相关信息，所在区域市场信息，并提出建议；\n5、完成领导安排的各项工作安排；\n\n任职要求：\n1、大专学历以上，有电销资深经验者可放宽；\n2、市场营销类等相关专业；\n3、一年以上市场营销、家政招商工作经验；\n4、具备基本的销售常识、营销知识；\n5、良好的商务礼仪和表达能力，会使用office软件；",
    "capabilityReq": "1. - 客户开发能力\n- 简要定义：负责区域内劳动者招募及意向客户跟进签约的能力\n- 典型行为表现：电话、企业微信跟进邀约意向劳动者；接待劳动者考查并沟通签约\n2. - 活动执行能力\n- 简要定义：参与并执行公司各类招商活动的能力\n- 典型行为表现：参与完成公司举办的各类招商活动\n3. - 市场分析能力\n- 简要定义：分析行业及区域市场信息并提出建议的能力\n- 典型行为表现：分析行业内相关信息及所在区域市场信息，并提出建议\n4. - 商务沟通能力\n- 简要定义：具备良好商务礼仪和表达以开展业务沟通的能力\n- 典型行为表现：与劳动者进行有效沟通，展现良好商务礼仪\n5. - 软件操作能力\n- 简要定义：熟练使用office软件处理工作的能力\n- 典型行为表现：会使用office软件完成工作相关文档处理",
    "interview1": "李兴",
    "interview2": "何雨菱",
    "interview3": null,
    "reason": "离职替补",
    "progress": "1",
    "inBudget": null
  },
  {
    "id": "HC-2026-037",
    "dept": "养老及商业事业部 · 招商业务部",
    "position": "招商专员（地招）",
    "count": 1,
    "priority": "P2",
    "budget": "",
    "status": "已入职",
    "recruiter": "何雨菱",
    "publish": "重庆",
    "received": 0,
    "target": "",
    "city": "重庆",
    "subDept": "招商业务部",
    "startDate": "",
    "endDate": "",
    "jd": "岗位职责：\n1、完成负责区域的劳动者招募任务；\n2、负责电话、企业微信跟进，邀约意向劳动者，劳动者考查接待，沟通，签约；\n3、参与完成公司举办的各类招商活动；\n4、分析行业内相关信息，所在区域市场信息，并提出建议；\n5、完成领导安排的各项工作安排；\n\n任职要求：\n1、大专学历以上，有电销资深经验者可放宽；\n2、市场营销类等相关专业；\n3、一年以上市场营销、家政招商工作经验；\n4、具备基本的销售常识、营销知识；\n5、良好的商务礼仪和表达能力，会使用office软件；",
    "capabilityReq": "1. - 客户开发能力\n- 简要定义：负责区域内劳动者招募及意向客户跟进签约的能力\n- 典型行为表现：电话、企业微信跟进邀约意向劳动者；接待劳动者考查并沟通签约\n2. - 活动执行能力\n- 简要定义：参与并执行公司各类招商活动的能力\n- 典型行为表现：参与完成公司举办的各类招商活动\n3. - 市场分析能力\n- 简要定义：分析行业及区域市场信息并提出建议的能力\n- 典型行为表现：分析行业内相关信息及所在区域市场信息，并提出建议\n4. - 商务沟通能力\n- 简要定义：具备良好商务礼仪和表达以开展业务沟通的能力\n- 典型行为表现：与劳动者进行有效沟通，展现良好商务礼仪\n5. - 软件操作能力\n- 简要定义：熟练使用office软件处理工作的能力\n- 典型行为表现：会使用office软件完成工作相关文档处理",
    "interview1": "李兴",
    "interview2": null,
    "interview3": null,
    "reason": "",
    "progress": "1",
    "inBudget": null
  },
  {
    "id": "HC-2026-012",
    "dept": "养老及商业事业部 · 综合渠道部",
    "position": "医疗渠道经理",
    "count": 1,
    "priority": "P2",
    "budget": "",
    "status": "待招聘",
    "recruiter": "何雨菱",
    "publish": "北京",
    "received": 0,
    "target": "2026-04-30",
    "city": "北京",
    "subDept": "综合渠道部",
    "startDate": "2026-04-01",
    "endDate": "2026-04-30",
    "jd": "",
    "capabilityReq": "请提供需要提取信息的正文内容，以便我按照要求完成能力维度的提取。",
    "interview1": "王邺辉",
    "interview2": "杜雁玲",
    "interview3": "王彦强",
    "reason": "",
    "progress": "30",
    "inBudget": null
  },
  {
    "id": "HC-2026-013",
    "dept": "养老及商业事业部 · 联合办学",
    "position": "商务专员",
    "count": 2,
    "priority": "P2",
    "budget": "",
    "status": "待招聘",
    "recruiter": "何雨菱",
    "publish": "长沙",
    "received": 0,
    "target": "2026-04-30",
    "city": "长沙",
    "subDept": "联合办学",
    "startDate": "2026-03-01",
    "endDate": "2026-04-30",
    "jd": "岗位职责：\n一、商务谈判与签约支持\n1、协助主管进行战略客户的谈判与签约，跟进合作协议审批流程。\n2、支持招商专员完成重点谈判，提供行业知识与销售技巧辅助。\n3、负责合作协议的整理、归档与区域协议管理。\n二、市场开拓与关系维护\n1、参与招商空白城市新渠道开发，拓展培训机构、家政公司等合作资源。\n2、维护现有合作机构关系，保障合作稳定性与持续性。\n3、建立并维护行业人脉网络，挖掘潜在合作机会。\n三、项目交付与协调\n1、完成合作机构的交付协调工作，跟进项目落地进度。\n2、负责机构交付沟通，协调师资赋能（学习、考核、CS系统、跟班）等交付事项。\n3、协调机构会销课时间与产品线线上培训安排，保障培训服务质量。\n4、跨部门协调资源，推动内部团队配合完成合作项目目标。\n任职要求：\n1、大专及以上学历，市场营销、商务管理、家政服务相关专业优先。\n2、1-2年商务谈判、市场开拓或销售相关工作经验，有家政/培训行业经验者优先。\n3、具备良好的商务谈判能力与销售技巧，能独立跟进合作沟通。\n4、具备较强的跨部门协调能力与资源整合能力，能高效推进项目。\n5、具备良好的沟通表达能力、抗压能力与团队协作精神。\n6、能接受一定频次的出差，支持空白城市渠道开发。\n7、熟练使用Office办公软件，具备基础的数据分析与文档撰写能力。",
    "capabilityReq": "1. - 商务谈判能力\n- 简要定义：在商务活动中与客户进行有效沟通、协商并达成合作的能力\n- 典型行为表现：协助主管进行战略客户的谈判与签约；支持招商专员完成重点谈判，提供行业知识与销售技巧辅助\n2. - 市场开拓能力\n- 简要定义：开发新渠道、拓展合作资源以扩大市场份额的能力\n- 典型行为表现：参与招商空白城市新渠道开发，拓展培训机构、家政公司等合作资源；建立并维护行业人脉网络，挖掘潜在合作机会\n3. - 关系维护能力\n- 简要定义：维持现有合作关系并保障合作稳定持续的能力\n- 典型行为表现：维护现有合作机构关系，保障合作稳定性与持续性\n4. - 项目交付协调\n- 简要定义：跟进项目落地进度并协调各方资源保障项目交付的能力\n- 典型行为表现：完成合作机构的交付协调工作，跟进项目落地进度；协调机构会销课时间与产品线线上培训安排，保障培训服务质量\n5. - 跨部门协作能力\n- 简要定义：与不同部门沟通协调以推动项目目标完成的能力\n- 典型行为表现：跨部门协调资源，推动内部团队配合完成合作项目目标",
    "interview1": "严鹏",
    "interview2": "何雨菱",
    "interview3": null,
    "reason": "",
    "progress": "61",
    "inBudget": null
  },
  {
    "id": "HC-2026-014",
    "dept": "养老及商业事业部 · 综合运营部",
    "position": "运营专员",
    "count": 1,
    "priority": "P1",
    "budget": "新增HC",
    "status": "已入职",
    "recruiter": "何雨菱",
    "publish": "北京",
    "received": 0,
    "target": "",
    "city": "北京",
    "subDept": "综合运营部",
    "startDate": "",
    "endDate": "",
    "jd": "",
    "capabilityReq": "",
    "interview1": "魏冰",
    "interview2": "何雨菱",
    "interview3": null,
    "reason": "新增HC",
    "progress": "1",
    "inBudget": null
  },
  {
    "id": "HC-2026-016",
    "dept": "AI创新事业部 · 闪电云签",
    "position": "用户服务专员",
    "count": 1,
    "priority": "P0",
    "budget": "新增HC",
    "status": "暂停",
    "recruiter": "杜雁玲",
    "publish": "长沙",
    "received": 0,
    "target": "",
    "city": "长沙",
    "subDept": "闪电云签",
    "startDate": "",
    "endDate": "",
    "jd": "",
    "capabilityReq": "",
    "interview1": "黄雁",
    "interview2": "魏秋柠",
    "interview3": "林烽",
    "reason": "新增HC",
    "progress": "1",
    "inBudget": null
  },
  {
    "id": "HC-2026-017",
    "dept": "AI创新事业部 · 劳动者增长部",
    "position": "招商专员",
    "count": 1,
    "priority": "P2",
    "budget": "新增HC",
    "status": "已入职",
    "recruiter": "杜雁玲",
    "publish": "长沙",
    "received": 0,
    "target": "2026-04-23",
    "city": "长沙",
    "subDept": "劳动者增长部",
    "startDate": "2026-04-15",
    "endDate": "2026-04-23",
    "jd": "岗位职责：\n1、积极利用公司提供或自行开拓的各种资源，通过电话、微信等方式筛选并跟进符合条件的意向保姆、月嫂、育婴师阿姨，协助他们参加公司资质审核、考试等，将其纳入天鹅到家平台；\n2、积极维护和劳动者的关系，增加劳动者的转介绍；\n3、加分项：寻找和拓展负责同月子中心、社区医院、养老院、劳动者培训机构、家政公司等渠道，进行建联，确保渠道定期向公司输送合适的家政行业劳动者，完成蓝领阿姨的招聘目标。\n\n岗位要求：\n1、全日制大专及以上学历，40周岁以下，细心耐心、较好的亲和力；\n2、有较好的沟通能力、学习能力、信息整合能力；\n3、有过人力行政/招聘等工作经验优先，具有RPO等人力资源公司渠道者优先，销售工作经验者优先，月子中心、社区医院、养老院等家政行业工作经验者优先。",
    "capabilityReq": "1. - 沟通协调能力\n- 简要定义：通过电话、微信等方式与意向保姆、月嫂、育婴师阿姨有效沟通，协助其完成资质审核、考试等纳入平台流程的能力\n- 典型行为表现：通过电话向意向阿姨介绍公司资质审核要求和流程，跟进其准备相关材料；利用微信与阿姨沟通考试安排及注意事项\n2. - 渠道拓展能力\n- 简要定义：开拓和维护月子中心、社区医院等渠道，确保定期输送合适家政劳动者的能力\n- 典型行为表现：主动联系本地月子中心进行建联，洽谈合作输送月嫂事宜；与社区医院沟通，建立长期合作关系以获取育婴师推荐资源\n3. - 关系维护能力\n- 简要定义：积极维护与劳动者的关系，以增加转介绍的能力\n- 典型行为表现：定期回访已纳入平台的阿姨，了解其工作情况并提供必要支持；组织线上交流活动，增强阿姨对平台的认同感以促进转介绍\n4. - 信息整合能力\n- 简要定义：对筛选出的意向阿姨信息及渠道资源信息进行整理和有效利用的能力\n- 典型行为表现：将不同渠道获取的阿姨信息进行分类整理，建立信息库以便后续跟进；整合各合作渠道输送劳动者的情况，分析渠道有效性并优化合作策略\n5. - 学习适应能力\n- 简要定义：快速学习公司业务流程、家政行业知识并适应岗位要求的能力\n- 典型行为表现：入职后迅速学习公司资质审核标准和平台操作流程；主动了解家政行业动态和不同岗位阿姨的技能要求，以更好地开展工作",
    "interview1": "丰文杰",
    "interview2": "魏秋柠",
    "interview3": "林烽",
    "reason": "新增HC",
    "progress": "9",
    "inBudget": null
  },
  {
    "id": "HC-2026-018",
    "dept": "AI创新事业部 · 劳动者增长部",
    "position": "招商专员",
    "count": 1,
    "priority": "P1",
    "budget": "新增HC",
    "status": "已入职",
    "recruiter": "杜雁玲",
    "publish": "长沙",
    "received": 0,
    "target": "2026-05-11",
    "city": "长沙",
    "subDept": "劳动者增长部",
    "startDate": "2026-04-15",
    "endDate": "2026-05-11",
    "jd": "岗位职责：\n1、积极利用公司提供或自行开拓的各种资源，通过电话、微信等方式筛选并跟进符合条件的意向保姆、月嫂、育婴师阿姨，协助他们参加公司资质审核、考试等，将其纳入天鹅到家平台；\n2、积极维护和劳动者的关系，增加劳动者的转介绍；\n3、加分项：寻找和拓展负责同月子中心、社区医院、养老院、劳动者培训机构、家政公司等渠道，进行建联，确保渠道定期向公司输送合适的家政行业劳动者，完成蓝领阿姨的招聘目标。\n\n岗位要求：\n1、全日制大专及以上学历，40周岁以下，细心耐心、较好的亲和力；\n2、有较好的沟通能力、学习能力、信息整合能力；\n3、有过人力行政/招聘等工作经验优先，具有RPO等人力资源公司渠道者优先，销售工作经验者优先，月子中心、社区医院、养老院等家政行业工作经验者优先。",
    "capabilityReq": "1. - 沟通协调能力\n- 简要定义：通过电话、微信等方式与意向保姆、月嫂、育婴师阿姨有效沟通，协助其完成资质审核、考试等纳入平台流程的能力\n- 典型行为表现：通过电话向意向阿姨介绍公司资质审核要求和流程，跟进其准备相关材料；利用微信与阿姨沟通考试安排及注意事项\n2. - 渠道拓展能力\n- 简要定义：开拓和维护月子中心、社区医院等渠道，确保定期输送合适家政劳动者的能力\n- 典型行为表现：主动联系本地月子中心进行建联，洽谈合作输送月嫂事宜；与社区医院沟通，建立长期合作关系以获取育婴师推荐资源\n3. - 关系维护能力\n- 简要定义：积极维护与劳动者的关系，以增加转介绍的能力\n- 典型行为表现：定期回访已纳入平台的阿姨，了解其工作情况并提供必要支持；组织线上交流活动，增强阿姨对平台的认同感以促进转介绍\n4. - 信息整合能力\n- 简要定义：对筛选出的意向阿姨信息及渠道资源信息进行整理和有效利用的能力\n- 典型行为表现：将不同渠道获取的阿姨信息进行分类整理，建立信息库以便后续跟进；整合各合作渠道输送劳动者的情况，分析渠道有效性并优化合作策略\n5. - 学习适应能力\n- 简要定义：快速学习公司业务流程、家政行业知识并适应岗位要求的能力\n- 典型行为表现：入职后迅速学习公司资质审核标准和平台操作流程；主动了解家政行业动态和不同岗位阿姨的技能要求，以更好地开展工作",
    "interview1": "丰文杰",
    "interview2": "魏秋柠",
    "interview3": "林烽",
    "reason": "新增HC",
    "progress": "27",
    "inBudget": null
  },
  {
    "id": "HC-2026-019",
    "dept": "AI创新事业部 · 劳动者增长部",
    "position": "招商专员",
    "count": 1,
    "priority": "P0",
    "budget": "新增HC",
    "status": "招聘中",
    "recruiter": "杜雁玲",
    "publish": "长沙",
    "received": 0,
    "target": "",
    "city": "长沙",
    "subDept": "劳动者增长部",
    "startDate": "2026-05-11",
    "endDate": "",
    "jd": "岗位职责：\n1、积极利用公司提供或自行开拓的各种资源，通过电话、微信等方式筛选并跟进符合条件的意向保姆、月嫂、育婴师阿姨，协助他们参加公司资质审核、考试等，将其纳入天鹅到家平台；\n2、积极维护和劳动者的关系，增加劳动者的转介绍；\n3、加分项：寻找和拓展负责同月子中心、社区医院、养老院、劳动者培训机构、家政公司等渠道，进行建联，确保渠道定期向公司输送合适的家政行业劳动者，完成蓝领阿姨的招聘目标。\n\n岗位要求：\n1、全日制大专及以上学历，40周岁以下，细心耐心、较好的亲和力；\n2、有较好的沟通能力、学习能力、信息整合能力；\n3、有过人力行政/招聘等工作经验优先，具有RPO等人力资源公司渠道者优先，销售工作经验者优先，月子中心、社区医院、养老院等家政行业工作经验者优先。",
    "capabilityReq": "1. - 沟通协调能力\n- 简要定义：通过电话、微信等方式与意向保姆、月嫂、育婴师阿姨有效沟通，协助其完成资质审核、考试等纳入平台流程的能力\n- 典型行为表现：通过电话向意向阿姨介绍公司资质审核要求和流程，跟进其准备相关材料；利用微信与阿姨沟通考试安排及注意事项\n2. - 渠道拓展能力\n- 简要定义：开拓和维护月子中心、社区医院等渠道，确保定期输送合适家政劳动者的能力\n- 典型行为表现：主动联系本地月子中心进行建联，洽谈合作输送月嫂事宜；与社区医院沟通，建立长期合作关系以获取育婴师推荐资源\n3. - 关系维护能力\n- 简要定义：积极维护与劳动者的关系，以增加转介绍的能力\n- 典型行为表现：定期回访已纳入平台的阿姨，了解其工作情况并提供必要支持；组织线上交流活动，增强阿姨对平台的认同感以促进转介绍\n4. - 信息整合能力\n- 简要定义：对筛选出的意向阿姨信息及渠道资源信息进行整理和有效利用的能力\n- 典型行为表现：将不同渠道获取的阿姨信息进行分类整理，建立信息库以便后续跟进；整合各合作渠道输送劳动者的情况，分析渠道有效性并优化合作策略\n5. - 学习适应能力\n- 简要定义：快速学习公司业务流程、家政行业知识并适应岗位要求的能力\n- 典型行为表现：入职后迅速学习公司资质审核标准和平台操作流程；主动了解家政行业动态和不同岗位阿姨的技能要求，以更好地开展工作",
    "interview1": "胡顺",
    "interview2": "魏秋柠",
    "interview3": "林烽",
    "reason": "新增HC",
    "progress": "-46152",
    "inBudget": null
  },
  {
    "id": "HC-2026-020",
    "dept": "AI创新事业部 · 劳动者增长部",
    "position": "招商专员",
    "count": 1,
    "priority": "P0",
    "budget": "新增HC",
    "status": "招聘中",
    "recruiter": "杜雁玲",
    "publish": "长沙",
    "received": 0,
    "target": "2026-05-13",
    "city": "长沙",
    "subDept": "劳动者增长部",
    "startDate": "2026-05-08",
    "endDate": "2026-05-13",
    "jd": "岗位职责：\n1、积极利用公司提供或自行开拓的各种资源，通过电话、微信等方式筛选并跟进符合条件的意向保姆、月嫂、育婴师阿姨，协助他们参加公司资质审核、考试等，将其纳入天鹅到家平台；\n2、积极维护和劳动者的关系，增加劳动者的转介绍；\n3、加分项：寻找和拓展负责同月子中心、社区医院、养老院、劳动者培训机构、家政公司等渠道，进行建联，确保渠道定期向公司输送合适的家政行业劳动者，完成蓝领阿姨的招聘目标。\n\n岗位要求：\n1、全日制大专及以上学历，40周岁以下，细心耐心、较好的亲和力；\n2、有较好的沟通能力、学习能力、信息整合能力；\n3、有过人力行政/招聘等工作经验优先，具有RPO等人力资源公司渠道者优先，销售工作经验者优先，月子中心、社区医院、养老院等家政行业工作经验者优先。",
    "capabilityReq": "1. - 沟通协调能力\n- 简要定义：通过电话、微信等方式与意向保姆、月嫂、育婴师阿姨有效沟通，协助其完成资质审核、考试等纳入平台流程的能力\n- 典型行为表现：通过电话向意向阿姨介绍公司资质审核要求和流程，跟进其准备相关材料；利用微信与阿姨沟通考试安排及注意事项\n2. - 渠道拓展能力\n- 简要定义：开拓和维护月子中心、社区医院等渠道，确保定期输送合适家政劳动者的能力\n- 典型行为表现：主动联系本地月子中心进行建联，洽谈合作输送月嫂事宜；与社区医院沟通，建立长期合作关系以获取育婴师推荐资源\n3. - 关系维护能力\n- 简要定义：积极维护与劳动者的关系，以增加转介绍的能力\n- 典型行为表现：定期回访已纳入平台的阿姨，了解其工作情况并提供必要支持；组织线上交流活动，增强阿姨对平台的认同感以促进转介绍\n4. - 信息整合能力\n- 简要定义：对筛选出的意向阿姨信息及渠道资源信息进行整理和有效利用的能力\n- 典型行为表现：将不同渠道获取的阿姨信息进行分类整理，建立信息库以便后续跟进；整合各合作渠道输送劳动者的情况，分析渠道有效性并优化合作策略\n5. - 学习适应能力\n- 简要定义：快速学习公司业务流程、家政行业知识并适应岗位要求的能力\n- 典型行为表现：入职后迅速学习公司资质审核标准和平台操作流程；主动了解家政行业动态和不同岗位阿姨的技能要求，以更好地开展工作",
    "interview1": "张继鹏",
    "interview2": "魏秋柠",
    "interview3": "林烽",
    "reason": "新增HC",
    "progress": "6",
    "inBudget": null
  },
  {
    "id": "HC-2026-021",
    "dept": "AI创新事业部 · 劳动者增长部",
    "position": "招商专员",
    "count": 1,
    "priority": "P1",
    "budget": "新增HC",
    "status": "招聘中",
    "recruiter": "杜雁玲",
    "publish": "长沙",
    "received": 0,
    "target": "2026-05-11",
    "city": "长沙",
    "subDept": "劳动者增长部",
    "startDate": "2026-04-15",
    "endDate": "2026-05-11",
    "jd": "岗位职责：\n1、积极利用公司提供或自行开拓的各种资源，通过电话、微信等方式筛选并跟进符合条件的意向保姆、月嫂、育婴师阿姨，协助他们参加公司资质审核、考试等，将其纳入天鹅到家平台；\n2、积极维护和劳动者的关系，增加劳动者的转介绍；\n3、加分项：寻找和拓展负责同月子中心、社区医院、养老院、劳动者培训机构、家政公司等渠道，进行建联，确保渠道定期向公司输送合适的家政行业劳动者，完成蓝领阿姨的招聘目标。\n\n岗位要求：\n1、全日制大专及以上学历，40周岁以下，细心耐心、较好的亲和力；\n2、有较好的沟通能力、学习能力、信息整合能力；\n3、有过人力行政/招聘等工作经验优先，具有RPO等人力资源公司渠道者优先，销售工作经验者优先，月子中心、社区医院、养老院等家政行业工作经验者优先。",
    "capabilityReq": "1. - 沟通协调能力\n- 简要定义：通过电话、微信等方式与意向保姆、月嫂、育婴师阿姨有效沟通，协助其完成资质审核、考试等纳入平台流程的能力\n- 典型行为表现：通过电话向意向阿姨介绍公司资质审核要求和流程，跟进其准备相关材料；利用微信与阿姨沟通考试安排及注意事项\n2. - 渠道拓展能力\n- 简要定义：开拓和维护月子中心、社区医院等渠道，确保定期输送合适家政劳动者的能力\n- 典型行为表现：主动联系本地月子中心进行建联，洽谈合作输送月嫂事宜；与社区医院沟通，建立长期合作关系以获取育婴师推荐资源\n3. - 关系维护能力\n- 简要定义：积极维护与劳动者的关系，以增加转介绍的能力\n- 典型行为表现：定期回访已纳入平台的阿姨，了解其工作情况并提供必要支持；组织线上交流活动，增强阿姨对平台的认同感以促进转介绍\n4. - 信息整合能力\n- 简要定义：对筛选出的意向阿姨信息及渠道资源信息进行整理和有效利用的能力\n- 典型行为表现：将不同渠道获取的阿姨信息进行分类整理，建立信息库以便后续跟进；整合各合作渠道输送劳动者的情况，分析渠道有效性并优化合作策略\n5. - 学习适应能力\n- 简要定义：快速学习公司业务流程、家政行业知识并适应岗位要求的能力\n- 典型行为表现：入职后迅速学习公司资质审核标准和平台操作流程；主动了解家政行业动态和不同岗位阿姨的技能要求，以更好地开展工作",
    "interview1": "丰文杰",
    "interview2": "魏秋柠",
    "interview3": "林烽",
    "reason": "新增HC",
    "progress": "27",
    "inBudget": null
  },
  {
    "id": "HC-2026-031",
    "dept": "AI创新事业部 · AI智聘",
    "position": "产品运营经理",
    "count": 1,
    "priority": "P2",
    "budget": "换人储备",
    "status": "招聘中",
    "recruiter": "杜雁玲",
    "publish": "长沙",
    "received": 0,
    "target": "",
    "city": "长沙",
    "subDept": "AI智聘",
    "startDate": "2026-05-06",
    "endDate": "",
    "jd": "岗位职责\n1. AI驱动的模式落地与运营提效（核心职责）：主导AI技术在运营全链路的深度应用，推动AI驱动用户增长、转化与服务，重构关键运营环节，系统性提升运营效率。\n2. 产品运营与增长驱动：以\"AI+数据\"双引擎制定家政类产品运营策略，推动0到1项目落地，实现运营对业务增长的有效驱动。\n3. 用户增长体系建设：结合家政服务特点，设计不同用户生命周期阶段的增长路径。推动新用户获取、老用户复购裂变。\n4. 数据分析与策略优化：监控核心运营指标（如注册转化率、复购率、用户流失率等），通过数据驱动运营策略调整。挖掘用户需求与行为特征，输出分析报告并提出优化建议。\n5. 团队管理与能力建设：运营团队目标管理、AI应用思维能力培养。\n\n任职要求\n1. 学历背景： 本科及以上，管理学、市场营销等相关专业优先。\n2. AI运营经验（必须项）： 具备AI在运营业务中的丰富落地经验，能清晰阐述如何通过AI推动业务模式创新与效率提升，并呈现量化业务价值。\n3. 运营管理经验： 3年以上销售运营或产品运营团队管理经验，有运营驱动业务增长的成功案例。\n4. 项目统筹能力： 有完整的流程优化、用户增长项目经验，能独立承担项目管理并善用AI增效。",
    "capabilityReq": "1. - AI应用落地能力\n- 简要定义：主导AI技术在运营全链路的深度应用，推动AI驱动业务模式创新与效率提升并呈现量化业务价值\n- 典型行为表现：推动AI驱动用户增长、转化与服务，重构关键运营环节；清晰阐述如何通过AI推动业务模式创新与效率提升\n2. - 产品运营策略能力\n- 简要定义：以\"AI+数据\"双引擎制定家政类产品运营策略，推动0到1项目落地并驱动业务增长\n- 典型行为表现：制定家政类产品运营策略，实现运营对业务增长的有效驱动；有运营驱动业务增长的成功案例\n3. - 用户增长建设能力\n- 简要定义：结合家政服务特点设计不同用户生命周期阶段的增长路径，推动用户获取与复购裂变\n- 典型行为表现：设计用户生命周期阶段的增长路径；推动新用户获取、老用户复购裂变\n4. - 数据分析优化能力\n- 简要定义：监控核心运营指标，通过数据驱动运营策略调整，挖掘用户需求与行为特征并输出分析报告\n- 典型行为表现：监控注册转化率、复购率等核心运营指标；挖掘用户需求与行为特征，输出分析报告并提出优化建议\n5. - 团队管理建设能力\n- 简要定义：负责运营团队目标管理、AI应用思维能力培养及团队能力建设\n- 典型行为表现：进行运营团队目标管理；培养团队AI应用思维能力",
    "interview1": "彭创",
    "interview2": "魏秋柠",
    "interview3": null,
    "reason": "换人储备",
    "progress": "-46147",
    "inBudget": null
  },
  {
    "id": "HC-2026-032",
    "dept": "AI创新事业部 · AI智聘",
    "position": "高级JAVA开发",
    "count": 1,
    "priority": "P2",
    "budget": "换人储备",
    "status": "招聘中",
    "recruiter": "杜雁玲",
    "publish": "长沙",
    "received": 0,
    "target": "",
    "city": "长沙",
    "subDept": "AI智聘",
    "startDate": "2026-05-06",
    "endDate": "",
    "jd": "岗位职责：\n1.参与公司业务系统的 Java 后端开发，负责核心功能模块的设计、开发与维护；\n2.负责 API 接口设计、开发、联调及优化，支持内部系统及第三方系统对接；\n3.参与 AI Agent / 小龙虾（OpenClaw）等工具在研发及业务场景中的应用落地；\n4.与产品、业务及研发团队协作，完成需求分析、技术方案设计、功能迭代和系统优化；\n5.参与系统架构设计、数据库设计及性能优化，提升系统稳定性、扩展性和交付效率；\n6.持续关注 AI 编程工具、Agent 产品及 API 集成能力，推动新技术在实际项目中的应用。\n\n任职要求：\n1.精通 Java 编程语言，熟悉 Spring Boot、Spring Cloud、MyBatis 等主流开发框架；\n2.具备 5 年及以上 Java 后端研发经验，有独立负责模块设计、开发和上线的能力；\n3.熟悉 RESTful API 设计规范，具备接口开发、第三方系统对接、数据同步、权限鉴权等经验；\n4.熟练使用 MySQL、Oracle 等关系型数据库，具备数据库设计、SQL 优化和问题排查能力；\n5.具备良好的面向对象编程思想，熟悉常见设计模式，有较好的代码规范和文档意识；\n6.对 AI Model 基础原理及 Agent 框架有基本认识，能参与 AI Agent 在项目中的集成和应用；\n7.熟悉 AI 编程工具，习惯使用Claude Code、小龙虾（OpenClaw）或相关 Agent 产品辅助研发；\n8.具备良好的沟通协作能力、需求理解能力和问题闭环能力。",
    "capabilityReq": "1. - 后端开发能力\n- 指运用Java及主流框架进行业务系统核心模块设计、开发与维护的能力\n- 参与公司业务系统的Java后端开发，负责核心功能模块的设计、开发与维护；参与系统架构设计、数据库设计及性能优化\n2. - API设计开发能力\n- 指按照规范设计、开发API接口并完成联调优化，支持系统对接的能力\n- 负责API接口设计、开发、联调及优化，支持内部系统及第三方系统对接；熟悉RESTful API设计规范，具备接口开发、第三方系统对接经验\n3. - 数据库应用能力\n- 指熟练使用关系型数据库进行设计、优化及问题排查的能力\n- 熟练使用MySQL、Oracle等关系型数据库，具备数据库设计、SQL优化和问题排查能力\n4. - AI工具应用能力\n- 指理解AI Model及Agent框架，运用AI编程工具辅助研发并推动应用落地的能力\n- 参与AI Agent/小龙虾（OpenClaw）等工具在研发及业务场景中的应用落地；熟悉AI编程工具，习惯使用Claude Code、小龙虾（OpenClaw）或相关Agent产品辅助研发\n5. - 团队协作能力\n- 指与产品、业务及研发团队有效协作，完成需求分析等工作的能力\n- 与产品、业务及研发团队协作，完成需求分析、技术方案设计、功能迭代和系统优化；具备良好的沟通协作能力、需求理解能力和问题闭环能力",
    "interview1": "陈宇佳",
    "interview2": "魏秋柠",
    "interview3": "彭创",
    "reason": "换人储备",
    "progress": "-46147",
    "inBudget": null
  },
  {
    "id": "HC-2026-035",
    "dept": "AI创新事业部 · AI智聘",
    "position": "劳动者运营实习生",
    "count": 2,
    "priority": "P2",
    "budget": "新增HC",
    "status": "招聘中",
    "recruiter": "杜雁玲",
    "publish": "长沙",
    "received": 0,
    "target": "",
    "city": "长沙",
    "subDept": "AI智聘",
    "startDate": "2026-05-25",
    "endDate": "",
    "jd": "【岗位职责】\n招募内容运营：负责家政阿姨招募类笔记的创意策划与发布，吸引潜在劳动者入驻、认证。\n流量优化：跟踪各渠道内容数据（曝光、点击、转化率），分析流量来源与用户行为，持续优化标题、封面、关键词、发布时间等，提升招募帖的曝光与咨询量。\n内容效率提升：针对Boss直聘、社群等渠道的家政招聘岗位，测试不同岗位描述话术、福利亮点、沟通方式，优化从“内容展示”到“求职者主动投递/咨询”的转化效率。\n用户互动：及时回复劳动者咨询，引导意向阿姨完成留资或报名，收集反馈并协助迭代运营策略。\n【任职要求】\n本科及以上学历在读，专业不限；有互联网运营、内容创作、社群运营实习经验者优先。\n熟悉主流内容平台，具备网感，能撰写接地气、有吸引力的招募文案。\n对数据敏感，能简单分析流量数据（曝光、点击、转化）并主动优化动作。\n目标导向，执行力强，善于沟通，有耐心。",
    "capabilityReq": "1. - 内容策划能力\n- 负责家政阿姨招募类笔记的创意策划与发布，撰写接地气、有吸引力的招募文案以吸引潜在劳动者入驻、认证\n- 创意策划家政阿姨招募类笔记并发布\n2. - 流量分析能力\n- 跟踪各渠道内容数据（曝光、点击、转化率），分析流量来源与用户行为，优化内容提升招募帖的曝光与咨询量\n- 分析流量数据并优化标题、封面、关键词、发布时间等\n3. - 转化优化能力\n- 针对不同招聘渠道测试岗位描述话术、福利亮点、沟通方式，提升从“内容展示”到“求职者主动投递/咨询”的转化效率\n- 测试Boss直聘、社群等渠道的招聘内容并优化转化效率\n4. - 用户沟通能力\n- 及时回复劳动者咨询，引导意向阿姨完成留资或报名，收集反馈并协助迭代运营策略\n- 回复劳动者咨询并引导完成留资或报名",
    "interview1": "王嘉伟",
    "interview2": "宗莎",
    "interview3": "魏秋柠",
    "reason": "新增HC",
    "progress": "-46166",
    "inBudget": null
  },
  {
    "id": "HC-2026-022",
    "dept": "雏渐肥事业部 · 销售部",
    "position": "母婴顾问",
    "count": 1,
    "priority": "P1",
    "budget": "换人储备",
    "status": "招聘中",
    "recruiter": "杜雁玲",
    "publish": "苏州",
    "received": 0,
    "target": "",
    "city": "苏州",
    "subDept": "销售部",
    "startDate": "2026-05-01",
    "endDate": "",
    "jd": "岗位职责：\n1、给客户提供母婴相关的专业咨询和服务，针对需要看阿姨的客户筛选月嫂推荐面试；\n2、与客户建立良好的关系，熟悉及挖掘客户需求，促进线上签约；\n3、邀约到店面谈，接待客户促成线下签约；\n4、及时处理客户投诉，安排接单，回答疑难问题，提高客户满意度；\n5、定期参加公司营销培训、系统使用培训，提升营销技能并提高工作效率\n6、顾问式销售，公司给资源，不需要推销；\n任职要求：\n1、大专以上学历，\n2、有销售经验优先;\n3、有良好的抗压能力，能快速调整心态;\n4、有强烈赚钱欲望和积极性;",
    "capabilityReq": "1. - 专业咨询能力\n- 为客户提供母婴相关专业咨询和服务的能力\n- 针对需要看阿姨的客户筛选月嫂推荐面试\n2. - 客户关系维护\n- 与客户建立良好关系并熟悉、挖掘客户需求的能力\n- 促进线上签约，邀约到店面谈并接待客户促成线下签约\n3. - 问题处理能力\n- 及时处理客户投诉、安排接单及回答疑难问题的能力\n- 处理客户投诉，回答客户疑难问题以提高客户满意度\n4. - 营销技能提升\n- 参与培训并提升营销技能和工作效率的能力\n- 定期参加公司营销培训、系统使用培训\n5. - 抗压积极能力\n- 具备良好抗压能力并保持积极性的能力\n- 快速调整心态，保持强烈赚钱欲望和积极性",
    "interview1": "谭维",
    "interview2": "杜雁玲",
    "interview3": "欧阳剑",
    "reason": "换人储备",
    "progress": "-46142",
    "inBudget": null
  },
  {
    "id": "HC-2026-023",
    "dept": "雏渐肥事业部 · 销售部",
    "position": "母婴顾问",
    "count": 1,
    "priority": "P2",
    "budget": "离职替补",
    "status": "招聘中",
    "recruiter": "杜雁玲",
    "publish": "杭州",
    "received": 0,
    "target": "",
    "city": "杭州",
    "subDept": "销售部",
    "startDate": "2026-05-01",
    "endDate": "",
    "jd": "岗位职责：\n1、给客户提供母婴相关的专业咨询和服务，针对需要看阿姨的客户筛选月嫂推荐面试；\n2、与客户建立良好的关系，熟悉及挖掘客户需求，促进线上签约；\n3、邀约到店面谈，接待客户促成线下签约；\n4、及时处理客户投诉，安排接单，回答疑难问题，提高客户满意度；\n5、定期参加公司营销培训、系统使用培训，提升营销技能并提高工作效率\n6、顾问式销售，公司给资源，不需要推销；\n任职要求：\n1、大专以上学历，\n2、有销售经验优先;\n3、有良好的抗压能力，能快速调整心态;\n4、有强烈赚钱欲望和积极性;",
    "capabilityReq": "1. - 专业咨询能力\n- 为客户提供母婴相关专业咨询和服务的能力\n- 针对需要看阿姨的客户筛选月嫂推荐面试\n2. - 客户关系维护\n- 与客户建立良好关系并熟悉、挖掘客户需求的能力\n- 促进线上签约，邀约到店面谈并接待客户促成线下签约\n3. - 问题处理能力\n- 及时处理客户投诉、安排接单及回答疑难问题的能力\n- 处理客户投诉，回答客户疑难问题以提高客户满意度\n4. - 营销技能提升\n- 参与培训并提升营销技能和工作效率的能力\n- 定期参加公司营销培训、系统使用培训\n5. - 抗压积极能力\n- 具备良好抗压能力并保持积极性的能力\n- 快速调整心态，保持强烈赚钱欲望和积极性",
    "interview1": "吴思为",
    "interview2": "杜雁玲",
    "interview3": "欧阳剑",
    "reason": "离职替补",
    "progress": "-46142",
    "inBudget": null
  },
  {
    "id": "HC-2026-036",
    "dept": "雏渐肥事业部 · 销售部",
    "position": "母婴顾问",
    "count": 1,
    "priority": "P2",
    "budget": "换人储备",
    "status": "招聘中",
    "recruiter": "杜雁玲",
    "publish": "南京",
    "received": 0,
    "target": "",
    "city": "南京",
    "subDept": "销售部",
    "startDate": "",
    "endDate": "",
    "jd": "岗位职责：\n1、给客户提供母婴相关的专业咨询和服务，针对需要看阿姨的客户筛选月嫂推荐面试；\n2、与客户建立良好的关系，熟悉及挖掘客户需求，促进线上签约；\n3、邀约到店面谈，接待客户促成线下签约；\n4、及时处理客户投诉，安排接单，回答疑难问题，提高客户满意度；\n5、定期参加公司营销培训、系统使用培训，提升营销技能并提高工作效率\n6、顾问式销售，公司给资源，不需要推销；\n任职要求：\n1、大专以上学历，\n2、有销售经验优先;\n3、有良好的抗压能力，能快速调整心态;\n4、有强烈赚钱欲望和积极性;",
    "capabilityReq": "1. - 专业咨询能力\n- 为客户提供母婴相关专业咨询和服务的能力\n- 针对需要看阿姨的客户筛选月嫂推荐面试\n2. - 客户关系维护\n- 与客户建立良好关系并熟悉、挖掘客户需求的能力\n- 促进线上签约，邀约到店面谈并接待客户促成线下签约\n3. - 问题处理能力\n- 及时处理客户投诉、安排接单及回答疑难问题的能力\n- 处理客户投诉，回答客户疑难问题以提高客户满意度\n4. - 营销技能提升\n- 参与培训并提升营销技能和工作效率的能力\n- 定期参加公司营销培训、系统使用培训\n5. - 抗压积极能力\n- 具备良好抗压能力并保持积极性的能力\n- 快速调整心态，保持强烈赚钱欲望和积极性",
    "interview1": "谭维",
    "interview2": "杜雁玲",
    "interview3": "欧阳剑",
    "reason": "换人储备",
    "progress": "1",
    "inBudget": null
  },
  {
    "id": "HC-2026-024",
    "dept": "雏渐肥事业部 · 招商部（劳动者）",
    "position": "招商专员（CJF）",
    "count": 1,
    "priority": "P2",
    "budget": "换人储备",
    "status": "已入职",
    "recruiter": "杜雁玲",
    "publish": "杭州",
    "received": 0,
    "target": "2026-05-10",
    "city": "杭州",
    "subDept": "招商部（劳动者）",
    "startDate": "2026-05-01",
    "endDate": "2026-05-10",
    "jd": "岗位职责：\n【阿姨招募板块】\n1、通过线上线下渠道（电话/社群/家政公司合作）招募优质保姆、月嫂、育婴师；\n2、帮阿姨完成平台入驻流程，建立长期合作关系；\n3、维护阿姨社群，组织转介绍活动提升招募效率；\n【商家合作板块】\n1、开发家政公司、培训机构等渠道，建立劳动者输送合作；\n2、制定商家合作方案，谈判分成机制，签订合作协议；\n3、跟进合作商家的履约情况，持续优化资源供给；\n任职要求：\n1、学历大专及以上（非全日制亦可），能力优先：善沟通会来事，喜欢和人打交道，耐心；\n2、有资源整合意识：能同时维护阿姨和商家两类资源；\n3、弹性条件（有这些经验更好）：\n- 做过家政/中介/社区团购/电话销售/社群运营等工作；\n- 有销售经验或家政行业资源优先（养老院/社区/月子中心/家政机构/体检中心/医院/本地阿姨等社群资源）。",
    "capabilityReq": "1. 渠道拓展能力\n- 简要定义：通过线上线下多渠道招募阿姨及开发商家合作的能力\n- 典型行为表现：通过电话、社群、家政公司合作等渠道招募保姆、月嫂、育婴师；开发家政公司、培训机构等劳动者输送合作渠道\n2. 资源维护能力\n- 简要定义：同时维护阿姨和商家两类资源并建立长期合作关系的能力\n- 典型行为表现：帮阿姨完成平台入驻流程，建立长期合作关系；跟进合作商家的履约情况，持续优化资源供给\n3. 沟通协调能力\n- 简要定义：与阿姨和商家有效沟通并促成合作的能力\n- 典型行为表现：制定商家合作方案，谈判分成机制，签订合作协议；善沟通会来事，喜欢和人打交道，有耐心\n4. 活动组织能力\n- 简要定义：组织社群活动提升招募效率的能力\n- 典型行为表现：维护阿姨社群，组织转介绍活动提升招募效率\n5. 资源整合能力\n- 简要定义：整合各类资源为岗位服务的意识与能力\n- 典型行为表现：有资源整合意识，能同时维护阿姨和商家两类资源；利用家政行业资源（养老院/社区/月子中心等）开展工作",
    "interview1": "欧阳剑",
    "interview2": "杜雁玲",
    "interview3": null,
    "reason": "换人储备",
    "progress": "10",
    "inBudget": null
  },
  {
    "id": "HC-2026-025",
    "dept": "雏渐肥事业部 · 招商部（劳动者）",
    "position": "招商专员（CJF）",
    "count": 1,
    "priority": "P2",
    "budget": "换人储备",
    "status": "已入职",
    "recruiter": "杜雁玲",
    "publish": "杭州",
    "received": 0,
    "target": "2026-05-10",
    "city": "杭州",
    "subDept": "招商部（劳动者）",
    "startDate": "2026-05-01",
    "endDate": "2026-05-10",
    "jd": "岗位职责：\n【阿姨招募板块】\n1、通过线上线下渠道（电话/社群/家政公司合作）招募优质保姆、月嫂、育婴师；\n2、帮阿姨完成平台入驻流程，建立长期合作关系；\n3、维护阿姨社群，组织转介绍活动提升招募效率；\n【商家合作板块】\n1、开发家政公司、培训机构等渠道，建立劳动者输送合作；\n2、制定商家合作方案，谈判分成机制，签订合作协议；\n3、跟进合作商家的履约情况，持续优化资源供给；\n任职要求：\n1、学历大专及以上（非全日制亦可），能力优先：善沟通会来事，喜欢和人打交道，耐心；\n2、有资源整合意识：能同时维护阿姨和商家两类资源；\n3、弹性条件（有这些经验更好）：\n- 做过家政/中介/社区团购/电话销售/社群运营等工作；\n- 有销售经验或家政行业资源优先（养老院/社区/月子中心/家政机构/体检中心/医院/本地阿姨等社群资源）。",
    "capabilityReq": "1. 渠道拓展能力\n- 简要定义：通过线上线下多渠道招募阿姨及开发商家合作的能力\n- 典型行为表现：通过电话、社群、家政公司合作等渠道招募保姆、月嫂、育婴师；开发家政公司、培训机构等劳动者输送合作渠道\n2. 资源维护能力\n- 简要定义：同时维护阿姨和商家两类资源并建立长期合作关系的能力\n- 典型行为表现：帮阿姨完成平台入驻流程，建立长期合作关系；跟进合作商家的履约情况，持续优化资源供给\n3. 沟通协调能力\n- 简要定义：与阿姨和商家有效沟通并促成合作的能力\n- 典型行为表现：制定商家合作方案，谈判分成机制，签订合作协议；善沟通会来事，喜欢和人打交道，有耐心\n4. 活动组织能力\n- 简要定义：组织社群活动提升招募效率的能力\n- 典型行为表现：维护阿姨社群，组织转介绍活动提升招募效率\n5. 资源整合能力\n- 简要定义：整合各类资源为岗位服务的意识与能力\n- 典型行为表现：有资源整合意识，能同时维护阿姨和商家两类资源；利用家政行业资源（养老院/社区/月子中心等）开展工作",
    "interview1": "欧阳剑",
    "interview2": "杜雁玲",
    "interview3": null,
    "reason": "换人储备",
    "progress": "10",
    "inBudget": null
  },
  {
    "id": "HC-2026-026",
    "dept": "雏渐肥事业部 · 流量运营部",
    "position": "新媒体运营",
    "count": 1,
    "priority": "P2",
    "budget": "换人储备",
    "status": "已入职",
    "recruiter": "杜雁玲",
    "publish": "杭州",
    "received": 0,
    "target": "2026-06-01",
    "city": "杭州",
    "subDept": "流量运营部",
    "startDate": "2026-05-01",
    "endDate": "2026-06-01",
    "jd": "岗位职责：\n1. 线上拓客（自拓）\n通过小红书、抖音等平台，主动寻找目标用户，进行评论互动、私信沟通\n获取客户线索（预产期+联系方式），转交给销售顾问跟进\n2. 视频拍摄与剪辑\n参与视频选题策划，独立完成拍摄与剪辑（以宣发公司为主）\n对母婴话题有感知力，能捕捉有温度的内容瞬间做宣发\n3. 公众号运营\n负责公众号内容的编辑与发布\n具备基础的排版能力，能把专业内容转化成有温度的文字\n4. 直播执行\n每周参与3场直播（每场1小时），负责直播执行或辅助场控\n直播形式：月嫂访谈、育儿答疑、客户连麦，直播引流等等\n5. 抗压与成长\n有目标感，能接受以结果为导向的工作节奏\n愿意主动学习，对新媒体运营有热情，对母婴行业有兴趣\n任职要求\n有1年以上新媒体运营经验（优秀应届生可放宽）\n熟练使用剪映等剪辑工具，能独立完成视频产出\n小红书/抖音深度用户，有网感，懂平台规则\n具备基础文案能力，能独立完成公众号排版\n加分项：有母婴/本地生活/服务行业运营经验",
    "capabilityReq": "1. - 平台拓客能力\n- 简要定义：通过小红书、抖音等线上平台主动寻找目标用户并获取客户线索的能力\n- 典型行为表现：在小红书、抖音等平台对目标用户进行评论互动、私信沟通；成功获取客户的预产期和联系方式等线索并转交给销售顾问跟进\n2. - 视频制作能力\n- 简要定义：参与视频选题策划，独立完成母婴相关宣发视频拍摄与剪辑的能力\n- 典型行为表现：参与视频选题策划并独立完成拍摄与剪辑工作；对母婴话题有感知力，能捕捉有温度的内容瞬间进行宣发\n3. - 公号运营能力\n- 简要定义：负责公众号内容编辑、发布及将专业内容转化为有温度文字的能力\n- 典型行为表现：负责公众号内容的编辑与发布；具备基础排版能力，能把专业内容转化成有温度的文字\n4. - 直播执行能力\n- 简要定义：参与直播执行或辅助场控，保障不同形式母婴直播顺利进行的能力\n- 典型行为表现：每周参与3场（每场1小时）直播，负责直播执行或辅助场控；参与月嫂访谈、育儿答疑、客户连麦等形式的直播引流工作\n5. - 抗压学习能力\n- 简要定义：在结果导向的工作节奏中保持目标感，并主动学习新媒体运营知识的能力\n- 典型行为表现：有目标感，能接受以结果为导向的工作节奏；愿意主动学习，对新媒体运营有热情，对母婴行业有兴趣",
    "interview1": "李博",
    "interview2": "杜雁玲",
    "interview3": "李双",
    "reason": "换人储备",
    "progress": "32",
    "inBudget": null
  },
  {
    "id": "HC-2026-027",
    "dept": "雏渐肥事业部 · 流量运营部",
    "position": "新媒体运营",
    "count": 1,
    "priority": "P2",
    "budget": "换人储备",
    "status": "已入职",
    "recruiter": "杜雁玲",
    "publish": "杭州",
    "received": 0,
    "target": "2026-05-29",
    "city": "杭州",
    "subDept": "流量运营部",
    "startDate": "2026-05-01",
    "endDate": "2026-05-29",
    "jd": "岗位职责：\n1. 线上拓客（自拓）\n通过小红书、抖音等平台，主动寻找目标用户，进行评论互动、私信沟通\n获取客户线索（预产期+联系方式），转交给销售顾问跟进\n2. 视频拍摄与剪辑\n参与视频选题策划，独立完成拍摄与剪辑（以宣发公司为主）\n对母婴话题有感知力，能捕捉有温度的内容瞬间做宣发\n3. 公众号运营\n负责公众号内容的编辑与发布\n具备基础的排版能力，能把专业内容转化成有温度的文字\n4. 直播执行\n每周参与3场直播（每场1小时），负责直播执行或辅助场控\n直播形式：月嫂访谈、育儿答疑、客户连麦，直播引流等等\n5. 抗压与成长\n有目标感，能接受以结果为导向的工作节奏\n愿意主动学习，对新媒体运营有热情，对母婴行业有兴趣\n任职要求\n有1年以上新媒体运营经验（优秀应届生可放宽）\n熟练使用剪映等剪辑工具，能独立完成视频产出\n小红书/抖音深度用户，有网感，懂平台规则\n具备基础文案能力，能独立完成公众号排版\n加分项：有母婴/本地生活/服务行业运营经验",
    "capabilityReq": "1. - 平台拓客能力\n- 简要定义：通过小红书、抖音等线上平台主动寻找目标用户并获取客户线索的能力\n- 典型行为表现：在小红书、抖音等平台对目标用户进行评论互动、私信沟通；成功获取客户的预产期和联系方式等线索并转交给销售顾问跟进\n2. - 视频制作能力\n- 简要定义：参与视频选题策划，独立完成母婴相关宣发视频拍摄与剪辑的能力\n- 典型行为表现：参与视频选题策划并独立完成拍摄与剪辑工作；对母婴话题有感知力，能捕捉有温度的内容瞬间进行宣发\n3. - 公号运营能力\n- 简要定义：负责公众号内容编辑、发布及将专业内容转化为有温度文字的能力\n- 典型行为表现：负责公众号内容的编辑与发布；具备基础排版能力，能把专业内容转化成有温度的文字\n4. - 直播执行能力\n- 简要定义：参与直播执行或辅助场控，保障不同形式母婴直播顺利进行的能力\n- 典型行为表现：每周参与3场（每场1小时）直播，负责直播执行或辅助场控；参与月嫂访谈、育儿答疑、客户连麦等形式的直播引流工作\n5. - 抗压学习能力\n- 简要定义：在结果导向的工作节奏中保持目标感，并主动学习新媒体运营知识的能力\n- 典型行为表现：有目标感，能接受以结果为导向的工作节奏；愿意主动学习，对新媒体运营有热情，对母婴行业有兴趣",
    "interview1": "李博",
    "interview2": "杜雁玲",
    "interview3": "李双",
    "reason": "换人储备",
    "progress": "29",
    "inBudget": null
  },
  {
    "id": "HC-2026-028",
    "dept": "雏渐肥事业部 · 商家运营部",
    "position": "商家运营专员",
    "count": 1,
    "priority": "P2",
    "budget": "换人储备",
    "status": "已入职",
    "recruiter": "杜雁玲",
    "publish": "杭州",
    "received": 0,
    "target": "2026-05-10",
    "city": "杭州",
    "subDept": "商家运营部",
    "startDate": "2026-04-10",
    "endDate": "2026-05-10",
    "jd": "岗位职责：\n1.月嫂日常维护，工资、奖金、路费、物料的发放\n2.月嫂，育婴师正常订单、换单安排\n3.月嫂，育婴师非专业培训\n4.协助顾问急单的对接，以及云管家售后的处理\n任职要求：\n1.大专及以上学历，会熟练使用电脑\n2.性格开朗，善于沟通\n3.能接受非工作时间的信息回复\n4.具有团队精神",
    "capabilityReq": "1. - 人员维护能力\n- 简要定义：负责月嫂日常事务管理及薪资物料发放的能力\n- 典型行为表现：进行月嫂工资、奖金、路费、物料的发放\n2. - 订单安排能力\n- 简要定义：合理安排月嫂和育婴师订单及换单的能力\n- 典型行为表现：处理月嫂、育婴师正常订单、换单安排\n3. - 基础培训能力\n- 简要定义：对月嫂和育婴师开展非专业培训的能力\n- 典型行为表现：开展月嫂、育婴师非专业培训\n4. - 应急对接能力\n- 简要定义：协助处理急单对接及售后问题的能力\n- 典型行为表现：协助顾问急单的对接，处理云管家售后\n5. - 沟通协作能力\n- 简要定义：具备良好沟通能力及团队合作精神的能力\n- 典型行为表现：性格开朗善于沟通，具有团队精神，接受非工作时间信息回复",
    "interview1": "范金荣",
    "interview2": "杜雁玲",
    "interview3": "欧阳剑",
    "reason": "换人储备",
    "progress": "31",
    "inBudget": null
  },
  {
    "id": "HC-2026-029",
    "dept": "雏渐肥事业部 · 商家运营部",
    "position": "商家运营专员",
    "count": 1,
    "priority": "P2",
    "budget": "换人储备",
    "status": "已入职",
    "recruiter": "杜雁玲",
    "publish": "杭州",
    "received": 0,
    "target": "2026-05-10",
    "city": "杭州",
    "subDept": "商家运营部",
    "startDate": "2026-04-10",
    "endDate": "2026-05-10",
    "jd": "岗位职责：\n1.月嫂日常维护，工资、奖金、路费、物料的发放\n2.月嫂，育婴师正常订单、换单安排\n3.月嫂，育婴师非专业培训\n4.协助顾问急单的对接，以及云管家售后的处理\n任职要求：\n1.大专及以上学历，会熟练使用电脑\n2.性格开朗，善于沟通\n3.能接受非工作时间的信息回复\n4.具有团队精神",
    "capabilityReq": "1. - 人员维护能力\n- 简要定义：负责月嫂日常事务管理及薪资物料发放的能力\n- 典型行为表现：进行月嫂工资、奖金、路费、物料的发放\n2. - 订单安排能力\n- 简要定义：合理安排月嫂和育婴师订单及换单的能力\n- 典型行为表现：处理月嫂、育婴师正常订单、换单安排\n3. - 基础培训能力\n- 简要定义：对月嫂和育婴师开展非专业培训的能力\n- 典型行为表现：开展月嫂、育婴师非专业培训\n4. - 应急对接能力\n- 简要定义：协助处理急单对接及售后问题的能力\n- 典型行为表现：协助顾问急单的对接，处理云管家售后\n5. - 沟通协作能力\n- 简要定义：具备良好沟通能力及团队合作精神的能力\n- 典型行为表现：性格开朗善于沟通，具有团队精神，接受非工作时间信息回复",
    "interview1": "范金荣",
    "interview2": "杜雁玲",
    "interview3": "欧阳剑",
    "reason": "换人储备",
    "progress": "31",
    "inBudget": null
  },
  {
    "id": "HC-2026-030",
    "dept": "雏渐肥事业部 · 商家运营部",
    "position": "商家运营专员",
    "count": 1,
    "priority": "P2",
    "budget": "换人储备",
    "status": "已入职",
    "recruiter": "杜雁玲",
    "publish": "杭州",
    "received": 0,
    "target": "2026-05-10",
    "city": "杭州",
    "subDept": "商家运营部",
    "startDate": "2026-04-10",
    "endDate": "2026-05-10",
    "jd": "岗位职责：\n1.月嫂日常维护，工资、奖金、路费、物料的发放\n2.月嫂，育婴师正常订单、换单安排\n3.月嫂，育婴师非专业培训\n4.协助顾问急单的对接，以及云管家售后的处理\n任职要求：\n1.大专及以上学历，会熟练使用电脑\n2.性格开朗，善于沟通\n3.能接受非工作时间的信息回复\n4.具有团队精神",
    "capabilityReq": "1. - 人员维护能力\n- 简要定义：负责月嫂日常事务管理及薪资物料发放的能力\n- 典型行为表现：进行月嫂工资、奖金、路费、物料的发放\n2. - 订单安排能力\n- 简要定义：合理安排月嫂和育婴师订单及换单的能力\n- 典型行为表现：处理月嫂、育婴师正常订单、换单安排\n3. - 基础培训能力\n- 简要定义：对月嫂和育婴师开展非专业培训的能力\n- 典型行为表现：开展月嫂、育婴师非专业培训\n4. - 应急对接能力\n- 简要定义：协助处理急单对接及售后问题的能力\n- 典型行为表现：协助顾问急单的对接，处理云管家售后\n5. - 沟通协作能力\n- 简要定义：具备良好沟通能力及团队合作精神的能力\n- 典型行为表现：性格开朗善于沟通，具有团队精神，接受非工作时间信息回复",
    "interview1": "范金荣",
    "interview2": "杜雁玲",
    "interview3": "欧阳剑",
    "reason": "换人储备",
    "progress": "31",
    "inBudget": null
  },
  {
    "id": "HC-2026-034",
    "dept": "雏渐肥事业部 · 流量运营部",
    "position": "社群用户运营专员",
    "count": 1,
    "priority": "P0",
    "budget": "离职替补",
    "status": "招聘中",
    "recruiter": "杜雁玲",
    "publish": "杭州",
    "received": 0,
    "target": "",
    "city": "杭州",
    "subDept": "流量运营部",
    "startDate": "2026-05-15",
    "endDate": "",
    "jd": "岗位职责：\n1.社群管理：负责雏渐肥社群的日常运营，包括用户答疑、氛围维护、活动发布、规则同步等，提升社群活跃度；\n2.数据跟踪与复盘：更新线索进度、渠道达成等关键指标，每日输出运营数据报表，协助负责人优化运营策略；\n3. 转介绍管理：负责转介绍渠道端线索录入，整理月度营销活动触达转介绍用户；\n4.协助管理：活动返佣、礼品按规则有序发放，与友商及合作部门保持良好沟通；\n5. 领导交办的其他事务：完成上级安排的其他日常事务性工作。\n\n要求：\n1. 大专及以上学历，有社群运营或用户运营实习经验优先；\n2.责任心强：能主动跟进问题，不推诿不拖延\n3.沟通力好：能够用通俗易懂的语言沟通问题，主动push待办事项；",
    "capabilityReq": "1. - 社群运营能力\n- 负责社群日常管理，提升用户活跃度的能力\n- 进行用户答疑、氛围维护、活动发布及规则同步\n2. - 数据处理能力\n- 跟踪并复盘数据，辅助优化运营策略的能力\n- 更新关键指标，每日输出运营数据报表\n3. - 渠道管理能力\n- 管理转介绍渠道，处理线索及活动触达的能力\n- 负责转介绍渠道端线索录入，整理月度营销活动触达转介绍用户\n4. - 协作沟通能力\n- 与友商及合作部门沟通，保障事务有序进行的能力\n- 活动返佣、礼品按规则有序发放，与友商及合作部门保持良好沟通\n5. - 执行推进能力\n- 主动跟进问题，高效完成任务的能力\n- 主动跟进问题不推诿不拖延，主动push待办事项",
    "interview1": "李双",
    "interview2": "杜雁玲",
    "interview3": "欧阳剑",
    "reason": "离职替补",
    "progress": "-46156",
    "inBudget": null
  },
  {
    "id": "HC-2026-051",
    "dept": "雏渐肥事业部 · 商家运营部",
    "position": "商家运营专员",
    "count": 1,
    "priority": "P2",
    "budget": "",
    "status": "招聘中",
    "recruiter": "杜雁玲",
    "publish": "杭州",
    "received": 0,
    "target": "",
    "city": "杭州",
    "subDept": "商家运营部",
    "startDate": "",
    "endDate": "",
    "jd": "岗位职责：\n1.月嫂日常维护，工资、奖金、路费、物料的发放\n2.月嫂，育婴师正常订单、换单安排\n3.月嫂，育婴师非专业培训\n4.协助顾问急单的对接，以及云管家售后的处理\n任职要求：\n1.大专及以上学历，会熟练使用电脑\n2.性格开朗，善于沟通\n3.能接受非工作时间的信息回复\n4.具有团队精神",
    "capabilityReq": "1. - 人员维护能力\n- 简要定义：负责月嫂日常事务管理及薪资物料发放的能力\n- 典型行为表现：进行月嫂工资、奖金、路费、物料的发放\n2. - 订单安排能力\n- 简要定义：合理安排月嫂和育婴师订单及换单的能力\n- 典型行为表现：处理月嫂、育婴师正常订单、换单安排\n3. - 基础培训能力\n- 简要定义：对月嫂和育婴师开展非专业培训的能力\n- 典型行为表现：开展月嫂、育婴师非专业培训\n4. - 应急对接能力\n- 简要定义：协助处理急单对接及售后问题的能力\n- 典型行为表现：协助顾问急单的对接，处理云管家售后\n5. - 沟通协作能力\n- 简要定义：具备良好沟通能力及团队合作精神的能力\n- 典型行为表现：性格开朗善于沟通，具有团队精神，接受非工作时间信息回复",
    "interview1": "黄维",
    "interview2": "帕合尔尼沙·阿不里孜",
    "interview3": null,
    "reason": "",
    "progress": "1",
    "inBudget": null
  },
  {
    "id": "HC-2026-052",
    "dept": "雏渐肥事业部 · 商家运营部",
    "position": "招商主管",
    "count": 1,
    "priority": "P2",
    "budget": "",
    "status": "招聘中",
    "recruiter": "杜雁玲",
    "publish": "杭州",
    "received": 0,
    "target": "",
    "city": "杭州",
    "subDept": "商家运营部",
    "startDate": "",
    "endDate": "",
    "jd": "",
    "capabilityReq": "",
    "interview1": "黄维",
    "interview2": "帕合尔尼沙·阿不里孜",
    "interview3": "杜雁玲",
    "reason": "",
    "progress": "1",
    "inBudget": null
  },
  {
    "id": "HC-2026-054",
    "dept": "雏渐肥事业部 · 商家运营部",
    "position": "市场BD专员",
    "count": 1,
    "priority": "P2",
    "budget": "",
    "status": "招聘中",
    "recruiter": "杜雁玲",
    "publish": "杭州",
    "received": 0,
    "target": "",
    "city": "杭州",
    "subDept": "商家运营部",
    "startDate": "",
    "endDate": "",
    "jd": "",
    "capabilityReq": "",
    "interview1": "黄维",
    "interview2": "帕合尔尼沙·阿不里孜",
    "interview3": "杜雁玲",
    "reason": "",
    "progress": "1",
    "inBudget": null
  }
];

export const feishuCandidates: FeishuCandidate[] = [
  {
    "id": 1,
    "name": "王女士",
    "role": "运营专员",
    "company": "综合运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "王",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "34岁",
    "gender": "女",
    "strengths": "12年综合管理经验，精通商务运营、招投标全流程、合同管理及跨部门协作，具备标准化流程建设能力；有上市公司背景，擅长客户对接与团队管理，与天鹅到家家政服务标准化、职业化方向有一定契合度。",
    "risks": "1. 求职意向为\"商务总监\"（期望15-30K），与运营专员（10-12K）职级薪资差距大，存在动机存疑；\n2. 无家政/本地生活/平台运营直接经验；\n3. 近三段工作均不足3年，稳定性待考察；\n4. 34岁年龄与基础岗匹配度偏低。",
    "aiEval": "以下为候选人的 运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：运营专员（财税法方向）\n🏢 招聘岗位：运营专员\n👤 年龄：34岁 | 性别：女 | 学历：无\n\n初筛结果: 淘汰\n\n优势分析:\n12年综合管理经验，精通商务运营、招投标全流程、合同管理及跨部门协作，具备标准化流程建设能力；有上市公司背景，擅长客户对接与团队管理，与天鹅到家家政服务标准化、职业化方向有一定契合度。\n\n风险点:\n求职意向为\"商务总监\"（期望15-30K），与运营专员（10-12K）职级薪资差距大，存在动机存疑；无家政/本地生活/平台运营直接经验；近三段工作均不足3年，稳定性待考察；34岁年龄与基础岗匹配度偏低。\n\n能力维度匹配:\n1. **流程标准化建设能力：4/5分**。依据：多次主导投标制度、合同管理制度、商务接待SOP制定，建立台账及文件追踪机制，具备从0到1搭建标准化体系的经验。\n2. **跨部门协调与沟通：4/5分**。依据：明确描述为\"跨部门协作核心枢纽\"，统筹市场、财务、法务、技术及运营团队，定期组织复盘会议推动问题解决。\n3. **客户导向与服务意识：3/5分**。依据：有重点客户对接、投诉处理、满意度提升经验，但均为B端企业客户，缺乏C端家政服务场景验证。\n4. **数据分析与经营洞察：3/5分**。依据：负责年度营收总结、预算编制、业绩更新及各类报表制作，但偏向财务统计层面，缺乏用户运营或业务增长类数据分析。\n5. **行业适配与稳定性：2/5分**。依据：无家政/本地生活行业背景；职业路径从行政→商务经理，目标岗位为商务总监，投递运营专员存在明显落差；2017年至今三段工作平均 tenure 约2.5年。\n\n面试问题:\n1. \"请描述一次你协调多个部门解决紧急项目冲突的经历，当时各方诉求是什么，你采取了什么策略，最终结果如何？\"\n2. \"你过往服务的多为企业客户",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "运营专员（财税法方向）",
    "interviewQ": "1. \"请描述一次你协调多个部门解决紧急项目冲突的经历，当时各方诉求是什么，你采取了什么策略，最终结果如何？\"\n2. \"你过往服务的多为企业客户，如果转向服务个人家庭用户（如月嫂/保洁客户），你认为最大的挑战会是什么，你会如何调整？\"\n3. \"你的职业目标是商务总监，目前投递的是运营专员岗位，能否谈谈这个选择背后的考虑，以及未来2-3年的职业规划？\"\n4. \"天鹅到家需要对保洁服务进行标准化拆解（如108项标准），如果你负责这项工作，你会如何设计可执行、可质检的服务流程？\"\n5. \"假设某城市月嫂订单量下滑20%，你会从哪些维度分析原因，并制定提升方案？请简述思路。\"",
    "capabilityMatch": "1. **流程标准化建设能力：4/5分**。依据：多次主导投标制度、合同管理制度、商务接待SOP制定，建立台账及文件追踪机制，具备从0到1搭建标准化体系的经验。\n2. **跨部门协调与沟通：4/5分**。依据：明确描述为\"跨部门协作核心枢纽\"，统筹市场、财务、法务、技术及运营团队，定期组织复盘会议推动问题解决。\n3. **客户导向与服务意识：3/5分**。依据：有重点客户对接、投诉处理、满意度提升经验，但均为B端企业客户，缺乏C端家政服务场景验证。\n4. **数据分析与经营洞察：3/5分**。依据：负责年度营收总结、预算编制、业绩更新及各类报表制作，但偏向财务统计层面，缺乏用户运营或业务增长类数据分析。\n5. **行业适配与稳定性：2/5分**。依据：无家政/本地生活行业背景；职业路径从行政→商务经理，目标岗位为商务总监，投递运营专员存在明显落差；2017年至今三段工作平均 tenure 约2.5年。",
    "created": "2026-05-07 14:39:45"
  },
  {
    "id": 2,
    "name": "曾晨",
    "role": "大客户经理",
    "company": "",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "曾",
    "dept": "",
    "city": "北京",
    "age": "38岁",
    "gender": "无",
    "strengths": "十余年快消母婴/零售KA管理经验，精通山姆、盒马、永辉等大型连锁客户谈判与年度合同落地；具备经销商开发与管理能力，2025年新开发3家经销商；有从0到1新品上市经验，擅长数据驱动的生意分析与策略调整，与天鹅到家标准化、规模化扩张需求高度契合。",
    "risks": "无家政/保洁行业直接经验，服务标准化与人员管理场景需适应；近5年跨2家公司，2020年加入菲仕兰后职位未晋升，职业成长速度存疑；38岁年龄与一线高频出差/地推岗位的体力投入需关注；简历多处文字错误，细致度待考察。",
    "aiEval": "以下为候选人的 大客户经理 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：大客户经理（母婴_保洁类）\n🏢 招聘岗位：大客户经理\n\n初筛结果: 淘汰\n\n优势分析:\n十余年快消母婴/零售KA管理经验，精通山姆、盒马、永辉等大型连锁客户谈判与年度合同落地；具备经销商开发与管理能力，2025年新开发3家经销商；有从0到1新品上市经验，擅长数据驱动的生意分析与策略调整，与天鹅到家标准化、规模化扩张需求高度契合。\n\n风险点:\n无家政/保洁行业直接经验，服务标准化与人员管理场景需适应；近5年跨2家公司，2020年加入菲仕兰后职位未晋升，职业成长速度存疑；38岁年龄与一线高频出差/地推岗位的体力投入需关注；简历多处文字错误，细致度待考察。\n\n能力维度匹配:\n1. **商务拓展与谈判：4/5分。依据：负责NKA/RKA年度合同谈判，覆盖山姆、盒马等头部客户，年销售额1.8亿，同比增长10%，经销商开发成果明确。**\n2. **渠道管理与运营：4/5分。依据：统筹经销商sell in/out、库存周转分析及KA门店陈列、促销、培训全链路管理，具备规模化渠道管控经验。**\n3. **数据分析与策略制定：3/5分。依据：提及分析竞争态势、调整价格结构、输出产品建议，但未展示具体数据工具或量化分析案例。**\n4. **团队管理与协作：3/5分。依据：带过4人团队，描述团队氛围融洽，但未呈现具体管理方法论、绩效改进或冲突处理实例。**\n5. **行业认知与适应力：2/5分。依据：母婴/快消背景与家政服务差异较大，缺乏服务端人员管理、服务标准制定、用户履约体验等核心经验，转型跨度需验证。**\n\n面试问题:\n1. 请描述一次你与采购方谈判陷入僵局的经历，具体分歧是什么，你采取了哪些策略最终促成合作？\n2. 你曾管理经销商库存周转，当经销商因压货拒绝配合你的销售目标时，你是如何平衡双方利益并推动执行",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "大客户经理（母婴_保洁类）",
    "interviewQ": "1. 请描述一次你与采购方谈判陷入僵局的经历，具体分歧是什么，你采取了哪些策略最终促成合作？\n2. 你曾管理经销商库存周转，当经销商因压货拒绝配合你的销售目标时，你是如何平衡双方利益并推动执行的？\n3. 你在菲仕兰工作5年，期间是否有考虑过内部晋升或转岗机会，目前看外部机会的核心驱动力是什么？\n4. 家政服务的核心难点在于服务者的非标准化，假设你需要为天鹅到家设计一套保洁服务者的分级认证体系，你会从哪些维度切入，如何与现有客户分层策略结合？\n5. 你过往对接的多为商超渠道，to B决策链相对清晰；若转向面对分散的社区门店或平台合作方，你认为获客和维系的关键差异点在哪里，你会如何快速建立信任？",
    "capabilityMatch": "1. **商务拓展与谈判：4/5分。依据：负责NKA/RKA年度合同谈判，覆盖山姆、盒马等头部客户，年销售额1.8亿，同比增长10%，经销商开发成果明确。**\n2. **渠道管理与运营：4/5分。依据：统筹经销商sell in/out、库存周转分析及KA门店陈列、促销、培训全链路管理，具备规模化渠道管控经验。**\n3. **数据分析与策略制定：3/5分。依据：提及分析竞争态势、调整价格结构、输出产品建议，但未展示具体数据工具或量化分析案例。**\n4. **团队管理与协作：3/5分。依据：带过4人团队，描述团队氛围融洽，但未呈现具体管理方法论、绩效改进或冲突处理实例。**\n5. **行业认知与适应力：2/5分。依据：母婴/快消背景与家政服务差异较大，缺乏服务端人员管理、服务标准制定、用户履约体验等核心经验，转型跨度需验证。**",
    "created": "2026-05-08 11:48:36"
  },
  {
    "id": 3,
    "name": "吴斌",
    "role": "市场BD专员",
    "company": "综合渠道部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "吴",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "38岁",
    "gender": "男",
    "strengths": "13年渠道拓展经验，擅长物业/地产类B端商务谈判，具备从陌拜到签约落地的完整闭环能力；有团队管理经验，执行力强，能快速建立合作关系并跟进项目验收回款，适应高强度业务拓展节奏。",
    "risks": "无孕婴/家政行业经验，过往客户群体为物业、地产、停车场等，与目标行业资源错位；年龄38岁接近上限，职业路径从销售总监降至专员岗，存在稳定性与动机存疑；缺乏数据复盘及母婴市场洞察的直接证据。",
    "aiEval": "初筛结果：淘汰\n\n优势分析（≤120字）：\n13年渠道拓展经验，擅长物业/地产类B端商务谈判，具备从陌拜到签约落地的完整闭环能力；有团队管理经验，执行力强，能快速建立合作关系并跟进项目验收回款，适应高强度业务拓展节奏。\n\n风险点（≤120字）：\n无孕婴/家政行业经验，过往客户群体为物业、地产、停车场等，与目标行业资源错位；年龄38岁接近上限，职业路径从销售总监降至专员岗，存在稳定性与动机存疑；缺乏数据复盘及母婴市场洞察的直接证据。\n\n能力维度匹配：\n1. **渠道拓展能力：3/5分。依据：有丰富B端拓展经验，但行业领域为物业/地产/停车场，与孕婴/家政行业差异大，无相关商家资源积累，需重新建立行业认知。\n2. **客情维护能力：4/5分。依据：多次提及维护物业关系、跟进项目验收回款、处理政府部门协调，具备长期客情维护意识与实操经验。\n3. **数据复盘能力：2/5分。依据：简历未体现数据分析、定期复盘、竞品监测等行为，仅提及\"总结工作、发现问题\"，缺乏量化数据管理证据。\n4. **市场洞察能力：2/5分。依据：无孕婴市场、家政行业或竞品动态分析经验，过往行业为防水、停车、润滑油，市场认知需从零构建。\n5. **商务谈判能力：4/5分。依据：多次独立完成战略合作签约（万科、富力等），具备从洽谈到合同落地的全流程谈判能力，但谈判对象非目标行业。\n\n建议追问的面试问题（5个）：\n\n1. 请描述一次你从陌生行业从零开始拓展渠道的经历，具体如何快速建立行业认知并完成首单签约？\n2. 过往你维护的物业合作关系平均周期多长？请举例说明当合作方提出终止合作时，你如何挽回或平稳过渡？\n3. 你近三段工作经历时长分别为2年3个月、2年3个月、2年7个月，且职位呈下降趋势，能否说明离职原因及你对本次岗位3年以上稳定性的规划？\n4. 假设你需要在30天内拓展10家月子中心合作，请简述你的目标拆解、",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "渠道拓展专员",
    "interviewQ": "1. 请描述一次你从陌生行业从零开始拓展渠道的经历，具体如何快速建立行业认知并完成首单签约？\n2. 过往你维护的物业合作关系平均周期多长？请举例说明当合作方提出终止合作时，你如何挽回或平稳过渡？\n3. 你近三段工作经历时长分别为2年3个月、2年3个月、2年7个月，且职位呈下降趋势，能否说明离职原因及你对本次岗位3年以上稳定性的规划？\n4. 假设你需要在30天内拓展10家月子中心合作，请简述你的目标拆解、陌拜话术设计、以及可能遇到的拒绝类型及应对策略。\n5. 渠道合作中常出现\"线索数量多但转化率低\"的情况，请结合过往经验说明你会如何联动销售团队诊断问题并优化？",
    "capabilityMatch": "1. **渠道拓展能力：3/5分。依据：有丰富B端拓展经验，但行业领域为物业/地产/停车场，与孕婴/家政行业差异大，无相关商家资源积累，需重新建立行业认知。\n2. **客情维护能力：4/5分。依据：多次提及维护物业关系、跟进项目验收回款、处理政府部门协调，具备长期客情维护意识与实操经验。\n3. **数据复盘能力：2/5分。依据：简历未体现数据分析、定期复盘、竞品监测等行为，仅提及\"总结工作、发现问题\"，缺乏量化数据管理证据。\n4. **市场洞察能力：2/5分。依据：无孕婴市场、家政行业或竞品动态分析经验，过往行业为防水、停车、润滑油，市场认知需从零构建。\n5. **商务谈判能力：4/5分。依据：多次独立完成战略合作签约（万科、富力等），具备从洽谈到合同落地的全流程谈判能力，但谈判对象非目标行业。",
    "created": "2026-05-08 11:48:41"
  },
  {
    "id": 4,
    "name": "钰斌",
    "role": "市场BD专员",
    "company": "综合渠道部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "待定",
    "star": 0,
    "avatar": "钰",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "29岁",
    "gender": "无",
    "strengths": "10年母婴护理一线经验，深度了解产妇/新生儿服务场景；具备培训带教、库存管理、人员协调经验；持多项护理资质，对孕婴行业有认知基础。",
    "risks": "零商务/渠道拓展经验，无销售、谈判、数据分析背景；职业路径从临床护理→社区→母婴护理师，均为执行岗，无BD或市场类经历；年龄29岁但行业转型跨度大，技能缺口显著。",
    "aiEval": "以下为候选人的 市场BD专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：渠道拓展专员\n🏢 招聘岗位：市场BD专员\n\n初筛结果: 淘汰\n\n优势分析:\n10年母婴护理一线经验，深度了解产妇/新生儿服务场景；具备培训带教、库存管理、人员协调经验；持多项护理资质，对孕婴行业有认知基础。\n\n风险点:\n零商务/渠道拓展经验，无销售、谈判、数据分析背景；职业路径从临床护理→社区→母婴护理师，均为执行岗，无BD或市场类经历；年龄29岁但行业转型跨度大，技能缺口显著。\n\n能力维度匹配:\n1. **渠道拓展能力：0/5分。依据：简历无任何商务拓展、商家对接、异业合作经验，职业经历均为护理服务执行岗。**\n2. **客情维护能力：2/5分。依据：有内部团队协调、客户关系维护经验（责任护理长、人事管理），但属服务交付场景，非渠道合作场景。**\n3. **数据复盘能力：1/5分。依据：提及\"计划采买、入库、出库\"等库存管理，属操作层数据记录，无渠道线索转化分析、市场数据复盘经验。**\n4. **市场洞察能力：2/5分。依据：长期深耕母婴护理领域，熟悉孕婴服务场景与客户痛点，但无竞品分析、行业动态追踪、市场信息输出经历。**\n5. **商务谈判能力：0/5分。依据：简历无任何商务谈判、合作签约、资源整合相关经验，职业经历不涉及对外商务场景。**\n\n面试问题:\n1. 请描述一次你主动推动跨部门/跨机构协作完成任务的经历，当时如何协调各方资源、解决分歧？\n2. 作为责任护理长，当遇到客户投诉或合作方（如医院、供应商）提出额外需求时，你如何处理并达成双方满意的结果？\n3. 从临床护理转向母婴护理师，再到应聘渠道拓展岗，这几次职业转换的决策逻辑是什么？如何看待未来3-5年的职业稳定性？\n4. 假设你需要与一家月子中心谈合作，对方担心推荐客户后服务质量不可控，你会如何设计合作方案并谈判推进？\n5. ",
    "aiScreen": "已入库（人工确认）",
    "hrReview": "",
    "interviewPos": "渠道拓展专员",
    "interviewQ": "1. 请描述一次你主动推动跨部门/跨机构协作完成任务的经历，当时如何协调各方资源、解决分歧？\n2. 作为责任护理长，当遇到客户投诉或合作方（如医院、供应商）提出额外需求时，你如何处理并达成双方满意的结果？\n3. 从临床护理转向母婴护理师，再到应聘渠道拓展岗，这几次职业转换的决策逻辑是什么？如何看待未来3-5年的职业稳定性？\n4. 假设你需要与一家月子中心谈合作，对方担心推荐客户后服务质量不可控，你会如何设计合作方案并谈判推进？\n5. 请基于你的行业经验，分析北京孕婴摄影、母婴店等渠道获取家政服务线索的核心痛点，并说明你会如何设计异业合作模式？",
    "capabilityMatch": "1. **渠道拓展能力：0/5分。依据：简历无任何商务拓展、商家对接、异业合作经验，职业经历均为护理服务执行岗。**\n2. **客情维护能力：2/5分。依据：有内部团队协调、客户关系维护经验（责任护理长、人事管理），但属服务交付场景，非渠道合作场景。**\n3. **数据复盘能力：1/5分。依据：提及\"计划采买、入库、出库\"等库存管理，属操作层数据记录，无渠道线索转化分析、市场数据复盘经验。**\n4. **市场洞察能力：2/5分。依据：长期深耕母婴护理领域，熟悉孕婴服务场景与客户痛点，但无竞品分析、行业动态追踪、市场信息输出经历。**\n5. **商务谈判能力：0/5分。依据：简历无任何商务谈判、合作签约、资源整合相关经验，职业经历不涉及对外商务场景。**",
    "created": "2026-05-08 11:48:42"
  },
  {
    "id": 5,
    "name": "任彦俐",
    "role": "运营专员",
    "company": "综合运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "任",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "29岁",
    "gender": "女",
    "strengths": "9年财税商务复合背景，具备供应商管理、招投标全流程、合同风控及成本管控经验；数据敏感度高，擅长台账管理与流程优化，ERP/OA系统熟练，可迁移至家政服务标准化与数字化运营。",
    "risks": "无家政/生活服务/O2O行业经验，业务场景差异大；近4年半岗位未晋升，职业成长轨迹平缓；29岁（1994年生）未体现管理或带团队经验，高潜属性不足。",
    "aiEval": "以下为候选人的 运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：运营专员（财税法方向）\n🏢 招聘岗位：运营专员\n\n初筛结果: 淘汰\n\n优势分析:\n9年财税商务复合背景，具备供应商管理、招投标全流程、合同风控及成本管控经验；数据敏感度高，擅长台账管理与流程优化，ERP/OA系统熟练，可迁移至家政服务标准化与数字化运营。\n\n风险点:\n无家政/生活服务/O2O行业经验，业务场景差异大；近4年半岗位未晋升，职业成长轨迹平缓；29岁（1994年生）未体现管理或带团队经验，高潜属性不足。\n\n能力维度匹配:\n1. **商务运营能力：4/5分。依据：4年商务专员经验覆盖采销全链路、招投标、供应商管理，流程闭环完整，但行业属性为IT硬件，与家政服务场景有差距。**\n2. **数据分析能力：3.5/5分。依据：财务背景+商务台账管理经验，具备成本意识与数据整理能力，但简历未体现深度分析或BI工具应用。**\n3. **合规风控能力：4/5分。依据：财务出身+合同审核+税务申报经验，风险意识强，零差错记录，契合家政服务合规化要求。**\n4. **沟通协调能力：3.5/5分。依据：简历描述\"良好对内对外沟通\"，但缺乏具体案例（如冲突解决、跨部门重大项目推动）。**\n5. **行业适配潜力：2.5/5分。依据：无家政/O2O/本地生活经验，服务标准化、阿姨管理、用户运营等核心场景需从零学习，转型成本较高。**\n\n面试问题:\n1. 请描述一次你与难缠供应商谈判并达成双赢的具体案例，当时分歧点是什么？你采取了哪些策略？\n2. 财务工作需高度严谨，商务工作强调灵活应变，两种角色切换中你遇到过什么冲突？如何平衡？\n3. 过去4年多未主动寻求晋升或转岗，能否分享你的职业规划？什么契机让你考虑加入家政行业？\n4. 假设需制定一套保洁服务SOP，你会如何从0到1搭建标准、培训落地并监控执行效果？\n5",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "运营专员（财税法方向）",
    "interviewQ": "1. 请描述一次你与难缠供应商谈判并达成双赢的具体案例，当时分歧点是什么？你采取了哪些策略？\n2. 财务工作需高度严谨，商务工作强调灵活应变，两种角色切换中你遇到过什么冲突？如何平衡？\n3. 过去4年多未主动寻求晋升或转岗，能否分享你的职业规划？什么契机让你考虑加入家政行业？\n4. 假设需制定一套保洁服务SOP，你会如何从0到1搭建标准、培训落地并监控执行效果？\n5. 家政服务涉及阿姨（供给端）、用户（需求端）、平台三方，若阿姨临时爽约导致用户投诉，你的应急处理流程是什么？",
    "capabilityMatch": "1. **商务运营能力：4/5分。依据：4年商务专员经验覆盖采销全链路、招投标、供应商管理，流程闭环完整，但行业属性为IT硬件，与家政服务场景有差距。**\n2. **数据分析能力：3.5/5分。依据：财务背景+商务台账管理经验，具备成本意识与数据整理能力，但简历未体现深度分析或BI工具应用。**\n3. **合规风控能力：4/5分。依据：财务出身+合同审核+税务申报经验，风险意识强，零差错记录，契合家政服务合规化要求。**\n4. **沟通协调能力：3.5/5分。依据：简历描述\"良好对内对外沟通\"，但缺乏具体案例（如冲突解决、跨部门重大项目推动）。**\n5. **行业适配潜力：2.5/5分。依据：无家政/O2O/本地生活经验，服务标准化、阿姨管理、用户运营等核心场景需从零学习，转型成本较高。**",
    "created": "2026-05-08 11:48:43"
  },
  {
    "id": 6,
    "name": "王水平",
    "role": "运营专员",
    "company": "综合运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "王",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "35岁",
    "gender": "无",
    "strengths": "12年运营经验，擅长合同合规、采购管理、经营数据分析及跨部门协作，具备较强的流程管控与风险意识；有从数据分析师到运营主管的完整职业路径，数据驱动决策能力强，可支撑家政服务数字化与标准化建设。",
    "risks": "无家政/生活服务/O2O行业背景，缺乏一线业务运营及用户服务经验；近5年工作偏B端政企项目（司法大数据、智慧园区），与天鹅到家C端家政场景差异较大；35岁转型成本较高，稳定性待验证。",
    "aiEval": "以下为候选人的 运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：运营专员（财税法方向）\n🏢 招聘岗位：运营专员\n\n初筛结果: 存疑\n\n优势分析:\n12年运营经验，擅长合同合规、采购管理、经营数据分析及跨部门协作，具备较强的流程管控与风险意识；有从数据分析师到运营主管的完整职业路径，数据驱动决策能力强，可支撑家政服务数字化与标准化建设。\n\n风险点:\n无家政/生活服务/O2O行业背景，缺乏一线业务运营及用户服务经验；近5年工作偏B端政企项目（司法大数据、智慧园区），与天鹅到家C端家政场景差异较大；35岁转型成本较高，稳定性待验证。\n\n能力维度匹配:\n1. **数据分析与经营洞察：4/5分。依据：11年数据分析经验，搭建收入测算模型、业绩分析报告，熟悉经营数据全流程，可直接迁移至家政业务数据化运营。**\n2. **流程管控与合规管理：4/5分。依据：年处理700+份合同、1000万+采购管理，建立开票回款跟踪机制，标准化能力强，契合家政服务职业化合规需求。**\n3. **跨部门协作与沟通：3.5/5分。依据：长期对接财务、经管、战略等多部门，推动审批闭环，但缺乏C端用户、一线服务者沟通场景验证。**\n4. **行业认知与业务适配：2/5分。依据：无家政、本地生活、O2O或C端运营经验，智慧园区、司法大数据项目与家政服务场景差异显著，需重新建立行业理解。**\n5. **稳定性与转型意愿：2.5/5分。依据：12年3份工作平均4年/家稳定性尚可，但最近一次5年任期即将结束（2026.03），求职意向为商务经理（15-18K），与运营专员（10-12K）职级薪资双降，动机需深挖。**\n\n面试问题:\n1. \"请描述一次你协调多个部门解决紧急问题的经历，当时各方诉求冲突点是什么？你具体如何推动达成共识？\"\n2. \"你的过往经历偏B端内部运营，若转向C端家政服务，面对用户投诉",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "运营专员（财税法方向）",
    "interviewQ": "1. \"请描述一次你协调多个部门解决紧急问题的经历，当时各方诉求冲突点是什么？你具体如何推动达成共识？\"\n2. \"你的过往经历偏B端内部运营，若转向C端家政服务，面对用户投诉或服务者纠纷，你认为最大的挑战会是什么？请举例说明你处理过类似压力场景。\"\n3. \"你目前求职意向是商务经理（15-18K），该岗位为运营专员（10-12K），且行业跨度较大，能否说明选择天鹅到家的核心动机及3年职业规划？\"\n4. \"天鹅到家需将保洁、保姆等服务流程标准化，结合你搭建合同管理体系的经验，如何设计一套可落地的服务者培训与质检SOP？\"\n5. \"假设你需要分析某城市月嫂订单量下滑的原因，请简述你的分析框架，并说明会调取哪些核心数据指标？\"\n6. \"今天的交流到此，我也想听听你的想法——关于天鹅到家目前的业务挑战、这个岗位的实际工作内容，或者团队氛围，有没有什么是你特别想了解或确认的？我们也希望找到双向契合的伙伴。\"",
    "capabilityMatch": "1. **数据分析与经营洞察：4/5分。依据：11年数据分析经验，搭建收入测算模型、业绩分析报告，熟悉经营数据全流程，可直接迁移至家政业务数据化运营。**\n2. **流程管控与合规管理：4/5分。依据：年处理700+份合同、1000万+采购管理，建立开票回款跟踪机制，标准化能力强，契合家政服务职业化合规需求。**\n3. **跨部门协作与沟通：3.5/5分。依据：长期对接财务、经管、战略等多部门，推动审批闭环，但缺乏C端用户、一线服务者沟通场景验证。**\n4. **行业认知与业务适配：2/5分。依据：无家政、本地生活、O2O或C端运营经验，智慧园区、司法大数据项目与家政服务场景差异显著，需重新建立行业理解。**\n5. **稳定性与转型意愿：2.5/5分。依据：12年3份工作平均4年/家稳定性尚可，但最近一次5年任期即将结束（2026.03），求职意向为商务经理（15-18K），与运营专员（10-12K）职级薪资双降，动机需深挖。**",
    "created": "2026-05-08 11:48:45"
  },
  {
    "id": 7,
    "name": "蒋世明",
    "role": "运营专员",
    "company": "综合运营部",
    "years": 0,
    "edu": "法学本科",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "蒋",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "无",
    "gender": "无",
    "strengths": "具备7年跨领域商务经验，擅长政企资源对接、项目落地与多方协调；有医疗行业数字化项目（互联网医院、电子处方流转）实操经验，对标准化服务流程有一定认知；性格外向，商务沟通与执行能力突出。",
    "risks": "岗位目标为运营专员（财税法方向），但简历完全无财税法相关背景、经验或技能；法学本科2024年6月才毕业，缺乏法律实务经验；近4年经历均为商务/销售岗，职业路径与运营岗偏离；期望薪资20-22K远超JD标注的10-12K，薪资预期严重不匹配。",
    "aiEval": "以下为候选人的 运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：运营专员（财税法方向）\n🏢 招聘岗位：运营专员\n\n初筛结果: 淘汰\n\n优势分析:\n具备7年跨领域商务经验，擅长政企资源对接、项目落地与多方协调；有医疗行业数字化项目（互联网医院、电子处方流转）实操经验，对标准化服务流程有一定认知；性格外向，商务沟通与执行能力突出。\n\n风险点:\n岗位目标为运营专员（财税法方向），但简历完全无财税法相关背景、经验或技能；法学本科2024年6月才毕业，缺乏法律实务经验；近4年经历均为商务/销售岗，职业路径与运营岗偏离；期望薪资20-22K远超JD标注的10-12K，薪资预期严重不匹配。\n\n能力维度匹配:\n1. **业务理解力：2/5分。依据：有医疗健康行业经验，但完全缺乏家政服务、财税法领域认知，行业切换跨度极大，无相关学习或实践痕迹。**\n2. **数据分析与运营：1/5分。依据：简历无任何数据分析、用户运营、流程优化、财税处理等运营核心技能描述，工作内容以商务拓展为主。**\n3. **沟通协调与资源整合：4/5分。依据：多次成功对接政府、医院、保司等多方资源，统筹项目落地，沟通协调经验丰富。**\n4. **学习适应与稳定性：2/5分。依据：4年内3段经历，平均任期约16个月；职业方向从传媒跳转医疗，再跳财税法运营，目标漂移明显；法学在读期间即全职工作，学业与职业专注度存疑。**\n5. **职业动机与薪资匹配：1/5分。依据：期望薪资为JD上限的近2倍，投递方向与自身背景、薪资预期均严重错位，动机合理性不足。**\n\n面试问题:\n1. 你目前从事商务工作且即将获得法学学位，为何选择投递\"运营专员（财税法方向）\"这一基层岗位？请具体说明你的职业转型思考过程。\n2. 你的期望薪资为20-22K，但该岗位预算为10-12K，这一差距你将如何协调？是否了解家政服务行业的薪酬结",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "运营专员（财税法方向）",
    "interviewQ": "1. 你目前从事商务工作且即将获得法学学位，为何选择投递\"运营专员（财税法方向）\"这一基层岗位？请具体说明你的职业转型思考过程。\n2. 你的期望薪资为20-22K，但该岗位预算为10-12K，这一差距你将如何协调？是否了解家政服务行业的薪酬结构？\n3. 你过往经历中平均任期约1-2年，请分享一次你主动选择离开的经历，当时是基于哪些因素做出的决定？\n4. 该岗位涉及家政服务人员的财税合规管理，请简述你对灵活用工人员个人所得税申报或社保缴纳政策的了解程度。\n5. 假设你需要设计一套保洁服务的标准化验收流程，请描述你会从哪些维度建立可量化的服务标准，并如何收集数据持续优化？",
    "capabilityMatch": "1. **业务理解力：2/5分。依据：有医疗健康行业经验，但完全缺乏家政服务、财税法领域认知，行业切换跨度极大，无相关学习或实践痕迹。**\n2. **数据分析与运营：1/5分。依据：简历无任何数据分析、用户运营、流程优化、财税处理等运营核心技能描述，工作内容以商务拓展为主。**\n3. **沟通协调与资源整合：4/5分。依据：多次成功对接政府、医院、保司等多方资源，统筹项目落地，沟通协调经验丰富。**\n4. **学习适应与稳定性：2/5分。依据：4年内3段经历，平均任期约16个月；职业方向从传媒跳转医疗，再跳财税法运营，目标漂移明显；法学在读期间即全职工作，学业与职业专注度存疑。**\n5. **职业动机与薪资匹配：1/5分。依据：期望薪资为JD上限的近2倍，投递方向与自身背景、薪资预期均严重错位，动机合理性不足。**",
    "created": "2026-05-08 14:53:02"
  },
  {
    "id": 8,
    "name": "邱震",
    "role": "运营专员",
    "company": "综合运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "邱",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "27岁",
    "gender": "无",
    "strengths": "4年中铁央企商务法务经验，具备招投标全流程管控、合同生命周期管理、成本测算与结算等标准化流程能力；多任务并行处理能力强（高峰期同步推进6个项目），数据敏感度高，曾获集团多项荣誉，职业稳定性基础较好。",
    "risks": "行业背景差异显著（建筑工程→家政服务），缺乏互联网/平台运营经验及用户端服务场景；技能工具侧重工程预算软件（广联达、铁路预算），与家政数字化运营工具匹配度低；27岁4年工作经验后寻求跨行业转型，动机与长期稳定性待验证。",
    "aiEval": "以下为候选人的 运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：运营专员（财税法方向）\n🏢 招聘岗位：运营专员\n\n初筛结果: 存疑\n\n优势分析:\n4年中铁央企商务法务经验，具备招投标全流程管控、合同生命周期管理、成本测算与结算等标准化流程能力；多任务并行处理能力强（高峰期同步推进6个项目），数据敏感度高，曾获集团多项荣誉，职业稳定性基础较好。\n\n风险点:\n行业背景差异显著（建筑工程→家政服务），缺乏互联网/平台运营经验及用户端服务场景；技能工具侧重工程预算软件（广联达、铁路预算），与家政数字化运营工具匹配度低；27岁4年工作经验后寻求跨行业转型，动机与长期稳定性待验证。\n\n能力维度匹配:\n1. **流程标准化能力：4/5分。依据：主导76次招标全流程、百余份合同全周期管理，具备强流程设计与执行经验，可迁移至家政服务标准化建设。**\n2. **数据分析与经营意识：3.5/5分。依据：擅长成本测算、报价管控、结算及时率100%，但缺乏用户行为数据、C端运营指标分析经验。**\n3. **多任务协同与执行力：4/5分。依据：高峰期6项目并行、年均70余份结算单据处理，跨部门协同经验丰富，抗压能力强。**\n4. **行业认知与用户洞察：1/5分。依据：简历无任何家政、生活服务、互联网平台相关经历，B端工程思维与C端服务场景差异大。**\n5. **数字化工具应用：2/5分。依据：熟练使用Office及工程专用软件，但缺乏CRM、ERP、数据分析平台等互联网运营工具经验。**\n\n面试问题:\n1. 请描述一次你同时推进多个紧急任务时，如何协调各方资源确保节点达成的具体案例，当时遇到的最大阻力是什么？\n2. 在合同评审或招投标过程中，是否遇到过合作方强烈反对条款的情况？你如何平衡公司利益与对方诉求，最终达成双赢？\n3. 从建筑工程转向家政服务运营，这一职业转型的核心驱动力是什",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "运营专员（财税法方向）",
    "interviewQ": "1. 请描述一次你同时推进多个紧急任务时，如何协调各方资源确保节点达成的具体案例，当时遇到的最大阻力是什么？\n2. 在合同评审或招投标过程中，是否遇到过合作方强烈反对条款的情况？你如何平衡公司利益与对方诉求，最终达成双赢？\n3. 从建筑工程转向家政服务运营，这一职业转型的核心驱动力是什么？未来3-5年的职业规划如何与天鹅到家平台发展结合？\n4. 假设你需要为平台设计一套保洁服务标准化流程（含服务前-中-后关键节点），请简述你的设计思路及可量化的核心指标。\n5. 针对家政服务常见的客诉场景（如服务超时、物品损坏），结合你过往的风险管控经验，你会如何建立预防机制与应急响应流程？",
    "capabilityMatch": "1. **流程标准化能力：4/5分。依据：主导76次招标全流程、百余份合同全周期管理，具备强流程设计与执行经验，可迁移至家政服务标准化建设。**\n2. **数据分析与经营意识：3.5/5分。依据：擅长成本测算、报价管控、结算及时率100%，但缺乏用户行为数据、C端运营指标分析经验。**\n3. **多任务协同与执行力：4/5分。依据：高峰期6项目并行、年均70余份结算单据处理，跨部门协同经验丰富，抗压能力强。**\n4. **行业认知与用户洞察：1/5分。依据：简历无任何家政、生活服务、互联网平台相关经历，B端工程思维与C端服务场景差异大。**\n5. **数字化工具应用：2/5分。依据：熟练使用Office及工程专用软件，但缺乏CRM、ERP、数据分析平台等互联网运营工具经验。**",
    "created": "2026-05-08 14:53:04"
  },
  {
    "id": 9,
    "name": "刘肖肖",
    "role": "运营专员",
    "company": "综合运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "刘",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "无",
    "gender": "无相关信息",
    "strengths": "具备10年运营经验，擅长数据管理、流程制度搭建与跨部门协同，有房产互联网运营背景，对标准化服务流程和佣金结算体系熟悉，可迁移至家政服务数字化运营场景。",
    "risks": "无家政/母婴/保洁行业经验，技能描述混乱（\"精通e l q、s l e c x e\"疑似OCR错误），教育经历时间倒置（2012-2016写成\"60.6102-90.2102\"），职业稳定性存疑（2年跳1次），缺乏用户端服务运营直接经验。",
    "aiEval": "以下为候选人的 运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：运营专员（财税法方向）\n🏢 招聘岗位：运营专员\n\n初筛结果: 淘汰\n\n优势分析:\n具备10年运营经验，擅长数据管理、流程制度搭建与跨部门协同，有房产互联网运营背景，对标准化服务流程和佣金结算体系熟悉，可迁移至家政服务数字化运营场景。\n\n风险点:\n无家政/母婴/保洁行业经验，技能描述混乱（\"精通e l q、s l e c x e\"疑似OCR错误），教育经历时间倒置（2012-2016写成\"60.6102-90.2102\"），职业稳定性存疑（2年跳1次），缺乏用户端服务运营直接经验。\n\n能力维度匹配:\n1. **运营流程标准化：4/5分。依据：简历明确提及\"制定业务相关流程制度及标准化操作规范\"\"建立健全合同管理台账\"，有完整SOP搭建与落地经验。\n2. **数据管理与分析：3/5分。依据：负责日报/周报/月报输出，但仅描述为\"审核、校验及汇总\"，未体现深度分析或数据驱动决策案例。\n3. **跨部门沟通协调：4/5分。依据：明确担任\"总部与业务部门的核心沟通枢纽\"，处理\"跨部门协同与突发问题\"，协调链条复杂。\n4. **行业知识/业务理解：1/5分。依据：经历集中于房产、旅游签证，完全缺失家政服务、母婴护理、保洁标准等相关背景。\n5. **抗压与稳定性：2/5分。依据：10年3段经历平均3年/段，但最近一段仅2年；自述\"抗压能力强\"但缺乏具体案例佐证。\n\n面试问题:\n1. 请描述一次你推动跨部门流程变革时遭遇阻力、最终说服对方配合的具体经历——当时反对意见是什么，你采取了什么策略？\n2. 房产/签证业务的家政客户与你有明显差异，请举例说明你如何快速理解一个全新用户群体的核心痛点，并调整运营策略？\n3. 你过往经历中哪一段持续时间最短？如果加入天鹅到家后2年内行业或岗位发生较大变化，你的应对思路和去留",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "运营专员（财税法方向）",
    "interviewQ": "1. 请描述一次你推动跨部门流程变革时遭遇阻力、最终说服对方配合的具体经历——当时反对意见是什么，你采取了什么策略？\n2. 房产/签证业务的家政客户与你有明显差异，请举例说明你如何快速理解一个全新用户群体的核心痛点，并调整运营策略？\n3. 你过往经历中哪一段持续时间最短？如果加入天鹅到家后2年内行业或岗位发生较大变化，你的应对思路和去留意向是什么？\n4. 假设需要为保洁师设计一套服务动线SOP，从接单到完工验收，你会如何拆解关键节点并设置质量监控指标？请简述框架。\n5. 家政服务常涉及客户投诉（如服务不达标、物品损坏），结合你过往的结算风控或异常处理经验，设计一个投诉响应与责任判定的运营机制。",
    "capabilityMatch": "1. **运营流程标准化：4/5分。依据：简历明确提及\"制定业务相关流程制度及标准化操作规范\"\"建立健全合同管理台账\"，有完整SOP搭建与落地经验。\n2. **数据管理与分析：3/5分。依据：负责日报/周报/月报输出，但仅描述为\"审核、校验及汇总\"，未体现深度分析或数据驱动决策案例。\n3. **跨部门沟通协调：4/5分。依据：明确担任\"总部与业务部门的核心沟通枢纽\"，处理\"跨部门协同与突发问题\"，协调链条复杂。\n4. **行业知识/业务理解：1/5分。依据：经历集中于房产、旅游签证，完全缺失家政服务、母婴护理、保洁标准等相关背景。\n5. **抗压与稳定性：2/5分。依据：10年3段经历平均3年/段，但最近一段仅2年；自述\"抗压能力强\"但缺乏具体案例佐证。",
    "created": "2026-05-12 17:14:27"
  },
  {
    "id": 10,
    "name": "倪女士",
    "role": "运营专员",
    "company": "综合运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "倪",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "约1993年生、1996.09",
    "gender": "女",
    "strengths": "10年政企项目管理经验，精通ERP/OA系统与数据可视化，具备流程标准化与跨部门协调能力；47个项目100%验收通过率体现强执行力；供应链优化经验可迁移至家政服务标准化与数字化运营。",
    "risks": "简历时间线存疑（2011年入学推算约1993年生，与标注1996.09矛盾；2025.3-2025.11为未来时间段）；无家政/母婴/保洁等民生服务领域经验；10年经验应聘10-12K岗位，动机与稳定性需验证；最近两段工作均不足1年。",
    "aiEval": "以下为候选人的 运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：运营专员（财税法方向）\n🏢 招聘岗位：运营专员\n\n初筛结果: 存疑\n\n优势分析:\n10年政企项目管理经验，精通ERP/OA系统与数据可视化，具备流程标准化与跨部门协调能力；47个项目100%验收通过率体现强执行力；供应链优化经验可迁移至家政服务标准化与数字化运营。\n\n风险点:\n简历时间线存疑（2011年入学推算约1993年生，与标注1996.09矛盾；2025.3-2025.11为未来时间段）；无家政/母婴/保洁等民生服务领域经验；10年经验应聘10-12K岗位，动机与稳定性需验证；最近两段工作均不足1年。\n\n能力维度匹配:\n1. **项目管理：4/5分。依据：主导47个项目全周期管理，含500万级展陈项目，有ERP运维、供应链优化等复杂项目经验，但缺乏家政服务场景验证。**\n2. **数字化运营：4/5分。依据：熟练使用ERP、OA、Power BI，重构数据链路使库存周转率提升128%，具备数据驱动决策能力。**\n3. **标准化建设：3.5/5分。依据：制定SOP缩短项目周期20%、会议效率提升40%，但均为B端政企场景，C端服务标准化经验空白。**\n4. **客户洞察：3/5分。依据：服务中核、国网等大型客户，熟悉政企沟通机制，但缺乏家庭用户/母婴等C端高情感需求服务经验。**\n5. **稳定性与动机：2/5分。依据：时间线矛盾（2025年工作经历）、近两段工作时长均不足1年、10年经验应聘初级岗位动机不明，需重点核实。**\n\n面试问题:\n1. 请描述一次您处理客户紧急投诉或重大不满的经历，当时您如何平衡公司利益与客户诉求？结果如何？\n2. 您过往项目涉及多方供应商协调，当保洁/月嫂等服务人员临时爽约导致客户投诉时，您会如何快速响应并解决？\n3. 您最近两段工作时间都较短，且10年经验应",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "运营专员（财税法方向）",
    "interviewQ": "1. 请描述一次您处理客户紧急投诉或重大不满的经历，当时您如何平衡公司利益与客户诉求？结果如何？\n2. 您过往项目涉及多方供应商协调，当保洁/月嫂等服务人员临时爽约导致客户投诉时，您会如何快速响应并解决？\n3. 您最近两段工作时间都较短，且10年经验应聘该岗位，能否具体说明您的职业规划与选择天鹅到家的核心动机？\n4. 假设需要设计一套月嫂服务SOP，从面试筛选、培训认证到上户服务、售后回访，您会如何搭建全流程标准并确保落地执行？\n5. 家政行业阿姨流动性高、服务质量难量化，您会设计哪些关键数据指标（非财务指标）来监控运营健康度？如何用Power BI呈现给管理层？",
    "capabilityMatch": "1. **项目管理：4/5分。依据：主导47个项目全周期管理，含500万级展陈项目，有ERP运维、供应链优化等复杂项目经验，但缺乏家政服务场景验证。**\n2. **数字化运营：4/5分。依据：熟练使用ERP、OA、Power BI，重构数据链路使库存周转率提升128%，具备数据驱动决策能力。**\n3. **标准化建设：3.5/5分。依据：制定SOP缩短项目周期20%、会议效率提升40%，但均为B端政企场景，C端服务标准化经验空白。**\n4. **客户洞察：3/5分。依据：服务中核、国网等大型客户，熟悉政企沟通机制，但缺乏家庭用户/母婴等C端高情感需求服务经验。**\n5. **稳定性与动机：2/5分。依据：时间线矛盾（2025年工作经历）、近两段工作时长均不足1年、10年经验应聘初级岗位动机不明，需重点核实。**",
    "created": "2026-05-12 17:14:28"
  },
  {
    "id": 11,
    "name": "谢荣",
    "role": "运营专员",
    "company": "综合运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "谢",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "26岁",
    "gender": "未提及性别信息",
    "strengths": "2年财税运营复合经验，擅长费用管控、台账标准化与数据报表，具备跨部门协同及消保合规处理能力；财务背景+运营实操双轮驱动，适配家政服务数字化运营与流程标准化需求。",
    "risks": "当前在职仅8个月，稳定性存疑；无家政/本地生活行业经验，服务场景理解需验证；26岁职业探索期，岗位适配深度待观察。",
    "aiEval": "以下为候选人的 运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：运营专员（财税法方向）\n🏢 招聘岗位：运营专员\n\n初筛结果: 通过\n\n优势分析:\n2年财税运营复合经验，擅长费用管控、台账标准化与数据报表，具备跨部门协同及消保合规处理能力；财务背景+运营实操双轮驱动，适配家政服务数字化运营与流程标准化需求。\n\n风险点:\n当前在职仅8个月，稳定性存疑；无家政/本地生活行业经验，服务场景理解需验证；26岁职业探索期，岗位适配深度待观察。\n\n能力维度匹配:\n1. **数据分析与流程优化：4/5分。依据：搭建标准化台账，输出周月报，管控592万费用，数据工具熟练。**\n2. **跨部门协同与沟通：4/5分。依据：对接7区域部、组织45期例会、多部门项目联动，沟通频次高。**\n3. **合规与风险管控：4/5分。依据：用印362次零差错、消保投诉处理、资金内控经验完整。**\n4. **行业认知与业务洞察：2/5分。依据：履历集中在金融/审计领域，无家政或服务行业一线经验。**\n5. **稳定性与职业动机：3/5分。依据：2年内2段经历（含实习），当前在职时间短，跳槽信号需排查。**\n\n面试问题:\n1. 请描述一次你协调多个区域/部门解决紧急运营问题的经历，当时冲突点是什么？你如何推动共识达成？\n2. 处理客户投诉时，你如何判断\"合规底线\"与\"客户体验\"的平衡？举例说明一次两难决策。\n3. 目前在职仅8个月，是什么因素促使你看外部机会？未来2-3年职业路径如何规划？\n4. 假设需设计家政服务师的\"服务履约质量台账\"，你会从哪些维度搭建指标？如何确保一线数据真实可追踪？\n5. 家政服务存在非标痛点，若让你优化\"保洁服务验收\"的数字化流程，结合你过往费用管控经验，关键控制点会设在哪里？\n\n互动引导语:\n谢荣您好，我是天鹅到家HR。看了您的简历，您在2年财税运营复合经验，擅长费",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "运营专员（财税法方向）",
    "interviewQ": "1. 请描述一次你协调多个区域/部门解决紧急运营问题的经历，当时冲突点是什么？你如何推动共识达成？\n2. 处理客户投诉时，你如何判断\"合规底线\"与\"客户体验\"的平衡？举例说明一次两难决策。\n3. 目前在职仅8个月，是什么因素促使你看外部机会？未来2-3年职业路径如何规划？\n4. 假设需设计家政服务师的\"服务履约质量台账\"，你会从哪些维度搭建指标？如何确保一线数据真实可追踪？\n5. 家政服务存在非标痛点，若让你优化\"保洁服务验收\"的数字化流程，结合你过往费用管控经验，关键控制点会设在哪里？",
    "capabilityMatch": "1. **数据分析与流程优化：4/5分。依据：搭建标准化台账，输出周月报，管控592万费用，数据工具熟练。**\n2. **跨部门协同与沟通：4/5分。依据：对接7区域部、组织45期例会、多部门项目联动，沟通频次高。**\n3. **合规与风险管控：4/5分。依据：用印362次零差错、消保投诉处理、资金内控经验完整。**\n4. **行业认知与业务洞察：2/5分。依据：履历集中在金融/审计领域，无家政或服务行业一线经验。**\n5. **稳定性与职业动机：3/5分。依据：2年内2段经历（含实习），当前在职时间短，跳槽信号需排查。**",
    "created": "2026-05-12 17:14:30"
  },
  {
    "id": 12,
    "name": "张女士",
    "role": "运营专员",
    "company": "综合运营部",
    "years": 0,
    "edu": "大专",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "张",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "无",
    "gender": "女",
    "strengths": "具备从0-1搭建SOP、流程标准化及数字化运营经验，与天鹅到家家政服务标准化、数字化方向契合；擅长跨部门协同与客户沟通，有500+商户群运营经验；数据驱动意识强，能搭建可视化看板支撑业务决策。",
    "risks": "意向岗位为\"销售运营\"而非家政运营，行业匹配度存疑；最高学历大专，教育背景薄弱；2025.12至今任职时间标注异常（未来日期），简历严谨性不足；缺乏家政/生活服务/O2O行业直接经验，业务理解需验证。",
    "aiEval": "以下为候选人的 运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：运营专员（财税法方向）\n🏢 招聘岗位：运营专员\n\n初筛结果: 存疑\n\n优势分析:\n具备从0-1搭建SOP、流程标准化及数字化运营经验，与天鹅到家家政服务标准化、数字化方向契合；擅长跨部门协同与客户沟通，有500+商户群运营经验；数据驱动意识强，能搭建可视化看板支撑业务决策。\n\n风险点:\n意向岗位为\"销售运营\"而非家政运营，行业匹配度存疑；最高学历大专，教育背景薄弱；2025.12至今任职时间标注异常（未来日期），简历严谨性不足；缺乏家政/生活服务/O2O行业直接经验，业务理解需验证。\n\n能力维度匹配:\n1. **流程标准化能力：4/5分。依据：主导结算SOP从0-1搭建，输出多份标准化文件并建立知识库，有完整方法论沉淀。**\n2. **数据运营能力：4/5分。依据：自主设计对账工具、搭建可视化看板，实现T+0数据监控，具备数据产品化思维。**\n3. **客户运营能力：3.5/5分。依据：运营500+商户沟通群，推动回票效率提升35%，但B端商户与C端家政用户场景差异大。**\n4. **跨部门协同能力：4/5分。依据：多次主导跨部门项目，推动CRM规范化使用，有专项小组统筹经验。**\n5. **行业适配潜力：2/5分。依据：经历集中于办公设备租赁、能源科技，无家政/O2O/本地生活服务背景，业务场景转换挑战大。**\n\n面试问题:\n1. 你运营500+商户群时，遇到最难处理的客户冲突是什么？具体如何协调多方利益达成解决？\n2. 简历中2025.12至今的时间标注是否有误？请说明近半年实际工作状态及求职动机。\n3. 过往经历多为B端企业服务，若转向服务C端家政用户，你认为最大挑战是什么？如何快速适应？\n4. 假设需为保洁师设计服务标准SOP，你会如何调研一线需求、平衡标准化与灵活性？请简述框架思路。\n",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "运营专员（财税法方向）",
    "interviewQ": "1. 你运营500+商户群时，遇到最难处理的客户冲突是什么？具体如何协调多方利益达成解决？\n2. 简历中2025.12至今的时间标注是否有误？请说明近半年实际工作状态及求职动机。\n3. 过往经历多为B端企业服务，若转向服务C端家政用户，你认为最大挑战是什么？如何快速适应？\n4. 假设需为保洁师设计服务标准SOP，你会如何调研一线需求、平衡标准化与灵活性？请简述框架思路。\n5. 家政服务客诉常涉及服务过程难追溯，结合你的数据看板经验，如何设计关键指标监控服务质量？",
    "capabilityMatch": "1. **流程标准化能力：4/5分。依据：主导结算SOP从0-1搭建，输出多份标准化文件并建立知识库，有完整方法论沉淀。**\n2. **数据运营能力：4/5分。依据：自主设计对账工具、搭建可视化看板，实现T+0数据监控，具备数据产品化思维。**\n3. **客户运营能力：3.5/5分。依据：运营500+商户沟通群，推动回票效率提升35%，但B端商户与C端家政用户场景差异大。**\n4. **跨部门协同能力：4/5分。依据：多次主导跨部门项目，推动CRM规范化使用，有专项小组统筹经验。**\n5. **行业适配潜力：2/5分。依据：经历集中于办公设备租赁、能源科技，无家政/O2O/本地生活服务背景，业务场景转换挑战大。**",
    "created": "2026-05-12 17:14:32"
  },
  {
    "id": 13,
    "name": "赵亚睿",
    "role": "运营专员",
    "company": "综合运营部",
    "years": 0,
    "edu": "非全日制硕士在读",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "赵",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "无",
    "gender": "无",
    "strengths": "金融+会计复合背景，具备财务分析、数据建模（Excel/SPSS/Python/Power BI）及风险管控能力；有场租成本管控、财务台账管理、跨部门协同经验，契合家政业务数字化运营与成本优化需求；擅长数据驱动决策，可支撑标准化体系建设。",
    "risks": "无家政/本地生活/O2O行业经验，业务场景理解存疑；2年工作经验含1年硕士在读期，实际全职经验仅约1年；非全日制硕士在读至2026年，需关注精力分配与稳定性；简历未体现一线服务运营或客户触点经验。",
    "aiEval": "以下为候选人的 运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：运营专员（财税法方向）\n🏢 招聘岗位：运营专员\n\n初筛结果: 存疑\n\n优势分析:\n金融+会计复合背景，具备财务分析、数据建模（Excel/SPSS/Python/Power BI）及风险管控能力；有场租成本管控、财务台账管理、跨部门协同经验，契合家政业务数字化运营与成本优化需求；擅长数据驱动决策，可支撑标准化体系建设。\n\n风险点:\n无家政/本地生活/O2O行业经验，业务场景理解存疑；2年工作经验含1年硕士在读期，实际全职经验仅约1年；非全日制硕士在读至2026年，需关注精力分配与稳定性；简历未体现一线服务运营或客户触点经验。\n\n能力维度匹配:\n1. **数据分析能力：4/5分。依据：熟练Excel/SPSS/Python/Power BI，有场租财务指标体系搭建、数据可视化及经营分析报告编制经验，工具应用扎实。\n2. **财务与成本管控：4/5分。依据：精通财务核算、成本管控、税务筹划，有场租成本优化策略输出、资金支付风险预警等实战经验。\n3. **跨部门协同：3/5分。依据：简历提及\"联动多部门推进成本管控\"\"运营商合作备忘录落地\"，但缺乏具体案例与量化成果，深度待验证。\n4. **行业适配与业务理解：2/5分。依据：无家政/O2O/本地生活行业背景，过往通信/网络设备领域与家政服务场景差异较大，客户运营经验未体现。\n5. **稳定性与投入度：2/5分。依据：非全硕士在读至2026年，当前岗位为外包驻场性质（河北长宽驻铁塔北分），职业连续性及长期投入意愿需重点考察。\n\n面试问题:\n1. 请描述一次你推动跨部门成本管控时遭遇阻力，最终如何说服对方达成共识的具体案例。\n2. 过往工作中是否直接对接过外部客户或服务商？请举例说明如何处理对方对财务流程的质疑或投诉。\n3. 非全日制硕士学业与全职工作如",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "运营专员（财税法方向）",
    "interviewQ": "1. 请描述一次你推动跨部门成本管控时遭遇阻力，最终如何说服对方达成共识的具体案例。\n2. 过往工作中是否直接对接过外部客户或服务商？请举例说明如何处理对方对财务流程的质疑或投诉。\n3. 非全日制硕士学业与全职工作如何平衡？若入职后业务旺季与学业冲突，你的优先级排序是什么？\n4. 家政服务涉及保洁、保姆等多品类，若需搭建某一品类的服务成本核算模型，你的设计思路是什么？\n5. 假设月嫂订单投诉率上升，你会如何通过数据定位问题环节并提出运营优化建议？",
    "capabilityMatch": "1. **数据分析能力：4/5分。依据：熟练Excel/SPSS/Python/Power BI，有场租财务指标体系搭建、数据可视化及经营分析报告编制经验，工具应用扎实。\n2. **财务与成本管控：4/5分。依据：精通财务核算、成本管控、税务筹划，有场租成本优化策略输出、资金支付风险预警等实战经验。\n3. **跨部门协同：3/5分。依据：简历提及\"联动多部门推进成本管控\"\"运营商合作备忘录落地\"，但缺乏具体案例与量化成果，深度待验证。\n4. **行业适配与业务理解：2/5分。依据：无家政/O2O/本地生活行业背景，过往通信/网络设备领域与家政服务场景差异较大，客户运营经验未体现。\n5. **稳定性与投入度：2/5分。依据：非全硕士在读至2026年，当前岗位为外包驻场性质（河北长宽驻铁塔北分），职业连续性及长期投入意愿需重点考察。",
    "created": "2026-05-12 17:14:34"
  },
  {
    "id": 14,
    "name": "倪女士",
    "role": "运营专员",
    "company": "综合运营部",
    "years": 0,
    "edu": "2015年毕业",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "倪",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "1996年生",
    "gender": "女",
    "strengths": "10年政企项目管理经验，精通ERP/OA系统与流程标准化，具备从0到1搭建管理体系能力（如供应商分级、决策追踪系统），与天鹅到家数字化运营、服务标准化需求高度契合；跨部门协调与资源整合能力强，有大型复杂项目交付经验。",
    "risks": "简历显示2025年3月-11月在职深圳普菲特，但当前状态为\"空闲\"，时间线存疑；无家政/生活服务/母婴护理行业背景，业务场景转换跨度大；1996年生却称10年工作经验（2015年毕业），时间计算需核实；缺乏家政服务类项目经验；履历集中于军工、电力、制造、展陈等B端领域，无C端家政服务、母婴护理、保洁运营等场景经验，业务逻辑差异显著；2023-2024年笔中科技仅1年，2025年普菲特标注8个月但已空闲，职业连续性需验证；10年经验对应4段履历，平均2.5年/段，跳槽频率偏高。",
    "aiEval": "以下为候选人的 运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：运营专员（财税法方向）\n🏢 招聘岗位：运营专员\n\n初筛结果: 存疑\n\n优势分析:\n10年政企项目管理经验，精通ERP/OA系统与流程标准化，具备从0到1搭建管理体系能力（如供应商分级、决策追踪系统），与天鹅到家数字化运营、服务标准化需求高度契合；跨部门协调与资源整合能力强，有大型复杂项目交付经验。\n\n风险点:\n简历显示2025年3月-11月在职深圳普菲特，但当前状态为\"空闲\"，时间线存疑；无家政/生活服务/母婴护理行业背景，业务场景转换跨度大；1996年生却称10年工作经验（2015年毕业），时间计算需核实。\n\n能力维度匹配:\n1. **项目管理：4/5分。依据：主导47个项目100%验收，精通全周期管理，有VR预演降本、标准化手册等创新实践，但缺乏家政服务类项目经验。**\n2. **数字化运营：4/5分。依据：熟练使用ERP、OA、Power BI，重构数据链路提升库存周转128%，开发智能评估模型，技术工具应用成熟。**\n3. **客户/供应商管理：4/5分。依据：服务中核、国网、中电科等大型政企客户，搭建供应商分级体系降低采购成本15%，具备B端复杂关系维护能力。**\n4. **行业适配性：2/5分。依据：履历集中于军工、电力、制造、展陈等B端领域，无C端家政服务、母婴护理、保洁运营等场景经验，业务逻辑差异显著。**\n5. **稳定性：2/5分。依据：2023-2024年笔中科技仅1年，2025年普菲特标注8个月但已空闲，职业连续性需验证；10年经验对应4段履历，平均2.5年/段，跳槽频率偏高。**\n\n面试问题:\n1. 请描述一次你处理客户投诉或重大服务纠纷的经历，当时采取了哪些步骤，最终结果如何？\n2. 你曾同时协调多个部门推进项目，遇到过最大的阻力是什么？如何说服对方配合？\n3. 你的",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "运营专员（财税法方向）",
    "interviewQ": "1. 请描述一次你处理客户投诉或重大服务纠纷的经历，当时采取了哪些步骤，最终结果如何？\n2. 你曾同时协调多个部门推进项目，遇到过最大的阻力是什么？如何说服对方配合？\n3. 你的简历显示2025年3月至11月在深圳普菲特任职，但目前状态为空闲，能否说明具体离职时间和原因？未来3-5年职业规划是什么？\n4. 假设需要为保洁服务设计一套标准化作业流程（SOP），你会从哪些维度入手，如何确保一线服务人员执行到位？\n5. 家政服务涉及大量非标场景（如客户临时加需求、服务人员突发状况），结合你过往ERP系统经验，如何通过数字化工具提升调度效率和客户满意度？",
    "capabilityMatch": "1. **项目管理：4/5分。依据：主导47个项目100%验收，精通全周期管理，有VR预演降本、标准化手册等创新实践，但缺乏家政服务类项目经验。**\n2. **数字化运营：4/5分。依据：熟练使用ERP、OA、Power BI，重构数据链路提升库存周转128%，开发智能评估模型，技术工具应用成熟。**\n3. **客户/供应商管理：4/5分。依据：服务中核、国网、中电科等大型政企客户，搭建供应商分级体系降低采购成本15%，具备B端复杂关系维护能力。**\n4. **行业适配性：2/5分。依据：履历集中于军工、电力、制造、展陈等B端领域，无C端家政服务、母婴护理、保洁运营等场景经验，业务逻辑差异显著。**\n5. **稳定性：2/5分。依据：2023-2024年笔中科技仅1年，2025年普菲特标注8个月但已空闲，职业连续性需验证；10年经验对应4段履历，平均2.5年/段，跳槽频率偏高。**",
    "created": "2026-05-13 12:01:09"
  },
  {
    "id": 15,
    "name": "谢荣",
    "role": "运营专员",
    "company": "综合运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "谢",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "26岁",
    "gender": "无",
    "strengths": "2年财务运营复合背景，精通费用管控、台账标准化与数据报表，契合天鹅到家数字化运营需求；跨7区域协同、45期例会组织经验，具备强执行力与多线程处理能力；消保合规与应急处理经验直接匹配家政服务风控场景。",
    "risks": "职业路径存跳跃性（财务→运营），家政垂直领域经验空白；26岁2年经验属初级水平，独立操盘复杂项目能力待验证；北京本地稳定性需确认，财税法方向与家政运营核心技能（服务标准、供应链管理）存在认知Gap。",
    "aiEval": "以下为候选人的 运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：运营专员（财税法方向）\n🏢 招聘岗位：运营专员\n\n初筛结果: 通过\n\n优势分析:\n2年财务运营复合背景，精通费用管控、台账标准化与数据报表，契合天鹅到家数字化运营需求；跨7区域协同、45期例会组织经验，具备强执行力与多线程处理能力；消保合规与应急处理经验直接匹配家政服务风控场景。\n\n风险点:\n职业路径存跳跃性（财务→运营），家政垂直领域经验空白；26岁2年经验属初级水平，独立操盘复杂项目能力待验证；北京本地稳定性需确认，财税法方向与家政运营核心技能（服务标准、供应链管理）存在认知Gap。\n\n能力维度匹配:\n1. **数据运营与标准化：4/5分。依据：搭建费用/用印/消保3套台账，输出周月报，592万资金全流程管控，数据工具熟练。**\n2. **跨部门协同与沟通：4/5分。依据：对接7区域部、组织45期例会、撰写OA稿件，多线程事务处理经验丰富。**\n3. **合规风控意识：4/5分。依据：消保投诉处理、362次用印审批、资金内控管理，风险敏感度较高。**\n4. **行业认知与业务洞察：2/5分。依据：简历零家政/生活服务/供应链相关经验，业务场景迁移能力待考。**\n5. **稳定性与职业动机：3/5分。依据：2年2段经历含实习，转型运营仅1年，长期深耕意愿需验证。**\n\n面试问题:\n1. 请描述一次你协调多个区域部门解决紧急费用争议的经历，当时各方诉求冲突点是什么？你如何推动共识达成？\n2. 消保工作中遇到情绪激动的客户投诉时，你如何处理？能否举例说明最终转化客户满意的完整过程？\n3. 从财务转向运营的核心驱动力是什么？未来3年职业规划是否与家政服务行业的深耕方向一致？\n4. 假设需为保洁服务设计一套阿姨服务质量的数字化评分台账，你会从哪些维度构建指标体系？如何确保区域落地一致性？\n5. 家政服",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "运营专员（财税法方向）",
    "interviewQ": "1. 请描述一次你协调多个区域部门解决紧急费用争议的经历，当时各方诉求冲突点是什么？你如何推动共识达成？\n2. 消保工作中遇到情绪激动的客户投诉时，你如何处理？能否举例说明最终转化客户满意的完整过程？\n3. 从财务转向运营的核心驱动力是什么？未来3年职业规划是否与家政服务行业的深耕方向一致？\n4. 假设需为保洁服务设计一套阿姨服务质量的数字化评分台账，你会从哪些维度构建指标体系？如何确保区域落地一致性？\n5. 家政服务存在高频客诉场景（如物品损坏、服务迟到），结合你的合规经验，设计一个从投诉受理到闭环归档的标准SOP流程。",
    "capabilityMatch": "1. **数据运营与标准化：4/5分。依据：搭建费用/用印/消保3套台账，输出周月报，592万资金全流程管控，数据工具熟练。**\n2. **跨部门协同与沟通：4/5分。依据：对接7区域部、组织45期例会、撰写OA稿件，多线程事务处理经验丰富。**\n3. **合规风控意识：4/5分。依据：消保投诉处理、362次用印审批、资金内控管理，风险敏感度较高。**\n4. **行业认知与业务洞察：2/5分。依据：简历零家政/生活服务/供应链相关经验，业务场景迁移能力待考。**\n5. **稳定性与职业动机：3/5分。依据：2年2段经历含实习，转型运营仅1年，长期深耕意愿需验证。**",
    "created": "2026-05-13 12:01:09"
  },
  {
    "id": 16,
    "name": "赵亚睿",
    "role": "运营专员",
    "company": "综合运营部",
    "years": 0,
    "edu": "非全日制硕士在读",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "赵",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "无",
    "gender": "无",
    "strengths": "具备财务数据分析与成本管控能力，有跨部门协同经验；擅长用数据支撑决策，符合天鹅到家数字化运营需求；工作严谨务实，执行力强，可适配标准化流程管理。",
    "risks": "非全日制硕士在读（2024.09-至今），学业与工作平衡存疑；2年工作经验但岗位为数据分析专员，与家政运营场景差异较大；缺乏一线服务运营或客户-facing经验，文化匹配度待验证；在职状态（2024.05-2026.04）与求职时间线存疑（当前应为2025年），精力分配风险高；缺乏家政行业场景数据驱动运营应用，未体现服务类产品标准化落地案例，协同对象非家政复杂供给端（阿姨、客户、平台三方），无客户服务、用户运营、一线服务场景经验，家政运营核心能力缺失。",
    "aiEval": "以下为候选人的 运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：运营专员（财税法方向）\n🏢 招聘岗位：运营专员\n\n初筛结果: 存疑\n\n优势分析:\n具备财务数据分析与成本管控能力，有跨部门协同经验；擅长用数据支撑决策，符合天鹅到家数字化运营需求；工作严谨务实，执行力强，可适配标准化流程管理。\n\n风险点:\n非全日制硕士在读（2024.09-至今），学业与工作平衡存疑；2年工作经验但岗位为数据分析专员，与家政运营场景差异较大；缺乏一线服务运营或客户-facing经验，文化匹配度待验证。\n\n能力维度匹配:\n1. **数据驱动运营：4/5分。依据：简历明确提及\"财务数据挖掘\"\"多维度财务数据分析输出成本优化策略\"\"Power BI可视化\"，数据工具熟练，但缺乏家政行业场景应用。**\n2. **流程标准化管理：3/5分。依据：有\"合同全流程管控\"\"场租卡片全生命周期财务监控\"经验，具备流程意识，但未体现服务类产品标准化落地案例。**\n3. **跨部门协同：3/5分。依据：描述\"联动多部门推进成本管控\"\"参与运营商合作备忘录落地\"，但协同对象为企业内部部门，非家政复杂供给端（阿姨、客户、平台三方）。**\n4. **客户洞察与服务意识：1/5分。依据：简历无任何客户服务、用户运营、一线服务场景经验，家政运营核心能力缺失。**\n5. **稳定性与投入度：2/5分。依据：在职状态（2024.05-2026.04）与求职时间线存疑（当前应为2025年），且非全硕士在读，精力分配风险高。**\n\n面试问题:\n1. 请描述一次你协调多个部门解决复杂问题的经历，当时各方诉求冲突点是什么？你如何推动达成共识？\n2. 家政服务中阿姨与客户常发生纠纷，若你接到客户投诉阿姨服务质量，会如何处理？请结合过往经验说明。\n3. 你目前非全日制硕士在读，预计学业压力最大的阶段是什么？如何保障工作投入度？",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "运营专员（财税法方向）",
    "interviewQ": "1. 请描述一次你协调多个部门解决复杂问题的经历，当时各方诉求冲突点是什么？你如何推动达成共识？\n2. 家政服务中阿姨与客户常发生纠纷，若你接到客户投诉阿姨服务质量，会如何处理？请结合过往经验说明。\n3. 你目前非全日制硕士在读，预计学业压力最大的阶段是什么？如何保障工作投入度？\n4. 假设需要设计一套阿姨服务质量的数字化评估体系，你会从哪些维度选取指标？如何验证指标有效性？\n5. 天鹅到家保洁服务有58项标准流程，若发现某城市阿姨执行率仅60%，你会如何用数据定位问题并推动改进？",
    "capabilityMatch": "1. **数据驱动运营：4/5分。依据：简历明确提及\"财务数据挖掘\"\"多维度财务数据分析输出成本优化策略\"\"Power BI可视化\"，数据工具熟练，但缺乏家政行业场景应用。**\n2. **流程标准化管理：3/5分。依据：有\"合同全流程管控\"\"场租卡片全生命周期财务监控\"经验，具备流程意识，但未体现服务类产品标准化落地案例。**\n3. **跨部门协同：3/5分。依据：描述\"联动多部门推进成本管控\"\"参与运营商合作备忘录落地\"，但协同对象为企业内部部门，非家政复杂供给端（阿姨、客户、平台三方）。**\n4. **客户洞察与服务意识：1/5分。依据：简历无任何客户服务、用户运营、一线服务场景经验，家政运营核心能力缺失。**\n5. **稳定性与投入度：2/5分。依据：在职状态（2024.05-2026.04）与求职时间线存疑（当前应为2025年），且非全硕士在读，精力分配风险高。**",
    "created": "2026-05-13 12:01:09"
  },
  {
    "id": 17,
    "name": "李晨旭",
    "role": "产品运营经理",
    "company": "AI智聘",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "李",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "无",
    "gender": "无",
    "strengths": "具备强流程优化与数据驱动能力，在去哪儿网搭建异常订单判责SOP、数据监控看板，实现异常订单量下降40%、申诉率从156%降至71%等量化成果；SQL/Excel工具能力强，跨部门协同经验丰富，契合家政服务标准化、数字化需求。",
    "risks": "AI应用深度不足，仅提及\"AI工具运营提效/提示词输出\"，无AI驱动业务模式创新案例；无家政/本地生活行业经验，用户生命周期运营经验薄弱；无团队管理经验，与\"3年以上团队管理\"要求存在缺口；当前在职仅3个月，稳定性存疑。",
    "aiEval": "以下为候选人的 产品运营经理 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：产品运营经理\n🏢 招聘岗位：产品运营经理\n\n初筛结果: 存疑\n\n优势分析:\n具备强流程优化与数据驱动能力，在去哪儿网搭建异常订单判责SOP、数据监控看板，实现异常订单量下降40%、申诉率从156%降至71%等量化成果；SQL/Excel工具能力强，跨部门协同经验丰富，契合家政服务标准化、数字化需求。\n\n风险点:\nAI应用深度不足，仅提及\"AI工具运营提效/提示词输出\"，无AI驱动业务模式创新案例；无家政/本地生活行业经验，用户生命周期运营经验薄弱；无团队管理经验，与\"3年以上团队管理\"要求存在缺口；当前在职仅3个月，稳定性存疑。\n\n能力维度匹配:\n1. **1. AI应用落地能力：2/5分。依据：仅列\"AI工具(运营提效/提示词输出)\"为工具能力，无AI驱动用户增长、转化或重构运营环节的实例，无量化业务价值呈现，与\"必须项\"要求差距明显。**\n2. **2. 产品运营策略能力：3/5分。依据：有平台产品运营经验，擅长SOP搭建与流程优化，但无家政类产品策略经验，无\"AI+数据\"双引擎驱动0到1项目案例，增长驱动案例集中于降本提效而非业务扩张。**\n3. **3. 用户增长建设能力：2/5分。依据：鲜橙科技有品类增长经验（服装月销增长10倍），但无用户生命周期分层运营、复购裂变设计经验；近期工作聚焦售后流程优化，非用户获取与留存。**\n4. **4. 数据分析优化能力：4/5分。依据：核心优势领域，熟练SQL/Excel，搭建多维度数据看板，监控异常订单、赔付申诉等指标，实现40%异常量下降等量化优化，能输出分析报告并推动闭环。**\n5. **5. 团队管理建设能力：1/5分。依据：简历未体现任何团队管理经验，无目标管理、人才培养相关描述，与\"3年以上团队管理经验\"硬性要求不符。**\n\n面试问",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "产品运营经理",
    "interviewQ": "1. 你入职去哪儿网仅3个月，请说明离职原因及加入天鹅到家的动机，如何评估自身稳定性？\n2. 描述一次你与客服、技术、商务等多部门协同推动项目落地的经历，遇到最大阻力是什么，如何解决的？\n3. 鲜橙科技后两段工作经历间隔较长（2021年3月前），请说明职业空窗期或过渡期的具体情况。\n4. 假设需用AI优化家政阿姨派单匹配效率，请简述你的思路：会选用什么AI技术/工具？如何设计验证方案并量化提效成果？\n5. 针对家政服务低频、高客诉特点，设计一个老用户复购裂变活动，说明目标用户分层、激励策略及核心监控指标。",
    "capabilityMatch": "1. **1. AI应用落地能力：2/5分。依据：仅列\"AI工具(运营提效/提示词输出)\"为工具能力，无AI驱动用户增长、转化或重构运营环节的实例，无量化业务价值呈现，与\"必须项\"要求差距明显。**\n2. **2. 产品运营策略能力：3/5分。依据：有平台产品运营经验，擅长SOP搭建与流程优化，但无家政类产品策略经验，无\"AI+数据\"双引擎驱动0到1项目案例，增长驱动案例集中于降本提效而非业务扩张。**\n3. **3. 用户增长建设能力：2/5分。依据：鲜橙科技有品类增长经验（服装月销增长10倍），但无用户生命周期分层运营、复购裂变设计经验；近期工作聚焦售后流程优化，非用户获取与留存。**\n4. **4. 数据分析优化能力：4/5分。依据：核心优势领域，熟练SQL/Excel，搭建多维度数据看板，监控异常订单、赔付申诉等指标，实现40%异常量下降等量化优化，能输出分析报告并推动闭环。**\n5. **5. 团队管理建设能力：1/5分。依据：简历未体现任何团队管理经验，无目标管理、人才培养相关描述，与\"3年以上团队管理经验\"硬性要求不符。**",
    "created": "2026-05-18 15:40:07"
  },
  {
    "id": 18,
    "name": "刘超群",
    "role": "产品运营经理",
    "company": "AI智聘",
    "years": 0,
    "edu": "专科",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "刘",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "无",
    "gender": "未提及",
    "strengths": "12年互联网运营经验，8年互金背景，具备0-1搭建5000万用户运营体系及15人团队管理经验；擅长数据驱动决策，有神策等平台部署经验；跨文化运营能力（印尼市场）可迁移至家政服务标准化场景。",
    "risks": "学历为专科，不满足本科硬性门槛；AI应用仅限\"AI智能触达\"等工具层使用，无主导AI技术深度落地或业务模式重构经验；行业背景集中于现金贷/互金，与家政服务场景差异大，存在文化适配风险；求职目标为运营总监/经理，与产品运营经理职级可能存在落差。",
    "aiEval": "以下为候选人的 产品运营经理 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：产品运营经理\n🏢 招聘岗位：产品运营经理\n\n初筛结果: 淘汰\n\n优势分析:\n12年互联网运营经验，8年互金背景，具备0-1搭建5000万用户运营体系及15人团队管理经验；擅长数据驱动决策，有神策等平台部署经验；跨文化运营能力（印尼市场）可迁移至家政服务标准化场景。\n\n风险点:\n学历为专科，不满足本科硬性门槛；AI应用仅限\"AI智能触达\"等工具层使用，无主导AI技术深度落地或业务模式重构经验；行业背景集中于现金贷/互金，与家政服务场景差异大，存在文化适配风险；求职目标为运营总监/经理，与产品运营经理职级可能存在落差。\n\n能力维度匹配:\n1. **1. AI应用落地能力：1/5分。依据：仅提及\"AI智能触达\"作为触达渠道之一，无主导AI技术架构设计、模型训练或业务模式重构经验，未体现AI驱动业务创新的量化价值。**\n2. **2. 产品运营策略能力：3/5分。依据：有现金贷产品0-1运营体系搭建经验，但行业场景差异大；擅长数据+策略双驱动，但\"AI+数据\"双引擎未体现，家政类产品经验缺失。**\n3. **3. 用户增长建设能力：4/5分。依据：5000万用户分层运营体系搭建经验丰富，覆盖新客、老客、沉默用户全生命周期，复借/回流策略成熟，可迁移至家政用户复购场景。**\n4. **4. 数据分析优化能力：4/5分。依据：日级数据监控、漏斗分析、用户标签体系搭建经验扎实，神策平台部署经验可直接复用，但缺乏家政行业特定指标（如服务满意度、阿姨留存率）经验。**\n5. **5. 团队管理建设能力：3/5分。依据：15人团队0-1搭建及目标拆解经验丰富，但无AI应用思维能力培养的相关表述，团队职能以传统运营为主。**\n\n面试问题:\n1. 您从互金行业转型家政服务，如何看待两个行业在用户信任建立、服务标准化",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "产品运营经理",
    "interviewQ": "1. 您从互金行业转型家政服务，如何看待两个行业在用户信任建立、服务标准化方面的核心差异？请举例说明您如何快速适应新行业规则。\n2. 现金贷业务强结果导向，家政服务更强调长期口碑与复购，您的管理风格如何调整以适配 slower-cycle 的业务特性？\n3. 您简历中印尼市场经历跨越2023-2025年，但国内职责同期延续，请说明实际工作精力分配，是否存在频繁出差或远程管理挑战？\n4. 假设需设计一款\"AI智能匹配阿姨-家庭需求\"的产品功能，请简述您的需求分析框架、关键数据指标及冷启动策略。\n5. 家政服务场景中，阿姨端供给不足常制约用户增长，您会如何运用AI+运营手段提升阿姨招募效率与留存率？",
    "capabilityMatch": "1. **1. AI应用落地能力：1/5分。依据：仅提及\"AI智能触达\"作为触达渠道之一，无主导AI技术架构设计、模型训练或业务模式重构经验，未体现AI驱动业务创新的量化价值。**\n2. **2. 产品运营策略能力：3/5分。依据：有现金贷产品0-1运营体系搭建经验，但行业场景差异大；擅长数据+策略双驱动，但\"AI+数据\"双引擎未体现，家政类产品经验缺失。**\n3. **3. 用户增长建设能力：4/5分。依据：5000万用户分层运营体系搭建经验丰富，覆盖新客、老客、沉默用户全生命周期，复借/回流策略成熟，可迁移至家政用户复购场景。**\n4. **4. 数据分析优化能力：4/5分。依据：日级数据监控、漏斗分析、用户标签体系搭建经验扎实，神策平台部署经验可直接复用，但缺乏家政行业特定指标（如服务满意度、阿姨留存率）经验。**\n5. **5. 团队管理建设能力：3/5分。依据：15人团队0-1搭建及目标拆解经验丰富，但无AI应用思维能力培养的相关表述，团队职能以传统运营为主。**",
    "created": "2026-05-18 15:40:08"
  },
  {
    "id": 19,
    "name": "万佳",
    "role": "产品运营经理",
    "company": "AI智聘",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "万",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "38岁",
    "gender": "未提及",
    "strengths": "13年新零售/电商实战经验，擅长从0到1搭建私域运营与数字化体系，有私域分销、会员增长、爆品孵化全链路经验；操盘过3500万+用户沉淀、年销20亿级项目；具备万人级员工分销体系搭建与激励经验，与家政服务标准化、数字化、职业化方向有一定契合度。",
    "risks": "AI应用落地能力存疑，简历仅提及\"熟练运用私域工具与AI赋能\"但无具体案例；无家政/本地生活服务经验，行业跨度大；38岁求职运营总监但应聘产品运营经理，职级预期可能存在落差；近1年多仅在岗1家公司，此前跳槽频繁（平均1-2年）。",
    "aiEval": "以下为候选人的 产品运营经理 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：产品运营经理\n🏢 招聘岗位：产品运营经理\n\n初筛结果: 淘汰\n\n优势分析:\n13年新零售/电商实战经验，擅长从0到1搭建私域运营与数字化体系，有私域分销、会员增长、爆品孵化全链路经验；操盘过3500万+用户沉淀、年销20亿级项目；具备万人级员工分销体系搭建与激励经验，与家政服务标准化、数字化、职业化方向有一定契合度。\n\n风险点:\nAI应用落地能力存疑，简历仅提及\"熟练运用私域工具与AI赋能\"但无具体案例；无家政/本地生活服务经验，行业跨度大；38岁求职运营总监但应聘产品运营经理，职级预期可能存在落差；近1年多仅在岗1家公司，此前跳槽频繁（平均1-2年）。\n\n能力维度匹配:\n1. **AI应用落地能力：1/5分。依据：简历仅一句\"熟练运用私域工具与AI赋能\"，无AI项目主导经验、无具体场景（用户增长/转化/服务重构）、无量化业务价值呈现，与JD\"必须项\"差距显著。\n2. **产品运营策略能力：4/5分。依据：有丰富0到1项目经验（Better购小程序、万家丽O2O平台），年销20亿级案例，但缺乏家政类产品经验，\"AI+数据\"双引擎未体现。\n3. **用户增长建设能力：4/5分。依据：设计过新人1元购、员工分销激励等增长路径，新用户转化率提升至23%，员工动销超2万人，老客复购与裂变有实操，但家政生命周期特点未验证。\n4. **数据分析优化能力：3/5分。依据：强调\"数据驱动运营\"，有精准营销、爆品打造案例，但未明确提及注册转化率、复购率、用户流失率等核心指标监控及分析报告输出。\n5. **团队管理建设能力：3/5分。依据：有万人级员工分销体系搭建经验，但未明确提及运营团队目标管理、AI应用思维能力培养，团队管理深度待验证。\n\n面试问题:\n1. 您过往经历集中在医药零售和商超领域，家政服务具有高",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "产品运营经理",
    "interviewQ": "1. 您过往经历集中在医药零售和商超领域，家政服务具有高频低客单、非标性强、服务即产品的特点，请举例说明您如何快速理解一个陌生行业的核心逻辑并推动业务落地？\n2. 您在老百姓大药房期间推动年销售额从800万增长至3200万，过程中遇到最大的跨部门协作阻力是什么？您如何协调供应链、门店、技术等多方资源达成目标？\n3. 您期望薪资25-50K且求职意向为运营总监，本次应聘产品运营经理（18-23K），请说明您的职业规划以及如何看待职级与薪资的调整？\n4. JD要求\"AI在运营业务中的丰富落地经验\"，您简历中提到\"AI赋能\"，请具体阐述一个您主导的AI应用场景：使用了什么AI工具/模型？解决了什么运营痛点？量化业务价值如何？\n5. 家政服务用户生命周期包含认知、首次下单、服务履约、复购推荐等阶段，请设计一个结合AI能力的用户增长方案，重点说明如何通过AI提升服务履约质量并驱动老客裂变。",
    "capabilityMatch": "1. **AI应用落地能力：1/5分。依据：简历仅一句\"熟练运用私域工具与AI赋能\"，无AI项目主导经验、无具体场景（用户增长/转化/服务重构）、无量化业务价值呈现，与JD\"必须项\"差距显著。\n2. **产品运营策略能力：4/5分。依据：有丰富0到1项目经验（Better购小程序、万家丽O2O平台），年销20亿级案例，但缺乏家政类产品经验，\"AI+数据\"双引擎未体现。\n3. **用户增长建设能力：4/5分。依据：设计过新人1元购、员工分销激励等增长路径，新用户转化率提升至23%，员工动销超2万人，老客复购与裂变有实操，但家政生命周期特点未验证。\n4. **数据分析优化能力：3/5分。依据：强调\"数据驱动运营\"，有精准营销、爆品打造案例，但未明确提及注册转化率、复购率、用户流失率等核心指标监控及分析报告输出。\n5. **团队管理建设能力：3/5分。依据：有万人级员工分销体系搭建经验，但未明确提及运营团队目标管理、AI应用思维能力培养，团队管理深度待验证。",
    "created": "2026-05-18 15:40:10"
  },
  {
    "id": 20,
    "name": "王博谦",
    "role": "产品运营经理",
    "company": "AI智聘",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "王",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "无",
    "gender": "无",
    "strengths": "候选人具备扎实的AI产品落地经验，主导5个AI项目从0到1，覆盖智能客服、数字人直播、知识库等场景，量化成果突出（效率提升200%+、成本降低70%+）。技术理解深度与\"AI+运营\"双引擎模式契合天鹅到家数字化转型需求。3年团队管理经验，曾管理12人运营团队并推动AI工具全员适配。",
    "risks": "行业跨度大，缺乏家政/本地生活服务经验，用户生命周期运营、复购裂变设计能力未直接验证。简历中\"用户增长\"侧重效率工具而非用户获取策略，\"数据分析\"偏重技术搭建而非业务洞察输出。现居深圳，岗位地点长沙，需关注稳定性与地域匹配。",
    "aiEval": "以下为候选人的 产品运营经理 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：产品运营经理\n🏢 招聘岗位：产品运营经理\n\n初筛结果: 存疑\n\n优势分析:\n候选人具备扎实的AI产品落地经验，主导5个AI项目从0到1，覆盖智能客服、数字人直播、知识库等场景，量化成果突出（效率提升200%+、成本降低70%+）。技术理解深度与\"AI+运营\"双引擎模式契合天鹅到家数字化转型需求。3年团队管理经验，曾管理12人运营团队并推动AI工具全员适配。\n\n风险点:\n行业跨度大，缺乏家政/本地生活服务经验，用户生命周期运营、复购裂变设计能力未直接验证。简历中\"用户增长\"侧重效率工具而非用户获取策略，\"数据分析\"偏重技术搭建而非业务洞察输出。现居深圳，岗位地点长沙，需关注稳定性与地域匹配。\n\n能力维度匹配:\n1. **AI应用落地能力：4/5分。依据：主导5个AI产品落地，覆盖客服、直播、培训、合规、营销全链路，量化成果明确（效率提升200%+、成本压降70%+），技术方案与业务场景结合紧密，但缺乏家政服务场景验证。**\n2. **产品运营策略能力：3/5分。依据：有产品规划与0到1落地经验，搭建效果评估体系，但聚焦跨境电商AI工具而非家政类产品运营，\"AI+数据\"驱动业务增长的家政场景案例缺失。**\n3. **用户增长建设能力：2/5分。依据：项目涉及直播触达率提升40%、新人培训周期压缩，但属于B端效率优化而非C端用户生命周期运营；新用户获取、老用户复购裂变设计能力未体现。**\n4. **数据分析优化能力：3/5分。依据：搭建\"检索准确率、运营效率、成本压降\"等指标体系，熟练使用Python/Pandas/MySQL，但侧重技术基建与产品效果评估，用户需求洞察与运营策略优化报告未直接呈现。**\n5. **团队管理建设能力：3/5分。依据：管理12人运营团队2年，推动AI工具全员适配提升效",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "产品运营经理",
    "interviewQ": "1. 在跨境电商与研发团队协作时，如何解决业务需求与技术实现之间的冲突？请举例说明。\n2. 智能客服项目中，如何处理AI无法解决的复杂客诉升级？家政服务涉及人身财产安全，你会如何设计人机协同机制？\n3. 现居深圳，如何看待长沙岗位的地域差异？未来3年职业规划是否与家政行业长期发展契合？\n4. 家政服务具有高频、低客单、非标特性，结合你的AI落地经验，设计一个提升保洁师复购率的AI应用场景，说明技术选型与效果评估指标。\n5. 假设要搭建家政服务智能调度系统，基于你的RAG和Agent经验，如何设计知识库架构以支持多城市、多服务品类的动态匹配？",
    "capabilityMatch": "1. **AI应用落地能力：4/5分。依据：主导5个AI产品落地，覆盖客服、直播、培训、合规、营销全链路，量化成果明确（效率提升200%+、成本压降70%+），技术方案与业务场景结合紧密，但缺乏家政服务场景验证。**\n2. **产品运营策略能力：3/5分。依据：有产品规划与0到1落地经验，搭建效果评估体系，但聚焦跨境电商AI工具而非家政类产品运营，\"AI+数据\"驱动业务增长的家政场景案例缺失。**\n3. **用户增长建设能力：2/5分。依据：项目涉及直播触达率提升40%、新人培训周期压缩，但属于B端效率优化而非C端用户生命周期运营；新用户获取、老用户复购裂变设计能力未体现。**\n4. **数据分析优化能力：3/5分。依据：搭建\"检索准确率、运营效率、成本压降\"等指标体系，熟练使用Python/Pandas/MySQL，但侧重技术基建与产品效果评估，用户需求洞察与运营策略优化报告未直接呈现。**\n5. **团队管理建设能力：3/5分。依据：管理12人运营团队2年，推动AI工具全员适配提升效率50%，有目标管理与AI思维培养实践，但团队规模与家政服务运营团队差异较大，跨行业管理能力待验证。**",
    "created": "2026-05-18 15:40:11"
  },
  {
    "id": 21,
    "name": "王先生",
    "role": "产品运营经理",
    "company": "AI智聘",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "王",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "无",
    "gender": "男",
    "strengths": "候选人具备极强的AI落地能力，主导20+AI工具矩阵搭建，实现内容生产效率提升70%、素材处理效率提升18倍；擅长0-1项目孵化，有Multi-Agent工作流、RAG知识库等完整技术栈实践经验；Vibe Coding能力突出，\"需求→上线\"周期压缩至2-3天，契合天鹅到家数字化、标准化转型需求。",
    "risks": "10年工作经验但近5年经历均为AI/内容运营方向，缺乏家政/本地生活/O2O行业背景；简历未体现销售运营团队管理经验（仅提及\"团队运营库\"知识库搭建）；最近两段经历均为2023年后AI创业/项目，稳定性存疑；无明确用户生命周期分层运营案例。",
    "aiEval": "以下为候选人的 产品运营经理 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：产品运营经理\n🏢 招聘岗位：产品运营经理\n\n初筛结果: 通过\n\n优势分析:\n候选人具备极强的AI落地能力，主导20+AI工具矩阵搭建，实现内容生产效率提升70%、素材处理效率提升18倍；擅长0-1项目孵化，有Multi-Agent工作流、RAG知识库等完整技术栈实践经验；Vibe Coding能力突出，\"需求→上线\"周期压缩至2-3天，契合天鹅到家数字化、标准化转型需求。\n\n风险点:\n10年工作经验但近5年经历均为AI/内容运营方向，缺乏家政/本地生活/O2O行业背景；简历未体现销售运营团队管理经验（仅提及\"团队运营库\"知识库搭建）；最近两段经历均为2023年后AI创业/项目，稳定性存疑；无明确用户生命周期分层运营案例。\n\n能力维度匹配:\n1. **1. AI应用落地能力：5/5分。依据：主导AI运营全链路落地，搭建20+工具矩阵，量化成果丰富（效率提升70%/18倍、成本节省数万元），具备Multi-Agent、RAG、Prompt Engineering完整技术栈，Vibe Coding实践成熟。**\n2. **2. 产品运营策略能力：4/5分。依据：有明确的0-1项目经验（AI效率工具矩阵、私域销售Agent），制定三期版本规划，但缺乏家政类产品运营背景，行业迁移性待验证。**\n3. **3. 用户增长建设能力：2/5分。依据：简历侧重内容生产提效与私域销售辅助，未体现用户生命周期分层设计、新客获取或老客复购裂变的完整增长体系搭建经验。**\n4. **4. 数据分析优化能力：3/5分。依据：建立5维评分体系、设计三层指标体系（产品/AI/业务层），但未明确提及监控注册转化率、复购率等核心运营指标的经验，数据分析深度待确认。**\n5. **5. 团队管理建设能力：2/5分。依据：简历未体",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "产品运营经理",
    "interviewQ": "1. 您近5年专注AI方向，若加入家政这种相对传统的服务行业，如何快速理解保洁/月嫂等一线服务场景，并将AI工具与一线阿姨的工作流结合？请举例说明您过去跨行业迁移的经验。\n2. 您简历中项目周期多为6-12个月，若加入天鹅到家需要至少2-3年深耕，您如何看待职业稳定性？过去10年中有无一段超过3年的深度经历？\n3. 家政服务涉及大量线下履约与客诉处理，您过往以线上内容运营为主，请描述一次您处理复杂客户冲突或协调多方资源解决棘手问题的经历。\n4. 天鹅到家的核心转化链路是\"浏览→预约→上门→复购\"，若让您设计AI驱动的用户增长方案，请具体说明：①如何分层识别高潜用户；②针对首次使用保洁服务的用户，AI可在哪些触点介入以提升7日复购率？\n5. 家政阿姨群体的数字化能力参差不齐，您过往面向C端用户的AI工具经验，如何适配给阿姨端使用？请设计一个\"阿姨智能接单助手\"的最小可行产品（MVP）方案，包括核心功能、技术选型和推广策略。",
    "capabilityMatch": "1. **1. AI应用落地能力：5/5分。依据：主导AI运营全链路落地，搭建20+工具矩阵，量化成果丰富（效率提升70%/18倍、成本节省数万元），具备Multi-Agent、RAG、Prompt Engineering完整技术栈，Vibe Coding实践成熟。**\n2. **2. 产品运营策略能力：4/5分。依据：有明确的0-1项目经验（AI效率工具矩阵、私域销售Agent），制定三期版本规划，但缺乏家政类产品运营背景，行业迁移性待验证。**\n3. **3. 用户增长建设能力：2/5分。依据：简历侧重内容生产提效与私域销售辅助，未体现用户生命周期分层设计、新客获取或老客复购裂变的完整增长体系搭建经验。**\n4. **4. 数据分析优化能力：3/5分。依据：建立5维评分体系、设计三层指标体系（产品/AI/业务层），但未明确提及监控注册转化率、复购率等核心运营指标的经验，数据分析深度待确认。**\n5. **5. 团队管理建设能力：2/5分。依据：简历未体现运营团队目标管理、人员培养或组织架构搭建经验，\"团队运营库\"为知识库而非团队管理实践，管理幅度与年限不明确。**",
    "created": "2026-05-18 15:40:20"
  },
  {
    "id": 22,
    "name": "钟琰",
    "role": "产品运营经理",
    "company": "AI智聘",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "钟",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "无",
    "gender": "无",
    "strengths": "具备AI产品全链路实战经验，主导过2个大模型功能产品从0到1落地，擅长评测体系搭建与数据驱动迭代；有RAG、Prompt设计、Agent工具等前沿AI技术落地经验，AI敏感度高；跨阿里生态场景（夸克、通义等）的产品运营经验可迁移至家政数字化场景。",
    "risks": "缺乏家政/本地生活/O2O行业经验，无销售运营或用户增长直接操盘背景；3年政府办事员经历与互联网运营存在职业路径断层，稳定性存疑；无团队管理经验，与\"3年以上销售运营或产品运营团队管理经验\"硬性要求不符。",
    "aiEval": "以下为候选人的 产品运营经理 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：产品运营经理\n🏢 招聘岗位：产品运营经理\n\n初筛结果: 淘汰\n\n优势分析:\n具备AI产品全链路实战经验，主导过2个大模型功能产品从0到1落地，擅长评测体系搭建与数据驱动迭代；有RAG、Prompt设计、Agent工具等前沿AI技术落地经验，AI敏感度高；跨阿里生态场景（夸克、通义等）的产品运营经验可迁移至家政数字化场景。\n\n风险点:\n缺乏家政/本地生活/O2O行业经验，无销售运营或用户增长直接操盘背景；3年政府办事员经历与互联网运营存在职业路径断层，稳定性存疑；无团队管理经验，与\"3年以上销售运营或产品运营团队管理经验\"硬性要求不符。\n\n能力维度匹配:\n1. **1. AI应用落地能力：4/5分。依据：主导通义图像翻译、夸克高考推荐语等AI产品落地，具备模型评测、Prompt设计、Agent工作流搭建经验，能量化呈现翻译准确率从85%→98%等业务价值，但缺乏运营场景（非产品场景）的AI应用经验。\n2. **2. 产品运营策略能力：3/5分。依据：有0到1产品落地经验，但角色为AI产品经理而非运营经理，侧重功能设计而非运营策略制定；无\"AI+数据\"双引擎驱动业务增长的运营案例，与JD要求的运营视角存在差异。\n3. **3. 用户增长建设能力：2/5分。依据：项目成果涉及点击率、复购率等指标提升，但属于产品功能优化驱动，非运营策略驱动的用户增长；无生命周期管理、裂变设计、新客获取等直接经验。\n4. **4. 数据分析优化能力：4/5分。依据：搭建完整评测体系与数据闭环，设计GSB盲测、自动化评测工作流，擅长通过数据定位问题并驱动迭代；但聚焦模型效果评测，非业务运营指标（注册转化、复购率等）监控。\n5. **5. 团队管理建设能力：1/5分。依据：简历未体现任何团队管理经验，无目标管理、人才培养",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "产品运营经理",
    "interviewQ": "1. 你3年政府办事员经历后转型AI产品，请具体说明转型动机与准备过程，如何看待职业路径的连续性？\n2. 在跨部门协调算法、工程团队时，遇到过最大的阻力是什么？如何推动达成共识并保障交付？\n3. 通义图像翻译项目中，用户负向反馈50%集中在版式还原，你如何平衡用户体验与技术可行性，具体如何说服团队优先解决？\n4. 假设需为天鹅到家设计AI驱动的阿姨匹配推荐系统，你会如何结合服务标准化要求设计评测指标体系？\n5. 家政服务场景中，用户决策周期长、信任成本高，你认为AI在降低获客成本、提升转化效率方面有哪些可落地的切入点？",
    "capabilityMatch": "1. **AI应用落地能力：4/5分。依据：主导通义图像翻译、夸克高考推荐语等AI产品落地，具备模型评测、Prompt设计、Agent工作流搭建经验，能量化呈现翻译准确率从85%→98%等业务价值，但缺乏运营场景（非产品场景）的AI应用经验。\n2. **产品运营策略能力：3/5分。依据：有0到1产品落地经验，但角色为AI产品经理而非运营经理，侧重功能设计而非运营策略制定；无\"AI+数据\"双引擎驱动业务增长的运营案例，与JD要求的运营视角存在差异。\n3. **用户增长建设能力：2/5分。依据：项目成果涉及点击率、复购率等指标提升，但属于产品功能优化驱动，非运营策略驱动的用户增长；无生命周期管理、裂变设计、新客获取等直接经验。\n4. **数据分析优化能力：4/5分。依据：搭建完整评测体系与数据闭环，设计GSB盲测、自动化评测工作流，擅长通过数据定位问题并驱动迭代；但聚焦模型效果评测，非业务运营指标（注册转化、复购率等）监控。\n5. **团队管理建设能力：1/5分。依据：简历未体现任何团队管理经验，无目标管理、人才培养、AI思维建设等相关描述，与JD\"3年以上团队管理经验\"硬性要求差距明显。",
    "created": "2026-05-18 15:40:22"
  },
  {
    "id": 23,
    "name": "陈浩志",
    "role": "产品运营经理",
    "company": "AI智聘",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "陈",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "无",
    "gender": "无",
    "strengths": "12年互联网运营经验，具备AI知识库搭建实战（使用率提升30%、准确率提升18%），擅长0到1项目落地（车主服务生态月交易额从0到10万），数据驱动意识强（年节省成本超400万），跨部门协同经验丰富（途虎蓄电池项目统筹产研/供应链/门店）。",
    "risks": "无家政/本地生活服务直接经验（仅朗新科技涉及\"非遗地图\"本地生活商家运营但非家政）；当前在职两家公司（风图汽车2025.09-至今、芒果数智2024.06-至今），稳定性存疑；AI应用集中于销售赋能与知识库，未体现用户增长/转化场景的AI重构。",
    "aiEval": "以下为候选人的 产品运营经理 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：产品运营经理\n🏢 招聘岗位：产品运营经理\n\n初筛结果: 存疑\n\n优势分析:\n12年互联网运营经验，具备AI知识库搭建实战（使用率提升30%、准确率提升18%），擅长0到1项目落地（车主服务生态月交易额从0到10万），数据驱动意识强（年节省成本超400万），跨部门协同经验丰富（途虎蓄电池项目统筹产研/供应链/门店）。\n\n风险点:\n无家政/本地生活服务直接经验（仅朗新科技涉及\"非遗地图\"本地生活商家运营但非家政）；当前在职两家公司（风图汽车2025.09-至今、芒果数智2024.06-至今），稳定性存疑；AI应用集中于销售赋能与知识库，未体现用户增长/转化场景的AI重构。\n\n能力维度匹配:\n1. **能力1：AI应用落地能力：3/5分。依据：有AI知识库搭建经验（使用率+30%、准确率+18%），但场景局限于销售培训，未覆盖用户增长/转化/服务全链路，缺乏家政场景AI应用经验。**\n2. **能力2：产品运营策略能力：4/5分。依据：多次0到1项目经验（车主服务生态、数据自动化平台、蓄电池快送），擅长\"数据+产品\"双引擎驱动，但家政类产品策略经验空白。**\n3. **能力3：用户增长建设能力：2/5分。依据：有用户分层运营经验（途虎汽车用品品类），但未明确展示生命周期增长路径设计；无新用户获取/老用户复购裂变的系统性案例。**\n4. **能力4：数据分析优化能力：4/5分。依据：精通经营分析模型，搭建BI/Excel看板，设计核心标签体系与数据SOP，年节省成本量化成果显著（300万+200万）。**\n5. **能力5：团队管理建设能力：3/5分。依据：有商品运营团队管理经验，但简历未明确AI应用思维能力培养案例；团队规模与家政运营团队匹配度不明。**\n\n面试问题:\n1. 在途虎蓄电池项目中，你",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "产品运营经理",
    "interviewQ": "1. 在途虎蓄电池项目中，你如何协调产研、供应链、门店三方利益冲突？请举例说明具体冲突场景与解决过程。\n2. 风图汽车的AI知识库项目中，如何处理一线销售对AI工具的抵触情绪？最终如何推动使用率提升30%？\n3. 目前同时在风图汽车和芒果数智任职，能否说明两段工作的实际状态？若加入天鹅到家，如何保障投入稳定性？\n4. 假设需为天鹅到家保洁服务设计AI驱动的用户转化路径，你会如何结合家政服务非标准化特点，用AI重构从获客到复购的关键环节？\n5. 朗新科技的\"非遗地图\"项目中，如何将线下服务转化为线上产品？若迁移到家政场景，你认为最大的转化难点是什么？",
    "capabilityMatch": "1. **能力1：AI应用落地能力：3/5分。依据：有AI知识库搭建经验（使用率+30%、准确率+18%），但场景局限于销售培训，未覆盖用户增长/转化/服务全链路，缺乏家政场景AI应用经验。**\n2. **能力2：产品运营策略能力：4/5分。依据：多次0到1项目经验（车主服务生态、数据自动化平台、蓄电池快送），擅长\"数据+产品\"双引擎驱动，但家政类产品策略经验空白。**\n3. **能力3：用户增长建设能力：2/5分。依据：有用户分层运营经验（途虎汽车用品品类），但未明确展示生命周期增长路径设计；无新用户获取/老用户复购裂变的系统性案例。**\n4. **能力4：数据分析优化能力：4/5分。依据：精通经营分析模型，搭建BI/Excel看板，设计核心标签体系与数据SOP，年节省成本量化成果显著（300万+200万）。**\n5. **能力5：团队管理建设能力：3/5分。依据：有商品运营团队管理经验，但简历未明确AI应用思维能力培养案例；团队规模与家政运营团队匹配度不明。**",
    "created": "2026-05-18 15:40:24"
  },
  {
    "id": 24,
    "name": "胡先生",
    "role": "产品运营经理",
    "company": "AI智聘",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "胡",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "30岁",
    "gender": "男",
    "strengths": "8年电商/零售产品运营经验，亿级用户量产品设计，擅长用户增长、转化漏斗优化、会员体系建设，有0-1项目孵化经验（支付宝小程序百万用户），中台架构设计能力强，具备数据驱动思维。",
    "risks": "无AI应用落地经验（必须项缺失）；行业背景集中于电商/汽车/零售，无家政服务经验；近期2份工作任职均约3年，稳定性一般；30岁应聘产品运营经理，职级预期可能偏高。",
    "aiEval": "以下为候选人的 产品运营经理 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：产品运营经理\n🏢 招聘岗位：产品运营经理\n\n初筛结果: 淘汰\n\n优势分析:\n8年电商/零售产品运营经验，亿级用户量产品设计，擅长用户增长、转化漏斗优化、会员体系建设，有0-1项目孵化经验（支付宝小程序百万用户），中台架构设计能力强，具备数据驱动思维。\n\n风险点:\n无AI应用落地经验（必须项缺失）；行业背景集中于电商/汽车/零售，无家政服务经验；近期2份工作任职均约3年，稳定性一般；30岁应聘产品运营经理，职级预期可能偏高。\n\n能力维度匹配:\n1. **AI应用落地能力：0/5分。依据：简历全文未提及任何AI相关项目或技术落地，\"AT自动化产品体验评估\"中的AT应为测试术语（Acceptance Testing），非AI应用。必须项缺失。**\n2. **产品运营策略能力：4/5分。依据：主导多个0-1项目（支付宝小程序、海外商城），擅长\"AI+数据\"中的数据驱动部分，有明确的运营策略制定与业务增长案例（GMV增长、转化率提升）。**\n3. **用户增长建设能力：5/5分。依据：核心优势领域，设计用户等级/权益/任务/勋章体系，裂变增长项目ROI=50，支付宝小程序0-1增长至百万用户，漏斗优化经验丰富。**\n4. **数据分析优化能力：4/5分。依据：多次提及漏斗分析、AB测试、数据驱动决策，有转化率、留存率等核心指标监控与优化案例，但缺乏家政场景下的需求挖掘报告输出证据。**\n5. **团队管理建设能力：3/5分。依据：有带教培训经验（比亚迪带教应届生），统筹7-10人产品团队，但无明确的目标管理（OKR/KPI制定）案例，更偏执行层而非管理层。**\n\n面试问题:\n1. 在比亚迪五品牌合一中台重构项目中，涉及上百人产研测运营团队，你如何协调各方利益冲突推动3个月上线？请举例说明一次重大分歧的",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "产品运营经理",
    "interviewQ": "1. 在比亚迪五品牌合一中台重构项目中，涉及上百人产研测运营团队，你如何协调各方利益冲突推动3个月上线？请举例说明一次重大分歧的处理过程。\n2. 名创优品支付宝小程序订单转化率从1%提升至13.7%，过程中是否收到过商家或用户的负面反馈？你是如何平衡数据目标与用户体验的？\n3. 近三份工作分别为2年、2年1个月、至今约3年，离职原因是什么？如何看待家政行业需要长期深耕服务者运营与用户信任建立的特点？\n4. JD要求主导AI在运营全链路落地，但简历中未体现相关经验。请阐述你对AI在家政场景（如智能派单、服务者匹配、用户意图识别）的应用设想，以及你计划如何快速补齐这一能力缺口？\n5. 家政服务具有高频低客单、服务非标、信任成本高的特点，与你熟悉的电商标品运营差异较大。请设计一个针对天鹅到家保洁服务的用户复购裂变方案，并说明与电商裂变的核心差异点。",
    "capabilityMatch": "1. **AI应用落地能力：0/5分。依据：简历全文未提及任何AI相关项目或技术落地，\"AT自动化产品体验评估\"中的AT应为测试术语（Acceptance Testing），非AI应用。必须项缺失。**\n2. **产品运营策略能力：4/5分。依据：主导多个0-1项目（支付宝小程序、海外商城），擅长\"AI+数据\"中的数据驱动部分，有明确的运营策略制定与业务增长案例（GMV增长、转化率提升）。**\n3. **用户增长建设能力：5/5分。依据：核心优势领域，设计用户等级/权益/任务/勋章体系，裂变增长项目ROI=50，支付宝小程序0-1增长至百万用户，漏斗优化经验丰富。**\n4. **数据分析优化能力：4/5分。依据：多次提及漏斗分析、AB测试、数据驱动决策，有转化率、留存率等核心指标监控与优化案例，但缺乏家政场景下的需求挖掘报告输出证据。**\n5. **团队管理建设能力：3/5分。依据：有带教培训经验（比亚迪带教应届生），统筹7-10人产品团队，但无明确的目标管理（OKR/KPI制定）案例，更偏执行层而非管理层。**",
    "created": "2026-05-18 15:40:26"
  },
  {
    "id": 25,
    "name": "马骏驰",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "大专学历",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "马",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "无",
    "gender": "男",
    "strengths": "10年连续销售/运营经验，横跨房产、教育、AI软件多行业，电销与地推能力兼备；VIPKID、编程猫经历体现强电话转化与社群运营能力，与\"电话+企微跟进邀约\"高度契合；性格开朗、亲和力强的自我评价匹配劳动者沟通场景。",
    "risks": "无家政/蓝领招募经验，行业认知空白；近3年从事toB媒体销售（博纳之翼），与toC劳动者招募场景差异大；简历时间线存疑（2025.12为结束时间），稳定性待验证；大专学历未明确标注，教育经历信息缺失。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 存疑\n\n优势分析:\n10年连续销售/运营经验，横跨房产、教育、AI软件多行业，电销与地推能力兼备；VIPKID、编程猫经历体现强电话转化与社群运营能力，与\"电话+企微跟进邀约\"高度契合；性格开朗、亲和力强的自我评价匹配劳动者沟通场景。\n\n风险点:\n无家政/蓝领招募经验，行业认知空白；近3年从事toB媒体销售（博纳之翼），与toC劳动者招募场景差异大；简历时间线存疑（2025.12为结束时间），稳定性待验证；大专学历未明确标注，教育经历信息缺失。\n\n能力维度匹配:\n1. **客户开发能力：4/5分。依据：VIPKID课程顾问（电话规划促成报课）、编程猫社群运营（群内报课）、博纳之翼toB销售（展会选企业沟通）均体现强电话/线下开发转化能力，与劳动者招募跟进场景高度 transferable。**\n2. **活动执行能力：2/5分。依据：博纳之翼\"联系企业上栏目组拍摄、去各种展会选择企业\"涉及活动参与，但无明确\"招商活动\"执行经验，家政行业活动特性未知。**\n3. **市场分析能力：1/5分。依据：简历未体现行业信息收集、区域市场分析或策略建议行为，该能力维度无文本支撑。**\n4. **商务沟通能力：4/5分。依据：自我评价明确\"良好亲和力、沟通协调能力、应变能力\"；多段销售经历需高频客户沟通，链家置业顾问需带看接待，与\"劳动者考查接待\"场景部分重叠。**\n5. **软件操作能力：3/5分。依据：小帮规划经历涉及\"编写、测试、优化SOP\"，隐含文档处理能力；但未明确提及Office软件，仅基于岗位要求的基础假设。**\n\n面试问题:\n1. \"请描述一次你通过电话成功转化高意向客户但最终未签约的经历，当时如何跟进？若重来会如何",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. \"请描述一次你通过电话成功转化高意向客户但最终未签约的经历，当时如何跟进？若重来会如何处理？\"\n2. \"链家带看与VIPKID电话销售中，你如何快速建立客户信任？面对劳动者学历背景差异大的群体，会如何调整沟通方式？\"\n3. \"2016年至今共4段工作经历，2022-2025年在博纳之翼从事toB销售，为何考虑转向toC劳动者招募？对家政行业蓝领群体有何认知？\"\n4. \"假设需在北京朝阳区招募保洁劳动者，你会如何设计一周的电话邀约话术与跟进节奏？请现场模拟首通电话开场。\"\n5. \"若劳动者到司考查后犹豫签约，提及'听说别家平台抽成更低'，你如何回应并促成？\"",
    "capabilityMatch": "1. **客户开发能力：4/5分。依据：VIPKID课程顾问（电话规划促成报课）、编程猫社群运营（群内报课）、博纳之翼toB销售（展会选企业沟通）均体现强电话/线下开发转化能力，与劳动者招募跟进场景高度 transferable。**\n2. **活动执行能力：2/5分。依据：博纳之翼\"联系企业上栏目组拍摄、去各种展会选择企业\"涉及活动参与，但无明确\"招商活动\"执行经验，家政行业活动特性未知。**\n3. **市场分析能力：1/5分。依据：简历未体现行业信息收集、区域市场分析或策略建议行为，该能力维度无文本支撑。**\n4. **商务沟通能力：4/5分。依据：自我评价明确\"良好亲和力、沟通协调能力、应变能力\"；多段销售经历需高频客户沟通，链家置业顾问需带看接待，与\"劳动者考查接待\"场景部分重叠。**\n5. **软件操作能力：3/5分。依据：小帮规划经历涉及\"编写、测试、优化SOP\"，隐含文档处理能力；但未明确提及Office软件，仅基于岗位要求的基础假设。**",
    "created": ""
  },
  {
    "id": 26,
    "name": "白东磊",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "白",
    "dept": "养老及商业事业部",
    "city": "郑州",
    "age": "28岁",
    "gender": "男",
    "strengths": "7年物流管理经验，5年京东站长经历证明强客户开发能力（政企/学校/商圈多场景定制方案）；擅长团队招募与培训（直营50人+挂靠89人）；业绩导向明确（站点收入从2.9万提升至12万）；具备商务沟通与突发事件处理能力；有车可出差，覆盖河南全境。",
    "risks": "行业跨度大（物流→家政），无家政/母婴/保洁等行业经验；期望薪资6-11K与JD 7-12K上限接近，需确认薪酬弹性；28岁求职\"物流经理\"但投递\"招商专员\"，职业定位存疑；副业经历分散（大健康、婚恋、词曲），需评估专注度。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 通过\n\n优势分析:\n7年物流管理经验，5年京东站长经历证明强客户开发能力（政企/学校/商圈多场景定制方案）；擅长团队招募与培训（直营50人+挂靠89人）；业绩导向明确（站点收入从2.9万提升至12万）；具备商务沟通与突发事件处理能力；有车可出差，覆盖河南全境。\n\n风险点:\n行业跨度大（物流→家政），无家政/母婴/保洁等行业经验；期望薪资6-11K与JD 7-12K上限接近，需确认薪酬弹性；28岁求职\"物流经理\"但投递\"招商专员\"，职业定位存疑；副业经历分散（大健康、婚恋、词曲），需评估专注度。\n\n能力维度匹配:\n1. **客户开发能力：4/5分。依据：5年京东站长经验，开发政企/学校/医院/商圈多类客户，定制寄递方案，新签续签及回款全流程，业绩从2.9万提升至12万，匹配\"招募+跟进+签约\"核心要求。\n2. **活动执行能力：3/5分。依据：参与\"战狼行动头狼先行\"集训、荣获\"优秀站长\"，有促销应对经验，但未明确提及大型招商/展会活动执行经历。\n3. **市场分析能力：3/5分。依据：对标竞品制定定价方案、分析区域产粮区、挖掘校园寄递增量，但分析维度偏物流运营，家政行业洞察待验证。\n4. **商务沟通能力：4/5分。依据：自述\"沟通有亲和力\"\"擅长化解内部矛盾\"\"政企客户开发\"，接待考查、商务谈判经验丰富，符合劳动者接待签约场景。\n5. **软件操作能力：3/5分。依据：熟悉ERP系统，简历未明确提及Office熟练度，但\"流程数据把控熟练\"暗示基础数据处理能力，需现场验证Excel/PPT。\n\n面试问题:\n1. 请描述一次你开发最难啃的客户（如政企或学校）的具体过程：如何触达关键人、遭遇哪些拒绝、最终如何签约？\n2.",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 请描述一次你开发最难啃的客户（如政企或学校）的具体过程：如何触达关键人、遭遇哪些拒绝、最终如何签约？\n2. 京东5年管理50人团队，期间遇到过最大的内部冲突是什么？你如何化解并重建信任？\n3. 简历显示期望岗位是\"物流经理\"，为何投递天鹅到家\"招商专员\"？未来3年职业规划如何？\n4. 假设需在郑州某老旧小区招募10名家政保洁劳动者，你会如何设计招募方案（渠道选择、话术设计、转化策略）？\n5. 请现场用Excel设计一张\"周招募进度跟踪表\"，包含关键字段并说明如何使用它向领导汇报。",
    "capabilityMatch": "1. **客户开发能力：4/5分。依据：5年京东站长经验，开发政企/学校/医院/商圈多类客户，定制寄递方案，新签续签及回款全流程，业绩从2.9万提升至12万，匹配\"招募+跟进+签约\"核心要求。\n2. **活动执行能力：3/5分。依据：参与\"战狼行动头狼先行\"集训、荣获\"优秀站长\"，有促销应对经验，但未明确提及大型招商/展会活动执行经历。\n3. **市场分析能力：3/5分。依据：对标竞品制定定价方案、分析区域产粮区、挖掘校园寄递增量，但分析维度偏物流运营，家政行业洞察待验证。\n4. **商务沟通能力：4/5分。依据：自述\"沟通有亲和力\"\"擅长化解内部矛盾\"\"政企客户开发\"，接待考查、商务谈判经验丰富，符合劳动者接待签约场景。\n5. **软件操作能力：3/5分。依据：熟悉ERP系统，简历未明确提及Office熟练度，但\"流程数据把控熟练\"暗示基础数据处理能力，需现场验证Excel/PPT。",
    "created": ""
  },
  {
    "id": 27,
    "name": "张先生",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "物流专业背景",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "张",
    "dept": "养老及商业事业部",
    "city": "郑州",
    "age": "45岁",
    "gender": "男",
    "strengths": "有电销/招聘邀约经验（中置置业负责招聘邀约、简历初筛），具备基础客户触达能力；学生会经历体现一定沟通与活动组织潜力；国家奖学金及专业前5%说明学习能力强，可快速适应家政行业标准化培训。",
    "risks": "无家政/招商行业经验，缺乏劳动者群体（蓝领/服务业）沟通背景；工作经历较短（中置置业约1年4个月，五金店标注至2026年存疑），稳定性待验证；简历时间逻辑异常（2024.05-2026.01），需核实真实性。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 存疑\n\n优势分析:\n有电销/招聘邀约经验（中置置业负责招聘邀约、简历初筛），具备基础客户触达能力；学生会经历体现一定沟通与活动组织潜力；国家奖学金及专业前5%说明学习能力强，可快速适应家政行业标准化培训。\n\n风险点:\n无家政/招商行业经验，缺乏劳动者群体（蓝领/服务业）沟通背景；工作经历较短（中置置业约1年4个月，五金店标注至2026年存疑），稳定性待验证；简历时间逻辑异常（2024.05-2026.01），需核实真实性。\n\n能力维度匹配:\n1. **客户开发能力：2/5分。依据：有中置置业招聘邀约经验（电话、平台投放、初筛），但针对的是普通岗位求职者，非家政劳动者群体；无企业微信运营及线下签约经验。\n2. **活动执行能力：1/5分。依据：学生会经历暗示活动参与，但无具体招商/地推活动执行描述；五金店工作无相关活动经验。\n3. **市场分析能力：1/5分。依据：物流专业背景有基础数据分析能力（编制收支明细），但无行业市场分析、竞品调研或策略建议的实证。\n4. **商务沟通能力：2/5分。依据：内勤及门店运营涉及多方协调，具备基础沟通经验；但\"商务礼仪\"针对劳动者群体的亲和力、同理心未体现。\n5. **软件操作能力：3/5分。依据：明确熟练使用Word、Excel、PPT；有编制收支明细、薪资核算等实操，符合基础办公要求。\n\n面试问题:\n1. 请描述一次你通过电话成功说服一位犹豫的候选人到岗的经历，当时对方顾虑什么，你如何回应？\n2. 五金店运营中遇到最难沟通的客户类型是什么，你如何调整沟通方式促成交易？\n3. 你的工作经历中多次跨行业转换（物流→房产→五金），选择加入家政行业的核心动机是什么，如何看待未来2-3年的职",
    "aiScreen": "已入库（人工确认）",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 请描述一次你通过电话成功说服一位犹豫的候选人到岗的经历，当时对方顾虑什么，你如何回应？\n2. 五金店运营中遇到最难沟通的客户类型是什么，你如何调整沟通方式促成交易？\n3. 你的工作经历中多次跨行业转换（物流→房产→五金），选择加入家政行业的核心动机是什么，如何看待未来2-3年的职业发展？\n4. 假设一位45岁农村籍阿姨对\"家政服务标准化\"概念陌生，担心被公司\"管太严\"，你会如何用她理解的语言介绍天鹅到家的合作模式？\n5. 请现场模拟：用Excel设计一张劳动者招募进度跟踪表，需包含哪些核心字段以支持区域招募目标管理？",
    "capabilityMatch": "1. **客户开发能力：2/5分。依据：有中置置业招聘邀约经验（电话、平台投放、初筛），但针对的是普通岗位求职者，非家政劳动者群体；无企业微信运营及线下签约经验。\n2. **活动执行能力：1/5分。依据：学生会经历暗示活动参与，但无具体招商/地推活动执行描述；五金店工作无相关活动经验。\n3. **市场分析能力：1/5分。依据：物流专业背景有基础数据分析能力（编制收支明细），但无行业市场分析、竞品调研或策略建议的实证。\n4. **商务沟通能力：2/5分。依据：内勤及门店运营涉及多方协调，具备基础沟通经验；但\"商务礼仪\"针对劳动者群体的亲和力、同理心未体现。\n5. **软件操作能力：3/5分。依据：明确熟练使用Word、Excel、PPT；有编制收支明细、薪资核算等实操，符合基础办公要求。",
    "created": ""
  },
  {
    "id": 28,
    "name": "韩传志",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "本科",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "韩",
    "dept": "养老及商业事业部",
    "city": "郑州",
    "age": "45岁",
    "gender": "男",
    "strengths": "具备一线门店经营与地推实战经验，蜜雪冰城期间实现单店营收同比1033%增长及323%异业合作提升，验证强目标导向与执行能力；擅长排班调度、人员分工及活动策划，契合家政劳动者招募中的标准化运营需求；体育社团带队经历体现基层人员组织与沟通能力。",
    "risks": "无家政/母婴行业经验，需跨行业知识迁移；工作经历多为短期（3-12个月），稳定性存疑；简历时间线存在逻辑问题（2025.05-2026.04为未来时段），需核实真实性；无明确电销或企业微信规模化跟进经验。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 存疑\n\n优势分析:\n具备一线门店经营与地推实战经验，蜜雪冰城期间实现单店营收同比1033%增长及323%异业合作提升，验证强目标导向与执行能力；擅长排班调度、人员分工及活动策划，契合家政劳动者招募中的标准化运营需求；体育社团带队经历体现基层人员组织与沟通能力。\n\n风险点:\n无家政/母婴行业经验，需跨行业知识迁移；工作经历多为短期（3-12个月），稳定性存疑；简历时间线存在逻辑问题（2025.05-2026.04为未来时段），需核实真实性；无明确电销或企业微信规模化跟进经验。\n\n能力维度匹配:\n1. **客户开发能力：3/5分。依据：有门店地推、异业合作及招生销售经验，但缺乏电话/企微规模化跟进劳动者的直接证据，客户类型与家政劳动者差异较大。\n2. **活动执行能力：4/5分。依据：蜜雪冰城策划执行多场营销活动并获同期第一，羽毛球社团组织友谊赛与交流活动，活动落地能力较强。\n3. **市场分析能力：2/5分。依据：提及\"结合商圈特点调研顾客消费习惯\"，但无系统市场信息收集、行业分析及书面建议输出的明确证据。\n4. **商务沟通能力：4/5分。依据：经营顾问岗需高频对接门店、客户及团队，招生教练需与家长沟通，社团顾问负责新成员招收测定，沟通场景多元。\n5. **软件操作能力：3/5分。依据：未明确提及Office软件使用，但本科教育背景及经营顾问的数据分析工作（销售额、同比增长计算）暗示基础办公能力，需面试核实。\n\n面试问题:\n1. 请描述一次你通过电话或线上方式持续跟进并最终转化意向客户的完整经历，当时跟进频率和关键破冰话术是什么？\n2. 蜜雪冰城和教练岗位都是面向C端服务，若转为招募家政劳动者（B端属性更强），你认为沟",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 请描述一次你通过电话或线上方式持续跟进并最终转化意向客户的完整经历，当时跟进频率和关键破冰话术是什么？\n2. 蜜雪冰城和教练岗位都是面向C端服务，若转为招募家政劳动者（B端属性更强），你认为沟通策略上需要做出哪些调整？请举例说明。\n3. 你过往多段工作经历时长较短，如果加入天鹅到家，你计划如何规划未来2-3年的职业发展路径以确保稳定性？\n4. 假设你需要在郑州某社区开展一场家政劳动者招募地推活动，请简述你会如何设计活动流程、筛选目标人群及设计转化话术？\n5. 请现场模拟一段电话邀约：对方是一位在招聘平台浏览过保洁岗位但未投递简历的45岁女性，通话时长控制在90秒内。",
    "capabilityMatch": "1. **客户开发能力：3/5分。依据：有门店地推、异业合作及招生销售经验，但缺乏电话/企微规模化跟进劳动者的直接证据，客户类型与家政劳动者差异较大。\n2. **活动执行能力：4/5分。依据：蜜雪冰城策划执行多场营销活动并获同期第一，羽毛球社团组织友谊赛与交流活动，活动落地能力较强。\n3. **市场分析能力：2/5分。依据：提及\"结合商圈特点调研顾客消费习惯\"，但无系统市场信息收集、行业分析及书面建议输出的明确证据。\n4. **商务沟通能力：4/5分。依据：经营顾问岗需高频对接门店、客户及团队，招生教练需与家长沟通，社团顾问负责新成员招收测定，沟通场景多元。\n5. **软件操作能力：3/5分。依据：未明确提及Office软件使用，但本科教育背景及经营顾问的数据分析工作（销售额、同比增长计算）暗示基础办公能力，需面试核实。",
    "created": ""
  },
  {
    "id": 29,
    "name": "董宇",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "董",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "无",
    "gender": "无",
    "strengths": "7年一线销售经验，年均成交70+客户，客户满意度97%，具备强电话邀约、面谈签约及客诉处理能力；熟悉标准化销售流程（带看-签约-售后），可快速迁移至劳动者招募场景；抗压能力强，曾连续三月日均工作12小时完成开盘目标。",
    "risks": "行业跨度大（房地产/公寓→家政），无劳动者/蓝领群体招募经验；简历未体现企业微信运营、数据分析或市场洞察输出；近8个月两次跳槽（2024.07-2025.01玺悦台，2025.03至今河马公舍），稳定性存疑。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 存疑\n\n优势分析:\n7年一线销售经验，年均成交70+客户，客户满意度97%，具备强电话邀约、面谈签约及客诉处理能力；熟悉标准化销售流程（带看-签约-售后），可快速迁移至劳动者招募场景；抗压能力强，曾连续三月日均工作12小时完成开盘目标。\n\n风险点:\n行业跨度大（房地产/公寓→家政），无劳动者/蓝领群体招募经验；简历未体现企业微信运营、数据分析或市场洞察输出；近8个月两次跳槽（2024.07-2025.01玺悦台，2025.03至今河马公舍），稳定性存疑。\n\n能力维度匹配:\n1. **客户开发能力：4/5分。依据：7年置业顾问经验，精通电话邀约、带看接待、签约全流程；月均最高业绩15套/1200万回款，客户满意度97%；但缺乏蓝领劳动者群体触达经验。\n2. **活动执行能力：3/5分。依据：有组织售楼处活动经验（\"组织售楼处活动，促进销售\"），但未明确参与招商/地推类活动规模及角色。\n3. **市场分析能力：2/5分。依据：简历提及\"定期对销售数据及成交进行分析评估\"，但未体现行业信息收集、区域市场洞察或策略建议输出。\n4. **商务沟通能力：4/5分。依据：销讲比赛第一名，客户满意度97%，擅长商务洽谈、贷款协商及客诉处理；具备\"良好商务礼仪\"自我认知。\n5. **软件操作能力：2/5分。依据：简历未明确提及Office技能，仅房地产销售系统操作经验（网签合同上传房管局）。\n\n面试问题:\n1. 请描述一次你通过电话邀约成功转化高意向客户的完整过程：当时客户的顾虑是什么？你用了哪些话术或策略？最终签约周期多长？\n2. 房地产客户与家政劳动者在决策动机、沟通方式上差异较大，你如何看待这种转变？能否举例说明你曾快速适应新客群",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 请描述一次你通过电话邀约成功转化高意向客户的完整过程：当时客户的顾虑是什么？你用了哪些话术或策略？最终签约周期多长？\n2. 房地产客户与家政劳动者在决策动机、沟通方式上差异较大，你如何看待这种转变？能否举例说明你曾快速适应新客群的经历？\n3. 你近两份工作时长均不足1年，请说明离职原因；若加入天鹅到家，你计划如何克服行业转换期的挑战并稳定产出？\n4. 假设你负责北京某区域的保洁阿姨招募，电话接通后对方表示\"现在做保姆收入更高\"，你会如何回应并引导其考虑平台优势？请现场模拟。\n5. 劳动者到门店考察时，常关心\"接单是否稳定\"\"培训是否收费\"\"平台抽成比例\"，请设计一套标准的接待讲解流程（时间控制在15分钟内）。",
    "capabilityMatch": "1. **客户开发能力：4/5分。依据：7年置业顾问经验，精通电话邀约、带看接待、签约全流程；月均最高业绩15套/1200万回款，客户满意度97%；但缺乏蓝领劳动者群体触达经验。\n2. **活动执行能力：3/5分。依据：有组织售楼处活动经验（\"组织售楼处活动，促进销售\"），但未明确参与招商/地推类活动规模及角色。\n3. **市场分析能力：2/5分。依据：简历提及\"定期对销售数据及成交进行分析评估\"，但未体现行业信息收集、区域市场洞察或策略建议输出。\n4. **商务沟通能力：4/5分。依据：销讲比赛第一名，客户满意度97%，擅长商务洽谈、贷款协商及客诉处理；具备\"良好商务礼仪\"自我认知。\n5. **软件操作能力：2/5分。依据：简历未明确提及Office技能，仅房地产销售系统操作经验（网签合同上传房管局）。",
    "created": ""
  },
  {
    "id": 30,
    "name": "高腾",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "高",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "34岁",
    "gender": "未提及",
    "strengths": "12年B端销售经验，精通电话/面销/转介绍多渠道开发，客户复购率60%+，具备从获客到签约的全流程闭环能力；曾服务教育行业SaaS产品，熟悉劳动者培训、考核、CRM系统运营，与天鹅到家数字化、标准化业务高度契合；目标感强，擅长建立信任关系。",
    "risks": "近3年转型产品经理，销售实战经验断层；34岁年龄与基层地招岗位存在预期落差；缺乏家政行业一线从业背景，劳动者群体沟通经验未验证；最近一份工作仅10个月，稳定性存疑。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 通过\n\n优势分析:\n12年B端销售经验，精通电话/面销/转介绍多渠道开发，客户复购率60%+，具备从获客到签约的全流程闭环能力；曾服务教育行业SaaS产品，熟悉劳动者培训、考核、CRM系统运营，与天鹅到家数字化、标准化业务高度契合；目标感强，擅长建立信任关系。\n\n风险点:\n近3年转型产品经理，销售实战经验断层；34岁年龄与基层地招岗位存在预期落差；缺乏家政行业一线从业背景，劳动者群体沟通经验未验证；最近一份工作仅10个月，稳定性存疑。\n\n能力维度匹配:\n1. **客户开发能力：4/5分。依据：税务筹划产品销售中电销+面销+转介绍多渠道开发50+企业客户，全程跟进从接触到签约，复购率60%+，与劳动者招募全流程高度匹配。**\n2. **活动执行能力：3/5分。依据：简历未直接提及招商活动执行，但有\"策划客户培训会与产品路演\"经验，活动组织基础具备，需验证线下地推活动参与度。**\n3. **市场分析能力：3/5分。依据：有\"及时掌握税收政策变动，解读政策红利，优化销售策略\"及\"分析产品核心数据，优化产品策略\"经历，但聚焦产品数据而非区域市场信息收集。**\n4. **商务沟通能力：4/5分。依据：长期对接制造业、服务业、互联网等多行业企业客户，擅长建立信任、商务谈判及成交，\"沟通与执行力强\"为自我核心优势。**\n5. **软件操作能力：4/5分。依据：产品经理背景熟练使用各类系统工具，\"主动使用AI等工具提升工作效率\"，Office基础操作可默认具备，但需确认熟练程度。**\n\n面试问题:\n1. \"您在中联华科仅工作10个月，请描述离职原因，以及如何看待地招岗位可能需要的2-3年深耕稳定性？\"\n2. \"您过往主要对接企业决策层",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. \"您在中联华科仅工作10个月，请描述离职原因，以及如何看待地招岗位可能需要的2-3年深耕稳定性？\"\n2. \"您过往主要对接企业决策层，若面对家政劳动者（如保洁阿姨、月嫂）群体，会如何调整沟通方式建立信任？请举例说明您曾向下沟通或跨圈层服务的经历。\"\n3. \"产品经理期间您以内部赋能为主，请描述一次您必须完成硬性销售指标且压力极大的经历，当时采取了哪些具体动作？\"\n4. \"天鹅到家要求劳动者通过技能认证上岗，若一位有5年经验但无正规证书的阿姨坚持直接接单，您如何沟通说服她接受培训考证？\"\n5. \"假设您负责的区域本月招募目标20人，目前仅完成8人，剩余15天您会制定哪些具体动作（渠道、话术、活动）冲刺目标？\"",
    "capabilityMatch": "1. **客户开发能力：4/5分。依据：税务筹划产品销售中电销+面销+转介绍多渠道开发50+企业客户，全程跟进从接触到签约，复购率60%+，与劳动者招募全流程高度匹配。**\n2. **活动执行能力：3/5分。依据：简历未直接提及招商活动执行，但有\"策划客户培训会与产品路演\"经验，活动组织基础具备，需验证线下地推活动参与度。**\n3. **市场分析能力：3/5分。依据：有\"及时掌握税收政策变动，解读政策红利，优化销售策略\"及\"分析产品核心数据，优化产品策略\"经历，但聚焦产品数据而非区域市场信息收集。**\n4. **商务沟通能力：4/5分。依据：长期对接制造业、服务业、互联网等多行业企业客户，擅长建立信任、商务谈判及成交，\"沟通与执行力强\"为自我核心优势。**\n5. **软件操作能力：4/5分。依据：产品经理背景熟练使用各类系统工具，\"主动使用AI等工具提升工作效率\"，Office基础操作可默认具备，但需确认熟练程度。**",
    "created": ""
  },
  {
    "id": 31,
    "name": "李瑞明",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "李",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "40岁",
    "gender": "无",
    "strengths": "人力资源专业背景与劳动者招募岗位有一定契合度；自我评价强调\"快速适应重复性事务性工作\"\"抗压能力强\"，符合地招岗位高强度特性；实习经历体现与员工沟通经验，对理解劳动者心理有潜在帮助。",
    "risks": "26年应届生身份与JD要求\"一年以上市场营销、家政招商工作经验\"硬性冲突；简历未体现任何销售/电销/招商相关经历，客户开发能力存疑；市场营销专业背景缺失；籍贯河北邢台与北京岗位地域匹配度未明确。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 淘汰\n\n优势分析:\n人力资源专业背景与劳动者招募岗位有一定契合度；自我评价强调\"快速适应重复性事务性工作\"\"抗压能力强\"，符合地招岗位高强度特性；实习经历体现与员工沟通经验，对理解劳动者心理有潜在帮助。\n\n风险点:\n26年应届生身份与JD要求\"一年以上市场营销、家政招商工作经验\"硬性冲突；简历未体现任何销售/电销/招商相关经历，客户开发能力存疑；市场营销专业背景缺失；籍贯河北邢台与北京岗位地域匹配度未明确。\n\n能力维度匹配:\n1. **客户开发能力：1/5分。依据：简历零销售/客户开发经历，仅实习中\"耐心与员工沟通\"，与\"电话邀约、签约\"等主动销售行为差异显著，应届生身份无经验积累。**\n2. **活动执行能力：2/5分。依据：提及\"经常参加义务活动\"但未说明组织或执行角色，实习中\"努力学习前辈经验\"暗示被动参与，无招商活动相关证据。**\n3. **市场分析能力：1/5分。依据：完全未体现市场信息收集、行业分析或建议提出经历，专业课程学习未转化为实践输出。**\n4. **商务沟通能力：2/5分。依据：自我评价强调\"性格开朗\"\"适应性强\"，实习有\"与员工沟通\"经历，但缺乏商务场景（谈判、签约、礼仪展示）实证。**\n5. **软件操作能力：2/5分。依据：未明确提及Office技能，仅\"认真完成老师任务及作业\"隐含基础文档处理能力，无Excel数据分析或PPT呈现证据。**\n\n面试问题:\n1. \"请描述一次你主动说服他人接受你观点或方案的经历，当时对方有什么顾虑，你如何回应的？\"\n2. \"实习中你提到'耐心与员工沟通'，能否举例说明如何处理一位情绪激动的员工或客户？\"\n3. \"你期望在北京发展，但籍贯在河北，能否说明未来3",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. \"请描述一次你主动说服他人接受你观点或方案的经历，当时对方有什么顾虑，你如何回应的？\"\n2. \"实习中你提到'耐心与员工沟通'，能否举例说明如何处理一位情绪激动的员工或客户？\"\n3. \"你期望在北京发展，但籍贯在河北，能否说明未来3年职业规划及如何看待地招岗位的高流动性问题？\"\n4. \"假设你需要电话邀约一位40岁农村户籍、对家政行业有顾虑的女性劳动者，请模拟开场白并说明如何打消其'做家政丢人'的观念。\"\n5. \"如果本月招募目标为30人，目前进度仅完成40%，你会如何分析原因并调整策略？请列出具体动作。\"",
    "capabilityMatch": "1. **客户开发能力：1/5分。依据：简历零销售/客户开发经历，仅实习中\"耐心与员工沟通\"，与\"电话邀约、签约\"等主动销售行为差异显著，应届生身份无经验积累。**\n2. **活动执行能力：2/5分。依据：提及\"经常参加义务活动\"但未说明组织或执行角色，实习中\"努力学习前辈经验\"暗示被动参与，无招商活动相关证据。**\n3. **市场分析能力：1/5分。依据：完全未体现市场信息收集、行业分析或建议提出经历，专业课程学习未转化为实践输出。**\n4. **商务沟通能力：2/5分。依据：自我评价强调\"性格开朗\"\"适应性强\"，实习有\"与员工沟通\"经历，但缺乏商务场景（谈判、签约、礼仪展示）实证。**\n5. **软件操作能力：2/5分。依据：未明确提及Office技能，仅\"认真完成老师任务及作业\"隐含基础文档处理能力，无Excel数据分析或PPT呈现证据。**",
    "created": ""
  },
  {
    "id": 32,
    "name": "刘女士",
    "role": "母婴顾问",
    "company": "销售部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "刘",
    "dept": "雏渐肥事业部",
    "city": "南京",
    "age": "39岁",
    "gender": "女",
    "strengths": "15年大型企业HR管理经验，具备成熟的沟通协调能力、团队搭建及培训体系搭建经验，对绩效考核和人才梯队建设有实操经验，有一定管理素养。",
    "risks": "年龄39岁远超21-26岁硬性要求；求职意向为\"薪酬绩效\"，与母婴顾问销售岗严重偏离；近5年无一线销售经验，无母婴行业背景；简历显示管理岗定位，与顾问式销售的执行层角色存在职级落差。",
    "aiEval": "以下为候选人的 母婴顾问 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：母婴顾问\n🏢 招聘岗位：母婴顾问\n\n初筛结果: 淘汰\n\n优势分析:\n15年大型企业HR管理经验，具备成熟的沟通协调能力、团队搭建及培训体系搭建经验，对绩效考核和人才梯队建设有实操经验，有一定管理素养。\n\n风险点:\n年龄39岁远超21-26岁硬性要求；求职意向为\"薪酬绩效\"，与母婴顾问销售岗严重偏离；近5年无一线销售经验，无母婴行业背景；简历显示管理岗定位，与顾问式销售的执行层角色存在职级落差。\n\n能力维度匹配:\n1. **1. 专业咨询能力：1/5分。依据：无母婴护理知识储备，无月嫂筛选或家政服务经验，2020年后转岗电信产品销售，与母婴咨询场景无关。**\n2. **2. 客户关系维护：2/5分。依据：HR背景涉及员工关系管理，但面向内部员工而非外部客户销售；无线上签约、到店邀约等C端销售转化经验。**\n3. **3. 问题处理能力：2/5分。依据：有员工投诉处理及劳动争议经验，但客户投诉处理场景不同；无\"接单派单\"类业务流程经验。**\n4. **4. 营销技能提升：1/5分。依据：简历体现的是\"组织培训\"而非\"接受培训\"，角色为培训管理者而非受训销售；无营销技能自我提升的相关表述。**\n5. **5. 抗压积极能力：2/5分。依据：多年职场经历体现一定抗压性，但\"强烈赚钱欲望\"和\"快速调整心态\"等销售特质无直接证据；管理岗背景对销售岗积极性匹配度存疑。**\n\n面试问题:\n1. 请描述一次您从管理岗转岗到一线执行岗的经历，当时如何调整心态适应角色落差？\n2. 在电信产品销售中，您如何快速建立客户信任并完成转化？请举例说明具体话术或策略。\n3. 您期望薪酬为8-13K，但过往管理岗薪资可能更高，如何确保长期稳定性而非过渡？\n4. 假设客户质疑月嫂资质，要求更换人选，您如何在30分钟内完成备选匹配并",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "母婴顾问",
    "interviewQ": "1. 请描述一次您从管理岗转岗到一线执行岗的经历，当时如何调整心态适应角色落差？\n2. 在电信产品销售中，您如何快速建立客户信任并完成转化？请举例说明具体话术或策略。\n3. 您期望薪酬为8-13K，但过往管理岗薪资可能更高，如何确保长期稳定性而非过渡？\n4. 假设客户质疑月嫂资质，要求更换人选，您如何在30分钟内完成备选匹配并安抚客户？\n5. 请简述您对母婴护理服务标准化流程的理解，以及如何将HR的\"人岗匹配\"经验迁移到月嫂筛选场景？",
    "capabilityMatch": "1. **1. 专业咨询能力：1/5分。依据：无母婴护理知识储备，无月嫂筛选或家政服务经验，2020年后转岗电信产品销售，与母婴咨询场景无关。**\n2. **2. 客户关系维护：2/5分。依据：HR背景涉及员工关系管理，但面向内部员工而非外部客户销售；无线上签约、到店邀约等C端销售转化经验。**\n3. **3. 问题处理能力：2/5分。依据：有员工投诉处理及劳动争议经验，但客户投诉处理场景不同；无\"接单派单\"类业务流程经验。**\n4. **4. 营销技能提升：1/5分。依据：简历体现的是\"组织培训\"而非\"接受培训\"，角色为培训管理者而非受训销售；无营销技能自我提升的相关表述。**\n5. **5. 抗压积极能力：2/5分。依据：多年职场经历体现一定抗压性，但\"强烈赚钱欲望\"和\"快速调整心态\"等销售特质无直接证据；管理岗背景对销售岗积极性匹配度存疑。**",
    "created": ""
  },
  {
    "id": 33,
    "name": "小程",
    "role": "母婴顾问",
    "company": "销售部",
    "years": 0,
    "edu": "大专",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "小",
    "dept": "雏渐肥事业部",
    "city": "南京",
    "age": "20岁",
    "gender": "无",
    "strengths": "3年医药零售经验，兼具中药调剂与西药房运营双背景，具备标准化服务流程意识；有客户投诉处理、物流时效管理、库存盘点等实操经验；年龄20岁符合21-26岁区间，求职销售岗意愿明确，有\"拼劲、钻研精神\"自驱力描述，与顾问式销售属性契合。",
    "risks": "学历为大专（药物制剂技术），专业与母婴护理关联度弱；简历显示\"店员/营业员1年\"但工作经历累计2年，经验深度有限；无明确家政/母婴行业背景，专业咨询能力需从零构建；当前在职（2023.11-2025.07），稳定性存疑。",
    "aiEval": "以下为候选人的 母婴顾问 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：母婴顾问\n🏢 招聘岗位：母婴顾问\n\n初筛结果: 通过\n\n优势分析:\n3年医药零售经验，兼具中药调剂与西药房运营双背景，具备标准化服务流程意识；有客户投诉处理、物流时效管理、库存盘点等实操经验；年龄20岁符合21-26岁区间，求职销售岗意愿明确，有\"拼劲、钻研精神\"自驱力描述，与顾问式销售属性契合。\n\n风险点:\n学历为大专（药物制剂技术），专业与母婴护理关联度弱；简历显示\"店员/营业员1年\"但工作经历累计2年，经验深度有限；无明确家政/母婴行业背景，专业咨询能力需从零构建；当前在职（2023.11-2025.07），稳定性存疑。\n\n能力维度匹配:\n1. **1. 专业咨询能力：2/5分。依据：无母婴/家政行业经验，但具备药品专业知识迁移潜力；有\"对中药有一定认知\"基础，需系统培训母婴护理知识。**\n2. **2. 客户关系维护：3/5分。依据：1年药店销售经验，有\"确保完成销售目标\"业绩描述；负责\"患者客诉矛盾\"处理，具备基础客户沟通经验；无线上签约、邀约到店等O2O服务经验。**\n3. **3. 问题处理能力：3/5分。依据：明确负责\"患者客诉矛盾\"处理，有物流售后、效期管理经验；但投诉处理场景为医疗领域，家政服务客诉复杂度不同，迁移性待验证。**\n4. **4. 营销技能提升：2/5分。依据：有\"参与预备店长培训\"经历，显示学习意愿；但无数字化系统使用、顾问式销售等具体经验，需从零适应天鹅到家业务系统。**\n5. **5. 抗压积极能力：4/5分。依据：自评\"认真对待、有拼劲、敬业精神\"，求职意向明确写\"期望薪资7-12K\"体现赚钱动机；20岁即3年工作经验，职业启动早，抗压韧性有支撑。**\n\n面试问题:\n1. 请描述一次你处理患者/客户投诉的具体案例：当时矛盾焦点是什么？你采取了哪些步骤？最",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "母婴顾问",
    "interviewQ": "1. 请描述一次你处理患者/客户投诉的具体案例：当时矛盾焦点是什么？你采取了哪些步骤？最终如何达成双方满意的结果？\n2. 药店工作涉及药品效期管理和库存盘点，这些需要高度细致和责任心。请分享一次你因疏忽几乎出错、最终如何补救的经历。\n3. 你目前仍在南京固生堂任职，能否说明离职动机？对天鹅到家\"顾问式销售+公司给资源\"的模式，与你过往主动推销经历相比，你认为最大挑战会是什么？\n4. 假设一位准妈妈咨询月嫂服务，主要担忧是\"月嫂专业度不够、怕照顾不好新生儿\"，你会如何运用顾问式沟通挖掘真实需求并建立信任？\n5. 我们需同时维护线上客户（微信/电话）和邀约到店转化，你过往有同时处理多线程任务（如配药+客诉+物流对接）的经验，请说明你的优先级排序方法。\n6. 基于我们对岗位职责和公司模式的介绍，你有哪些关于团队支持体系、客户资源分配、或者职业成长路径的问题想进一步了解？",
    "capabilityMatch": "1. **1. 专业咨询能力：2/5分。依据：无母婴/家政行业经验，但具备药品专业知识迁移潜力；有\"对中药有一定认知\"基础，需系统培训母婴护理知识。**\n2. **2. 客户关系维护：3/5分。依据：1年药店销售经验，有\"确保完成销售目标\"业绩描述；负责\"患者客诉矛盾\"处理，具备基础客户沟通经验；无线上签约、邀约到店等O2O服务经验。**\n3. **3. 问题处理能力：3/5分。依据：明确负责\"患者客诉矛盾\"处理，有物流售后、效期管理经验；但投诉处理场景为医疗领域，家政服务客诉复杂度不同，迁移性待验证。**\n4. **4. 营销技能提升：2/5分。依据：有\"参与预备店长培训\"经历，显示学习意愿；但无数字化系统使用、顾问式销售等具体经验，需从零适应天鹅到家业务系统。**\n5. **5. 抗压积极能力：4/5分。依据：自评\"认真对待、有拼劲、敬业精神\"，求职意向明确写\"期望薪资7-12K\"体现赚钱动机；20岁即3年工作经验，职业启动早，抗压韧性有支撑。**",
    "created": ""
  },
  {
    "id": 34,
    "name": "张女士",
    "role": "母婴顾问",
    "company": "销售部",
    "years": 0,
    "edu": "大专",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "张",
    "dept": "雏渐肥事业部",
    "city": "南京",
    "age": "39岁",
    "gender": "女",
    "strengths": "13年销售经验覆盖电话销售、招商、房产经纪，具备客户邀约、商务谈判、合同签约全流程经验；执行力与抗压能力获前雇主认可，顾问式销售模式与现有资源支持型岗位匹配度较高。",
    "risks": "硬性条件不符：JD明确要求\"男，年龄21-26岁\"，候选人39岁女性，存在根本冲突；行业跨度大（供应链/商管/房产→母婴家政），专业咨询能力无直接背书；大专学历2019年取得，教育背景与工作经验时间线存疑。",
    "aiEval": "以下为候选人的 母婴顾问 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：母婴顾问\n🏢 招聘岗位：母婴顾问\n\n初筛结果: 淘汰\n\n优势分析:\n13年销售经验覆盖电话销售、招商、房产经纪，具备客户邀约、商务谈判、合同签约全流程经验；执行力与抗压能力获前雇主认可，顾问式销售模式与现有资源支持型岗位匹配度较高。\n\n风险点:\n硬性条件不符：JD明确要求\"男，年龄21-26岁\"，候选人39岁女性，存在根本冲突；行业跨度大（供应链/商管/房产→母婴家政），专业咨询能力无直接背书；大专学历2019年取得，教育背景与工作经验时间线存疑。\n\n能力维度匹配:\n1. **1. 专业咨询能力：1/5分。依据**：无母婴/家政行业经验，未体现月嫂筛选、护理知识等专业背景，仅房产经纪有\"匹配房源\"的类比经验。\n2. **2. 客户关系维护：4/5分。依据**：电话销售\"回访跟进促成二次成交\"、招商专员\"客户邀约跟踪及商务谈判\"、房产经纪\"客户接待咨询与成交\"，三层经验叠加。\n3. **3. 问题处理能力：2/5分。依据**：仅商管工作涉及\"催缴欠费\"，无投诉处理、疑难解答的直接记录，客户满意度提升无数据支撑。\n4. **4. 营销技能提升：2/5分。依据**：简历未提主动参加培训经历，仅笼统写\"虚心学习\"，数字化系统使用经验未体现。\n5. **5. 抗压积极能力：4/5分。依据**：自我评价明确\"抗压力强\"，销售岗位13年留存及\"多次获得领导嘉奖\"可佐证稳定性与积极性。\n\n面试问题:\n1. \"请描述一次客户强烈投诉的经历，你如何处理并最终转化满意度？\"\n2. \"房产经纪与母婴顾问都需要建立信任，但决策周期和情感因素差异大，你如何调整沟通策略？\"\n3. \"39岁转型母婴行业，相比21-26岁候选人，你认为自身核心优势是什么？职业规划如何？\"\n4. \"假设客户坚持要'金牌月嫂'但预算仅够标准档，你如",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "母婴顾问",
    "interviewQ": "1. \"请描述一次客户强烈投诉的经历，你如何处理并最终转化满意度？\"\n2. \"房产经纪与母婴顾问都需要建立信任，但决策周期和情感因素差异大，你如何调整沟通策略？\"\n3. \"39岁转型母婴行业，相比21-26岁候选人，你认为自身核心优势是什么？职业规划如何？\"\n4. \"假设客户坚持要'金牌月嫂'但预算仅够标准档，你如何专业说服并推荐匹配人选？\"\n5. \"系统显示某月嫂历史评价中有'做饭不合口味'标签，客户面试时未提及，你会主动披露吗？为什么？\"",
    "capabilityMatch": "1. **1. 专业咨询能力：1/5分。依据**：无母婴/家政行业经验，未体现月嫂筛选、护理知识等专业背景，仅房产经纪有\"匹配房源\"的类比经验。\n2. **2. 客户关系维护：4/5分。依据**：电话销售\"回访跟进促成二次成交\"、招商专员\"客户邀约跟踪及商务谈判\"、房产经纪\"客户接待咨询与成交\"，三层经验叠加。\n3. **3. 问题处理能力：2/5分。依据**：仅商管工作涉及\"催缴欠费\"，无投诉处理、疑难解答的直接记录，客户满意度提升无数据支撑。\n4. **4. 营销技能提升：2/5分。依据**：简历未提主动参加培训经历，仅笼统写\"虚心学习\"，数字化系统使用经验未体现。\n5. **5. 抗压积极能力：4/5分。依据**：自我评价明确\"抗压力强\"，销售岗位13年留存及\"多次获得领导嘉奖\"可佐证稳定性与积极性。",
    "created": ""
  },
  {
    "id": 35,
    "name": "杨雨欣",
    "role": "母婴顾问",
    "company": "销售部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "杨",
    "dept": "雏渐肥事业部",
    "city": "南京",
    "age": "28岁",
    "gender": "女",
    "strengths": "8年工作经验含咨询顾问岗位，具备客户接待、需求沟通、转化跟进及维护客户关系经验；有销售指标完成记录，适应灵活工作节奏；定居江宁通勤稳定，个人状态踏实长期任职意愿明确。",
    "risks": "无母婴/家政行业背景，专业咨询能力存缺口；28岁超年龄上限（21-26岁）；近期岗位切换频繁（2023-2025年三份工作），职业稳定性需验证；期望薪资6-8K低于JD标注8-13K，动机需确认。",
    "aiEval": "以下为候选人的 母婴顾问 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：母婴顾问\n🏢 招聘岗位：母婴顾问\n\n初筛结果: 存疑\n\n优势分析:\n8年工作经验含咨询顾问岗位，具备客户接待、需求沟通、转化跟进及维护客户关系经验；有销售指标完成记录，适应灵活工作节奏；定居江宁通勤稳定，个人状态踏实长期任职意愿明确。\n\n风险点:\n无母婴/家政行业背景，专业咨询能力存缺口；28岁超年龄上限（21-26岁）；近期岗位切换频繁（2023-2025年三份工作），职业稳定性需验证；期望薪资6-8K低于JD标注8-13K，动机需确认。\n\n能力维度匹配:\n1. **1. 专业咨询能力：2/5分**。依据：无母婴/家政服务经验，仅有医疗美容咨询背景，行业知识迁移性有限；未体现月嫂筛选、阿姨匹配等具体技能。\n2. **2. 客户关系维护：4/5分**。依据：南京新生医疗美容门诊咨询顾问经历明确包含\"客户咨询接待、需求沟通与转化跟进\"\"主动维护客户关系，定期跟进回访\"\"客户邀约、活动接待与现场转化\"，与JD高度匹配。\n3. **3. 问题处理能力：3/5分**。依据：京东舆情管理经历涉及\"对接跨部门信息反馈\"\"撰写沟通方案\"，有投诉处理相关经验；但无明确客户投诉处理及满意度提升量化成果。\n4. **4. 营销技能提升：3/5分**。依据：未提及主动参与营销培训记录，但\"适应灵活工作节奏，抗压能力与营销意识显著提升\"体现学习适应性；需验证培训参与主动性。\n5. **5. 抗压积极能力：4/5分**。依据：简历明确标注\"适应灵活的工作节奏，抗压能力与营销意识显著提升\"\"个人状态稳定，能踏实长期任职\"；期望薪资低于JD标注，需深挖赚钱欲望真实性。\n\n面试问题:\n1. 请描述在医疗美容咨询中，遇到客户对服务效果强烈不满并要求退款时，你如何处理？最终结果如何？\n2. 你近三份工作均在1年左右，请说明离职原因",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "母婴顾问",
    "interviewQ": "1. 请描述在医疗美容咨询中，遇到客户对服务效果强烈不满并要求退款时，你如何处理？最终结果如何？\n2. 你近三份工作均在1年左右，请说明离职原因及选择天鹅到家母婴顾问岗位的长期职业规划。\n3. 期望薪资6-8K低于我们标注范围，结合你\"强烈赚钱欲望\"的自我评价，请说明薪资期望背后的考量。\n4. 假设客户坚持要求\"必须有10年经验、会双语、会做月子餐\"的月嫂，但公司资源库无完全匹配人选，你如何沟通并促成签约？\n5. 请简述你对月嫂服务标准（如新生儿护理、产妇护理核心项目）的基础认知，或说明你计划如何快速补足母婴专业知识。",
    "capabilityMatch": "1. **专业咨询能力：2/5分**。依据：无母婴/家政服务经验，仅有医疗美容咨询背景，行业知识迁移性有限；未体现月嫂筛选、阿姨匹配等具体技能。\n2. **客户关系维护：4/5分**。依据：南京新生医疗美容门诊咨询顾问经历明确包含\"客户咨询接待、需求沟通与转化跟进\"\"主动维护客户关系，定期跟进回访\"\"客户邀约、活动接待与现场转化\"，与JD高度匹配。\n3. **问题处理能力：3/5分**。依据：京东舆情管理经历涉及\"对接跨部门信息反馈\"\"撰写沟通方案\"，有投诉处理相关经验；但无明确客户投诉处理及满意度提升量化成果。\n4. **营销技能提升：3/5分**。依据：未提及主动参与营销培训记录，但\"适应灵活工作节奏，抗压能力与营销意识显著提升\"体现学习适应性；需验证培训参与主动性。\n5. **抗压积极能力：4/5分**。依据：简历明确标注\"适应灵活的工作节奏，抗压能力与营销意识显著提升\"\"个人状态稳定，能踏实长期任职\"；期望薪资低于JD标注，需深挖赚钱欲望真实性。",
    "created": ""
  },
  {
    "id": 36,
    "name": "翁凤敏",
    "role": "母婴顾问",
    "company": "销售部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "翁",
    "dept": "雏渐肥事业部",
    "city": "南京",
    "age": "29岁",
    "gender": "女",
    "strengths": "具备6年销售及服务经验，有房地产经纪（链家）和零售门店管理（Costa店长）背景，客户开发与维护、签约促成、团队培训经验较丰富；英语六级可服务外籍客户；数字化工具使用熟练。",
    "risks": "1. 硬性条件不符：JD明确要求\"男，年龄21-26岁\"，候选人29岁女性，直接淘汰；\n2. 职业路径跳跃（咖啡→房产→咖啡），家政行业零经验；\n3. 近2年存在职业空档（2023-04至2024-06），稳定性存疑。",
    "aiEval": "以下为候选人的 母婴顾问 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：母婴顾问\n🏢 招聘岗位：母婴顾问\n\n初筛结果: 淘汰\n\n优势分析:\n具备6年销售及服务经验，有房地产经纪（链家）和零售门店管理（Costa店长）背景，客户开发与维护、签约促成、团队培训经验较丰富；英语六级可服务外籍客户；数字化工具使用熟练。\n\n风险点:\n硬性条件不符：JD明确要求\"男，年龄21-26岁\"，候选人29岁女性，直接淘汰；职业路径跳跃（咖啡→房产→咖啡），家政行业零经验；近2年存在职业空档（2023-04至2024-06），稳定性存疑。\n\n能力维度匹配:\n1. **1. 专业咨询能力：1/5分。依据：零母婴/家政行业背景，无月嫂筛选或育儿知识相关经验，专业咨询基础缺失。**\n2. **2. 客户关系维护：4/5分。依据：链家租赁经纪经验含客户开发、需求挖掘、签约促成；Costa店长负责会员维护与复购提升，匹配度高。**\n3. **3. 问题处理能力：3/5分。依据：门店管理涉及客诉处理，但无明确投诉处理案例；房产销售有签约后服务经验，可迁移。**\n4. **4. 营销技能提升：3/5分。依据：有培训新员工经验，接受度高；但无主动提及参加外部营销培训经历，学习主动性待验证。**\n5. **5. 抗压积极能力：3/5分。依据：销售岗位背景隐含抗压性，简历自述\"具有一定抗压性\"；但无具体业绩数据佐证\"强烈赚钱欲望\"。**\n\n面试问题:\n1. 请描述在链家时，一次客户签约前反复犹豫、你最终促成交易的完整过程，你采取了哪些关键动作？\n2. Costa店长期间，如何处理过客户对咖啡品质或服务的严重投诉？最终结果如何？\n3. 2023年4月离开链家后至2024年7月入职Costa前，这段时间的职业规划是什么？为何选择回归咖啡行业？\n4. 假设一位孕晚期客户坚持要一位\"会双语、能做月子餐、有早产儿护理",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "母婴顾问",
    "interviewQ": "1. 请描述在链家时，一次客户签约前反复犹豫、你最终促成交易的完整过程，你采取了哪些关键动作？\n2. Costa店长期间，如何处理过客户对咖啡品质或服务的严重投诉？最终结果如何？\n3. 2023年4月离开链家后至2024年7月入职Costa前，这段时间的职业规划是什么？为何选择回归咖啡行业？\n4. 假设一位孕晚期客户坚持要一位\"会双语、能做月子餐、有早产儿护理经验\"的月嫂，但公司资源库暂无完全匹配人选，你会如何沟通并推进？\n5. 客户签约后3天，反馈月嫂上门时态度冷淡、做事拖沓，要求退单或更换，你的处理步骤是什么？",
    "capabilityMatch": "1. **1. 专业咨询能力：1/5分。依据：零母婴/家政行业背景，无月嫂筛选或育儿知识相关经验，专业咨询基础缺失。**\n2. **2. 客户关系维护：4/5分。依据：链家租赁经纪经验含客户开发、需求挖掘、签约促成；Costa店长负责会员维护与复购提升，匹配度高。**\n3. **3. 问题处理能力：3/5分。依据：门店管理涉及客诉处理，但无明确投诉处理案例；房产销售有签约后服务经验，可迁移。**\n4. **4. 营销技能提升：3/5分。依据：有培训新员工经验，接受度高；但无主动提及参加外部营销培训经历，学习主动性待验证。**\n5. **5. 抗压积极能力：3/5分。依据：销售岗位背景隐含抗压性，简历自述\"具有一定抗压性\"；但无具体业绩数据佐证\"强烈赚钱欲望\"。**",
    "created": ""
  },
  {
    "id": 37,
    "name": "邱女士",
    "role": "母婴顾问",
    "company": "销售部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "邱",
    "dept": "雏渐肥事业部",
    "city": "南京",
    "age": "29岁",
    "gender": "女",
    "strengths": "7年工作经验体现一定职业成熟度；秘书学专业背景具备基础文档处理与沟通素养；博物馆销售及门店店长经历有客户接待与文创产品销售经验，对\"顾问式销售+线下接待\"模式有初步认知。",
    "risks": "硬性条件不符：JD明确要求\"男，年龄21-26岁\"，候选人女性29岁，直接不满足任职要求；无母婴/家政行业背景，专业咨询能力为零基础；简历中\"期望薪资5-7K\"与岗位标注\"8-13K\"存在预期偏差，动机存疑。",
    "aiEval": "以下为候选人的 母婴顾问 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：母婴顾问\n🏢 招聘岗位：母婴顾问\n\n初筛结果: 淘汰\n\n优势分析:\n7年工作经验体现一定职业成熟度；秘书学专业背景具备基础文档处理与沟通素养；博物馆销售及门店店长经历有客户接待与文创产品销售经验，对\"顾问式销售+线下接待\"模式有初步认知。\n\n风险点:\n硬性条件不符：JD明确要求\"男，年龄21-26岁\"，候选人女性29岁，直接不满足任职要求；无母婴/家政行业背景，专业咨询能力为零基础；简历中\"期望薪资5-7K\"与岗位标注\"8-13K\"存在预期偏差，动机存疑。\n\n能力维度匹配:\n1. **专业咨询能力：0/5分。依据**：简历零母婴护理、月嫂筛选、家政服务相关经验，专业背景为秘书学，与母婴咨询完全无关。\n2. **客户关系维护：2/5分。依据**：有博物馆销售、门店店长等客户接待经验，但属文创零售场景，与家政服务的高信任度、长周期客户关系差异较大。\n3. **问题处理能力：1/5分。依据**：行政助理经历涉及基础事务协调，但无客户投诉处理、售后纠纷解决等复杂问题应对记录。\n4. **营销技能提升：2/5分。依据**：有销售岗位经历暗示一定学习能力，但无参加系统培训、主动提升营销技能的直接证据。\n5. **抗压积极能力：1/5分。依据**：简历自述\"热爱工作有热情\"，但无业绩压力、高强度KPI场景下的抗压实证；期望薪资低于岗位区间，赚钱欲望存疑。\n\n面试问题:\n1. \"你过往经历中文创产品销售与母婴顾问的服务属性差异较大，请举例说明你如何快速学习一个全新行业知识并应用于客户沟通？\"\n2. \"门店店长期间是否遇到过客户对产品质量或服务的激烈投诉？当时如何处理，结果如何？\"\n3. \"7年内经历行政、销售、店长多岗位转换，请说明每次转换的原因，以及未来3-5年的职业规划是否清晰？\"\n4. \"假设一位新手妈妈",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "母婴顾问",
    "interviewQ": "1. \"你过往经历中文创产品销售与母婴顾问的服务属性差异较大，请举例说明你如何快速学习一个全新行业知识并应用于客户沟通？\"\n2. \"门店店长期间是否遇到过客户对产品质量或服务的激烈投诉？当时如何处理，结果如何？\"\n3. \"7年内经历行政、销售、店长多岗位转换，请说明每次转换的原因，以及未来3-5年的职业规划是否清晰？\"\n4. \"假设一位新手妈妈咨询月嫂服务，但对价格敏感且对服务质量担忧，请模拟一段顾问式销售对话，展示你如何挖掘需求并建立信任？\"\n5. \"请简述你认为月嫂筛选的核心评估维度有哪些？如果客户面试后对两位月嫂犹豫，你会如何推进决策？\"",
    "capabilityMatch": "1. **专业咨询能力：0/5分。依据**：简历零母婴护理、月嫂筛选、家政服务相关经验，专业背景为秘书学，与母婴咨询完全无关。\n2. **客户关系维护：2/5分。依据**：有博物馆销售、门店店长等客户接待经验，但属文创零售场景，与家政服务的高信任度、长周期客户关系差异较大。\n3. **问题处理能力：1/5分。依据**：行政助理经历涉及基础事务协调，但无客户投诉处理、售后纠纷解决等复杂问题应对记录。\n4. **营销技能提升：2/5分。依据**：有销售岗位经历暗示一定学习能力，但无参加系统培训、主动提升营销技能的直接证据。\n5. **抗压积极能力：1/5分。依据**：简历自述\"热爱工作有热情\"，但无业绩压力、高强度KPI场景下的抗压实证；期望薪资低于岗位区间，赚钱欲望存疑。",
    "created": ""
  },
  {
    "id": 38,
    "name": "闫琳",
    "role": "母婴顾问",
    "company": "销售部",
    "years": 0,
    "edu": "大专",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "闫",
    "dept": "雏渐肥事业部",
    "city": "南京",
    "age": "32岁",
    "gender": "女",
    "strengths": "11年ToB企业销售经验，具备客户开发、客情维护、需求挖掘及资源协调能力；有业绩成果（季度增长80%、年度目标110%），抗压性与执行力经长期验证；熟悉南京本地市场，具备顾问式销售思维。",
    "risks": "硬性条件不符：32岁女性超JD年龄限制（21-26岁男性）；行业经验断层：无母婴/家政行业背景，专业咨询能力存疑；稳定性风险：近5年更换5份工作，平均任期1年；学历不符：大专学历，JD要求本科；薪资预期过高：5-10K超南京母婴顾问常规薪酬带。",
    "aiEval": "以下为候选人的 母婴顾问 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：母婴顾问\n🏢 招聘岗位：母婴顾问\n\n初筛结果: 淘汰\n\n优势分析:\n11年ToB企业销售经验，具备客户开发、客情维护、需求挖掘及资源协调能力；有业绩成果（季度增长80%、年度目标110%），抗压性与执行力经长期验证；熟悉南京本地市场，具备顾问式销售思维。\n\n风险点:\n硬性条件不符：32岁女性超JD年龄限制（21-26岁男性）；行业经验断层：无母婴/家政行业背景，专业咨询能力存疑；稳定性风险：近5年更换5份工作，平均任期1年；学历不符：大专学历，JD要求本科；薪资预期过高：5-10K超南京母婴顾问常规薪酬带。\n\n能力维度匹配:\n1. **1. 专业咨询能力：1/5分。依据**：完全无母婴护理、月嫂筛选、家政服务相关专业背景；11年经验集中于企业服务/交通工程/乳业推广，与母婴咨询零交集。\n2. **2. 客户关系维护：4/5分。依据**：长期负责客户全周期维护、二次合作、长期续约，具备成熟的客情管理与需求挖掘能力，可迁移至签约促成场景。\n3. **3. 问题处理能力：3/5分。依据**：有售后跟进、投诉处理相关描述（\"售后跟进\"\"保障服务落地\"），但无具体客诉解决案例，家政场景复杂性未验证。\n4. **4. 营销技能提升：2/5分。依据**：简历未提及主动参与培训经历；虽标注\"多次获评最佳经理代表\"，但缺乏营销技能、数字化工具学习证据。\n5. **5. 抗压积极能力：4/5分。依据**：个人优势明确标注\"抗压性强、执行力高\"；业绩成果（季度增长80%、年度110%）及5年乳业推广经历可佐证积极性与韧性。\n\n面试问题:\n1. 请描述一次你协调内外部资源解决客户紧急需求的经历，当时涉及哪些部门？具体如何推动？\n2. 你维护客户关系的平均周期是多久？能否举例说明如何将一次性合作客户转化为长期续约客户？\n",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "母婴顾问",
    "interviewQ": "1. 请描述一次你协调内外部资源解决客户紧急需求的经历，当时涉及哪些部门？具体如何推动？\n2. 你维护客户关系的平均周期是多久？能否举例说明如何将一次性合作客户转化为长期续约客户？\n3. 你近5年经历了5份工作，平均任期约1年，能否说明离职原因？如何看待母婴顾问需要长期积累客户信任的特点？\n4. 假设一位孕28周的准妈妈咨询月嫂服务，她关注产后抑郁预防和新生儿黄疸护理，你会如何筛选匹配月嫂？\n5. 客户签约后投诉月嫂做饭口味不符、夜间响应慢，你将如何处理投诉并挽回客户满意度？\n6. 今天的交流到此，我想把主动权交给你——关于天鹅到家的业务模式、我们团队的工作节奏，或者这个岗位未来半年的成长路径，你有什么想了解的吗？请随意提问。",
    "capabilityMatch": "1. **专业咨询能力：1/5分。依据**：完全无母婴护理、月嫂筛选、家政服务相关专业背景；11年经验集中于企业服务/交通工程/乳业推广，与母婴咨询零交集。\n2. **客户关系维护：4/5分。依据**：长期负责客户全周期维护、二次合作、长期续约，具备成熟的客情管理与需求挖掘能力，可迁移至签约促成场景。\n3. **问题处理能力：3/5分。依据**：有售后跟进、投诉处理相关描述（\"售后跟进\"\"保障服务落地\"），但无具体客诉解决案例，家政场景复杂性未验证。\n4. **营销技能提升：2/5分。依据**：简历未提及主动参与培训经历；虽标注\"多次获评最佳经理代表\"，但缺乏营销技能、数字化工具学习证据。\n5. **抗压积极能力：4/5分。依据**：个人优势明确标注\"抗压性强、执行力高\"；业绩成果（季度增长80%、年度110%）及5年乳业推广经历可佐证积极性与韧性。",
    "created": ""
  },
  {
    "id": 39,
    "name": "刘晓颖",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "刘",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "无",
    "gender": "无",
    "strengths": "小红书0-1独立运营经验（曝光4.7万+，点击率20%+，互动率16%）直接匹配内容策划与流量优化需求；Python/SQL数据分析能力支撑数据驱动决策；A/B测试优化标题封面的实战经验与岗位\"测试不同话术\"要求高度契合；校级活动统筹2000+人次体现用户沟通与项目执行力。",
    "risks": "到岗时间2026年5月25日较晚，距投递间隔约1年，存在计划变动风险；无家政/蓝领劳动者群体运营经验，对阿姨群体痛点理解可能不足；实习仅6个月且与债券承做实习连续，需关注职业方向清晰度。",
    "aiEval": "以下为候选人的 劳动者运营实习生 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：劳动者运营实习生（家政业务方向）\n🏢 招聘岗位：劳动者运营实习生\n\n初筛结果: 通过\n\n优势分析:\n小红书0-1独立运营经验（曝光4.7万+，点击率20%+，互动率16%）直接匹配内容策划与流量优化需求；Python/SQL数据分析能力支撑数据驱动决策；A/B测试优化标题封面的实战经验与岗位\"测试不同话术\"要求高度契合；校级活动统筹2000+人次体现用户沟通与项目执行力。\n\n风险点:\n到岗时间2026年5月25日较晚，距投递间隔约1年，存在计划变动风险；无家政/蓝领劳动者群体运营经验，对阿姨群体痛点理解可能不足；实习仅6个月且与债券承做实习连续，需关注职业方向清晰度。\n\n能力维度匹配:\n1. **内容策划能力：4/5分。依据：小红书独立运营10余条内容，聚焦垂类策划选题、撰写文案、设计视觉，点击率20%+，赞阅比10%，具备网感与爆款思维；但缺乏家政/招募类文案经验。\n2. **流量分析能力：4/5分。依据：建立数据台账追踪曝光量、完播率等核心指标，通过A/B测试优化标题与封面；SQL/Python熟练，10万级用户行为日志清洗建模经验，但无招聘渠道流量分析实操。\n3. **转化优化能力：3.5/5分。依据：价格敏感度建模中完成竞品分层可视化、阶梯定价策略设计，转化率提升8.2%；小红书自然流量占比94%，但缺乏Boss直聘/社群等渠道招聘转化测试经验。\n4. **用户沟通能力：3.5/5分。依据：小红书累计回复评论200余条、私信50余次，基于反馈迭代内容；校园活动统筹20+部门协调2000+人次，但无电话/IM引导留资的强销售场景经验。\n\n面试问题:\n1. 请描述一次你与\"非目标用户\"（如年龄/背景差异大）沟通并改变其认知的经历，具体做了什么？\n2. 小红书运营中收到负面反馈或数据低",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 请描述一次你与\"非目标用户\"（如年龄/背景差异大）沟通并改变其认知的经历，具体做了什么？\n2. 小红书运营中收到负面反馈或数据低迷时，你如何调整心态并推动迭代？举例说明。\n3. 你的实习规划显示2026年5月才能到岗，如果期间出现更优机会或学业变动，你会如何决策？\n4. 假设需为\"住家育儿嫂\"岗位撰写小红书招募笔记，请现场构思一个标题+封面文案框架，并说明吸引阿姨群体的核心痛点。\n5. 如果Boss直聘上某岗位曝光高但投递率低，你会用哪些数据维度拆解问题？设计一个A/B测试方案验证假设。",
    "capabilityMatch": "1. **内容策划能力：4/5分。依据：小红书独立运营10余条内容，聚焦垂类策划选题、撰写文案、设计视觉，点击率20%+，赞阅比10%，具备网感与爆款思维；但缺乏家政/招募类文案经验。\n2. **流量分析能力：4/5分。依据：建立数据台账追踪曝光量、完播率等核心指标，通过A/B测试优化标题与封面；SQL/Python熟练，10万级用户行为日志清洗建模经验，但无招聘渠道流量分析实操。\n3. **转化优化能力：3.5/5分。依据：价格敏感度建模中完成竞品分层可视化、阶梯定价策略设计，转化率提升8.2%；小红书自然流量占比94%，但缺乏Boss直聘/社群等渠道招聘转化测试经验。\n4. **用户沟通能力：3.5/5分。依据：小红书累计回复评论200余条、私信50余次，基于反馈迭代内容；校园活动统筹20+部门协调2000+人次，但无电话/IM引导留资的强销售场景经验。",
    "created": ""
  },
  {
    "id": 40,
    "name": "吴盈盈",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "吴",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "无",
    "gender": "无相关信息",
    "strengths": "具备扎实的数据处理与实证分析能力（统计建模大赛、市场调查大赛），对数据敏感度高；有教育行业用户运营经验（新东方助教），熟悉学员全流程管理与学情反馈；擅长文案撰写与活动宣传（演讲与辩论协会），具备基础内容策划与执行落地能力。",
    "risks": "无互联网内容运营或社群运营直接经验，缺乏家政行业认知与劳动者群体沟通背景；实习周期仅3个月（新东方），稳定性待验证；网感与\"接地气\"文案风格未在简历中体现，需考察内容创作实战能力。",
    "aiEval": "以下为候选人的 劳动者运营实习生 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：劳动者运营实习生（家政业务方向）\n🏢 招聘岗位：劳动者运营实习生\n\n初筛结果: 通过\n\n优势分析:\n具备扎实的数据处理与实证分析能力（统计建模大赛、市场调查大赛），对数据敏感度高；有教育行业用户运营经验（新东方助教），熟悉学员全流程管理与学情反馈；擅长文案撰写与活动宣传（演讲与辩论协会），具备基础内容策划与执行落地能力。\n\n风险点:\n无互联网内容运营或社群运营直接经验，缺乏家政行业认知与劳动者群体沟通背景；实习周期仅3个月（新东方），稳定性待验证；网感与\"接地气\"文案风格未在简历中体现，需考察内容创作实战能力。\n\n能力维度匹配:\n1. **内容策划能力：2/5分。依据：有活动宣传文案（海报、推文）经验，但无小红书/抖音等平台内容策划案例，未体现\"接地气\"风格与家政招募场景适配性。\n2. **流量分析能力：3/5分。依据：统计建模与正大杯经历证明数据清洗、变量选取、结果解读能力扎实，但缺乏互联网流量数据（曝光/点击/转化）实操经验，需验证平台工具使用能力。\n3. **转化优化能力：2/5分。依据：新东方助教工作涉及学情数据反馈辅助教学调整，有闭环优化意识；但无A/B测试、招聘渠道运营或转化漏斗优化直接经验。\n4. **用户沟通能力：3/5分。依据：新东方管理50+学员成绩全流程，定期输出学情报告；演讲辩论协会统筹20+人员分工，具备多角色协调与执行力，但服务对象为学员而非蓝领劳动者群体。\n\n面试问题:\n1. 在新东方担任助教期间，遇到学员或家长对成绩反馈有异议时，你是如何沟通处理的？请描述具体场景与结果。\n2. 正大杯调研中需要与陌生受访者沟通回收400+份问卷，你如何快速建立信任、提高配合度？遇到拒绝如何应对？\n3. 你提到实习时间为2025年6-9月，若加入天鹅到家，能否保证至少6个月",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 在新东方担任助教期间，遇到学员或家长对成绩反馈有异议时，你是如何沟通处理的？请描述具体场景与结果。\n2. 正大杯调研中需要与陌生受访者沟通回收400+份问卷，你如何快速建立信任、提高配合度？遇到拒绝如何应对？\n3. 你提到实习时间为2025年6-9月，若加入天鹅到家，能否保证至少6个月实习周期？学业与实习冲突时如何平衡？\n4. 假设需为天鹅到家招募保洁阿姨撰写一条小红书招募笔记，请现场口述标题+封面文案+3个关键词，并说明设计理由。\n5. 若Boss直聘上某保洁岗位曝光高但投递率低，你会从哪些维度拆解数据、设计优化实验？请简述分析框架与假设。",
    "capabilityMatch": "1. **内容策划能力：2/5分。依据：有活动宣传文案（海报、推文）经验，但无小红书/抖音等平台内容策划案例，未体现\"接地气\"风格与家政招募场景适配性。\n2. **流量分析能力：3/5分。依据：统计建模与正大杯经历证明数据清洗、变量选取、结果解读能力扎实，但缺乏互联网流量数据（曝光/点击/转化）实操经验，需验证平台工具使用能力。\n3. **转化优化能力：2/5分。依据：新东方助教工作涉及学情数据反馈辅助教学调整，有闭环优化意识；但无A/B测试、招聘渠道运营或转化漏斗优化直接经验。\n4. **用户沟通能力：3/5分。依据：新东方管理50+学员成绩全流程，定期输出学情报告；演讲辩论协会统筹20+人员分工，具备多角色协调与执行力，但服务对象为学员而非蓝领劳动者群体。",
    "created": ""
  },
  {
    "id": 41,
    "name": "周天强",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "预计2028年毕业（在读）",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "周",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "无",
    "gender": "男",
    "strengths": "具备完整内容运营闭环经验，校融媒体中心经历覆盖策划-拍摄-剪辑-数据复盘全流程，单条视频5000+播放、粉丝增长20%有量化成果；建立选题灵感库、提炼爆款公式的方法论与家政招募内容工业化生产需求高度契合；抖音/小红书平台熟悉度与网感符合劳动者触媒习惯。",
    "risks": "2024年9月入学，2025年6月才担任校融媒体中心干事，时间线存在矛盾（预计2028年毕业但已担任2025-2026年职务），需核实实际可实习时长；无家政/蓝领招聘场景经验，劳动者群体沟通语境与校园新媒体存在差异；岗位描述未提及社群运营实操，Boss直聘等渠道转化测试经验为零。",
    "aiEval": "以下为候选人的 劳动者运营实习生 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：劳动者运营实习生（家政业务方向）\n🏢 招聘岗位：劳动者运营实习生\n\n初筛结果: 通过\n\n优势分析:\n具备完整内容运营闭环经验，校融媒体中心经历覆盖策划-拍摄-剪辑-数据复盘全流程，单条视频5000+播放、粉丝增长20%有量化成果；建立选题灵感库、提炼爆款公式的方法论与家政招募内容工业化生产需求高度契合；抖音/小红书平台熟悉度与网感符合劳动者触媒习惯。\n\n风险点:\n2024年9月入学，2025年6月才担任校融媒体中心干事，时间线存在矛盾（预计2028年毕业但已担任2025-2026年职务），需核实实际可实习时长；无家政/蓝领招聘场景经验，劳动者群体沟通语境与校园新媒体存在差异；岗位描述未提及社群运营实操，Boss直聘等渠道转化测试经验为零。\n\n能力维度匹配:\n1. **1. 内容策划能力：4/5分。依据：独立策划校运会专题报道，产出5条短视频；建立《校园传播选题灵感库》提炼爆款公式；熟练剪映/秀米/可画工具链，具备招募类笔记从0到1产出能力。\n2. **2. 流量分析能力：3.5/5分。依据：追踪阅读量、完播率、互动量等数据，对比选题差异使后续内容提升20%；但缺乏曝光-点击-转化率全链路分析经验，未涉及关键词优化与发布时间测试。\n3. **3. 转化优化能力：2/5分。依据：无招聘场景转化优化经验，未提及A/B测试、话术迭代、福利包装等动作；校园新媒体以传播量为核心目标，与\"内容展示→投递咨询\"的招聘转化逻辑差异显著。\n4. **4. 用户沟通能力：3/5分。依据：有抖音博主对接经验，能清晰传达优化建议并协调执行；但面向C端劳动者咨询回复、留资引导、异议处理等场景无直接证据，耐心与服务意识待验证。\n\n面试问题:\n1. 请描述一次你与博主或合作方在内容方向上产生分歧的经历，你是如何对齐目标",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 请描述一次你与博主或合作方在内容方向上产生分歧的经历，你是如何对齐目标并推动落地的？\n2. 面对评论区或私信中持续重复的相似问题，你如何保持回复质量与效率的平衡？\n3. 你的简历显示2024年9月入学但已参与2025年工作，能否说明实际学业安排与可全职实习的时间区间？\n4. 假设需在抖音发布一条招募保洁阿姨的短视频，目标人群为45-55岁农村进城女性，请现场口述你的选题角度、前三秒钩子与文案风格\n5. 如果Boss直聘上某岗位曝光高但投递率低，你会如何设计对照实验排查原因？请列出3个可测试变量",
    "capabilityMatch": "1. **1. 内容策划能力：4/5分。依据：独立策划校运会专题报道，产出5条短视频；建立《校园传播选题灵感库》提炼爆款公式；熟练剪映/秀米/可画工具链，具备招募类笔记从0到1产出能力。\n2. **2. 流量分析能力：3.5/5分。依据：追踪阅读量、完播率、互动量等数据，对比选题差异使后续内容提升20%；但缺乏曝光-点击-转化率全链路分析经验，未涉及关键词优化与发布时间测试。\n3. **3. 转化优化能力：2/5分。依据：无招聘场景转化优化经验，未提及A/B测试、话术迭代、福利包装等动作；校园新媒体以传播量为核心目标，与\"内容展示→投递咨询\"的招聘转化逻辑差异显著。\n4. **4. 用户沟通能力：3/5分。依据：有抖音博主对接经验，能清晰传达优化建议并协调执行；但面向C端劳动者咨询回复、留资引导、异议处理等场景无直接证据，耐心与服务意识待验证。",
    "created": ""
  },
  {
    "id": 42,
    "name": "张洁",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "本科在读（专升本）",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "张",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "无",
    "gender": "女",
    "strengths": "数据驱动思维突出（整理300+学生数据、优化管理方案），与流量分析能力高度契合；有公众号运营经验（提升阅读量30%），具备基础内容策划与网感；选款敏感度可迁移至招募文案优化；执行力强、学习快，符合互联网运营快节奏要求。",
    "risks": "无家政/蓝领招聘行业经验，对劳动者群体（家政阿姨）沟通语境需快速适应；本科在读（专升本），2024年9月刚入学，学业与实习时间分配存疑；无Boss直聘、社群运营等渠道实操经验，转化优化能力需验证。",
    "aiEval": "以下为候选人的 劳动者运营实习生 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：劳动者运营实习生（家政业务方向）\n🏢 招聘岗位：劳动者运营实习生\n\n初筛结果: 通过\n\n优势分析:\n数据驱动思维突出（整理300+学生数据、优化管理方案），与流量分析能力高度契合；有公众号运营经验（提升阅读量30%），具备基础内容策划与网感；选款敏感度可迁移至招募文案优化；执行力强、学习快，符合互联网运营快节奏要求。\n\n风险点:\n无家政/蓝领招聘行业经验，对劳动者群体（家政阿姨）沟通语境需快速适应；本科在读（专升本），2024年9月刚入学，学业与实习时间分配存疑；无Boss直聘、社群运营等渠道实操经验，转化优化能力需验证。\n\n能力维度匹配:\n1. **内容策划能力：3/5分。依据：有公众号内容运营经验（优化标题排版提升阅读量30%），但无招募类文案经验，未体现\"接地气\"风格创作能力。\n2. **流量分析能力：4/5分。依据：数据驱动思维明确（整理分析300+学生考勤成绩数据、发现规律优化方案），具备数据敏感度和主动优化意识，与JD要求高度匹配。\n3. **转化优化能力：2/5分。依据：无招聘渠道运营经验，未体现A/B测试、话术优化等转化提升实操；选款敏感度有一定迁移性，但缺乏直接证据。\n4. **用户沟通能力：3/5分。依据：有辅导员助理经历（对接300+学生），具备基础沟通和服务意识；但无蓝领群体沟通经验，\"引导留资/报名\"的转化型沟通未验证。\n\n面试问题:\n1. 请描述一次你需要说服他人配合完成某项任务的经历，当时对方有什么顾虑，你如何沟通解决的？\n2. 在辅导员助理工作中，面对学生的不合理诉求或情绪投诉，你通常如何处理？能否举一个具体例子？\n3. 你的专升本学业2026年才结束，未来两年如何规划学业与实习的时间分配？如果业务高峰期与期末考试冲突，你会怎么协调？\n4. 假设需要在抖音",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 请描述一次你需要说服他人配合完成某项任务的经历，当时对方有什么顾虑，你如何沟通解决的？\n2. 在辅导员助理工作中，面对学生的不合理诉求或情绪投诉，你通常如何处理？能否举一个具体例子？\n3. 你的专升本学业2026年才结束，未来两年如何规划学业与实习的时间分配？如果业务高峰期与期末考试冲突，你会怎么协调？\n4. 假设需要在抖音发布一条招募家政阿姨的短视频，目标人群是35-50岁农村女性，你会怎么设计前3秒的钩子？请现场口述文案框架。\n5. 如果Boss直聘上某岗位曝光量高但咨询转化率低，你会从哪些维度拆解原因？请列出你的分析步骤和优化假设。",
    "capabilityMatch": "1. **内容策划能力：3/5分。依据：有公众号内容运营经验（优化标题排版提升阅读量30%），但无招募类文案经验，未体现\"接地气\"风格创作能力。\n2. **流量分析能力：4/5分。依据：数据驱动思维明确（整理分析300+学生考勤成绩数据、发现规律优化方案），具备数据敏感度和主动优化意识，与JD要求高度匹配。\n3. **转化优化能力：2/5分。依据：无招聘渠道运营经验，未体现A/B测试、话术优化等转化提升实操；选款敏感度有一定迁移性，但缺乏直接证据。\n4. **用户沟通能力：3/5分。依据：有辅导员助理经历（对接300+学生），具备基础沟通和服务意识；但无蓝领群体沟通经验，\"引导留资/报名\"的转化型沟通未验证。",
    "created": ""
  },
  {
    "id": 43,
    "name": "温美华",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "大三在读",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "温",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "无",
    "gender": "女",
    "strengths": "工科背景培养结构化思维与数据敏感度，Python技能可支撑流量数据处理；校园墙运营经验日均处理50+投稿，验证内容策划与用户互动能力；熟练使用AI工具提效，契合家政数字化运营需求；具备拍摄剪辑能力，可拓展短视频招募形式。",
    "risks": "无家政行业经验，对劳动者群体痛点理解待验证；大三在读（2023级），2027年毕业，实习周期与业务需求匹配度需确认；无Boss直聘/社群等商业化渠道运营经验，转化优化能力待考察。",
    "aiEval": "以下为候选人的 劳动者运营实习生 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：劳动者运营实习生（家政业务方向）\n🏢 招聘岗位：劳动者运营实习生\n\n初筛结果: 通过\n\n优势分析:\n工科背景培养结构化思维与数据敏感度，Python技能可支撑流量数据处理；校园墙运营经验日均处理50+投稿，验证内容策划与用户互动能力；熟练使用AI工具提效，契合家政数字化运营需求；具备拍摄剪辑能力，可拓展短视频招募形式。\n\n风险点:\n无家政行业经验，对劳动者群体痛点理解待验证；大三在读（2023级），2027年毕业，实习周期与业务需求匹配度需确认；无Boss直聘/社群等商业化渠道运营经验，转化优化能力待考察。\n\n能力维度匹配:\n1. **内容策划能力：4/5分。依据：校园墙策划「新生答疑」专题，单篇互动量高于日常，证明选题策划与文案能力；自述\"擅长结构化表达与信息可视化\"，但缺乏家政场景文案样本。\n2. **流量分析能力：3/5分。依据：主修大数据与云计算，GPA前30%，具备数据基础；Python可实现数据处理，但简历未体现实际分析流量数据并优化内容的案例。\n3. **转化优化能力：2/5分。依据：无A/B测试、渠道运营或转化漏斗优化经验；校园墙运营侧重内容发布而非转化效率提升，Boss直聘/社群渠道零经验。\n4. **用户沟通能力：4/5分。依据：日均处理50+投稿，覆盖求助/闲置/交友等多元场景，具备高并发咨询响应经验；通过答疑互动提升账号信任度，验证引导留资潜力。\n\n面试问题:\n1. \"校园墙日均50+投稿中，遇到过最棘手的用户投诉或冲突是什么？你如何处理并维护账号口碑？\"\n2. \"新生答疑专题的互动量提升，具体数据是多少？如果让你复盘，哪些动作对'转化'（如关注/私信）贡献最大？\"\n3. \"实习周期如何规划？如果业务旺季需要周末或晚间响应劳动者咨询，你的时间投入底线是什么？\"\n4",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. \"校园墙日均50+投稿中，遇到过最棘手的用户投诉或冲突是什么？你如何处理并维护账号口碑？\"\n2. \"新生答疑专题的互动量提升，具体数据是多少？如果让你复盘，哪些动作对'转化'（如关注/私信）贡献最大？\"\n3. \"实习周期如何规划？如果业务旺季需要周末或晚间响应劳动者咨询，你的时间投入底线是什么？\"\n4. \"假设要在小红书发布保洁阿姨招募笔记，目标人群是40-50岁农村女性，请现场构思一个标题+封面文案，并说明设计理由。\"\n5. \"如果Boss直聘上某岗位曝光高但投递率低，你会用Python或Excel如何分析数据？请描述分析框架和优化假设。\"",
    "capabilityMatch": "1. **内容策划能力：4/5分。依据：校园墙策划「新生答疑」专题，单篇互动量高于日常，证明选题策划与文案能力；自述\"擅长结构化表达与信息可视化\"，但缺乏家政场景文案样本。\n2. **流量分析能力：3/5分。依据：主修大数据与云计算，GPA前30%，具备数据基础；Python可实现数据处理，但简历未体现实际分析流量数据并优化内容的案例。\n3. **转化优化能力：2/5分。依据：无A/B测试、渠道运营或转化漏斗优化经验；校园墙运营侧重内容发布而非转化效率提升，Boss直聘/社群渠道零经验。\n4. **用户沟通能力：4/5分。依据：日均处理50+投稿，覆盖求助/闲置/交友等多元场景，具备高并发咨询响应经验；通过答疑互动提升账号信任度，验证引导留资潜力。",
    "created": ""
  },
  {
    "id": 44,
    "name": "卢珏如",
    "role": "新媒体运营",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "卢",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "20岁",
    "gender": "无",
    "strengths": "有学生会宣传经验（推文制作、视频策划剪辑），具备基础内容生产能力；有销售及家教经验，沟通意愿较强；获优秀团干等荣誉，执行力有一定验证。20岁年轻，学习窗口期长。",
    "risks": "求职意向为\"外贸文员\"且期望城市\"金华\"，与岗位\"新媒体运营/杭州\"存在明显错位；专业为现代物流管理，无母婴/家政行业背景；简历未提及小红书/抖音运营、直播、公众号实操经验，技能缺口较大；1年以内经验但无具体新媒体作品佐证。",
    "aiEval": "以下为候选人的 新媒体运营 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：新媒体运营（双休+五险一金）\n🏢 招聘岗位：新媒体运营\n👤 年龄：20岁 | 性别：无 | 学历：无\n\n初筛结果: 淘汰\n\n优势分析:\n有学生会宣传经验（推文制作、视频策划剪辑），具备基础内容生产能力；有销售及家教经验，沟通意愿较强；获优秀团干等荣誉，执行力有一定验证。20岁年轻，学习窗口期长。\n\n风险点:\n求职意向为\"外贸文员\"且期望城市\"金华\"，与岗位\"新媒体运营/杭州\"存在明显错位；专业为现代物流管理，无母婴/家政行业背景；简历未提及小红书/抖音运营、直播、公众号实操经验，技能缺口较大；1年以内经验但无具体新媒体作品佐证。\n\n能力维度匹配:\n1. **平台拓客能力：1/5分。依据：简历未提及小红书/抖音运营经验，无主动拓客行为描述，仅学生会宣传经验与平台规则、用户互动无关。**\n2. **视频制作能力：2/5分。依据：提及\"视频策划及剪辑\"，但无具体平台（抖音/小红书）、作品类型（母婴/宣发）、独立完成度说明，工具熟练度不明。**\n3. **公号运营能力：2/5分。依据：有\"推文制作\"经验，但未明确公众号运营、排版工具使用、专业内容转化案例，深度不足。**\n4. **直播执行能力：0/5分。依据：简历完全无直播、场控、连麦等相关经验，从零起步风险高。**\n5. **抗压学习能力：3/5分。依据：多角色学生干部经历+销售/家教兼职体现一定抗压性；但\"外贸文员\"求职意向与岗位方向偏离，动机存疑需验证。**\n\n面试问题:\n1. 你简历上求职意向是外贸文员且期望城市是金华，能否具体说明投递天鹅到家新媒体运营岗位的原因？这个转变是如何考虑的？\n2. 作为学生会干部制作推文时，是否遇到过紧急任务或多方意见冲突的情况？当时如何协调并确保按时交付？\n3. 你有过乐高课代理和家教兼职经历，这些工作中最挫败",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "新媒体运营（双休+五险一金）",
    "interviewQ": "1. 你简历上求职意向是外贸文员且期望城市是金华，能否具体说明投递天鹅到家新媒体运营岗位的原因？这个转变是如何考虑的？\n2. 作为学生会干部制作推文时，是否遇到过紧急任务或多方意见冲突的情况？当时如何协调并确保按时交付？\n3. 你有过乐高课代理和家教兼职经历，这些工作中最挫败的一次客户沟通是什么？最终如何处理的？\n4. 请现场描述一个你认为适合天鹅到家的小红书爆款选题，并说明目标用户、互动钩子设计，以及如何将评论用户转化为私域线索？\n5. 如果让你用剪映剪辑一条\"月嫂一天\"的短视频，你会如何设计前3秒抓眼球的画面和文案？请具体描述镜头和字幕安排。",
    "capabilityMatch": "1. **平台拓客能力：1/5分。依据：简历未提及小红书/抖音运营经验，无主动拓客行为描述，仅学生会宣传经验与平台规则、用户互动无关。**\n2. **视频制作能力：2/5分。依据：提及\"视频策划及剪辑\"，但无具体平台（抖音/小红书）、作品类型（母婴/宣发）、独立完成度说明，工具熟练度不明。**\n3. **公号运营能力：2/5分。依据：有\"推文制作\"经验，但未明确公众号运营、排版工具使用、专业内容转化案例，深度不足。**\n4. **直播执行能力：0/5分。依据：简历完全无直播、场控、连麦等相关经验，从零起步风险高。**\n5. **抗压学习能力：3/5分。依据：多角色学生干部经历+销售/家教兼职体现一定抗压性；但\"外贸文员\"求职意向与岗位方向偏离，动机存疑需验证。**",
    "created": ""
  },
  {
    "id": 45,
    "name": "孙海玉",
    "role": "新媒体运营",
    "company": "流量运营部",
    "years": 0,
    "edu": "会计专业",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "孙",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "具备抖音/小红书/视频号多平台实操经验，熟悉内容发布、直播执行、数据台账整理等运营全流程；有线下民宿用户服务经验，擅长挖掘用户需求与客情维护，与家政服务\"用户痛点洞察\"场景相通；自我评价提及\"获客率同比上升5%\"，具备初步结果导向意识。",
    "risks": "无母婴行业经验，对\"预产期\"等关键线索敏感度未知；简历时间线存疑（2025.3-2026.4为未来日期），稳定性需核实；无公众号运营经验，公号能力缺口明确；会计专业转行新媒体，职业动机与长期规划不清晰。",
    "aiEval": "以下为候选人的 新媒体运营 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：新媒体运营（双休+五险一金）\n🏢 招聘岗位：新媒体运营\n\n初筛结果: 存疑\n\n优势分析:\n具备抖音/小红书/视频号多平台实操经验，熟悉内容发布、直播执行、数据台账整理等运营全流程；有线下民宿用户服务经验，擅长挖掘用户需求与客情维护，与家政服务\"用户痛点洞察\"场景相通；自我评价提及\"获客率同比上升5%\"，具备初步结果导向意识。\n\n风险点:\n无母婴行业经验，对\"预产期\"等关键线索敏感度未知；简历时间线存疑（2025.3-2026.4为未来日期），稳定性需核实；无公众号运营经验，公号能力缺口明确；会计专业转行新媒体，职业动机与长期规划不清晰。\n\n能力维度匹配:\n1. **平台拓客能力：2/5分。依据：简历提及\"内容发布推广\"，但未体现主动评论互动、私信沟通、获取预产期/联系方式等线索转化行为，与JD要求的\"自拓\"模式存在差距。**\n2. **视频制作能力：3/5分。依据：有抖音/视频号内容运营及\"活动直播\"经验，但简历未明确独立完成拍摄剪辑，无母婴话题相关作品佐证，\"捕捉有温度内容\"能力未验证。**\n3. **公号运营能力：0/5分。依据：简历完全未提及公众号运营、排版或文案转化经验，为该岗位明显技能缺口。**\n4. **直播执行能力：3/5分。依据：有\"活动直播\"执行经验，但未明确每周3场、1小时/场的频次，也无月嫂访谈、育儿答疑、客户连麦等母婴直播形式经验。**\n5. **抗压学习能力：3/5分。依据：自我评价强调\"结果导向\"，提及主动优化运营流程；但跨专业转行、工作经验仅1年左右（2024.6-2026.4时间线存疑，可能为笔误），持续学习意愿需面试验证。**\n\n面试问题:\n1. 请描述一次你通过线上互动成功转化潜在客户的具体案例，当时是如何建立信任并获取联系方式的？\n2. 在民宿店助工作中，",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "新媒体运营（双休+五险一金）",
    "interviewQ": "1. 请描述一次你通过线上互动成功转化潜在客户的具体案例，当时是如何建立信任并获取联系方式的？\n2. 在民宿店助工作中，你如何处理过客户投诉或负面评价？请举例说明具体步骤和最终结果。\n3. 你的专业是会计，第一份工作转向文旅运营，现在又应聘母婴新媒体，能否说明职业选择的内在逻辑和长期规划？\n4. 假设需要为\"新生儿黄疸护理\"策划一条抖音视频，你会如何选题、捕捉温度瞬间？请简述脚本框架。\n5. 小红书对私信导流有严格限制，你了解的合规获客方式有哪些？如果账号被限流会如何应对？",
    "capabilityMatch": "1. **平台拓客能力：2/5分。依据：简历提及\"内容发布推广\"，但未体现主动评论互动、私信沟通、获取预产期/联系方式等线索转化行为，与JD要求的\"自拓\"模式存在差距。**\n2. **视频制作能力：3/5分。依据：有抖音/视频号内容运营及\"活动直播\"经验，但简历未明确独立完成拍摄剪辑，无母婴话题相关作品佐证，\"捕捉有温度内容\"能力未验证。**\n3. **公号运营能力：0/5分。依据：简历完全未提及公众号运营、排版或文案转化经验，为该岗位明显技能缺口。**\n4. **直播执行能力：3/5分。依据：有\"活动直播\"执行经验，但未明确每周3场、1小时/场的频次，也无月嫂访谈、育儿答疑、客户连麦等母婴直播形式经验。**\n5. **抗压学习能力：3/5分。依据：自我评价强调\"结果导向\"，提及主动优化运营流程；但跨专业转行、工作经验仅1年左右（2024.6-2026.4时间线存疑，可能为笔误），持续学习意愿需面试验证。**",
    "created": ""
  },
  {
    "id": 46,
    "name": "张佳琳",
    "role": "新媒体运营",
    "company": "流量运营部",
    "years": 0,
    "edu": "应届生",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "张",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "应届生",
    "gender": "无",
    "strengths": "应届生但具备完整新媒体实战经验，有抖音直播从0到1运营经验（10+场直播、单场2000+观看、涨粉800+），熟练使用剪映剪辑，数据驱动意识强（Excel/SPSS/Power BI），英语能力可支撑未来国际化业务探索，校级团队管理经验体现执行力与跨部门协作能力。",
    "risks": "无母婴行业经验，需验证对母婴话题的感知力；实习时间均仅1-2个月，稳定性存疑；无公众号运营直接经验，排版能力未验证；无主动\"拓客\"获取销售线索的经历，更多是内容运营而非线索转化。",
    "aiEval": "以下为候选人的 新媒体运营 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：新媒体运营（双休+五险一金）\n🏢 招聘岗位：新媒体运营\n\n初筛结果: 通过\n\n优势分析:\n应届生但具备完整新媒体实战经验，有抖音直播从0到1运营经验（10+场直播、单场2000+观看、涨粉800+），熟练使用剪映剪辑，数据驱动意识强（Excel/SPSS/Power BI），英语能力可支撑未来国际化业务探索，校级团队管理经验体现执行力与跨部门协作能力。\n\n风险点:\n无母婴行业经验，需验证对母婴话题的感知力；实习时间均仅1-2个月，稳定性存疑；无公众号运营直接经验，排版能力未验证；无主动\"拓客\"获取销售线索的经历，更多是内容运营而非线索转化。\n\n能力维度匹配:\n1. **平台拓客能力：2/5分。依据：有抖音直播与内容运营经验，但无主动私信获客、获取联系方式并转交销售的直接经历，属于内容涨粉而非销售线索拓客。**\n2. **视频制作能力：4/5分。依据：独立完成脚本、出镜、拍摄、剪辑全流程，10+场直播经验，熟悉剪映，有\"汉服游园\"等主题策划案例，但缺母婴垂类内容验证。**\n3. **公号运营能力：2/5分。依据：简历未提及公众号运营经验，仅标注\"文案创作\"能力，排版与专业内容转化能力无直接证据。**\n4. **直播执行能力：4/5分。依据：独立负责抖音直播全流程，有出镜互动、场控、数据分析经验，单场2000+观看，但缺\"辅助场控\"及访谈/答疑类直播形式经验。**\n5. **抗压学习能力：4/5分。依据：专业前10%、快速到岗、多工具自学（Power BI/SPSS）、跨专业实习（国贸转运营），但需验证结果导向的目标感与母婴行业兴趣真实性。**\n\n面试问题:\n1. 你提到实习周期较短（1-2个月），如果加入天鹅到家后需要至少稳定1年以上，你会如何规划自己的职业发展来确保稳定性？\n2. 在景区直播时",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "新媒体运营（双休+五险一金）",
    "interviewQ": "1. 你提到实习周期较短（1-2个月），如果加入天鹅到家后需要至少稳定1年以上，你会如何规划自己的职业发展来确保稳定性？\n2. 在景区直播时，你如何处理过游客的负面反馈或突发状况？请举例说明你的沟通方式和结果。\n3. 你同时负责内容创作、用户服务、现场协调多项工作，当任务冲突时，你如何优先级排序并确保交付质量？\n4. 假设需要你为天鹅到家策划一条\"月嫂服务\"抖音短视频，目标获取准妈妈线索，你会如何设计选题、钩子与转化路径？\n5. 请现场口述或手写一段公众号推文开头：将\"月嫂需持有育婴师证、健康证、背景调查合格\"等专业要求，转化为有温度、吸引准妈妈阅读的文字。",
    "capabilityMatch": "1. **平台拓客能力：2/5分。依据：有抖音直播与内容运营经验，但无主动私信获客、获取联系方式并转交销售的直接经历，属于内容涨粉而非销售线索拓客。**\n2. **视频制作能力：4/5分。依据：独立完成脚本、出镜、拍摄、剪辑全流程，10+场直播经验，熟悉剪映，有\"汉服游园\"等主题策划案例，但缺母婴垂类内容验证。**\n3. **公号运营能力：2/5分。依据：简历未提及公众号运营经验，仅标注\"文案创作\"能力，排版与专业内容转化能力无直接证据。**\n4. **直播执行能力：4/5分。依据：独立负责抖音直播全流程，有出镜互动、场控、数据分析经验，单场2000+观看，但缺\"辅助场控\"及访谈/答疑类直播形式经验。**\n5. **抗压学习能力：4/5分。依据：专业前10%、快速到岗、多工具自学（Power BI/SPSS）、跨专业实习（国贸转运营），但需验证结果导向的目标感与母婴行业兴趣真实性。**",
    "created": ""
  },
  {
    "id": 47,
    "name": "张米佳",
    "role": "新媒体运营",
    "company": "流量运营部",
    "years": 0,
    "edu": "设计专业在读",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "张",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "具备完整新媒体技能栈（PS/AI/PR/AE/剪映），有TikTok AI视频制作与小红书运营实战经验，广告赛事获奖体现内容创意能力；设计专业背景契合家政服务数字化视觉呈现需求。",
    "risks": "实习时间存在异常重叠（2024.06-2025.09与2025.11-2025.03），稳定性存疑；无母婴/家政/本地生活行业经验，母婴话题感知力未经检验；无公众号运营与直播执行相关经历，两项核心技能缺失；当前为在读状态（2024.09-2026.06），需确认到岗时间与实习/全职性质。",
    "aiEval": "以下为候选人的 新媒体运营 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：新媒体运营（双休+五险一金）\n🏢 招聘岗位：新媒体运营\n\n初筛结果: 淘汰\n\n优势分析:\n具备完整新媒体技能栈（PS/AI/PR/AE/剪映），有TikTok AI视频制作与小红书运营实战经验，广告赛事获奖体现内容创意能力；设计专业背景契合家政服务数字化视觉呈现需求。\n\n风险点:\n实习时间存在异常重叠（2024.06-2025.09与2025.11-2025.03），稳定性存疑；无母婴/家政/本地生活行业经验，母婴话题感知力未经检验；无公众号运营与直播执行相关经历，两项核心技能缺失；当前为在读状态（2024.09-2026.06），需确认到岗时间与实习/全职性质。\n\n能力维度匹配:\n1. **平台拓客能力：1/5分。依据：简历提及\"小红书运营\"但未描述主动拓客、私信获客、线索转化等行为，无获取客户联系方式及转交销售的具体经验。\n2. **视频制作能力：4/5分。依据：精通剪映/PR/AE等工具，有TikTok AI视频制作、广告视频创作及定格动画经验，具备独立完成拍摄剪辑能力；缺母婴话题感知力实证。\n3. **公号运营能力：2/5分。依据：有\"推文撰写\"经历但未明确公众号运营，无排版工具（如秀米/135）使用描述，缺乏将专业内容转化为有温度文字的实证。\n4. **直播执行能力：0/5分。依据：简历无任何直播执行、场控、连麦等经验描述，完全空白。\n5. **抗压学习能力：3/5分。依据：自我评价称\"抗压能力优秀\"\"乐于尝试新鲜事物\"，但实习时间异常、学业并行可能分散精力，结果导向的目标感无实证。\n\n面试问题:\n1. 你简历中两份实习时间（2024.06-2025.09及2025.11-2025.03）均超出当前时间，请具体说明实际实习起止时间、每周出勤天数及是否已离职？\n2. 在TikTok或小",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "新媒体运营（双休+五险一金）",
    "interviewQ": "1. 你简历中两份实习时间（2024.06-2025.09及2025.11-2025.03）均超出当前时间，请具体说明实际实习起止时间、每周出勤天数及是否已离职？\n2. 在TikTok或小红书运营中，请描述一次你主动与陌生用户互动并最终获取其联系方式的具体案例，当时的目标用户画像是什么？\n3. 你目前仍在衢州学院就读（2024.09入学），如何平衡学业与全职工作？若入职后需每周参与3场直播，你的时间安排方案是什么？\n4. 请现场口述：若需为天鹅到家策划一条\"月嫂服务\"短视频，你的选题角度、拍摄场景及剪辑节奏设计是什么？\n5. 假设需将一篇《新生儿黄疸护理指南》专业文章转化为公众号推文，你会如何调整标题、开头及结构以增强\"有温度\"的阅读体验？",
    "capabilityMatch": "1. **平台拓客能力：1/5分。依据：简历提及\"小红书运营\"但未描述主动拓客、私信获客、线索转化等行为，无获取客户联系方式及转交销售的具体经验。\n2. **视频制作能力：4/5分。依据：精通剪映/PR/AE等工具，有TikTok AI视频制作、广告视频创作及定格动画经验，具备独立完成拍摄剪辑能力；缺母婴话题感知力实证。\n3. **公号运营能力：2/5分。依据：有\"推文撰写\"经历但未明确公众号运营，无排版工具（如秀米/135）使用描述，缺乏将专业内容转化为有温度文字的实证。\n4. **直播执行能力：0/5分。依据：简历无任何直播执行、场控、连麦等经验描述，完全空白。\n5. **抗压学习能力：3/5分。依据：自我评价称\"抗压能力优秀\"\"乐于尝试新鲜事物\"，但实习时间异常、学业并行可能分散精力，结果导向的目标感无实证。",
    "created": ""
  },
  {
    "id": 48,
    "name": "胡芷嘉",
    "role": "新媒体运营",
    "company": "流量运营部",
    "years": 0,
    "edu": "在校生",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "胡",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "数字媒体技术专业背景，GPA 3.8/前10%，掌握PR/AE/剪映等全套视频工具链；有AI剪辑+直播运营+公众号运营三段垂直经历，具备\"选题-拍摄-剪辑-发布\"内容闭环能力；学习委员+策展助理经历体现统筹执行力，契合家政服务数字化、标准化运营需求。",
    "risks": "1. 简历时间线混乱（2025.11-2026年实习为未来时段），3年工作年限与2026年毕业时间矛盾，诚信存疑；\n2. 零母婴/本地生活/家政行业经验，\"温度内容\"转化能力未验证；\n3. 4段实习跨度大（AI剪辑/电商运营/美工/直播），稳定性与职业聚焦度待考察。",
    "aiEval": "以下为候选人的 新媒体运营 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：新媒体运营（双休+五险一金）\n🏢 招聘岗位：新媒体运营\n\n初筛结果: 存疑\n\n优势分析:\n数字媒体技术专业背景，GPA 3.8/前10%，掌握PR/AE/剪映等全套视频工具链；有AI剪辑+直播运营+公众号运营三段垂直经历，具备\"选题-拍摄-剪辑-发布\"内容闭环能力；学习委员+策展助理经历体现统筹执行力，契合家政服务数字化、标准化运营需求。\n\n风险点:\n简历时间线混乱（2025.11-2026年实习为未来时段），3年工作年限与2026年毕业时间矛盾，诚信存疑；零母婴/本地生活/家政行业经验，\"温度内容\"转化能力未验证；4段实习跨度大（AI剪辑/电商运营/美工/直播），稳定性与职业聚焦度待考察。\n\n能力维度匹配:\n1. **平台拓客能力：2/5分。依据：仅有\"参与社媒内容输出\"泛化描述，无主动私信获客、线索转化等直接证据，电商运营经历侧重商品上架而非用户挖掘。\n2. **视频制作能力：4/5分。依据：AI剪辑实习明确\"批量生成视频素材+基础剪辑+字幕包装\"，掌握PR/AE/剪映/C4D等工具，但缺母婴题材作品及\"温度瞬间\"捕捉案例。\n3. **公号运营能力：3/5分。依据：\"三下乡\"公众号独立发表多篇推文，有基础排版经验；但内容为学生志愿活动，未体现\"专业内容转温度文字\"的母婴/服务类场景。\n4. **直播执行能力：3/5分。依据：直播运营实习涵盖\"策划执行+数据跟踪+社媒宣传\"，但职责侧重主播协助与流程优化，无明确场控/连麦/访谈等具体形式经验。\n5. **抗压学习能力：3/5分。依据：自我评价强调\"结果导向、学习能力强、积极进取\"，但无量化目标达成案例；对母婴行业兴趣仅为求职意向，无 prior 接触证据。\n\n面试问题:\n1. 你简历中工作年限写3年但2026年才毕业，时间线存在矛盾，请具体说",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "新媒体运营（双休+五险一金）",
    "interviewQ": "1. 你简历中工作年限写3年但2026年才毕业，时间线存在矛盾，请具体说明每段经历的真实起止时间与工作性质（全职/兼职/实习）？\n2. 描述一次你主动在社交平台（如小红书/抖音）与陌生用户建立联系并最终达成目标的经历，当时如何破冰、跟进、转化？\n3. 作为在校生，如果课业与直播排期（每周3场固定时段）冲突，你过往如何处理类似多线程压力？\n4. 请现场分析一个天鹅到家月嫂服务的小红书爆款笔记结构，并模拟撰写一条针对孕晚期用户的私信话术，要求自然获取预产期+微信。\n5. 展示你独立拍摄剪辑的最满意作品（非AI生成），说明选题逻辑、拍摄设备、剪辑时长，并指出如果改为母婴主题会如何调整？",
    "capabilityMatch": "1. **平台拓客能力：2/5分。依据：仅有\"参与社媒内容输出\"泛化描述，无主动私信获客、线索转化等直接证据，电商运营经历侧重商品上架而非用户挖掘。\n2. **视频制作能力：4/5分。依据：AI剪辑实习明确\"批量生成视频素材+基础剪辑+字幕包装\"，掌握PR/AE/剪映/C4D等工具，但缺母婴题材作品及\"温度瞬间\"捕捉案例。\n3. **公号运营能力：3/5分。依据：\"三下乡\"公众号独立发表多篇推文，有基础排版经验；但内容为学生志愿活动，未体现\"专业内容转温度文字\"的母婴/服务类场景。\n4. **直播执行能力：3/5分。依据：直播运营实习涵盖\"策划执行+数据跟踪+社媒宣传\"，但职责侧重主播协助与流程优化，无明确场控/连麦/访谈等具体形式经验。\n5. **抗压学习能力：3/5分。依据：自我评价强调\"结果导向、学习能力强、积极进取\"，但无量化目标达成案例；对母婴行业兴趣仅为求职意向，无 prior 接触证据。",
    "created": ""
  },
  {
    "id": 49,
    "name": "陈含笑",
    "role": "新媒体运营",
    "company": "流量运营部",
    "years": 0,
    "edu": "2026年6月毕业在校生，应届生",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "陈",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "候选人具备从0到1搭建小红书账号经验，1个月粉丝增长200+，单条爆款7.6w播放，熟悉抖音/小红书平台规则与流量逻辑；有保险行业抖音运营获客经验，直接获客咨询50+次，验证了其线上拓客与转化能力；掌握Pr/剪映/飞瓜数据等工具，可独立完成选题-创作-优化闭环，适配天鹅到家数字化运营需求。",
    "risks": "简历显示2026年6月才毕业，当前仍为在校生，实习经历时间线存在矛盾（2025.04-2025.06、2026.03-2026.04），稳定性存疑；无母婴/家政行业经验，对\"有温度的母婴内容\"感知力未经证实；杭州求职但无本地生活运营经验，区域用户洞察需验证。",
    "aiEval": "以下为候选人的 新媒体运营 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：新媒体运营（双休+五险一金）\n🏢 招聘岗位：新媒体运营\n\n初筛结果: 通过\n\n优势分析:\n候选人具备从0到1搭建小红书账号经验，1个月粉丝增长200+，单条爆款7.6w播放，熟悉抖音/小红书平台规则与流量逻辑；有保险行业抖音运营获客经验，直接获客咨询50+次，验证了其线上拓客与转化能力；掌握Pr/剪映/飞瓜数据等工具，可独立完成选题-创作-优化闭环，适配天鹅到家数字化运营需求。\n\n风险点:\n简历显示2026年6月才毕业，当前仍为在校生，实习经历时间线存在矛盾（2025.04-2025.06、2026.03-2026.04），稳定性存疑；无母婴/家政行业经验，对\"有温度的母婴内容\"感知力未经证实；杭州求职但无本地生活运营经验，区域用户洞察需验证。\n\n能力维度匹配:\n1. **平台拓客能力：4/5分。依据：平安保险抖音运营中通过评论区答疑+私信引导直接获客咨询50+次，转化率提升30%，具备主动获客与线索转化经验；小红书0到1起号经验验证平台运营能力。但无明确\"获取预产期+联系方式\"等母婴线索经验。\n2. **视频制作能力：3.5/5分。依据：独立完成15条保险科普视频全流程制作（选题、脚本、拍摄、剪辑），使用Pr/剪映工具熟练；有爆款案例（7.6w播放）。但无母婴题材视频经验，\"有温度内容\"感知力待验证。\n3. **公号运营能力：3/5分。依据：负责学院公众号运营，单篇最高阅读3000+，推动整体阅读量提升20%；具备秀米排版能力。但缺乏将\"专业内容转化为有温度文字\"的明确案例，母婴/家政类文案经验空白。\n4. **直播执行能力：2.5/5分。依据：有主播助理经验，参与直播设备调试、后台操作、数据记录，协助优化内容节奏。但仅1个月短期经验，未独立负责场控，无母婴直播（月嫂访谈、育儿答疑等）经验，",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "新媒体运营（双休+五险一金）",
    "interviewQ": "1. 在平安保险抖音运营中，你提到通过私信引导获客50+次，能否具体描述一次你处理用户抗拒或质疑的场景？你是如何建立信任并最终获取联系方式的？\n2. 小红书运营中你策划了《日本核污水排放》爆款视频，这类热点内容与用户评论中可能出现争议，你如何处理负面评论或情绪激动的用户？请举例说明。\n3. 简历显示你2026年6月毕业，目前课程安排如何？如果加入天鹅到家，能否保证每周参与3场直播及日常拓客工作的时间投入？过往如何平衡学业与实习冲突？\n4. 天鹅到家的用户多为孕期或新手妈妈，需要\"有温度\"的内容。请现场构思一个针对\"月嫂面试避坑\"主题的抖音视频脚本（1分钟内），并说明如何体现温度感与专业性。\n5. 小红书对私信导流有严格限制，你过往如何规避封号风险获取用户联系方式？如果平台规则收紧，你有哪些备选获客策略？",
    "capabilityMatch": "1. **平台拓客能力：4/5分。依据：平安保险抖音运营中通过评论区答疑+私信引导直接获客咨询50+次，转化率提升30%，具备主动获客与线索转化经验；小红书0到1起号经验验证平台运营能力。但无明确\"获取预产期+联系方式\"等母婴线索经验。\n2. **视频制作能力：3.5/5分。依据：独立完成15条保险科普视频全流程制作（选题、脚本、拍摄、剪辑），使用Pr/剪映工具熟练；有爆款案例（7.6w播放）。但无母婴题材视频经验，\"有温度内容\"感知力待验证。\n3. **公号运营能力：3/5分。依据：负责学院公众号运营，单篇最高阅读3000+，推动整体阅读量提升20%；具备秀米排版能力。但缺乏将\"专业内容转化为有温度文字\"的明确案例，母婴/家政类文案经验空白。\n4. **直播执行能力：2.5/5分。依据：有主播助理经验，参与直播设备调试、后台操作、数据记录，协助优化内容节奏。但仅1个月短期经验，未独立负责场控，无母婴直播（月嫂访谈、育儿答疑等）经验，频次与深度不足。\n5. **抗压学习能力：4/5分。依据：自我评价明确\"接受结果导向工作节奏\"，2年持续运营经验体现目标感；主动学习飞瓜数据、SPSS等工具，对杭州互联网/本地生活行业持续关注。但应届生身份下学业与实习平衡压力未说明。",
    "created": ""
  },
  {
    "id": 50,
    "name": "memory",
    "role": "母婴销售代表",
    "company": "",
    "years": 0,
    "edu": "会计金融",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "m",
    "dept": "",
    "city": "苏州",
    "age": "无",
    "gender": "无",
    "strengths": "候选人仅2年工作经验，具备基础客户开发维护能力（课程顾问岗位涉及家长邀约、老生维护），学习能力和吃苦耐劳特质可迁移至服务标准化执行。但优势与母婴销售/家政业务关联度极低。",
    "risks": "严重岗位错配——简历明确求职意向为\"淘宝运营\"，期望薪资5-10K，与母婴销售代表岗位（4-5K）及线下地推/服务销售属性完全不符；教育背景为会计金融，无母婴、家政、护理相关经验；职业稳定性存疑（课程顾问转淘宝运营意向）。",
    "aiEval": "以下为候选人的 母婴销售代表 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：母婴销售代表\n🏢 招聘岗位：母婴销售代表\n\n初筛结果: 淘汰\n\n优势分析:\n候选人仅2年工作经验，具备基础客户开发维护能力（课程顾问岗位涉及家长邀约、老生维护），学习能力和吃苦耐劳特质可迁移至服务标准化执行。但优势与母婴销售/家政业务关联度极低。\n\n风险点:\n严重岗位错配——简历明确求职意向为\"淘宝运营\"，期望薪资5-10K，与母婴销售代表岗位（4-5K）及线下地推/服务销售属性完全不符；教育背景为会计金融，无母婴、家政、护理相关经验；职业稳定性存疑（课程顾问转淘宝运营意向）。\n\n能力维度匹配:\n1. **客户开发能力：2/5分。依据：仅有教育行业课程顾问经验，未体现家政/母婴客户资源开发或B端/C端服务销售经验，行业场景差异大。**\n2. **沟通协调能力：2/5分。依据：有家长沟通经验，但面向成人家长的教培场景与母婴家庭服务销售场景差异显著，未体现复杂客诉处理或高客单价转化能力。**\n3. **抗压与执行力：3/5分。依据：自述\"吃苦耐劳\"，但无具体业绩数据或高强度工作场景佐证；课程顾问岗位通常有业绩压力，可部分迁移。**\n4. **行业认知与专业度：0/5分。依据：零母婴护理、家政服务、产后康复等相关知识或经验，无数字化平台运营背景，与天鹅到家业务核心需求脱节。**\n5. **职业稳定性：1/5分。依据：求职意向与岗位方向完全背离，期望薪资高于岗位上限，存在入职后快速流失或转岗风险。**\n\n面试问题:\n1. 你简历中求职意向为淘宝运营，是什么原因让你考虑母婴销售代表这个线下销售岗位？请具体说明职业规划的转变逻辑。\n2. 课程顾问工作中，描述一次你成功转化犹豫期家长的具体过程，你用了哪些策略建立信任并推动决策？\n3. 你的期望薪资是5-10K，该岗位底薪+绩效结构为4-5K，且前期需3-",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "母婴销售代表",
    "interviewQ": "1. 你简历中求职意向为淘宝运营，是什么原因让你考虑母婴销售代表这个线下销售岗位？请具体说明职业规划的转变逻辑。\n2. 课程顾问工作中，描述一次你成功转化犹豫期家长的具体过程，你用了哪些策略建立信任并推动决策？\n3. 你的期望薪资是5-10K，该岗位底薪+绩效结构为4-5K，且前期需3-6个月积累期，你如何评估这一落差？\n4. 请简述你对母婴家政服务行业的理解：认为当前新手妈妈在选择月嫂/育儿嫂时最关注的三个因素是什么？\n5. 假设一位客户认为\"请月嫂不如让婆婆照顾，省钱又放心\"，你会如何回应并挖掘其真实需求？",
    "capabilityMatch": "1. **客户开发能力：2/5分。依据：仅有教育行业课程顾问经验，未体现家政/母婴客户资源开发或B端/C端服务销售经验，行业场景差异大。**\n2. **沟通协调能力：2/5分。依据：有家长沟通经验，但面向成人家长的教培场景与母婴家庭服务销售场景差异显著，未体现复杂客诉处理或高客单价转化能力。**\n3. **抗压与执行力：3/5分。依据：自述\"吃苦耐劳\"，但无具体业绩数据或高强度工作场景佐证；课程顾问岗位通常有业绩压力，可部分迁移。**\n4. **行业认知与专业度：0/5分。依据：零母婴护理、家政服务、产后康复等相关知识或经验，无数字化平台运营背景，与天鹅到家业务核心需求脱节。**\n5. **职业稳定性：1/5分。依据：求职意向与岗位方向完全背离，期望薪资高于岗位上限，存在入职后快速流失或转岗风险。**",
    "created": ""
  },
  {
    "id": 51,
    "name": "庞佳楠",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "UCL教育学硕士，硕士在读（2024.09-2025.12），预计2025年底毕业",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "庞",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "UCL教育学硕士背景，具备小红书内容商业化运营与环球雅思用户社群运营双重经验，擅长用户分层、数据追踪与跨部门协同；自媒体运营经历证明其内容敏感度与执行力，与家政服务数字化、标准化运营高度契合。",
    "risks": "1. 硕士在读（2024.09-2025.12），预计2025年底毕业，实习仅2个月（2025.11-2025.12），稳定性存疑；\n2. 缺乏家政/本地生活行业经验，对服务者管理、履约场景理解有限；\n3. 薪资期望6-8K与高学历背景可能存在落差。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\nUCL教育学硕士背景，具备小红书内容商业化运营与环球雅思用户社群运营双重经验，擅长用户分层、数据追踪与跨部门协同；自媒体运营经历证明其内容敏感度与执行力，与家政服务数字化、标准化运营高度契合。\n\n风险点:\n硕士在读（2024.09-2025.12），预计2025年底毕业，实习仅2个月（2025.11-2025.12），稳定性存疑；缺乏家政/本地生活行业经验，对服务者管理、履约场景理解有限；薪资期望6-8K与高学历背景可能存在落差。\n\n能力维度匹配:\n1. **社群运营能力：4/5分。依据：环球雅思期间完成80名用户分层运营，搭建全周期数据追踪表，课程好评率超95%；小红书期间输出5套封面模板、3套高转化文案，具备标准化运营思维。\n2. **数据处理能力：3/5分。依据：创建用户全周期数据追踪表监控出勤率与测试成绩，输出《竞品基础体验报告》；但未明确提及每日报表输出经验，SPSS技能存在但应用场景未详述。\n3. **渠道管理能力：2/5分。依据：无直接转介绍渠道管理经验；小红书达人挖掘（20+潜力创作者）与线索录入场景差异较大，缺乏线索流转、返佣规则执行等家政行业特定经验。\n4. **协作沟通能力：4/5分。依据：雅思教育中心期间协同教学、销售、教务团队筹备5场进度对齐会，推动效率提升40%；剧社统筹20人跨角色团队，具备多方协调与push能力。\n5. **执行推进能力：4/5分。依据：小红书实习2个月独立完成市场调研、竞品分析、策略方案全链路输出；互联网+大赛带领15人团队完成50+文献汇总与方案落地，主动性突出。\n\n面试问题:\n1. 你在环球雅思处理过最棘手的用户投诉或跨部门冲突是什么？具体如何push",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 你在环球雅思处理过最棘手的用户投诉或跨部门冲突是什么？具体如何push解决？\n2. 小红书实习仅2个月，如果天鹅到家需要至少6个月实习期，你的学业安排如何协调？\n3. 描述一次你发现数据异常后主动追查并优化流程的经历。\n4. 家政服务场景下，阿姨（服务者）与雇主（用户）同时在群，你会如何设计社群规则与答疑机制平衡双方诉求？\n5. 请现场设计一份转介绍渠道线索录入表的关键字段，并说明如何通过数据识别高潜力推荐人。",
    "capabilityMatch": "1. **社群运营能力：4/5分。依据：环球雅思期间完成80名用户分层运营，搭建全周期数据追踪表，课程好评率超95%；小红书期间输出5套封面模板、3套高转化文案，具备标准化运营思维。\n2. **数据处理能力：3/5分。依据：创建用户全周期数据追踪表监控出勤率与测试成绩，输出《竞品基础体验报告》；但未明确提及每日报表输出经验，SPSS技能存在但应用场景未详述。\n3. **渠道管理能力：2/5分。依据：无直接转介绍渠道管理经验；小红书达人挖掘（20+潜力创作者）与线索录入场景差异较大，缺乏线索流转、返佣规则执行等家政行业特定经验。\n4. **协作沟通能力：4/5分。依据：雅思教育中心期间协同教学、销售、教务团队筹备5场进度对齐会，推动效率提升40%；剧社统筹20人跨角色团队，具备多方协调与push能力。\n5. **执行推进能力：4/5分。依据：小红书实习2个月独立完成市场调研、竞品分析、策略方案全链路输出；互联网+大赛带领15人团队完成50+文献汇总与方案落地，主动性突出。",
    "created": ""
  },
  {
    "id": 52,
    "name": "冯伟",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "冯",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "男",
    "strengths": "6年B端产品运营经验，擅长用户分层、活跃度提升与数据驱动运营；具备社群推广、SOP输出、用户答疑等实战经验；有商业化售卖与服务商协作经验，对标准化服务流程理解较深。",
    "risks": "期望薪资14-16K远超岗位6-8K预算；6年经验投递初级专员岗，职级落差大；简历无家政/本地生活行业背景，C端社群运营经验薄弱；稳定性存疑，过往经历多为1-2年跳槽。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 存疑\n\n优势分析:\n6年B端产品运营经验，擅长用户分层、活跃度提升与数据驱动运营；具备社群推广、SOP输出、用户答疑等实战经验；有商业化售卖与服务商协作经验，对标准化服务流程理解较深。\n\n风险点:\n期望薪资14-16K远超岗位6-8K预算；6年经验投递初级专员岗，职级落差大；简历无家政/本地生活行业背景，C端社群运营经验薄弱；稳定性存疑，过往经历多为1-2年跳槽。\n\n能力维度匹配:\n1. **能力1-社群运营能力：2/5分。依据：简历侧重B端产品运营与服务商社群推广，非C端用户日常答疑、氛围维护；无\"规则同步\"\"活动发布\"等具体社群管理描述，场景差异大。\n2. **能力2-数据处理能力：4/5分。依据：每日输出报表、追踪关键指标、双周复盘等经验丰富；擅长用户分层、活跃度分析、根因分析，与JD\"更新线索进度、渠道达成\"高度匹配。\n3. **能力3-渠道管理能力：3/5分。依据：有服务商渠道合作、商业化推广经验，但\"转介绍渠道\"\"线索录入\"无直接体现；侧重B端生态合作，非C端用户转介绍场景。\n4. **能力4-协作沟通能力：4/5分。依据：跨部门协同（产品经理、研发、行业小二）、友商合作（服务商、生态伙伴）经验丰富；有返佣激励设计、礼品规则制定等商业化协作背景。\n5. **能力5-执行推进能力：3/5分。依据：主动push需求评审、故障复盘、策略迭代等体现执行力；但\"不推诿不拖延\"等基层岗位特质描述较少，更多体现为项目Owner而非执行者角色。\n\n面试问题:\n1. 你曾协调多方资源推进项目时遇到最大阻力是什么？具体如何与研发、业务方沟通解决？\n2. 在数据银行运营中，如何处理头部品牌用户的紧急投诉或负面反馈？请举例说明。\n3. ",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 你曾协调多方资源推进项目时遇到最大阻力是什么？具体如何与研发、业务方沟通解决？\n2. 在数据银行运营中，如何处理头部品牌用户的紧急投诉或负面反馈？请举例说明。\n3. 你过往经历多为1-2年，本次投递专员岗（6-8K）与期望薪资差距较大，能否说明职业规划与选择动机？\n4. 如果雏渐肥社群出现用户质疑服务质量的负面舆情，你会按什么步骤处理？请现场设计一套应对SOP。\n5. 请根据\"转介绍渠道线索录入\"场景，设计一张日报表字段，并说明如何通过数据发现渠道异常？",
    "capabilityMatch": "1. **能力1-社群运营能力：2/5分。依据：简历侧重B端产品运营与服务商社群推广，非C端用户日常答疑、氛围维护；无\"规则同步\"\"活动发布\"等具体社群管理描述，场景差异大。\n2. **能力2-数据处理能力：4/5分。依据：每日输出报表、追踪关键指标、双周复盘等经验丰富；擅长用户分层、活跃度分析、根因分析，与JD\"更新线索进度、渠道达成\"高度匹配。\n3. **能力3-渠道管理能力：3/5分。依据：有服务商渠道合作、商业化推广经验，但\"转介绍渠道\"\"线索录入\"无直接体现；侧重B端生态合作，非C端用户转介绍场景。\n4. **能力4-协作沟通能力：4/5分。依据：跨部门协同（产品经理、研发、行业小二）、友商合作（服务商、生态伙伴）经验丰富；有返佣激励设计、礼品规则制定等商业化协作背景。\n5. **能力5-执行推进能力：3/5分。依据：主动push需求评审、故障复盘、策略迭代等体现执行力；但\"不推诿不拖延\"等基层岗位特质描述较少，更多体现为项目Owner而非执行者角色。",
    "created": ""
  },
  {
    "id": 53,
    "name": "冯唯佳",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无有效学历信息",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "冯",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "无法评估。简历内容仅为乱码字符串（caa36f0da5eb961b1HB92N-_FlRYx4y4UP6XWOChnf7TMhZq等），无任何有效个人信息、教育背景、工作经历或项目经验可供提取。",
    "risks": "简历文件损坏或解析失败，无法验证候选人身份及基本资质；缺乏大专及以上学历证明、社群/用户运营经验等JD硬性要求；存在严重信息不对称风险。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 淘汰\n\n优势分析:\n无法评估。简历内容仅为乱码字符串（caa36f0da5eb961b1HB92N-_FlRYx4y4UP6XWOChnf7TMhZq等），无任何有效个人信息、教育背景、工作经历或项目经验可供提取。\n\n风险点:\n简历文件损坏或解析失败，无法验证候选人身份及基本资质；缺乏大专及以上学历证明、社群/用户运营经验等JD硬性要求；存在严重信息不对称风险，建议要求候选人重新提交标准格式简历。\n\n能力维度匹配:\n1. **社群运营能力：0/5分。依据：简历无社群管理、用户答疑、氛围维护、活动发布等相关经历描述。**\n2. **数据处理能力：0/5分。依据：无数据跟踪、报表输出、指标更新等经验证据。**\n3. **渠道管理能力：0/5分。依据：无转介绍渠道管理、线索录入、营销活动触达等经历。**\n4. **协作沟通能力：0/5分。依据：无与友商、合作部门沟通或跨部门协作案例。**\n5. **执行推进能力：0/5分。依据：无主动跟进问题、push待办事项、高效完成任务的行为事例。**\n\n面试问题:\n1. 请描述一次你在社群运营中处理用户投诉并转化为正面体验的具体案例，当时冲突点是什么，你采取了哪些步骤？\n2. 当你的上级或合作部门未能及时响应你的协作需求时，你如何主动push事项推进？请举例说明沟通策略和结果。\n3. 社群运营工作重复性较高，你过往经历中如何保持长期工作动力？未来1-2年职业规划是什么？\n4. 假设雏渐肥社群中有用户质疑月嫂服务标准与宣传不符，你会如何在群内回应并同步处理流程？请模拟回复话术。\n5. 请说明你会如何设计转介绍渠道的数据追踪表，关键字段包含哪些，如何通过数据发现渠道优化机会？\n\n互动引导语:\n冯",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你在社群运营中处理用户投诉并转化为正面体验的具体案例，当时冲突点是什么，你采取了哪些步骤？\n2. 当你的上级或合作部门未能及时响应你的协作需求时，你如何主动push事项推进？请举例说明沟通策略和结果。\n3. 社群运营工作重复性较高，你过往经历中如何保持长期工作动力？未来1-2年职业规划是什么？\n4. 假设雏渐肥社群中有用户质疑月嫂服务标准与宣传不符，你会如何在群内回应并同步处理流程？请模拟回复话术。\n5. 请说明你会如何设计转介绍渠道的数据追踪表，关键字段包含哪些，如何通过数据发现渠道优化机会？",
    "capabilityMatch": "1. **社群运营能力：0/5分。依据：简历无社群管理、用户答疑、氛围维护、活动发布等相关经历描述。**\n2. **数据处理能力：0/5分。依据：无数据跟踪、报表输出、指标更新等经验证据。**\n3. **渠道管理能力：0/5分。依据：无转介绍渠道管理、线索录入、营销活动触达等经历。**\n4. **协作沟通能力：0/5分。依据：无与友商、合作部门沟通或跨部门协作案例。**\n5. **执行推进能力：0/5分。依据：无主动跟进问题、push待办事项、高效完成任务的行为事例。**",
    "created": ""
  },
  {
    "id": 54,
    "name": "凡朋飞",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "凡",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "33岁",
    "gender": "未提及",
    "strengths": "10年跨行业服务经验，深耕客户全生命周期管理，具备标准化服务执行与复杂客诉处理能力；擅长统筹多方资源、推进流程落地，与天鹅到家家政服务标准化、数字化需求高度契合；数据整合、活动组织、渠道维护等经验可直接迁移。",
    "risks": "年龄33岁与6-8K薪资预期存在落差，需关注职业动机与长期稳定性；无家政/母婴垂直领域经验，行业知识需从零构建；近两份工作间隔短（2020.11-2021.11仅1年），需核实离职原因。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n10年跨行业服务经验，深耕客户全生命周期管理，具备标准化服务执行与复杂客诉处理能力；擅长统筹多方资源、推进流程落地，与天鹅到家家政服务标准化、数字化需求高度契合；数据整合、活动组织、渠道维护等经验可直接迁移。\n\n风险点:\n年龄33岁与6-8K薪资预期存在落差，需关注职业动机与长期稳定性；无家政/母婴垂直领域经验，行业知识需从零构建；近两份工作间隔短（2020.11-2021.11仅1年），需核实离职原因。\n\n能力维度匹配:\n1. **社群运营能力：4/5分。依据：潭州网络课程运营中完成学员群日常运营、学习打卡互动、作业点评、氛围维护，具备社群活跃度提升实操经验；投融界建立客户长效沟通渠道，熟悉规则同步与信息推送。\n2. **数据处理能力：3.5/5分。依据：潭州网络后期统筹部门退款数据整合统计与汇报，投融界完成服务回访反馈收集；但缺乏每日固定报表输出经验，数据复盘深度待验证。\n3. **渠道管理能力：3/5分。依据：投融界负责投融资对接会议统筹、客户资源匹配与常态化跟进，具备渠道线索处理基础；但无明确转介绍渠道管理经验，月度营销活动触达经验不足。\n4. **协作沟通能力：4.5/5分。依据：投融界高频协调客户、资金方、内部多部门，处理黑猫投诉、市长热线、报警等复杂场景；河象网络对接学员家长与教师，多方沟通经验丰富，push能力强。\n5. **执行推进能力：4/5分。依据：投融界独立操盘客户服务全周期，主动摸排退款诉求、拟定解决方案并跟进落地；多份工作经历均体现\"不推诿不拖延\"的问题跟进风格，抗压性与闭环意识突出。\n\n面试问题:\n1. 请描述一次你需要同时协调客户、合作方、内部团队三方利益冲突的经历，具体如",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你需要同时协调客户、合作方、内部团队三方利益冲突的经历，具体如何沟通push达成共识？\n2. 你过往处理过最复杂的客诉场景是什么（如报警、仲裁）？如何平衡客户情绪与公司权益，最终结果如何？\n3. 2020-2021年间换工作较频繁，能否说明原因？对于社群运营专员这个相对基础的岗位，你的职业规划是什么？\n4. 假设社群内有用户质疑天鹅到家保洁服务标准，引发其他用户跟风讨论，你会如何即时响应并维护社群氛围？\n5. 请设计一个简单的转介绍渠道数据跟踪表，需要包含哪些核心字段来支撑月度复盘？",
    "capabilityMatch": "1. **社群运营能力：4/5分。依据：潭州网络课程运营中完成学员群日常运营、学习打卡互动、作业点评、氛围维护，具备社群活跃度提升实操经验；投融界建立客户长效沟通渠道，熟悉规则同步与信息推送。\n2. **数据处理能力：3.5/5分。依据：潭州网络后期统筹部门退款数据整合统计与汇报，投融界完成服务回访反馈收集；但缺乏每日固定报表输出经验，数据复盘深度待验证。\n3. **渠道管理能力：3/5分。依据：投融界负责投融资对接会议统筹、客户资源匹配与常态化跟进，具备渠道线索处理基础；但无明确转介绍渠道管理经验，月度营销活动触达经验不足。\n4. **协作沟通能力：4.5/5分。依据：投融界高频协调客户、资金方、内部多部门，处理黑猫投诉、市长热线、报警等复杂场景；河象网络对接学员家长与教师，多方沟通经验丰富，push能力强。\n5. **执行推进能力：4/5分。依据：投融界独立操盘客户服务全周期，主动摸排退款诉求、拟定解决方案并跟进落地；多份工作经历均体现\"不推诿不拖延\"的问题跟进风格，抗压性与闭环意识突出。",
    "created": ""
  },
  {
    "id": 55,
    "name": "卢俊蕾",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "本科",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "卢",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "未提及",
    "strengths": "具备医美社群运营实操经验，擅长用户答疑、氛围维护与活动转化；数据复盘意识强，沉淀SOP模板；工具熟练度高（有机云、微伴助手等），可快速上手；设计背景助力视觉物料产出，契合家政服务标准化、数字化需求。",
    "risks": "实习时长仅2个月，稳定性存疑；无转介绍渠道管理直接经验；缺乏家政/本地生活行业背景，对服务标准化场景理解需验证；岗位薪资6-8K与本科背景及一线城市成本匹配度待确认。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n具备医美社群运营实操经验，擅长用户答疑、氛围维护与活动转化；数据复盘意识强，沉淀SOP模板；工具熟练度高（有机云、微伴助手等），可快速上手；设计背景助力视觉物料产出，契合家政服务标准化、数字化需求。\n\n风险点:\n实习时长仅2个月，稳定性存疑；无转介绍渠道管理直接经验；缺乏家政/本地生活行业背景，对服务标准化场景理解需验证；岗位薪资6-8K与本科背景及一线城市成本匹配度待确认。\n\n能力维度匹配:\n1. **能力1（社群运营能力）：4/5分。依据：维护300个活跃社群，优化欢迎语与自动回复，重复咨询量降60%；设计\"品牌背书+科普+种草+转化\"内容组合，购买引导满意度96%，具备完整社群运营闭环经验。**\n2. **能力2（数据处理能力）：3.5/5分。依据：每日输出运营数据报表未明确提及，但具备数据复盘意识，整理互动数据、用户反馈，沉淀高转化话术模板，辅助优化策略能力可迁移。**\n3. **能力3（渠道管理能力）：2/5分。依据：简历无转介绍渠道管理、线索录入、月度营销活动触达经验，仅涉及社群端用户运营，渠道端能力为明显缺口。**\n4. **能力4（协作沟通能力）：3.5/5分。依据：跨部门协作描述较少，但具备\"与友商及合作部门沟通\"潜在基础；活动物料需多方配合产出，返佣礼品发放规则性工作未直接验证。**\n5. **能力5（执行推进能力）：4/5分。依据：面对快节奏活动主动压缩物料周期50%，主动发现问题（欢迎语不统一）并优化，自驱力获连续三年奖学金佐证，\"不推诿不拖延\"特质可验证。**\n\n面试问题:\n1. 在天鹅到家社群中，保洁阿姨因订单分配问题在群内表达不满，你会如何处理？请描述具体步骤和沟通话术。\n2",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 在天鹅到家社群中，保洁阿姨因订单分配问题在群内表达不满，你会如何处理？请描述具体步骤和沟通话术。\n2. 请举例说明你曾遇到的最难缠的用户咨询，当时如何解决的？如果换成家政服务场景（如月嫂服务质量投诉），你会调整哪些策略？\n3. 你的实习经历均为3个月左右，天鹅到家希望寻找能长期发展的同学，你如何证明自己能持续投入？未来1-2年职业规划是什么？\n4. 假设需要设计一个\"老用户转介绍新用户得保洁券\"的社群活动，请简述你的活动流程设计、关键数据指标及风险预案。\n5. 家政服务涉及保洁、月嫂、育儿嫂等多品类，你认为不同品类的社群用户（如年轻白领vs新手妈妈）运营策略应有何差异？请结合天鹅到家业务举例说明。\n6. 关于天鹅到家社群运营这个岗位，或者我们团队的工作方式，你有没有什么想了解或确认的？无论是业务挑战、成长空间还是日常协作，都可以聊聊。",
    "capabilityMatch": "1. **能力1（社群运营能力）：4/5分。依据：维护300个活跃社群，优化欢迎语与自动回复，重复咨询量降60%；设计\"品牌背书+科普+种草+转化\"内容组合，购买引导满意度96%，具备完整社群运营闭环经验。**\n2. **能力2（数据处理能力）：3.5/5分。依据：每日输出运营数据报表未明确提及，但具备数据复盘意识，整理互动数据、用户反馈，沉淀高转化话术模板，辅助优化策略能力可迁移。**\n3. **能力3（渠道管理能力）：2/5分。依据：简历无转介绍渠道管理、线索录入、月度营销活动触达经验，仅涉及社群端用户运营，渠道端能力为明显缺口。**\n4. **能力4（协作沟通能力）：3.5/5分。依据：跨部门协作描述较少，但具备\"与友商及合作部门沟通\"潜在基础；活动物料需多方配合产出，返佣礼品发放规则性工作未直接验证。**\n5. **能力5（执行推进能力）：4/5分。依据：面对快节奏活动主动压缩物料周期50%，主动发现问题（欢迎语不统一）并优化，自驱力获连续三年奖学金佐证，\"不推诿不拖延\"特质可验证。**",
    "created": ""
  },
  {
    "id": 56,
    "name": "吕腾蛟",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "本科",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "吕",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "具备5000+用户社群运营实战经验，日均处理事件30+起，用户好评率99%；擅长Z世代沟通策略，话术能力突出（蝉联Q3、Q4优秀话术第一）；有储值卡推广及会员社群运营经验，契合家政服务用户留存与转化场景。",
    "risks": "无明确数据报表输出经验，数据处理能力存疑；实习经历集中于游戏、餐饮领域，家政行业认知空白；哈尔滨籍贯+杭州求职，需关注长期稳定性；学历为本科但院校非重点，需验证学习迁移能力。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n具备5000+用户社群运营实战经验，日均处理事件30+起，用户好评率99%；擅长Z世代沟通策略，话术能力突出（蝉联Q3、Q4优秀话术第一）；有储值卡推广及会员社群运营经验，契合家政服务用户留存与转化场景。\n\n风险点:\n无明确数据报表输出经验，数据处理能力存疑；实习经历集中于游戏、餐饮领域，家政行业认知空白；哈尔滨籍贯+杭州求职，需关注长期稳定性；学历为本科但院校非重点，需验证学习迁移能力。\n\n能力维度匹配:\n1. **社群运营能力：4/5分。依据：盛趣游戏5000+用户社群运营，日均处理30+事件，好评率99%；巴奴运营核心会员社群，有活动推送及用户粘性提升经验。\n2. **数据处理能力：2/5分。依据：简历提及\"更新关键指标\"但无具体数据报表输出经验；项目经历有\"信息整合归纳\"但未涉及日常数据跟踪与复盘。\n3. **渠道管理能力：2/5分。依据：无转介绍渠道管理直接经验；海尔开业推广涉及潜在客户拓展，但属地推而非线索录入与系统化管理。\n4. **协作沟通能力：3/5分。依据：三下乡活动独立统筹15人跨区域团队，有资源整合与远程协作经验；盛趣游戏明确\"跨部门协作信息整合\"，但未涉及友商对接。\n5. **执行推进能力：4/5分。依据：三下乡\"独立端对端统筹全流程\"，班长经历牵头20+场志愿活动；巴奴\"主动识别目标客户、打消消费顾虑\"体现主动push特质。\n\n面试问题:\n1. 请描述一次你需要同时协调多个部门或外部合作方完成项目的经历，当时遇到了什么阻力，你是如何推动的？\n2. 游戏用户与家政用户群体差异较大，你如何将过往服务Z世代的经验迁移到服务家庭客户场景？\n3. 你的实习和项目经历多在哈尔滨、杭州两地，",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你需要同时协调多个部门或外部合作方完成项目的经历，当时遇到了什么阻力，你是如何推动的？\n2. 游戏用户与家政用户群体差异较大，你如何将过往服务Z世代的经验迁移到服务家庭客户场景？\n3. 你的实习和项目经历多在哈尔滨、杭州两地，未来2-3年职业规划是否考虑长期深耕家政行业？\n4. 如果让你设计一套社群SOP来触达转介绍用户，你会如何拆解关键节点并设定数据追踪指标？\n5. 家政服务涉及保洁、月嫂、保姆等多品类，假设社群用户对服务标准提出质疑，你会如何响应并维护品牌信任？",
    "capabilityMatch": "1. **社群运营能力：4/5分。依据：盛趣游戏5000+用户社群运营，日均处理30+事件，好评率99%；巴奴运营核心会员社群，有活动推送及用户粘性提升经验。\n2. **数据处理能力：2/5分。依据：简历提及\"更新关键指标\"但无具体数据报表输出经验；项目经历有\"信息整合归纳\"但未涉及日常数据跟踪与复盘。\n3. **渠道管理能力：2/5分。依据：无转介绍渠道管理直接经验；海尔开业推广涉及潜在客户拓展，但属地推而非线索录入与系统化管理。\n4. **协作沟通能力：3/5分。依据：三下乡活动独立统筹15人跨区域团队，有资源整合与远程协作经验；盛趣游戏明确\"跨部门协作信息整合\"，但未涉及友商对接。\n5. **执行推进能力：4/5分。依据：三下乡\"独立端对端统筹全流程\"，班长经历牵头20+场志愿活动；巴奴\"主动识别目标客户、打消消费顾虑\"体现主动push特质。",
    "created": ""
  },
  {
    "id": 57,
    "name": "周展博",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "周",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "29岁+",
    "gender": "男",
    "strengths": "6年客户运营经验，擅长C端需求挖掘与分层管理；具备私域运营、抖音团购等数字化运营经验，契合天鹅到家标准化与数字化方向；有SOP搭建、标准话术沉淀经验，支持服务职业化建设；执行力强，数据与商务统筹能力成熟。",
    "risks": "简历时间线存在异常（2024.05-2026.04），疑似模板错误或未来日期，需核实真实性；过往行业集中于医疗健康，家政服务场景经验空白，行业切换需适应；29岁+6年经验应聘专员岗，职级预期与岗位定位需对齐。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n6年客户运营经验，擅长C端需求挖掘与分层管理；具备私域运营、抖音团购等数字化运营经验，契合天鹅到家标准化与数字化方向；有SOP搭建、标准话术沉淀经验，支持服务职业化建设；执行力强，数据与商务统筹能力成熟。\n\n风险点:\n简历时间线存在异常（2024.05-2026.04），疑似模板错误或未来日期，需核实真实性；过往行业集中于医疗健康，家政服务场景经验空白，行业切换需适应；29岁+6年经验应聘专员岗，职级预期与岗位定位需对齐。\n\n能力维度匹配:\n1. **社群运营能力：4/5分。依据：明确具备\"社群与社区运营\"经验，擅长客户分层管理、内容活动提升粘性、高效触达激活用户，与JD中日常运营、答疑、氛围维护高度匹配。\n2. **数据处理能力：4/5分。依据：熟练数据统计、输出月度报表，能梳理服务SOP并沉淀标准话术，具备数据化管理思维，可支撑每日报表与策略优化需求。\n3. **渠道管理能力：3/5分。依据：有私域运营、抖音团购及门店赋能经验，但未明确提及\"转介绍渠道\"专项管理；线索录入、月度营销活动整理等具体动作需进一步验证。\n4. **协作沟通能力：4/5分。依据：长期担任\"核心对接窗口\"，负责多方协调、合同审核、内部问题处理；具备面对面服务沟通经验，能维护长期信任关系。\n5. **执行推进能力：4/5分。依据：自我评价\"责任心强、做事严谨、执行力强\"，工作描述中多次出现\"确保准确高效\"\"主动跟进\"等关键词，与JD\"不推诿不拖延\"要求一致。\n\n面试问题:\n1. 请描述一次你需要同时对接多个部门（如财务、物流、采购）推进项目的经历，当时遇到了什么阻力，你如何主动push事项落地？\n2. 你提到将复杂工具拆解为简单操",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你需要同时对接多个部门（如财务、物流、采购）推进项目的经历，当时遇到了什么阻力，你如何主动push事项落地？\n2. 你提到将复杂工具拆解为简单操作步骤指导门店运营，能否具体举例说明？如果面对家政阿姨这类文化水平参差不齐的群体，你会如何调整沟通方式？\n3. 你过往6年都在医疗健康行业，现在考虑加入家政服务领域，能分享一下你的职业规划吗？如何看待从\"医疗高客单价\"到\"家政高频低价\"的服务心态转换？\n4. 假设你需要运营一个母婴护理师（月嫂）的微信社群，群内既有阿姨也有客户，你会如何设计群规则、日常内容节奏和活跃度提升策略？\n5. 请现场模拟：一位转介绍客户通过老阿姨推荐添加你微信，咨询\"天鹅到家的保洁和58同城有什么区别\"，请用通俗易懂的语言在3句话内完成首次响应。",
    "capabilityMatch": "1. **社群运营能力：4/5分。依据：明确具备\"社群与社区运营\"经验，擅长客户分层管理、内容活动提升粘性、高效触达激活用户，与JD中日常运营、答疑、氛围维护高度匹配。\n2. **数据处理能力：4/5分。依据：熟练数据统计、输出月度报表，能梳理服务SOP并沉淀标准话术，具备数据化管理思维，可支撑每日报表与策略优化需求。\n3. **渠道管理能力：3/5分。依据：有私域运营、抖音团购及门店赋能经验，但未明确提及\"转介绍渠道\"专项管理；线索录入、月度营销活动整理等具体动作需进一步验证。\n4. **协作沟通能力：4/5分。依据：长期担任\"核心对接窗口\"，负责多方协调、合同审核、内部问题处理；具备面对面服务沟通经验，能维护长期信任关系。\n5. **执行推进能力：4/5分。依据：自我评价\"责任心强、做事严谨、执行力强\"，工作描述中多次出现\"确保准确高效\"\"主动跟进\"等关键词，与JD\"不推诿不拖延\"要求一致。",
    "created": ""
  },
  {
    "id": 58,
    "name": "唐瑞",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "本科在读",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "待定",
    "star": 0,
    "avatar": "唐",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "具备完整社群运营闭环经验（用户分层、话术撰写、IP运营、高客单价转化63%），数据敏感度高（SPSS分析、日报周报输出），擅长跨部门协作与线下活动落地，与天鹅到家标准化、数字化运营需求高度契合。",
    "risks": "本科在读预计2026年6月毕业，实习期仅1-2个月（2026.3-4及2025.11-2026.2），稳定性存疑；无家政/母婴行业背景，需快速学习服务标准；应届生身份对\"责任心强、主动push\"的验证不足。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n具备完整社群运营闭环经验（用户分层、话术撰写、IP运营、高客单价转化63%），数据敏感度高（SPSS分析、日报周报输出），擅长跨部门协作与线下活动落地，与天鹅到家标准化、数字化运营需求高度契合。\n\n风险点:\n本科在读预计2026年6月毕业，实习期仅1-2个月（2026.3-4及2025.11-2026.2），稳定性存疑；无家政/母婴行业背景，需快速学习服务标准；应届生身份对\"责任心强、主动push\"的验证不足。\n\n能力维度匹配:\n1. **社群运营能力：4/5分。依据：两段实习均涉及社群日常管理、话题策划、氛围营造、规则同步，有私域转化实战经验，但未明确提及家政类服务社群运营。\n2. **数据处理能力：4/5分。依据：熟练使用SPSS、输出数据周报、实时监控活动数据优化链路，具备日报/周报习惯；但JD要求的\"每日输出运营数据报表\"强度未完全验证。\n3. **渠道管理能力：3/5分。依据：有用户分层标签管理、拉新活动全流程经验，但未明确涉及\"转介绍渠道\"专属管理，线索录入与月度整理经验未直接体现。\n4. **协作沟通能力：4/5分。依据：多次跨部门协作（技术、采访、播出、影院、工厂），物料发放与资源协调经验丰富，企业微信沟通日均100+条，契合\"友商及合作部门沟通\"要求。\n5. **执行推进能力：3/5分。依据：活动落地完整闭环多，但简历未明确体现\"主动push待办事项、不推诿不拖延\"的冲突场景案例，应届生身份对主动性验证有限。\n\n面试问题:\n1. 请描述一次你在社群运营中遇到用户投诉或负面反馈的经历，具体如何沟通解决？结果如何？\n2. 在\"支付宝种树\"或\"下单赠收纳箱\"活动中，是否遇到过跨部门协作卡点？你",
    "aiScreen": "已入库（人工确认）",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你在社群运营中遇到用户投诉或负面反馈的经历，具体如何沟通解决？结果如何？\n2. 在\"支付宝种树\"或\"下单赠收纳箱\"活动中，是否遇到过跨部门协作卡点？你如何主动push推进？\n3. 你的实习经历集中在2025-2026年，毕业后职业规划是什么？如何看待社群运营岗位与家政行业的结合？\n4. 假设雏渐肥社群中有用户质疑月嫂服务标准，请现场撰写一段安抚话术并说明设计思路。\n5. 请说明你会如何设计转介绍活动的线索录入标签体系，以支撑月度数据复盘？",
    "capabilityMatch": "1. **社群运营能力：4/5分。依据：两段实习均涉及社群日常管理、话题策划、氛围营造、规则同步，有私域转化实战经验，但未明确提及家政类服务社群运营。\n2. **数据处理能力：4/5分。依据：熟练使用SPSS、输出数据周报、实时监控活动数据优化链路，具备日报/周报习惯；但JD要求的\"每日输出运营数据报表\"强度未完全验证。\n3. **渠道管理能力：3/5分。依据：有用户分层标签管理、拉新活动全流程经验，但未明确涉及\"转介绍渠道\"专属管理，线索录入与月度整理经验未直接体现。\n4. **协作沟通能力：4/5分。依据：多次跨部门协作（技术、采访、播出、影院、工厂），物料发放与资源协调经验丰富，企业微信沟通日均100+条，契合\"友商及合作部门沟通\"要求。\n5. **执行推进能力：3/5分。依据：活动落地完整闭环多，但简历未明确体现\"主动push待办事项、不推诿不拖延\"的冲突场景案例，应届生身份对主动性验证有限。",
    "created": ""
  },
  {
    "id": 59,
    "name": "姚静茹",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "2023-2025在读",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "姚",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "20岁",
    "gender": "女",
    "strengths": "3年私域/社群运营实战经验，独立搭建0-1社群体系，擅长用户分层与裂变拉新，单月业绩提升33%；具备数据驱动意识，熟练输出运营报表；有KOC管理与跨平台（美团/饿了么）运营经验，契合天鹅到家数字化、标准化服务场景。",
    "risks": "年龄20岁但标注3年经验（2023-2025在读），时间线存疑；无家政/母婴行业背景，服务标准化认知待验证；2025年6月至今两段工作经历均不足5个月，稳定性需关注。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n3年私域/社群运营实战经验，独立搭建0-1社群体系，擅长用户分层与裂变拉新，单月业绩提升33%；具备数据驱动意识，熟练输出运营报表；有KOC管理与跨平台（美团/饿了么）运营经验，契合天鹅到家数字化、标准化服务场景。\n\n风险点:\n年龄20岁但标注3年经验（2023-2025在读），时间线存疑；无家政/母婴行业背景，服务标准化认知待验证；2025年6月至今两段工作经历均不足5个月，稳定性需关注。\n\n能力维度匹配:\n1. **社群运营能力：4/5分。依据：独立搭建私域社群，策划\"周三福利日\"活动，用户增长20%，日均互动频次提升；负责社群日常维护、文案撰写、氛围营造，与JD中\"用户答疑、活动发布、规则同步\"高度匹配。\n2. **数据处理能力：4/5分。依据：明确提及\"统计并分析销售数据\"\"定期分析社群用户行为、商城销售数据\"，月均业绩15万、外卖月营业额4万等数据量化成果，具备日报输出基础。\n3. **渠道管理能力：3/5分。依据：有KOC合作体系搭建经验（筛选、签约、管理），但无明确\"转介绍渠道线索录入\"经验；社群拉新与裂变经验可迁移，需验证线索管理精细度。\n4. **协作沟通能力：3/5分。依据：有\"供应商拓展\"\"门店稽核汇报\"\"KOC管理体系\"等跨角色协作经验，但缺乏\"友商返佣、礼品发放\"等具体场景；文案功底扎实，沟通表达基础较好。\n5. **执行推进能力：4/5分。依据：简历强调\"主动跟进问题不推诿\"，独立负责多模块（供应链、社群、外卖平台）并行运营，月均业绩稳定输出；但两段短期经历需验证持续执行力。\n\n面试问题:\n1. 你提到2025年6月至今有两段工作经历，能否具体说明每段的离职原因？\n2. 在KO",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 你提到2025年6月至今有两段工作经历，能否具体说明每段的离职原因？\n2. 在KOC管理中，如果遇到合作方拖延执行或拒不配合，你如何主动push推进？请举例说明。\n3. 社群运营中曾遇到用户集中投诉或负面舆情吗？当时如何维护氛围、同步规则并解决问题？\n4. 假设天鹅到家推出\"月嫂转介绍奖励计划\"，你会如何设计社群活动触达高意向用户并追踪线索转化？请简述思路。\n5. 请现场说明：如果每日需输出\"线索进度、渠道达成、社群活跃度\"三类数据报表，你会用Excel设计怎样的表头和自动化公式？",
    "capabilityMatch": "1. **社群运营能力：4/5分。依据：独立搭建私域社群，策划\"周三福利日\"活动，用户增长20%，日均互动频次提升；负责社群日常维护、文案撰写、氛围营造，与JD中\"用户答疑、活动发布、规则同步\"高度匹配。\n2. **数据处理能力：4/5分。依据：明确提及\"统计并分析销售数据\"\"定期分析社群用户行为、商城销售数据\"，月均业绩15万、外卖月营业额4万等数据量化成果，具备日报输出基础。\n3. **渠道管理能力：3/5分。依据：有KOC合作体系搭建经验（筛选、签约、管理），但无明确\"转介绍渠道线索录入\"经验；社群拉新与裂变经验可迁移，需验证线索管理精细度。\n4. **协作沟通能力：3/5分。依据：有\"供应商拓展\"\"门店稽核汇报\"\"KOC管理体系\"等跨角色协作经验，但缺乏\"友商返佣、礼品发放\"等具体场景；文案功底扎实，沟通表达基础较好。\n5. **执行推进能力：4/5分。依据：简历强调\"主动跟进问题不推诿\"，独立负责多模块（供应链、社群、外卖平台）并行运营，月均业绩稳定输出；但两段短期经历需验证持续执行力。",
    "created": ""
  },
  {
    "id": 60,
    "name": "孟鑫睿",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "本科海归",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "孟",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "具备1年以上私域/社群运营实战经验，从0到1搭建会员体系，擅长用户分层与SOP迭代；有酒店高客单价服务经验，契合家政服务标准化、品质化需求；数据驱动意识强，能构建\"洞察-策略-执行-复盘\"闭环。",
    "risks": "工作经历均为6-10个月短周期，稳定性存疑；无家政/本地生活行业背景，需快速学习服务标准；本科海归背景与6-8K薪资预期可能存在落差，需确认职业动机；两段工作经历间隔3个月（2024.5-2024.8），需核实空窗期原因。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n具备1年以上私域/社群运营实战经验，从0到1搭建会员体系，擅长用户分层与SOP迭代；有酒店高客单价服务经验，契合家政服务标准化、品质化需求；数据驱动意识强，能构建\"洞察-策略-执行-复盘\"闭环。\n\n风险点:\n工作经历均为6-10个月短周期，稳定性存疑；无家政/本地生活行业背景，需快速学习服务标准；本科海归背景与6-8K薪资预期可能存在落差，需确认职业动机。\n\n能力维度匹配:\n1. **1. 社群运营能力：4/5分。依据：运营过泛粉群、快闪群、会员群三类社群，迭代多版SOP，首单转化率从8%提升至13%；有每日3-5条朋友圈IP打造及社群话题库搭建经验。**\n2. **2. 数据处理能力：3.5/5分。依据：简历提及\"习惯通过数据分析定位问题\"，但未明确展示每日输出报表的例行工作；有用户分层、客诉优先级策略等数据应用案例，缺具体工具技能描述。**\n3. **3. 渠道管理能力：3/5分。依据：有\"承接公域流量，设计转化路径\"经验，但转介绍渠道管理未直接体现；快职文化咨询工作中涉及线索承接，与JD线索录入、月度整理有迁移空间。**\n4. **4. 协作沟通能力：4/5分。依据：酒店经历明确\"搭建需求-转接-跟进-反馈服务链路\"，实现98%需求解决率；有跨部门协同及与学员1对1沟通转化经验。**\n5. **5. 执行推进能力：4/5分。依据：简历自述\"主动push待办事项\"，酒店工作实现日均销售额提升至2w+的落地结果；但两段工作经历间隔3个月（2024.5-2024.8），需核实空窗期原因。**\n\n面试问题:\n1. 请描述一次你需要协调多个部门解决用户紧急客诉的具体经历，当时各方诉求冲突点是什么，你如何推动达",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你需要协调多个部门解决用户紧急客诉的具体经历，当时各方诉求冲突点是什么，你如何推动达成共识？\n2. 你过往两段工作周期均在半年左右，能否谈谈离职原因？如果加入天鹅到家，你期望至少服务多长时间？\n3. 酒店服务与家政服务都强调\"标准化+个性化\"平衡，请举例说明你如何在SOP框架内，针对高净值用户做出超出预期的服务设计？\n4. 假设你需要为天鹅到家设计一套月嫂/保洁阿姨的转介绍激励社群运营方案，你会如何分层用户、设计触达节奏和转化钩子？\n5. 请现场演示：用Excel或口述方式，设计一张你理解的\"转介绍渠道日运营数据报表\"，需包含哪些核心字段和计算逻辑？",
    "capabilityMatch": "1. **1. 社群运营能力：4/5分。依据：运营过泛粉群、快闪群、会员群三类社群，迭代多版SOP，首单转化率从8%提升至13%；有每日3-5条朋友圈IP打造及社群话题库搭建经验。**\n2. **2. 数据处理能力：3.5/5分。依据：简历提及\"习惯通过数据分析定位问题\"，但未明确展示每日输出报表的例行工作；有用户分层、客诉优先级策略等数据应用案例，缺具体工具技能描述。**\n3. **3. 渠道管理能力：3/5分。依据：有\"承接公域流量，设计转化路径\"经验，但转介绍渠道管理未直接体现；快职文化咨询工作中涉及线索承接，与JD线索录入、月度整理有迁移空间。**\n4. **4. 协作沟通能力：4/5分。依据：酒店经历明确\"搭建需求-转接-跟进-反馈服务链路\"，实现98%需求解决率；有跨部门协同及与学员1对1沟通转化经验。**\n5. **5. 执行推进能力：4/5分。依据：简历自述\"主动push待办事项\"，酒店工作实现日均销售额提升至2w+的落地结果；但两段工作经历间隔3个月（2024.5-2024.8），需核实空窗期原因。**",
    "created": ""
  },
  {
    "id": 61,
    "name": "宋怡非",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "宋",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "用户洞察与共情能力强，擅长捕捉情绪需求建立信任；有社群通知、地推获客经验；自学运营知识并拆解案例，学习转化能力突出；迭代执行习惯与家政服务标准化、数字化需求高度契合。",
    "risks": "无家政行业背景，对母婴/保洁等服务场景认知空白；1年经验跨度分散（教育/电商/军职），稳定性待验证；Excel仅基础公式能力，数据报表输出效率可能不足。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n用户洞察与共情能力强，擅长捕捉情绪需求建立信任；有社群通知、地推获客经验；自学运营知识并拆解案例，学习转化能力突出；迭代执行习惯与家政服务标准化、数字化需求高度契合。\n\n风险点:\n无家政行业背景，对母婴/保洁等服务场景认知空白；1年经验跨度分散（教育/电商/军职），稳定性待验证；Excel仅基础公式能力，数据报表输出效率可能不足。\n\n能力维度匹配:\n1. **社群运营能力：3.5/5分。依据：有小新星\"社群通知\"经验，但非深度运营；用户洞察与共情能力可迁移，缺活动发布、规则同步等具体实践。\n2. **数据处理能力：2.5/5分。依据：Excel仅基础公式与表格整理，无每日报表输出经验；有\"分析归纳、结构化思维\"自评，但缺乏数据跟踪复盘实证。\n3. **渠道管理能力：2/5分。依据：无转介绍渠道管理经验；军职教育有销售开单经历，但属直销非渠道模式，线索录入、月度整理无直接关联。\n4. **协作沟通能力：3.5/5分。依据：多岗位均涉及跨角色协作（助教/客服/销售），被评价\"交代的事放心\"；有\"主动push待办事项\"自评，但缺与友商/合作部门沟通实证。\n5. **执行推进能力：4/5分。依据：经历多次验证——地推无培训仍获客领先、军职首周独立开单、习惯\"小步试探-反馈-迭代\"；责任心与主动性明确匹配JD要求。\n\n面试问题:\n1. 请描述一次你需要同时处理多个客户紧急需求并协调资源解决的经历，当时如何排序优先级并推动结果？\n2. 过往经历中，有没有遇到过客户对服务规则强烈不满的情况？你如何沟通化解并维护关系？\n3. 你的工作经历涉及教育、电商、军职多个领域，选择社群用户运营方向的核心考量是什么？未来2-3年职业",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你需要同时处理多个客户紧急需求并协调资源解决的经历，当时如何排序优先级并推动结果？\n2. 过往经历中，有没有遇到过客户对服务规则强烈不满的情况？你如何沟通化解并维护关系？\n3. 你的工作经历涉及教育、电商、军职多个领域，选择社群用户运营方向的核心考量是什么？未来2-3年职业规划如何？\n4. 假设需要你每日输出社群运营数据报表，你会设计哪些核心指标？如何用Excel实现自动化或提效？\n5. 家政服务涉及保洁、月嫂、育儿嫂等品类，如果让你在社群中向用户推荐转介绍活动，会如何针对不同品类设计话术？",
    "capabilityMatch": "1. **社群运营能力：3.5/5分。依据：有小新星\"社群通知\"经验，但非深度运营；用户洞察与共情能力可迁移，缺活动发布、规则同步等具体实践。\n2. **数据处理能力：2.5/5分。依据：Excel仅基础公式与表格整理，无每日报表输出经验；有\"分析归纳、结构化思维\"自评，但缺乏数据跟踪复盘实证。\n3. **渠道管理能力：2/5分。依据：无转介绍渠道管理经验；军职教育有销售开单经历，但属直销非渠道模式，线索录入、月度整理无直接关联。\n4. **协作沟通能力：3.5/5分。依据：多岗位均涉及跨角色协作（助教/客服/销售），被评价\"交代的事放心\"；有\"主动push待办事项\"自评，但缺与友商/合作部门沟通实证。\n5. **执行推进能力：4/5分。依据：经历多次验证——地推无培训仍获客领先、军职首周独立开单、习惯\"小步试探-反馈-迭代\"；责任心与主动性明确匹配JD要求。",
    "created": ""
  },
  {
    "id": 62,
    "name": "曹圣培",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "金融本科",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "曹",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "未提及",
    "strengths": "金融本科背景具备数据分析基础，熟练使用SQL/SPSS等工具，有CRM系统落地经验；英语六级600+可支持国际化业务；省级奖学金及竞赛获奖体现学习力与抗压性，与天鹅到家数字化运营方向有一定契合。",
    "risks": "简历存在明显异常（2025.10-2026.05的工作时间），无社群/用户运营直接经验，行业背景（汽车零部件、金融咨询）与家政服务场景差异大；3年工作经验应聘6-8K专员岗，动机与稳定性需验证。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 存疑\n\n优势分析:\n金融本科背景具备数据分析基础，熟练使用SQL/SPSS等工具，有CRM系统落地经验；英语六级600+可支持国际化业务；省级奖学金及竞赛获奖体现学习力与抗压性，与天鹅到家数字化运营方向有一定契合。\n\n风险点:\n简历存在明显异常（2025.10-2026.05的工作时间），无社群/用户运营直接经验，行业背景（汽车零部件、金融咨询）与家政服务场景差异大；3年工作经验应聘6-8K专员岗，动机与稳定性需验证。\n\n能力维度匹配:\n1. **社群运营能力：1/5分。依据：简历无社群运营、用户答疑、氛围维护、活动发布等任何相关经验，仅提及\"性格开朗\"属软性描述。**\n2. **数据处理能力：4/5分。依据：明确具备\"搭建标准化数据台账，输出50+份周期性报表\"经验，熟练使用SQL/SPSS/STATA，数据准确率提升至98%+，与JD每日输出运营数据报表高度匹配。**\n3. **渠道管理能力：2/5分。依据：有\"梳理分析3000+条有效商机\"经验，但属市场端线索而非转介绍渠道管理；无用户触达、营销活动整理等社群场景经验。**\n4. **协作沟通能力：3/5分。依据：有\"与友商及合作部门沟通\"间接描述（CRM项目推广、专家库维护），但缺乏返佣发放、礼品管理等具体事务经验；强调\"主动push\"需验证。**\n5. **执行推进能力：3/5分。依据：自我评价提及\"抗压能力强\"，有独立撰写报告、项目交付量团队前10%等结果，但\"主动跟进问题不推诿\"等行为特质缺乏具体案例支撑。**\n\n面试问题:\n1. 你过往经历集中在金融和汽车行业，为什么选择应聘天鹅到家的社群运营岗位？请具体说明你对家政服务行业的理解。\n2. 描述一次你需要同时对",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 你过往经历集中在金融和汽车行业，为什么选择应聘天鹅到家的社群运营岗位？请具体说明你对家政服务行业的理解。\n2. 描述一次你需要同时对接多个部门推进项目的经历，当时遇到了什么阻力，你如何\"主动push\"确保进度？\n3. 你的简历中工作时间显示为2025-2026年，能否澄清一下你的实际工作时间段？近半年你的职业状态是什么？\n4. 假设雏渐肥社群中有用户投诉月嫂服务质量，你会如何在社群内进行答疑和氛围维护？请模拟回复。\n5. 请说明你会如何设计一张\"转介绍渠道线索跟进表\"，需要包含哪些关键字段来支撑每日数据输出？",
    "capabilityMatch": "1. **社群运营能力：1/5分。依据：简历无社群运营、用户答疑、氛围维护、活动发布等任何相关经验，仅提及\"性格开朗\"属软性描述。**\n2. **数据处理能力：4/5分。依据：明确具备\"搭建标准化数据台账，输出50+份周期性报表\"经验，熟练使用SQL/SPSS/STATA，数据准确率提升至98%+，与JD每日输出运营数据报表高度匹配。**\n3. **渠道管理能力：2/5分。依据：有\"梳理分析3000+条有效商机\"经验，但属市场端线索而非转介绍渠道管理；无用户触达、营销活动整理等社群场景经验。**\n4. **协作沟通能力：3/5分。依据：有\"与友商及合作部门沟通\"间接描述（CRM项目推广、专家库维护），但缺乏返佣发放、礼品管理等具体事务经验；强调\"主动push\"需验证。**\n5. **执行推进能力：3/5分。依据：自我评价提及\"抗压能力强\"，有独立撰写报告、项目交付量团队前10%等结果，但\"主动跟进问题不推诿\"等行为特质缺乏具体案例支撑。**",
    "created": ""
  },
  {
    "id": 63,
    "name": "朱亚鹏",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "本科",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "朱",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "男",
    "strengths": "4年用户运营经验，有完整社群SOP搭建与分层运营经验；擅长数据驱动优化，具备日更报表、指标追踪实操；跨部门协作成熟，活动落地与资源协调能力突出；转介绍运营经验丰富，与岗位核心职责高度契合。",
    "risks": "期望薪资9-10K高于JD标注的6-8K，存在薪酬谈判风险；本科背景对大专岗存在overqualified可能；无家政/本地生活行业经验，服务标准化场景需适应；职业空档（2023.11-2024.04）未说明原因。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n4年用户运营经验，有完整社群SOP搭建与分层运营经验；擅长数据驱动优化，具备日更报表、指标追踪实操；跨部门协作成熟，活动落地与资源协调能力突出；转介绍运营经验丰富，与岗位核心职责高度契合。\n\n风险点:\n期望薪资9-10K高于JD标注的6-8K，存在薪酬谈判风险；本科背景对大专岗存在overqualified可能；无家政/本地生活行业经验，服务标准化场景需适应；职业空档（2023.11-2024.04）未说明原因。\n\n能力维度匹配:\n1. **社群运营能力：4/5分。依据：粉笔时期策划打卡闯关、群内带练等活动，单活动触达5000+用户，社群活跃度提升30%-60%，有完整社群SOP制定经验。\n2. **数据处理能力：4/5分。依据：明确提及\"搭建核心指标体系\"\"每日输出运营数据报表\"，基于用户行为数据绘制画像、定位问题并迭代方案。\n3. **渠道管理能力：3.5/5分。依据：五菱时期有客户转介绍运营经验（月均10+台），但侧重C端车主而非渠道端线索录入；无明确转介绍渠道系统管理描述。\n4. **协作沟通能力：4/5分。依据：多次强调\"联动跨部门资源\"\"协调门店、市场等资源\"\"善于跨部门协作\"，有活动返佣类资源协调经验。\n5. **执行推进能力：4/5分。依据：自我评价\"执行力强\"\"目标导向\"\"主动push待办事项\"，个人优势明确提及\"主动跟进问题不推诿\"。\n\n面试问题:\n1. 请描述一次你需要协调多个部门（如市场、门店、财务）共同推进活动的经历，当时遇到了什么阻力，你如何推动解决？\n2. 你的简历显示期望薪资9-10K，而我们岗位预算为6-8K，请谈谈你的薪酬考量，以及什么情况下你愿意调整预期？\n3. 20",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你需要协调多个部门（如市场、门店、财务）共同推进活动的经历，当时遇到了什么阻力，你如何推动解决？\n2. 你的简历显示期望薪资9-10K，而我们岗位预算为6-8K，请谈谈你的薪酬考量，以及什么情况下你愿意调整预期？\n3. 2023年11月至2024年4月期间你的职业状态是什么？这段时间是否影响你对下一份工作的稳定性规划？\n4. 假设你需要运营一个母婴护理师社群，用户主要是新手妈妈，请设计一个7天打卡活动方案来提升活跃度，并说明你会追踪哪些关键数据指标。\n5. 家政服务存在服务非标、用户投诉率高的特点，如果社群内出现用户对保洁服务质量的激烈投诉，你会如何处理并在群内维护品牌形象？",
    "capabilityMatch": "1. **社群运营能力：4/5分。依据：粉笔时期策划打卡闯关、群内带练等活动，单活动触达5000+用户，社群活跃度提升30%-60%，有完整社群SOP制定经验。\n2. **数据处理能力：4/5分。依据：明确提及\"搭建核心指标体系\"\"每日输出运营数据报表\"，基于用户行为数据绘制画像、定位问题并迭代方案。\n3. **渠道管理能力：3.5/5分。依据：五菱时期有客户转介绍运营经验（月均10+台），但侧重C端车主而非渠道端线索录入；无明确转介绍渠道系统管理描述。\n4. **协作沟通能力：4/5分。依据：多次强调\"联动跨部门资源\"\"协调门店、市场等资源\"\"善于跨部门协作\"，有活动返佣类资源协调经验。\n5. **执行推进能力：4/5分。依据：自我评价\"执行力强\"\"目标导向\"\"主动push待办事项\"，个人优势明确提及\"主动跟进问题不推诿\"。",
    "created": ""
  },
  {
    "id": 64,
    "name": "朱嘉炜",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "硕士学历，硕士在读（2024.9-2025.12）",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "朱",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "男",
    "strengths": "具备新媒体矩阵运营经验，熟悉抖音/小红书内容策划与数据分析，有线下活动统筹及观众答疑经历；艺术背景带来视觉表达与创意能力，可提升社群内容质感；硕士学历学习能力强，英语能力利于潜在国际化业务。",
    "risks": "缺乏家政/本地生活服务行业认知，无明确社群运营（微信群/企微等）直接经验；硕士在读（2024.9-2025.12）与岗位全职需求冲突，稳定性存疑；转介绍渠道管理、线索录入等B端运营经验空白，数据报表输出经验未体现。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 存疑\n\n优势分析:\n具备新媒体矩阵运营经验，熟悉抖音/小红书内容策划与数据分析，有线下活动统筹及观众答疑经历；艺术背景带来视觉表达与创意能力，可提升社群内容质感；硕士学历学习能力强，英语能力利于潜在国际化业务。\n\n风险点:\n缺乏家政/本地生活服务行业认知，无明确社群运营（微信群/企微等）直接经验；硕士在读（2024.9-2025.12）与岗位全职需求冲突，稳定性存疑；转介绍渠道管理、线索录入等B端运营经验空白，数据报表输出经验未体现。\n\n能力维度匹配:\n1. **社群运营能力：2/5分。依据：仅有\"观众答疑\"间接相关，无微信群/企微社群日常管理、氛围维护、规则同步等核心经验；新媒体运营侧重内容而非社群运维。**\n2. **数据处理能力：3/5分。依据：有抖音/小红书后台数据分析经验，能优化内容策略；但缺乏\"每日输出运营数据报表\"的系统性报表经验，未体现线索进度跟踪、渠道达成等B端指标管理。**\n3. **渠道管理能力：1/5分。依据：简历无任何转介绍渠道、线索录入、营销活动触达等相关经验，能力缺口明显。**\n4. **协作沟通能力：3/5分。依据：有跨部门协作（布展执行、活动统筹）及多方沟通（观众答疑、友商对接）经验；但缺乏\"返佣/礼品发放\"等商务流程经验，家政行业沟通场景未验证。**\n5. **执行推进能力：3/5分。依据：自述\"做事严谨、主动push待办事项\"，有项目全流程跟进经历；但学业在职状态与全职岗位冲突，实际投入度存疑，需验证时间管理能力。**\n\n面试问题:\n1. 你目前硕士在读，课程安排如何？如果录用，能否保证全职坐班？请举例说明你曾如何平衡学业与高强度实习/工作。\n2. 描述一次你处理大量用户咨询或投诉的经历",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 你目前硕士在读，课程安排如何？如果录用，能否保证全职坐班？请举例说明你曾如何平衡学业与高强度实习/工作。\n2. 描述一次你处理大量用户咨询或投诉的经历，当时用户情绪如何？你用了什么方法安抚并解决问题？\n3. 你的职业规划是偏向艺术领域还是运营方向？如何看待家政服务行业的社群运营工作与你的专业背景差异？\n4. 假设社群内有用户投诉保洁阿姨服务不达标、要求退款，你会如何处理？请分步骤说明沟通话术与升级机制。\n5. 请现场设计一份\"转介绍用户月度触达活动\"的简单方案，包括目标、渠道、激励设置及效果追踪指标。",
    "capabilityMatch": "1. **社群运营能力：2/5分。依据：仅有\"观众答疑\"间接相关，无微信群/企微社群日常管理、氛围维护、规则同步等核心经验；新媒体运营侧重内容而非社群运维。**\n2. **数据处理能力：3/5分。依据：有抖音/小红书后台数据分析经验，能优化内容策略；但缺乏\"每日输出运营数据报表\"的系统性报表经验，未体现线索进度跟踪、渠道达成等B端指标管理。**\n3. **渠道管理能力：1/5分。依据：简历无任何转介绍渠道、线索录入、营销活动触达等相关经验，能力缺口明显。**\n4. **协作沟通能力：3/5分。依据：有跨部门协作（布展执行、活动统筹）及多方沟通（观众答疑、友商对接）经验；但缺乏\"返佣/礼品发放\"等商务流程经验，家政行业沟通场景未验证。**\n5. **执行推进能力：3/5分。依据：自述\"做事严谨、主动push待办事项\"，有项目全流程跟进经历；但学业在职状态与全职岗位冲突，实际投入度存疑，需验证时间管理能力。**",
    "created": ""
  },
  {
    "id": 65,
    "name": "李兰鑫",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "2024.06毕业，法学专业",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "待定",
    "star": 0,
    "avatar": "李",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "具备完整社群运营闭环经验（0-1搭建达人库、用户标签化运营、裂变增长），擅长数据驱动优化（ROI评估、AB测试）。有家政服务相关母婴垂类达人运营经验，与天鹅到家业务场景契合度高。跨部门协作及客户转化能力经多岗位验证。",
    "risks": "工作经历时间线存疑（2025年工作经历与毕业时间2024.06冲突），需核实真实性。法学专业背景与运营岗位关联度低，稳定性待观察。缺乏家政行业一线服务经验，对保洁/月嫂等标准化服务理解可能不足。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n具备完整社群运营闭环经验（0-1搭建达人库、用户标签化运营、裂变增长），擅长数据驱动优化（ROI评估、AB测试）。有家政服务相关母婴垂类达人运营经验，与天鹅到家业务场景契合度高。跨部门协作及客户转化能力经多岗位验证。\n\n风险点:\n工作经历时间线存疑（2025年工作经历与毕业时间2024.06冲突），需核实真实性。法学专业背景与运营岗位关联度低，稳定性待观察。缺乏家政行业一线服务经验，对保洁/月嫂等标准化服务理解可能不足。\n\n能力维度匹配:\n1. **社群运营能力：4/5分。依据：杭州全民共识科技经历中明确\"日常社群运营\"\"用户活跃度90%+\"，含话题引导、入群仪式、激励体系搭建；五颜六色传媒有达人孵化-内容优化闭环经验。**\n2. **数据处理能力：3.5/5分。依据：新东方\"收集并分析市场流量数据\"、五颜六色\"建立视频投放ROI评估体系、AB测试\"，但缺乏\"每日输出运营数据报表\"的固定日报经验。**\n3. **渠道管理能力：3/5分。依据：新东方\"渠道维护、群运营裂变\"、乐凌艺术\"地推/电话/微信私域\"多渠道开发，但无明确\"转介绍渠道\"专属管理经验，线索录入表述模糊。**\n4. **协作沟通能力：4/5分。依据：自我评价强调\"跨部门沟通协作\"，乐凌艺术\"高效对接学员家长\"、新东方\"独立处理客户问题\"、乡村振兴调研\"访谈驻村干部\"，多场景验证沟通能力。**\n5. **执行推进能力：4/5分。依据：自我评价\"面对工作压力保持专注执行\"，多段经历体现结果导向（转化率50%、续费率40%、GMV200W+），但\"主动push待办事项\"的显性证据不足。**\n\n面试问题:\n1. 请描述一次你需要同时对接多个部门推进",
    "aiScreen": "已入库（人工确认）",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你需要同时对接多个部门推进活动的经历，当时遇到了什么阻力，你如何主动push事项落地？\n2. 你的简历中2025年工作经历与毕业时间存在重叠，能否具体说明每段工作的实际起止时间？这期间是否有过空窗期？\n3. 在处理客户投诉或负面反馈时，你通常如何平衡公司规则与客户满意度？请举例说明。\n4. 假设你需要运营一个月嫂/保洁师的社群，这类服务者普遍年龄偏大、数字化程度低，你会如何设计入群仪式和日常活跃机制？\n5. 请现场设计一张转介绍渠道的日报数据报表，需要包含哪些核心指标？你会用什么工具追踪线索从录入到成交的全链路？\n6. 基于你对天鹅到家和社群用户运营专员这个岗位的了解，你有哪些问题想问我？无论是关于我们服务者运营体系的现状、团队的工作节奏，还是这个岗位未来半年的核心挑战，都可以坦诚交流。",
    "capabilityMatch": "1. **社群运营能力：4/5分。依据：杭州全民共识科技经历中明确\"日常社群运营\"\"用户活跃度90%+\"，含话题引导、入群仪式、激励体系搭建；五颜六色传媒有达人孵化-内容优化闭环经验。**\n2. **数据处理能力：3.5/5分。依据：新东方\"收集并分析市场流量数据\"、五颜六色\"建立视频投放ROI评估体系、AB测试\"，但缺乏\"每日输出运营数据报表\"的固定日报经验。**\n3. **渠道管理能力：3/5分。依据：新东方\"渠道维护、群运营裂变\"、乐凌艺术\"地推/电话/微信私域\"多渠道开发，但无明确\"转介绍渠道\"专属管理经验，线索录入表述模糊。**\n4. **协作沟通能力：4/5分。依据：自我评价强调\"跨部门沟通协作\"，乐凌艺术\"高效对接学员家长\"、新东方\"独立处理客户问题\"、乡村振兴调研\"访谈驻村干部\"，多场景验证沟通能力。**\n5. **执行推进能力：4/5分。依据：自我评价\"面对工作压力保持专注执行\"，多段经历体现结果导向（转化率50%、续费率40%、GMV200W+），但\"主动push待办事项\"的显性证据不足。**",
    "created": ""
  },
  {
    "id": 66,
    "name": "李盼盼",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "大专",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "待定",
    "star": 0,
    "avatar": "李",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "23岁",
    "gender": "未提及",
    "strengths": "1年社群运营实战经验，熟悉用户答疑、信息整理与数据反馈闭环；文案策划与创意能力突出，契合社群内容运营需求；性格外向、沟通力强，能快速对接达人/商家等多方角色；自驱力与抗压能力明确，适应家政服务高频响应场景。",
    "risks": "工作经历时间存疑（2025.06-2025.12为未来时段，可能为简历模板误填或虚构）；无明确转介绍渠道管理经验；学前教育背景与家政业务关联度低，行业认知需验证；23岁大专学历，职业稳定性与长期发展意愿待考察。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n1年社群运营实战经验，熟悉用户答疑、信息整理与数据反馈闭环；文案策划与创意能力突出，契合社群内容运营需求；性格外向、沟通力强，能快速对接达人/商家等多方角色；自驱力与抗压能力明确，适应家政服务高频响应场景。\n\n风险点:\n工作经历时间存疑（2025.06-2025.12为未来时段，可能为简历模板误填或虚构）；无明确转介绍渠道管理经验；学前教育背景与家政业务关联度低，行业认知需验证；23岁大专学历，职业稳定性与长期发展意愿待考察。\n\n能力维度匹配:\n1. **社群运营能力：3/5分。依据：有社群文案撰写、用户答疑、氛围维护经验，但未明确提及\"规则同步\"\"活动发布\"等完整社群运营闭环，且经历时间异常。\n2. **数据处理能力：2/5分。依据：提及\"定期分析客户咨询数据\"\"完善信息表格\"，但无每日输出报表、关键指标跟踪的明确经验，数据敏感度未验证。\n3. **渠道管理能力：1/5分。依据：简历未提及转介绍渠道管理、线索录入、月度营销活动整理等任何相关经验，存在明显技能缺口。\n4. **协作沟通能力：4/5分。依据：多次强调\"沟通能力强\"\"擅长对内沟通对接\"\"促进业务推进\"，有协同达人及商家处理问题的经验，与友商沟通有一定基础。\n5. **执行推进能力：4/5分。依据：自述\"执行力与目标精神强\"\"主动跟进问题不推诿\"，有独立负责项目运营、主动push待办事项的特质，符合\"责任心强\"要求。\n\n面试问题:\n1. 请描述一次你与达人或商家产生分歧的经历，当时分歧点是什么？你如何通过沟通推动问题解决？最终结果如何？\n2. 简历提到\"对无法处理的问题进行记录并转交跟进\"，能否举例说明一次你处理的复杂客诉？如何确保客户满意且问",
    "aiScreen": "已入库（人工确认）",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你与达人或商家产生分歧的经历，当时分歧点是什么？你如何通过沟通推动问题解决？最终结果如何？\n2. 简历提到\"对无法处理的问题进行记录并转交跟进\"，能否举例说明一次你处理的复杂客诉？如何确保客户满意且问题真正闭环？\n3. 你的教育背景是学前教育，第一份工作选择了社群运营，能否分享职业转型的思考？未来3年希望在用户运营方向达成什么目标？\n4. 假设雏渐肥社群中有用户频繁发布竞品广告，你会如何依据规则处理？同时怎样避免误伤正常用户、维护社群氛围？\n5. 如果今日转介绍线索量环比下降30%，你会从哪些维度拆解数据？如何快速定位问题并反馈给负责人？",
    "capabilityMatch": "1. **社群运营能力：3/5分。依据：有社群文案撰写、用户答疑、氛围维护经验，但未明确提及\"规则同步\"\"活动发布\"等完整社群运营闭环，且经历时间异常。\n2. **数据处理能力：2/5分。依据：提及\"定期分析客户咨询数据\"\"完善信息表格\"，但无每日输出报表、关键指标跟踪的明确经验，数据敏感度未验证。\n3. **渠道管理能力：1/5分。依据：简历未提及转介绍渠道管理、线索录入、月度营销活动整理等任何相关经验，存在明显技能缺口。\n4. **协作沟通能力：4/5分。依据：多次强调\"沟通能力强\"\"擅长对内沟通对接\"\"促进业务推进\"，有协同达人及商家处理问题的经验，与友商沟通有一定基础。\n5. **执行推进能力：4/5分。依据：自述\"执行力与目标精神强\"\"主动跟进问题不推诿\"，有独立负责项目运营、主动push待办事项的特质，符合\"责任心强\"要求。",
    "created": ""
  },
  {
    "id": 67,
    "name": "江忠诚",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "江",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "男",
    "strengths": "具备社群运营实战经验（10+社群、90%活跃率、500+用户服务），擅长用户答疑、任务监督与情绪调节；有数据复盘意识（学习完成率提升35.6%）；退伍军人背景体现执行力与抗压性，契合家政服务标准化、数字化运营需求。",
    "risks": "实习时间标注异常（2025-2026年未来日期），需核实真实性；无转介绍渠道管理直接经验；短视频运营与家政社群场景差异较大，行业切换需适应期；期望薪资6-8K与岗位定位需确认匹配度。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n具备社群运营实战经验（10+社群、90%活跃率、500+用户服务），擅长用户答疑、任务监督与情绪调节；有数据复盘意识（学习完成率提升35.6%）；退伍军人背景体现执行力与抗压性，契合家政服务标准化、数字化运营需求。\n\n风险点:\n实习时间标注异常（2025-2026年未来日期），需核实真实性；无转介绍渠道管理直接经验；短视频运营与家政社群场景差异较大，行业切换需适应期；期望薪资6-8K与岗位定位需确认匹配度。\n\n能力维度匹配:\n1. **社群运营能力：4/5分。依据：搭建运营10+学习社群，用户答疑、氛围维护、任务发布经验丰富，活跃率90%，但缺乏家政/母婴垂类社群经验。\n2. **数据处理能力：3/5分。依据：协助整理运营数据、形成复盘记录，有基础数据跟踪意识，但未明确提及日报输出及关键指标监控体系化经验。\n3. **渠道管理能力：1/5分。依据：简历无转介绍渠道、线索录入、营销活动触达等相关经验，存在明显技能缺口。\n4. **协作沟通能力：3/5分。依据：与学校老师对接、同步资料、收集诉求并反馈，跨角色沟通经验较丰富，但缺乏友商/合作部门商务沟通场景。\n5. **执行推进能力：4/5分。依据：每日监督学习进展、针对性提醒滞后学生、推动完成率提升35.6%，主动跟进不推诿特质与JD\"主动push待办事项\"高度匹配。\n\n面试问题:\n1. 请描述一次你主动发现并解决社群用户负面情绪或冲突的具体经历，当时采取了哪些步骤？\n2. 在同时对接多所学校、服务500+学生时，如何优先级排序并确保每位用户的需求不被遗漏？请举例说明。\n3. 你的实习经历时间标注为2025-2026年，能否说明具体情况？未来1-2年职业规划",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你主动发现并解决社群用户负面情绪或冲突的具体经历，当时采取了哪些步骤？\n2. 在同时对接多所学校、服务500+学生时，如何优先级排序并确保每位用户的需求不被遗漏？请举例说明。\n3. 你的实习经历时间标注为2025-2026年，能否说明具体情况？未来1-2年职业规划是否倾向长期深耕家政/本地生活赛道？\n4. 假设一位转介绍用户通过老带新活动咨询月嫂服务，但对我们服务标准存疑，请模拟一段社群内的答疑话术。\n5. 如果需要你每日输出社群运营数据报表，你会设计哪些核心指标？如何确保数据准确性并及时发现异常波动？",
    "capabilityMatch": "1. **社群运营能力：4/5分。依据：搭建运营10+学习社群，用户答疑、氛围维护、任务发布经验丰富，活跃率90%，但缺乏家政/母婴垂类社群经验。\n2. **数据处理能力：3/5分。依据：协助整理运营数据、形成复盘记录，有基础数据跟踪意识，但未明确提及日报输出及关键指标监控体系化经验。\n3. **渠道管理能力：1/5分。依据：简历无转介绍渠道、线索录入、营销活动触达等相关经验，存在明显技能缺口。\n4. **协作沟通能力：3/5分。依据：与学校老师对接、同步资料、收集诉求并反馈，跨角色沟通经验较丰富，但缺乏友商/合作部门商务沟通场景。\n5. **执行推进能力：4/5分。依据：每日监督学习进展、针对性提醒滞后学生、推动完成率提升35.6%，主动跟进不推诿特质与JD\"主动push待办事项\"高度匹配。",
    "created": ""
  },
  {
    "id": 68,
    "name": "王思瑶",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "王",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "具备新媒体运营经验（小红书账号运营、内容策划、数据监测），熟悉数据驱动优化；有项目策划经历，涉及任务分配、进度跟进与数据分析，与社群运营所需的执行力和基础数据能力部分契合；沟通与团队协作意识在自我评价中有体现。",
    "risks": "社群运营直接经验缺失（JD要求社群/用户运营经验，简历仅体现新媒体运营）；稳定性存疑（2025.7-2025.9实习仅2个月，且预计2026年7月才毕业，到岗时间与实习周期可能不匹配）；数据处理能力未验证（无Excel/报表实操描述，仅提及\"调研旅游数据\"）；无家政/本地生活行业背景，业务理解需从零建立。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 淘汰\n\n优势分析:\n具备新媒体运营经验（小红书账号运营、内容策划、数据监测），熟悉数据驱动优化；有项目策划经历，涉及任务分配、进度跟进与数据分析，与社群运营所需的执行力和基础数据能力部分契合；沟通与团队协作意识在自我评价中有体现。\n\n风险点:\n社群运营直接经验缺失（JD要求社群/用户运营经验，简历仅体现新媒体运营）；稳定性存疑（2025.7-2025.9实习仅2个月，且预计2026年7月才毕业，到岗时间与实习周期可能不匹配）；数据处理能力未验证（无Excel/报表实操描述，仅提及\"调研旅游数据\"）；无家政/本地生活行业背景，业务理解需从零建立。\n\n能力维度匹配:\n1. **社群运营能力：2/5分。依据：无直接社群运营经验，仅有小红书新媒体运营经历（内容策划、粉丝互动），与用户答疑、氛围维护、规则同步等社群场景差异较大，需验证迁移能力。\n2. **数据处理能力：2/5分。依据：提及\"监测新媒体数据\"\"调研旅游数据\"，但无日报/周报输出、关键指标跟踪、数据报表制作的直接经验，Excel技能仅写\"精通\"无实证。\n3. **渠道管理能力：1/5分。依据：简历完全未涉及转介绍渠道、线索录入、营销活动触达等相关经历，为零经验领域。\n4. **协作沟通能力：3/5分。依据：项目策划中有任务分配、进度跟进经历；新媒体运营需跨部门协作；自我评价强调\"团队精神\"\"沟通技巧\"，但缺乏与友商/合作部门对接的具体案例。\n5. **执行推进能力：3/5分。依据：项目策划中体现进度跟进意识，新媒体运营需高频内容输出；但实习周期仅2个月，且自我评价中\"独立完成工作\"与\"团队精神\"表述矛盾，需验证实际执行风格。\n\n面试问题:\n1. 请描述一次你在运营工作中主",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你在运营工作中主动发现并解决用户投诉或负面反馈的经历，当时如何沟通处理？结果如何？\n2. 你提到项目策划中会根据组员能力分配任务，请举例说明当组员未按时交付时，你如何主动push进度、协调资源？\n3. 你目前预计2026年毕业，如果加入我们需要全职实习或提前到岗，学业与工作的冲突你如何规划？过往有无长期（6个月以上）实习经历？\n4. 假设需要你每日输出社群运营数据报表，你会设计哪些核心指标？请用Excel思路说明如何快速统计社群活跃度、线索转化率。\n5. 家政服务的社群用户（如月嫂/保洁客户）与小红书用户特征差异较大，你认为运营家政社群时，内容策略和互动方式应做哪些调整？",
    "capabilityMatch": "1. **社群运营能力：2/5分。依据：无直接社群运营经验，仅有小红书新媒体运营经历（内容策划、粉丝互动），与用户答疑、氛围维护、规则同步等社群场景差异较大，需验证迁移能力。\n2. **数据处理能力：2/5分。依据：提及\"监测新媒体数据\"\"调研旅游数据\"，但无日报/周报输出、关键指标跟踪、数据报表制作的直接经验，Excel技能仅写\"精通\"无实证。\n3. **渠道管理能力：1/5分。依据：简历完全未涉及转介绍渠道、线索录入、营销活动触达等相关经历，为零经验领域。\n4. **协作沟通能力：3/5分。依据：项目策划中有任务分配、进度跟进经历；新媒体运营需跨部门协作；自我评价强调\"团队精神\"\"沟通技巧\"，但缺乏与友商/合作部门对接的具体案例。\n5. **执行推进能力：3/5分。依据：项目策划中体现进度跟进意识，新媒体运营需高频内容输出；但实习周期仅2个月，且自我评价中\"独立完成工作\"与\"团队精神\"表述矛盾，需验证实际执行风格。",
    "created": ""
  },
  {
    "id": 69,
    "name": "王桃桃",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "专科",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "待定",
    "star": 0,
    "avatar": "王",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "有2个月小红书社群运营实操经验，涵盖内容生产、用户答疑、私信维护等核心动作；海尔经历体现数据记录意识与客户接待经验；技术支持背景培养远程沟通与问题排查能力，契合家政服务数字化场景。",
    "risks": "社群运营经验仅2个月且非家政垂直领域；学历为专科，计算机专业与运营岗位关联度弱；经历时间线存疑（2026年日期），需核实实际毕业与工作时间；缺乏转介绍渠道管理及返佣结算等复杂协作经验。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n有2个月小红书社群运营实操经验，涵盖内容生产、用户答疑、私信维护等核心动作；海尔经历体现数据记录意识与客户接待经验；技术支持背景培养远程沟通与问题排查能力，契合家政服务数字化场景。\n\n风险点:\n社群运营经验仅2个月且非家政垂直领域；学历为专科，计算机专业与运营岗位关联度弱；经历时间线存疑（2026年日期），需核实实际毕业与工作时间；缺乏转介绍渠道管理及返佣结算等复杂协作经验。\n\n能力维度匹配:\n1. **社群运营能力：3/5分。依据：有小红书账号维护、用户答疑、评论私信维护经验，但缺乏活动发布、规则同步、氛围营造的明确证据，且时长较短。\n2. **数据处理能力：2/5分。依据：海尔经历有\"数据实时录入与核对\"，但属生产环境而非运营数据；无\"每日输出报表\"\"复盘优化策略\"的直接经验，需验证转化能力。\n3. **渠道管理能力：1/5分。依据：简历无转介绍渠道管理、线索录入、营销活动触达相关经验，属明显能力缺口。\n4. **协作沟通能力：3/5分。依据：技术支持岗位有跨部门沟通与用户服务经验，海尔有客户接待讲解经历；但无\"友商合作\"\"返佣礼品发放\"等商务协作证据。\n5. **执行推进能力：3/5分。依据：自我评价强调\"主动跟进\"\"不推诿\"\"push待办\"，但工作描述中缺乏主动闭环问题的具体案例，需行为面试验证。\n\n面试问题:\n1. 请描述一次你在社群运营中遇到的棘手用户投诉或冲突，当时如何沟通解决？结果如何？\n2. 海尔客户接待中，曾遇到客户提出超出标准的需求，你如何协调资源或向上反馈的？具体做了什么？\n3. 你的简历时间显示2026年，能否说明实际毕业时间和每段工作的起止月份？未来2-3年职业规划是否倾向长期",
    "aiScreen": "已入库（人工确认）",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你在社群运营中遇到的棘手用户投诉或冲突，当时如何沟通解决？结果如何？\n2. 海尔客户接待中，曾遇到客户提出超出标准的需求，你如何协调资源或向上反馈的？具体做了什么？\n3. 你的简历时间显示2026年，能否说明实际毕业时间和每段工作的起止月份？未来2-3年职业规划是否倾向长期深耕运营？\n4. 若社群内有用户质疑天鹅到家保洁师服务不达标，你会如何在群内回应并引导至私域解决？请模拟回复话术。\n5. 假设本周需完成100个转介绍线索录入+月度活动触达，同时出现数据报表错误需返工，你如何安排优先级并保证交付？",
    "capabilityMatch": "1. **社群运营能力：3/5分。依据：有小红书账号维护、用户答疑、评论私信维护经验，但缺乏活动发布、规则同步、氛围营造的明确证据，且时长较短。\n2. **数据处理能力：2/5分。依据：海尔经历有\"数据实时录入与核对\"，但属生产环境而非运营数据；无\"每日输出报表\"\"复盘优化策略\"的直接经验，需验证转化能力。\n3. **渠道管理能力：1/5分。依据：简历无转介绍渠道管理、线索录入、营销活动触达相关经验，属明显能力缺口。\n4. **协作沟通能力：3/5分。依据：技术支持岗位有跨部门沟通与用户服务经验，海尔有客户接待讲解经历；但无\"友商合作\"\"返佣礼品发放\"等商务协作证据。\n5. **执行推进能力：3/5分。依据：自我评价强调\"主动跟进\"\"不推诿\"\"push待办\"，但工作描述中缺乏主动闭环问题的具体案例，需行为面试验证。",
    "created": ""
  },
  {
    "id": 70,
    "name": "王蓝圻",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "本科在读",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "王",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "具备B端私域社群全周期运营经验，月活跃率90%+；擅长用户答疑、规则同步与满意度提升；有直播引流与数据复盘能力；熟练使用Excel数据核算与报表输出；网感强，契合家政服务数字化运营需求。",
    "risks": "实习经历均为B端（律师/直播），无家政/C端服务经验；期望薪资5-8K高于JD范围；2026年4月实习结束，到岗时间需确认；本科在读未毕业，稳定性存疑。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n具备B端私域社群全周期运营经验，月活跃率90%+；擅长用户答疑、规则同步与满意度提升；有直播引流与数据复盘能力；熟练使用Excel数据核算与报表输出；网感强，契合家政服务数字化运营需求。\n\n风险点:\n实习经历均为B端（律师/直播），无家政/C端服务经验；期望薪资5-8K高于JD范围；2026年4月实习结束，到岗时间需确认；本科在读未毕业，稳定性存疑。\n\n能力维度匹配:\n1. **能力1（社群运营能力）：4/5分。依据：主导律师私域社群管理，覆盖规范同步、实时答疑、诉求响应，月活跃率90%+，满意度92%，与JD社群日常运营高度匹配。\n2. **能力2（数据处理能力）：4/5分。依据：负责月度佣金核算、质检数据分析，输出运营数据支持；直播后整理用户观看/互动/转化数据并反馈优化，具备日报/复盘能力。\n3. **能力3（渠道管理能力）：2/5分。依据：有直播引流至私域经验（单月1200+用户），但无转介绍渠道管理、线索录入、营销活动触达等直接经验，需培训补足。\n4. **能力4（协作沟通能力）：3/5分。依据：作为核心成员参与APP优化，向技术团队提迭代建议；与律师群体、直播团队多方协作，但无\"友商\"对接及返佣/礼品发放经验。\n5. **能力5（执行推进能力）：4/5分。依据：牵头推进AI智能审核项目落地，完成需求提议到后期优化；主动push功能迭代与效率提升，符合\"不推诿不拖延\"要求。\n\n面试问题:\n1. 你曾向技术团队提出APP功能迭代建议，当时遇到的最大阻力是什么？如何推动对方采纳？\n2. 律师社群中遇到情绪激动、对服务规则不满意的用户，你如何处理？最终结果如何？\n3. 目前仍在读，实习结束后计划继续学",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 你曾向技术团队提出APP功能迭代建议，当时遇到的最大阻力是什么？如何推动对方采纳？\n2. 律师社群中遇到情绪激动、对服务规则不满意的用户，你如何处理？最终结果如何？\n3. 目前仍在读，实习结束后计划继续学业还是全职工作？对家政服务行业的认知和兴趣来源是什么？\n4. 家政服务涉及保洁、保姆、月嫂等多品类，如果让你设计一个转介绍用户的社群促活活动，你会如何分层触达不同需求的老用户？\n5. 每日运营数据报表需要跟踪线索进度、渠道达成等关键指标，请描述你会如何设计这张报表的字段结构和更新机制？\n6. 今天的交流很充分，最后想邀请你主动提问——关于天鹅到家的业务模式、团队工作方式，或者这个岗位未来的成长空间，有任何想了解的吗？",
    "capabilityMatch": "1. **能力1（社群运营能力）：4/5分。依据：主导律师私域社群管理，覆盖规范同步、实时答疑、诉求响应，月活跃率90%+，满意度92%，与JD社群日常运营高度匹配。\n2. **能力2（数据处理能力）：4/5分。依据：负责月度佣金核算、质检数据分析，输出运营数据支持；直播后整理用户观看/互动/转化数据并反馈优化，具备日报/复盘能力。\n3. **能力3（渠道管理能力）：2/5分。依据：有直播引流至私域经验（单月1200+用户），但无转介绍渠道管理、线索录入、营销活动触达等直接经验，需培训补足。\n4. **能力4（协作沟通能力）：3/5分。依据：作为核心成员参与APP优化，向技术团队提迭代建议；与律师群体、直播团队多方协作，但无\"友商\"对接及返佣/礼品发放经验。\n5. **能力5（执行推进能力）：4/5分。依据：牵头推进AI智能审核项目落地，完成需求提议到后期优化；主动push功能迭代与效率提升，符合\"不推诿不拖延\"要求。",
    "created": ""
  },
  {
    "id": 71,
    "name": "石妮娜",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "石",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "女",
    "strengths": "2年运营经验覆盖本地生活、电商票务、京东平台，具备多平台运营思维；擅长资源对接与商务谈判，可迁移至家政服务渠道拓展；有从0-1孵化门店及全链路运营经验，契合天鹅到家标准化服务落地需求；数据监控与周报输出习惯成熟。",
    "risks": "简历时间线存疑（2025.12-2026.03为未来日期），需核实真实在职时间；无明确社群运营直接经验，用户答疑、氛围维护等场景未体现；家政/母婴行业背景空白，服务标准化认知需验证；期望薪资6-8K与2年经验匹配度一般，稳定性待观察。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n2年运营经验覆盖本地生活、电商票务、京东平台，具备多平台运营思维；擅长资源对接与商务谈判，可迁移至家政服务渠道拓展；有从0-1孵化门店及全链路运营经验，契合天鹅到家标准化服务落地需求；数据监控与周报输出习惯成熟。\n\n风险点:\n简历时间线存疑（2025.12-2026.03为未来日期），需核实真实在职时间；无明确社群运营直接经验，用户答疑、氛围维护等场景未体现；家政/母婴行业背景空白，服务标准化认知需验证；期望薪资6-8K与2年经验匹配度一般，稳定性待观察。\n\n能力维度匹配:\n1. **社群运营能力：2/5分。依据：简历无社群运营直接经验，用户答疑、氛围维护、规则同步等场景未提及，仅有\"活动组织\"间接相关，需验证用户侧服务意识。\n2. **数据处理能力：4/5分。依据：明确提及\"每日监控核心指标\"\"输出数据周报/月报\"\"跟踪销售数据优化策略\"，数据工具使用（京东商智）及日报习惯与JD高度匹配。\n3. **渠道管理能力：3/5分。依据：有\"转介绍\"相关经验未直接体现，但具备\"资源对接、方案磋商\"\"渠道运营\"经验，线索录入、活动触达等执行层需验证。\n4. **协作沟通能力：4/5分。依据：\"对接各类合作方\"\"独立对接各平台BD\"\"协调学院各部门\"等经历丰富，商务谈判与跨部门沟通经验可迁移至友商协作场景。\n5. **执行推进能力：3/5分。依据：\"高效推进合作项目落地\"\"主动跟进问题\"等自我描述存在，但缺乏具体案例支撑\"不推诿不拖延\"的行为证据，需深挖。\n\n面试问题:\n1. 请描述一次你与合作方产生分歧的经历，具体分歧点是什么，你如何推动达成共识并保障项目落地？\n2. 在美甲门店运营中，你如何处理过用户投诉或负面",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你与合作方产生分歧的经历，具体分歧点是什么，你如何推动达成共识并保障项目落地？\n2. 在美甲门店运营中，你如何处理过用户投诉或负面评价？请举例说明具体场景、你的应对步骤及最终效果。\n3. 你过往三段工作平均在职时长约10个月，请说明离职原因，并解释为何选择家政行业及天鹅到家作为下一段职业方向？\n4. 天鹅到家社群中常见咨询包括\"保姆突然下户如何应急\"\"保洁服务不满意能否退款\"，你会如何设计标准话术框架并同步至社群规则？\n5. 假设本月转介绍渠道线索量环比下降30%，请简述你会如何通过数据拆解定位问题，并列举3个可落地的优化动作。",
    "capabilityMatch": "1. **社群运营能力：2/5分。依据：简历无社群运营直接经验，用户答疑、氛围维护、规则同步等场景未提及，仅有\"活动组织\"间接相关，需验证用户侧服务意识。\n2. **数据处理能力：4/5分。依据：明确提及\"每日监控核心指标\"\"输出数据周报/月报\"\"跟踪销售数据优化策略\"，数据工具使用（京东商智）及日报习惯与JD高度匹配。\n3. **渠道管理能力：3/5分。依据：有\"转介绍\"相关经验未直接体现，但具备\"资源对接、方案磋商\"\"渠道运营\"经验，线索录入、活动触达等执行层需验证。\n4. **协作沟通能力：4/5分。依据：\"对接各类合作方\"\"独立对接各平台BD\"\"协调学院各部门\"等经历丰富，商务谈判与跨部门沟通经验可迁移至友商协作场景。\n5. **执行推进能力：3/5分。依据：\"高效推进合作项目落地\"\"主动跟进问题\"等自我描述存在，但缺乏具体案例支撑\"不推诿不拖延\"的行为证据，需深挖。",
    "created": ""
  },
  {
    "id": 72,
    "name": "肖雯婷",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "本科在读（2026年6月毕业）",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "肖",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "具备新媒体运营与数据运营双重经验，熟悉小红书算法与标签运营逻辑，有日均触达150+用户的C端沟通实践；Excel数据透视表/VLOOKUP技能可直接复用于日报输出；旅游管理背景对家政服务场景化运营有迁移价值。",
    "risks": "1. 本科在读（2026年6月毕业）与岗位\"大专及以上学历\"存在时间错配，需确认到岗时间\n2. 无明确社群运营经验，仅有\"账号运营\"与\"用户触达\"经历，社群氛围维护、规则同步等场景未验证\n3. 转介绍渠道管理为零经验",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n具备新媒体运营与数据运营双重经验，熟悉小红书算法与标签运营逻辑，有日均触达150+用户的C端沟通实践；Excel数据透视表/VLOOKUP技能可直接复用于日报输出；旅游管理背景对家政服务场景化运营有迁移价值。\n\n风险点:\n本科在读（2026年6月毕业）与岗位\"大专及以上学历\"存在时间错配，需确认到岗时间；无明确社群运营经验，仅有\"账号运营\"与\"用户触达\"经历，社群氛围维护、规则同步等场景未验证；转介绍渠道管理为零经验。\n\n能力维度匹配:\n1. **社群运营能力：2/5分。依据：无社群场景经验，仅有新媒体账号运营（小红书）与C端产品推荐经历，用户答疑、氛围维护、规则同步等核心动作未体现，需验证场景迁移能力。**\n2. **数据处理能力：4/5分。依据：明确具备Excel数据透视表/VLOOKUP技能，有\"输出可视化日报\"实践，定量分析完成5000+字报告，日报输出与指标更新要求可快速上手。**\n3. **渠道管理能力：1/5分。依据：简历无转介绍、线索录入、渠道管理任何相关经验，仅提及\"线上购票渠道渗透\"，与转介绍场景差异较大，存在明显技能缺口。**\n4. **协作沟通能力：3/5分。依据：8人团队项目核心成员经历验证基础协作能力，C端日均150+用户触达体现沟通耐力，但跨部门、友商对接等复杂协作场景未涉及。**\n5. **执行推进能力：3/5分。依据：个人评价强调\"抗压性强\"\"积极主动\"，有从0到1账号运营闭环经历，但\"主动push待办事项\"这一强执行要求缺乏直接证据，需面试深挖。**\n\n面试问题:\n1. 请描述一次你在团队中主动推进他人配合完成任务的经历，当时遇到了什么阻力，你如何push进度？\n2. ",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你在团队中主动推进他人配合完成任务的经历，当时遇到了什么阻力，你如何push进度？\n2. 在日均触达150+用户的过程中，有没有遇到过情绪激烈或反复咨询的客户，你是如何沟通处理的？\n3. 你的实习经历显示2025年12月-2026年2月仍在南京，如果加入我们需要尽快到岗，学业与实习时间如何协调？\n4. 假设社群内有用户质疑家政阿姨服务质量并引发其他用户围观，你会如何处理这次危机并维护社群氛围？\n5. 请现场说明：如果用Excel统计转介绍渠道的月度线索转化率，你会设计哪些字段，用什么函数或工具呈现给负责人？\n6. 关于天鹅到家的社群运营，你对我们目前面向家政用户的服务场景有什么观察或疑问？或者对团队工作方式、这个岗位的成长空间，有什么想了解的？",
    "capabilityMatch": "1. **社群运营能力：2/5分。依据：无社群场景经验，仅有新媒体账号运营（小红书）与C端产品推荐经历，用户答疑、氛围维护、规则同步等核心动作未体现，需验证场景迁移能力。**\n2. **数据处理能力：4/5分。依据：明确具备Excel数据透视表/VLOOKUP技能，有\"输出可视化日报\"实践，定量分析完成5000+字报告，日报输出与指标更新要求可快速上手。**\n3. **渠道管理能力：1/5分。依据：简历无转介绍、线索录入、渠道管理任何相关经验，仅提及\"线上购票渠道渗透\"，与转介绍场景差异较大，存在明显技能缺口。**\n4. **协作沟通能力：3/5分。依据：8人团队项目核心成员经历验证基础协作能力，C端日均150+用户触达体现沟通耐力，但跨部门、友商对接等复杂协作场景未涉及。**\n5. **执行推进能力：3/5分。依据：个人评价强调\"抗压性强\"\"积极主动\"，有从0到1账号运营闭环经历，但\"主动push待办事项\"这一强执行要求缺乏直接证据，需面试深挖。**",
    "created": ""
  },
  {
    "id": 73,
    "name": "胡樾",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "胡",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "3年私域/社群运营经验，完整经历\"0到1\"搭建（小程序、企微、社群矩阵），擅长用户分层与生命周期管理。在袋鼠先生、麻六记项目中有数据复盘习惯（留存率90%、互动率25%等），与天鹅到家\"数字化运营\"方向高度契合。兼具B端（有赞私域顾问）与C端运营视角，能快速理解家政服务标准化需求。",
    "risks": "①稳定性存疑：2023.7-2025.9仅2年3份工作经历，最长8个月，平均任期短；②技能缺口：无转介绍渠道管理、线索录入等直销/分销渠道经验，无家政/本地生活行业背景；③文化匹配：过往聚焦电商快消，家政服务\"重履约、重信任\"特性需适应；④薪资预期6-8K与3年经验可能倒挂，需确认动机。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n3年私域/社群运营经验，完整经历\"0到1\"搭建（小程序、企微、社群矩阵），擅长用户分层与生命周期管理。在袋鼠先生、麻六记项目中有数据复盘习惯（留存率90%、互动率25%等），与天鹅到家\"数字化运营\"方向高度契合。兼具B端（有赞私域顾问）与C端运营视角，能快速理解家政服务标准化需求。\n\n风险点:\n①稳定性存疑：2023.7-2025.9仅2年3份工作经历，最长8个月，平均任期短；②技能缺口：无转介绍渠道管理、线索录入等直销/分销渠道经验，无家政/本地生活行业背景；③文化匹配：过往聚焦电商快消，家政服务\"重履约、重信任\"特性需适应；④薪资预期6-8K与3年经验可能倒挂，需确认动机。\n\n能力维度匹配:\n1. **能力1（社群运营能力）：4/5分。依据：主导2个品牌微信生态搭建，策划打卡晒餐、快手菜教学等活动，社群互动率21%-25%，月留存率89%-90%，有SOP设计经验。缺：无明确\"规则同步\"\"答疑\"等客服向描述。\n2. **能力2（数据处理能力）：3.5/5分。依据：简历明确\"数据敏感\"，输出过留存率、复购率、GMV增长等核心指标，有业务复盘习惯。缺：无\"每日报表\"经验，未体现线索进度、渠道达成等B端销售数据跟踪。\n3. **能力3（渠道管理能力）：2/5分。依据：有赞期间涉及\"异业合作资源置换\"\"企业家社群运营\"，但无转介绍渠道、线索录入、分销体系管理（除最后一个项目二级分销）。缺：无线索管理、月度营销活动触达转介绍用户的直接经验。\n4. **能力4（协作沟通能力）：3.5/5分。依据：有赞期间\"客情维护\"\"商务谈判\"，派能科技\"内外部沟通协调\"，麻六记\"与电商平台联动\"。缺：无\"友商\"合作、返佣/礼品",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你需要协调多个部门或外部合作方，但对方配合度不高的经历。你具体如何推动？最终结果如何？\n2. 社群运营中遇到用户投诉或负面舆情时，你如何处理？请举例说明具体场景、你的回应方式和后续优化动作。\n3. 你近三段工作经历都比较短，能否说明离职原因？如果加入天鹅到家，你期望在这里深耕多久？什么因素会让你考虑离开？\n4. 假设你需要管理一批家政阿姨的转介绍渠道，设计一套线索录入-跟进-转化的SOP，你会关注哪些关键节点？如何设计阿姨的激励体系？\n5. 请现场设计一张社群运营日报表，需要包含哪些指标？如果某周社群活跃度下降20%，你会如何拆解原因并优化？",
    "capabilityMatch": "1. **能力1（社群运营能力）：4/5分。依据：主导2个品牌微信生态搭建，策划打卡晒餐、快手菜教学等活动，社群互动率21%-25%，月留存率89%-90%，有SOP设计经验。缺：无明确\"规则同步\"\"答疑\"等客服向描述。\n2. **能力2（数据处理能力）：3.5/5分。依据：简历明确\"数据敏感\"，输出过留存率、复购率、GMV增长等核心指标，有业务复盘习惯。缺：无\"每日报表\"经验，未体现线索进度、渠道达成等B端销售数据跟踪。\n3. **能力3（渠道管理能力）：2/5分。依据：有赞期间涉及\"异业合作资源置换\"\"企业家社群运营\"，但无转介绍渠道、线索录入、分销体系管理（除最后一个项目二级分销）。缺：无线索管理、月度营销活动触达转介绍用户的直接经验。\n4. **能力4（协作沟通能力）：3.5/5分。依据：有赞期间\"客情维护\"\"商务谈判\"，派能科技\"内外部沟通协调\"，麻六记\"与电商平台联动\"。缺：无\"友商\"合作、返佣/礼品发放等具体场景，未体现\"通俗易懂\"的服务型沟通风格。\n5. **能力5（执行推进能力）：3.5/5分。依据：自我评价\"主动跟进问题不推诿\"\"主动push待办\"，项目经历中体现从0到1推进力。缺：无具体案例佐证\"高效完成日常事务性工作\"，过往更偏策略设计而非执行闭环。",
    "created": ""
  },
  {
    "id": 74,
    "name": "舒磊",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "舒",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "具备社群运营实操经验（凯乐石越野跑社群内容规划、SOP撰写、用户答疑），有数据复盘意识（每日活跃数据、会员拉新进度追踪），熟悉从策划到落地的完整链路；体育赛事执行背景锻炼了多部门协调与高压场景应变能力，与家政服务标准化、数字化运营有迁移空间。",
    "risks": "经历时间线异常（2025.02-2025.09、2025.10-2026.03等未来日期），存在简历造假或严重笔误可能；无家政/本地生活行业经验，转介绍渠道管理、线索录入等具体场景零接触；稳定性存疑（4段经历均不足4个月，最长7个月）。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 存疑\n\n优势分析:\n具备社群运营实操经验（凯乐石越野跑社群内容规划、SOP撰写、用户答疑），有数据复盘意识（每日活跃数据、会员拉新进度追踪），熟悉从策划到落地的完整链路；体育赛事执行背景锻炼了多部门协调与高压场景应变能力，与家政服务标准化、数字化运营有迁移空间。\n\n风险点:\n经历时间线异常（2025.02-2025.09、2025.10-2026.03等未来日期），存在简历造假或严重笔误可能；无家政/本地生活行业经验，转介绍渠道管理、线索录入等具体场景零接触；稳定性存疑（4段经历均不足4个月，最长7个月）。\n\n能力维度匹配:\n1. **1. 社群运营能力：3.5/5分。依据：有社群内容规划、SOP撰写、日常答疑经验，但缺乏家政类高客诉场景的用户维护经验，未体现\"规则同步\"具体案例。\n2. **2. 数据处理能力：3/5分。依据：提及数据复盘、输出报表，但仅描述\"活跃数据\"\"拉新进度\"等笼统指标，无日报/线索进度等具体工具或方法论呈现。\n3. **3. 渠道管理能力：1/5分。依据：简历完全未涉及转介绍渠道、线索录入、月度活动触达等任何相关经验，技能缺口明显。\n4. **4. 协作沟通能力：4/5分。依据：多次跨部门协调经验（赛事安保对接、政府接待、赞助商沟通），\"主动push\"特质需进一步验证。\n5. **5. 执行推进能力：3.5/5分。依据：赛事执行背景体现强执行力，但\"不推诿不拖延\"等行为风格缺乏文本证据，需面试深挖。\n\n面试问题:\n1. 在凯乐石或虎鲸文娱期间，是否遇到过合作方临时变卦或资源不到位的情况？你具体如何push进度、协调多方达成目标的？\n2. 越野跑社群中是否遇到过用户投诉或负面情绪爆发？你如何维护社群氛",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 在凯乐石或虎鲸文娱期间，是否遇到过合作方临时变卦或资源不到位的情况？你具体如何push进度、协调多方达成目标的？\n2. 越野跑社群中是否遇到过用户投诉或负面情绪爆发？你如何维护社群氛围并同步规则，最终如何解决的？\n3. 注意到您多段经历时长较短且时间线存在疑问，能否解释2025-2026年的时间记录？未来2-3年职业规划是否倾向深耕运营还是赛事方向？\n4. 假设需设计一个老用户转介绍活动，你会如何设计线索录入流程、追踪转介绍转化率，并用哪些指标评估活动效果？\n5. 家政服务中保洁/月嫂等品类客诉率较高，若社群内出现用户对服务质量的公开质疑，你会如何处理答疑、氛围维护与规则同步？",
    "capabilityMatch": "1. **1. 社群运营能力：3.5/5分。依据：有社群内容规划、SOP撰写、日常答疑经验，但缺乏家政类高客诉场景的用户维护经验，未体现\"规则同步\"具体案例。\n2. **2. 数据处理能力：3/5分。依据：提及数据复盘、输出报表，但仅描述\"活跃数据\"\"拉新进度\"等笼统指标，无日报/线索进度等具体工具或方法论呈现。\n3. **3. 渠道管理能力：1/5分。依据：简历完全未涉及转介绍渠道、线索录入、月度活动触达等任何相关经验，技能缺口明显。\n4. **4. 协作沟通能力：4/5分。依据：多次跨部门协调经验（赛事安保对接、政府接待、赞助商沟通），\"主动push\"特质需进一步验证。\n5. **5. 执行推进能力：3.5/5分。依据：赛事执行背景体现强执行力，但\"不推诿不拖延\"等行为风格缺乏文本证据，需面试深挖。",
    "created": ""
  },
  {
    "id": 75,
    "name": "苏玉婷",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "物流管理专业",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "苏",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "女",
    "strengths": "具备多平台用户运营实战经验，重庆悦派对期间月均处理违规内容10000+条，擅长社区氛围维护与用户反馈运营；科大讯飞活动执行经历体现线下服务与流程管理能力；团支书及党委宣传部经历验证跨部门协作与活动统筹能力，与家政服务标准化运营场景高度契合。",
    "risks": "实习经历集中于2025-2026年，时间线存疑（当前为2025年1月），需核实实际在岗时长；无明确转介绍渠道管理或线索录入经验，渠道管理能力为空白；物流管理专业背景与社群运营关联度低，行业认知需考察。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n具备多平台用户运营实战经验，重庆悦派对期间月均处理违规内容10000+条，擅长社区氛围维护与用户反馈运营；科大讯飞活动执行经历体现线下服务与流程管理能力；团支书及党委宣传部经历验证跨部门协作与活动统筹能力，与家政服务标准化运营场景高度契合。\n\n风险点:\n实习经历集中于2025-2026年，时间线存疑（当前为2025年1月），需核实实际在岗时长；无明确转介绍渠道管理或线索录入经验，渠道管理能力为空白；物流管理专业背景与社群运营关联度低，行业认知需考察。\n\n能力维度匹配:\n1. **社群运营能力：4/5分。依据：重庆悦派对负责海内外娱乐社交App内容审核与社区氛围维护，月均处理违规内容10000+条，应用商店评价回复300+条，具备规模化社群治理经验；但缺乏明确\"活动发布、规则同步\"等正向运营动作描述。\n2. **数据处理能力：3/5分。依据：乡村基每日处理100-150条订单数据并动态调整投放计划，科大讯飞记录用户互动数据协助复盘；但无\"每日输出运营数据报表\"的固定报表经验，指标跟踪系统性不足。\n3. **渠道管理能力：1/5分。依据：简历未提及任何转介绍渠道管理、线索录入或营销活动触达经验，该维度为明显能力缺口。\n4. **协作沟通能力：4/5分。依据：团支书联合多学院合作完成工作，党委宣传部协调8个部门开展新闻中心文化建设，200人规模活动统筹经验；客服实习经历验证跨部门问题上报与闭环能力。\n5. **执行推进能力：4/5分。依据：多段实习体现\"0中断\"保障目标，并行处理举报、反馈、评价等多任务；自我评价强调\"主动跟进问题不推诿\"，但缺乏具体push待办事项的实例佐证。\n\n面试问题:\n1. 在悦派对处理",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 在悦派对处理月均10000+条违规内容时，如何区分优先级并确保处理时效？请举例说明一次因标准模糊导致的争议及你的处理方式。\n2. 作为团支书联合其他学院合作时，遇到过对方配合度低的情况吗？你采取了哪些具体措施推动事项落地？\n3. 你的实习时间显示2025年7月才开始，目前（2025年1月）是否已离职？未来2-3年的职业规划是否倾向于互联网运营还是家政服务行业？\n4. 假设社群内有用户投诉月嫂服务不达标并引发其他用户围观，你会如何在维护品牌口碑的同时妥善处理？请描述具体话术与操作步骤。\n5. 请设计一份转介绍渠道线索录入的Excel表格模板，需包含哪些核心字段？如何设置数据校验避免录入错误？",
    "capabilityMatch": "1. **社群运营能力：4/5分。依据：重庆悦派对负责海内外娱乐社交App内容审核与社区氛围维护，月均处理违规内容10000+条，应用商店评价回复300+条，具备规模化社群治理经验；但缺乏明确\"活动发布、规则同步\"等正向运营动作描述。\n2. **数据处理能力：3/5分。依据：乡村基每日处理100-150条订单数据并动态调整投放计划，科大讯飞记录用户互动数据协助复盘；但无\"每日输出运营数据报表\"的固定报表经验，指标跟踪系统性不足。\n3. **渠道管理能力：1/5分。依据：简历未提及任何转介绍渠道管理、线索录入或营销活动触达经验，该维度为明显能力缺口。\n4. **协作沟通能力：4/5分。依据：团支书联合多学院合作完成工作，党委宣传部协调8个部门开展新闻中心文化建设，200人规模活动统筹经验；客服实习经历验证跨部门问题上报与闭环能力。\n5. **执行推进能力：4/5分。依据：多段实习体现\"0中断\"保障目标，并行处理举报、反馈、评价等多任务；自我评价强调\"主动跟进问题不推诿\"，但缺乏具体push待办事项的实例佐证。",
    "created": ""
  },
  {
    "id": 76,
    "name": "谢冰欣",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无明确学历信息",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "谢",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "女",
    "strengths": "候选人具备企业微信社群运营实操经验，涵盖内容策划、用户互动、数据整理分析；有私域精准营销及同人创作引流经验，契合家政服务数字化运营需求；Excel数据处理（vlookup）及海报设计能力可支撑日常报表与物料产出；跨部门协作与活动策划经验较丰富。",
    "risks": "期望城市为广州，与岗位地点杭州存在地域错配，需确认接受度；工作经历时间线异常（2025-2026年），疑似简历日期错误或应届生身份存疑；无家政/本地生活行业背景，业务理解需从零培养；稳定性待观察（多段短期经历）。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n候选人具备企业微信社群运营实操经验，涵盖内容策划、用户互动、数据整理分析；有私域精准营销及同人创作引流经验，契合家政服务数字化运营需求；Excel数据处理（vlookup）及海报设计能力可支撑日常报表与物料产出；跨部门协作与活动策划经验较丰富。\n\n风险点:\n期望城市为广州，与岗位地点杭州存在地域错配，需确认接受度；工作经历时间线异常（2025-2026年），疑似简历日期错误或应届生身份存疑；无家政/本地生活行业背景，业务理解需从零培养；稳定性待观察（多段短期经历）。\n\n能力维度匹配:\n1. **社群运营能力：4/5分。依据：主导企业微信社群日常运营，含内容策划、互动维护、用户答疑；有私域团购开团及同人社群引流实战经验，可直接迁移至雏渐肥社群管理。\n2. **数据处理能力：3/5分。依据：每日导出整理运营数据，使用vlookup分类清洗；但未体现\"每日输出报表\"的固定节奏，且缺乏数据复盘驱动策略优化的明确案例。\n3. **渠道管理能力：2/5分。依据：有转介绍类私域团购经验，但简历未明确\"线索录入\"系统操作；无B端渠道管理或返佣规则执行经历，与JD要求存在差距。\n4. **协作沟通能力：3/5分。依据：多次提及跨部门协作、项目组配合、团队认可；但\"友商沟通\"及\"返佣礼品发放\"等商务场景无直接经验，需验证沟通风格是否适配家政行业。\n5. **执行推进能力：4/5分。依据：自我评价强调\"主动跟进问题不推诿\"；经历中体现\"快速响应客户需求\"\"主动push待办\"特质，与JD责任心要求高度吻合。\n\n面试问题:\n1. 请描述一次你在社群运营中遇到用户集中投诉或负面舆情的经历，当时如何协调资源、沟通解决，最终结果如何？\n",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你在社群运营中遇到用户集中投诉或负面舆情的经历，当时如何协调资源、沟通解决，最终结果如何？\n2. 你的期望工作城市是广州，而我们岗位base杭州，请谈谈你对异地求职的考虑，以及未来2-3年的职业规划？\n3. 在星火教育或学院办公室助理经历中，请举例说明你是如何\"主动push\"一项被拖延的工作任务，推动团队达成目标的？\n4. 假设需要设计一个针对月嫂/育儿嫂的转介绍激励活动，你会如何拆解目标、设计触达话术，并跟踪哪些关键数据指标？\n5. 请现场说明：如果用Excel统计某月各渠道转介绍线索的转化率，你会如何设计表格结构、使用哪些函数，并输出可视化结论？",
    "capabilityMatch": "1. **社群运营能力：4/5分。依据：主导企业微信社群日常运营，含内容策划、互动维护、用户答疑；有私域团购开团及同人社群引流实战经验，可直接迁移至雏渐肥社群管理。\n2. **数据处理能力：3/5分。依据：每日导出整理运营数据，使用vlookup分类清洗；但未体现\"每日输出报表\"的固定节奏，且缺乏数据复盘驱动策略优化的明确案例。\n3. **渠道管理能力：2/5分。依据：有转介绍类私域团购经验，但简历未明确\"线索录入\"系统操作；无B端渠道管理或返佣规则执行经历，与JD要求存在差距。\n4. **协作沟通能力：3/5分。依据：多次提及跨部门协作、项目组配合、团队认可；但\"友商沟通\"及\"返佣礼品发放\"等商务场景无直接经验，需验证沟通风格是否适配家政行业。\n5. **执行推进能力：4/5分。依据：自我评价强调\"主动跟进问题不推诿\"；经历中体现\"快速响应客户需求\"\"主动push待办\"特质，与JD责任心要求高度吻合。",
    "created": ""
  },
  {
    "id": 77,
    "name": "谭圻琪",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "谭",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "未提及",
    "strengths": "3年社群运营实战经验，擅长老年用户社群维护与活动主持，具备\"线上+线下\"全链路运营能力；有数据报表编制经验（工程部月材料/能耗表），符合家政服务数字化运营需求；旅游行业背景与天鹅到家服务标准化理念契合。",
    "risks": "期望薪资4.5-5K低于JD标注的6-8K，需确认稳定性；无明确转介绍渠道管理经验；3份工作均不满1年（最长10个月），跳槽频繁；无家政/母婴行业背景，服务标准认知需培养。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n3年社群运营实战经验，擅长老年用户社群维护与活动主持，具备\"线上+线下\"全链路运营能力；有数据报表编制经验（工程部月材料/能耗表），符合家政服务数字化运营需求；旅游行业背景与天鹅到家服务标准化理念契合。\n\n风险点:\n期望薪资4.5-5K低于JD标注的6-8K，需确认稳定性；无明确转介绍渠道管理经验；3份工作均不满1年（最长10个月），跳槽频繁；无家政/母婴行业背景，服务标准认知需培养。\n\n能力维度匹配:\n1. **社群运营能力：4/5分。依据：主导微信群日常运营、用户答疑、活动发布，主持线下活动提升粘性，有直播互动经验，匹配\"雏渐肥\"母婴社群场景。\n2. **数据处理能力：3/5分。依据：编制过工程部月度能耗表、资金消耗表，具备基础报表能力；但无明确\"每日输出运营数据报表\"经验，数据复盘深度待验证。\n3. **渠道管理能力：2/5分。依据：无直接转介绍渠道管理经验；仅有签证业务中\"跟踪客户进度\"的间接相关经历，线索录入与月度触达整理能力未体现。\n4. **协作沟通能力：3/5分。依据：跨部门协助工程部资料管理，与地接/客户多方协调处理突发状况；但\"友商返佣、礼品发放\"等商务协作经验缺失。\n5. **执行推进能力：3/5分。依据：简历自述\"办事稳重、认真负责\"，有紧急联系用户、处理突发状况的主动跟进案例；但\"主动push待办事项\"的具体行为未呈现，3段短期经历存疑。\n\n面试问题:\n1. 请描述一次你在旅游团中处理客户与地接冲突的具体经历，你如何平衡双方诉求并推动问题解决？\n2. 老年用户社群中常遇到重复提问或负面情绪，你如何在银尚乐活处理这类情况？能否举例说明？\n3. 你近3份工作平均任期约8个月，请说明离",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你在旅游团中处理客户与地接冲突的具体经历，你如何平衡双方诉求并推动问题解决？\n2. 老年用户社群中常遇到重复提问或负面情绪，你如何在银尚乐活处理这类情况？能否举例说明？\n3. 你近3份工作平均任期约8个月，请说明离职原因，以及如何看待社群运营岗位的长期发展？\n4. 假设转介绍渠道本月线索转化率下降20%，你会如何拆解数据并定位问题？请简述分析框架。\n5. 天鹅到家保洁服务包含日常保洁/深度保洁/开荒保洁三类，若要在社群中推广转介绍活动，你会如何设计差异化话术触达不同用户？",
    "capabilityMatch": "1. **社群运营能力：4/5分。依据：主导微信群日常运营、用户答疑、活动发布，主持线下活动提升粘性，有直播互动经验，匹配\"雏渐肥\"母婴社群场景。\n2. **数据处理能力：3/5分。依据：编制过工程部月度能耗表、资金消耗表，具备基础报表能力；但无明确\"每日输出运营数据报表\"经验，数据复盘深度待验证。\n3. **渠道管理能力：2/5分。依据：无直接转介绍渠道管理经验；仅有签证业务中\"跟踪客户进度\"的间接相关经历，线索录入与月度触达整理能力未体现。\n4. **协作沟通能力：3/5分。依据：跨部门协助工程部资料管理，与地接/客户多方协调处理突发状况；但\"友商返佣、礼品发放\"等商务协作经验缺失。\n5. **执行推进能力：3/5分。依据：简历自述\"办事稳重、认真负责\"，有紧急联系用户、处理突发状况的主动跟进案例；但\"主动push待办事项\"的具体行为未呈现，3段短期经历存疑。",
    "created": ""
  },
  {
    "id": 78,
    "name": "赵苏",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "赵",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "29岁",
    "gender": "无",
    "strengths": "7年电商运营经验，深耕天猫平台用户维护与数据复盘，擅长跨部门协作（客服/物流/仓管）及活动落地，具备强执行力和基础社群运营场景经验（客户咨询、粘性维护、中差评处理），与家政服务数字化运营高度契合。",
    "risks": "无明确社群运营专职经验，转介绍渠道管理为空白领域；近3年两次跳槽（2022.12、2024.5），2024.5-2025.9经历存疑（时间线超前）；29岁转基础岗，职业动机与稳定性需验证。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n7年电商运营经验，深耕天猫平台用户维护与数据复盘，擅长跨部门协作（客服/物流/仓管）及活动落地，具备强执行力和基础社群运营场景经验（客户咨询、粘性维护、中差评处理），与家政服务数字化运营高度契合。\n\n风险点:\n无明确社群运营专职经验，转介绍渠道管理为空白领域；近3年两次跳槽（2022.12、2024.5），2024.5-2025.9经历存疑（时间线超前）；29岁转基础岗，职业动机与稳定性需验证。\n\n能力维度匹配:\n1. **社群运营能力：3/5分。依据：有客户咨询承接、粘性维护、中差评处理经验，但无专职社群日常管理、氛围营造、规则同步的明确证据。\n2. **数据处理能力：4/5分。依据：定期统计销售数据、调研竞品、输出基础数据反馈，每日报表输出习惯未明确提及，但数据跟踪复盘能力扎实。\n3. **渠道管理能力：2/5分。依据：无转介绍渠道管理、线索录入、营销活动触达经验，仅有达人直播对接经验，与JD要求差距较大。\n4. **协作沟通能力：4/5分。依据：多次协调客服、物流、仓管等跨部门资源，与友商及合作部门沟通经验较丰富，返佣礼品发放无直接证据。\n5. **执行推进能力：4/5分。依据：主动跟进直播落地、活动全流程执行，\"不推诿不拖延\"特质有项目落地支撑，但push待办事项主动性未明确体现。\n\n面试问题:\n1. 请描述一次你需要同时协调多个部门（如客服、物流、市场）共同完成紧急任务的经历，当时遇到了什么阻力，你如何push进度确保目标达成？\n2. 你在凯元伞业处理中差评时，遇到过情绪激烈的客户吗？具体如何沟通化解，最终结果如何？\n3. 2024年5月选择从酒类运营转向通信产品配置，现在又应聘社群运营，能谈谈",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你需要同时协调多个部门（如客服、物流、市场）共同完成紧急任务的经历，当时遇到了什么阻力，你如何push进度确保目标达成？\n2. 你在凯元伞业处理中差评时，遇到过情绪激烈的客户吗？具体如何沟通化解，最终结果如何？\n3. 2024年5月选择从酒类运营转向通信产品配置，现在又应聘社群运营，能谈谈这几次职业选择的考量吗？未来3年的职业规划是什么？\n4. 假设雏渐肥社群内有用户投诉月嫂服务与宣传不符、要求退款，同时引发群内其他用户围观议论，你会如何在社群内第一时间响应并私信处理？请分步骤说明。\n5. 请设计一个转介绍用户的月度营销活动方案框架，包括目标、触达渠道、激励规则和效果追踪指标，重点说明如何提升老用户转介绍意愿。",
    "capabilityMatch": "1. **社群运营能力：3/5分。依据：有客户咨询承接、粘性维护、中差评处理经验，但无专职社群日常管理、氛围营造、规则同步的明确证据。\n2. **数据处理能力：4/5分。依据：定期统计销售数据、调研竞品、输出基础数据反馈，每日报表输出习惯未明确提及，但数据跟踪复盘能力扎实。\n3. **渠道管理能力：2/5分。依据：无转介绍渠道管理、线索录入、营销活动触达经验，仅有达人直播对接经验，与JD要求差距较大。\n4. **协作沟通能力：4/5分。依据：多次协调客服、物流、仓管等跨部门资源，与友商及合作部门沟通经验较丰富，返佣礼品发放无直接证据。\n5. **执行推进能力：4/5分。依据：主动跟进直播落地、活动全流程执行，\"不推诿不拖延\"特质有项目落地支撑，但push待办事项主动性未明确体现。",
    "created": ""
  },
  {
    "id": 79,
    "name": "金磊",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "金",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "男",
    "strengths": "9年运营经验，具备从0到1社群搭建、SOP制定及私域全链路运营能力；有医疗/母婴营养项目经验，与天鹅到家母婴护理业务高度契合；擅长用户分层、数据复盘及高价值会员维护，标准化运营思维成熟。",
    "risks": "简历显示2023年4月-2025年8月任职杭州震升汽车科技，但2026年1月已入职新岗位，存在时间空档或简历时间错误；近4段工作平均任期约1.5年，稳定性存疑；无家政/本地生活服务行业背景，需验证业务迁移能力。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n9年运营经验，具备从0到1社群搭建、SOP制定及私域全链路运营能力；有医疗/母婴营养项目经验，与天鹅到家母婴护理业务高度契合；擅长用户分层、数据复盘及高价值会员维护，标准化运营思维成熟。\n\n风险点:\n简历显示2023年4月-2025年8月任职杭州震升汽车科技，但2026年1月已入职新岗位，存在时间空档或简历时间错误；近4段工作平均任期约1.5年，稳定性存疑；无家政/本地生活服务行业背景，需验证业务迁移能力。\n\n能力维度匹配:\n1. **社群运营能力：5/5分。依据：简历明确\"从0到1搭建社群\"\"企业微信、社群、朋友圈私域流量池运营\"\"社群日常互动、科普、秒杀活动策划\"，与JD\"用户答疑、氛围维护、活动发布\"完全匹配。\n2. **数据处理能力：4/5分。依据：明确提及\"统计社群活跃度、新增留存、复购率、客单价等核心数据\"\"收集分析服务商投产比、客单价\"，但未明确提及\"每日输出运营数据报表\"的日报经验。\n3. **渠道管理能力：3/5分。依据：有\"老客裂变\"\"转介绍\"经验，但侧重用户端裂变而非渠道端线索管理；无明确\"转介绍渠道线索录入\"\"月度营销活动触达\"的系统化渠道运营描述。\n4. **协作沟通能力：4/5分。依据：多次强调\"对接设计团队\"\"对接线上及线下门店老板\"\"维护良好合作关系\"\"售后答疑\"，体现跨部门与B端沟通能力，但无\"友商\"合作及\"返佣、礼品发放\"经验。\n5. **执行推进能力：4/5分。依据：自我评价明确\"工作细致负责\"\"高效处理订单\"，经历中多次体现\"主动跟进用户咨询、复购唤醒\"，但缺乏\"主动push待办事项\"的明确证据。\n\n面试问题:\n1. 请描述一次你需要同时对接多个部门（如设计、销售、",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你需要同时对接多个部门（如设计、销售、客服）推进项目的经历，当时遇到了什么阻力，你如何push事项前进？\n2. 你在医疗/母婴项目中处理过最棘手的客户投诉或售后问题是什么？最终如何解决的？\n3. 你近几段工作任期均在1-2年左右，能否分享一下离职原因？你如何看待社群运营岗位的长期发展？\n4. 假设天鹅到家推出新手妈妈育儿嫂服务套餐，请设计一个7天社群SOP，包含每日主题、互动形式及转化节点。\n5. 你如何设计转介绍激励机制？请结合家政服务低频高客单的特点，说明如何提升老客转介绍率。",
    "capabilityMatch": "1. **社群运营能力：5/5分。依据：简历明确\"从0到1搭建社群\"\"企业微信、社群、朋友圈私域流量池运营\"\"社群日常互动、科普、秒杀活动策划\"，与JD\"用户答疑、氛围维护、活动发布\"完全匹配。\n2. **数据处理能力：4/5分。依据：明确提及\"统计社群活跃度、新增留存、复购率、客单价等核心数据\"\"收集分析服务商投产比、客单价\"，但未明确提及\"每日输出运营数据报表\"的日报经验。\n3. **渠道管理能力：3/5分。依据：有\"老客裂变\"\"转介绍\"经验，但侧重用户端裂变而非渠道端线索管理；无明确\"转介绍渠道线索录入\"\"月度营销活动触达\"的系统化渠道运营描述。\n4. **协作沟通能力：4/5分。依据：多次强调\"对接设计团队\"\"对接线上及线下门店老板\"\"维护良好合作关系\"\"售后答疑\"，体现跨部门与B端沟通能力，但无\"友商\"合作及\"返佣、礼品发放\"经验。\n5. **执行推进能力：4/5分。依据：自我评价明确\"工作细致负责\"\"高效处理订单\"，经历中多次体现\"主动跟进用户咨询、复购唤醒\"，但缺乏\"主动push待办事项\"的明确证据。",
    "created": ""
  },
  {
    "id": 80,
    "name": "钱俊威",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "钱",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "3年教育行业私域运营经验，擅长0-1搭建社群体系（团长群+家长群5个，沉淀2000+用户），社群活跃率维持40%+；具备数据工具应用能力（Excel、石墨文档数据看板）；有转介绍体系搭建经验（转介绍率15%→28%）；执行力强，输出SOP文档优化团队效率30%。",
    "risks": "期望薪资12-14K远高于JD标注的6-8K，薪资匹配度存疑；简历时间线异常（2025.10-2026.02为未来日期），真实性需核实；无家政/本地生活行业经验，业务场景切换需适应；3年经验应聘专员级岗位，职级定位与职业发展诉求可能错位。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 存疑\n\n优势分析:\n3年教育行业私域运营经验，擅长0-1搭建社群体系（团长群+家长群5个，沉淀2000+用户），社群活跃率维持40%+；具备数据工具应用能力（Excel、石墨文档数据看板）；有转介绍体系搭建经验（转介绍率15%→28%）；执行力强，输出SOP文档优化团队效率30%。\n\n风险点:\n期望薪资12-14K远高于JD标注的6-8K，薪资匹配度存疑；简历时间线异常（2025.10-2026.02为未来日期），真实性需核实；无家政/本地生活行业经验，业务场景切换需适应；3年经验应聘专员级岗位，职级定位与职业发展诉求可能错位。\n\n能力维度匹配:\n1. **社群运营能力：4/5分。依据：** 搭建5个社群（1000+人），多元运营形式（干货分享、限时福利、案例拆解），活跃率40%+，有标准化话术手册输出经验，与JD日常管理、答疑、活动发布高度匹配。\n2. **数据处理能力：3.5/5分。依据：** 运用Excel、石墨文档做数据看板与客情分析，优化SOP流程；但JD要求\"每日输出运营数据报表\"的例行性工作，简历侧重策略优化而非日常报表，颗粒度需验证。\n3. **渠道管理能力：3/5分。依据：** 有转介绍体系搭建经验（转介绍率提升至28%），但侧重C端家长裂变；JD要求\"转介绍渠道端线索录入、月度营销活动触达\"，B端渠道管理（友商合作）经验未体现。\n4. **协作沟通能力：3.5/5分。依据：** 高效对接客户、合作伙伴及团队成员，协同领导优化SOP；但\"与友商沟通、返佣礼品发放\"等商务协作场景未直接呈现，需深挖。\n5. **执行推进能力：4/5分。依据：** 个人优势明确\"工作严谨负责、注重细节，执行力强\"，简历多项目并行",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 你曾同时推进多个项目（视频策划、社群运营、销售拓展），请举例说明当资源冲突时，你如何主动协调各方优先级并push事项落地？\n2. 你的期望薪资与JD标注范围存在差距，请谈谈你对该岗位薪资预期的考量，以及未来1-2年的职业规划？\n3. 教育行业与家政服务行业在用户群体、服务场景上有较大差异，你如何看待这种切换？如果入职后需要从一线客服答疑做起，你能否接受？\n4. 请描述你过往\"每日输出运营数据报表\"的具体经历：报表包含哪些核心指标？从数据收集到呈现的流程是怎样的？如何确保数据的准确性和时效性？\n5. 假设你需要与一位对返佣规则不满意的合作团长沟通，请现场模拟一段对话，展示你如何用通俗易懂的语言解释规则并维护合作关系？",
    "capabilityMatch": "1. **社群运营能力：4/5分。依据：** 搭建5个社群（1000+人），多元运营形式（干货分享、限时福利、案例拆解），活跃率40%+，有标准化话术手册输出经验，与JD日常管理、答疑、活动发布高度匹配。\n2. **数据处理能力：3.5/5分。依据：** 运用Excel、石墨文档做数据看板与客情分析，优化SOP流程；但JD要求\"每日输出运营数据报表\"的例行性工作，简历侧重策略优化而非日常报表，颗粒度需验证。\n3. **渠道管理能力：3/5分。依据：** 有转介绍体系搭建经验（转介绍率提升至28%），但侧重C端家长裂变；JD要求\"转介绍渠道端线索录入、月度营销活动触达\"，B端渠道管理（友商合作）经验未体现。\n4. **协作沟通能力：3.5/5分。依据：** 高效对接客户、合作伙伴及团队成员，协同领导优化SOP；但\"与友商沟通、返佣礼品发放\"等商务协作场景未直接呈现，需深挖。\n5. **执行推进能力：4/5分。依据：** 个人优势明确\"工作严谨负责、注重细节，执行力强\"，简历多项目并行推进（视频策划、社群运营、销售拓展），主动优化4版SOP文档，与\"主动push待办事项\"匹配。",
    "created": ""
  },
  {
    "id": 81,
    "name": "韩枫",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "韩",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "具备客户沟通与问题跟进经验，在顺丰客诉岗位中体现主动识别风险、安抚情绪、推动闭环的能力；前锦网络经历显示客户需求分析与项目统筹能力；计算机背景（Python/HTML）对数字化运营工具有一定适配性。",
    "risks": "无直接社群运营经验，JD要求的\"氛围维护、活动发布\"等场景未验证；数据处理能力停留在\"表格登记\"，缺乏运营数据报表输出经验；转介绍渠道管理为零经验；4年工作经验期望6-8K薪资，需关注职业稳定性与动机。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 存疑\n\n优势分析:\n具备客户沟通与问题跟进经验，在顺丰客诉岗位中体现主动识别风险、安抚情绪、推动闭环的能力；前锦网络经历显示客户需求分析与项目统筹能力；计算机背景（Python/HTML）对数字化运营工具有一定适配性。\n\n风险点:\n无直接社群运营经验，JD要求的\"氛围维护、活动发布\"等场景未验证；数据处理能力停留在\"表格登记\"，缺乏运营数据报表输出经验；转介绍渠道管理为零经验；4年工作经验期望6-8K薪资，需关注职业稳定性与动机。\n\n能力维度匹配:\n1. **社群运营能力：1/5分。依据：简历无社群运营经验，仅有客户电话回访与一对一沟通经历，未涉及社群场景下的氛围维护、活动发布、规则同步等核心动作。**\n2. **数据处理能力：2/5分。依据：具备基础表格登记与记录能力，但JD要求的\"每日输出运营数据报表、更新关键指标、辅助策略优化\"等分析性工作无直接证据支撑。**\n3. **渠道管理能力：0/5分。依据：简历无任何转介绍渠道管理、线索录入、营销活动触达相关经历，该维度完全空白。**\n4. **协作沟通能力：3/5分。依据：客户代表岗位涉及\"组织协调内外部资源\"，客诉岗位体现跨部门反馈与问题升级机制，具备基础沟通协作意识，但未涉及\"友商\"合作场景。**\n5. **执行推进能力：3/5分。依据：客诉岗位明确\"主动识别风险、及时反馈、协助推动闭环\"，客户代表岗位有\"项目全流程实施\"经历，体现一定主动性；但\"push待办事项\"的管理行为未验证。**\n\n面试问题:\n1. 请描述一次你需要同时对接多个部门才能解决客户问题的经历，当时涉及哪些部门？你如何确保信息不遗漏、进度不延误？\n2. 在顺丰处理客诉时，有没有遇到情绪特别激动的客户？",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你需要同时对接多个部门才能解决客户问题的经历，当时涉及哪些部门？你如何确保信息不遗漏、进度不延误？\n2. 在顺丰处理客诉时，有没有遇到情绪特别激动的客户？你具体如何安抚情绪并推动问题解决？最终客户反馈如何？\n3. 你的两段工作经历时长都在1.5-2年左右，且目前处于离职状态，能否谈谈你对下一份工作的期望？如何看待社群运营专员这个岗位的长期发展？\n4. 假设你负责一个新手妈妈的微信社群，有用户在群内抱怨月嫂服务不达标并引发其他用户跟风，你会如何处理？请分步骤说明。\n5. 如果要求你每天跟踪\"转介绍线索转化率\"并输出报表，你会设计哪些核心指标？如何用Excel或工具实现自动化追踪？",
    "capabilityMatch": "1. **社群运营能力：1/5分。依据：简历无社群运营经验，仅有客户电话回访与一对一沟通经历，未涉及社群场景下的氛围维护、活动发布、规则同步等核心动作。**\n2. **数据处理能力：2/5分。依据：具备基础表格登记与记录能力，但JD要求的\"每日输出运营数据报表、更新关键指标、辅助策略优化\"等分析性工作无直接证据支撑。**\n3. **渠道管理能力：0/5分。依据：简历无任何转介绍渠道管理、线索录入、营销活动触达相关经历，该维度完全空白。**\n4. **协作沟通能力：3/5分。依据：客户代表岗位涉及\"组织协调内外部资源\"，客诉岗位体现跨部门反馈与问题升级机制，具备基础沟通协作意识，但未涉及\"友商\"合作场景。**\n5. **执行推进能力：3/5分。依据：客诉岗位明确\"主动识别风险、及时反馈、协助推动闭环\"，客户代表岗位有\"项目全流程实施\"经历，体现一定主动性；但\"push待办事项\"的管理行为未验证。**",
    "created": ""
  },
  {
    "id": 82,
    "name": "马悦萱",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "研究生学历",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "马",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "候选人具备完整的社群运营+数据分析+跨部门协作经验，游戏运营经历中沉淀了用户留存、活动策划、KOL联动等核心能力，可直接迁移至家政服务社群运营；传媒背景擅长内容产出与舆情管理，契合天鹅到家标准化、数字化运营需求。",
    "risks": "研究生学历应聘6-8K基础岗存在明显overqualified风险，职业稳定性存疑；无家政/本地生活行业经验，母婴护理、保洁标准等垂直知识需从零补足；Animate兼职与全职岗位时间重叠，需核实实际投入度；需警惕多线程任务（全职+兼职）下的实际执行力。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n候选人具备完整的社群运营+数据分析+跨部门协作经验，游戏运营经历中沉淀了用户留存、活动策划、KOL联动等核心能力，可直接迁移至家政服务社群运营；传媒背景擅长内容产出与舆情管理，契合天鹅到家标准化、数字化运营需求。\n\n风险点:\n研究生学历应聘6-8K基础岗存在明显overqualified风险，职业稳定性存疑；无家政/本地生活行业经验，母婴护理、保洁标准等垂直知识需从零补足；Animate兼职与全职岗位时间重叠，需核实实际投入度。\n\n能力维度匹配:\n1. **能力1 社群运营能力：4/5分。依据：Animate门店微博运营（周更5-7条、互动率提升15%）、游戏内活动策划（DAU提升5%）、IP孵化中的用户洞察经验，覆盖答疑、氛围维护、活动发布全链路，但缺乏大规模社群（500+人）管理实证。\n2. **能力2 数据处理能力：4/5分。依据：游戏运营中搭建用户行为分析模型、输出20+份周月报、推动留存率提升5%；品牌公关阶段产出20+份舆情周报，具备数据跟踪-分析-反哺策略的完整闭环能力。\n3. **能力3 渠道管理能力：2/5分。依据：简历未直接体现转介绍渠道管理或线索录入经验；最接近的是网络文学平台的\"作者挖掘\"（筛选200+潜力作者），属于供给侧拓展而非需求侧渠道运营，匹配度有限。\n4. **能力4 协作沟通能力：4/5分。依据：S级品牌项目中串联5+跨部门团队建立协同机制；游戏版本更新统筹20+KOL内容共创；Animate门店现场处理突发事件，具备多场景沟通与危机应对经验。\n5. **能力5 执行推进能力：4/5分。依据：多次使用\"主导\"\"独立负责\"\"从0到1搭建\"等表述；游戏运营中\"主动push待",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 在S级品牌项目中，你提到串联5+跨部门团队，请描述一次与设计或产品部门出现严重分歧的具体场景，你是如何push事项推进的？最终结果如何？\n2. Animate门店运营中遇到的最棘手客诉是什么？你如何判断用户真实需求并调整策略？请用STAR法则说明。\n3. 你目前的学历背景和实习经历都偏向传媒/游戏行业，为什么选择应聘家政服务领域的基础运营岗？未来2-3年的职业规划是什么？\n4. 假设雏渐肥社群中有用户投诉保洁师服务态度问题并在群内引发负面讨论，请简述你的应急处理SOP和话术框架。\n5. 请现场设计一个针对老用户的转介绍激励活动方案，需包含：活动主题、核心玩法、数据追踪指标及预期ROI逻辑。",
    "capabilityMatch": "1. **能力1 社群运营能力：4/5分。依据：Animate门店微博运营（周更5-7条、互动率提升15%）、游戏内活动策划（DAU提升5%）、IP孵化中的用户洞察经验，覆盖答疑、氛围维护、活动发布全链路，但缺乏大规模社群（500+人）管理实证。\n2. **能力2 数据处理能力：4/5分。依据：游戏运营中搭建用户行为分析模型、输出20+份周月报、推动留存率提升5%；品牌公关阶段产出20+份舆情周报，具备数据跟踪-分析-反哺策略的完整闭环能力。\n3. **能力3 渠道管理能力：2/5分。依据：简历未直接体现转介绍渠道管理或线索录入经验；最接近的是网络文学平台的\"作者挖掘\"（筛选200+潜力作者），属于供给侧拓展而非需求侧渠道运营，匹配度有限。\n4. **能力4 协作沟通能力：4/5分。依据：S级品牌项目中串联5+跨部门团队建立协同机制；游戏版本更新统筹20+KOL内容共创；Animate门店现场处理突发事件，具备多场景沟通与危机应对经验。\n5. **能力5 执行推进能力：4/5分。依据：多次使用\"主导\"\"独立负责\"\"从0到1搭建\"等表述；游戏运营中\"主动push待办事项\"特征与JD高度吻合；但需警惕多线程任务（全职+兼职）下的实际执行力。",
    "created": ""
  },
  {
    "id": 83,
    "name": "骆弟翔",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "骆",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "无",
    "strengths": "候选人具备扎实的用户运营与数据处理能力，在贵阳移动实习中完成日均20+人次用户答疑及98%准确率的数据清洗，与家政服务数字化运营高度契合；校团委经历体现10人团队管理与标准化流程建设能力，可迁移至社群规模化管理。",
    "risks": "缺乏纯线上社群运营经验（现有经历偏重线下/电话触达）；转介绍渠道管理为零经验；财政学专业背景与家政行业关联度弱，需评估职业稳定性及行业认知；仅一年以内实习经验，独立承担多线程任务抗压性待验证。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n候选人具备扎实的用户运营与数据处理能力，在贵阳移动实习中完成日均20+人次用户答疑及98%准确率的数据清洗，与家政服务数字化运营高度契合；校团委经历体现10人团队管理与标准化流程建设能力，可迁移至社群规模化管理。\n\n风险点:\n缺乏纯线上社群运营经验（现有经历偏重线下/电话触达）；转介绍渠道管理为零经验；财政学专业背景与家政行业关联度弱，需评估职业稳定性及行业认知；仅一年以内实习经验，独立承担多线程任务抗压性待验证。\n\n能力维度匹配:\n1. **社群运营能力：3/5分。依据：有用户答疑、氛围维护经验（贵阳移动日均20+人次接待，满意度95%），但缺乏微信/企微社群工具实操，无活动发布、规则同步等线上场景证据。\n2. **数据处理能力：4/5分。依据：Excel熟练度高（透视表、XLOOKUP、SUMIFS），日均处理300+组台账，输出8份/月月报；有异常值校验意识，但缺乏\"每日输出\"高频节奏验证。\n3. **渠道管理能力：1/5分。依据：简历无任何转介绍、线索录入、渠道维护经验，属明显能力缺口。\n4. **协作沟通能力：3.5/5分。依据：跨部门对接经验丰富（10+部门数据收集、5+学生组织协作），有流程优化推动案例；但缺乏\"友商\"外部合作及返佣、礼品发放等商务场景经验。\n5. **执行推进能力：4/5分。依据：主动建立标准化模板解决数据口径问题，制定《稿件审核流程表》压缩30%时长，体现\"主动push\"特质；但实习周期均较短（4-5个月），长期稳定性存疑。\n\n面试问题:\n1. 请描述一次你需要同时对接多个部门/团队推进项目的经历，当时遇到了什么阻力，你如何主动push确保进度？\n2. 在贵阳移动实习中，",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你需要同时对接多个部门/团队推进项目的经历，当时遇到了什么阻力，你如何主动push确保进度？\n2. 在贵阳移动实习中，客户满意度达95%，能否分享一个处理棘手用户投诉的具体案例，你如何平衡公司规则与用户体验？\n3. 你的实习经历集中在2025年，且专业为财政学，选择社群运营方向而非财务/数据分析本职岗位，职业规划是怎样的？如何看待家政服务行业的长期发展？\n4. 假设你需要运营一个200人的月嫂服务转介绍社群，请设计一套7天新人入群SOP（含欢迎语、规则同步、首次互动活动），并说明如何用Excel追踪线索转化率。\n5. 转介绍用户常因礼品发放延迟产生抱怨，你如何设计一套可视化进度查询机制，既能减轻人工答疑压力，又能提升用户信任？",
    "capabilityMatch": "1. **社群运营能力：3/5分。依据：有用户答疑、氛围维护经验（贵阳移动日均20+人次接待，满意度95%），但缺乏微信/企微社群工具实操，无活动发布、规则同步等线上场景证据。\n2. **数据处理能力：4/5分。依据：Excel熟练度高（透视表、XLOOKUP、SUMIFS），日均处理300+组台账，输出8份/月月报；有异常值校验意识，但缺乏\"每日输出\"高频节奏验证。\n3. **渠道管理能力：1/5分。依据：简历无任何转介绍、线索录入、渠道维护经验，属明显能力缺口。\n4. **协作沟通能力：3.5/5分。依据：跨部门对接经验丰富（10+部门数据收集、5+学生组织协作），有流程优化推动案例；但缺乏\"友商\"外部合作及返佣、礼品发放等商务场景经验。\n5. **执行推进能力：4/5分。依据：主动建立标准化模板解决数据口径问题，制定《稿件审核流程表》压缩30%时长，体现\"主动push\"特质；但实习周期均较短（4-5个月），长期稳定性存疑。",
    "created": ""
  },
  {
    "id": 84,
    "name": "黄女士",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "黄",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "26岁",
    "gender": "女",
    "strengths": "4年私域运营经验，擅长从0到1搭建社群体系，21个社群月均退群率仅8.54%，数据驱动意识强（每日输出报表、ARPU值追踪），与天鹅到家数字化、标准化运营高度契合；具备转介绍渠道维护经验，可直接迁移至家政顾问转介绍场景。",
    "risks": "期望薪资8-10K高于JD标注的6-8K，存在薪酬谈判风险；过往聚焦健康食品/保健品高客单价品类，家政服务低客单价、高频次、强信任背书的模式差异需适应；26岁4年经验换过2份工作，稳定性需验证。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n4年私域运营经验，擅长从0到1搭建社群体系，21个社群月均退群率仅8.54%，数据驱动意识强（每日输出报表、ARPU值追踪），与天鹅到家数字化、标准化运营高度契合；具备转介绍渠道维护经验，可直接迁移至家政顾问转介绍场景。\n\n风险点:\n期望薪资8-10K高于JD标注的6-8K，存在薪酬谈判风险；过往聚焦健康食品/保健品高客单价品类，家政服务低客单价、高频次、强信任背书的模式差异需适应；26岁4年经验换过2份工作，稳定性需验证。\n\n能力维度匹配:\n1. **能力1-社群运营能力：5/5分。依据：运营21个自有社群，负责日常答疑、氛围维护、活动发布、选品排期，用户月均退群率8.54%，直接匹配JD\"用户答疑、氛围维护、活动发布、规则同步\"要求。**\n2. **能力2-数据处理能力：4/5分。依据：明确提及\"每日输出运营数据报表\"\"更新关键指标\"\"数据驱动业务决策\"，具备数据跟踪与复盘习惯，但未明确提及\"线索进度\"类B端指标。**\n3. **能力3-渠道管理能力：3/5分。依据：有\"分销商活跃度维护\"经验，但JD强调的\"转介绍渠道线索录入、月度营销活动触达\"属家政顾问场景，健康食品分销与家政服务转介绍逻辑差异较大，需确认迁移能力。**\n4. **能力4-协作沟通能力：4/5分。依据：有\"配合达人策划脚本\"\"与友商及合作部门沟通\"经验，但未明确涉及\"活动返佣、礼品发放\"等财务流程协作，需追问细节。**\n5. **能力5-执行推进能力：4/5分。依据：简历强调\"主动跟进问题不推诿不拖延\"，但未提供具体案例（如跨部门push、紧急项目救火），需面试验证\"主动push待办事项\"的实操表现。**\n\n面试问题:\n1. 请描述",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你需要同时协调达人、供应链、设计多方资源，推动活动上线的经历——当时最大的冲突是什么？你如何push进度？\n2. 健康食品用户与家政服务用户决策周期差异很大，能否举例说明你如何处理过高客单价用户的长期信任建立，或低频次用户的激活？\n3. 你两份工作间隔约1年4个月，且期望薪资高于我们标注范围，能否说明选择天鹅到家的核心动机，以及未来2-3年的职业规划？\n4. 假设你负责月嫂/育儿嫂顾问的转介绍社群，用户反馈“推荐的家政员技能很好但性格不合”，你会如何在社群中回应并转化这条线索？\n5. 请现场说明：如果每日需要输出“转介绍线索录入数-触达数-转化率”报表，你会用Excel还是BI工具？如何设计自动化减少重复劳动？\n6. 今天的交流到此，我想把话筒交给你——基于刚才的沟通，关于天鹅到家的社群运营体系、这个岗位未来3个月的挑战，或者我们团队的工作方式，你有什么想深入了解的吗？",
    "capabilityMatch": "1. **能力1-社群运营能力：5/5分。依据：运营21个自有社群，负责日常答疑、氛围维护、活动发布、选品排期，用户月均退群率8.54%，直接匹配JD\"用户答疑、氛围维护、活动发布、规则同步\"要求。**\n2. **能力2-数据处理能力：4/5分。依据：明确提及\"每日输出运营数据报表\"\"更新关键指标\"\"数据驱动业务决策\"，具备数据跟踪与复盘习惯，但未明确提及\"线索进度\"类B端指标。**\n3. **能力3-渠道管理能力：3/5分。依据：有\"分销商活跃度维护\"经验，但JD强调的\"转介绍渠道线索录入、月度营销活动触达\"属家政顾问场景，健康食品分销与家政服务转介绍逻辑差异较大，需确认迁移能力。**\n4. **能力4-协作沟通能力：4/5分。依据：有\"配合达人策划脚本\"\"与友商及合作部门沟通\"经验，但未明确涉及\"活动返佣、礼品发放\"等财务流程协作，需追问细节。**\n5. **能力5-执行推进能力：4/5分。依据：简历强调\"主动跟进问题不推诿不拖延\"，但未提供具体案例（如跨部门push、紧急项目救火），需面试验证\"主动push待办事项\"的实操表现。**",
    "created": ""
  },
  {
    "id": 85,
    "name": "于欣悦",
    "role": "招商专员",
    "company": "",
    "years": 0,
    "edu": "应届在校生",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "于",
    "dept": "",
    "city": "杭州",
    "age": "无",
    "gender": "女",
    "strengths": "有家政行业招聘实操经验（育婴师/月嫂），电话邀约成功率85%+，擅长社群运营与线下活动统筹，具备从0到1的渠道运营和团队管理经验，结果导向强，与天鹅到家数字化招聘场景高度契合。",
    "risks": "应届在校生（2026年毕业），实习经历均为短期（3-4个月），稳定性存疑；无B端商家合作开发经验，商家谈判与分成机制设计能力未验证；缺乏家政行业深度资源积累。",
    "aiEval": "以下为候选人的 招商专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：蓝领招聘专员\n🏢 招聘岗位：招商专员\n\n初筛结果: 通过\n\n优势分析:\n有家政行业招聘实操经验（育婴师/月嫂），电话邀约成功率85%+，擅长社群运营与线下活动统筹，具备从0到1的渠道运营和团队管理经验，结果导向强，与天鹅到家数字化招聘场景高度契合。\n\n风险点:\n应届在校生（2026年毕业），实习经历均为短期（3-4个月），稳定性存疑；无B端商家合作开发经验，商家谈判与分成机制设计能力未验证；缺乏家政行业深度资源积累。\n\n能力维度匹配:\n1. **渠道拓展能力：4/5分。依据：独立运营2个招聘账号，统筹5场线下招聘会，电话/线上渠道运维成熟；但家政阿姨专属渠道（社群/转介绍）及B端商家开发经验不足。\n2. **资源维护能力：3/5分。依据：完成家政阿姨面试邀约与入职跟进，建立长期合作意识；但缺乏商家履约跟进、分层维护及平台入驻流程实操经验。\n3. **沟通协调能力：4/5分。依据：累计沟通候选人4000+，晋升招聘组长统筹团队，跨部门协作经验丰富；但商家谈判、分成机制设计等B端复杂场景未涉及。\n4. **活动组织能力：3/5分。依据：统筹大型招聘会全流程，运营学院公众号推文20+篇；但阿姨社群维护、转介绍激励活动设计等垂直场景无直接经验。\n5. **资源整合能力：2/5分。依据：有内部推荐渠道配合意识，同时接触C端阿姨与B端家政公司；但缺乏\"阿姨+商家\"双资源并行维护的系统性实践，无行业资源（养老院/月子中心等）积累。\n\n面试问题:\n1. 请描述一次你处理候选人强烈异议或投诉的经历，当时如何沟通化解？（沟通协调+客户服务）\n2. 你的实习均为3-4个月，如果加入天鹅到家，如何看待家政行业需要长期深耕资源的特点？（稳定性）\n3. 作为招聘组长，你如何激励团队成员完成高压指标？请举例说明。（团队管理+",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "蓝领招聘专员",
    "interviewQ": "1. 请描述一次你处理候选人强烈异议或投诉的经历，当时如何沟通化解？\n2. 你的实习均为3-4个月，如果加入天鹅到家，如何看待家政行业需要长期深耕资源的特点？\n3. 作为招聘组长，你如何激励团队成员完成高压指标？请举例说明。\n4. 假设你需要开发一家本地家政公司作为合作渠道，请简述你的陌拜话术框架和分成谈判思路。\n5. 阿姨入职后流失率高是行业痛点，你会如何设计社群运营动作提升留存和转介绍率？",
    "capabilityMatch": "1. **渠道拓展能力：4/5分。依据：独立运营2个招聘账号，统筹5场线下招聘会，电话/线上渠道运维成熟；但家政阿姨专属渠道（社群/转介绍）及B端商家开发经验不足。**\n2. **资源维护能力：3/5分。依据：完成家政阿姨面试邀约与入职跟进，建立长期合作意识；但缺乏商家履约跟进、分层维护及平台入驻流程实操经验。**\n3. **沟通协调能力：4/5分。依据：累计沟通候选人4000+，晋升招聘组长统筹团队，跨部门协作经验丰富；但商家谈判、分成机制设计等B端复杂场景未涉及。**\n4. **活动组织能力：3/5分。依据：统筹大型招聘会全流程，运营学院公众号推文20+篇；但阿姨社群维护、转介绍激励活动设计等垂直场景无直接经验。**\n5. **资源整合能力：2/5分。依据：有内部推荐渠道配合意识，同时接触C端阿姨与B端家政公司；但缺乏\"阿姨+商家\"双资源并行维护的系统性实践，无行业资源（养老院/月子中心等）积累。**",
    "created": ""
  },
  {
    "id": 86,
    "name": "俞奕帆",
    "role": "招商专员",
    "company": "",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "俞",
    "dept": "",
    "city": "杭州",
    "age": "无",
    "gender": "无相关性别信息",
    "strengths": "有基础招聘经验（简历筛选、面试组织、校招参与），具备社群运营意识（学生会部长带团队、跨部门沟通），设计能力突出可辅助宣传物料制作，学习能力强（专业前30%、多奖项），年轻有活力适合一线地推场景。",
    "risks": "期望薪资2-6K与岗位6-10K差距大，稳定性存疑；无家政/中介/销售经验，缺乏B端商家谈判和阿姨资源维护实战；实习均为短期（1-2个月），未体现长期客户关系维护；求职意向为\"行政\"与\"招商专员\"岗位性质偏差。",
    "aiEval": "以下为候选人的 招商专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：蓝领招聘专员\n🏢 招聘岗位：招商专员\n\n初筛结果: 存疑\n\n优势分析:\n有基础招聘经验（简历筛选、面试组织、校招参与），具备社群运营意识（学生会部长带团队、跨部门沟通），设计能力突出可辅助宣传物料制作，学习能力强（专业前30%、多奖项），年轻有活力适合一线地推场景。\n\n风险点:\n期望薪资2-6K与岗位6-10K差距大，稳定性存疑；无家政/中介/销售经验，缺乏B端商家谈判和阿姨资源维护实战；实习均为短期（1-2个月），未体现长期客户关系维护；求职意向为\"行政\"与\"招商专员\"岗位性质偏差。\n\n能力维度匹配:\n1. **1. 渠道拓展能力：2/5分。依据：有校招、招聘渠道拓宽经验，但无家政行业渠道（社群/电话/家政公司合作）实操，未体现阿姨招募或B端商家开发经历。**\n2. **2. 资源维护能力：2/5分。依据：学生会经费管理有流程意识，但实习均为短期执行岗，无长期客户关系或劳动者入驻跟进经验，未体现\"两类资源\"同时维护。**\n3. **3. 沟通协调能力：3/5分。依据：学生会部长带团队、跨部门沟通、国际客户邮件沟通有基础，但无商务谈判、分成机制制定、合作协议签订等B端关键经验。**\n4. **4. 活动组织能力：3/5分。依据：学生会活动经费管理、社会实践项目组织有经验，但无阿姨社群维护、转介绍活动策划等家政场景实操。**\n5. **5. 资源整合能力：2/5分。依据：设计+管理复合背景有潜力，但无家政行业资源（养老院/社区/月子中心等），未体现\"为岗位服务\"的资源整合意识。**\n\n面试问题:\n1. 你曾在学生会担任部长，请举例说明如何处理部门间冲突或推动跨部门协作？这与我们协调阿姨和商家两类不同群体有何相似性？\n2. 你在文具公司对接国际客户时，遇到过最难处理的客户需求是什么？如何解决的？这与",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "蓝领招聘专员",
    "interviewQ": "1. 你曾在学生会担任部长，请举例说明如何处理部门间冲突或推动跨部门协作？这与我们协调阿姨和商家两类不同群体有何相似性？\n2. 你在文具公司对接国际客户时，遇到过最难处理的客户需求是什么？如何解决的？这与处理阿姨入驻抱怨或商家履约问题有何借鉴？\n3. 你的实习周期都较短（1-2个月），且求职意向是行政，能否说明为何选择招商专员这个偏销售的岗位？未来2-3年职业规划是什么？\n4. 如果让你一周内招募10位月嫂，你会选择哪些渠道？具体如何触达和转化？\n5. 假设一家家政公司已有固定合作平台，你会如何设计合作方案说服其同时与我们合作？关键谈判点是什么？",
    "capabilityMatch": "1. **1. 渠道拓展能力：2/5分。依据：有校招、招聘渠道拓宽经验，但无家政行业渠道（社群/电话/家政公司合作）实操，未体现阿姨招募或B端商家开发经历。**\n2. **2. 资源维护能力：2/5分。依据：学生会经费管理有流程意识，但实习均为短期执行岗，无长期客户关系或劳动者入驻跟进经验，未体现\"两类资源\"同时维护。**\n3. **3. 沟通协调能力：3/5分。依据：学生会部长带团队、跨部门沟通、国际客户邮件沟通有基础，但无商务谈判、分成机制制定、合作协议签订等B端关键经验。**\n4. **4. 活动组织能力：3/5分。依据：学生会活动经费管理、社会实践项目组织有经验，但无阿姨社群维护、转介绍活动策划等家政场景实操。**\n5. **5. 资源整合能力：2/5分。依据：设计+管理复合背景有潜力，但无家政行业资源（养老院/社区/月子中心等），未体现\"为岗位服务\"的资源整合意识。**",
    "created": ""
  },
  {
    "id": 87,
    "name": "王女士",
    "role": "招商专员",
    "company": "",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "王",
    "dept": "",
    "city": "杭州",
    "age": "50岁",
    "gender": "女",
    "strengths": "有基础招聘经验（简历筛选、面试邀约），具备活动策划与社群运营经历（党务宣传部干事、班干部），沟通协调能力有初步体现；英语能力较好，办公软件熟练。",
    "risks": "零家政/销售/BD行业经验，无阿姨或商家资源积累；期望薪资6-8K与岗位6-10K区间匹配但偏下限；实习仅3个月且明确拒绝转正，稳定性存疑；岗位核心要求\"善沟通会来事\"偏向市井亲和力，候选人履历偏行政文书风格。",
    "aiEval": "以下为候选人的 招商专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：蓝领招聘专员\n🏢 招聘岗位：招商专员\n\n初筛结果: 存疑\n\n优势分析:\n有基础招聘经验（简历筛选、面试邀约），具备活动策划与社群运营经历（党务宣传部干事、班干部），沟通协调能力有初步体现；英语能力较好，办公软件熟练。\n\n风险点:\n零家政/销售/BD行业经验，无阿姨或商家资源积累；期望薪资6-8K与岗位6-10K区间匹配但偏下限；实习仅3个月且明确拒绝转正，稳定性存疑；岗位核心要求\"善沟通会来事\"偏向市井亲和力，候选人履历偏行政文书风格。\n\n能力维度匹配:\n1. **1. 渠道拓展能力：2/5分。依据：仅有HR端简历筛选经验，无主动陌拜、地推、渠道开拓行为；未体现电话销售、社群转化、B端合作开发等家政招募场景能力。**\n2. **2. 资源维护能力：2/5分。依据：无阿姨群体或家政商家服务经验；行政实习涉及文档整理与群众接待，但非长期关系维护与履约跟进场景。**\n3. **3. 沟通协调能力：3/5分。依据：具备HR面试沟通、班级活动协调、群众矛盾调解经验；但缺乏商务谈判、分成机制设计、合作协议签订等BD场景验证。**\n4. **4. 活动组织能力：3/5分。依据：有大型活动策划组织经验（班干部、党务宣传部），含邀约、现场执行、公众号产出全流程；但未体现阿姨社群运营与转介绍裂变设计。**\n5. **5. 资源整合能力：2/5分。依据：无家政行业资源（养老院/社区/月子中心等）积累；简历未体现同时维护两类异质资源的意识或经验。**\n\n面试问题:\n1. 请描述一次你主动说服他人接受你方案的经历，当时对方有什么顾虑，你具体如何沟通解决的？\n2. 你的实习获得转正offer却选择拒绝，如果未来天鹅到家培养你半年后，你遇到更心仪的机会会如何处理？\n3. 假设一位50岁的阿姨对智能手机操作不熟悉，入驻平台时反",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "蓝领招聘专员",
    "interviewQ": "1. 请描述一次你主动说服他人接受你方案的经历，当时对方有什么顾虑，你具体如何沟通解决的？\n2. 你的实习获得转正offer却选择拒绝，如果未来天鹅到家培养你半年后，你遇到更心仪的机会会如何处理？\n3. 假设一位50岁的阿姨对智能手机操作不熟悉，入驻平台时反复出错且情绪激动，你会如何服务她完成流程？\n4. 如果你需要在一个月内通过社群运营招募30位月嫂，请简述你的执行计划，包括渠道选择、转化路径和激励设计。\n5. 假设你成功签约一家家政公司作为合作商家，但对方连续两周未按约定输送阿姨，你会如何跟进处理？",
    "capabilityMatch": "1. **1. 渠道拓展能力：2/5分。依据：仅有HR端简历筛选经验，无主动陌拜、地推、渠道开拓行为；未体现电话销售、社群转化、B端合作开发等家政招募场景能力。**\n2. **2. 资源维护能力：2/5分。依据：无阿姨群体或家政商家服务经验；行政实习涉及文档整理与群众接待，但非长期关系维护与履约跟进场景。**\n3. **3. 沟通协调能力：3/5分。依据：具备HR面试沟通、班级活动协调、群众矛盾调解经验；但缺乏商务谈判、分成机制设计、合作协议签订等BD场景验证。**\n4. **4. 活动组织能力：3/5分。依据：有大型活动策划组织经验（班干部、党务宣传部），含邀约、现场执行、公众号产出全流程；但未体现阿姨社群运营与转介绍裂变设计。**\n5. **5. 资源整合能力：2/5分。依据：无家政行业资源（养老院/社区/月子中心等）积累；简历未体现同时维护两类异质资源的意识或经验。**",
    "created": ""
  },
  {
    "id": 88,
    "name": "顾志艳",
    "role": "招商专员",
    "company": "",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "顾",
    "dept": "",
    "city": "杭州",
    "age": "32岁",
    "gender": "无",
    "strengths": "具备文字表达、活动策划及社群运营基础经验（校园记者团、公众号运营）；有兼职服务类工作背景（旅行管家、旅游报告撰写），体现一定客户沟通意识；持多类资格证书，学习能力尚可。",
    "risks": "完全缺乏家政/中介/销售/商务拓展等核心经验；无阿姨招募、商家合作、渠道开发等直接相关背景；职业路径偏向内容采编与文化宣传，与ToB招商及蓝领招募场景脱节；32岁转行至基础执行岗，动机与稳定性存疑。",
    "aiEval": "以下为候选人的 招商专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：蓝领招聘专员\n🏢 招聘岗位：招商专员\n\n初筛结果: 淘汰\n\n优势分析:\n具备文字表达、活动策划及社群运营基础经验（校园记者团、公众号运营）；有兼职服务类工作背景（旅行管家、旅游报告撰写），体现一定客户沟通意识；持多类资格证书，学习能力尚可。\n\n风险点:\n完全缺乏家政/中介/销售/商务拓展等核心经验；无阿姨招募、商家合作、渠道开发等直接相关背景；职业路径偏向内容采编与文化宣传，与ToB招商及蓝领招募场景脱节；32岁转行至基础执行岗，动机与稳定性存疑。\n\n能力维度匹配:\n1. **1. 渠道拓展能力：0/5分。依据：简历中无任何电话销售、社群招募、家政公司合作、渠道开发等经验，与岗位核心要求完全不符。**\n2. **2. 资源维护能力：1/5分。依据：仅有兼职旅行管家处理客户问题的经历，无阿姨入驻引导、商家履约跟进等双边资源维护经验。**\n3. **3. 沟通协调能力：2/5分。依据：校园记者采访、企业宣传文稿撰写体现基础沟通能力，但缺乏商务谈判、分成机制设计、合作协议签订等ToB场景经验。**\n4. **4. 活动组织能力：2/5分。依据：有校园社团活动组织及企业会议策划经验，但无阿姨社群维护、转介绍活动组织等针对性经历。**\n5. **5. 资源整合能力：1/5分。依据：无家政行业资源（养老院/社区/月子中心等），无同时维护劳动者与商家两类资源的意识或实践。**\n\n面试问题:\n1. 请描述一次你需要同时协调多方需求并达成目标的经历，当时如何平衡不同方的利益？\n2. 你过往工作中最需\"耐着性子\"处理人际冲突的场景是什么？具体如何应对？\n3. 从稳定的文化宣传岗位转向家政行业基础招商岗，职业动机是什么？如何看待3-5年发展路径？\n4. 假设需在一周内招募20名育儿嫂，你会如何设计线上线下渠道组合方案",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "蓝领招聘专员",
    "interviewQ": "1. 请描述一次你需要同时协调多方需求并达成目标的经历，当时如何平衡不同方的利益？\n2. 你过往工作中最需\"耐着性子\"处理人际冲突的场景是什么？具体如何应对？\n3. 从稳定的文化宣传岗位转向家政行业基础招商岗，职业动机是什么？如何看待3-5年发展路径？\n4. 假设需在一周内招募20名育儿嫂，你会如何设计线上线下渠道组合方案？\n5. 若合作家政公司要求提高分成比例，你将如何谈判并制定替代方案？",
    "capabilityMatch": "1. **1. 渠道拓展能力：0/5分。依据：简历中无任何电话销售、社群招募、家政公司合作、渠道开发等经验，与岗位核心要求完全不符。**\n2. **2. 资源维护能力：1/5分。依据：仅有兼职旅行管家处理客户问题的经历，无阿姨入驻引导、商家履约跟进等双边资源维护经验。**\n3. **3. 沟通协调能力：2/5分。依据：校园记者采访、企业宣传文稿撰写体现基础沟通能力，但缺乏商务谈判、分成机制设计、合作协议签订等ToB场景经验。**\n4. **4. 活动组织能力：2/5分。依据：有校园社团活动组织及企业会议策划经验，但无阿姨社群维护、转介绍活动组织等针对性经历。**\n5. **5. 资源整合能力：1/5分。依据：无家政行业资源（养老院/社区/月子中心等），无同时维护劳动者与商家两类资源的意识或实践。**",
    "created": ""
  },
  {
    "id": 89,
    "name": "高雯",
    "role": "招商专员",
    "company": "劳动者增长部",
    "years": 0,
    "edu": "临床医学大专",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "高",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "无",
    "gender": "女",
    "strengths": "具备医疗背景（临床医学大专）与医院实习经历，对母婴/护理场景有专业认知；人力资源助理经验涵盖档案数字化、招聘全流程支持及跨部门沟通；性格外向、学习能力强，能快速掌握新工具（AI助手）；有社区健康宣讲、脊柱健康筛查等基层outreach经验，与渠道拓展场景有一定契合。",
    "risks": "核心短板为零家政行业经验及零销售/渠道拓展直接经验，岗位要求的\"月子中心、社区医院渠道开拓\"无过往实证；临床医学背景与蓝领招聘目标群体差异大，可能存在职业认同感落差；2026年6月才毕业，当前为实习阶段，全职到岗时间与稳定性存疑。",
    "aiEval": "以下为候选人的 招商专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：蓝领招聘专员\n🏢 招聘岗位：招商专员\n\n初筛结果: 存疑\n\n优势分析:\n具备医疗背景（临床医学大专）与医院实习经历，对母婴/护理场景有专业认知；人力资源助理经验涵盖档案数字化、招聘全流程支持及跨部门沟通；性格外向、学习能力强，能快速掌握新工具（AI助手）；有社区健康宣讲、脊柱健康筛查等基层 outreach 经验，与渠道拓展场景有一定契合。\n\n风险点:\n核心短板为零家政行业经验及零销售/渠道拓展直接经验，岗位要求的\"月子中心、社区医院渠道开拓\"无过往实证；临床医学背景与蓝领招聘目标群体差异大，可能存在职业认同感落差；2026年6月才毕业，当前为实习阶段，全职到岗时间与稳定性存疑。\n\n能力维度匹配:\n1. **沟通协调能力：3/5分**。依据：健康宣讲、患者沟通、招聘面试接待有实践，但缺乏针对蓝领劳动者（阿姨群体）的沟通经验，群体画像差异大。\n2. **渠道拓展能力：1/5分**。依据：无任何B端渠道开拓、商务洽谈或合作建联经验，\"主动联系月子中心洽谈合作\"为零基础。\n3. **关系维护能力：2/5分**。依据：有档案管理、定期回访的数据支撑意识，但无劳动者关系维护、转介绍激励的实际案例。\n4. **信息整合能力：3/5分**。依据：3000+份档案电子化、检索系统搭建、数据分类整理有实证，但缺乏渠道有效性分析、策略优化经验。\n5. **学习适应能力：4/5分**。依据：跨专业快速掌握HR实务、主动学习AI工具、医学课程繁重下维持优异GPA，学习曲线陡峭但历史表现佳。\n\n面试问题:\n1. \"你曾在株洲职大参与招聘全流程，请描述一次你需要说服一位候选人接受岗位或完成入职手续的经历，当时对方有什么顾虑，你如何沟通解决的？\"\n2. \"你的专业背景是临床医学，目标岗位是面向阿姨群体的蓝领招聘，这个跨度较大",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "蓝领招聘专员",
    "interviewQ": "1. \"你曾在株洲职大参与招聘全流程，请描述一次你需要说服一位候选人接受岗位或完成入职手续的经历，当时对方有什么顾虑，你如何沟通解决的？\"\n2. \"你的专业背景是临床医学，目标岗位是面向阿姨群体的蓝领招聘，这个跨度较大，请分享你主动了解一个陌生行业或群体的具体做法，举例说明。\"\n3. \"这份工作需要大量电话/微信跟进阿姨完成资质审核，重复性高且可能遭遇拒绝，你过往经历中哪段工作最能体现你对这类事务的耐心和抗压能力？\"\n4. \"假设你联系到一位有5年经验的月嫂，她对线上资质审核流程不熟悉且担心隐私泄露，你会如何一步步建立信任并推动她完成入驻？请模拟关键话术。\"\n5. \"如果你需要开拓社区医院渠道获取育婴师资源，但对方负责人以'没有合作先例'为由拒绝，你准备如何破冰？请列出你的准备清单和首次沟通策略。\"",
    "capabilityMatch": "1. **沟通协调能力：3/5分**。依据：健康宣讲、患者沟通、招聘面试接待有实践，但缺乏针对蓝领劳动者（阿姨群体）的沟通经验，群体画像差异大。\n2. **渠道拓展能力：1/5分**。依据：无任何B端渠道开拓、商务洽谈或合作建联经验，\"主动联系月子中心洽谈合作\"为零基础。\n3. **关系维护能力：2/5分**。依据：有档案管理、定期回访的数据支撑意识，但无劳动者关系维护、转介绍激励的实际案例。\n4. **信息整合能力：3/5分**。依据：3000+份档案电子化、检索系统搭建、数据分类整理有实证，但缺乏渠道有效性分析、策略优化经验。\n5. **学习适应能力：4/5分**。依据：跨专业快速掌握HR实务、主动学习AI工具、医学课程繁重下维持优异GPA，学习曲线陡峭但历史表现佳。",
    "created": ""
  },
  {
    "id": 90,
    "name": "刘先生",
    "role": "无法提取",
    "company": "",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "刘",
    "dept": "",
    "city": "",
    "age": "35岁",
    "gender": "男",
    "strengths": "13年即时配送管理经验，擅长从0到1搭建团队、标准化SOP制定、服务商渠道管理及数字化运营，与家政服务标准化、职业化高度契合；具备强执行力与跨部门协调能力，有大型平台（京东、盒马、顺丰、饿了么）复杂业务管理经验。",
    "risks": "无家政/家庭服务直接经验，行业切换需适应期；近期4年集中于同一业务线（山姆云仓），长期稳定性存疑；年龄35岁，职业转型动机需验证；期望薪资20-25K与BD主管岗位预算可能不匹配。",
    "aiEval": "以下为候选人的 无法提取 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：无法提取\n🏢 招聘岗位：无法提取\n\n初筛结果: 通过\n\n优势分析:\n13年即时配送管理经验，擅长从0到1搭建团队、标准化SOP制定、服务商渠道管理及数字化运营，与家政服务标准化、职业化高度契合；具备强执行力与跨部门协调能力，有大型平台（京东、盒马、顺丰、饿了么）复杂业务管理经验。\n\n风险点:\n无家政/家庭服务直接经验，行业切换需适应期；近期4年集中于同一业务线（山姆云仓），长期稳定性存疑；年龄35岁，职业转型动机需验证；期望薪资20-25K与BD主管岗位预算可能不匹配。\n\n能力维度匹配:\n1. **团队搭建与管理能力：5/5分。依据：多次主导从0到1搭建配送团队（京东秒送10家云仓、七鲜首城首店、饿了么10个站点/500人），建立三级管理体系及标准化SOP，人才梯队建设经验丰富。**\n2. **渠道/供应商管理能力：5/5分。依据：10年服务商渠道管理经验，建立供应商绩效考核体系，统筹招标、运营、优化全链路，擅长资源整合与利润改善，与家政服务商管理高度相关。**\n3. **标准化与数字化运营能力：4/5分。依据：精通KPI拆解、数据监控、SOP流程梳理，输出运营数据指导决策，具备强复盘能力；但缺乏家政场景数字化经验。**\n4. **客户服务与体验优化能力：4/5分。依据：主导服务标准化升级、客户满意度提升专项，处理重大突发事件经验丰富；但B端配送与C端家政服务场景差异需关注。**\n5. **行业适配与稳定性：3/5分。依据：物流即时配送与家政服务在\"即时响应、服务标准化、人员管理\"逻辑相通，但行业切换存在学习成本；4年同一业务经历显示专注度，但转型动机待验证。**\n\n面试问题:\n1. 请描述一次您处理服务商重大冲突或突发危机的具体经历，您如何协调多方利益并达成结果？\n2. 您在京东秒送管理山姆云",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "无法提取",
    "interviewQ": "1. 请描述一次您处理服务商重大冲突或突发危机的具体经历，您如何协调多方利益并达成结果？\n2. 您在京东秒送管理山姆云仓4年，是什么因素促使您考虑离开熟悉的物流领域，选择家政服务行业？\n3. 请举例说明您如何通过数据分析和流程优化，将客户满意度或服务质量指标从低位提升至行业前列的具体做法。\n4. 家政服务涉及保洁、保姆、月嫂等多品类，若让您设计一个服务商（家政经纪人/保洁团队）的准入评估和绩效考核体系，您的核心指标和权重会如何设置？\n5. 天鹅到家正在推进服务人员的职业化培训与认证，结合您在顺丰搭建培训体系的经验，您认为家政服务人员培训最大的难点是什么，如何解决？",
    "capabilityMatch": "1. **团队搭建与管理能力：5/5分。依据：多次主导从0到1搭建配送团队（京东秒送10家云仓、七鲜首城首店、饿了么10个站点/500人），建立三级管理体系及标准化SOP，人才梯队建设经验丰富。**\n2. **渠道/供应商管理能力：5/5分。依据：10年服务商渠道管理经验，建立供应商绩效考核体系，统筹招标、运营、优化全链路，擅长资源整合与利润改善，与家政服务商管理高度相关。**\n3. **标准化与数字化运营能力：4/5分。依据：精通KPI拆解、数据监控、SOP流程梳理，输出运营数据指导决策，具备强复盘能力；但缺乏家政场景数字化经验。**\n4. **客户服务与体验优化能力：4/5分。依据：主导服务标准化升级、客户满意度提升专项，处理重大突发事件经验丰富；但B端配送与C端家政服务场景差异需关注。**\n5. **行业适配与稳定性：3/5分。依据：物流即时配送与家政服务在\"即时响应、服务标准化、人员管理\"逻辑相通，但行业切换存在学习成本；4年同一业务经历显示专注度，但转型动机待验证。**",
    "created": ""
  },
  {
    "id": 91,
    "name": "陈叶",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "湖南农业大学在读（2024-2028）",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "陈",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "40-50岁",
    "gender": "无",
    "strengths": "行政管理专业背景，系统学习人力资源课程，具备公文写作、活动策划及跨部门沟通经验；有Python基础及数据工具使用能力，可支撑流量分析；共情力强、沟通高效，适配家政劳动者群体的用户沟通场景；湖南农业大学在读（2024-2028），长沙本地稳定性有保障。",
    "risks": "无互联网运营/内容创作/社群运营实习经验（JD优先项），网感与接地气的招募文案能力未经验证；无Boss直聘等招聘渠道实操经验；可画海报制作能力与\"内容策划\"要求存在差距；数据敏感度仅停留在\"简单分析\"层面，转化优化方法论待考察。",
    "aiEval": "以下为候选人的 劳动者运营实习生 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：劳动者运营实习生（家政业务方向）\n🏢 招聘岗位：劳动者运营实习生\n\n初筛结果: 通过\n\n优势分析:\n行政管理专业背景，系统学习人力资源课程，具备公文写作、活动策划及跨部门沟通经验；有Python基础及数据工具使用能力，可支撑流量分析；共情力强、沟通高效，适配家政劳动者群体的用户沟通场景；湖南农业大学在读（2024-2028），长沙本地稳定性有保障。\n\n风险点:\n无互联网运营/内容创作/社群运营实习经验（JD优先项），网感与接地气的招募文案能力未经验证；无Boss直聘等招聘渠道实操经验；可画海报制作能力与\"内容策划\"要求存在差距；数据敏感度仅停留在\"简单分析\"层面，转化优化方法论待考察。\n\n能力维度匹配:\n1. **内容策划能力：2/5分。依据：具备公文写作、新闻稿撰写经验，但无新媒体内容/招募文案/网感类作品证明；可画使用能力较弱，与\"接地气、有吸引力\"的创意策划要求存在差距。**\n2. **流量分析能力：3/5分。依据：有Python基础及Excel技能，具备数据工具学习潜力；但无实际流量数据跟踪、曝光/点击/转化率分析经验，\"对数据敏感\"仅为自我评价。**\n3. **转化优化能力：2/5分。依据：无A/B测试、渠道优化、招聘话术迭代经验；JD要求的\"测试不同岗位描述话术、福利亮点\"等实操能力在简历中无直接对应。**\n4. **用户沟通能力：4/5分。依据：自我评价\"共情力强、沟通高效、擅长换位思考\"，有面试对接、员工诉求协调、跨部门协作经验；但无家政行业/蓝领劳动者群体沟通场景验证。**\n\n面试问题:\n1. \"请描述一次你需要向不熟悉线上操作的人群（如长辈、基层服务人员）解释复杂流程的经历，你用了什么方法确保对方理解并配合？\"\n2. \"你提到有跨部门沟通经验，如果家政阿姨在报名过程中",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. \"请描述一次你需要向不熟悉线上操作的人群（如长辈、基层服务人员）解释复杂流程的经历，你用了什么方法确保对方理解并配合？\"\n2. \"你提到有跨部门沟通经验，如果家政阿姨在报名过程中反复咨询同一个问题且情绪急躁，你会如何回应并引导她完成留资？\"\n3. \"你的实习周期预计多久？如果3个月后流量数据仍未达预期，你会选择坚持优化还是申请调岗？请结合过往经历说明你的决策依据。\"\n4. \"请现场为'长沙住家育儿嫂'岗位写一段招募文案标题+首句钩子，要求让40-50岁农村女性觉得'这工作适合我'。\"\n5. \"假设Boss直聘上某岗位曝光高但咨询率低，你会从哪些维度拆解原因？请列出你的分析框架和下一步优化动作。\"",
    "capabilityMatch": "1. **内容策划能力：2/5分。依据：具备公文写作、新闻稿撰写经验，但无新媒体内容/招募文案/网感类作品证明；可画使用能力较弱，与\"接地气、有吸引力\"的创意策划要求存在差距。**\n2. **流量分析能力：3/5分。依据：有Python基础及Excel技能，具备数据工具学习潜力；但无实际流量数据跟踪、曝光/点击/转化率分析经验，\"对数据敏感\"仅为自我评价。**\n3. **转化优化能力：2/5分。依据：无A/B测试、渠道优化、招聘话术迭代经验；JD要求的\"测试不同岗位描述话术、福利亮点\"等实操能力在简历中无直接对应。**\n4. **用户沟通能力：4/5分。依据：自我评价\"共情力强、沟通高效、擅长换位思考\"，有面试对接、员工诉求协调、跨部门协作经验；但无家政行业/蓝领劳动者群体沟通场景验证。**",
    "created": ""
  },
  {
    "id": 92,
    "name": "刘俊辰",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "刘",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "无",
    "gender": "无",
    "strengths": "具备数据运营与内容策划复合背景，Python/SQL数据处理能力可支撑流量分析；英语角主持及宣传部副部长经历体现强沟通与活动运营能力；有AI工具辅助文案优化经验，契合家政招募内容创作需求。",
    "risks": "缺乏家政行业认知与劳动者群体沟通经验；实习时间仅2个月，稳定性存疑；无社群运营直接经验，需验证下沉市场内容敏感度；数据可视化工具未提及，流量分析深度或受限。",
    "aiEval": "以下为候选人的 劳动者运营实习生 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：劳动者运营实习生（家政业务方向）\n🏢 招聘岗位：劳动者运营实习生\n\n初筛结果: 通过\n\n优势分析:\n具备数据运营与内容策划复合背景，Python/SQL数据处理能力可支撑流量分析；英语角主持及宣传部副部长经历体现强沟通与活动运营能力；有AI工具辅助文案优化经验，契合家政招募内容创作需求。\n\n风险点:\n缺乏家政行业认知与劳动者群体沟通经验；实习时间仅2个月，稳定性存疑；无社群运营直接经验，需验证下沉市场内容敏感度；数据可视化工具未提及，流量分析深度或受限。\n\n能力维度匹配:\n1. **内容策划能力：3.5/5分。依据：有AI辅助英文文案优化及短视频策划经验，但无家政/下沉市场内容创作案例，缺乏\"接地气\"风格验证。\n2. **流量分析能力：3/5分。依据：掌握SQL/Excel数据处理，输出过业务数据周报，但未明确提及内容平台流量分析（曝光/点击/转化）经验。\n3. **转化优化能力：2.5/5分。依据：有外贸客户沟通及留资跟进经验，但无招聘场景A/B测试或岗位描述优化经历，渠道测试经验空白。\n4. **用户沟通能力：4/5分。依据：英语志愿者接待40+外宾零失误，英语角覆盖500+人次，具备强咨询回复与引导能力，但待验证对家政劳动者群体的沟通适配性。\n\n面试问题:\n1. 请描述一次你面对高压力、多线程任务时的经历，如何平衡数据整理与内容创作的优先级？（稳定性与执行力）\n2. 在英语志愿者服务中，遇到外宾需求与既定流程冲突时，你如何沟通协调并确保服务体验？（客户服务与应变）\n3. 你过往实习周期多为2-3个月，如何保证本次6个月实习期的稳定性？若学业与实习冲突如何处理？（稳定性）\n4. 假设需在Boss直聘发布\"住家育儿嫂\"岗位，你会如何设计标题、福利亮点及首句开场白以提升点击与投递？请现场",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 请描述一次你面对高压力、多线程任务时的经历，如何平衡数据整理与内容创作的优先级？\n2. 在英语志愿者服务中，遇到外宾需求与既定流程冲突时，你如何沟通协调并确保服务体验？\n3. 你过往实习周期多为2-3个月，如何保证本次6个月实习期的稳定性？若学业与实习冲突如何处理？\n4. 假设需在Boss直聘发布\"住家育儿嫂\"岗位，你会如何设计标题、福利亮点及首句开场白以提升点击与投递？请现场撰写并说明设计逻辑。\n5. 若某招募笔记曝光高但咨询转化率低，你会用Excel或SQL如何拆解数据定位问题？请简述分析步骤与优化方向。",
    "capabilityMatch": "1. **内容策划能力：3.5/5分。依据：有AI辅助英文文案优化及短视频策划经验，但无家政/下沉市场内容创作案例，缺乏\"接地气\"风格验证。\n2. **流量分析能力：3/5分。依据：掌握SQL/Excel数据处理，输出过业务数据周报，但未明确提及内容平台流量分析（曝光/点击/转化）经验。\n3. **转化优化能力：2.5/5分。依据：有外贸客户沟通及留资跟进经验，但无招聘场景A/B测试或岗位描述优化经历，渠道测试经验空白。\n4. **用户沟通能力：4/5分。依据：英语志愿者接待40+外宾零失误，英语角覆盖500+人次，具备强咨询回复与引导能力，但待验证对家政劳动者群体的沟通适配性。",
    "created": ""
  },
  {
    "id": 93,
    "name": "周健",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "本科在读",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "周",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "45岁",
    "gender": "男",
    "strengths": "视觉传达设计专业背景，具备全栈内容生产能力（海报、PPT、视频、文案），直接匹配招募笔记策划需求；部队文书岗锤炼出多线程抗压与零差错交付能力，适配家政业务高频、琐碎的劳动者沟通场景；电商运营经验覆盖用户转化全链路，具备数据驱动优化的实操意识。",
    "risks": "无家政行业垂直经验，对劳动者群体（阿姨）的沟通语境需快速适应；本科在读且预计2027年毕业，实习周期与业务需求需确认；过往经历多为B端/电商场景，C端下沉市场用户同理心待验证。",
    "aiEval": "以下为候选人的 劳动者运营实习生 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：劳动者运营实习生（家政业务方向）\n🏢 招聘岗位：劳动者运营实习生\n\n初筛结果: 通过\n\n优势分析:\n视觉传达设计专业背景，具备全栈内容生产能力（海报、PPT、视频、文案），直接匹配招募笔记策划需求；部队文书岗锤炼出多线程抗压与零差错交付能力，适配家政业务高频、琐碎的劳动者沟通场景；电商运营经验覆盖用户转化全链路，具备数据驱动优化的实操意识。\n\n风险点:\n无家政行业垂直经验，对劳动者群体（阿姨）的沟通语境需快速适应；本科在读且预计2027年毕业，实习周期与业务需求需确认；过往经历多为B端/电商场景，C端下沉市场用户同理心待验证。\n\n能力维度匹配:\n1. **内容策划能力：4/5分。依据：视觉设计专业+部队宣传物料策划+电商营销物料制作，具备文案+视觉双栖能力，但无小红书/抖音等主流平台招募类内容实操经验。\n2. **流量分析能力：3/5分。依据：电商运营中整理用户体验反馈、追踪售后数据，有基础数据敏感度；但未体现曝光/点击/转化率等流量漏斗分析经验，需确认数据工具熟练度。\n3. **转化优化能力：4/5分。依据：电商售前咨询转化率60%、整理标准化话术库、推动详情页优化，具备A/B测试思维与转化优化意识，可直接迁移至招聘渠道话术测试。\n4. **用户沟通能力：4/5分。依据：日均接待142名客户、48小时售后闭环、跨部门协同降低投诉率39%，体现强服务意识与耐心；部队文书岗对接多层级人员，沟通条理性强。\n\n面试问题:\n1. 在部队同时推进5-6项任务时，如何向不同层级（士兵/军官/上级机关）同步进度并确保信息准确？请举例说明一次冲突协调经历。\n2. 电商客服中遇到情绪激动的客户投诉，你是如何48小时内闭环解决的？具体话术和动作是什么？\n3. 服役两年+电商实习4个月后选择返校读书，职业规划",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 在部队同时推进5-6项任务时，如何向不同层级（士兵/军官/上级机关）同步进度并确保信息准确？请举例说明一次冲突协调经历。\n2. 电商客服中遇到情绪激动的客户投诉，你是如何48小时内闭环解决的？具体话术和动作是什么？\n3. 服役两年+电商实习4个月后选择返校读书，职业规划如何？如何看待家政行业劳动者运营岗位的长期价值？\n4. 假设要为45岁湖南籍育儿嫂设计一条抖音招募短视频，30秒内突出\"高薪+灵活+有保障\"，你会如何设计画面节奏和口播文案？\n5. 如果Boss直聘上某岗位曝光高但投递率低，你会从哪些维度拆解数据并优化？请列出具体排查步骤。",
    "capabilityMatch": "1. **内容策划能力：4/5分。依据：视觉设计专业+部队宣传物料策划+电商营销物料制作，具备文案+视觉双栖能力，但无小红书/抖音等主流平台招募类内容实操经验。\n2. **流量分析能力：3/5分。依据：电商运营中整理用户体验反馈、追踪售后数据，有基础数据敏感度；但未体现曝光/点击/转化率等流量漏斗分析经验，需确认数据工具熟练度。\n3. **转化优化能力：4/5分。依据：电商售前咨询转化率60%、整理标准化话术库、推动详情页优化，具备A/B测试思维与转化优化意识，可直接迁移至招聘渠道话术测试。\n4. **用户沟通能力：4/5分。依据：日均接待142名客户、48小时售后闭环、跨部门协同降低投诉率39%，体现强服务意识与耐心；部队文书岗对接多层级人员，沟通条理性强。",
    "created": ""
  },
  {
    "id": 94,
    "name": "吴珂钰",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "2023级本科在读",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "吴",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "无",
    "gender": "无",
    "strengths": "具备数据驱动思维与SOP构建能力，在新闻宣传部通过数据透视分析将阅读完成率提升20%，并建立SOP压缩流程50%；有跨部门协调经验，主动对接文体部确保宣传节奏一致；实验设计经历体现结构化拆解能力，契合家政业务标准化、数字化需求。",
    "risks": "缺乏家政行业认知与一线劳动者服务经验，\"接地气\"文案能力未验证；SQL仅基础语法，复杂数据分析存缺口；2023级本科在读，实习周期可能受限；生物科学专业与互联网运营关联度低，职业稳定性需确认。",
    "aiEval": "以下为候选人的 劳动者运营实习生 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：劳动者运营实习生（家政业务方向）\n🏢 招聘岗位：劳动者运营实习生\n\n初筛结果: 通过\n\n优势分析:\n具备数据驱动思维与SOP构建能力，在新闻宣传部通过数据透视分析将阅读完成率提升20%，并建立SOP压缩流程50%；有跨部门协调经验，主动对接文体部确保宣传节奏一致；实验设计经历体现结构化拆解能力，契合家政业务标准化、数字化需求。\n\n风险点:\n缺乏家政行业认知与一线劳动者服务经验，\"接地气\"文案能力未验证；SQL仅基础语法，复杂数据分析存缺口；2023级本科在读，实习周期可能受限；生物科学专业与互联网运营关联度低，职业稳定性需确认。\n\n能力维度匹配:\n1. **内容策划能力：3/5分。依据：有校园宣传内容策划经验（建立评估机制、统筹大型活动），但无家政招募文案或小红书/抖音等平台实操，\"网感\"与\"接地气\"特质未直接体现。\n2. **流量分析能力：3.5/5分。依据：熟练使用Excel数据透视表与可视化，曾基于100+实验数据发现异常值优化流程；但SQL仅基础语法，未提及其在内容平台（曝光/点击/转化）的具体分析案例。\n3. **转化优化能力：2.5/5分。依据：有\"调整发布节奏提升完成率20%\"的数据优化意识，但缺乏A/B测试、招聘渠道（Boss直聘/社群）转化优化的直接经验，方法论学习阶段未落地。\n4. **用户沟通能力：3/5分。依据：新闻宣传部负责人经历体现跨部门协调与0延误交付，但未涉及一线用户咨询回复、留资引导等客服场景，劳动者群体（家政阿姨）沟通经验空白。\n\n面试问题:\n1. 请描述一次你需要与风格差异很大的合作方（如文体部）协调需求并最终达成共识的经历，具体如何推进？\n2. 在新闻宣传部工作中，遇到过最紧急的突发需求是什么？你如何确保0延误交付，当时如何与团队成员沟通分工？\n3",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 请描述一次你需要与风格差异很大的合作方（如文体部）协调需求并最终达成共识的经历，具体如何推进？\n2. 在新闻宣传部工作中，遇到过最紧急的突发需求是什么？你如何确保0延误交付，当时如何与团队成员沟通分工？\n3. 你提到对互联网内容安全有兴趣，但家政阿姨群体年龄偏大、数字化程度不一，如果一位阿姨反复询问同一问题且情绪激动，你会如何处理？\n4. 假设需在Boss直聘发布\"住家育儿嫂\"岗位，现有文案曝光高但投递少，请现场设计一个A/B测试方案（包括测试变量、周期、判断指标）。\n5. 请用Excel或口述方式，说明如何搭建一个简单的\"渠道-日期-曝光-咨询-报名\"数据追踪表，并举例说明你如何从中发现优化机会。",
    "capabilityMatch": "1. **内容策划能力：3/5分。依据：有校园宣传内容策划经验（建立评估机制、统筹大型活动），但无家政招募文案或小红书/抖音等平台实操，\"网感\"与\"接地气\"特质未直接体现。\n2. **流量分析能力：3.5/5分。依据：熟练使用Excel数据透视表与可视化，曾基于100+实验数据发现异常值优化流程；但SQL仅基础语法，未提及其在内容平台（曝光/点击/转化）的具体分析案例。\n3. **转化优化能力：2.5/5分。依据：有\"调整发布节奏提升完成率20%\"的数据优化意识，但缺乏A/B测试、招聘渠道（Boss直聘/社群）转化优化的直接经验，方法论学习阶段未落地。\n4. **用户沟通能力：3/5分。依据：新闻宣传部负责人经历体现跨部门协调与0延误交付，但未涉及一线用户咨询回复、留资引导等客服场景，劳动者群体（家政阿姨）沟通经验空白。",
    "created": ""
  },
  {
    "id": 95,
    "name": "赖于蓝",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "硕士在读",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "赖",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "45岁",
    "gender": "无相关信息",
    "strengths": "具备多平台内容运营实战经验（学而思千人社群运营、出版社新媒体全流程策划），擅长SOP搭建与数据复盘；有跨部门协作及用户分层运营经验；网感与文案能力经\"应像经彩\"公众号30+篇推送验证，契合家政招募内容接地气需求。",
    "risks": "无家政/蓝领招聘垂直领域经验，对劳动者群体沟通语境需适应；硕士在读（2025.9入学）与实习时间存在潜在冲突，需确认每周出勤稳定性；无明确Boss直聘等招聘渠道实操经历。",
    "aiEval": "以下为候选人的 劳动者运营实习生 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：劳动者运营实习生（家政业务方向）\n🏢 招聘岗位：劳动者运营实习生\n\n初筛结果: 通过\n\n优势分析:\n具备多平台内容运营实战经验（学而思千人社群运营、出版社新媒体全流程策划），擅长SOP搭建与数据复盘；有跨部门协作及用户分层运营经验；网感与文案能力经\"应像经彩\"公众号30+篇推送验证，契合家政招募内容接地气需求。\n\n风险点:\n无家政/蓝领招聘垂直领域经验，对劳动者群体沟通语境需适应；硕士在读（2025.9入学）与实习时间存在潜在冲突，需确认每周出勤稳定性；无明确Boss直聘等招聘渠道实操经历。\n\n能力维度匹配:\n1. **内容策划能力：4/5分。依据：学而思\"策划并执行线上直播、线下沙龙\"、出版社\"全流程参与读书日活动\"及公众号30+篇推送经验，证明创意策划与文案执行力；缺家政垂直内容案例。\n2. **流量分析能力：3/5分。依据：学而思\"使用Excel进行运营数据统计与效果复盘，监测关键指标\"，具备基础数据敏感度；但无明确曝光/点击/转化率优化及关键词/发布时间调优的专项经验。\n3. **转化优化能力：3/5分。依据：学而思\"根据用户画像制定差异化沟通及活动方案\"体现A/B测试思维；但无Boss直聘等招聘渠道岗位描述话术测试经验，蓝领群体转化逻辑需验证。\n4. **用户沟通能力：4/5分。依据：学而思\"协助处理用户问题与需求反馈\"、研究生会\"联络各校研会并主持座谈会\"，具备多场景沟通与引导能力；但未涉及中老年劳动者群体沟通场景。\n\n面试问题:\n1. 在学而思维护千人社群时，遇到过最难沟通的用户类型是什么？具体如何化解矛盾并提升其参与度？\n2. 研究生会联络工作中，如何说服不同学院负责人配合完成权益座谈会？遇到抵触情绪如何处理？\n3. 硕士学业与实习并行时，如何规划时间确保每周至少4天出勤",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 在学而思维护千人社群时，遇到过最难沟通的用户类型是什么？具体如何化解矛盾并提升其参与度？\n2. 研究生会联络工作中，如何说服不同学院负责人配合完成权益座谈会？遇到抵触情绪如何处理？\n3. 硕士学业与实习并行时，如何规划时间确保每周至少4天出勤？过往有无学业与实习冲突的解决案例？\n4. 假设需为45岁家政阿姨设计一条抖音招募短视频脚本，请用30秒口述核心创意（钩子+福利+行动指令）。\n5. 若Boss直聘上某保洁岗位3天曝光高但投递率低，你会从哪些维度拆解问题并优化？请列举具体检查清单。",
    "capabilityMatch": "1. **内容策划能力：4/5分。依据：学而思\"策划并执行线上直播、线下沙龙\"、出版社\"全流程参与读书日活动\"及公众号30+篇推送经验，证明创意策划与文案执行力；缺家政垂直内容案例。\n2. **流量分析能力：3/5分。依据：学而思\"使用Excel进行运营数据统计与效果复盘，监测关键指标\"，具备基础数据敏感度；但无明确曝光/点击/转化率优化及关键词/发布时间调优的专项经验。\n3. **转化优化能力：3/5分。依据：学而思\"根据用户画像制定差异化沟通及活动方案\"体现A/B测试思维；但无Boss直聘等招聘渠道岗位描述话术测试经验，蓝领群体转化逻辑需验证。\n4. **用户沟通能力：4/5分。依据：学而思\"协助处理用户问题与需求反馈\"、研究生会\"联络各校研会并主持座谈会\"，具备多场景沟通和引导能力；但未涉及中老年劳动者群体沟通场景。",
    "created": ""
  },
  {
    "id": 96,
    "name": "左韧",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "无明确学历信息",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "左",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "35-50岁",
    "gender": "未明确提及性别信息",
    "strengths": "具备内容运营实战经验，云舟启行期间实现店铺点击率提升15%、自然搜索流量提升20%；私域运营与裂变增长经验丰富，沉淀精准客户50余人、老客户转介绍占比超25%；有从0到1项目经验，3天完成需求验证并零成本获客；网感强，运营小红书/抖音本地账号日均获客20余人，与家政劳动者招募的内容场景高度契合。",
    "risks": "实习时间线存疑（云舟启行标注2026/03-2026/04，可能为笔误或未来实习）；无明确家政行业背景，对劳动者群体（阿姨）沟通语境需适应；GPA 2.7处于中等水平，学业与实习平衡能力待观察；体育教育专业与运营岗位关联度低，职业稳定性需验证。",
    "aiEval": "以下为候选人的 劳动者运营实习生 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：劳动者运营实习生（家政业务方向）\n🏢 招聘岗位：劳动者运营实习生\n\n初筛结果: 通过\n\n优势分析:\n具备内容运营实战经验，云舟启行期间实现店铺点击率提升15%、自然搜索流量提升20%；私域运营与裂变增长经验丰富，沉淀精准客户50余人、老客户转介绍占比超25%；有从0到1项目经验，3天完成需求验证并零成本获客；网感强，运营小红书/抖音本地账号日均获客20余人，与家政劳动者招募的内容场景高度契合。\n\n风险点:\n实习时间线存疑（云舟启行标注2026/03-2026/04，可能为笔误或未来实习）；无明确家政行业背景，对劳动者群体（阿姨）沟通语境需适应；GPA 2.7处于中等水平，学业与实习平衡能力待观察；体育教育专业与运营岗位关联度低，职业稳定性需验证。\n\n能力维度匹配:\n1. **内容策划能力：4/5分。依据：云舟启行负责商品上架、主图优化、详情页文案撰写，私域运营中每周推送活动案例与优惠信息，小红书/抖音账号运营产出上课日常和体育口播视频，具备文案创作与内容迭代经验。\n2. **流量分析能力：3.5/5分。依据：云舟启行分析店铺流量来源、优化搜索关键词及商品标题，每周输出涵盖流量、转化、客单价、ROI的数据报告，具备基础数据跟踪与优化意识，但未明确提及曝光、点击率等具体指标分析。\n3. **转化优化能力：3.5/5分。依据：云舟启行调整低转化商品、识别高潜力与滞销品并提出优化建议，协助团队将ROI从1:2提升至1:3；私域运营中设计转介绍奖励机制降低获客成本40%，具备A/B测试与转化优化思维。\n4. **用户沟通能力：4/5分。依据：建设银行实习日均覆盖30余位潜在客户、解决20余次业务咨询，7天内实现独立成交；私域运营中建立客户池并分层标记，具备主动触达、需求洞察与闭环成交能力，沟通耐心",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 请描述一次你面对高拒绝率或低转化场景时，如何通过调整沟通策略或话术最终实现突破的具体案例。\n2. 在运营小红书/抖音账号时，如果遇到评论区负面反馈或用户质疑，你通常如何处理以维护账号口碑并转化潜在用户？\n3. 你的实习经历涉及金融、电商、教育多个领域，请说明选择家政劳动者运营方向的职业考量，以及如何看待未来1-2年的发展规划。\n4. 假设需要为天鹅到家策划一条招募保洁阿姨的短视频脚本，目标受众为35-50岁三四线城市女性，请简述你的内容框架、钩子设计和发布平台选择逻辑。\n5. 如果Boss直聘上某家政岗位的曝光量高但投递转化率低，你会如何系统性地排查问题并优化？请列举至少3个可落地的测试方向。",
    "capabilityMatch": "1. **内容策划能力：4/5分。依据：云舟启行负责商品上架、主图优化、详情页文案撰写，私域运营中每周推送活动案例与优惠信息，小红书/抖音账号运营产出上课日常和体育口播视频，具备文案创作与内容迭代经验。\n2. **流量分析能力：3.5/5分。依据：云舟启行分析店铺流量来源、优化搜索关键词及商品标题，每周输出涵盖流量、转化、客单价、ROI的数据报告，具备基础数据跟踪与优化意识，但未明确提及曝光、点击率等具体指标分析。\n3. **转化优化能力：3.5/5分。依据：云舟启行调整低转化商品、识别高潜力与滞销品并提出优化建议，协助团队将ROI从1:2提升至1:3；私域运营中设计转介绍奖励机制降低获客成本40%，具备A/B测试与转化优化思维。\n4. **用户沟通能力：4/5分。依据：建设银行实习日均覆盖30余位潜在客户、解决20次业务咨询，7天内实现独立成交；私域运营中建立客户池并分层标记，具备主动触达、需求洞察与闭环成交能力，沟通耐心与执行力有验证。",
    "created": ""
  },
  {
    "id": 97,
    "name": "林欣",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "林",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "无",
    "gender": "无",
    "strengths": "自媒体账号运营经验（播放量1000万+）直接匹配内容策划与流量优化需求；跨部门协作经验（音乐会策划、合唱团管理）契合家政业务多角色协调场景；网感与热点追踪能力已通过数据验证。",
    "risks": "城乡规划专业与家政/互联网运营关联度低，缺乏明确的数据分析工具（Excel仅为基础使用）和招聘平台实操经验；2027年毕业，实习周期可能受限。",
    "aiEval": "以下为候选人的 劳动者运营实习生 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：劳动者运营实习生（家政业务方向）\n🏢 招聘岗位：劳动者运营实习生\n\n初筛结果: 通过\n\n优势分析:\n自媒体账号运营经验（播放量1000万+）直接匹配内容策划与流量优化需求；跨部门协作经验（音乐会策划、合唱团管理）契合家政业务多角色协调场景；网感与热点追踪能力已通过数据验证。\n\n风险点:\n城乡规划专业与家政/互联网运营关联度低，缺乏明确的数据分析工具（Excel仅为基础使用）和招聘平台实操经验；2027年毕业，实习周期可能受限。\n\n能力维度匹配:\n1. **内容策划能力：4/5分。依据：独立运营自媒体账号，总播放量1000万+，具备热点捕捉、视频制作、文案包装经验，但缺乏家政垂直领域内容经验。\n2. **流量分析能力：2/5分。依据：简历提及\"数据优化\"但未明确说明使用何种数据分析方法或工具，仅标注\"熟练使用Excel\"，无流量漏斗分析实证。\n3. **转化优化能力：2/5分。依据：无A/B测试、渠道对比、话术迭代等转化优化经验，自媒体运营与招聘场景转化逻辑差异较大。\n4. **用户沟通能力：3/5分。依据：合唱团副团长需协调50+团员、对接校内外需求，具备多角色沟通经验，但缺乏一线客服/销售转化场景经验。\n\n面试问题:\n1. 请描述一次你协调多方利益冲突完成项目的经历（如音乐会中场地、节目、部门的矛盾），你如何解决？\n2. 自媒体运营中，收到负面评论或粉丝投诉时，你如何处理？请举例说明。\n3. 你预计2027年毕业，未来2-3年职业规划是什么？如何看待家政行业的职业价值？\n4. 假设需在抖音发布一条招募保洁阿姨的短视频，你会如何设计前3秒钩子、文案结构和CTA？请现场简述。\n5. 如果Boss直聘上某岗位曝光高但投递率低，你会从哪些维度拆解原因并优化？\n\n互动引导语:\n林欣您好，我是天鹅",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 请描述一次你协调多方利益冲突完成项目的经历（如音乐会中场地、节目、部门的矛盾），你如何解决？\n2. 自媒体运营中，收到负面评论或粉丝投诉时，你如何处理？请举例说明。\n3. 你预计2027年毕业，未来2-3年职业规划是什么？如何看待家政行业的职业价值？\n4. 假设需在抖音发布一条招募保洁阿姨的短视频，你会如何设计前3秒钩子、文案结构和CTA？请现场简述。\n5. 如果Boss直聘上某岗位曝光高但投递率低，你会从哪些维度拆解原因并优化？",
    "capabilityMatch": "1. **内容策划能力：4/5分。依据：独立运营自媒体账号，总播放量1000万+，具备热点捕捉、视频制作、文案包装经验，但缺乏家政垂直领域内容经验。\n2. **流量分析能力：2/5分。依据：简历提及\"数据优化\"但未明确说明使用何种数据分析方法或工具，仅标注\"熟练使用Excel\"，无流量漏斗分析实证。\n3. **转化优化能力：2/5分。依据：无A/B测试、渠道对比、话术迭代等转化优化经验，自媒体运营与招聘场景转化逻辑差异较大。\n4. **用户沟通能力：3/5分。依据：合唱团副团长需协调50+团员、对接校内外需求，具备多角色沟通经验，但缺乏一线客服/销售转化场景经验。",
    "created": ""
  },
  {
    "id": 98,
    "name": "王敏",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "大专",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "王",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "无",
    "gender": "女",
    "strengths": "8年销售经验，含雅诗兰黛柜台销售（客户开发、维护、活动邀约）及自主创业经历，具备基础客户跟进与商务沟通经验；电销面销求职意向与岗位匹配；学历符合大专要求。",
    "risks": "无家政/招商行业经验，缺乏劳动者招募场景；自主创业2024.11-2025.12时间存疑（未来时间或表述错误），稳定性待核实；无市场分析、活动执行相关经历描述；8年经验期望6-10K薪资偏低，需了解真实动机。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 存疑\n\n优势分析:\n8年销售经验，含雅诗兰黛柜台销售（客户开发、维护、活动邀约）及自主创业经历，具备基础客户跟进与商务沟通经验；电销面销求职意向与岗位匹配；学历符合大专要求。\n\n风险点:\n无家政/招商行业经验，缺乏劳动者招募场景；自主创业2024.11-2025.12时间存疑（未来时间或表述错误），稳定性待核实；无市场分析、活动执行相关经历描述；8年经验期望6-10K薪资偏低，需了解真实动机。\n\n能力维度匹配:\n1. **客户开发能力：3/5分。依据：雅诗兰黛经历含\"拓展新客、维护老客、活动邀约\"，但无电话/企业微信跟进、签约闭环经验，且为零售场景非B端/劳动者招募。\n2. **活动执行能力：2/5分。依据：仅有\"活动邀约\"提及，无参与执行公司招商活动的经历，自主创业也无相关活动组织描述。\n3. **市场分析能力：1/5分。依据：简历无任何市场信息收集、分析、建议的相关行为描述，能力缺口明显。\n4. **商务沟通能力：3/5分。依据：柜台销售需日常客户接待沟通，具备基础商务礼仪；但无劳动者群体沟通经验，场景差异大。\n5. **软件操作能力：2/5分。依据：计算机专业背景，但无具体Office软件使用描述，需实操验证。\n\n面试问题:\n1. 请描述一次你通过电话或微信持续跟进一位犹豫客户最终促成交易的经历，具体做了什么？\n2. 雅诗兰黛柜台销售中，你是如何维护老客户并促成复购的？请举例说明。\n3. 你自主创业的小百货超市为何结束/计划结束？未来3年职业规划是什么？\n4. 家政行业劳动者（如保洁阿姨、月嫂）招募与传统零售客户开发有何不同？你认为难点在哪里？\n5. 如果一位劳动者对平台抽成比例有顾虑，你会如何沟通说服？\n\n互动",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 请描述一次你通过电话或微信持续跟进一位犹豫客户最终促成交易的经历，具体做了什么？\n2. 雅诗兰黛柜台销售中，你是如何维护老客户并促成复购的？请举例说明。\n3. 你自主创业的小百货超市为何结束/计划结束？未来3年职业规划是什么？\n4. 家政行业劳动者（如保洁阿姨、月嫂）招募与传统零售客户开发有何不同？你认为难点在哪里？\n5. 如果一位劳动者对平台抽成比例有顾虑，你会如何沟通说服？",
    "capabilityMatch": "1. **客户开发能力：3/5分。依据：雅诗兰黛经历含\"拓展新客、维护老客、活动邀约\"，但无电话/企业微信跟进、签约闭环经验，且为零售场景非B端/劳动者招募。\n2. **活动执行能力：2/5分。依据：仅有\"活动邀约\"提及，无参与执行公司招商活动的经历，自主创业也无相关活动组织描述。\n3. **市场分析能力：1/5分。依据：简历无任何市场信息收集、分析、建议的相关行为描述，能力缺口明显。\n4. **商务沟通能力：3/5分。依据：柜台销售需日常客户接待沟通，具备基础商务礼仪；但无劳动者群体沟通经验，场景差异大。\n5. **软件操作能力：2/5分。依据：计算机专业背景，但无具体Office软件使用描述，需实操验证。",
    "created": ""
  },
  {
    "id": 99,
    "name": "陆维齐",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "陆",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "23岁",
    "gender": "无",
    "strengths": "简历信息极度匮乏，仅可见基础销售经验（客户开发、接待维护）及物流数据录入经历，无社群运营、用户运营相关经验可提取。23岁年轻，学习窗口期存在。",
    "risks": "1. 零社群/用户运营经验，岗位核心能力（社群管理、数据报表、转介绍渠道）均无文本支撑；\n2. 简历呈现极不专业（乱码、时间线混乱、2025-2026未来工作经历），职业诚信存疑；\n3. 求职意向为\"销售专员\"与投递岗位不符，稳定性与动机不明。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 淘汰\n\n优势分析:\n简历信息极度匮乏，仅可见基础销售经验（客户开发、接待维护）及物流数据录入经历，无社群运营、用户运营相关经验可提取。23岁年轻，学习窗口期存在。\n\n风险点:\n致命缺口：零社群/用户运营经验，岗位核心能力（社群管理、数据报表、转介绍渠道）均无文本支撑；简历呈现极不专业（乱码、时间线混乱、2025-2026未来工作经历），职业诚信存疑；求职意向为\"销售专员\"与投递岗位不符，稳定性与动机不明。\n\n能力维度匹配:\n1. **社群运营能力：0/5分。依据**：简历零提及社群管理、用户答疑、氛围维护、活动发布等任何相关经验，完全空白。\n2. **数据处理能力：1/5分。依据**：仅有\"生产资料数据录入\"片段化描述，无数据跟踪、复盘、报表输出经验，与JD要求的\"每日输出运营数据报表\"差距显著。\n3. **渠道管理能力：1/5分。依据**：销售岗位涉及\"新客户开发\"，但无转介绍渠道管理、线索录入、营销活动触达等具体经验，匹配度极低。\n4. **协作沟通能力：2/5分。依据**：销售岗位隐含客户沟通，但无跨部门协作、友商对接、返佣礼品发放等B端协同经验，无法验证。\n5. **执行推进能力：2/5分。依据**：\"工作态度良好\"为主观陈述，无主动跟进、push待办事项的具体案例支撑，且简历本身呈现混乱，反证执行力存疑。\n\n面试问题:\n1. 请描述一次你需要同时对接多个部门或外部合作方推进项目的经历，当时遇到了什么阻力，你如何确保信息同步和任务落地？\n2. 销售工作中遇到客户投诉或强烈不满时，你通常如何处理？请举例说明具体步骤和最终结果。\n3. 你的求职意向显示为销售专员，为何投递社群用户运营岗位？未来2-3年的职业规划是什么？\n",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你需要同时对接多个部门或外部合作方推进项目的经历，当时遇到了什么阻力，你如何确保信息同步和任务落地？\n2. 销售工作中遇到客户投诉或强烈不满时，你通常如何处理？请举例说明具体步骤和最终结果。\n3. 你的求职意向显示为销售专员，为何投递社群用户运营岗位？未来2-3年的职业规划是什么？\n4. 如果让你从零搭建一个家政服务用户的微信社群，你会如何设计入群欢迎语、群规和首周活跃计划？\n5. 假设需要每日跟踪社群新增用户数、活跃用户占比、线索转化率，你会用什么工具记录？如何设计一张简洁有效的日报表？",
    "capabilityMatch": "1. **社群运营能力：0/5分。依据**：简历零提及社群管理、用户答疑、氛围维护、活动发布等任何相关经验，完全空白。\n2. **数据处理能力：1/5分。依据**：仅有\"生产资料数据录入\"片段化描述，无数据跟踪、复盘、报表输出经验，与JD要求的\"每日输出运营数据报表\"差距显著。\n3. **渠道管理能力：1/5分。依据**：销售岗位涉及\"新客户开发\"，但无转介绍渠道管理、线索录入、营销活动触达等具体经验，匹配度极低。\n4. **协作沟通能力：2/5分。依据**：销售岗位隐含客户沟通，但无跨部门协作、友商对接、返佣礼品发放等B端协同经验，无法验证。\n5. **执行推进能力：2/5分。依据**：\"工作态度良好\"为主观陈述，无主动跟进、push待办事项的具体案例支撑，且简历本身呈现混乱，反证执行力存疑。",
    "created": ""
  },
  {
    "id": 100,
    "name": "卢晖",
    "role": "社群用户运营专员",
    "company": "流量运营部",
    "years": 0,
    "edu": "大专在读",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "卢",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "男",
    "strengths": "具备新媒体运营与直播策划经验，熟悉用户互动与活动执行；有80场直播统筹及演艺团队协作经历，能快速适应标准化服务场景的社群运营；设计背景有助于视觉化内容输出，契合家政数字化传播需求。",
    "risks": "无明确社群运营或家政行业经验，需验证用户答疑与长期社群维护能力；实习周期仅2个月，稳定性存疑；大专在读至2026年，需确认出勤时间是否满足全职要求。",
    "aiEval": "以下为候选人的 社群用户运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：社群用户运营专员\n🏢 招聘岗位：社群用户运营专员\n\n初筛结果: 通过\n\n优势分析:\n具备新媒体运营与直播策划经验，熟悉用户互动与活动执行；有80场直播统筹及演艺团队协作经历，能快速适应标准化服务场景的社群运营；设计背景有助于视觉化内容输出，契合家政数字化传播需求。\n\n风险点:\n无明确社群运营或家政行业经验，需验证用户答疑与长期社群维护能力；实习周期仅2个月，稳定性存疑；大专在读至2026年，需确认出勤时间是否满足全职要求。\n\n能力维度匹配:\n1. **社群运营能力：3/5分。依据：有直播互动策划经验（设计高吸引力互动环节），但无传统社群日常管理、答疑、规则同步的直接经历，需验证迁移能力。\n2. **数据处理能力：2/5分。依据：简历未提及数据跟踪、报表输出或指标复盘经验，直播策划侧重内容而非数据分析，存在明显技能缺口。\n3. **渠道管理能力：2/5分。依据：无转介绍渠道管理、线索录入或月度营销整理经验，演艺部助理工作侧重现场执行而非渠道运营。\n4. **协作沟通能力：4/5分。依据：多次体现跨团队协作（统筹摄影师/主持人/导播/技术团队、演艺团队与舞台管理中心沟通枢纽），沟通链条复杂且结果良好。\n5. **执行推进能力：4/5分。依据：80场直播零失误执行、演出前多环节核查、信息同步精准，体现主动跟进与流程把控意识。\n\n面试问题:\n1. 请描述一次你需要同时对接多个部门/角色（如技术、内容、现场执行）推进项目的经历，当时最大的协调难点是什么，你如何推动解决？\n2. 直播或演出中遇到过突发状况（如设备故障、人员缺席），你如何处理？结果如何？\n3. 你目前学业安排到2026年，如果入职全职岗位，如何平衡学业与工作时间？过往是否有长期实习（6个月以上）经历？\n4. 假设社群内有用户投诉保洁服",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "社群用户运营专员",
    "interviewQ": "1. 请描述一次你需要同时对接多个部门/角色（如技术、内容、现场执行）推进项目的经历，当时最大的协调难点是什么，你如何推动解决？\n2. 直播或演出中遇到过突发状况（如设备故障、人员缺席），你如何处理？结果如何？\n3. 你目前学业安排到2026年，如果入职全职岗位，如何平衡学业与工作时间？过往是否有长期实习（6个月以上）经历？\n4. 假设社群内有用户投诉保洁服务不达标，情绪激烈，请模拟一段回复话术，并说明后续跟进思路。\n5. 如果需要你每日输出社群运营数据报表，你认为应包含哪些核心指标？如何设计表格结构便于负责人快速抓取关键信息？",
    "capabilityMatch": "1. **社群运营能力：3/5分。依据：有直播互动策划经验（设计高吸引力互动环节），但无传统社群日常管理、答疑、规则同步的直接经历，需验证迁移能力。\n2. **数据处理能力：2/5分。依据：简历未提及数据跟踪、报表输出或指标复盘经验，直播策划侧重内容而非数据分析，存在明显技能缺口。\n3. **渠道管理能力：2/5分。依据：无转介绍渠道管理、线索录入或月度营销整理经验，演艺部助理工作侧重现场执行而非渠道运营。\n4. **协作沟通能力：4/5分。依据：多次体现跨团队协作（统筹摄影师/主持人/导播/技术团队、演艺团队与舞台管理中心沟通枢纽），沟通链条复杂且结果良好。\n5. **执行推进能力：4/5分。依据：80场直播零失误执行、演出前多环节核查、信息同步精准，体现主动跟进与流程把控意识。",
    "created": ""
  },
  {
    "id": 101,
    "name": "朱二璐",
    "role": "母婴顾问",
    "company": "销售部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "朱",
    "dept": "雏渐肥事业部",
    "city": "南京",
    "age": "35岁",
    "gender": "无明确性别信息",
    "strengths": "14年客服/电销经验，熟悉电话沟通与客户开发，曾获\"客服之星\"等荣誉，具备基础服务意识与沟通协调能力，有400热线接听及投诉处理经验。",
    "risks": "性别不符（要求男/女35岁超龄）、无母婴/家政行业背景、简历显示职业稳定性差（多段短期经历）、近半年出现2025.10至今的时间错误、缺乏顾问式销售及线下邀约面谈经验",
    "aiEval": "以下为候选人的 母婴顾问 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：母婴顾问\n🏢 招聘岗位：母婴顾问\n\n初筛结果: 淘汰\n\n优势分析:\n14年客服/电销经验，熟悉电话沟通与客户开发，曾获\"客服之星\"等荣誉，具备基础服务意识与沟通协调能力，有400热线接听及投诉处理经验。\n\n风险点:\n性别不符（要求男/女35岁超龄）、无母婴/家政行业背景、简历显示职业稳定性差（多段短期经历）、近半年出现2025.10至今的时间错误、缺乏顾问式销售及线下邀约面谈经验。\n\n能力维度匹配:\n1. **专业咨询能力：1/5分。依据：零母婴/家政行业经验，仅有人保车险、移动业务、信用卡分期等无关领域经历，无月嫂筛选或母婴知识储备证据。**\n2. **客户关系维护：2/5分。依据：有电话销售客户开发经验，但无线下邀约面谈、到店接待及顾问式销售证据，岗位要求的\"促进线上签约+线下促成\"双线能力未体现。**\n3. **问题处理能力：2/5分。依据：有400热线投诉处理经验，但无家政服务场景下的\"安排接单\"经验，客户满意度提升成果量化不足。**\n4. **营销技能提升：1/5分。依据：简历未提及主动参与营销培训或系统学习，仅被动完成业务目标，自我提升意识证据薄弱。**\n5. **抗压积极能力：2/5分。依据：电销岗位需抗压，但35岁年龄与21-26岁要求差距大，且简历时间错误（2025.10至今）反映严谨性不足，职业倦怠风险高。**\n\n面试问题:\n1. \"请描述一次您同时处理多位客户紧急投诉并协调资源解决的经历，您如何排序优先级？\"\n2. \"您的简历中2015年有两段南京宁众的短期经历，当时离职原因是什么？如何看待销售岗位的稳定性？\"\n3. \"电销与顾问式销售差异较大，请举例说明您如何从被动接单转为主动挖掘客户深层需求？\"\n4. \"假设客户坚持要一位'会做月子餐且带过双胞胎'的月嫂，但系统匹配度最",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "母婴顾问",
    "interviewQ": "1. \"请描述一次您同时处理多位客户紧急投诉并协调资源解决的经历，您如何排序优先级？\"\n2. \"您的简历中2015年有两段南京宁众的短期经历，当时离职原因是什么？如何看待销售岗位的稳定性？\"\n3. \"电销与顾问式销售差异较大，请举例说明您如何从被动接单转为主动挖掘客户深层需求？\"\n4. \"假设客户坚持要一位'会做月子餐且带过双胞胎'的月嫂，但系统匹配度最高的阿姨仅满足其一，您如何沟通并促成签约？\"\n5. \"客户签约后投诉月嫂服务态度差要求退款，您按什么流程处理？如何在公司利益与客户满意度间平衡？\"",
    "capabilityMatch": "1. **专业咨询能力：1/5分。依据：零母婴/家政行业经验，仅有人保车险、移动业务、信用卡分期等无关领域经历，无月嫂筛选或母婴知识储备证据。**\n2. **客户关系维护：2/5分。依据：有电话销售客户开发经验，但无线下邀约面谈、到店接待及顾问式销售证据，岗位要求的\"促进线上签约+线下促成\"双线能力未体现。**\n3. **问题处理能力：2/5分。依据：有400热线投诉处理经验，但无家政服务场景下的\"安排接单\"经验，客户满意度提升成果量化不足。**\n4. **营销技能提升：1/5分。依据：简历未提及主动参与营销培训或系统学习，仅被动完成业务目标，自我提升意识证据薄弱。**\n5. **抗压积极能力：2/5分。依据：电销岗位需抗压，但35岁年龄与21-26岁要求差距大，且简历时间错误（2025.10至今）反映严谨性不足，职业倦怠风险高。**",
    "created": ""
  },
  {
    "id": 102,
    "name": "耿梦慧",
    "role": "无法提取",
    "company": "",
    "years": 0,
    "edu": "无明确学历相关信息",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "耿",
    "dept": "",
    "city": "",
    "age": "无",
    "gender": "女",
    "strengths": "4年链家地推/招商实战经验，擅长从0到1搭建SOP、社群运营及200+人活动执行，具备完整的\"邀约-接待-签约\"闭环经验；公众号运营及数据复盘能力契合天鹅到家数字化、标准化业务需求。",
    "risks": "近4年链家经历未体现家政行业认知，存在行业转换适应期；简历显示2022.03-2026.02在职（未来日期），需核实实际离职时间；无明确电销/电话邀约量化成果，客户开发能力待验证。",
    "aiEval": "以下为候选人的 无法提取 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：无法提取\n🏢 招聘岗位：无法提取\n\n初筛结果: 通过\n\n优势分析:\n4年链家地推/招商实战经验，擅长从0到1搭建SOP、社群运营及200+人活动执行，具备完整的\"邀约-接待-签约\"闭环经验；公众号运营及数据复盘能力契合天鹅到家数字化、标准化业务需求。\n\n风险点:\n近4年链家经历未体现家政行业认知，存在行业转换适应期；简历显示2022.03-2026.02在职（未来日期），需核实实际离职时间；无明确电销/电话邀约量化成果，客户开发能力待验证。\n\n能力维度匹配:\n1. **客户开发能力：3/5分。依据：有租赁业务带看、签约经验及\"邀约-接待\"闭环，但缺乏电话/企业微信高频跟进、地推扫街等家政地招场景的直接证据，无量化招募数据。\n2. **活动执行能力：4/5分。依据：主导大区季度/年度表彰大会（200+人）、老员工周年策划及公众号报道（500+阅读），具备完整活动策划-执行-传播经验。\n3. **市场分析能力：2/5分。依据：简历提及\"萃取优秀标杆方法论\"及数据大区前30%，但无行业信息收集、竞品分析或区域市场策略建议的明确行为。\n4. **商务沟通能力：4/5分。依据：4年链家经纪及M3组长经历，需高频对接客户、带教团队；获普通话一级乙等，具备基础商务表达素养。\n5. **软件操作能力：4/5分。依据：明确掌握Excel数据统计/图表、PPT复盘、公众号运营（秀米），持计算机二级（Office）证书，提及学习chat-excel工具。\n\n面试问题:\n1. 请描述一次你通过电话或线上渠道持续跟进并最终促成签约的具体案例，当时遇到了什么阻力，如何突破？\n2. 链家与家政行业在客户群体、服务场景上有较大差异，你如何看待这种转换？如果入职后前3个月招募指标压力大，你会如何调整？\n3. 你简历中2022.0",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "无法提取",
    "interviewQ": "1. 请描述一次你通过电话或线上渠道持续跟进并最终促成签约的具体案例，当时遇到了什么阻力，如何突破？\n2. 链家与家政行业在客户群体、服务场景上有较大差异，你如何看待这种转换？如果入职后前3个月招募指标压力大，你会如何调整？\n3. 你简历中2022.03-2026.02的任职时间是否有误？请说明实际离职原因及空窗期规划。\n4. 假设你需要在1个月内为某新区域招募30名保洁劳动者，请简述你的渠道拓展策略及每日执行节奏。\n5. 家政劳动者群体多为40-50岁女性，与房产客户差异较大，你会如何设计沟通话术建立信任并推动签约？",
    "capabilityMatch": "1. **客户开发能力：3/5分。依据：有租赁业务带看、签约经验及\"邀约-接待\"闭环，但缺乏电话/企业微信高频跟进、地推扫街等家政地招场景的直接证据，无量化招募数据。\n2. **活动执行能力：4/5分。依据：主导大区季度/年度表彰大会（200+人）、老员工周年策划及公众号报道（500+阅读），具备完整活动策划-执行-传播经验。\n3. **市场分析能力：2/5分。依据：简历提及\"萃取优秀标杆方法论\"及数据大区前30%，但无行业信息收集、竞品分析或区域市场策略建议的明确行为。\n4. **商务沟通能力：4/5分。依据：4年链家经纪及M3组长经历，需高频对接客户、带教团队；获普通话一级乙等，具备基础商务表达素养。\n5. **软件操作能力：4/5分。依据：明确掌握Excel数据统计/图表、PPT复盘、公众号运营（秀米），持计算机二级（Office）证书，提及学习chat-excel工具。",
    "created": ""
  },
  {
    "id": 103,
    "name": "李根",
    "role": "无法提取",
    "company": "",
    "years": 0,
    "edu": "无法提取",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "李",
    "dept": "",
    "city": "长沙",
    "age": "35岁+",
    "gender": "无法提取",
    "strengths": "11年运营经验覆盖新媒体与门店全链路管理，具备标准化体系搭建（商学院、培训机制）、数字化运营（小程序、数据分析）及规模化扩张（1700%粉丝增长、70家门店统筹）能力，与天鹅到家\"标准化、数字化、职业化\"战略高度契合；跨医疗-电商-零售的复合背景有助于家政服务专业化升级。",
    "risks": "职业路径跳跃明显（医学→新媒体→电商门店），家政行业零直接经验，存在行业认知与实操技能缺口；2018年后经历时间表述异常（\"7-2026.2\"疑似笔误），稳定性存疑；35岁+转型基层管理岗，动机与长期职业规划需验证。",
    "aiEval": "以下为候选人的 无法提取 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：无法提取\n🏢 招聘岗位：无法提取\n\n初筛结果: 存疑\n\n优势分析:\n11年运营经验覆盖新媒体与门店全链路管理，具备标准化体系搭建（商学院、培训机制）、数字化运营（小程序、数据分析）及规模化扩张（1700%粉丝增长、70家门店统筹）能力，与天鹅到家\"标准化、数字化、职业化\"战略高度契合；跨医疗-电商-零售的复合背景有助于家政服务专业化升级。\n\n风险点:\n职业路径跳跃明显（医学→新媒体→电商门店），家政行业零直接经验，存在行业认知与实操技能缺口；2018年后经历时间表述异常（\"7-2026.2\"疑似笔误），稳定性存疑；35岁+转型基层管理岗，动机与长期职业规划需验证。\n\n能力维度匹配:\n1. **运营体系搭建能力：4/5分。依据：主导商学院、培训体系、盈利模型构建，有规模化复制经验，但缺乏家政垂直场景验证。**\n2. **数字化运营能力：4/5分。依据：精通公众号、小程序全链路运营，具备数据驱动迭代意识，但工具平台与天鹅到家技术栈匹配度待考。**\n3. **团队管理与培训能力：4/5分。依据：搭建人才体系，线上线下培训覆盖超万人次，但家政蓝领群体管理场景差异大。**\n4. **行业适配与稳定性：2/5分。依据：零家政从业背景，职业跨度大，时间线存疑，转型动机不明确。**\n5. **客户服务与标准化落地：2/5分。依据：医疗背景有服务意识基础，但缺乏家政服务标准（如保洁SOP、月嫂护理规范）实操经验。**\n\n面试问题:\n1. 请描述一次你推动标准化体系在门店落地时遭遇一线员工抵触的经历，你如何沟通协调最终实现目标？\n2. 你过往运营的粉丝/用户群体与家政客户差异较大，你认为服务这类对品质敏感的家庭客户，与以往最大的不同是什么？请举例说明你如何快速理解新客群需求。\n3. 你的职业经历跨越医疗、新媒体、电",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "无法提取",
    "interviewQ": "1. 请描述一次你推动标准化体系在门店落地时遭遇一线员工抵触的经历，你如何沟通协调最终实现目标？\n2. 你过往运营的粉丝/用户群体与家政客户差异较大，你认为服务这类对品质敏感的家庭客户，与以往最大的不同是什么？请举例说明你如何快速理解新客群需求。\n3. 你的职业经历跨越医疗、新媒体、电商多个领域，请分享一次因行业转换导致决策失误的经历，当时如何调整？未来3-5年是否计划在家政行业深耕？\n4. 假设你需要为天鹅到家设计一套\"保洁服务标准化培训体系\"，请简述课程框架、考核标准及如何通过数字化工具追踪服务品质。\n5. 请现场分析：当前家政行业普遍存在的\"服务者流动性高、客户复购率低\"问题，结合你的运营经验，提出3个可落地的改进方案。",
    "capabilityMatch": "1. **运营体系搭建能力：4/5分。依据：主导商学院、培训体系、盈利模型构建，有规模化复制经验，但缺乏家政垂直场景验证。**\n2. **数字化运营能力：4/5分。依据：精通公众号、小程序全链路运营，具备数据驱动迭代意识，但工具平台与天鹅到家技术栈匹配度待考。**\n3. **团队管理与培训能力：4/5分。依据：搭建人才体系，线上线下培训覆盖超万人次，但家政蓝领群体管理场景差异大。**\n4. **行业适配与稳定性：2/5分。依据：零家政从业背景，职业跨度大，时间线存疑，转型动机不明确。**\n5. **客户服务与标准化落地：2/5分。依据：医疗背景有服务意识基础，但缺乏家政服务标准（如保洁SOP、月嫂护理规范）实操经验。**",
    "created": ""
  },
  {
    "id": 104,
    "name": "刘先生",
    "role": "无法提取",
    "company": "",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "刘",
    "dept": "",
    "city": "长沙",
    "age": "35岁",
    "gender": "男",
    "strengths": "13年即时配送管理经验，擅长从0到1搭建标准化运营体系（SOP制定、三级管理架构、服务商绩效考核），具备数字化运营思维（数据监控、KPI拆解、效能优化），与天鹅到家\"服务标准化、数字化、职业化\"战略高度契合；跨平台（京东、盒马、顺丰、饿了么）背景带来多元管理视角。",
    "risks": "无家政/上门服务行业直接经验，存在业务场景转换风险；近4年任职京东秒送（2021.07至今），但此前每段经历平均1.5-2年，稳定性存疑；35岁期望薪资20-25K高于家政行业同类岗位均值，薪酬匹配度待验证。",
    "aiEval": "以下为候选人的 无法提取 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：无法提取\n🏢 招聘岗位：无法提取\n\n初筛结果: 存疑\n\n优势分析:\n13年即时配送管理经验，擅长从0到1搭建标准化运营体系（SOP制定、三级管理架构、服务商绩效考核），具备数字化运营思维（数据监控、KPI拆解、效能优化），与天鹅到家\"服务标准化、数字化、职业化\"战略高度契合；跨平台（京东、盒马、顺丰、饿了么）背景带来多元管理视角。\n\n风险点:\n无家政/上门服务行业直接经验，存在业务场景转换风险；近4年任职京东秒送（2021.07至今），但此前每段经历平均1.5-2年，稳定性存疑；35岁期望薪资20-25K高于家政行业同类岗位均值，薪酬匹配度待验证。\n\n能力维度匹配:\n1. **运营管理能力：4.5/5分。依据：10年同城配送全链路管理，搭建山姆云仓从3家扩至10家，建立三级管理体系与SOP标准化流程，KPI全国前列，具备规模化复制能力。**\n2. **数字化能力：4/5分。依据：持续输出运营数据报表，基于效能指标优化排班与运力结构，指导服务商利润优化，数据驱动决策意识明确。**\n3. **团队搭建能力：4.5/5分。依据：多次完成首城首店配送体系搭建，主导站长选拔与梯队建设，管理峰值500人团队，人才供应链管理经验扎实。**\n4. **供应商管理：4/5分。依据：建立供应商绩效考核体系，统筹招标-入驻-运营全周期，具备渠道资源整合与谈判能力，但缺乏家政阿姨直接管理经验。**\n5. **客户体验管理：3.5/5分。依据：制定服务标准化操作标准，通过巡店督导提升满意度，但过往聚焦B端履约时效，C端家庭服务场景经验有限。**\n\n面试问题:\n1. 请描述一次您处理重大客户投诉或突发危机事件的具体案例，当时采取了哪些步骤，最终结果如何？\n2. 您过往管理的配送员多为众包/兼职人员，与家政阿姨（相对固定、技",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "无法提取",
    "interviewQ": "1. 请描述一次您处理重大客户投诉或突发危机事件的具体案例，当时采取了哪些步骤，最终结果如何？\n2. 您过往管理的配送员多为众包/兼职人员，与家政阿姨（相对固定、技能型劳动者）的管理差异较大，您计划如何快速建立信任并提升其服务标准？\n3. 2021年前您的职业变动较为频繁，加入京东后稳定性提升的原因是什么？未来3-5年的职业规划是否与家政行业的长期深耕方向一致？\n4. 天鹅到家正在推进服务人员的职业化认证体系，结合您在顺丰搭建培训体系的经验，请设计一个针对新手保洁师的7天岗前培训框架（含核心模块与考核标准）。\n5. 假设某城市站点阿姨订单履约率达标但客户差评率持续偏高，请说明您会通过哪些数据指标定位问题根源，并给出改善方案。",
    "capabilityMatch": "1. **运营管理能力：4.5/5分。依据：10年同城配送全链路管理，搭建山姆云仓从3家扩至10家，建立三级管理体系与SOP标准化流程，KPI全国前列，具备规模化复制能力。**\n2. **数字化能力：4/5分。依据：持续输出运营数据报表，基于效能指标优化排班与运力结构，指导服务商利润优化，数据驱动决策意识明确。**\n3. **团队搭建能力：4.5/5分。依据：多次完成首城首店配送体系搭建，主导站长选拔与梯队建设，管理峰值500人团队，人才供应链管理经验扎实。**\n4. **供应商管理：4/5分。依据：建立供应商绩效考核体系，统筹招标-入驻-运营全周期，具备渠道资源整合与谈判能力，但缺乏家政阿姨直接管理经验。**\n5. **客户体验管理：3.5/5分。依据：制定服务标准化操作标准，通过巡店督导提升满意度，但过往聚焦B端履约时效，C端家庭服务场景经验有限。**",
    "created": ""
  },
  {
    "id": 105,
    "name": "刘欢",
    "role": "无法提取",
    "company": "",
    "years": 0,
    "edu": "2013-2019大专、2021-2023本科",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "刘",
    "dept": "",
    "city": "长沙",
    "age": "28岁",
    "gender": "无法提取",
    "strengths": "具备零售连锁规模化运营经验（2500家门店），擅长标准化流程搭建、加盟商赋能与团队管理；数据驱动意识强，有成本管控、SKU优化及供应链协同经验；跨部门协作与复杂问题处理能力突出，可迁移至家政服务数字化与职业化体系建设。",
    "risks": "无家政/生活服务直接经验，行业转换存在认知盲区；简历时间线异常（2025.04-2026.05为未来时段），诚信存疑；28岁经历6年工作+2段学历（2013-2019大专、2021-2023本科），时间线压缩，稳定性需验证；期望薪资13-16K与家政运营岗匹配度待确认。",
    "aiEval": "以下为候选人的 无法提取 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：无法提取\n🏢 招聘岗位：无法提取\n👤 年龄：28岁 | 性别：无法提取 | 学历：2013-2019大专、2021-2023本科\n\n初筛结果: 淘汰\n\n优势分析:\n具备零售连锁规模化运营经验（2500家门店），擅长标准化流程搭建、加盟商赋能与团队管理；数据驱动意识强，有成本管控、SKU优化及供应链协同经验；跨部门协作与复杂问题处理能力突出，可迁移至家政服务数字化与职业化体系建设。\n\n风险点:\n无家政/生活服务直接经验，行业转换存在认知盲区；简历时间线异常（2025.04-2026.05为未来时段），诚信存疑；28岁经历6年工作+2段学历（2013-2019大专、2021-2023本科），时间线压缩，稳定性需验证；期望薪资13-16K与家政运营岗匹配度待确认。\n\n能力维度匹配:\n1. **业务运营能力：4/5分。依据：统筹2500家门店运营，完成100+门店销售提升，具备规模化标准化运营经验，但缺乏家政服务场景验证。\n2. **数据分析与决策：3/5分。依据：熟练使用办公软件及OA系统，有基础数据分析能力，支撑SKU优化与采购决策，但未体现高级数据工具应用。\n3. **客户/加盟商管理：4/5分。依据：主导加盟商赋能、分级管理及关系维护，组织80+场培训活动，客户拓展与复杂问题处理经验丰富。\n4. **供应链与成本管控：4/5分。依据：1年采购经验，管理80+SKU，年度采购额30亿，降本与供应商谈判能力突出，可迁移至服务供应链优化。\n5. **团队管理与培养：3/5分。依据：管理学生团队100人，推进团队绩效考核与培训，但未明确直接下属管理规模及家政服务人员管理经验。\n\n面试问题:\n1. 请描述一次你处理加盟商重大投诉或冲突的经历，具体采取了哪些步骤，最终结果如何？\n2. 你在广东省从10家拓展",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "无法提取",
    "interviewQ": "1. 请描述一次你处理加盟商重大投诉或冲突的经历，具体采取了哪些步骤，最终结果如何？\n2. 你在广东省从10家拓展到500家门店的过程中，如何平衡快速扩张与服务质量稳定性？遇到过哪些阻力？\n3. 你的职业规划中为何选择从零售转向家政服务？如何看待两个行业的差异与挑战？\n4. 家政服务标准化涉及服务流程、人员培训、质量监控等多环节，结合你的零售标准化经验，请设计一个家政保洁服务的SOP框架要点。\n5. 假设你需要在3个月内将某城市家政服务订单量提升30%，你会如何从供给端（阿姨招募/培训）和需求端（获客/转化）制定策略？",
    "capabilityMatch": "1. **业务运营能力：4/5分。依据：统筹2500家门店运营，完成100+门店销售提升，具备规模化标准化运营经验，但缺乏家政服务场景验证。\n2. **数据分析与决策：3/5分。依据：熟练使用办公软件及OA系统，有基础数据分析能力，支撑SKU优化与采购决策，但未体现高级数据工具应用。\n3. **客户/加盟商管理：4/5分。依据：主导加盟商赋能、分级管理及关系维护，组织80+场培训活动，客户拓展与复杂问题处理经验丰富。\n4. **供应链与成本管控：4/5分。依据：1年采购经验，管理80+SKU，年度采购额30亿，降本与供应商谈判能力突出，可迁移至服务供应链优化。\n5. **团队管理与培养：3/5分。依据：管理学生团队100人，推进团队绩效考核与培训，但未明确直接下属管理规模及家政服务人员管理经验。",
    "created": ""
  },
  {
    "id": 106,
    "name": "夏尚",
    "role": "",
    "company": "",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "夏",
    "dept": "",
    "city": "",
    "age": "无",
    "gender": "无",
    "strengths": "6年零售渠道运营经验，曾在顾家家居任区域负责人（年生意8000万）、东方雨虹任零售运营经理（年销2800万），具备经销商管理、专卖店运营、营销活动策划全链路经验。数字化营销能力突出（抖音/直播/小红书），业绩可量化（年度完成率112%等）。",
    "risks": "薪资期望18-22K略高于市场",
    "aiEval": "以下为候选人的 夏尚 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：夏尚\n\n初筛结果: 淘汰\n\n优势分析:\n6年零售渠道运营经验，曾在顾家家居任区域负责人（年生意8000万）、东方雨虹任零售运营经理（年销2800万），具备经销商管理、专卖店运营、营销活动策划全链路经验。数字化营销能力突出（抖音/直播/小红书），业绩可量化（年度完成率112%等）。\n\n风险点:\n薪资期望18-22K略高于市场\n\n能力维度匹配:\n1. **能力：**经销商管理。依据：6年零售渠道运营经验，曾在顾家家居任区域负责人（年生意8000万）、东方雨虹任零售运营经理（年销2800万）\n2. **能力：**专卖店运营。依据：6年零售渠道运营经验，曾在顾家家居任区域负责人（年生意8000万）、东方雨虹任零售运营经理（年销2800万）\n3. **能力：**营销活动策划。依据：6年零售渠道运营经验，曾在顾家家居任区域负责人（年生意8000万）、东方雨虹任零售运营经理（年销2800万）\n4. **能力：**数字化营销。依据：数字化营销能力突出（抖音/直播/小红书）\n5. **能力：**业绩达成。依据：业绩可量化（年度完成率112%等）\n\n面试问题:\n1. 请介绍一下你在顾家家居担任区域负责人时，年生意8000万的具体达成策略和关键举措。\n2. 作为东方雨虹的零售运营经理，你是如何实现年销2800万业绩的？在经销商管理方面有哪些成功经验？\n3. 你具备全链路经验，能否详细说明你在专卖店运营和营销活动策划中的具体职责和成果？\n4. 你的数字化营销能力突出，能否分享一个你在抖音、直播或小红书平台上成功策划并执行的营销案例？\n5. 你提到业绩可量化，比如年度完成率112%，这个数据是在什么背景下达成的？遇到了哪些挑战，如何克服的？\n6. 你的薪资期望是18-22K略高于市场，能否说明你认为自己值这个薪资的核心竞争力",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "夏尚",
    "interviewQ": "1. 请介绍一下你在顾家家居担任区域负责人时，年生意8000万的具体达成策略和关键举措。\n2. 作为东方雨虹的零售运营经理，你是如何实现年销2800万业绩的？在经销商管理方面有哪些成功经验？\n3. 你具备全链路经验，能否详细说明你在专卖店运营和营销活动策划中的具体职责和成果？\n4. 你的数字化营销能力突出，能否分享一个你在抖音、直播或小红书平台上成功策划并执行的营销案例？\n5. 你提到业绩可量化，比如年度完成率112%，这个数据是在什么背景下达成的？遇到了哪些挑战，如何克服的？\n6. 你的薪资期望是18-22K略高于市场，能否说明你认为自己值这个薪资的核心竞争力是什么？",
    "capabilityMatch": "1. **能力：**经销商管理。依据：6年零售渠道运营经验，曾在顾家家居任区域负责人（年生意8000万）、东方雨虹任零售运营经理（年销2800万）\n2. **能力：**专卖店运营。依据：6年零售渠道运营经验，曾在顾家家居任区域负责人（年生意8000万）、东方雨虹任零售运营经理（年销2800万）\n3. **能力：**营销活动策划。依据：6年零售渠道运营经验，曾在顾家家居任区域负责人（年生意8000万）、东方雨虹任零售运营经理（年销2800万）\n4. **能力：**数字化营销。依据：数字化营销能力突出（抖音/直播/小红书）\n5. **能力：**业绩达成。依据：业绩可量化（年度完成率112%等）",
    "created": ""
  },
  {
    "id": 107,
    "name": "唐毓璟",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "27年应届生",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "唐",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "45岁",
    "gender": "无法提取",
    "strengths": "具备从0到1账号搭建经验，熟悉小红书内容运营与A/B测试优化；有社群运营及用户转化链路实战经验，数据敏感度高；环境设计背景兼具视觉内容输出与文案策划能力，契合家政招募内容\"接地气+吸引力\"的双重要求。",
    "risks": "27年应届生，实习周期仅3个月（网易）+当前在职，稳定性存疑；无家政/蓝领招聘领域经验，对劳动者群体沟通语境需适应；缺乏Boss直聘等垂直招聘渠道实操，转化优化能力需验证。",
    "aiEval": "以下为候选人的 劳动者运营实习生 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：劳动者运营实习生（家政业务方向）\n🏢 招聘岗位：劳动者运营实习生\n\n初筛结果: 通过\n\n优势分析:\n具备从0到1账号搭建经验，熟悉小红书内容运营与A/B测试优化；有社群运营及用户转化链路实战经验，数据敏感度高；环境设计背景兼具视觉内容输出与文案策划能力，契合家政招募内容\"接地气+吸引力\"的双重要求。\n\n风险点:\n27年应届生，实习周期仅3个月（网易）+当前在职，稳定性存疑；无家政/蓝领招聘领域经验，对劳动者群体沟通语境需适应；缺乏Boss直聘等垂直招聘渠道实操，转化优化能力需验证。\n\n能力维度匹配:\n1. **内容策划能力：4/5分。依据：独立完成小红书账号0-1搭建，产出60篇图文，单篇浏览量5k+；运营个人抖音账号，热点追踪与内容包装能力强；书画协会固定栏目策划经验，具备持续内容生产能力。\n2. **流量分析能力：4/5分。依据：建立数据监控表追踪点击率，A/B测试优化标题封面使点击率提升7%、曝光率提升40%；个人账号通过数据分析优化选题策略；建立AISAS模型分析购买数据，数据驱动意识明确。\n3. **转化优化能力：3/5分。依据：社群运营中搭建\"内容引流-互动反馈-用户转化\"链路，引导用户进入付费池；但缺乏Boss直聘等招聘渠道测试经验，蓝领群体转化场景需验证。\n4. **用户沟通能力：3.5/5分。依据：维护评论区与私信收集用户反馈30余条，推动产品优化；社群200人日常互动与咨询引导；但面向家政阿姨群体的下沉市场沟通经验未体现。\n\n面试问题:\n1. 请描述一次你处理用户负面反馈或投诉的经历，当时如何沟通解决？\n2. 在网易实习仅3个月，如果天鹅到家需要6个月实习周期，你如何规划学业与实习的时间冲突？\n3. 社群运营中如何协调多方资源推动活动落地，请举例说明跨部门协作的具体做",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 请描述一次你处理用户负面反馈或投诉的经历，当时如何沟通解决？\n2. 在网易实习仅3个月，如果天鹅到家需要6个月实习周期，你如何规划学业与实习的时间冲突？\n3. 社群运营中如何协调多方资源推动活动落地，请举例说明跨部门协作的具体做法。\n4. 针对45岁家政阿姨群体，设计一条小红书招募笔记的标题和封面文案，并说明你的用户洞察依据。\n5. 如果Boss直聘上某家政岗位投递转化率低于行业均值，你会如何设计A/B测试方案优化岗位描述？",
    "capabilityMatch": "1. **内容策划能力：4/5分。依据：独立完成小红书账号0-1搭建，产出60篇图文，单篇浏览量5k+；运营个人抖音账号，热点追踪与内容包装能力强；书画协会固定栏目策划经验，具备持续内容生产能力。\n2. **流量分析能力：4/5分。依据：建立数据监控表追踪点击率，A/B测试优化标题封面使点击率提升7%、曝光率提升40%；个人账号通过数据分析优化选题策略；建立AISAS模型分析购买数据，数据驱动意识明确。\n3. **转化优化能力：3/5分。依据：社群运营中搭建\"内容引流-互动反馈-用户转化\"链路，引导用户进入付费池；但缺乏Boss直聘等招聘渠道测试经验，蓝领群体转化场景需验证。\n4. **用户沟通能力：3.5/5分。依据：维护评论区与私信收集用户反馈30余条，推动产品优化；社群200人日常互动与咨询引导；但面向家政阿姨群体的下沉市场沟通经验未体现。",
    "created": ""
  },
  {
    "id": 108,
    "name": "HZJHZJ",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "大二在读",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "H",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "大二",
    "gender": "无",
    "strengths": "具备短视频策划、剪辑及自媒体推广经验（泉州广电、力诚项目），有完整内容生产链路能力；校园新媒体运营经历（湖北大学记者团4w+浏览）验证基础流量敏感度；性格外向、抗压能力强，适配家政劳动者沟通场景。",
    "risks": "2028年毕业（大二在读），实习周期稳定性存疑；无明确数据复盘案例（力诚项目仅描述\"销量提升\"无具体指标）；缺乏招聘/社群运营直接经验，家政行业认知空白；香港籍身份需确认长沙实习签证/居留合规性。",
    "aiEval": "以下为候选人的 劳动者运营实习生 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：劳动者运营实习生（家政业务方向）\n🏢 招聘岗位：劳动者运营实习生\n\n初筛结果: 存疑\n\n优势分析:\n具备短视频策划、剪辑及自媒体推广经验（泉州广电、力诚项目），有完整内容生产链路能力；校园新媒体运营经历（湖北大学记者团4w+浏览）验证基础流量敏感度；性格外向、抗压能力强，适配家政劳动者沟通场景。\n\n风险点:\n2028年毕业（大二在读），实习周期稳定性存疑；无明确数据复盘案例（力诚项目仅描述\"销量提升\"无具体指标）；缺乏招聘/社群运营直接经验，家政行业认知空白；香港籍身份需确认长沙实习签证/居留合规性。\n\n能力维度匹配:\n1. **内容策划能力：3.5/5分。依据：有短视频策划及小红书/微博文案撰写经验，但均为产品推广而非招聘类内容，家政\"接地气\"文案风格未验证。**\n2. **流量分析能力：2/5分。依据：仅提及\"浏览量4w+\"等结果数据，无主动优化动作描述（如AB测试、关键词调整），数据敏感度未体现。**\n3. **转化优化能力：2/5分。依据：力诚项目提到\"优化内容结构\"，但无渠道测试、话术迭代、转化率对比等具体方法论，招聘场景转化经验缺失。**\n4. **用户沟通能力：3/5分。依据：担任班长、学委有协调沟通经验，但缺乏服务蓝领/中老年劳动者群体的直接经历，耐心与引导技巧待验证。**\n\n面试问题:\n1. \"请描述一次你需要说服他人配合完成某项任务的经历，当时对方是什么态度，你具体采取了哪些沟通策略？\"\n2. \"在泉州广电实习中，如果医生主题活动的直播现场出现突发状况（如设备故障或嘉宾迟到），你会如何快速协调处理？\"\n3. \"你的求职意向是互联网广告行业，为什么选择投递家政业务的运营实习？未来1-2年的职业规划是什么？\"\n4. \"假设需要在Boss直聘发布一则'住家育儿嫂'招募帖，请",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. \"请描述一次你需要说服他人配合完成某项任务的经历，当时对方是什么态度，你具体采取了哪些沟通策略？\"\n2. \"在泉州广电实习中，如果医生主题活动的直播现场出现突发状况（如设备故障或嘉宾迟到），你会如何快速协调处理？\"\n3. \"你的求职意向是互联网广告行业，为什么选择投递家政业务的运营实习？未来1-2年的职业规划是什么？\"\n4. \"假设需要在Boss直聘发布一则'住家育儿嫂'招募帖，请现场构思标题、3个核心福利亮点，并说明针对40-50岁农村女性劳动者的文案设计思路。\"\n5. \"如果某条小红书招募笔记曝光量高但咨询转化率低，你会从哪些维度拆解原因？请列出你的分析框架和优化优先级。\"\n6. \"面试接近尾声，我想把主动权交给你——关于天鹅到家的劳动者运营模式、我们团队当前面临的核心挑战，或者这个岗位的成长空间，你有什么想深入了解的吗？\"",
    "capabilityMatch": "1. **内容策划能力：3.5/5分。依据：有短视频策划及小红书/微博文案撰写经验，但均为产品推广而非招聘类内容，家政\"接地气\"文案风格未验证。**\n2. **流量分析能力：2/5分。依据：仅提及\"浏览量4w+\"等结果数据，无主动优化动作描述（如AB测试、关键词调整），数据敏感度未体现。**\n3. **转化优化能力：2/5分。依据：力诚项目提到\"优化内容结构\"，但无渠道测试、话术迭代、转化率对比等具体方法论，招聘场景转化经验缺失。**\n4. **用户沟通能力：3/5分。依据：担任班长、学委有协调沟通经验，但缺乏服务蓝领/中老年劳动者群体的直接经历，耐心与引导技巧待验证。**",
    "created": ""
  },
  {
    "id": 109,
    "name": "刘子龙",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "刘",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "37岁",
    "gender": "男",
    "strengths": "16年电销/网销经验，连续多份业绩Top5/销冠，擅长电话+企微+面签全流程转化；具备带教培训经验，可快速复制方法论；自媒体运营能力契合天鹅到家数字化获客需求。",
    "risks": "期望薪资20-40K显著高于JD的7-12K，存在落差；保险/教育/金融行业背景与家政劳动者招募场景差异较大，行业认知需重建；37岁职业转型动机待验证。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 通过\n\n优势分析:\n16年电销/网销经验，连续多份业绩Top5/销冠，擅长电话+企微+面签全流程转化；具备带教培训经验，可快速复制方法论；自媒体运营能力契合天鹅到家数字化获客需求。\n\n风险点:\n期望薪资20-40K显著高于JD的7-12K，存在落差；保险/教育/金融行业背景与家政劳动者招募场景差异较大，行业认知需重建；37岁职业转型动机待验证。\n\n能力维度匹配:\n1. **客户开发能力：5/5分。依据：中英人寿及菜鸟无忧均体现\"电话+企微+面签\"全链路成交，连续销冠，业绩20-30万/月，与JD招募签约场景高度吻合。**\n2. **活动执行能力：3/5分。依据：卓越蔚蓝店长经历涉及促销计划制定与活动实施，但未明确提及大型招商活动执行经验。**\n3. **市场分析能力：2/5分。依据：简历未体现行业信息收集、区域市场分析或策略建议的相关行为证据。**\n4. **商务沟通能力：4/5分。依据：多份销售岗位均强调客户沟通与谈判，带过徒弟培训产品技能，具备基础商务表达素养。**\n5. **软件操作能力：3/5分。依据：持有计算机二级证书，但未明确提及Office具体应用场景，需实操验证。**\n\n面试问题:\n1. \"您过往客户以B端企业主或C端保险客户为主，家政劳动者群体学历偏低、流动性高、决策链条短，请举例说明您如何调整沟通策略应对差异化客群？\"\n2. \"您在中英人寿带教新人时，遇到徒弟连续3个月未开单的情况，您具体做了什么帮助其突破？结果如何？\"\n3. \"您期望薪资20-40K与岗位预算存在差距，如果最终offer为10K底薪+绩效，您的决策考量是什么？\"\n4. \"假设您需要本周内招募10名保洁劳动者，请简述您的电话邀约话术",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. \"您过往客户以B端企业主或C端保险客户为主，家政劳动者群体学历偏低、流动性高、决策链条短，请举例说明您如何调整沟通策略应对差异化客群？\"\n2. \"您在中英人寿带教新人时，遇到徒弟连续3个月未开单的情况，您具体做了什么帮助其突破？结果如何？\"\n3. \"您期望薪资20-40K与岗位预算存在差距，如果最终offer为10K底薪+绩效，您的决策考量是什么？\"\n4. \"假设您需要本周内招募10名保洁劳动者，请简述您的电话邀约话术设计思路及跟进节奏安排。\"\n5. \"家政行业劳动者普遍关注'接单量、收入保障、培训免费'，请对比您过往销售产品的痛点差异，说明如何建立信任。\"",
    "capabilityMatch": "1. **客户开发能力：5/5分。依据：中英人寿及菜鸟无忧均体现\"电话+企微+面签\"全链路成交，连续销冠，业绩20-30万/月，与JD招募签约场景高度吻合。**\n2. **活动执行能力：3/5分。依据：卓越蔚蓝店长经历涉及促销计划制定与活动实施，但未明确提及大型招商活动执行经验。**\n3. **市场分析能力：2/5分。依据：简历未体现行业信息收集、区域市场分析或策略建议的相关行为证据。**\n4. **商务沟通能力：4/5分。依据：多份销售岗位均强调客户沟通与谈判，带过徒弟培训产品技能，具备基础商务表达素养。**\n5. **软件操作能力：3/5分。依据：持有计算机二级证书，但未明确提及Office具体应用场景，需实操验证。**",
    "created": ""
  },
  {
    "id": 110,
    "name": "黄维",
    "role": "人力资源助理-实习生",
    "company": "",
    "years": 0,
    "edu": "本科在读",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "黄",
    "dept": "",
    "city": "长沙",
    "age": "无",
    "gender": "无",
    "strengths": "具备AI产品实习经验，有从0到1项目落地经历，熟悉数字化工具与流程优化，对服务标准化、效率提升有认知基础。",
    "risks": "专业背景（景观设计）与家政服务零关联；实习仅4个月且已结束，稳定性存疑；无一线服务/运营经验，岗位匹配度极低；期望薪资100-130元/天与实习生定位吻合，但能力结构错位。",
    "aiEval": "以下为候选人的 人力资源助理-实习生 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：人力资源助理-实习生\n🏢 招聘岗位：人力资源助理-实习生\n\n初筛结果: 淘汰\n\n优势分析:\n具备AI产品实习经验，有从0到1项目落地经历，熟悉数字化工具与流程优化，对服务标准化、效率提升有认知基础。\n\n风险点:\n专业背景（景观设计）与家政服务零关联；实习仅4个月且已结束，稳定性存疑；无一线服务/运营经验，岗位匹配度极低；期望薪资100-130元/天与实习生定位吻合，但能力结构错位。\n\n能力维度匹配:\n1. **业务理解力：1/5分。依据**：完全缺乏家政/本地生活行业认知，AI产品经验与家政数字化场景无直接衔接，需从零建立业务sense。\n2. **客户服务意识：1/5分。依据**：简历未体现任何直面客户、处理客诉、服务交付的经历，产品岗偏后台支持，一线体感缺失。\n3. **沟通协调力：2/5分。依据**：有跨团队协作痕迹（模型评测、接口对接），但均为技术侧沟通，未验证复杂利益相关方协调能力。\n4. **执行力与稳定性：2/5分。依据**：单段实习4个月偏短，本科在读至2027年，毕业时间远，长期实习意愿及留用可能性不明。\n5. **数字化工具应用：3/5分。依据**：熟练使用Coze、RAG、prompt工程等AI工具，对家政数字化提效有潜在迁移价值，但场景差异大。\n\n面试问题:\n1. 请描述一次你主动识别并解决客户/用户痛点的经历，当时如何确认这是真需求而非伪需求？结果如何？\n2. 你的实习仅持续4个月，若加入天鹅到家需6个月以上实习期，如何说服我们你不会中途退出？\n3. 家政服务场景高度非标、客诉频发，请举例说明你如何处理过规则明确但执行混乱的复杂局面。\n4. 假设需设计一款帮助保洁阿姨提升服务效率的数字化工具，你会如何调研真实需求、定义MVP功能？\n5. 请对比AI生成营销文",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "人力资源助理-实习生",
    "interviewQ": "1. 请描述一次你主动识别并解决客户/用户痛点的经历，当时如何确认这是真需求而非伪需求？结果如何？\n2. 你的实习仅持续4个月，若加入天鹅到家需6个月以上实习期，如何说服我们你不会中途退出？\n3. 家政服务场景高度非标、客诉频发，请举例说明你如何处理过规则明确但执行混乱的复杂局面。\n4. 假设需设计一款帮助保洁阿姨提升服务效率的数字化工具，你会如何调研真实需求、定义MVP功能？\n5. 请对比AI生成营销文案与规范家政服务SOP的异同，你认为技术赋能家政的核心难点是什么？",
    "capabilityMatch": "1. **业务理解力：1/5分。依据**：完全缺乏家政/本地生活行业认知，AI产品经验与家政数字化场景无直接衔接，需从零建立业务sense。\n2. **客户服务意识：1/5分。依据**：简历未体现任何直面客户、处理客诉、服务交付的经历，产品岗偏后台支持，一线体感缺失。\n3. **沟通协调力：2/5分。依据**：有跨团队协作痕迹（模型评测、接口对接），但均为技术侧沟通，未验证复杂利益相关方协调能力。\n4. **执行力与稳定性：2/5分。依据**：单段实习4个月偏短，本科在读至2027年，毕业时间远，长期实习意愿及留用可能性不明。\n5. **数字化工具应用：3/5分。依据**：熟练使用Coze、RAG、prompt工程等AI工具，对家政数字化提效有潜在迁移价值，但场景差异大。",
    "created": ""
  },
  {
    "id": 111,
    "name": "雷纯平",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "待定",
    "star": 0,
    "avatar": "雷",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "",
    "gender": "",
    "strengths": "无",
    "risks": "意向不强",
    "aiEval": "29届，销售经验，意向不强",
    "aiScreen": "无",
    "hrReview": "",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 29届，销售经验，意向不强",
    "capabilityMatch": "（因正文未包含符合“能力维度匹配”格式的信息，无法提取，故输出空列表）\n1.",
    "created": ""
  },
  {
    "id": 112,
    "name": "明丽",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "待定",
    "star": 0,
    "avatar": "明",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "",
    "gender": "",
    "strengths": "28届，内容运营背景",
    "risks": "28届",
    "aiEval": "28届，内容运营背景",
    "aiScreen": "无",
    "hrReview": "",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 28届，内容运营背景",
    "capabilityMatch": "无能力维度匹配信息",
    "created": ""
  },
  {
    "id": 113,
    "name": "jdgejgfkk",
    "role": "劳动者运营实习生",
    "company": "",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "待定",
    "star": 0,
    "avatar": "j",
    "dept": "",
    "city": "岳阳",
    "age": "",
    "gender": "",
    "strengths": "未提及优势分析相关内容",
    "risks": "无风险点",
    "aiEval": "27届，湖南工商大学",
    "aiScreen": "未提及初筛结果",
    "hrReview": "",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 无",
    "capabilityMatch": "（由于正文内容中未包含任何与“能力维度匹配”相关的信息，无法提取出符合要求的内容，因此输出为空列表）\n1.",
    "created": ""
  },
  {
    "id": 114,
    "name": "张文学",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "待定",
    "star": 0,
    "avatar": "张",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "",
    "gender": "",
    "strengths": "该文本中未提及“优势分析”相关内容，无法提取。",
    "risks": "未提及风险点信息",
    "aiEval": "27届，湖南工商大学经济学",
    "aiScreen": "无",
    "hrReview": "",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 27届，湖南工商大学经济学",
    "capabilityMatch": "1. **能力：**经济学。依据：27届，湖南工商大学经济学",
    "created": ""
  },
  {
    "id": 115,
    "name": "刘艳艳",
    "role": "劳动者运营实习生",
    "company": "",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "待定",
    "star": 0,
    "avatar": "刘",
    "dept": "",
    "city": "宜春",
    "age": "",
    "gender": "",
    "strengths": "该文本中未提及优势分析相关内容，无法提取。",
    "risks": "无风险点信息",
    "aiEval": "28届，宜春学院数字经济",
    "aiScreen": "无",
    "hrReview": "",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 无",
    "capabilityMatch": "（由于正文中未包含“能力维度匹配”相关内容，无法提取信息，此处输出为空列表）\n1.",
    "created": ""
  },
  {
    "id": 116,
    "name": "李佳乐",
    "role": "劳动者运营实习生",
    "company": "AI智聘",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "待定",
    "star": 0,
    "avatar": "李",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "",
    "gender": "",
    "strengths": "未提及优势分析相关内容",
    "risks": "未提及风险点",
    "aiEval": "26届硕士，武汉华图教育视频编辑",
    "aiScreen": "无",
    "hrReview": "",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "无",
    "capabilityMatch": "（空）",
    "created": ""
  },
  {
    "id": 117,
    "name": "史小恬",
    "role": "劳动者运营实习生",
    "company": "",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "待定",
    "star": 0,
    "avatar": "史",
    "dept": "",
    "city": "广州",
    "age": "",
    "gender": "",
    "strengths": "28届硕士，天职国际审计",
    "risks": "无风险点",
    "aiEval": "28届硕士，天职国际审计",
    "aiScreen": "无",
    "hrReview": "",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 请介绍一下你自己。\n2. 你为什么选择天职国际审计岗位？\n3. 你对审计工作有哪些了解？\n4. 你在硕士期间学习的专业课程中，哪些与审计相关？\n5. 你有过相关的实习经历吗？请具体描述一下。\n6. 你认为审计工作需要具备哪些重要的能力？\n7. 面对高强度的审计工作，你会如何调节自己？\n8. 你对未来的职业发展有什么规划？\n9. 你还有什么问题想向我们了解的吗？",
    "capabilityMatch": "（无能力维度匹配相关信息）",
    "created": ""
  },
  {
    "id": 118,
    "name": "郁军亮",
    "role": "劳动者运营实习生",
    "company": "",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "待定",
    "star": 0,
    "avatar": "郁",
    "dept": "",
    "city": "新乡",
    "age": "",
    "gender": "",
    "strengths": "无",
    "risks": "无风险点信息",
    "aiEval": "27届，拓尔思舆情数据分析师",
    "aiScreen": "未提及初筛结果",
    "hrReview": "",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 无面试问题信息",
    "capabilityMatch": "（正文内容未包含“能力维度匹配”相关信息，无法提取）",
    "created": ""
  },
  {
    "id": 119,
    "name": "唐毓璟",
    "role": "劳动者运营实习生",
    "company": "",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "待定",
    "star": 0,
    "avatar": "唐",
    "dept": "",
    "city": "广州",
    "age": "",
    "gender": "",
    "strengths": "厦门社群运营经验",
    "risks": "27届毕业时间过早，存在时间真实性风险；仅提及厦门社群运营经验，未明确具体时长、职责及成果，经验深度和可信度存疑。",
    "aiEval": "27届，厦门社群运营经验",
    "aiScreen": "无",
    "hrReview": "",
    "interviewPos": "劳动者运营实习生（家政业务方向）",
    "interviewQ": "1. 你有厦门社群运营经验，能否具体分享一下你在社群运营中负责的主要工作内容和取得的成果？\n2. 作为27届毕业生，你认为自己相比有多年工作经验的社群运营从业者，有哪些独特的优势或学习能力可以胜任这个岗位？\n3. 在社群运营过程中，你是如何吸引新用户加入并提高用户活跃度的？有没有遇到过用户流失的问题，你是如何解决的？\n4. 你认为一个成功的社群应该具备哪些要素？在之前的经验中，你是如何打造或维护这些要素的？\n5. 社群运营中经常需要与用户沟通，当遇到用户投诉或负面情绪时，你会如何处理？请举例说明。",
    "capabilityMatch": "1. 能力：社群运营。依据：27届，厦门社群运营经验",
    "created": ""
  },
  {
    "id": 120,
    "name": "孟祥瑞",
    "role": "产品运营经理",
    "company": "AI智聘",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "孟",
    "dept": "AI创新事业部",
    "city": "长沙",
    "age": "无",
    "gender": "无",
    "strengths": "6年运营经验覆盖美团、京东、闪送等头部平台，擅长渠道拓展（15%订单增长）、流量运营（2.7倍老客增长）及0到1项目落地；具备完整增长方法论与跨部门协调能力，契合家政服务数字化、标准化需求。",
    "risks": "简历未提及任何AI应用落地经验（JD必须项），存在核心技能缺口；近1年4个月经历存疑（2024.05-2025.09为未来时间）；跳槽频繁（6年5段经历），稳定性待验证；无家政/服务类行业背景。",
    "aiEval": "以下为候选人的 产品运营经理 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：产品运营经理（双休）\n🏢 招聘岗位：产品运营经理\n\n初筛结果: 存疑\n\n优势分析:\n6年运营经验覆盖美团、京东、闪送等头部平台，擅长渠道拓展（15%订单增长）、流量运营（2.7倍老客增长）及0到1项目落地；具备完整增长方法论与跨部门协调能力，契合家政服务数字化、标准化需求。\n\n风险点:\n简历未提及任何AI应用落地经验（JD必须项），存在核心技能缺口；近1年4个月经历存疑（2024.05-2025.09为未来时间）；跳槽频繁（6年5段经历），稳定性待验证；无家政/服务类行业背景。\n\n能力维度匹配:\n1. **AI应用落地能力：0/5分。依据：简历全文未出现AI、智能算法、大模型、自动化运营等相关关键词，无法满足JD\"必须项\"要求。**\n2. **产品运营策略能力：4/5分。依据：主导闪送小程序从0到1成为行业标杆，美团跑腿增长框架规划及落地，具备\"数据+策略\"双引擎经验，但缺AI融合案例。**\n3. **用户增长建设能力：5/5分。依据：设计并落地全生命周期增长路径，外部渠道拓展贡献15%订单增量，智能外呼+企微私域实现10倍触达效率提升，老客访问2.7倍、新客4倍增长。**\n4. **数据分析优化能力：3/5分。依据：多次提及\"以客观事实+数据现状为参考\"\"数据跟踪\"\"效果分析\"，但缺乏核心指标监控体系搭建、深度用户行为挖掘及分析报告输出的直接描述。**\n5. **团队管理建设能力：2/5分。依据：仅有创业公司14人团队（商务部6人+达人部8人）管理经验，无AI思维培养、目标管理体系搭建描述，且近4年无管理岗经历。**\n\n面试问题:\n1. 你近5段工作经历平均时长约14个月，2024.05-2025.09的时间标注是否有误？请说明离职原因及职业选择逻辑，如何证明在天鹅到家的长期稳定性？\n2.",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "产品运营经理（双休）",
    "interviewQ": "1. 你近5段工作经历平均时长约14个月，2024.05-2025.09的时间标注是否有误？请说明离职原因及职业选择逻辑，如何证明在天鹅到家的长期稳定性？\n2. 描述一次与业务方/技术方产生重大分歧的经历，你如何通过沟通协调推动共识达成？具体策略与结果是什么？\n3. 家政服务涉及劳动者（阿姨）与消费者（家庭）双边信任建立，你过往有无服务类/双边平台运营经验？如何理解\"服务标准化\"与\"用户体验个性化\"的平衡？\n4. JD要求\"AI在运营全链路的深度应用\"，你简历中未体现AI经验。请阐述你对AI+家政运营的理解：若入职，你会在哪些环节引入AI？如何量化其价值？（允许基于现有能力推演）\n5. 家政用户生命周期与跑腿/即时配送存在显著差异（决策周期长、复购依赖信任、服务非标），请设计一套针对新客获取-首单转化-复购裂变-流失预警的增长路径，并说明关键指标与数据监控逻辑。",
    "capabilityMatch": "1. **AI应用落地能力：0/5分。依据：简历全文未出现AI、智能算法、大模型、自动化运营等相关关键词，无法满足JD\"必须项\"要求。**\n2. **产品运营策略能力：4/5分。依据：主导闪送小程序从0到1成为行业标杆，美团跑腿增长框架规划及落地，具备\"数据+策略\"双引擎经验，但缺AI融合案例。**\n3. **用户增长建设能力：5/5分。依据：设计并落地全生命周期增长路径，外部渠道拓展贡献15%订单增量，智能外呼+企微私域实现10倍触达效率提升，老客访问2.7倍、新客4倍增长。**\n4. **数据分析优化能力：3/5分。依据：多次提及\"以客观事实+数据现状为参考\"\"数据跟踪\"\"效果分析\"，但缺乏核心指标监控体系搭建、深度用户行为挖掘及分析报告输出的直接描述。**\n5. **团队管理建设能力：2/5分。依据：仅有创业公司14人团队（商务部6人+达人部8人）管理经验，无AI思维培养、目标管理体系搭建描述，且近4年无管理岗经历。**",
    "created": ""
  },
  {
    "id": 121,
    "name": "韩惠颖",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "本科",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "韩",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "50岁左右",
    "gender": "女",
    "strengths": "具备1年+教培销售及用户运营经验，擅长电话/社群跟进、需求挖掘与高转化沟通，曾获\"新人业绩第一\"；有独立对接18所高校、组织10场宣讲会的渠道开发与活动执行经验；目标感强、抗压能力突出，与家政招商地推场景高度契合。",
    "risks": "无家政/本地生活行业经验，需适应从\"家长-学生\"到\"劳动者-平台\"的服务对象转换；本科2025年7月毕业，当前仍为实习状态，存在学业与全职工作的时间冲突风险；校招经历集中于呼和浩特/河北，北京本地市场资源待验证。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 通过\n\n优势分析:\n具备1年+教培销售及用户运营经验，擅长电话/社群跟进、需求挖掘与高转化沟通，曾获\"新人业绩第一\"；有独立对接18所高校、组织10场宣讲会的渠道开发与活动执行经验；目标感强、抗压能力突出，与家政招商地推场景高度契合。\n\n风险点:\n无家政/本地生活行业经验，需适应从\"家长-学生\"到\"劳动者-平台\"的服务对象转换；本科2025年7月毕业，当前仍为实习状态，存在学业与全职工作的时间冲突风险；校招经历集中于呼和浩特/河北，北京本地市场资源待验证。\n\n能力维度匹配:\n1. **客户开发能力：4/5分。依据：教培销售中精准挖掘家长需求、推进续费转介绍（贡献占比50%），具备电话/社群跟进、签约转化全流程经验，可直接迁移至劳动者招募场景。\n2. **活动执行能力：4/5分。依据：全流程主导校招落地，独立组织10场宣讲会，涵盖策划、邀约、现场执行、面试统筹，转化率35%，活动执行力经规模化验证。\n3. **市场分析能力：2/5分。依据：简历未体现主动的市场信息收集与策略建议行为，用户调研聚焦个体需求而非行业/区域市场分析，该维度为明显短板。\n4. **商务沟通能力：4/5分。依据：兼具销售端高转化沟通与校企合作商务对接经验，\"走访30+赞助商/企业\"体现线下商务拓展能力，礼仪与表达符合岗位要求。\n5. **软件操作能力：3/5分。依据：环境科学本科背景含计算机基础课程，新媒体运营经历涉及数据分析与内容产出，但未明确提及Office文档处理的具体场景。\n\n面试问题:\n1. 请描述一次你通过电话或线上方式跟进高意向客户但最终未能签约的经历，当时你如何判断客户顾虑并尝试挽回？最终结果如何？\n2. 校招工作中需要同时对接多所",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 请描述一次你通过电话或线上方式跟进高意向客户但最终未能签约的经历，当时你如何判断客户顾虑并尝试挽回？最终结果如何？\n2. 校招工作中需要同时对接多所高校、协调多方资源，请举例说明你如何处理某个关键合作方的突发变更或冲突，确保活动如期举行？\n3. 你的毕业时间为2025年7月，目前实习已持续半年，如果加入我们需要全职投入地推工作，你如何规划学业与工作的平衡？是否考虑过提前毕业或延期？\n4. 家政劳动者招募与教培家长销售在客户决策链条、信任建立方式上有显著差异——前者更关注收入保障与平台可靠性，后者侧重教育效果。如果你负责招募一位50岁左右的保洁阿姨，你会如何设计首次电话沟通的话术结构？\n5. 假设你负责的北京某区域本月招募目标为30人，但前两周仅完成8人，且竞品平台正在同一区域密集地推。请简述你会如何快速收集该区域市场信息并调整策略？",
    "capabilityMatch": "1. **客户开发能力：4/5分。依据：教培销售中精准挖掘家长需求、推进续费转介绍（贡献占比50%），具备电话/社群跟进、签约转化全流程经验，可直接迁移至劳动者招募场景。\n2. **活动执行能力：4/5分。依据：全流程主导校招落地，独立组织10场宣讲会，涵盖策划、邀约、现场执行、面试统筹，转化率35%，活动执行力经规模化验证。\n3. **市场分析能力：2/5分。依据：简历未体现主动的市场信息收集与策略建议行为，用户调研聚焦个体需求而非行业/区域市场分析，该维度为明显短板。\n4. **商务沟通能力：4/5分。依据：兼具销售端高转化沟通与校企合作商务对接经验，\"走访30+赞助商/企业\"体现线下商务拓展能力，礼仪与表达符合岗位要求。\n5. **软件操作能力：3/5分。依据：环境科学本科背景含计算机基础课程，新媒体运营经历涉及数据分析与内容产出，但未明确提及Office文档处理的具体场景。",
    "created": ""
  },
  {
    "id": 122,
    "name": "于涌波",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "计算机专业",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "于",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "34岁",
    "gender": "男",
    "strengths": "11年北京本地工作经验，具备招商/客服多岗位历练；联东集团招商经历直接匹配\"电话+陌拜+接待签约\"全流程；SOHO物业客服经验沉淀了投诉处理、入驻跟进、费用催缴等劳动者服务场景；自我评价强调\"吃苦耐劳、突破自我\"，契合家政行业地推属性。",
    "risks": "简历时间线存在重大异常（2025年11月-2026年5月联东集团经历为\"未来时间\"），真实性存疑；无家政/母婴/保洁等行业背景；期望薪资9K高于JD区间7-12K下限但接近上限，需确认薪酬弹性；34岁未婚未育，需评估地推岗位体力负荷适配性。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 淘汰\n\n优势分析:\n11年北京本地工作经验，具备招商/客服多岗位历练；联东集团招商经历直接匹配\"电话+陌拜+接待签约\"全流程；SOHO物业客服经验沉淀了投诉处理、入驻跟进、费用催缴等劳动者服务场景；自我评价强调\"吃苦耐劳、突破自我\"，契合家政行业地推属性。\n\n风险点:\n简历时间线存在重大异常（2025年11月-2026年5月联东集团经历为\"未来时间\"），真实性存疑；无家政/母婴/保洁等行业背景；期望薪资9K高于JD区间7-12K下限但接近上限，需确认薪酬弹性；34岁未婚未育，需评估地推岗位体力负荷适配性。\n\n能力维度匹配:\n1. **客户开发能力：4/5分。依据：联东集团招商经理经历明确包含\"电话、陌拜、网络、老客户转介绍、商会活动\"等多渠道拓客，以及\"接待-跟进-签约-入园\"全链路，与JD\"电话/企微跟进、邀约、接待、签约\"高度重合。\n2. **活动执行能力：3/5分。依据：联东经历提及\"参加商会协会活动\"，但未明确描述主导或深度参与招商活动的策划执行细节，更多体现为参与而非组织。\n3. **市场分析能力：2/5分。依据：简历未直接呈现\"分析行业及区域市场信息并提出建议\"的行为证据；联东经历提到\"了解片区产业布局\"，偏向执行层信息获取，缺乏主动分析建议的显性描述。\n4. **商务沟通能力：4/5分。依据：SOHO物业3年客服经历涵盖\"投诉协调、入驻手续办理、费用催缴\"等高频沟通场景；自我评价明确\"沟通协调与谈判能力突出，善于精准洞察客户需求\"；珠宝顾问经历补充高端客户服务经验。\n5. **软件操作能力：3/5分。依据：自我评价提及\"熟悉Word、Excel、ppt等办公软件\"，但无具体应用案例（如数据分析、报表制作）",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. \"联东集团的工作时间显示为2025年11月至2026年5月，请确认这段经历的实际起止时间，并说明离职原因。\"\n2. \"在SOHO物业处理客户投诉时，请描述一次您协调多方资源、最终达成客户满意的完整案例，您具体采取了哪些步骤？\"\n3. \"招商工作中常面临业绩压力，请分享一次您连续遭遇客户拒绝后，如何调整状态并最终突破的经历。\"\n4. \"家政行业劳动者群体以中年女性为主，与联东集团的厂库房企业客户差异较大，您计划如何快速建立信任并有效邀约？\"\n5. \"假设需要在一周内完成20个保洁阿姨的招募目标，请简述您的具体执行计划，包括渠道选择和时间分配。\"",
    "capabilityMatch": "1. **客户开发能力：4/5分。依据：联东集团招商经理经历明确包含\"电话、陌拜、网络、老客户转介绍、商会活动\"等多渠道拓客，以及\"接待-跟进-签约-入园\"全链路，与JD\"电话/企微跟进、邀约、接待、签约\"高度重合。\n2. **活动执行能力：3/5分。依据：联东经历提及\"参加商会协会活动\"，但未明确描述主导或深度参与招商活动的策划执行细节，更多体现为参与而非组织。\n3. **市场分析能力：2/5分。依据：简历未直接呈现\"分析行业及区域市场信息并提出建议\"的行为证据；联东经历提到\"了解片区产业布局\"，偏向执行层信息获取，缺乏主动分析建议的显性描述。\n4. **商务沟通能力：4/5分。依据：SOHO物业3年客服经历涵盖\"投诉协调、入驻手续办理、费用催缴\"等高频沟通场景；自我评价明确\"沟通协调与谈判能力突出，善于精准洞察客户需求\"；珠宝顾问经历补充高端客户服务经验。\n5. **软件操作能力：3/5分。依据：自我评价提及\"熟悉Word、Excel、ppt等办公软件\"，但无具体应用案例（如数据分析、报表制作）；教育背景计算机专业提供基础支撑，但未体现深度应用。",
    "created": ""
  },
  {
    "id": 123,
    "name": "万女士",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "大专",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "万",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "29岁",
    "gender": "女",
    "strengths": "9年招聘实战经验，深耕美团小象超市蓝领用工场景，日均沟通500+候选人、月完成HC满编，对劳动者招募全流程（电话邀约-面试-入职）极度熟练；擅长地推活动执行与文案设计，有从0-1门店推广成功案例；疫情期异地招聘项目体现强抗压与资源整合能力，与天鹅到家\"地招+活动\"模式高度契合。",
    "risks": "无家政/母婴行业背景，劳动者群体从\"分拣员\"转向\"家政阿姨\"需重新建立人才画像认知；近3年美团经历稳定但此前2段工作均仅1年，早期职业稳定性存疑；29岁大专学历，长期职业发展天花板需关注；简历未体现Office技能细节。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 通过\n\n优势分析:\n9年招聘实战经验，深耕美团小象超市蓝领用工场景，日均沟通500+候选人、月完成HC满编，对劳动者招募全流程（电话邀约-面试-入职）极度熟练；擅长地推活动执行与文案设计，有从0-1门店推广成功案例；疫情期异地招聘项目体现强抗压与资源整合能力，与天鹅到家\"地招+活动\"模式高度契合。\n\n风险点:\n无家政/母婴行业背景，劳动者群体从\"分拣员\"转向\"家政阿姨\"需重新建立人才画像认知；近3年美团经历稳定但此前2段工作均仅1年，早期职业稳定性存疑；29岁大专学历，长期职业发展天花板需关注；简历未体现Office技能细节。\n\n能力维度匹配:\n1. **客户开发能力：5/5分。依据：日均电话沟通500+候选人、月邀约200+人、入职率60%-80%，蓝领招募转化数据优异，完全匹配\"电话/企微跟进-邀约-签约\"全流程。**\n2. **活动执行能力：4/5分。依据：主导小象超市APP地推项目，负责文案/海报/场地搭建，实现销量0-1突破、门店单量提升90%，具备完整活动执行经验。**\n3. **市场分析能力：2/5分。依据：简历仅体现\"对接业务leader明晰招聘需求\"，无主动市场信息收集、竞品分析或策略建议的明确证据，家政行业分析能力待验证。**\n4. **商务沟通能力：4/5分。依据：对接100+门店负责人及5+业务leader，擅长跨部门沟通调整招聘方向；薪资谈判、背景调查、入职协调经验丰富，商务礼仪基础扎实。**\n5. **软件操作能力：3/5分。依据：简历提及\"撰写文案、海报设计\"但未明确工具（是否Office/PS），无Excel数据处理或PPT汇报的量化证据，需现场验证。**\n\n面试问题:\n1. 你曾对接1",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 你曾对接100+门店负责人，当多个门店同时紧急要人但资源有限时，如何协调优先级并沟通解决冲突？请举例说明。\n2. 蓝领劳动者入职后流失率高是行业痛点，你在美团期间如何跟踪候选人入职后的稳定性？遇到入职3天内离职的情况如何处理？\n3. 你2017-2019年两段工作均为1年左右，但2021-2024年在美团任职3年，是什么因素促使你后期职业稳定性提升？加入新行业后如何规划3-5年发展？\n4. 天鹅到家招募的家政劳动者以育儿嫂、保洁员为主，与美团分拣员在求职动机、决策周期、顾虑点上差异很大，你认为招募家政阿姨最大的难点是什么？如何设计话术？\n5. 假设需要你分析北京朝阳区某片区家政劳动者供给不足的原因，你会从哪些维度收集信息？如何用Excel呈现分析结论给上级？",
    "capabilityMatch": "1. **客户开发能力：5/5分。依据：日均电话沟通500+候选人、月邀约200+人、入职率60%-80%，蓝领招募转化数据优异，完全匹配\"电话/企微跟进-邀约-签约\"全流程。**\n2. **活动执行能力：4/5分。依据：主导小象超市APP地推项目，负责文案/海报/场地搭建，实现销量0-1突破、门店单量提升90%，具备完整活动执行经验。**\n3. **市场分析能力：2/5分。依据：简历仅体现\"对接业务leader明晰招聘需求\"，无主动市场信息收集、竞品分析或策略建议的明确证据，家政行业分析能力待验证。**\n4. **商务沟通能力：4/5分。依据：对接100+门店负责人及5+业务leader，擅长跨部门沟通调整招聘方向；薪资谈判、背景调查、入职协调经验丰富，商务礼仪基础扎实。**\n5. **软件操作能力：3/5分。依据：简历提及\"撰写文案、海报设计\"但未明确工具（是否Office/PS），无Excel数据处理或PPT汇报的量化证据，需现场验证。**",
    "created": ""
  },
  {
    "id": 124,
    "name": "王洁",
    "role": "销售运营经理",
    "company": "",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "王",
    "dept": "",
    "city": "长沙",
    "age": "35岁",
    "gender": "女",
    "strengths": "12年商业化运营经验，擅长销售目标拆解、数据监控、商机管理及客户分层运营，具备从策略到落地的完整视野；多次超额达成业绩，有跨部门协同及数据驱动决策能力，对标准化流程建设有实践经验。",
    "risks": "求职意向为销售运营经理（管理岗/策略岗），与天鹅到家一线家政服务岗位（保洁/保姆/月嫂等）技能模型完全不匹配；无家政行业背景、无服务交付实操经验；35岁已婚已育但职业路径为互联网大厂运营，稳定性存疑（管理岗降维至服务岗动机不明）。",
    "aiEval": "以下为候选人的 销售运营经理 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：销售运营经理（双休）\n🏢 招聘岗位：销售运营经理\n\n初筛结果: 淘汰\n\n优势分析:\n12年商业化运营经验，擅长销售目标拆解、数据监控、商机管理及客户分层运营，具备从策略到落地的完整视野；多次超额达成业绩，有跨部门协同及数据驱动决策能力，对标准化流程建设有实践经验。\n\n风险点:\n求职意向为销售运营经理（管理岗/策略岗），与天鹅到家一线家政服务岗位（保洁/保姆/月嫂等）技能模型完全不匹配；无家政行业背景、无服务交付实操经验；35岁已婚已育但职业路径为互联网大厂运营，稳定性存疑（管理岗降维至服务岗动机不明）。\n\n能力维度匹配:\n1. **家政服务技能：0/5分。依据：简历无任何家政服务、保洁标准、母婴护理、烹饪等实操经验，纯互联网运营背景。**\n2. **客户沟通与服务意识：3/5分。依据：有客户分级管理、异动挽回、商机跟进经验，但偏向B端销售管理，非C端家政服务场景。**\n3. **标准化流程执行：4/5分。依据：擅长数据治理、流程搭建、标签体系建立，有从0到1制度搭建经验，可迁移至服务标准化。**\n4. **稳定性与职业动机：1/5分。依据：当前在职微博（2024.8至今），求职地为长沙但现base北京，管理岗背景应聘服务岗动机未明，存疑。**\n5. **数字化工具应用：4/5分。依据：熟练使用Excel、Tableau、SQL，有可视化看板搭建及数据预测模型构建能力。**\n\n面试问题:\n1. 请描述一次你需要协调产品、销售、财务等多部门解决复杂客户问题的经历，当时各方分歧是什么，你如何推动共识达成？\n2. 在你过往的客户分级管理中，针对\"下迁客户\"的挽回案例，具体采取了哪些动作，最终挽回率如何？\n3. 你目前在北京微博担任销售运营，求职长沙岗位且偏一线服务性质，请说明这一职业选择的动机及未来",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "销售运营经理（双休）",
    "interviewQ": "1. 请描述一次你需要协调产品、销售、财务等多部门解决复杂客户问题的经历，当时各方分歧是什么，你如何推动共识达成？\n2. 在你过往的客户分级管理中，针对\"下迁客户\"的挽回案例，具体采取了哪些动作，最终挽回率如何？\n3. 你目前在北京微博担任销售运营，求职长沙岗位且偏一线服务性质，请说明这一职业选择的动机及未来3年规划。\n4. 天鹅到家对保洁服务有108项验收标准，假设你需要将这类标准转化为一线服务人员可执行的SOP，你会如何设计培训和检核机制？\n5. 家政行业服务人员流动性高、服务非标，你如何运用数据工具识别高风险订单并提前干预？请举例说明可落地的数据看板指标。",
    "capabilityMatch": "1. **家政服务技能：0/5分。依据：简历无任何家政服务、保洁标准、母婴护理、烹饪等实操经验，纯互联网运营背景。**\n2. **客户沟通与服务意识：3/5分。依据：有客户分级管理、异动挽回、商机跟进经验，但偏向B端销售管理，非C端家政服务场景。**\n3. **标准化流程执行：4/5分。依据：擅长数据治理、流程搭建、标签体系建立，有从0到1制度搭建经验，可迁移至服务标准化。**\n4. **稳定性与职业动机：1/5分。依据：当前在职微博（2024.8至今），求职地为长沙但现base北京，管理岗背景应聘服务岗动机未明，存疑。**\n5. **数字化工具应用：4/5分。依据：熟练使用Excel、Tableau、SQL，有可视化看板搭建及数据预测模型构建能力。**",
    "created": ""
  },
  {
    "id": 125,
    "name": "孙立成",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "孙",
    "dept": "养老及商业事业部",
    "city": "郑州",
    "age": "无",
    "gender": "男",
    "strengths": "16年工作经验含5年大客户开发，1个月拜访150+客户并成功签约，具备强目标导向与结果思维；军人出身纪律严明执行力强，契合家政服务标准化、规范化要求；有B端+C端双重视角，擅长需求挖掘与沟通。",
    "risks": "近10年工作经历以B端大客户销售、安全管理和行政为主，无家政/劳动者招募直接经验；最近两份工作间隔存疑（2023.11-2026.02标注为\"GV\"疑似格式错误）；期望城市为济南，与岗位地点郑州存在地域偏差。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 通过\n\n优势分析:\n16年工作经验含5年大客户开发，1个月拜访150+客户并成功签约，具备强目标导向与结果思维；军人出身纪律严明执行力强，契合家政服务标准化、规范化要求；有B端+C端双重视角，擅长需求挖掘与沟通。\n\n风险点:\n近10年工作经历以B端大客户销售、安全管理和行政为主，无家政/劳动者招募直接经验；最近两份工作间隔存疑（2023.11-2026.02标注为\"GV\"疑似格式错误）；期望城市为济南，与岗位地点郑州存在地域偏差。\n\n能力维度匹配:\n1. **客户开发能力：4/5分。依据：5年大客户开发经验，1个月拜访150+客户并签约，具备电话跟进、邀约、签约全流程经验，但缺乏劳动者/家政C端招募场景验证。\n2. **活动执行能力：3/5分。依据：参与集采平台项目落地、协调供应商与客户，具备活动/项目执行经验，但无明确招商活动执行记录。\n3. **市场分析能力：3/5分。依据：负责空白市场开拓、筛选优质代理商，具备基础市场判断能力，但无系统性的行业信息分析与建议输出记录。\n4. **商务沟通能力：4/5分。依据：仪仗队/警卫连出身，形象气质佳；完成终端成交110万+，具备B端与C端沟通经验；为老首长服务体现礼仪与耐心。\n5. **软件操作能力：3/5分。依据：负责数据统计、分析与归档，具备数据化运营意识，提及\"使用office软件\"但未明确具体熟练程度。\n\n面试问题:\n1. 请描述一次您通过电话或线上方式持续跟进并最终促成签约的经历，当时遇到了什么阻力，您如何调整策略？\n2. 您曾1个月拜访150+客户，如何平衡拜访数量与质量？如果换成需要长期维护的劳动者招募场景，您会调整哪些工作方法？\n3. 您的期望城市是济南，该",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 请描述一次您通过电话或线上方式持续跟进并最终促成签约的经历，当时遇到了什么阻力，您如何调整策略？\n2. 您曾1个月拜访150+客户，如何平衡拜访数量与质量？如果换成需要长期维护的劳动者招募场景，您会调整哪些工作方法？\n3. 您的期望城市是济南，该岗位base郑州，请说明您的地域考虑及未来2-3年的稳定性规划。\n4. 家政劳动者招募中，常见流失原因是\"收入不稳定\"和\"客户挑剔\"，您会如何设计话术或方案应对这两个核心顾虑？\n5. 假设公司计划在郑州某区开展地推招募活动，请简述您会如何提前分析该区域市场信息并制定执行建议。",
    "capabilityMatch": "1. **客户开发能力：4/5分。依据：5年大客户开发经验，1个月拜访150+客户并签约，具备电话跟进、邀约、签约全流程经验，但缺乏劳动者/家政C端招募场景验证。\n2. **活动执行能力：3/5分。依据：参与集采平台项目落地、协调供应商与客户，具备活动/项目执行经验，但无明确招商活动执行记录。\n3. **市场分析能力：3/5分。依据：负责空白市场开拓、筛选优质代理商，具备基础市场判断能力，但无系统性的行业信息分析与建议输出记录。\n4. **商务沟通能力：4/5分。依据：仪仗队/警卫连出身，形象气质佳；完成终端成交110万+，具备B端与C端沟通经验；为老首长服务体现礼仪与耐心。\n5. **软件操作能力：3/5分。依据：负责数据统计、分析与归档，具备数据化运营意识，提及\"使用office软件\"但未明确具体熟练程度。",
    "created": ""
  },
  {
    "id": 126,
    "name": "张聪颖",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "软件技术专业背景",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "张",
    "dept": "养老及商业事业部",
    "city": "郑州",
    "age": "无",
    "gender": "未提及",
    "strengths": "5年销售经验，具备陌拜开发、客户接待、需求匹配及市场分析能力；慕思销售经历体现高端客户沟通经验；有巡场督导、培训帮扶及活动方案制定经验，与招商活动执行、劳动者带教场景有迁移性。",
    "risks": "无家政/劳动者招募行业经验，客户群体从\"消费者\"转向\"劳动者\"需适应；简历中未体现电话销售、企业微信运营等数字化工具使用；期望薪资7-9K与JD标注7-12K存在差距，需确认接受度；工作经历时间线存在异常（2024.06-2026.03）",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 存疑\n\n优势分析:\n5年销售经验，具备陌拜开发、客户接待、需求匹配及市场分析能力；慕思销售经历体现高端客户沟通经验；有巡场督导、培训帮扶及活动方案制定经验，与招商活动执行、劳动者带教场景有迁移性。\n\n风险点:\n无家政/劳动者招募行业经验，客户群体从\"消费者\"转向\"劳动者\"需适应；简历中未体现电话销售、企业微信运营等数字化工具使用；期望薪资7-9K与JD标注7-12K存在差距，需确认接受度；工作经历时间线存在异常（2024.06-2026.03）\n\n能力维度匹配:\n1. **客户开发能力：3/5分。依据：有线下陌拜、客户开发经验，但无电话/企业微信跟进、劳动者签约等B端招募场景的直接经历，客户对象差异大。**\n2. **活动执行能力：3/5分。依据：有制定活动方案、巡场督导、产品培训经验，但未明确参与招商类活动，活动性质偏向C端促销而非B端招募。**\n3. **市场分析能力：4/5分。依据：明确提及\"每月提交市场分析报告\"，跟踪竞品价格、促销活动、客户反馈，与JD要求高度匹配。**\n4. **商务沟通能力：4/5分。依据：5年销售背景，擅长客户接待、需求挖掘、产品讲解、消除顾虑；慕思高端家具销售体现商务礼仪意识。**\n5. **软件操作能力：2/5分。依据：软件技术专业背景，但未在工作经历中体现Office实际应用，缺乏文档处理的具体描述。**\n\n面试问题:\n1. 请描述一次你通过陌拜成功开发最难客户的经历，当时遇到了什么阻力，如何突破的？\n2. 慕思客户与家政劳动者群体差异较大，你如何看待从\"卖产品给消费者\"转向\"招募服务者加入平台\"的角色转变？\n3. 你的工作经历中2024.06-2026.03时间段是否有误？近两年",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 请描述一次你通过陌拜成功开发最难客户的经历，当时遇到了什么阻力，如何突破的？\n2. 慕思客户与家政劳动者群体差异较大，你如何看待从\"卖产品给消费者\"转向\"招募服务者加入平台\"的角色转变？\n3. 你的工作经历中2024.06-2026.03时间段是否有误？近两年是否有职业空窗期，原因是什么？\n4. 假设一位意向家政阿姨对平台抽成比例有顾虑，请现场模拟电话沟通，展示如何邀约她来公司考查。\n5. 请举例说明你过去如何用Excel或PPT完成销售数据分析或方案汇报，具体做了什么内容？",
    "capabilityMatch": "1. **客户开发能力：3/5分。依据：有线下陌拜、客户开发经验，但无电话/企业微信跟进、劳动者签约等B端招募场景的直接经历，客户对象差异大。**\n2. **活动执行能力：3/5分。依据：有制定活动方案、巡场督导、产品培训经验，但未明确参与招商类活动，活动性质偏向C端促销而非B端招募。**\n3. **市场分析能力：4/5分。依据：明确提及\"每月提交市场分析报告\"，跟踪竞品价格、促销活动、客户反馈，与JD要求高度匹配。**\n4. **商务沟通能力：4/5分。依据：5年销售背景，擅长客户接待、需求挖掘、产品讲解、消除顾虑；慕思高端家具销售体现商务礼仪意识。**\n5. **软件操作能力：2/5分。依据：软件技术专业背景，但未在工作经历中体现Office实际应用，缺乏文档处理的具体描述。**",
    "created": ""
  },
  {
    "id": 127,
    "name": "柴嘉",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "柴",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "无",
    "gender": "无",
    "strengths": "具备京东市场调研经验，熟悉数据采集、用户访谈及报告撰写，有一定数据思维；平安银行实习经历体现基础客户信息处理与流程跟进能力；Office工具熟练，可支撑文档处理需求。",
    "risks": "意向岗位为文员/婚礼策划/室内设计，与家政招商/劳动者招募方向偏差显著；无电销、地推或家政行业经验；3段实习均为辅助执行角色，独立签约转化、商务谈判等核心销售行为证据不足；稳定性存疑（实习时间跨度短，最长1年）。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 淘汰\n\n优势分析:\n具备京东市场调研经验，熟悉数据采集、用户访谈及报告撰写，有一定数据思维；平安银行实习经历体现基础客户信息处理与流程跟进能力；Office工具熟练，可支撑文档处理需求。\n\n风险点:\n意向岗位为文员/婚礼策划/室内设计，与家政招商/劳动者招募方向偏差显著；无电销、地推或家政行业经验；3段实习均为辅助执行角色，独立签约转化、商务谈判等核心销售行为证据不足；稳定性存疑（实习时间跨度短，最长1年）。\n\n能力维度匹配:\n1. **客户开发能力：1/5分。依据：简历无电话销售、客户邀约、签约转化等直接经验；京东工作为调研支持，平安银行为行政辅助，均未涉及销售闭环。**\n2. **活动执行能力：2/5分。依据：有课程项目、调研项目执行经验，但无招商活动、线下地推活动直接经历；活动类型与家政招商场景差异大。**\n3. **市场分析能力：3/5分。依据：京东市场调研经历匹配度最高，完成数据采集、趋势研判、报告撰写，有数据交叉分析与建议输出经验。**\n4. **商务沟通能力：2/5分。依据：有用户访谈、客户信息校验、跨部门协调经验，但缺乏面向劳动者群体的商务谈判、签约沟通等直接证据；商务礼仪未体现。**\n5. **软件操作能力：4/5分。依据：明确掌握Office全系列，可独立完成文档排版、数据统计、报表制作；有PS设计软件技能，但岗位需求度低。**\n\n面试问题:\n1. 请描述一次你需要在短时间内说服他人接受你观点的经历，当时你采取了哪些具体策略，结果如何？\n2. 京东调研工作中，你如何处理用户访谈中遇到的拒绝或配合度低的情况？请举例说明。\n3. 你的实习经历跨度较大（市场调研、银行行政、产品运营），如果加入天鹅到家后需",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 请描述一次你需要在短时间内说服他人接受你观点的经历，当时你采取了哪些具体策略，结果如何？\n2. 京东调研工作中，你如何处理用户访谈中遇到的拒绝或配合度低的情况？请举例说明。\n3. 你的实习经历跨度较大（市场调研、银行行政、产品运营），如果加入天鹅到家后需要长期深耕一线地推和电话销售，你如何规划自己的职业发展？\n4. 假设你需要在3天内为一个新开拓的社区招募20名保洁劳动者，请简述你的执行计划和关键动作。\n5. 家政行业劳动者流动性高、信任建立难，你认为在电话邀约和现场考查环节，最关键的三个沟通要点是什么？",
    "capabilityMatch": "1. **客户开发能力：1/5分。依据：简历无电话销售、客户邀约、签约转化等直接经验；京东工作为调研支持，平安银行为行政辅助，均未涉及销售闭环。**\n2. **活动执行能力：2/5分。依据：有课程项目、调研项目执行经验，但无招商活动、线下地推活动直接经历；活动类型与家政招商场景差异大。**\n3. **市场分析能力：3/5分。依据：京东市场调研经历匹配度最高，完成数据采集、趋势研判、报告撰写，有数据交叉分析与建议输出经验。**\n4. **商务沟通能力：2/5分。依据：有用户访谈、客户信息校验、跨部门协调经验，但缺乏面向劳动者群体的商务谈判、签约沟通等直接证据；商务礼仪未体现。**\n5. **软件操作能力：4/5分。依据：明确掌握Office全系列，可独立完成文档排版、数据统计、报表制作；有PS设计软件技能，但岗位需求度低。**",
    "created": ""
  },
  {
    "id": 128,
    "name": "凡慢",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "凡",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "无",
    "gender": "无",
    "strengths": "7年运营经验，5年母婴互联网背景，擅长用户深度运营与活动策划，具备电话外呼、客户接待、邀约转化全流程经验；有电销+线下活动执行+数据分析复合能力，与家政劳动者招募场景有一定迁移性。",
    "risks": "求职意向为\"电商运营/客服专员\"，与招商专员（地招）岗位方向偏差明显；近10年工作均为运营/设计/客服，无家政行业或劳动者招募经验；最近岗位为保险电话客服，职业路径呈下行趋势，稳定性与动机存疑。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 存疑\n\n优势分析:\n7年运营经验，5年母婴互联网背景，擅长用户深度运营与活动策划，具备电话外呼、客户接待、邀约转化全流程经验；有电销+线下活动执行+数据分析复合能力，与家政劳动者招募场景有一定迁移性。\n\n风险点:\n求职意向为\"电商运营/客服专员\"，与招商专员（地招）岗位方向偏差明显；近10年工作均为运营/设计/客服，无家政行业或劳动者招募经验；最近岗位为保险电话客服，职业路径呈下行趋势，稳定性与动机存疑。\n\n能力维度匹配:\n1. **客户开发能力：3/5分。依据：泰康人寿有电话外呼、邀约客户参与线下活动、接待到访客户经验，但对象为保险老客户而非劳动者招募，无企业微信跟进、签约谈判等关键行为证据。\n2. **活动执行能力：4/5分。依据：婚博会期间负责线上线下展会运营规划，泰康人寿协助组织手工、旅游、社区活动，活动全流程参与经验丰富。\n3. **市场分析能力：3/5分。依据：婚博会期间通过数据分析调整内容架构，有用户特点挖掘经验，但无行业市场信息分析并提出策略建议的直接证据。\n4. **商务沟通能力：3/5分。依据：多岗位涉及客户沟通、用户运营，强调\"服务好用户\"\"注重用户体验\"，但无商务礼仪专项体现，劳动者群体沟通经验空白。\n5. **软件操作能力：4/5分。依据：明确熟练使用Office、Photoshop、Dreamweaver，有平面设计及网页制作经验，文档处理无问题。\n\n面试问题:\n1. 你目前求职方向是电商运营，但我们的岗位是线下劳动者招募，请具体说明你选择投递本岗位的原因，以及如何看待职业方向的调整？\n2. 在泰康人寿电话邀约客户参加活动时，遇到过客户明确拒绝或态度恶劣的情况吗？当时如何处理，最终是否成功转",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 你目前求职方向是电商运营，但我们的岗位是线下劳动者招募，请具体说明你选择投递本岗位的原因，以及如何看待职业方向的调整？\n2. 在泰康人寿电话邀约客户参加活动时，遇到过客户明确拒绝或态度恶劣的情况吗？当时如何处理，最终是否成功转化？\n3. 你的工作经历跨度较大（母婴电商→婚博会→保险客服），请分享一次因行业转换导致需要快速学习新领域知识的经历，如何确保自己快速上手并达成目标？\n4. 家政劳动者招募中，常见痛点是劳动者对平台不信任或担心收入不稳定，结合你过往电话销售经验，你会如何设计话术打消这类顾虑？\n5. 假设你需要在一周内完成20个劳动者的签约目标，但目前线索池仅有30个意向号码，且回访后表示\"再考虑\"的占60%，你会如何拆解目标并推进执行？",
    "capabilityMatch": "1. **客户开发能力：3/5分。依据：泰康人寿有电话外呼、邀约客户参与线下活动、接待到访客户经验，但对象为保险老客户而非劳动者招募，无企业微信跟进、签约谈判等关键行为证据。\n2. **活动执行能力：4/5分。依据：婚博会期间负责线上线下展会运营规划，泰康人寿协助组织手工、旅游、社区活动，活动全流程参与经验丰富。\n3. **市场分析能力：3/5分。依据：婚博会期间通过数据分析调整内容架构，有用户特点挖掘经验，但无行业市场信息分析并提出策略建议的直接证据。\n4. **商务沟通能力：3/5分。依据：多岗位涉及客户沟通、用户运营，强调\"服务好用户\"\"注重用户体验\"，但无商务礼仪专项体现，劳动者群体沟通经验空白。\n5. **软件操作能力：4/5分。依据：明确熟练使用Office、Photoshop、Dreamweaver，有平面设计及网页制作经验，文档处理无问题。",
    "created": ""
  },
  {
    "id": 129,
    "name": "李女士",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "2026年应届生",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "李",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "无",
    "gender": "女",
    "strengths": "具备强电话销售与微信运营经验，日均60分钟有效通话、200+触达、15+微信新增，与劳动者招募的高频触达模式高度契合；猎头背景培养的目标导向与结果量化意识，适配家政招商的数字化管理要求；性格热情开朗，擅长主动沟通，符合地推场景需求。",
    "risks": "零家政/蓝领行业经验，劳动者群体（阿姨、保洁等）与互联网算法候选人的沟通场景差异大，需验证下沉市场适应能力；2026年应届生身份，稳定性存疑，地招岗位需长期深耕区域，与猎头/HR实习的短期项目制节奏不同；无招商活动执行与市场分析的直接案例。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 通过\n\n优势分析:\n具备强电话销售与微信运营经验，日均60分钟有效通话、200+触达、15+微信新增，与劳动者招募的高频触达模式高度契合；猎头背景培养的目标导向与结果量化意识，适配家政招商的数字化管理要求；性格热情开朗，擅长主动沟通，符合地推场景需求。\n\n风险点:\n零家政/蓝领行业经验，劳动者群体（阿姨、保洁等）与互联网算法候选人的沟通场景差异大，需验证下沉市场适应能力；2026年应届生身份，稳定性存疑，地招岗位需长期深耕区域，与猎头/HR实习的短期项目制节奏不同；无招商活动执行与市场分析的直接案例。\n\n能力维度匹配:\n1. **客户开发能力：4/5分。依据：猎头实习日均60分钟通话+15微信新增，HR实习日均200触达+30电话+4-5份简历推送，电销强度与多线程跟进能力已验证，但缺乏蓝领群体触达经验。\n2. **活动执行能力：2/5分。依据：简历无招商/活动执行直接经历，仅有人力资源调研项目经验，未体现线下活动统筹或现场执行能力。\n3. **市场分析能力：2/5分。依据：人力资源调研项目涉及数据整理与问卷设计，但聚焦招聘渠道效率分析，非行业市场信息收集与策略建议，与JD要求的区域市场洞察有差距。\n4. **商务沟通能力：3/5分。依据：实习经历体现多层级沟通（候选人-客户-业务部门），性格描述\"热情开朗、擅长主动沟通\"，但缺乏商务礼仪场景验证及劳动者群体沟通案例。\n5. **软件操作能力：3/5分。依据：明确提及\"熟练运用办公软件\"，有用友U8财务软件实操经验，但未具体说明Excel数据处理或PPT汇报能力深度。\n\n面试问题:\n1. 请描述一次你持续跟进但最终未能签约的候选人经历，你如何判断放弃时机？这与家政阿姨招",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 请描述一次你持续跟进但最终未能签约的候选人经历，你如何判断放弃时机？这与家政阿姨招募中\"反复跟进、长期培育\"的要求如何平衡？\n2. 你在猎头工作中对接的是高学历算法人才，若转换为学历较低、手机操作不熟练的保洁阿姨群体，你会如何调整沟通方式与信任建立策略？\n3. 你的实习经历集中在2025-2026年，选择应届生身份投递地招岗位而非校招管培，是出于短期过渡还是长期职业规划？请说明未来2-3年对区域深耕的意愿。\n4. 假设你负责北京朝阳区劳动者招募，请现场设计一套\"电话邀约-微信运营-到店面试\"的7天跟进SOP，并说明关键转化节点的话术设计。\n5. 家政行业存在阿姨\"试单后流失\"\"虚假简历\"等问题，结合你过往背景核实经验，请提出2-3个针对蓝领劳动者的风控识别方法。",
    "capabilityMatch": "1. **客户开发能力：4/5分。依据：猎头实习日均60分钟通话+15微信新增，HR实习日均200触达+30电话+4-5份简历推送，电销强度与多线程跟进能力已验证，但缺乏蓝领群体触达经验。\n2. **活动执行能力：2/5分。依据：简历无招商/活动执行直接经历，仅有人力资源调研项目经验，未体现线下活动统筹或现场执行能力。\n3. **市场分析能力：2/5分。依据：人力资源调研项目涉及数据整理与问卷设计，但聚焦招聘渠道效率分析，非行业市场信息收集与策略建议，与JD要求的区域市场洞察有差距。\n4. **商务沟通能力：3/5分。依据：实习经历体现多层级沟通（候选人-客户-业务部门），性格描述\"热情开朗、擅长主动沟通\"，但缺乏商务礼仪场景验证及劳动者群体沟通案例。\n5. **软件操作能力：3/5分。依据：明确提及\"熟练运用办公软件\"，有用友U8财务软件实操经验，但未具体说明Excel数据处理或PPT汇报能力深度。",
    "created": ""
  },
  {
    "id": 130,
    "name": "李先生",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "成人教育",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "李",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "无",
    "gender": "男",
    "strengths": "13年电销及团队管理经验，核心优势在于大规模电话客户开发与转化（日均200+通），擅长SOP搭建与话术优化；客诉处理经验丰富，能有效化解劳动者签约顾虑；成人教育背景与家政劳动者招募场景高度契合，均面向蓝领/在职人群的职业发展痛点。",
    "risks": "近3年均为管理岗（30人/12人团队），需确认是否接受一线地推+电话执行的专员角色；无家政/本地生活行业经验，劳动者群体（阿姨、保洁等）与成人教育学员决策逻辑差异大；履历中无企业微信运营、线下接待签约等O2O闭环经验。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 通过\n\n优势分析:\n13年电销及团队管理经验，核心优势在于大规模电话客户开发与转化（日均200+通），擅长SOP搭建与话术优化；客诉处理经验丰富，能有效化解劳动者签约顾虑；成人教育背景与家政劳动者招募场景高度契合，均面向蓝领/在职人群的职业发展痛点。\n\n风险点:\n近3年均为管理岗（30人/12人团队），需确认是否接受一线地推+电话执行的专员角色；无家政/本地生活行业经验，劳动者群体（阿姨、保洁等）与成人教育学员决策逻辑差异大；履历中无企业微信运营、线下接待签约等O2O闭环经验。\n\n能力维度匹配:\n1. **客户开发能力：4/5分。依据：13年电销经验，日均200+通电话，擅长客户分级、需求挖掘与签约转化；但简历未体现企业微信运营及线下劳动者接待场景，需验证O2O闭环能力。**\n2. **活动执行能力：2/5分。依据：无直接招商/地推活动执行经验，仅有\"参与话术优化项目\"等间接经历；管理岗背景可能缺乏一线活动落地体感。**\n3. **市场分析能力：3/5分。依据：有\"分析行业动态及竞品销售模式\"\"调整销售话术与优惠政策\"经历，但聚焦销售策略而非区域市场开拓建议，家政行业认知待验证。**\n4. **商务沟通能力：4/5分。依据：\"出色的电话沟通能力，快速建立信任\"\"深度沟通挖掘核心诉求\"\"客诉复盘推动跨部门协作\"等证据充分；但商务礼仪、线下劳动者沟通场景未体现。**\n5. **软件操作能力：3/5分。依据：计算机应用技术专业背景，客诉主管经历涉及\"系统功能迭代\"，但未明确提及Office文档处理的具体场景。**\n\n面试问题:\n1. 您曾统筹30人电销团队，若现在转型为独立负责某区域劳动者招募，需同时对接总部运营、本地家政阿",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 您曾统筹30人电销团队，若现在转型为独立负责某区域劳动者招募，需同时对接总部运营、本地家政阿姨、合作物业等多方，您会如何调整沟通策略？请举例说明过往跨部门协作中化解冲突的经历。\n2. 客诉处理中您提到\"联合招生部门提供个性化解决方案\"，请描述一次劳动者/客户因费用或服务标准问题激烈投诉的案例，您如何平衡公司政策与客户诉求达成双赢？\n3. 您近两份工作均为3年左右，且从管理岗（销售经理/客诉主管）转向一线专员岗位，职业规划上如何考虑？若入职后6个月内业绩压力较大，您的应对方式是什么？\n4. 家政劳动者招募与成人教育学员转化有何核心差异？您认为阿姨群体（年龄偏大、流动性高、决策依赖口碑）的电话邀约和线下签约，最关键的三个破冰技巧是什么？\n5. 假设您负责北京朝阳区高端家政劳动者招募，请现场设计一个\"企业微信+线下体验\"的邀约话术框架，并说明如何筛选高意向劳动者、如何设计到店考查的动线以提升签约率。",
    "capabilityMatch": "1. **客户开发能力：4/5分。依据：13年电销经验，日均200+通电话，擅长客户分级、需求挖掘与签约转化；但简历未体现企业微信运营及线下劳动者接待场景，需验证O2O闭环能力。**\n2. **活动执行能力：2/5分。依据：无直接招商/地推活动执行经验，仅有\"参与话术优化项目\"等间接经历；管理岗背景可能缺乏一线活动落地体感。**\n3. **市场分析能力：3/5分。依据：有\"分析行业动态及竞品销售模式\"\"调整销售话术与优惠政策\"经历，但聚焦销售策略而非区域市场开拓建议，家政行业认知待验证。**\n4. **商务沟通能力：4/5分。依据：\"出色的电话沟通能力，快速建立信任\"\"深度沟通挖掘核心诉求\"\"客诉复盘推动跨部门协作\"等证据充分；但商务礼仪、线下劳动者沟通场景未体现。**\n5. **软件操作能力：3/5分。依据：计算机应用技术专业背景，客诉主管经历涉及\"系统功能迭代\"，但未明确提及Office文档处理的具体场景。**",
    "created": ""
  },
  {
    "id": 131,
    "name": "刘女士",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "刘",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "25岁",
    "gender": "女",
    "strengths": "3年一线招聘实战经验，擅长批量蓝领招募与渠道运营（BOSS/58/抖音/劳务/社群），日均70%工作量投入电话邀约与面试跟进，与天鹅到家劳动者地招场景高度契合；具备HRBP视角，熟悉从招募到留存的全流程管控及数据报表产出。",
    "risks": "行业跨度大（餐饮→家政），需验证对家政服务标准化、职业化认知；无明确招商/活动执行经验；前两家公司任职均约1年，稳定性存疑；25岁年轻，商务礼仪与劳动者信任建立需考察。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 通过\n\n优势分析:\n3年一线招聘实战经验，擅长批量蓝领招募与渠道运营（BOSS/58/抖音/劳务/社群），日均70%工作量投入电话邀约与面试跟进，与天鹅到家劳动者地招场景高度契合；具备HRBP视角，熟悉从招募到留存的全流程管控及数据报表产出。\n\n风险点:\n行业跨度大（餐饮→家政），需验证对家政服务标准化、职业化认知；无明确招商/活动执行经验；前两家公司任职均约1年，稳定性存疑；25岁年轻，商务礼仪与劳动者信任建立需考察。\n\n能力维度匹配:\n1. **客户开发能力：4/5分。依据：简历明确\"电话邀约占每日70%工作量\"\"对接门店确认缺口、拆解月度指标\"\"沉淀餐饮求职者资源\"，具备成熟的意向跟进、邀约、签约全流程经验，仅行业差异扣1分。**\n2. **活动执行能力：2/5分。依据：简历未提及任何招商活动、线下地推、展会等执行经历，仅有\"渠道运营\"线上经验，能力缺口明显。**\n3. **市场分析能力：3/5分。依据：有\"产出数据报表\"\"对接本地中介、职校补充淡季人力\"等基础信息整合行为，但无明确行业分析、区域市场建议的文本证据。**\n4. **商务沟通能力：3/5分。依据：有\"面试统筹\"\"矛盾调解\"\"离职面谈\"\"跨部门协同\"等多场景沟通经验，但商务礼仪、劳动者群体（尤其家政阿姨）沟通特殊性无直接证明。**\n5. **软件操作能力：3/5分。依据：多次提及\"数据报表产出\"，但未明确Office具体技能层级，按基础办公能力评估。**\n\n面试问题:\n1. \"请描述一次你通过电话/微信跟进最终成功签约劳动者的完整案例：对方最初的顾虑是什么？你采取了哪些具体策略建立信任？\"\n2. \"在海底捞招聘期间，你如何管理月度招聘指标压力？当连续",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. \"请描述一次你通过电话/微信跟进最终成功签约劳动者的完整案例：对方最初的顾虑是什么？你采取了哪些具体策略建立信任？\"\n2. \"在海底捞招聘期间，你如何管理月度招聘指标压力？当连续两周未达标时，你会如何调整策略并向上反馈？\"\n3. \"你上一份工作仅持续1年，离开的主要原因是什么？选择天鹅到家招商岗位，你期望获得什么样的职业发展？\"\n4. \"家政劳动者群体以40-50岁女性为主，与餐饮年轻从业者差异较大。你会如何设计话术或跟进节奏，提升这类群体的到面率和签约转化率？\"\n5. \"假设你负责北京朝阳区保洁师招募，目前渠道ROI下降，请简述你会从哪些维度分析原因，并给出3个可落地的优化建议。\"",
    "capabilityMatch": "1. **客户开发能力：4/5分。依据：简历明确\"电话邀约占每日70%工作量\"\"对接门店确认缺口、拆解月度指标\"\"沉淀餐饮求职者资源\"，具备成熟的意向跟进、邀约、签约全流程经验，仅行业差异扣1分。**\n2. **活动执行能力：2/5分。依据：简历未提及任何招商活动、线下地推、展会等执行经历，仅有\"渠道运营\"线上经验，能力缺口明显。**\n3. **市场分析能力：3/5分。依据：有\"产出数据报表\"\"对接本地中介、职校补充淡季人力\"等基础信息整合行为，但无明确行业分析、区域市场建议的文本证据。**\n4. **商务沟通能力：3/5分。依据：有\"面试统筹\"\"矛盾调解\"\"离职面谈\"\"跨部门协同\"等多场景沟通经验，但商务礼仪、劳动者群体（尤其家政阿姨）沟通特殊性无直接证明。**\n5. **软件操作能力：3/5分。依据：多次提及\"数据报表产出\"，但未明确Office具体技能层级，按基础办公能力评估。**",
    "created": ""
  },
  {
    "id": 132,
    "name": "卢奕妃",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "26届应届生",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "卢",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "45岁",
    "gender": "女",
    "strengths": "1年互联网招聘经验，擅长电话邀约、候选人跟进与签约转化（累计沟通10000+，入职50+），具备\"地推+电销\"复合能力；擅长数据统计与可视化，契合家政数字化运营需求；有区域化招聘经验（华中、华北门店），理解下沉市场劳动者招募逻辑。",
    "risks": "零家政/招商行业经验，需验证对蓝领劳动者群体的沟通适配性；26届应届生身份，稳定性存疑（当前实习预计2025.12结束）；期望薪资8-12K高于地招岗位预算，需确认薪酬弹性。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 通过\n\n优势分析:\n1年互联网招聘经验，擅长电话邀约、候选人跟进与签约转化（累计沟通10000+，入职50+），具备\"地推+电销\"复合能力；擅长数据统计与可视化，契合家政数字化运营需求；有区域化招聘经验（华中、华北门店），理解下沉市场劳动者招募逻辑。\n\n风险点:\n零家政/招商行业经验，需验证对蓝领劳动者群体的沟通适配性；26届应届生身份，稳定性存疑（当前实习预计2025.12结束）；期望薪资8-12K高于地招岗位预算，需确认薪酬弹性。\n\n能力维度匹配:\n1. **客户开发能力：4/5分。依据：高德期间每周推荐50+简历，独立完成邀约-初试-复试-入职全流程；新氧阶段主导区域门店规模化招聘，具备\"电话+现场\"双触点开发经验，但未验证企业微信工具使用。**\n2. **活动执行能力：3/5分。依据：主导策划5场校园志愿活动（300+人参与），有活动统筹经验；但缺乏商业招商类活动执行背景，家政行业活动场景差异大。**\n3. **市场分析能力：2/5分。依据：制作招聘周报、优化人才画像，具备基础数据分析能力；但无行业市场分析或区域竞品调研的直接经验，建议项未体现。**\n4. **商务沟通能力：4/5分。依据：简历自述\"优秀亲和力与沟通表达\"，跨部门协同业务团队响应需求；1年HR岗位沉淀出候选人谈判与关系维护技巧，商务礼仪需现场观察。**\n5. **软件操作能力：4/5分。依据：明确标注\"熟练使用office软件\"，擅长文档表格撰写；有飞书、Moka等数字化工具经验，契合家政SaaS化作业场景。**\n\n面试问题:\n1. \"请描述一次你成功说服一位犹豫候选人接受offer的经历，当时他的顾虑是什么？你具体如何应对？\"\n2. \"在高德",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. \"请描述一次你成功说服一位犹豫候选人接受offer的经历，当时他的顾虑是什么？你具体如何应对？\"\n2. \"在高德或新氧期间，有没有遇到过招聘需求突然翻倍的情况？你如何协调资源保证交付？\"\n3. \"你目前的实习预计12月结束，选择天鹅到家地招岗位而非转正互联网HR，核心考量是什么？未来2-3年职业规划如何？\"\n4. \"假设你需要在朝阳区招募20名保洁劳动者，但BOSS直聘响应率低，你会设计哪些线下渠道组合策略？\"\n5. \"请现场模拟：一位45岁农村大姐想来做保洁但担心'没经验、客户不满意'，你如何用3句话建立信任并邀约到店？\"",
    "capabilityMatch": "1. **客户开发能力：4/5分。依据：高德期间每周推荐50+简历，独立完成邀约-初试-复试-入职全流程；新氧阶段主导区域门店规模化招聘，具备\"电话+现场\"双触点开发经验，但未验证企业微信工具使用。**\n2. **活动执行能力：3/5分。依据：主导策划5场校园志愿活动（300+人参与），有活动统筹经验；但缺乏商业招商类活动执行背景，家政行业活动场景差异大。**\n3. **市场分析能力：2/5分。依据：制作招聘周报、优化人才画像，具备基础数据分析能力；但无行业市场分析或区域竞品调研的直接经验，建议项未体现。**\n4. **商务沟通能力：4/5分。依据：简历自述\"优秀亲和力与沟通表达\"，跨部门协同业务团队响应需求；1年HR岗位沉淀出候选人谈判与关系维护技巧，商务礼仪需现场观察。**\n5. **软件操作能力：4/5分。依据：明确标注\"熟练使用office软件\"，擅长文档表格撰写；有飞书、Moka等数字化工具经验，契合家政SaaS化作业场景。**",
    "created": ""
  },
  {
    "id": 133,
    "name": "万女士",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "成人教育大专",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "万",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "无",
    "gender": "女",
    "strengths": "9年招聘经验，擅长蓝领/基层岗位批量招募（美团分拣员/理货员等），日均邀约7-10人、月完成HC满编，电销+地推双经验匹配家政劳动者招募场景；有线下推广项目统筹经验，熟悉O2O平台运营逻辑。",
    "risks": "无家政/母婴行业背景，需跨行业迁移；简历显示2024年8月离职后空窗期未说明；连续两段工作均不足2年（2018-2019、2021-2024），稳定性待验证；学历为成人教育大专。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 通过\n\n优势分析:\n9年招聘经验，擅长蓝领/基层岗位批量招募（美团分拣员/理货员等），日均邀约7-10人、月完成HC满编，电销+地推双经验匹配家政劳动者招募场景；有线下推广项目统筹经验，熟悉O2O平台运营逻辑。\n\n风险点:\n无家政/母婴行业背景，需跨行业迁移；简历显示2024年8月离职后空窗期未说明；连续两段工作均不足2年（2018-2019、2021-2024），稳定性待验证；学历为成人教育大专。\n\n能力维度匹配:\n1. **客户开发能力：4/5分。依据：美团期间日均电话沟通500+候选人、邀约7-10人，月完成200+人招募，具备高强度电销及批量转化经验，与劳动者电话跟进、邀约签约场景高度匹配。**\n2. **活动执行能力：3/5分。依据：主导小象超市APP线下推广项目，负责文案、海报、场地搭建及BD配合，实现销量0-1突破；但属单次项目经验，缺乏常态化招商活动执行记录。**\n3. **市场分析能力：2/5分。依据：简历未体现行业信息分析或区域市场建议相关行为，招聘优化中仅提及\"与业务沟通调整方向\"，无主动市场洞察输出。**\n4. **商务沟通能力：4/5分。依据：对接100+门店负责人及5+业务leader，定期沟通需求并调整策略；疫情期间协调异地候选人住宿、防疫证明等复杂事项，展现多方协调能力。**\n5. **软件操作能力：3/5分。依据：负责宣传文案、海报设计，暗示基础办公软件使用；但无Excel数据分析或PPT汇报等具体技能描述，无法判断熟练程度。**\n\n面试问题:\n1. 请描述一次您与业务leader就招聘需求产生分歧的经历，您如何沟通并达成共识？\n2. 美团期间面对高流失率的基层岗位，您采取了哪些措施提",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 请描述一次您与业务leader就招聘需求产生分歧的经历，您如何沟通并达成共识？\n2. 美团期间面对高流失率的基层岗位，您采取了哪些措施提升候选人到场率和入职稳定性？\n3. 2024年8月离职至今的职业规划是什么？如何看待家政行业与互联网招聘的差异？\n4. 若负责北京朝阳区保洁阿姨招募，您会如何设计7天内完成50人入职的落地计划？\n5. 劳动者到店咨询后犹豫签约，常见顾虑有哪些？您会如何针对性沟通促单？",
    "capabilityMatch": "1. **客户开发能力：4/5分。依据：美团期间日均电话沟通500+候选人、邀约7-10人，月完成200+人招募，具备高强度电销及批量转化经验，与劳动者电话跟进、邀约签约场景高度匹配。**\n2. **活动执行能力：3/5分。依据：主导小象超市APP线下推广项目，负责文案、海报、场地搭建及BD配合，实现销量0-1突破；但属单次项目经验，缺乏常态化招商活动执行记录。**\n3. **市场分析能力：2/5分。依据：简历未体现行业信息分析或区域市场建议相关行为，招聘优化中仅提及\"与业务沟通调整方向\"，无主动市场洞察输出。**\n4. **商务沟通能力：4/5分。依据：对接100+门店负责人及5+业务leader，定期沟通需求并调整策略；疫情期间协调异地候选人住宿、防疫证明等复杂事项，展现多方协调能力。**\n5. **软件操作能力：3/5分。依据：负责宣传文案、海报设计，暗示基础办公软件使用；但无Excel数据分析或PPT汇报等具体技能描述，无法判断熟练程度。**",
    "created": ""
  },
  {
    "id": 134,
    "name": "王彬",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "本科（非统招）",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "王",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "无",
    "gender": "无",
    "strengths": "14年工作经验，具备多行业客户接待与沟通经验（汽车销售、物业客服）；有数据追踪与门店巡检经历，对标准化服务流程有一定认知；性格描述强调倾听、沟通与坚持，与地招岗位一线开发属性部分契合。",
    "risks": "求职意向为\"录入员\"（6-7K），与招商专员（7-12K）薪资期望及岗位性质错位；无市场营销、家政行业经验，缺乏电销/招商活动执行经历；近三段工作跨度大（商贸、防水、投资），稳定性存疑；学历为本科但院校非统招，需核实。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 淘汰\n\n优势分析:\n14年工作经验，具备多行业客户接待与沟通经验（汽车销售、物业客服）；有数据追踪与门店巡检经历，对标准化服务流程有一定认知；性格描述强调倾听、沟通与坚持，与地招岗位一线开发属性部分契合。\n\n风险点:\n求职意向为\"录入员\"（6-7K），与招商专员（7-12K）薪资期望及岗位性质错位；无市场营销、家政行业经验，缺乏电销/招商活动执行经历；近三段工作跨度大（商贸、防水、投资），稳定性存疑；学历为本科但院校非统招，需核实。\n\n能力维度匹配:\n1. **客户开发能力：1/5分。依据：无电话销售、客户跟进签约经验；仅有汽车销售中被动接待客户经历，与主动开发劳动者差距大。\n2. **活动执行能力：1/5分。依据：无招商活动、地推活动执行经历；仅提及新店开业申报与验收，属行政支持而非活动策划执行。\n3. **市场分析能力：2/5分。依据：有商业数据分析经历（地产建筑信息采集），但仅为信息查找与分配，未体现分析建议输出能力。\n4. **商务沟通能力：3/5分。依据：多岗位涉及客户接待（汽车销售、物业客服），具备基础沟通经验；但缺乏商务礼仪专项训练证据，劳动者群体沟通场景未验证。\n5. **软件操作能力：2/5分。依据：简历未明确提及Office技能，仅\"数据追踪\"可能涉及基础表格；求职意向\"录入员\"暗示打字/基础操作能力，但无具体软件应用描述。\n\n面试问题:\n1. 请描述一次你主动说服他人接受某个方案或产品的经历，当时对方有哪些顾虑，你是如何逐步化解的？\n2. 你过往工作中需要同时跟进多个客户需求时，如何安排优先级并确保不遗漏？请举例说明。\n3. 你的求职意向是录入员，但我们的岗位需要频繁外出拜访和电话开发，能否说明这",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 请描述一次你主动说服他人接受某个方案或产品的经历，当时对方有哪些顾虑，你是如何逐步化解的？\n2. 你过往工作中需要同时跟进多个客户需求时，如何安排优先级并确保不遗漏？请举例说明。\n3. 你的求职意向是录入员，但我们的岗位需要频繁外出拜访和电话开发，能否说明这一转变的原因及你的适应计划？\n4. 假设你需要在一周内招募10名家政劳动者，请简述你会如何规划每日工作动作（渠道选择、话术准备、跟进节奏）？\n5. 如果一位意向劳动者对\"缴纳服务费/培训费\"有强烈抵触，你会如何回应？请现场模拟一段沟通。",
    "capabilityMatch": "1. **客户开发能力：1/5分。依据：无电话销售、客户跟进签约经验；仅有汽车销售中被动接待客户经历，与主动开发劳动者差距大。\n2. **活动执行能力：1/5分。依据：无招商活动、地推活动执行经历；仅提及新店开业申报与验收，属行政支持而非活动策划执行。\n3. **市场分析能力：2/5分。依据：有商业数据分析经历（地产建筑信息采集），但仅为信息查找与分配，未体现分析建议输出能力。\n4. **商务沟通能力：3/5分。依据：多岗位涉及客户接待（汽车销售、物业客服），具备基础沟通经验；但缺乏商务礼仪专项训练证据，劳动者群体沟通场景未验证。\n5. **软件操作能力：2/5分。依据：简历未明确提及Office技能，仅\"数据追踪\"可能涉及基础表格；求职意向\"录入员\"暗示打字/基础操作能力，但无具体软件应用描述。",
    "created": ""
  },
  {
    "id": 135,
    "name": "于涌波",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "大专学历非统招",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "于",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "无",
    "gender": "无",
    "strengths": "10年+北京本地工作经验，熟悉区域市场；联东集团招商经历与岗位高度匹配，具备电话陌拜、客户接待、签约全流程经验；自我评价强调\"吃苦耐劳、突破自我\"，契合家政行业地推属性；有物业客服背景，理解基层劳动者服务场景。",
    "risks": "简历时间线存疑（2025年11月-2026年5月为未来时段），需核实真实在职状态；期望薪资9K处于JD范围7-12K的上限边缘，需确认薪酬弹性；无家政/母婴/保洁行业经验，行业认知空白；大专学历非统招，专业为计算机而非市场营销。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 通过\n\n优势分析:\n10年+北京本地工作经验，熟悉区域市场；联东集团招商经历与岗位高度匹配，具备电话陌拜、客户接待、签约全流程经验；自我评价强调\"吃苦耐劳、突破自我\"，契合家政行业地推属性；有物业客服背景，理解基层劳动者服务场景。\n\n风险点:\n简历时间线存疑（2025年11月-2026年5月为未来时段），需核实真实在职状态；期望薪资9K高于JD范围（7-12K上限边缘），需确认薪酬弹性；无家政/母婴/保洁行业经验，行业认知空白；大专学历非统招，专业为计算机而非市场营销。\n\n能力维度匹配:\n1. **客户开发能力：4/5分。依据：联东集团招商经理经历明确包含\"电话、陌拜、网络、老客户转介绍\"等多元渠道拓客，及\"接待-跟进-签约-入园\"全链路闭环，与JD中\"电话/企微跟进、邀约、接待、签约\"高度重合。\n2. **活动执行能力：3/5分。依据：简历提及\"参加商会协会活动\"，但未明确描述独立策划或执行招商活动的具体案例，活动参与度深度待验证。\n3. **市场分析能力：2/5分。依据：联东经历提到\"了解片区产业布局\"，但未呈现主动分析市场信息并提出建议的具体行为，该维度证据薄弱。\n4. **商务沟通能力：4/5分。依据：三段经历均涉及客户-facing场景（招商接待、物业投诉处理、珠宝顾问），自我评价强调\"沟通协调与谈判能力突出，善于精准洞察客户需求\"。\n5. **软件操作能力：3/5分。依据：明确表述\"熟悉Word、Excel、ppt等办公软件操作\"，但未提及具体应用场景或数据处理能力，基础水平可确认。\n\n面试问题:\n1. \"请描述一次你通过陌拜或电话成功开发最难缠客户的完整过程——具体做了什么打破僵局？\"\n2. \"SOHO物",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. \"请描述一次你通过陌拜或电话成功开发最难缠客户的完整过程——具体做了什么打破僵局？\"\n2. \"SOHO物业期间处理过最复杂的客户投诉是什么？最终如何闭环解决，客户反馈如何？\"\n3. \"简历显示2025年11月入职联东，但目前投递简历，能否说明真实离职原因及时间线？未来3年职业规划是否接受基层地推岗位？\"\n4. \"假设需要招募一批月嫂劳动者，你会如何设计一周的电话邀约话术框架？请现场模拟首通电话开场。\"\n5. \"家政劳动者普遍学历偏低、流动性高，你认为招商过程中最大的信任建立难点是什么？如何针对性解决？\"",
    "capabilityMatch": "1. **客户开发能力：4/5分。依据：联东集团招商经理经历明确包含\"电话、陌拜、网络、老客户转介绍\"等多元渠道拓客，及\"接待-跟进-签约-入园\"全链路闭环，与JD中\"电话/企微跟进、邀约、接待、签约\"高度重合。\n2. **活动执行能力：3/5分。依据：简历提及\"参加商会协会活动\"，但未明确描述独立策划或执行招商活动的具体案例，活动参与度深度待验证。\n3. **市场分析能力：2/5分。依据：联东经历提到\"了解片区产业布局\"，但未呈现主动分析市场信息并提出建议的具体行为，该维度证据薄弱。\n4. **商务沟通能力：4/5分。依据：三段经历均涉及客户-facing场景（招商接待、物业投诉处理、珠宝顾问），自我评价强调\"沟通协调与谈判能力突出，善于精准洞察客户需求\"。\n5. **软件操作能力：3/5分。依据：明确表述\"熟悉Word、Excel、ppt等办公软件操作\"，但未提及具体应用场景或数据处理能力，基础水平可确认。",
    "created": ""
  },
  {
    "id": 136,
    "name": "甄女士",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "甄",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "无",
    "gender": "女",
    "strengths": "4年HR全模块经验，擅长招聘全流程（寻源、面试、谈薪、offer）及员工关系管理，具备电话沟通、企业微信跟进、候选人接待签约等直接 transferable 技能；多次独立策划执行员工活动（圣诞、中秋、慈善等），活动执行能力扎实；有数据分析及报表输出经验，适应数字化管理。",
    "risks": "无家政/蓝领行业经验，需适应从白领招聘到劳动者招募的场景转换；近2年两段工作经历（荣耀11个月、曼秀雷敦预计14个月），稳定性存疑；目前在职且薪资13.4万/年，与岗位7-12K预算存在差距，需确认求职动机。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 通过\n\n优势分析:\n4年HR全模块经验，擅长招聘全流程（寻源、面试、谈薪、offer）及员工关系管理，具备电话沟通、企业微信跟进、候选人接待签约等直接 transferable 技能；多次独立策划执行员工活动（圣诞、中秋、慈善等），活动执行能力扎实；有数据分析及报表输出经验，适应数字化管理。\n\n风险点:\n无家政/蓝领行业经验，需适应从白领招聘到劳动者招募的场景转换；近2年两段工作经历（荣耀11个月、曼秀雷敦预计14个月），稳定性存疑；目前在职且薪资13.4万/年，与岗位7-12K预算存在差距，需确认求职动机。\n\n能力维度匹配:\n1. **客户开发能力：4/5分。依据：4年招聘经验，精通电话/微信跟进、候选人保温、谈薪签约全流程；驻场NEC期间独立完成社招全流程，批量校招25人，留存率96%，具备强意向客户转化能力。\n2. **活动执行能力：4/5分。依据：独立策划执行圣诞、中秋、端午、慈善等员工活动；组织市场走访、企业内购会、代言人促销会，活动统筹经验丰富。\n3. **市场分析能力：3/5分。依据：负责每月人力资源报表输出、销量达成率分析；有区域院校洞察经验，但缺乏家政行业市场分析直接证据。\n4. **商务沟通能力：4/5分。依据：4年HRBP/猎头经历，日常高频对接候选人、业务方、猎头公司；员工关系管理中擅长解答咨询、处理工伤等敏感事务，商务礼仪与沟通成熟度高。\n5. **软件操作能力：4/5分。依据：优化BI看板和单据审批流配置，熟练使用Office完成数据分析、报表输出、培训课件制作，数字化工具应用能力强。\n\n面试问题:\n1. 请描述一次你通过电话或微信持续跟进，最终成功转化一位犹豫候选人的完整过程，你具体做了什",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 请描述一次你通过电话或微信持续跟进，最终成功转化一位犹豫候选人的完整过程，你具体做了什么打破僵局？\n2. 家政劳动者群体与白领候选人在沟通诉求上差异很大，请举例说明你如何快速适应并赢得一个陌生群体信任的经历。\n3. 你近两段工作时长都在1年左右，如果加入天鹅到家，你计划如何克服新行业学习曲线并承诺至少2-3年的稳定性？\n4. 假设你需要在一个月内为北京某区域招募50名保洁劳动者，请简述你的渠道策略、每日电话量规划及关键转化节点设计。\n5. 家政行业劳动者流动性高，你认为在签约前和入职后哪些环节最能影响留存率？请结合过往人才保温经验说明。",
    "capabilityMatch": "1. **客户开发能力：4/5分。依据：4年招聘经验，精通电话/微信跟进、候选人保温、谈薪签约全流程；驻场NEC期间独立完成社招全流程，批量校招25人，留存率96%，具备强意向客户转化能力。\n2. **活动执行能力：4/5分。依据：独立策划执行圣诞、中秋、端午、慈善等员工活动；组织市场走访、企业内购会、代言人促销会，活动统筹经验丰富。\n3. **市场分析能力：3/5分。依据：负责每月人力资源报表输出、销量达成率分析；有区域院校洞察经验，但缺乏家政行业市场分析直接证据。\n4. **商务沟通能力：4/5分。依据：4年HRBP/猎头经历，日常高频对接候选人、业务方、猎头公司；员工关系管理中擅长解答咨询、处理工伤等敏感事务，商务礼仪与沟通成熟度高。\n5. **软件操作能力：4/5分。依据：优化BI看板和单据审批流配置，熟练使用Office完成数据分析、报表输出、培训课件制作，数字化工具应用能力强。",
    "created": ""
  },
  {
    "id": 137,
    "name": "刘先生",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "刘",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "无",
    "gender": "男",
    "strengths": "11年工作经验含3年招聘+3年招商，电销与地推双背景；近期同创蓝天招商岗业绩突出（入职2月获分公司第2名），具备\"电话/微信邀约-接待考察-签约-培训-售后\"全链路闭环经验；熟练使用AI工具提效，与天鹅到家数字化方向契合。",
    "risks": "期望薪资10-15K高于JD标注7-12K，需确认薪酬弹性；近3份工作均2-3年，稳定性中等；无家政行业经验，劳动者群体（蓝领）与过往B端招商/房产客户差异大，文化适配待验证。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 通过\n\n优势分析:\n11年工作经验含3年招聘+3年招商，电销与地推双背景；近期同创蓝天招商岗业绩突出（入职2月获分公司第2名），具备\"电话/微信邀约-接待考察-签约-培训-售后\"全链路闭环经验；熟练使用AI工具提效，与天鹅到家数字化方向契合。\n\n风险点:\n期望薪资10-15K高于JD标注7-12K，需确认薪酬弹性；近3份工作均2-3年，稳定性中等；无家政行业经验，劳动者群体（蓝领）与过往B端招商/房产客户差异大，文化适配待验证。\n\n能力维度匹配:\n1. **客户开发能力：4/5分。依据：同创蓝天岗明确\"电话/微信邀约-接待考察-签约\"全流程，入职2月业绩排名第2，获现金奖励及总经理表彰；秋谷集团地推+电销挖掘客户，首月出单。匹配JD\"电话、企业微信跟进，邀约、接待、签约\"要求。\n2. **活动执行能力：2/5分。依据：简历未明确提及\"招商活动\"执行，仅华夏良子有\"招聘会参加\"，但属招聘场景非招商活动。JD要求\"参与完成公司举办的各类招商活动\"，此维度证据不足。\n3. **市场分析能力：1/5分。依据：简历无\"分析行业及区域市场信息并提出建议\"的直接描述，华夏良子\"招聘渠道挖掘\"偏向执行层开拓，非系统性市场分析。JD此要求匹配度低。\n4. **商务沟通能力：4/5分。依据：自述\"沟通协调方面表现突出，促进团队合作\"；同创蓝天\"现场详细介绍\"\"与领导团队紧密合作成功签约\"；房产销售客户维护及转介绍经验。匹配\"与劳动者有效沟通，展现良好商务礼仪\"。\n5. **软件操作能力：3/5分。依据：自述\"熟练掌握AI工具使用\"；未明确提Office，但11年职场经验含HR经理岗（员工花名册、合同管理），隐含基础办公软件使用。JD要求\"",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 您在同创蓝天入职第2个月就拿到分公司业绩第2名，请具体描述当时是如何快速打开局面、建立客户信任的？过程中遇到最大的阻力是什么？\n2. 招商工作中常遇到客户考察后犹豫不签约的情况，请举例说明您如何跟进并最终促成签约的？具体做了哪些动作？\n3. 您过往3份工作平均在职2-3年，请谈谈离职原因；如果加入天鹅到家，您期望在这份工作中获得什么，计划深耕多久？\n4. 天鹅到家的劳动者以保洁、保姆、月嫂等蓝领群体为主，与过往B端加盟商或房产客户差异较大。您认为服务这类群体与之前客户最大的不同是什么？您会如何调整沟通方式？\n5. 假设公司要求您在3个月内招募50名合格劳动者，但当前区域市场竞品激烈、线索质量下降，请简述您的破局思路和具体执行步骤。",
    "capabilityMatch": "1. **客户开发能力：4/5分。依据：同创蓝天岗明确\"电话/微信邀约-接待考察-签约\"全流程，入职2月业绩排名第2，获现金奖励及总经理表彰；秋谷集团地推+电销挖掘客户，首月出单。匹配JD\"电话、企业微信跟进，邀约、接待、签约\"要求。\n2. **活动执行能力：2/5分。依据：简历未明确提及\"招商活动\"执行，仅华夏良子有\"招聘会参加\"，但属招聘场景非招商活动。JD要求\"参与完成公司举办的各类招商活动\"，此维度证据不足。\n3. **市场分析能力：1/5分。依据：简历无\"分析行业及区域市场信息并提出建议\"的直接描述，华夏良子\"招聘渠道挖掘\"偏向执行层开拓，非系统性市场分析。JD此要求匹配度低。\n4. **商务沟通能力：4/5分。依据：自述\"沟通协调方面表现突出，促进团队合作\"；同创蓝天\"现场详细介绍\"\"与领导团队紧密合作成功签约\"；房产销售客户维护及转介绍经验。匹配\"与劳动者有效沟通，展现良好商务礼仪\"。\n5. **软件操作能力：3/5分。依据：自述\"熟练掌握AI工具使用\"；未明确提Office，但11年职场经验含HR经理岗（员工花名册、合同管理），隐含基础办公软件使用。JD要求\"会使用office软件\"，假设达标但无直接证据。",
    "created": ""
  },
  {
    "id": 138,
    "name": "徐青国",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "徐",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "37岁",
    "gender": "无",
    "strengths": "16年销售经验，具备完整客户开发闭环能力（开发-跟进-签约-维护），单月回款37万业绩突出；擅长电话销售与商务洽谈，与家政招商\"电话邀约+考查接待+签约\"模式高度匹配；有地推经验（怪兽充电区域商家入驻），适应线下劳动者开发场景。",
    "risks": "近3年跳槽频繁（2021-2024三段经历），稳定性存疑；无家政/母婴行业背景，劳动者群体（阿姨）沟通需适应；37岁期望薪资6-11K低于市场资深销售水平，需确认职业动机与长期意愿。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 通过\n\n优势分析:\n16年销售经验，具备完整客户开发闭环能力（开发-跟进-签约-维护），单月回款37万业绩突出；擅长电话销售与商务洽谈，与家政招商\"电话邀约+考查接待+签约\"模式高度匹配；有地推经验（怪兽充电区域商家入驻），适应线下劳动者开发场景。\n\n风险点:\n近3年跳槽频繁（2021-2024三段经历），稳定性存疑；无家政/母婴行业背景，劳动者群体（阿姨）沟通需适应；37岁期望薪资6-11K低于市场资深销售水平，需确认职业动机与长期意愿。\n\n能力维度匹配:\n1. **客户开发能力：4/5分。依据：16年销售经验，优仙生物\"开发客户-促成合作-持续维护-老带新\"完整闭环，单月37万回款；怪兽充电\"商家洽谈入驻\"与劳动者招募场景相似，电话销售经验丰富。**\n2. **活动执行能力：3/5分。依据：优仙生物\"跟踪活动进度，推动活动正常进行直至结束\"体现活动跟进经验，但未明确提及招商活动执行，需进一步确认大型活动参与度。**\n3. **市场分析能力：2/5分。依据：简历未直接体现行业信息分析或区域市场建议案例，星火汇芯\"发掘潜在客户\"偏向执行层，战略分析能力待验证。**\n4. **商务沟通能力：4/5分。依据：自我评价\"真诚、耐心、协调关系、团队精神\"；多段销售经历验证商务沟通基础；怪兽充电\"维护商家良好关系\"与劳动者长期维护场景匹配。**\n5. **软件操作能力：3/5分。依据：任职要求明确\"会使用office软件\"，简历未具体描述操作场景，默认符合基础要求，但无高级功能（如数据分析）体现。**\n\n面试问题:\n1. \"请描述一次您成功说服一位犹豫客户签约的经历，当时对方的核心顾虑是什么，您如何针对性解决？\"\n2. \"您近三",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. \"请描述一次您成功说服一位犹豫客户签约的经历，当时对方的核心顾虑是什么，您如何针对性解决？\"\n2. \"您近三段工作经历时间都不长，请说明离职原因，以及如何看待家政行业需要长期深耕劳动者关系的特性？\"\n3. \"当同时跟进多位意向客户且活动执行期重叠时，您如何排序优先级并确保服务质量？\"\n4. \"家政劳动者（如保洁阿姨、月嫂）群体普遍年龄偏大、互联网使用能力参差，您过往如何应对类似低数字化客户群体的沟通与转化？\"\n5. \"假设您负责的区域本月招募目标10人，目前电话邀约到店率仅15%，您会从哪些环节优化提升转化？\"",
    "capabilityMatch": "1. **客户开发能力：4/5分。依据：16年销售经验，优仙生物\"开发客户-促成合作-持续维护-老带新\"完整闭环，单月37万回款；怪兽充电\"商家洽谈入驻\"与劳动者招募场景相似，电话销售经验丰富。**\n2. **活动执行能力：3/5分。依据：优仙生物\"跟踪活动进度，推动活动正常进行直至结束\"体现活动跟进经验，但未明确提及招商活动执行，需进一步确认大型活动参与度。**\n3. **市场分析能力：2/5分。依据：简历未直接体现行业信息分析或区域市场建议案例，星火汇芯\"发掘潜在客户\"偏向执行层，战略分析能力待验证。**\n4. **商务沟通能力：4/5分。依据：自我评价\"真诚、耐心、协调关系、团队精神\"；多段销售经历验证商务沟通基础；怪兽充电\"维护商家良好关系\"与劳动者长期维护场景匹配。**\n5. **软件操作能力：3/5分。依据：任职要求明确\"会使用office软件\"，简历未具体描述操作场景，默认符合基础要求，但无高级功能（如数据分析）体现。**",
    "created": ""
  },
  {
    "id": 139,
    "name": "郭丽丽",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "郭",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "31岁",
    "gender": "女",
    "strengths": "8年编辑出版经验，具备较强的内容策划、项目执行及商务对接能力（如CC讲坛促成人民网慕课合作）；有活动落地经验（妇联项目、读书教育活动）；沟通表达能力经演讲撰稿、作者对接验证；掌握Office基础工具。",
    "risks": "零销售/招商/地推经验，无电话销售、客户签约、业绩指标达成背景；履历集中于文化出版行业，与家政服务数字化、标准化业务断层；31岁转行成本与稳定性存疑；无市场营销专业背景及家政行业认知。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 淘汰\n\n优势分析:\n8年编辑出版经验，具备较强的内容策划、项目执行及商务对接能力（如CC讲坛促成人民网慕课合作）；有活动落地经验（妇联项目、读书教育活动）；沟通表达能力经演讲撰稿、作者对接验证；掌握Office基础工具。\n\n风险点:\n零销售/招商/地推经验，无电话销售、客户签约、业绩指标达成背景；履历集中于文化出版行业，与家政服务数字化、标准化业务断层；31岁转行成本与稳定性存疑；无市场营销专业背景及家政行业认知。\n\n能力维度匹配:\n1. **客户开发能力：0/5分。依据：简历无电话销售、客户跟进、签约转化、业绩达成等任何销售类经验，全程为内容策划与编辑岗位。**\n2. **活动执行能力：3/5分。依据：有\"活动落地\"经验（CC讲坛现场执行、妇联及文化机构活动执行），但属内容型活动，非招商/销售导向活动。**\n3. **市场分析能力：2/5分。依据：有选题策划时的市场判断（女性读者需求分析），但无行业数据收集、区域市场分析、商业建议输出等系统性经验。**\n4. **商务沟通能力：3/5分。依据：具备演讲者对接、商务合作（人民网专区上线）、作者沟通经验，礼仪与表达合格，但面向劳动者群体的亲和力与说服力未验证。**\n5. **软件操作能力：4/5分。依据：8年编辑工作必然熟练使用Office，有视频剪辑、新媒体平台运营经验，数字化工具适应力强。**\n\n面试问题:\n1. 您过往工作以内容策划为主，若转型需完成每月固定的劳动者招募签约指标，请描述一次您主动设定并达成量化目标的经历。\n2. 家政劳动者群体学历背景多元，请举例说明您曾与\"非专业受众\"（如非文化行业人士）高效沟通并推动合作的经历。\n3. 您近三段工作平均任期约1.5",
    "aiScreen": "淘汰",
    "hrReview": "淘汰",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 您过往工作以内容策划为主，若转型需完成每月固定的劳动者招募签约指标，请描述一次您主动设定并达成量化目标的经历。\n2. 家政劳动者群体学历背景多元，请举例说明您曾与\"非专业受众\"（如非文化行业人士）高效沟通并推动合作的经历。\n3. 您近三段工作平均任期约1.5年，请说明加入家政行业后的3-5年职业规划，以及如何应对初期可能的业绩压力与收入波动。\n4. 假设您负责北京朝阳区保洁劳动者招募，请简述您会如何在一周内快速获取该区域潜在劳动者聚集渠道（非网络渠道）。\n5. 请现场模拟电话邀约一位50岁农村户籍、对家政行业有顾虑的女性劳动者，时长2分钟，需包含打消顾虑与邀约到店两个动作。",
    "capabilityMatch": "1. **客户开发能力：0/5分。依据：简历无电话销售、客户跟进、签约转化、业绩达成等任何销售类经验，全程为内容策划与编辑岗位。**\n2. **活动执行能力：3/5分。依据：有\"活动落地\"经验（CC讲坛现场执行、妇联及文化机构活动执行），但属内容型活动，非招商/销售导向活动。**\n3. **市场分析能力：2/5分。依据：有选题策划时的市场判断（女性读者需求分析），但无行业数据收集、区域市场分析、商业建议输出等系统性经验。**\n4. **商务沟通能力：3/5分。依据：具备演讲者对接、商务合作（人民网专区上线）、作者沟通经验，礼仪与表达合格，但面向劳动者群体的亲和力与说服力未验证。**\n5. **软件操作能力：4/5分。依据：8年编辑工作必然熟练使用Office，有视频剪辑、新媒体平台运营经验，数字化工具适应力强。**",
    "created": ""
  },
  {
    "id": 140,
    "name": "郭丽丽",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "郭",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "31岁",
    "gender": "女",
    "strengths": "8年编辑出版经验，具备较强的内容策划、项目执行与多方沟通能力；曾负责\"家家幸福安康工程\"等大型项目落地，有一定活动组织经验；熟悉女性及家庭类用户群体，与天鹅到家目标劳动者（家政服务人员）画像存在潜在关联。",
    "risks": "零销售/招商/地推经验，无客户开发、签约转化、电销等核心技能；职业路径为纯内容编辑，与家政招商岗位差异显著；31岁转行意愿不明，稳定性存疑；无市场营销、家政行业背景，不满足任职要求第3条。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 淘汰\n\n优势分析:\n8年编辑出版经验，具备较强的内容策划、项目执行与多方沟通能力；曾负责\"家家幸福安康工程\"等大型项目落地，有一定活动组织经验；熟悉女性及家庭类用户群体，与天鹅到家目标劳动者（家政服务人员）画像存在潜在关联。\n\n风险点:\n零销售/招商/地推经验，无客户开发、签约转化、电销等核心技能；职业路径为纯内容编辑，与家政招商岗位差异显著；31岁转行意愿不明，稳定性存疑；无市场营销、家政行业背景，不满足任职要求第3条。\n\n能力维度匹配:\n1. **客户开发能力：0/5分。依据：简历无任何销售、客户跟进、签约转化经验，未体现电话销售、企业微信运营、客户接待等技能，与岗位核心职责完全不符。**\n2. **活动执行能力：2/5分。依据：有文化活动、项目落地经验（如温州儿童友好城市研学），但均为内容策划型活动，非招商推广类活动，场景差异较大。**\n3. **市场分析能力：1/5分。依据：作为编辑需分析图书市场，但属于文化出版领域，无家政行业或区域市场分析经验，未体现数据驱动决策能力。**\n4. **商务沟通能力：2/5分。依据：具备作者、出版社、文化机构多方沟通经验，商务礼仪基础尚可，但沟通对象均为文化从业者，与劳动者群体差异大，未验证接地气表达能力。**\n5. **软件操作能力：3/5分。依据：编辑岗位日常使用Office处理文档、合同、财务付款等，基础操作熟练，但未涉及数据分析、CRM系统等招商工具。**\n\n面试问题:\n1. 您过往工作以内容策划为主，本次应聘销售导向的招商岗位，请描述一次您主动说服他人接受您方案的经历，当时采取了哪些策略？\n2. 编辑工作相对独立稳定，招商岗位需高频外出、承受业绩压力，请分享您过往工作",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 您过往工作以内容策划为主，本次应聘销售导向的招商岗位，请描述一次您主动说服他人接受您方案的经历，当时采取了哪些策略？\n2. 编辑工作相对独立稳定，招商岗位需高频外出、承受业绩压力，请分享您过往工作中最能体现抗压能力和目标感的一次经历。\n3. 您计划如何快速建立对家政行业及基层劳动者群体的认知？如果一位农村阿姨对签约平台有顾虑，您会如何沟通？\n4. 假设您负责北京某区域的保洁阿姨招募，请简述您会如何制定一周的客户开发计划（渠道选择、每日电话量、邀约目标）？\n5. 请现场模拟一段电话沟通：向一位有家政经验但未接触过互联网平台的阿姨介绍天鹅到家，并邀请她到店考查。",
    "capabilityMatch": "1. **客户开发能力：0/5分。依据：简历无任何销售、客户跟进、签约转化经验，未体现电话销售、企业微信运营、客户接待等技能，与岗位核心职责完全不符。**\n2. **活动执行能力：2/5分。依据：有文化活动、项目落地经验（如温州儿童友好城市研学），但均为内容策划型活动，非招商推广类活动，场景差异较大。**\n3. **市场分析能力：1/5分。依据：作为编辑需分析图书市场，但属于文化出版领域，无家政行业或区域市场分析经验，未体现数据驱动决策能力。**\n4. **商务沟通能力：2/5分。依据：具备作者、出版社、文化机构多方沟通经验，商务礼仪基础尚可，但沟通对象均为文化从业者，与劳动者群体差异大，未验证接地气表达能力。**\n5. **软件操作能力：3/5分。依据：编辑岗位日常使用Office处理文档、合同、财务付款等，基础操作熟练，但未涉及数据分析、CRM系统等招商工具。**",
    "created": ""
  },
  {
    "id": 141,
    "name": "郭丽丽",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "郭",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "31岁",
    "gender": "女",
    "strengths": "8年编辑出版经验，具备较强的文案撰写、活动策划（CC讲坛演讲策划、出版社营销活动）及商务对接能力（CC讲坛与人民网慕课合作），有一定沟通表达基础；有韩语初级能力，或有助于涉外家政客户沟通。",
    "risks": "零家政/招商/销售经验，职业路径为纯内容编辑，与地招岗位核心要求（电销、劳动者招募签约、地推活动）严重错位；31岁转行意愿不明，稳定性存疑；无市场分析、客户开发直接经验，技能缺口显著。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 淘汰\n\n优势分析:\n8年编辑出版经验，具备较强的文案撰写、活动策划（CC讲坛演讲策划、出版社营销活动）及商务对接能力（CC讲坛与人民网慕课合作），有一定沟通表达基础；有韩语初级能力，或有助于涉外家政客户沟通。\n\n风险点:\n零家政/招商/销售经验，职业路径为纯内容编辑，与地招岗位核心要求（电销、劳动者招募签约、地推活动）严重错位；31岁转行意愿不明，稳定性存疑；无市场分析、客户开发直接经验，技能缺口显著。\n\n能力维度匹配:\n1. **客户开发能力：0/5分。依据：简历无任何销售、客户跟进、签约转化经验，8年工作均为内容策划与编辑，与\"电话/企业微信邀约、接待考查、沟通签约\"完全无关。\n2. **活动执行能力：2/5分。依据：有文化活动策划执行经验（CC讲坛现场落地、出版社签售活动），但均为内容向活动，非招商/销售导向的地推或招募活动，场景差异大。\n3. **市场分析能力：1/5分。依据：编辑工作涉及选题市场判断（如女性向、青少年向图书定位），但属文化产品分析，非区域家政市场信息收集与策略建议，无数据化分析痕迹。\n4. **商务沟通能力：2/5分。依据：有作者、演讲者、合作方对接经验，商务礼仪基础尚可；但沟通对象为文化界人士，与家政劳动者群体差异显著，共情能力与场景转换未验证。\n5. **软件操作能力：3/5分。依据：编辑岗位常规使用Office处理合同、信息表、PPT等，但简历未明确提及Excel数据处理或CRM系统，仅满足基础门槛。\n\n面试问题:\n1. 请描述一次你需要说服一位作者或合作方接受你方案的经历，当时对方的核心顾虑是什么，你具体如何沟通达成一致的？\n2. 编辑工作中常需服务作者需求，请举例说明你如何在资源有限",
    "aiScreen": "淘汰",
    "hrReview": "",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 请描述一次你需要说服一位作者或合作方接受你方案的经历，当时对方的核心顾虑是什么，你具体如何沟通达成一致的？\n2. 编辑工作中常需服务作者需求，请举例说明你如何在资源有限的情况下，平衡多位作者/合作方的紧急需求并维护好关系？\n3. 你从事编辑工作8年，此次应聘家政招商岗位，请具体说明是什么契机让你考虑跨行业转型，以及你对该岗位长期发展的理解？\n4. 你认为家政服务行业的劳动者（保洁/保姆/月嫂）在求职时最关注的三个因素是什么？你会如何针对性设计招募话术？\n5. 假设一位45岁农村女性劳动者来门店咨询月嫂岗位，但担心自己没有证书、不会普通话，你会如何现场沟通并推动她留下联系方式或完成报名？",
    "capabilityMatch": "1. **客户开发能力：0/5分。依据：简历无任何销售、客户跟进、签约转化经验，8年工作均为内容策划与编辑，与\"电话/企业微信邀约、接待考查、沟通签约\"完全无关。\n2. **活动执行能力：2/5分。依据：有文化活动策划执行经验（CC讲坛现场落地、出版社签售活动），但均为内容向活动，非招商/销售导向的地推或招募活动，场景差异大。\n3. **市场分析能力：1/5分。依据：编辑工作涉及选题市场判断（如女性向、青少年向图书定位），但属文化产品分析，非区域家政市场信息收集与策略建议，无数据化分析痕迹。\n4. **商务沟通能力：2/5分。依据：有作者、演讲者、合作方对接经验，商务礼仪基础尚可；但沟通对象为文化界人士，与家政劳动者群体差异显著，共情能力与场景转换未验证。\n5. **软件操作能力：3/5分。依据：编辑岗位常规使用Office处理合同、信息表、PPT等，但简历未明确提及Excel数据处理或CRM系统，仅满足基础门槛。",
    "created": ""
  },
  {
    "id": 142,
    "name": "刘先生",
    "role": "招商专员（地招）",
    "company": "招商业务部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "刘",
    "dept": "养老及商业事业部",
    "city": "北京",
    "age": "34岁",
    "gender": "男",
    "strengths": "11年人力资源与招商经验，具备完整的\"电话邀约-接待考察-签约-培训-售后\"闭环能力；在华夏良子实现单月招聘26人，同创蓝天入职次月获全国业绩第二，地推+电销双渠道经验丰富；擅长团队建设与渠道开拓（家政公司合作、校方对接），与天鹅到家劳动者招募场景高度契合。",
    "risks": "近3年经历含自主创业（人力公司）与当前招商岗位，职业路径存在波动；34岁年龄与7-12K薪资预期存在落差，需确认长期稳定性；简历未体现家政行业垂直经验，母婴/保洁等专业服务标准认知待验证。",
    "aiEval": "以下为候选人的 招商专员（地招） 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：招生专员（劳动者方向）\n🏢 招聘岗位：招商专员（地招）\n\n初筛结果: 通过\n\n优势分析:\n11年人力资源与招商经验，具备完整的\"电话邀约-接待考察-签约-培训-售后\"闭环能力；在华夏良子实现单月招聘26人，同创蓝天入职次月获全国业绩第二，地推+电销双渠道经验丰富；擅长团队建设与渠道开拓（家政公司合作、校方对接），与天鹅到家劳动者招募场景高度契合。\n\n风险点:\n近3年经历含自主创业（人力公司）与当前招商岗位，职业路径存在波动；34岁年龄与7-12K薪资预期存在落差，需确认长期稳定性；简历未体现家政行业垂直经验，母婴/保洁等专业服务标准认知待验证。\n\n能力维度匹配:\n1. **客户开发能力：5/5分。依据：同创蓝天任职期间完成电话/微信跟进、视频邀约、现场接待、签约、培训、售后全流程，次月获全国业绩第二，具备成熟的劳动者招募闭环经验。**\n2. **活动执行能力：3/5分。依据：简历提及\"活动组织\"及\"招聘会参加\"，但未明确描述招商活动执行细节，更多侧重招聘端活动，需进一步确认招商场景经验。**\n3. **市场分析能力：2/5分。依据：简历强调\"招聘渠道开发\"与\"新媒体运营\"，但未体现行业信息分析或区域市场策略建议的具体案例，此维度证据薄弱。**\n4. **商务沟通能力：4/5分。依据：多次描述\"详细介绍项目\"\"与客户紧密合作\"\"解决客户问题\"，获总经理公开表彰，商务表达与客情维护能力经业绩验证。**\n5. **软件操作能力：3/5分。依据：提及\"员工花名册制定\"\"业绩统计汇报\"，隐含Office使用场景，但未明确描述软件操作细节，AI工具使用为加分项。**\n\n面试问题:\n1. 请描述一次您成功招募高门槛劳动者（如月嫂、育儿嫂）的具体案例：您如何识别其真实技能水平？遇到劳动者对平台抽成或合同",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "招生专员（劳动者方向）",
    "interviewQ": "1. 请描述一次您成功招募高门槛劳动者（如月嫂、育儿嫂）的具体案例：您如何识别其真实技能水平？遇到劳动者对平台抽成或合同条款有抵触时，您如何沟通化解？\n2. 您在华夏良子单月招聘26人的高峰期，如何平衡\"快速到岗\"与\"服务质量\"的冲突？能否举例说明您拒绝过的不合格候选人及判断依据？\n3. 您近三段经历涉及人力资源、自主创业、招商三个方向，选择天鹅到家招商专员岗位的核心动机是什么？如何看待该岗位从一线执行到区域管理的晋升路径？\n4. 假设您负责北京朝阳区保洁劳动者招募，该区域58同城线索成本上涨40%，而竞品平台正在地推抢人。请简述您本周的获客渠道组合策略及优先级排序。\n5. 一位有5年经验的住家阿姨面试时表现优异，但背景调查发现其上一户存在\"擅自离岗\"投诉记录。您是否推进签约？请说明决策逻辑及与劳动者的沟通要点。",
    "capabilityMatch": "1. **客户开发能力：5/5分。依据：同创蓝天任职期间完成电话/微信跟进、视频邀约、现场接待、签约、培训、售后全流程，次月获全国业绩第二，具备成熟的劳动者招募闭环经验。**\n2. **活动执行能力：3/5分。依据：简历提及\"活动组织\"及\"招聘会参加\"，但未明确描述招商活动执行细节，更多侧重招聘端活动，需进一步确认招商场景经验。**\n3. **市场分析能力：2/5分。依据：简历强调\"招聘渠道开发\"与\"新媒体运营\"，但未体现行业信息分析或区域市场策略建议的具体案例，此维度证据薄弱。**\n4. **商务沟通能力：4/5分。依据：多次描述\"详细介绍项目\"\"与客户紧密合作\"\"解决客户问题\"，获总经理公开表彰，商务表达与客情维护能力经业绩验证。**\n5. **软件操作能力：3/5分。依据：提及\"员工花名册制定\"\"业绩统计汇报\"，隐含Office使用场景，但未明确描述软件操作细节，AI工具使用为加分项。**",
    "created": ""
  },
  {
    "id": 143,
    "name": "nala",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "视觉专业",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "n",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "女",
    "strengths": "具备数字化运营经验（小程序运营、数据提取分析），储备管理经历体现人员协调能力，视觉专业背景有助于培训物料制作，执行力与细节把控符合家政服务标准化要求。",
    "risks": "性别不符（JD要求男性），无家政/母婴行业经验，期望薪资5-6K低于岗位8-10K区间可能存在预期落差，烘焙店经历仅7个月稳定性待验证。",
    "aiEval": "以下为候选人的 商家运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：商家运营专员（月休8天）\n🏢 招聘岗位：商家运营专员\n\n初筛结果: 淘汰\n\n优势分析:\n具备数字化运营经验（小程序运营、数据提取分析），储备管理经历体现人员协调能力，视觉专业背景有助于培训物料制作，执行力与细节把控符合家政服务标准化要求。\n\n风险点:\n性别不符（JD要求男性），无家政/母婴行业经验，期望薪资5-6K低于岗位8-10K区间可能存在预期落差，烘焙店经历仅7个月稳定性待验证。\n\n能力维度匹配:\n1. **人员维护能力：2/5分。依据：仅有储备管理10+人排班经验，无薪资物料发放实操，家政服务人员管理场景缺失。\n2. **订单安排能力：1/5分。依据：无订单调度、换单处理相关经历，小程序运营侧重商品而非服务派单。\n3. **基础培训能力：3/5分。依据：储备管理含人员培养经历，视觉专业可支撑培训素材制作，但无家政培训实操。\n4. **应急对接能力：2/5分。依据：审核岗有数据监控辅助问题定位经验，无急单对接、售后处理直接经历。\n5. **沟通协作能力：4/5分。依据：简历明确\"沟通协调能力强\"\"团队协作意识\"，储备管理含日常沟通，但\"非工作时间回复\"未验证。\n\n面试问题:\n1. 请描述一次你处理团队成员突发请假导致排班冲突的经历，具体如何协调？\n2. 烘焙店运营中遇到客户紧急投诉或订单问题，你是如何对接解决的？\n3. 审核岗晋升储备管理后，同时承担原岗位和新职责压力较大时，你如何平衡并坚持下来的？\n4. 如果月嫂因突发疾病需紧急换单，客户要求指定替换人选但系统无匹配，你会如何处理？\n5. 请设计一个针对新入职月嫂的\"上户前须知\"非专业培训大纲（3个核心模块即可）。\n\n互动引导语:\nnala您好，我是天鹅到家HR。看了您的简历，您在具备数字化运营经验（小程序运营、数据提取分析），储备管",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你处理团队成员突发请假导致排班冲突的经历，具体如何协调？\n2. 烘焙店运营中遇到客户紧急投诉或订单问题，你是如何对接解决的？\n3. 审核岗晋升储备管理后，同时承担原岗位和新职责压力较大时，你如何平衡并坚持下来的？\n4. 如果月嫂因突发疾病需紧急换单，客户要求指定替换人选但系统无匹配，你会如何处理？\n5. 请设计一个针对新入职月嫂的\"上户前须知\"非专业培训大纲（3个核心模块即可）。",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：仅有储备管理10+人排班经验，无薪资物料发放实操，家政服务人员管理场景缺失。\n2. **订单安排能力：1/5分。依据：无订单调度、换单处理相关经历，小程序运营侧重商品而非服务派单。\n3. **基础培训能力：3/5分。依据：储备管理含人员培养经历，视觉专业可支撑培训素材制作，但无家政培训实操。\n4. **应急对接能力：2/5分。依据：审核岗有数据监控辅助问题定位经验，无急单对接、售后处理直接经历。\n5. **沟通协作能力：4/5分。依据：简历明确\"沟通协调能力强\"\"团队协作意识\"，储备管理含日常沟通，但\"非工作时间回复\"未验证。",
    "created": ""
  },
  {
    "id": 144,
    "name": "白文婧",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "26年应届生（未明确具体学历层次）",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "白",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "无",
    "gender": "女",
    "strengths": "具备直播运营、私域流量搭建及OTA平台运维经验，擅长数据监测与客诉处理（400+单，解决率95%），熟悉微信/抖音社群运营与活动策划，执行力与目标导向强，契合家政服务数字化运营需求。",
    "risks": "26年应届生，2025.07-2026.04实习时间与毕业时间重叠存疑；无母婴/家政行业背景，人员维护与基础培训能力为零经验；岗位需\"男性\"与候选人性别冲突（如JD硬性要求则存疑）。",
    "aiEval": "以下为候选人的 商家运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：商家运营专员（月休8天）\n🏢 招聘岗位：商家运营专员\n\n初筛结果: 通过\n\n优势分析:\n具备直播运营、私域流量搭建及OTA平台运维经验，擅长数据监测与客诉处理（400+单，解决率95%），熟悉微信/抖音社群运营与活动策划，执行力与目标导向强，契合家政服务数字化运营需求。\n\n风险点:\n26年应届生，2025.07-2026.04实习时间与毕业时间重叠存疑；无母婴/家政行业背景，人员维护与基础培训能力为零经验；岗位需\"男性\"与候选人性别冲突（如JD硬性要求则存疑）。\n\n能力维度匹配:\n1. **人员维护能力：1/5分。依据：无薪资发放、物料管理或人员事务维护经验，仅涉及线上产品咨询与客诉处理。**\n2. **订单安排能力：2/5分。依据：有OTA平台订单处理与库存调整经验，但无月嫂/育婴师排班、换单等家政服务调度经验。**\n3. **基础培训能力：0/5分。依据：简历未体现任何培训授课、课程开发或人员带教经历。**\n4. **应急对接能力：3/5分。依据：独立处理400+平台客诉，解决率95%以上，具备售后问题响应经验，但无\"急单\"场景验证。**\n5. **沟通协作能力：4/5分。依据：直播互动引导、社群运营、跨部门协作经历丰富，自我评价强调沟通能力与团队精神，但未明确接受非工作时间回复。**\n\n面试问题:\n1. \"请描述一次你需要在深夜或节假日紧急处理客户投诉的经历，当时如何平衡个人时间与工作需求？\"\n2. \"直播运营中曾优化3版互动话术，若将这套方法用于培训月嫂统一服务话术，你会如何设计？\"\n3. \"私域运营中通过拼团裂变提升业绩45%，面对月嫂群体流动性高、线上触达难的特点，你会如何设计激励机制？\"\n4. \"请用Excel演示：如何设计一张月嫂排班表，需包含姓名、技能等级、订单状态、预产期",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"请描述一次你需要在深夜或节假日紧急处理客户投诉的经历，当时如何平衡个人时间与工作需求？\"\n2. \"直播运营中曾优化3版互动话术，若将这套方法用于培训月嫂统一服务话术，你会如何设计？\"\n3. \"私域运营中通过拼团裂变提升业绩45%，面对月嫂群体流动性高、线上触达难的特点，你会如何设计激励机制？\"\n4. \"请用Excel演示：如何设计一张月嫂排班表，需包含姓名、技能等级、订单状态、预产期冲突预警字段，并说明常用函数。\"\n5. \"假设一位月嫂因突发疾病需紧急换单，客户要求原等级服务且不接受等待，你会如何协调资源并安抚双方？\"",
    "capabilityMatch": "1. **人员维护能力：1/5分。依据：无薪资发放、物料管理或人员事务维护经验，仅涉及线上产品咨询与客诉处理。**\n2. **订单安排能力：2/5分。依据：有OTA平台订单处理与库存调整经验，但无月嫂/育婴师排班、换单等家政服务调度经验。**\n3. **基础培训能力：0/5分。依据：简历未体现任何培训授课、课程开发或人员带教经历。**\n4. **应急对接能力：3/5分。依据：独立处理400+平台客诉，解决率95%以上，具备售后问题响应经验，但无\"急单\"场景验证。**\n5. **沟通协作能力：4/5分。依据：直播互动引导、社群运营、跨部门协作经历丰富，自我评价强调沟通能力与团队精神，但未明确接受非工作时间回复。**",
    "created": ""
  },
  {
    "id": 145,
    "name": "鲍志谦",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "鲍",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "24岁",
    "gender": "男",
    "strengths": "3年互联网平台商家运营经验，擅长商家分层运维、SOP标准化、1V1陪跑培训，具备数字化工具应用能力（AI作图、数据分析），有\"72小时极速部署+3天驻场培训\"的强执行案例，与家政服务标准化、职业化转型方向契合。",
    "risks": "简历显示24岁但工作年限存疑（2023.03-2025.08约2.5年却称3年经验）；无母婴/家政行业背景，人员维护涉及薪资发放等敏感事务需从零学习；期望薪资9-10K高于传统家政运营岗；男性候选人与月嫂群体（女性为主）日常管理存在天然沟通壁垒。",
    "aiEval": "以下为候选人的 商家运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：商家运营专员（月休8天）\n🏢 招聘岗位：商家运营专员\n\n初筛结果: 存疑\n\n优势分析:\n3年互联网平台商家运营经验，擅长商家分层运维、SOP标准化、1V1陪跑培训，具备数字化工具应用能力（AI作图、数据分析），有\"72小时极速部署+3天驻场培训\"的强执行案例，与家政服务标准化、职业化转型方向契合。\n\n风险点:\n简历显示24岁但工作年限存疑（2023.03-2025.08约2.5年却称3年经验）；无母婴/家政行业背景，人员维护涉及薪资发放等敏感事务需从零学习；期望薪资9-10K高于传统家政运营岗；男性候选人与月嫂群体（女性为主）日常管理存在天然沟通壁垒。\n\n能力维度匹配:\n1. **人员维护能力：2/5分。依据：无直接薪资/物料发放经验，但有商家分层运维、专属成功经理配置经验，可迁移至月嫂日常事务管理。**\n2. **订单安排能力：2/5分。依据：无订单调度经验，但有\"订单换单\"类商家动销链路搭建、活动资源匹配经验，逻辑可迁移但行业差异大。**\n3. **基础培训能力：3/5分。依据：明确具备\"1V1陪跑培训\"\"3天驻场冷启动培训\"\"线上培训+系统玩法教学\"经验，培训形式匹配但内容需转换。**\n4. **应急对接能力：3/5分。依据：有\"客诉解决链路优化\"\"云管家售后处理\"\"72小时极速部署响应\"经验，抗压与响应速度经验证。**\n5. **沟通协作能力：4/5分。依据：跨部门协同（天猫/美团/蚂蚁多平台）、服务商对接、200+商家1V1陪跑，性格开朗善于沟通获多雇主验证。**\n\n面试问题:\n1. \"请描述一次你处理商家紧急客诉或突发危机的具体案例，当时非工作时间你是如何响应的？结果如何？\"\n2. \"你的服务对象多为女性月嫂群体，作为男性运营如何建立信任并处理敏感事务（如薪资纠纷、情绪安抚）？是",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"请描述一次你处理商家紧急客诉或突发危机的具体案例，当时非工作时间你是如何响应的？结果如何？\"\n2. \"你的服务对象多为女性月嫂群体，作为男性运营如何建立信任并处理敏感事务（如薪资纠纷、情绪安抚）？是否有类似跨性别/跨群体沟通经验？\"\n3. \"简历中2023.03-2025.08约2.5年，但标注3年经验，能否澄清？近2年换3份工作（美团-中软-德科），如何看待家政行业需要的长期稳定性？\"\n4. \"假设一位月嫂因客户投诉被临时换单，情绪激烈拒绝配合，且当晚需紧急替补上户，你会如何协调？请模拟电话沟通关键话术。\"\n5. \"请用Excel设计一个月嫂薪资计算表框架，需包含基础工资、奖金、路费扣减、物料发放字段，并说明如何用数据透视表核对异常。\"",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：无直接薪资/物料发放经验，但有商家分层运维、专属成功经理配置经验，可迁移至月嫂日常事务管理。**\n2. **订单安排能力：2/5分。依据：无订单调度经验，但有\"订单换单\"类商家动销链路搭建、活动资源匹配经验，逻辑可迁移但行业差异大。**\n3. **基础培训能力：3/5分。依据：明确具备\"1V1陪跑培训\"\"3天驻场冷启动培训\"\"线上培训+系统玩法教学\"经验，培训形式匹配但内容需转换。**\n4. **应急对接能力：3/5分。依据：有\"客诉解决链路优化\"\"云管家售后处理\"\"72小时极速部署响应\"经验，抗压与响应速度经验证。**\n5. **沟通协作能力：4/5分。依据：跨部门协同（天猫/美团/蚂蚁多平台）、服务商对接、200+商家1V1陪跑，性格开朗善于沟通获多雇主验证。**",
    "created": ""
  },
  {
    "id": 146,
    "name": "毕女士",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "毕",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "25岁",
    "gender": "女",
    "strengths": "5年行政/销售经验，具备薪资审核、跨部门协调、新人带教等实操经验；性格踏实稳重、注重细节，符合家政服务标准化要求；有较强抗压能力与多任务处理能力，适应非工作时间响应需求。",
    "risks": "无家政/母婴行业背景，人员维护与订单安排能力未经证实；简历中\"销售经理/主管\"实际为外勤陌拜，存在岗位title夸大嫌疑；25岁年龄接近上限，职业路径从销售转行政再转运营，稳定性待验证。",
    "aiEval": "以下为候选人的 商家运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：商家运营专员（月休8天）\n🏢 招聘岗位：商家运营专员\n\n初筛结果: 存疑\n\n优势分析:\n5年行政/销售经验，具备薪资审核、跨部门协调、新人带教等实操经验；性格踏实稳重、注重细节，符合家政服务标准化要求；有较强抗压能力与多任务处理能力，适应非工作时间响应需求。\n\n风险点:\n无家政/母婴行业背景，人员维护与订单安排能力未经证实；简历中\"销售经理/主管\"实际为外勤陌拜，存在岗位title夸大嫌疑；25岁年龄接近上限，职业路径从销售转行政再转运营，稳定性待验证。\n\n能力维度匹配:\n1. **人员维护能力：2/5分。依据：有月度账单审核、成本数据管理经验，但无月嫂/育婴师群体维护经验，薪资发放对象与家政劳动者差异大。\n2. **订单安排能力：1/5分。依据：无任何订单调度、资源匹配相关经验，该能力完全空白。\n3. **基础培训能力：3/5分。依据：有制定新人带教计划、开展系统化培训的实操经验，可迁移至非专业培训场景。\n4. **应急对接能力：2/5分。依据：有协调解决账务差异、流程问题的跨部门协作经验，但无急单对接、售后处理专项经历。\n5. **沟通协作能力：4/5分。依据：主动对接各部门提升协作效率、持续外勤陌拜、客户面对面沟通等经历丰富，性格开朗善于沟通获多段经历验证。\n\n面试问题:\n1. 请描述一次你处理多方利益冲突的经历——当时涉及哪些部门/人员，你如何协调，最终结果如何？\n2. 你之前的工作也有非固定工时要求（早八晚八外勤），能否举例说明如何平衡工作强度与个人生活，这段经历为何结束？\n3. 带教新人时遇到过最难沟通的案例吗？对方抵触什么，你如何调整方式让其融入？\n4. 假设一位月嫂因客户投诉被临时换单，情绪激烈拒绝配合，你会如何电话沟通处理？请现场模拟关键话术。\n5. Excel中需核对50",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你处理多方利益冲突的经历——当时涉及哪些部门/人员，你如何协调，最终结果如何？\n2. 你之前的工作也有非固定工时要求（早八晚八外勤），能否举例说明如何平衡工作强度与个人生活，这段经历为何结束？\n3. 带教新人时遇到过最难沟通的案例吗？对方抵触什么，你如何调整方式让其融入？\n4. 假设一位月嫂因客户投诉被临时换单，情绪激烈拒绝配合，你会如何电话沟通处理？请现场模拟关键话术。\n5. Excel中需核对50名月嫂的工时、奖金、扣款后生成工资表，你会用哪些函数或工具确保零差错？请简述操作步骤。",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：有月度账单审核、成本数据管理经验，但无月嫂/育婴师群体维护经验，薪资发放对象与家政劳动者差异大。\n2. **订单安排能力：1/5分。依据：无任何订单调度、资源匹配相关经验，该能力完全空白。\n3. **基础培训能力：3/5分。依据：有制定新人带教计划、开展系统化培训的实操经验，可迁移至非专业培训场景。\n4. **应急对接能力：2/5分。依据：有协调解决账务差异、流程问题的跨部门协作经验，但无急单对接、售后处理专项经历。\n5. **沟通协作能力：4/5分。依据：主动对接各部门提升协作效率、持续外勤陌拜、客户面对面沟通等经历丰富，性格开朗善于沟通获多段经历验证。",
    "created": ""
  },
  {
    "id": 147,
    "name": "蔡女士",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "无",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "蔡",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "26岁",
    "gender": "女",
    "strengths": "具备电商运营与社群运营经验，熟悉ERP系统操作、订单全流程管理及客户对接，擅长数据整理与售后处理；有从0到1搭建私域流量经验，沟通协调能力经多岗位验证，符合天鹅到家数字化运营需求。",
    "risks": "无家政/母婴行业背景，需跨行业适应；简历时间线存疑（2025.10-2026.03为未来日期），稳定性待核实；26岁接近年龄上限，职业转型动机需确认。",
    "aiEval": "以下为候选人的 商家运营专员 岗位能力评估，AI 生成，仅供参考。\n\n📌 面试岗位：商家运营专员（月休8天）\n🏢 招聘岗位：商家运营专员\n\n初筛结果: 通过\n\n优势分析:\n具备电商运营与社群运营经验，熟悉ERP系统操作、订单全流程管理及客户对接，擅长数据整理与售后处理；有从0到1搭建私域流量经验，沟通协调能力经多岗位验证，符合天鹅到家数字化运营需求。\n\n风险点:\n无家政/母婴行业背景，需跨行业适应；简历时间线存疑（2025.10-2026.03为未来日期），稳定性待核实；26岁接近年龄上限，职业转型动机需确认。\n\n能力维度匹配:\n1. **人员维护能力：1/5分。依据：无月嫂/育婴师服务人员管理经验，无薪资/物料发放实操经历，仅有通用行政考勤记录经验。**\n2. **订单安排能力：2/5分。依据：有电商订单录入、审核、跟踪经验，但属系统操作层面，无服务人员派单、换单、档期协调等复杂调度经验。**\n3. **基础培训能力：0/5分。依据：简历未体现任何培训授课、课程组织或人员带教经历。**\n4. **应急对接能力：2/5分。依据：有社群售后投诉处理、突发状况跟进经验，但属线上客服场景，无家政行业急单对接、现场服务异常处理经验。**\n5. **沟通协作能力：3/5分。依据：多岗位涉及客户对接、跨部门协作（财务/人事/供应商），性格描述外向，但未验证非工作时间响应意愿及深度团队融入案例。**\n\n面试问题:\n1. \"请描述一次你处理客户紧急投诉并协调多方资源解决的具体案例，你当时如何平衡客户情绪与业务规则？\"\n2. \"你曾在社群运营中从0到1搭建用户体系，如果换成家政阿姨群体，你会如何设计维护策略以提升留存率？\"\n3. \"简历中2025-2026年的工作经历时间线需要确认，能否说明你的实际离职时间与求职空窗期安排？\"\n4. \"假设一位月嫂因突发疾病需紧急换单，客户次日就要上户，请简",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"请描述一次你处理客户紧急投诉并协调多方资源解决的具体案例，你当时如何平衡客户情绪与业务规则？\"\n2. \"你曾在社群运营中从0到1搭建用户体系，如果换成家政阿姨群体，你会如何设计维护策略以提升留存率？\"\n3. \"简历中2025-2026年的工作经历时间线需要确认，能否说明你的实际离职时间与求职空窗期安排？\"\n4. \"假设一位月嫂因突发疾病需紧急换单，客户次日就要上户，请简述你的应急处理步骤与资源协调思路。\"\n5. \"请现场演示Excel数据透视表操作：给定一份月嫂考勤与订单匹配表，如何快速筛选出本月可接单人员并计算预估薪资？\"",
    "capabilityMatch": "1. **人员维护能力：1/5分。依据：无月嫂/育婴师服务人员管理经验，无薪资/物料发放实操经历，仅有通用行政考勤记录经验。**\n2. **订单安排能力：2/5分。依据：有电商订单录入、审核、跟踪经验，但属系统操作层面，无服务人员派单、换单、档期协调等复杂调度经验。**\n3. **基础培训能力：0/5分。依据：简历未体现任何培训授课、课程组织或人员带教经历。**\n4. **应急对接能力：2/5分。依据：有社群售后投诉处理、突发状况跟进经验，但属线上客服场景，无家政行业急单对接、现场服务异常处理经验。**\n5. **沟通协作能力：3/5分。依据：多岗位涉及客户对接、跨部门协作（财务/人事/供应商），性格描述外向，但未验证非工作时间响应意愿及深度团队融入案例。**",
    "created": ""
  },
  {
    "id": 148,
    "name": "陈文静",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "陈",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备基础办公技能（Word/Excel）和细心特质，实习经历体现内容审核与流程执行能力，应届生可塑性强，服从安排、上手快的自我评价与岗位基础执行要求有一定契合度。",
    "risks": "核心技能完全错配——岗位需家政服务人员维护与订单管理，简历聚焦新媒体/剪辑/字幕校验；无月嫂/育婴师行业认知，无薪资核算、人员调度、培训组织经验；性别不符（JD明确要求男性）；稳定性存疑（动画专业背景与家政运营职业路径差异大）。",
    "aiEval": "- 初筛结果：淘汰\n\n- 优势分析：具备基础办公技能（Word/Excel）和细心特质，实习经历体现内容审核与流程执行能力，应届生可塑性强，服从安排、上手快的自我评价与岗位基础执行要求有一定契合度。\n\n- 风险点：核心技能完全错配——岗位需家政服务人员维护与订单管理，简历聚焦新媒体/剪辑/字幕校验；无月嫂/育婴师行业认知，无薪资核算、人员调度、培训组织经验；性别不符（JD明确要求男性）；稳定性存疑（动画专业背景与家政运营职业路径差异大）。\n\n- 能力维度匹配：\n  - **人员维护能力：0/5分。依据：无任何薪资发放、物料管理、人员事务处理经验，专业与实习均不涉及。\n  - **订单安排能力：0/5分。依据：无订单调度、换单协调、资源匹配经验，实习内容为静态字幕审核，无动态协调场景。\n  - **基础培训能力：0/5分。依据：无培训组织或授课经历，动画专业与母婴/家政培训内容无关联。\n  - **应急对接能力：1/5分。依据：实习中\"配合团队完成每日批量素材审核\"体现基础配合度，但无售后处理、急单响应经验。\n  - **沟通协作能力：2/5分。依据：自我评价称\"善于沟通、具有团队精神\"，但缺乏具体案例支撑；字幕校验需跨部门配合，可推测基础协作意识。\n\n- 建议追问的面试问题（5个）：\n  - 行为面试问题（3个）：\n    1. 请描述一次你需要同时处理多项任务并确保零失误的经历，当时如何分配优先级？\n    2. 你的实习涉及大量重复性审核工作，如何保持长期专注？若转岗到需要频繁人际沟通的运营岗，如何适应？\n    3. 动画专业与家政运营跨度较大，选择该岗位的核心动机是什么？未来3年职业规划如何？\n  - 技术评估问题（2个）：\n    1. 假设一位月嫂因薪资计算问题情绪激动来电，请模拟一段3分钟内的沟通回应。\n    2. Excel中需统计30位月嫂的月度奖金（含",
    "aiScreen": "已入库（人工确认）",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你需要同时处理多项任务并确保零失误的经历，当时如何分配优先级？\n2. 你的实习涉及大量重复性审核工作，如何保持长期专注？若转岗到需要频繁人际沟通的运营岗，如何适应？\n3. 动画专业与家政运营跨度较大，选择该岗位的核心动机是什么？未来3年职业规划如何？\n4. 假设一位月嫂因薪资计算问题情绪激动来电，请模拟一段3分钟内的沟通回应。\n5. Excel中需统计30位月嫂的月度奖金（含全勤奖、好评奖、转介绍奖三类），你会如何设计表格结构确保快速核算？",
    "capabilityMatch": "1. **人员维护能力：0/5分。依据：无任何薪资发放、物料管理、人员事务处理经验，专业与实习均不涉及。\n2. **订单安排能力：0/5分。依据：无订单调度、换单协调、资源匹配经验，实习内容为静态字幕审核，无动态协调场景。\n3. **基础培训能力：0/5分。依据：无培训组织或授课经历，动画专业与母婴/家政培训内容无关联。\n4. **应急对接能力：1/5分。依据：实习中\"配合团队完成每日批量素材审核\"体现基础配合度，但无售后处理、急单响应经验。\n5. **沟通协作能力：2/5分。依据：自我评价称\"善于沟通、具有团队精神\"，但缺乏具体案例支撑；字幕校验需跨部门配合，可推测基础协作意识。",
    "created": ""
  },
  {
    "id": 149,
    "name": "陈先生",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "陈",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "资产管理经验与人员维护、物资管控高度相关；数据标注经历体现流程优化与质量意识；社团副社长经历证明培训组织与团队管理能力；自我评价强调\"台账维护、跨岗对接、优化流程\"，契合家政服务数字化、标准化需求。",
    "risks": "无家政/母婴行业直接经验，需验证行业知识学习意愿；2025.7-2026.5工作经历为\"未来时间\"，存在简历逻辑矛盾，需核实实际状态；年龄21岁（2004年生）偏年轻，稳定性待考察；男性身份在传统女性主导的家政服务领域需评估客户接受度。",
    "aiEval": "- 初筛结果：通过\n- 优势分析：资产管理经验与人员维护、物资管控高度相关；数据标注经历体现流程优化与质量意识；社团副社长经历证明培训组织与团队管理能力；自我评价强调\"台账维护、跨岗对接、优化流程\"，契合家政服务数字化、标准化需求。\n- 风险点：无家政/母婴行业直接经验，需验证行业知识学习意愿；2025.7-2026.5工作经历为\"未来时间\"，存在简历逻辑矛盾，需核实实际状态；年龄21岁（2004年生）偏年轻，稳定性待考察；男性身份在传统女性主导的家政服务领域需评估客户接受度。\n- 能力维度匹配：\n  - **人员维护能力：4/5分。依据：资产管理岗负责\"仓库资产日常管理、入库出库领用盘点\"，与月嫂工资物料发放同属台账管理与物资发放；自我评价明确\"擅长台账维护、物资管控\"。\n  - **订单安排能力：3/5分。依据：无直接订单调度经验；但数据标注中\"日均处理800张\"体现任务分配与效率管理能力，社团\"带领团队完成多个项目\"显示资源协调能力。\n  - **基础培训能力：4/5分。依据：校园经历明确\"为社区老年人提供基础手机使用培训\"，包含教学方法设计；编写\"错误案例指南助力新成员快速上手\"证明培训材料开发能力。\n  - **应急对接能力：3/5分。依据：资产管理中\"对接楼宇管家，及时响应并协调楼宇内需求\"体现跨部门应急沟通；但无明确售后投诉处理案例。\n  - **沟通协作能力：4/5分。依据：自我评价强调\"良好沟通统筹能力\"；社团经历\"培养了良好的团队合作精神和沟通能力\"；JD要求\"性格开朗善于沟通\"基本匹配，但未明确提及\"非工作时间信息回复\"接受度。\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. 请描述一次你处理紧急需求或突发状况的具体经历，当时如何协调资源、沟通各方并最终解决？（应急对接能力）\n    2. 在社团培训老年人使用手机时，遇到过最困",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你处理紧急需求或突发状况的具体经历，当时如何协调资源、沟通各方并最终解决？（应急对接能力）\n2. 在社团培训老年人使用手机时，遇到过最困难的学员情况是什么？你如何调整方法确保培训效果？（基础培训能力+客户导向）\n3. 你的简历中2025.7-2026.5的工作经历标注为未来时间，能否说明当前实际工作状态及未来1-2年的职业规划？（稳定性核实）\n4. 月嫂服务涉及大量标准化流程（如上户物品清单、服务日志填写），结合你的资产管理经验，设计一个简单的月嫂物料发放台账表格框架，并说明关键字段。（人员维护能力+数字化思维）\n5. 假设一位月嫂因家庭突发状况需要紧急下户，客户订单次日开始，你会如何协调换单？请分步骤说明。（订单安排能力+行业场景模拟）",
    "capabilityMatch": "1. **人员维护能力：4/5分。依据：资产管理岗负责\"仓库资产日常管理、入库出库领用盘点\"，与月嫂工资物料发放同属台账管理与物资发放；自我评价明确\"擅长台账维护、物资管控\"。\n2. **订单安排能力：3/5分。依据：无直接订单调度经验；但数据标注中\"日均处理800张\"体现任务分配与效率管理能力，社团\"带领团队完成多个项目\"显示资源协调能力。\n3. **基础培训能力：4/5分。依据：校园经历明确\"为社区老年人提供基础手机使用培训\"，包含教学方法设计；编写\"错误案例指南助力新成员快速上手\"证明培训材料开发能力。\n4. **应急对接能力：3/5分。依据：资产管理中\"对接楼宇管家，及时响应并协调楼宇内需求\"体现跨部门应急沟通；但无明确售后投诉处理案例。\n5. **沟通协作能力：4/5分。依据：自我评价强调\"良好沟通统筹能力\"；社团经历\"培养了良好的团队合作精神和沟通能力\"；JD要求\"性格开朗善于沟通\"基本匹配，但未明确提及\"非工作时间信息回复\"接受度。",
    "created": ""
  },
  {
    "id": 150,
    "name": "陈亦鸿",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "陈",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备1年运营岗位经验，熟练Excel数据处理与报表输出，有跨部门协调及突发问题响应经验；客服岗位经历体现客户接待、物资台账管理及多模块协同能力；性格描述\"细心稳重、执行力强、抗压能力优秀\"与岗位沟通协作要求部分契合。",
    "risks": "无家政/母婴行业背景，缺乏薪资物料发放、服务人员调度等垂直场景经验；简历时间线存疑（2025.10-2026.03为未来时段），稳定性需验证；未明确提及接受非工作时间信息回复的意愿。",
    "aiEval": "- 初筛结果：存疑\n- 优势分析：具备跨部门沟通协调、数据报表处理及社群运营经验，性格细心稳重、执行力强，符合家政服务标准化运营中对事务跟进与多方对接的要求；有从0到1搭建部门流程及标准化交接机制的经验，与月嫂维护、订单管理的流程化需求契合。\n- 风险点：无家政/母婴行业背景，缺乏薪资物料发放、服务人员调度等垂直场景经验；简历时间线存疑（2025.10-2026.03为未来时段），稳定性需验证；未明确提及接受非工作时间信息回复的意愿。\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：无月嫂/育婴师管理经验，但有社群对接、物资盘点台账及标准化交接流程经验，可迁移至薪资物料发放场景。\n  - **订单安排能力：2/5分。依据：无明确订单调度经验，但有主播/客户社群需求对接、资源协调及突发问题响应经历，逻辑可迁移但行业场景差异大。\n  - **基础培训能力：1/5分。依据：无培训相关经验，仅有新媒体内容产出及活动宣传经历，与面向服务人员的非专业培训场景差距明显。\n  - **应急对接能力：3/5分。依据：有\"快速响应软件bug突发问题，协调资源跟进解决\"及酒店客诉、现场事务处理经验，与急单对接、售后处理高度相关。\n  - **沟通协作能力：4/5分。依据：自我评价明确\"跨部门沟通协调\"\"沟通共情力强\"，经历中多次体现多方对接（客房/保洁/维保、学生/宿管中心），性格描述匹配\"开朗善于沟通\"。\n- 建议追问的面试问题：\n  - 行为面试问题1：请描述一次你需要同时对接多个部门或群体、协调资源解决突发问题的经历，当时各方诉求冲突吗？你如何推动共识？\n  - 行为面试问题2：过往工作中是否有需要在非标准工作时间（如晚间、周末）处理紧急事务的情况？请举例说明你的响应方式和结果。\n  - 行为面试问题3：你简历中杭州云界元创的工作时间为2025.10-2026.03，请确认实",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你需要同时对接多个部门或群体、协调资源解决突发问题的经历，当时各方诉求冲突吗？你如何推动共识？\n2. 过往工作中是否有需要在非标准工作时间（如晚间、周末）处理紧急事务的情况？请举例说明你的响应方式和结果。\n3. 你简历中杭州云界元创的工作时间为2025.10-2026.03，请确认实际入职与离职时间，并说明离开原因及职业规划稳定性。\n4. 假设一位月嫂因突发家庭原因需临时下户，客户订单次日即开始，你会如何快速协调换单并安抚客户情绪？请分步骤说明。\n5. Excel中如需核对50名月嫂的工资、奖金、路费及物料发放明细，你会设计怎样的表格结构或公式来确保零差错？请现场简述思路。",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：无月嫂/育婴师管理经验，但有社群对接、物资盘点台账及标准化交接流程经验，可迁移至薪资物料发放场景。\n2. **订单安排能力：2/5分。依据：无明确订单调度经验，但有主播/客户社群需求对接、资源协调及突发问题响应经历，逻辑可迁移但行业场景差异大。\n3. **基础培训能力：1/5分。依据：无培训相关经验，仅有新媒体内容产出及活动宣传经历，与面向服务人员的非专业培训场景差距明显。\n4. **应急对接能力：3/5分。依据：有\"快速响应软件bug突发问题，协调资源跟进解决\"及酒店客诉、现场事务处理经验，与急单对接、售后处理高度相关。\n5. **沟通协作能力：4/5分。依据：自我评价明确\"跨部门沟通协调\"\"沟通共情力强\"，经历中多次体现多方对接（客房/保洁/维保、学生/宿管中心），性格描述匹配\"开朗善于沟通\"。",
    "created": ""
  },
  {
    "id": 151,
    "name": "程建凯",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "程",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备私域客户分层维护、线索转化及达人商务对接经验，沟通协调能力突出；熟练使用Excel/PPT进行数据复盘，契合数字化运营需求；抗压能力强，能接受非工作时间响应。",
    "risks": "无家政/母婴行业背景，人员维护、订单调度等核心技能零经验；2026届应届生身份与岗位稳定性要求存冲突；简历中\"2025.06-2026.06\"工作经历时间逻辑存疑（尚未毕业）。",
    "aiEval": "- 初筛结果：存疑\n- 优势分析：具备私域客户分层维护、线索转化及达人商务对接经验，沟通协调能力突出；熟练使用Excel/PPT进行数据复盘，契合数字化运营需求；抗压能力强，能接受非工作时间响应。\n- 风险点：无家政/母婴行业背景，人员维护、订单调度等核心技能零经验；2026届应届生身份与岗位稳定性要求存冲突；简历中\"2025.06-2026.06\"工作经历时间逻辑存疑（尚未毕业）。\n- 能力维度匹配：\n  - **人员维护能力：1/5分。依据：仅有客户档案整理、回访复购经验，无薪资核算、物料发放、一线服务人员（如月嫂）日常管理经历。\n  - **订单安排能力：1/5分。依据：无订单调度、资源匹配、换单协调等实操经验，过往工作不涉及服务者-订单动态匹配场景。\n  - **基础培训能力：2/5分。依据：有短视频脚本策划、内容审核经验，具备基础课程设计意识，但无面向服务人员（月嫂/育婴师）的现场培训经历。\n  - **应急对接能力：2/5分。依据：有评论区舆情维护、客户答疑经验，具备基础售后响应意识，但未涉及急单对接、多方协调等高压场景。\n  - **沟通协作能力：4/5分。依据：电话销售+达人PR双线经验验证强沟通能力；自我评价明确\"性格开朗善于沟通\"；接受非工作时间信息回复。\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. 请描述一次你需要同时维护多位客户/合作方关系，并通过持续跟进促成长期合作的案例——具体如何分层管理、优先级排序？\n    2. 过往工作中是否遇到过客户/达人临时毁约或突发投诉？当时如何协调资源、安抚情绪并推动问题解决？\n    3. 作为2026届应届生，目前学业与求职并行，若入职后需立即投入高强度、非标准工时的工作，你如何保障稳定性与投入度？\n  - 技术评估问题（2个）：\n    1. 假设一位月嫂因家庭急事需临时下户，客户",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你需要同时维护多位客户/合作方关系，并通过持续跟进促成长期合作的案例——具体如何分层管理、优先级排序？\n2. 过往工作中是否遇到过客户/达人临时毁约或突发投诉？当时如何协调资源、安抚情绪并推动问题解决？\n3. 作为2026届应届生，目前学业与求职并行，若入职后需立即投入高强度、非标准工时的工作，你如何保障稳定性与投入度？\n4. 假设一位月嫂因家庭急事需临时下户，客户次日即需服务，你会如何快速协调备选资源、沟通客户并控制舆情风险？\n5. 请用Excel设计一张月嫂月度薪资核算表，需包含基础工资、订单奖金、路费补贴、扣款项，并说明如何校验数据准确性。",
    "capabilityMatch": "1. **人员维护能力：1/5分。依据：仅有客户档案整理、回访复购经验，无薪资核算、物料发放、一线服务人员（如月嫂）日常管理经历。\n2. **订单安排能力：1/5分。依据：无订单调度、资源匹配、换单协调等实操经验，过往工作不涉及服务者-订单动态匹配场景。\n3. **基础培训能力：2/5分。依据：有短视频脚本策划、内容审核经验，具备基础课程设计意识，但无面向服务人员（月嫂/育婴师）的现场培训经历。\n4. **应急对接能力：2/5分。依据：有评论区舆情维护、客户答疑经验，具备基础售后响应意识，但未涉及急单对接、多方协调等高压场景。\n5. **沟通协作能力：4/5分。依据：电话销售+达人PR双线经验验证强沟通能力；自我评价明确\"性格开朗善于沟通\"；接受非工作时间信息回复。",
    "created": ""
  },
  {
    "id": 152,
    "name": "程锦",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "程",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备电商运营助理实习经验，熟悉渠道对接、订单跟进与客户维护；海底捞兼职经历体现高强度服务场景下的沟通协作与应急处理能力；性格开朗、抗压能力强，符合家政服务非工作时间响应要求。",
    "risks": "无家政/母婴行业背景，月嫂育婴师专业知识为零；2026年6月才毕业，当前为校招实习身份，全职稳定性存疑；男性身份与月嫂群体日常管理存在潜在信任建立障碍。",
    "aiEval": "- 初筛结果：通过\n- 优势分析：具备电商运营助理实习经验，熟悉渠道对接、订单跟进与客户维护；海底捞兼职经历体现高强度服务场景下的沟通协作与应急处理能力；性格开朗、抗压能力强，符合家政服务非工作时间响应要求。\n- 风险点：无家政/母婴行业背景，月嫂育婴师专业知识为零；2026年6月才毕业，当前为校招实习身份，全职稳定性存疑；男性身份与月嫂群体日常管理存在潜在信任建立障碍。\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：仅有渠道客户答疑经验，无薪资核算、物料发放等实操经历，需从零学习。\n  - **订单安排能力：3/5分。依据：电商实习中涉及订单跟进与后台配货，逻辑可迁移，但缺乏服务人员调度与换单场景经验。\n  - **基础培训能力：1/5分。依据：无任何培训授课或课程组织经历，手语协会仅参与组织而非主讲。\n  - **应急对接能力：3/5分。依据：瑞幸\"先重做后报损\"客诉处理、海底捞前台需求响应，体现服务场景应急意识。\n  - **沟通协作能力：4/5分。依据：多段服务岗位验证\"性格开朗善于沟通\"，自我评价强调团队合作与抗压，匹配度高。\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. 请描述一次你同时处理多个客户紧急需求并协调资源解决的经历，具体你做了什么？\n    2. 当你的工作安排需要在非工作时间响应信息时，你如何平衡个人生活与工作？能否举例？\n    3. 你作为男性，若需要管理以女性为主的月嫂群体并处理其私人事务（如薪资纠纷、情绪安抚），你会如何快速建立信任？\n  - 技术评估问题（2个）：\n    1. 假设一位月嫂因突发疾病需紧急换单，但备选人员不足，你会如何协调顾问、客户与月嫂三方？\n    2. 请用Excel模拟设计一个月嫂薪资发放表，需包含基础工资、奖金、路费扣减项，简述你的设计逻辑。\n  - 互动引导语：今天的",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"请描述一次你需要同时处理多个紧急客户需求，并通过协调资源解决冲突的经历。\"\n2. \"在瑞幸或海底捞遇到最棘手的客诉是什么？你如何安抚客户并推动解决？\"\n3. \"你的实习和兼职经历显示较多服务岗位轮换，选择天鹅到家商家运营作为职业起点，核心吸引点是什么？未来2-3年规划如何？\"\n4. \"如果一位月嫂因突发疾病无法上户，距离服务开始仅剩6小时，你会按什么步骤协调换单？\"\n5. \"请用Excel或口述方式，说明如何设计一张月嫂工资核算表，需包含哪些字段及校验逻辑？\"",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：仅有渠道客户答疑经验，无薪资核算、物料发放等实操经历，需从零学习。\n2. **订单安排能力：3/5分。依据：电商实习中涉及订单跟进与后台配货，逻辑可迁移，但缺乏服务人员调度与换单场景经验。\n3. **基础培训能力：1/5分。依据：无任何培训授课或课程组织经历，手语协会仅参与组织而非主讲。\n4. **应急对接能力：3/5分。依据：瑞幸\"先重做后报损\"客诉处理、海底捞前台需求响应，体现服务场景应急意识。\n5. **沟通协作能力：4/5分。依据：多段服务岗位验证\"性格开朗善于沟通\"，自我评价强调团队合作与抗压，匹配度高。",
    "created": ""
  },
  {
    "id": 153,
    "name": "杜思梦",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "杜",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备商户运营、审核及客服经验，有基础沟通与协调能力；自我评价强调沟通表达、学习能力及团队协作，与岗位沟通协作要求部分契合；熟练使用办公软件，符合基础工具要求。",
    "risks": "硬性条件不符（女性，JD明确要求男性）；无家政/母婴行业背景，缺乏月嫂育婴师服务场景认知；商户运营经验侧重B端拓展，与C端家政人员维护差异大；简历时间线混乱（2024-2026年份存疑），稳定性存疑。",
    "aiEval": "- 初筛结果：淘汰\n\n- 优势分析：具备商户运营、审核及客服经验，有基础沟通与协调能力；自我评价强调沟通表达、学习能力及团队协作，与岗位沟通协作要求部分契合；熟练使用办公软件，符合基础工具要求。\n\n- 风险点：硬性条件不符（女性，JD明确要求男性）；无家政/母婴行业背景，缺乏月嫂育婴师服务场景认知；商户运营经验侧重B端拓展，与C端家政人员维护差异大；简历时间线混乱（2024-2026年份存疑），稳定性存疑。\n\n- 能力维度匹配：\n  - **人员维护能力：1/5分。依据：无家政人员管理经验，仅有商户资质审核与客服答疑经历，未涉及薪资物料发放等实务操作。**\n  - **订单安排能力：1/5分。依据：无订单调度或人员排班经验，商户入驻审核与家政服务订单匹配逻辑差异显著。**\n  - **基础培训能力：0/5分。依据：简历未体现任何培训授课或带教经历，无相关能力证据。**\n  - **应急对接能力：2/5分。依据：有售前客服答疑及售后问题处理经验，但属电商场景，非家政急单或母婴服务售后。**\n  - **沟通协作能力：3/5分。依据：多段经历涉及商户/客户沟通，自我评价强调沟通调整能力，但未验证非工作时间响应意愿。**\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. 请描述一次你需要在非工作时间处理紧急事务的经历，当时如何平衡个人安排与工作需求？\n    2. 请举例说明你如何向一位对服务不满意的客户解释规则并达成和解，具体采取了哪些沟通策略？\n    3. 你的简历中多段经历时间较短，请说明离职原因及对未来2-3年职业稳定性的规划。\n  - 技术评估问题（2个）：\n    1. 假设一位月嫂因突发疾病无法上户，客户次日需用人，你会如何快速协调替换人员并安抚客户？\n    2. 请简述你认为月嫂薪资结构应包含哪些组成部分，发放时需注意哪些合规风险？\n ",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你需要在非工作时间处理紧急事务的经历，当时如何平衡个人安排与工作需求？\n2. 请举例说明你如何向一位对服务不满意的客户解释规则并达成和解，具体采取了哪些沟通策略？\n3. 你的简历中多段经历时间较短，请说明离职原因及对未来2-3年职业稳定性的规划。\n4. 假设一位月嫂因突发疾病无法上户，客户次日需用人，你会如何快速协调替换人员并安抚客户？\n5. 请简述你认为月嫂薪资结构应包含哪些组成部分，发放时需注意哪些合规风险？",
    "capabilityMatch": "1. **人员维护能力：1/5分。依据：无家政人员管理经验，仅有商户资质审核与客服答疑经历，未涉及薪资物料发放等实务操作。**\n2. **订单安排能力：1/5分。依据：无订单调度或人员排班经验，商户入驻审核与家政服务订单匹配逻辑差异显著。**\n3. **基础培训能力：0/5分。依据：简历未体现任何培训授课或带教经历，无相关能力证据。**\n4. **应急对接能力：2/5分。依据：有售前客服答疑及售后问题处理经验，但属电商场景，非家政急单或母婴服务售后。**\n5. **沟通协作能力：3/5分。依据：多段经历涉及商户/客户沟通，自我评价强调沟通调整能力，但未验证非工作时间响应意愿。**",
    "created": ""
  },
  {
    "id": 154,
    "name": "冯丹炫",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "冯",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备4年互联网大厂商家运营经验，精通全链路运营、跨团队协同及数据化分析，擅长SOP标准化建设与外包团队管理，与天鹅到家\"家政服务标准化、数字化\"战略高度契合；有供应链库存管控、商家培训手册编制经验，可迁移至月嫂/育婴师人员维护与培训体系搭建。",
    "risks": "简历未体现家政/母婴行业背景，存在行业认知缺口；过往经历聚焦线上商家运营，线下服务人员（月嫂/育婴师）直接管理经验不足；28岁年龄上限边缘，需关注职业稳定性与基层岗位心态适配；无薪资核算、物料发放等具体财务操作经验。",
    "aiEval": "- 初筛结果：通过\n\n- 优势分析：具备4年互联网大厂商家运营经验，精通全链路运营、跨团队协同及数据化分析，擅长SOP标准化建设与外包团队管理，与天鹅到家\"家政服务标准化、数字化\"战略高度契合；有供应链库存管控、商家培训手册编制经验，可迁移至月嫂/育婴师人员维护与培训体系搭建。\n\n- 风险点：简历未体现家政/母婴行业背景，存在行业认知缺口；过往经历聚焦线上商家运营，线下服务人员（月嫂/育婴师）直接管理经验不足；28岁年龄上限边缘，需关注职业稳定性与基层岗位心态适配；无薪资核算、物料发放等具体财务操作经验。\n\n- 能力维度匹配：\n  - **人员维护能力：3/5分。依据：有供应商管理、外包团队统筹经验，但无直接服务人员薪资/物料发放经历，需验证财务操作细心度与线下人员关怀能力。\n  - **订单安排能力：3/5分。依据：擅长商品排期、库存调配与资源优化，逻辑性强，但月嫂/育婴师订单涉及人身服务匹配，与实物商品调度差异大，需评估场景迁移能力。\n  - **基础培训能力：4/5分。依据：编制过新商家SOP培训手册并开展月度规范化培训，覆盖20+商家，具备标准化课程开发与执行经验，可快速适配非专业培训场景。\n  - **应急对接能力：4/5分。依据：多次牵头跨部门拉回会议处理技术问题，协同客服/法务/风控处理售后，有急单响应与多方协调实战经验，云管家售后处理可快速上手。\n  - **沟通协作能力：4/5分。依据：简历明确\"性格开朗善于沟通\"，长期对接商家/供应商/设计/技术等多方，接受非工作时间信息回复在电商运营中已成常态，文化适配度高。\n\n- 建议追问的面试问题：\n  - 行为面试问题1：请描述一次你处理商家/供应商紧急投诉或突发危机的经历，当时涉及哪些部门？你如何推动问题在24小时内闭环？\n  - 行为面试问题2：你曾带领外包团队完成审核任务，当团队成员连续出现失误影响SLA时",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你处理商家/供应商紧急投诉或突发危机的经历，当时涉及哪些部门？你如何推动问题在24小时内闭环？\n2. 你曾带领外包团队完成审核任务，当团队成员连续出现失误影响SLA时，你如何进行绩效沟通与辅导？请举例。\n3. 从蚂蚁/饿了么离职的原因是什么？选择天鹅到家这个相对传统的家政行业，你的职业规划是什么？如何看待从\"商家运营\"到\"服务人员运营\"的角色转变？\n4. 假设一位月嫂因突发疾病无法上户，客户明日即需服务，你会如何快速协调备用人员并安抚客户？请分步骤说明。\n5. 月嫂工资结构包含底薪+绩效+路费补贴，若系统计算出错导致多发500元，你发现后如何处理？如何与月嫂沟通追回？",
    "capabilityMatch": "1. **人员维护能力：3/5分。依据：有供应商管理、外包团队统筹经验，但无直接服务人员薪资/物料发放经历，需验证财务操作细心度与线下人员关怀能力。\n2. **订单安排能力：3/5分。依据：擅长商品排期、库存调配与资源优化，逻辑性强，但月嫂/育婴师订单涉及人身服务匹配，与实物商品调度差异大，需评估场景迁移能力。\n3. **基础培训能力：4/5分。依据：编制过新商家SOP培训手册并开展月度规范化培训，覆盖20+商家，具备标准化课程开发与执行经验，可快速适配非专业培训场景。\n4. **应急对接能力：4/5分。依据：多次牵头跨部门拉回会议处理技术问题，协同客服/法务/风控处理售后，有急单响应与多方协调实战经验，云管家售后处理可快速上手。\n5. **沟通协作能力：4/5分。依据：简历明确\"性格开朗善于沟通\"，长期对接商家/供应商/设计/技术等多方，接受非工作时间信息回复在电商运营中已成常态，文化适配度高。",
    "created": ""
  },
  {
    "id": 155,
    "name": "冯伟",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "冯",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "6年互联网B端产品运营经验，擅长用户分层、需求挖掘、跨部门协同及数据监控，具备较强的流程标准化与数字化运营思维，可迁移至家政服务人员的系统化管理与培训体系搭建。",
    "risks": "零家政/母婴行业背景，无线下服务人员（月嫂/育婴师）直接管理经验；过往工作聚焦SaaS数据产品，与岗位要求的\"工资物料发放、订单调度、应急售后\"等实操事务差异较大；27岁男性，与岗位隐含的性别偏好及\"21-28岁\"上限临界，稳定性待验证。",
    "aiEval": "- 初筛结果：存疑\n\n- 优势分析：6年互联网B端产品运营经验，擅长用户分层、需求挖掘、跨部门协同及数据监控，具备较强的流程标准化与数字化运营思维，可迁移至家政服务人员的系统化管理与培训体系搭建。\n\n- 风险点：零家政/母婴行业背景，无线下服务人员（月嫂/育婴师）直接管理经验；过往工作聚焦SaaS数据产品，与岗位要求的\"工资物料发放、订单调度、应急售后\"等实操事务差异较大；27岁男性，与岗位隐含的性别偏好及\"21-28岁\"上限临界，稳定性待验证。\n\n- 能力维度匹配：\n  - **人员维护能力：1/5分。依据：简历无薪酬核算、物料发放、一线服务人员日常管理经验，仅涉及数据产品的用户分层与活跃度运营，场景差异显著。**\n  - **订单安排能力：1/5分。依据：无订单调度、资源匹配、换单协调等实操经历，仅有抽象的\"需求排期规划\"经验，未涉及人力服务行业的动态匹配场景。**\n  - **基础培训能力：2/5分。依据：具备产品SOP制作、FAQ沉淀、使用视频录制经验，但均为数字化产品培训，未涉及线下人员的行为培训与技能带教。**\n  - **应急对接能力：2/5分。依据：有产品故障响应、工单处理、双周复盘经验，但属于技术售后范畴；无急单对接、客户投诉处理等高压服务场景的直接经历。**\n  - **沟通协作能力：3/5分。依据：多次提及跨团队协同、行业小二沟通、服务商合作，具备基础沟通与协作意识；但缺乏\"非工作时间响应\"的明确证据，且过往对接对象多为B端客户而非一线服务人员。**\n\n- 建议追问的面试问题：\n  - 行为面试问题1：\"请描述一次你需要在深夜或周末紧急响应并解决突发问题的经历，当时如何平衡个人时间与工作优先级？\"\n  - 行为面试问题2：\"过往工作中是否直接管理过外包人员或一线服务人员？请举例说明如何处理其薪资争议或突发离职导致的业务中断。\"\n  - 行为面试问题3：",
    "aiScreen": "存疑",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你需要在深夜或周末紧急响应并解决突发问题的经历，当时如何平衡个人时间与工作优先级？\n2. 过往工作中是否直接管理过外包人员或一线服务人员？请举例说明如何处理其薪资争议或突发离职导致的业务中断。\n3. 你曾通过服务商渠道完成2600万业绩，当时遇到最大的合作冲突是什么？如何解决的？\n4. 假设一位月嫂因突发疾病需临时下户，客户次日即需用人，你会如何协调资源确保服务不中断？请分步骤说明。\n5. 月嫂群体普遍年龄偏大、数字化程度低，若需推行线上考勤系统，你会如何设计培训方案降低抵触情绪？\n6. 今天的交流到此，我想把最后的时间交给你。关于天鹅到家的业务模式、这个岗位的日常挑战，或者你未来可能对接的团队，有没有什么是你希望更深入了解的？我们也非常看重候选人的主动思考，请随意提问。",
    "capabilityMatch": "1. **人员维护能力：1/5分。依据：简历无薪酬核算、物料发放、一线服务人员日常管理经验，仅涉及数据产品的用户分层与活跃度运营，场景差异显著。**\n2. **订单安排能力：1/5分。依据：无订单调度、资源匹配、换单协调等实操经历，仅有抽象的\"需求排期规划\"经验，未涉及人力服务行业的动态匹配场景。**\n3. **基础培训能力：2/5分。依据：具备产品SOP制作、FAQ沉淀、使用视频录制经验，但均为数字化产品培训，未涉及线下人员的行为培训与技能带教。**\n4. **应急对接能力：2/5分。依据：有产品故障响应、工单处理、双周复盘经验，但属于技术售后范畴；无急单对接、客户投诉处理等高压服务场景的直接经历。**\n5. **沟通协作能力：3/5分。依据：多次提及跨团队协同、行业小二沟通、服务商合作，具备基础沟通与协作意识；但缺乏\"非工作时间响应\"的明确证据，且过往对接对象多为B端客户而非一线服务人员。**",
    "created": ""
  },
  {
    "id": 156,
    "name": "付彤",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "付",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备强沟通协调能力与多客户管理经验，社群运营中建立长期信任关系、提升续约率的经历与月嫂维护场景高度契合；数字化工具熟练度高，适配云管家等系统操作；网感与热点捕捉能力可辅助培训内容设计。",
    "risks": "零家政/母婴行业背景，人员维护、订单安排等核心场景无直接经验；实习经历均为新媒体/互联网运营，与线下服务者管理逻辑差异大；应届生稳定性存疑，且未明确接受非工作时间回复的意愿。",
    "aiEval": "- 初筛结果：存疑\n\n- 优势分析：具备强沟通协调能力与多客户管理经验，社群运营中建立长期信任关系、提升续约率的经历与月嫂维护场景高度契合；数字化工具熟练度高，适配云管家等系统操作；网感与热点捕捉能力可辅助培训内容设计。\n\n- 风险点：零家政/母婴行业背景，人员维护、订单安排等核心场景无直接经验；实习经历均为新媒体/互联网运营，与线下服务者管理逻辑差异大；应届生稳定性存疑，且未明确接受非工作时间回复的意愿。\n\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：无薪资发放、物料管理等经验，但社群运营中客户分层维护、满意度管理有迁移潜力，需验证线下服务者管理适配性。\n  - **订单安排能力：1/5分。依据：简历无排班、资源调度、换单协调等经历，数字媒体专业与订单系统操作关联弱。\n  - **基础培训能力：3/5分。依据：具备话术辅导、内容创作及热点包装经验，可支撑非专业培训素材开发，但缺面对面授课与家政场景转化经验。\n  - **应急对接能力：2/5分。依据：社群运营中处理客户投诉、优化建议有初步经验，但急单高压场景与售后纠纷处理无直接验证。\n  - **沟通协作能力：4/5分。依据：自我评价与实习经历多次强调\"建立长期信任\"\"高频沟通\"\"团队融入\"，客户满意度95%为强佐证。\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. \"社群运营中遇到客户投诉投放效果差、要求退款的情况，你如何沟通处理？结果如何？\"（验证售后应急与冲突化解）\n    2. \"描述一次同时服务多家4S店、资源冲突时优先排序的经历，具体如何协调？\"（验证多任务调度与订单安排迁移潜力）\n    3. \"实习中是否有服务周期超过3个月的客户？如何维持关系？若客户突然终止合作，你的应对是？\"（验证稳定性与长期维护意识）\n  - 技术评估问题（2个）：\n    1. \"假设月嫂",
    "aiScreen": "存疑",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"社群运营中遇到客户投诉投放效果差、要求退款的情况，你如何沟通处理？结果如何？\"\n2. \"描述一次同时服务多家4S店、资源冲突时优先排序的经历，具体如何协调？\"\n3. \"实习中是否有服务周期超过3个月的客户？如何维持关系？若客户突然终止合作，你的应对是？\"\n4. \"假设月嫂因家中急事需临时下户，客户预产期临近拒绝换员，你会如何与双方沟通并制定方案？\"\n5. \"请用Excel设计一张简单的月嫂工资计算表，需包含基本工资、奖金扣减、路费补贴字段，口述逻辑。\"",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：无薪资发放、物料管理等经验，但社群运营中客户分层维护、满意度管理有迁移潜力，需验证线下服务者管理适配性。\n2. **订单安排能力：1/5分。依据：简历无排班、资源调度、换单协调等经历，数字媒体专业与订单系统操作关联弱。\n3. **基础培训能力：3/5分。依据：具备话术辅导、内容创作及热点包装经验，可支撑非专业培训素材开发，但缺面对面授课与家政场景转化经验。\n4. **应急对接能力：2/5分。依据：社群运营中处理客户投诉、优化建议有初步经验，但急单高压场景与售后纠纷处理无直接验证。\n5. **沟通协作能力：4/5分。依据：自我评价与实习经历多次强调\"建立长期信任\"\"高频沟通\"\"团队融入\"，客户满意度95%为强佐证。",
    "created": ""
  },
  {
    "id": 157,
    "name": "高笑杰",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "高",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备淘宝店铺全链路运营经验，熟悉订单管理、客户咨询转化、数据复盘等标准化流程，Excel与PS技能扎实；有担任组长协调分工经历，基础沟通协作意识具备；接受非工作时间信息回复的意愿需面试确认。",
    "risks": "无家政/母婴行业背景，需从零学习月嫂育婴师服务特性；简历未体现非工作时间响应经历，接受度存疑；26年应届生，职业稳定性与抗压能力待验证。",
    "aiEval": "- 初筛结果：存疑\n- 优势分析：具备淘宝店铺全链路运营经验，熟悉订单管理、客户咨询转化、数据复盘等标准化流程，Excel与PS技能扎实；有担任组长协调分工经历，基础沟通协作意识具备；接受非工作时间信息回复的意愿需面试确认。\n- 风险点：无家政/月嫂行业经验，人员维护、基础培训等核心能力为零经验；简历未体现\"性格开朗、善于沟通\"特质，需重点考察；26年应届生，稳定性存疑，且职业路径从电商转家政服务，动机需深挖。\n- 能力维度匹配：\n  - **人员维护能力：1/5分。依据：仅有淘宝订单物流管理经验，无人员薪资发放、物料管理或家政劳动者维护经验，行业场景差异大。**\n  - **订单安排能力：2/5分。依据：有电商订单处理、发货跟进经验，但\"换单\"逻辑与家政服务派单、人员调度完全不同，需从零学习。**\n  - **基础培训能力：0/5分。依据：简历无任何培训、带教、知识传递相关经历，该维度完全空白。**\n  - **应急对接能力：2/5分。依据：有售前咨询、售后履约处理经验，但电商售后与家政急单、云管家售后场景差异显著，抗压性待验证。**\n  - **沟通协作能力：3/5分。依据：担任组长组织分工、独立完成客户咨询转化，具备基础沟通协调意识；但\"性格开朗\"特质无文本证据，非工作时间响应意愿未明确。**\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. \"请描述一次你作为组长协调组员分工时，遇到有人不配合的具体情况，你是如何处理的？最终结果如何？\"\n    2. \"在淘宝店铺运营中，遇到过客户紧急投诉或订单突发问题的场景吗？当时你的响应时间和处理步骤是什么？\"\n    3. \"你的职业规划显示从电商转向家政服务，这个转变的核心动机是什么？如何看待家政行业'非工作时间信息回复'的工作特性？\"\n  - 技术评估问题（2个）：\n    1. \"假设一位月嫂因家庭",
    "aiScreen": "存疑",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"请描述一次你作为组长协调组员分工时，遇到有人不配合的具体情况，你是如何处理的？最终结果如何？\"\n2. \"在淘宝店铺运营中，遇到过客户紧急投诉或订单突发问题的场景吗？当时你的响应时间和处理步骤是什么？\"\n3. \"你的职业规划显示从电商转向家政服务，这个转变的核心动机是什么？如何看待家政行业'非工作时间信息回复'的工作特性？\"\n4. \"假设一位月嫂因家庭突发状况需要临时换单，原订单3天后上户，你会如何快速协调备选人员并安抚客户？请分步骤说明。\"\n5. \"请现场用Excel设计一个月嫂工资核算表框架，需包含基础工资、奖金、路费扣减项，并说明如何确保发放零差错。\"",
    "capabilityMatch": "1. **人员维护能力：1/5分。依据：仅有淘宝订单物流管理经验，无人员薪资发放、物料管理或家政劳动者维护经验，行业场景差异大。**\n2. **订单安排能力：2/5分。依据：有电商订单处理、发货跟进经验，但\"换单\"逻辑与家政服务派单、人员调度完全不同，需从零学习。**\n3. **基础培训能力：0/5分。依据：简历无任何培训、带教、知识传递相关经历，该维度完全空白。**\n4. **应急对接能力：2/5分。依据：有售前咨询、售后履约处理经验，但电商售后与家政急单、云管家售后场景差异显著，抗压性待验证。**\n5. **沟通协作能力：3/5分。依据：担任组长组织分工、独立完成客户咨询转化，具备基础沟通协调意识；但\"性格开朗\"特质无文本证据，非工作时间响应意愿未明确。**",
    "created": ""
  },
  {
    "id": 158,
    "name": "耿先生",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "耿",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "物流行业背景具备人员调度、薪资核算、异常处理经验；Excel数据化运营能力与天鹅到家数字化管理契合；退役军人抗压性强，能适应非工作时间响应；半年晋升经历体现学习力与执行力。",
    "risks": "风险点：行业跨度大（矿业/物流→家政服务），无母婴/家政领域经验；27岁超年龄上限28岁为误读，实际符合21-28岁，但性别为男与JD隐含偏好存疑；5年物流深耕后转家政，职业稳定性与动机存疑；无培训授课经验，基础培训能力缺口明显。",
    "aiEval": "- 初筛结果：淘汰\n\n- 优势分析：物流行业背景具备人员调度、薪资核算、异常处理经验；Excel数据化运营能力与天鹅到家数字化管理契合；退役军人抗压性强，能适应非工作时间响应；半年晋升经历体现学习力与执行力。\n\n- 风险点：行业跨度大（矿业/物流→家政服务），无母婴/家政领域经验；27岁超年龄上限28岁为误读，实际符合21-28岁，但性别为男与JD隐含偏好存疑；5年物流深耕后转家政，职业稳定性与动机存疑；无培训授课经验，基础培训能力缺口明显。\n\n- 能力维度匹配：\n  - **人员维护能力：3/5分。依据：有司机薪资结算、20人团队管理经验，熟悉工资发放与台账管理，但无女性服务人员维护经验，家政场景差异大。\n  - **订单安排能力：4/5分。依据：日均调度150+票货物、统筹20+台车辆、处理换单/急件经验丰富，调度逻辑可迁移，但家政\"人找人\"匹配复杂度更高。\n  - **基础培训能力：1/5分。依据：简历无培训授课经历，仅提及流程标准化建设（SOP），未涉及人员技能辅导，家政非专业培训（如服务礼仪）经验空白。\n  - **应急对接能力：4/5分。依据：多次处理司机纠纷、客户投诉、突发事故，建立异常处理SOP，售后理赔机制，高压场景冷静应对能力强。\n  - **沟通协作能力：3/5分。依据：多方协同经验足（司机/仓库/生产/客户），但物流B端沟通与家政C端情感服务差异显著，\"性格开朗\"仅为自我评价未验证。\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. \"请描述一次你处理客户激烈投诉的经历，当时采取了哪些步骤安抚情绪并解决问题？\"\n    2. \"物流行业与家政服务行业差异较大，是什么吸引你申请这个岗位？未来3年职业规划是什么？\"\n    3. \"请举例说明你如何管理情绪不稳定的合作方（如司机/客户），确保业务正常运转？\"\n  - 技术评估问题（",
    "aiScreen": "淘汰",
    "hrReview": "淘汰",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"请描述一次你处理客户激烈投诉的经历，当时采取了哪些步骤安抚情绪并解决问题？\"\n2. \"物流行业与家政服务行业差异较大，是什么吸引你申请这个岗位？未来3年职业规划是什么？\"\n3. \"请举例说明你如何管理情绪不稳定的合作方（如司机/客户），确保业务正常运转？\"\n4. \"假设一位月嫂因家庭突发情况需临时下户，客户预产期在3天后，你会如何协调换单并安抚客户？\"\n5. \"请现场设计一个Excel台账模板，用于跟踪50位月嫂的工资、路费、物料发放状态，并说明关键字段设计逻辑。\"",
    "capabilityMatch": "1. **人员维护能力：3/5分。依据：有司机薪资结算、20人团队管理经验，熟悉工资发放与台账管理，但无女性服务人员维护经验，家政场景差异大。\n2. **订单安排能力：4/5分。依据：日均调度150+票货物、统筹20+台车辆、处理换单/急件经验丰富，调度逻辑可迁移，但家政\"人找人\"匹配复杂度更高。\n3. **基础培训能力：1/5分。依据：简历无培训授课经历，仅提及流程标准化建设（SOP），未涉及人员技能辅导，家政非专业培训（如服务礼仪）经验空白。\n4. **应急对接能力：4/5分。依据：多次处理司机纠纷、客户投诉、突发事故，建立异常处理SOP，售后理赔机制，高压场景冷静应对能力强。\n5. **沟通协作能力：3/5分。依据：多方协同经验足（司机/仓库/生产/客户），但物流B端沟通与家政C端情感服务差异显著，\"性格开朗\"仅为自我评价未验证。",
    "created": ""
  },
  {
    "id": 159,
    "name": "谷明月",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "谷",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备2年电商运营经验，熟悉平台规则与商家维护，有跨部门协作及客户服务经验；自我评价强调责任心、执行力与沟通协调能力，与岗位所需的沟通协作、人员维护有潜在契合点；稳定性自述较好，能接受从零开始。",
    "risks": "无家政/母婴行业背景，缺乏月嫂、育婴师等垂直领域认知；简历未体现薪资核算、物料发放、人员调度等具体经验；年龄28岁接近上限，且为男性，与岗位隐含的性别偏好（服务女性从业者）存在文化匹配风险；未明确接受非工作时间信息回复。",
    "aiEval": "- 初筛结果：存疑\n\n- 优势分析：具备2年电商运营经验，熟悉平台规则与商家维护，有跨部门协作及客户服务经验；自我评价强调责任心、执行力与沟通协调能力，与岗位所需的沟通协作、人员维护有潜在契合点；稳定性自述较好，能接受从零开始。\n\n- 风险点：无家政/母婴行业背景，缺乏月嫂、育婴师等垂直领域认知；简历未体现薪资核算、物料发放、人员调度等具体经验；年龄28岁接近上限，且为男性，与岗位隐含的性别偏好（服务女性从业者）存在文化匹配风险；未明确接受非工作时间信息回复。\n\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：有商家/达人对接经验，但无薪资核算、物料发放、人员档案管理等具体行为，家政服务人员维护场景差异较大。\n  - **订单安排能力：2/5分。依据：熟悉电商订单流转与库存管理，但无月嫂/育婴师排班、换单、人岗匹配经验，服务标准化程度不同。\n  - **基础培训能力：1/5分。依据：简历未体现任何培训授课、课程组织、人员带教经验，技能缺口明显。\n  - **应急对接能力：3/5分。依据：有售后问题处理、异常协调及直播跟播等高压场景经验，具备基础应急响应意识。\n  - **沟通协作能力：4/5分。依据：多次强调跨部门协作、客户对接、达人沟通，自我评价突出性格开朗、执行力强，匹配度高。\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. \"请描述一次你需要在深夜或周末紧急处理商家/客户突发问题的经历，当时如何协调资源解决的？\"\n    2. \"你曾对接过门店或达人，如果合作方对薪资结算或物料发放有强烈异议，你如何沟通平息并推进执行？\"\n    3. \"过去两份工作平均在职时长约9-10个月，若加入天鹅到家，你计划如何快速适应并长期稳定发展？\"\n  - 技术评估问题（2个）：\n    1. \"月嫂服务涉及26天/42天等灵活周期，若客户临时要求",
    "aiScreen": "存疑",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"请描述一次你需要在深夜或周末紧急处理商家/客户突发问题的经历，当时如何协调资源解决的？\"\n2. \"你曾对接过门店或达人，如果合作方对薪资结算或物料发放有强烈异议，你如何沟通平息并推进执行？\"\n3. \"过去两份工作平均在职时长约9-10个月，若加入天鹅到家，你计划如何快速适应并长期稳定发展？\"\n4. \"月嫂服务涉及26天/42天等灵活周期，若客户临时要求更换月嫂且原月嫂已在岗，你会如何快速协调备选人员并安抚双方？\"\n5. \"假设需要给新入职月嫂讲解公司考勤打卡、物料领用规范，你会如何设计15分钟的高效培训？\"",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：有商家/达人对接经验，但无薪资核算、物料发放、人员档案管理等具体行为，家政服务人员维护场景差异较大。\n2. **订单安排能力：2/5分。依据：熟悉电商订单流转与库存管理，但无月嫂/育婴师排班、换单、人岗匹配经验，服务标准化程度不同。\n3. **基础培训能力：1/5分。依据：简历未体现任何培训授课、课程组织、人员带教经验，技能缺口明显。\n4. **应急对接能力：3/5分。依据：有售后问题处理、异常协调及直播跟播等高压场景经验，具备基础应急响应意识。\n5. **沟通协作能力：4/5分。依据：多次强调跨部门协作、客户对接、达人沟通，自我评价突出性格开朗、执行力强，匹配度高。",
    "created": ""
  },
  {
    "id": 160,
    "name": "韩星宇",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "韩",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备营销活动执行、物料管理、数据统计等标准化运营经验；有线下门店巡场、商户沟通、客诉处理经历；熟悉数字化工具（洞窝系统、1688平台）；学生会部长经历体现组织协调与沟通能力。",
    "risks": "无家政/母婴行业背景；简历时间线存疑（2026年工作经历）；岗位需非工作时间响应，但候选人未明确接受；大客户销售与月嫂维护场景差异大，人员维护经验空白。",
    "aiEval": "- 初筛结果：存疑\n- 优势分析：具备营销活动执行、物料管理、数据统计等标准化运营经验；有线下门店巡场、商户沟通、客诉处理经历；熟悉数字化工具（洞窝系统、1688平台）；学生会部长经历体现组织协调与沟通能力。\n- 风险点：无家政/母婴行业背景；简历时间线存疑（2026年工作经历）；岗位需非工作时间响应，但候选人未明确接受；大客户销售与月嫂维护场景差异大，人员维护经验空白。\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：有物料管理、费用核销经验，但无薪酬发放、人员日常事务管理经验；家政服务人员维护场景差异大。\n  - **订单安排能力：2/5分。依据：有活动统筹、流程调度经验，但无月嫂/育婴师订单匹配、换单调度等家政服务排班经验。\n  - **基础培训能力：2/5分。依据：有商户宣贯、活动培训经历，但无面向一线服务人员的非专业培训经验；母婴护理知识空白。\n  - **应急对接能力：3/5分。依据：有突发问题处理、客诉工单跟进、售后监督经验；但急单对接的时效压力场景未验证。\n  - **沟通协作能力：4/5分。依据：简历自述\"沟通协调能力突出\"\"性格开朗善于沟通\"；有商户常态化沟通、跨部门协作、团队管理经验。\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    - 请描述一次你需要在非工作时间（如晚间或周末）紧急处理工作事务的经历，当时情况如何，你是如何平衡个人时间与工作需求的？\n    - 请举例说明你如何管理和服务过一群分散在不同地点、文化背景或技能水平参差不齐的人员，遇到过什么挑战？\n    - 你的简历中2026年的工作经历是如何发生的？能否说明实际的时间线？\n  - 技术评估问题（2个）：\n    - 月嫂服务中常出现客户临时要求更换服务人员的情况，请设计一个换单沟通流程，说明如何安抚客户情绪并快速匹配替代人员？\n    - 假设一位月嫂",
    "aiScreen": "通过",
    "hrReview": "淘汰",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"请描述一次你处理多方冲突的经历——比如商户/客户对活动安排不满，同时上级又有业绩压力，你如何协调？\"\n2. \"你的简历中有大量商户维护经验，如果换成情绪化的月嫂因薪资问题深夜联系你，你会如何回应？\"\n3. \"你过往经历涉及销售、运营多岗位切换，加入天鹅到家后计划如何保持2年以上的稳定性？\"\n4. \"假设一位月嫂上户3天后因家庭急事要求立即下户，客户预产期临近拒绝换新人，你会如何安排订单与沟通？\"\n5. \"请现场演示：用Excel设计一个月嫂薪资发放表，需包含基本工资、好评奖金、路费报销、物料扣款字段，并说明核对逻辑。\"",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：有物料管理、费用核销经验，但无薪酬发放、人员日常事务管理经验；家政服务人员维护场景差异大。\n2. **订单安排能力：2/5分。依据：有活动统筹、流程调度经验，但无月嫂/育婴师订单匹配、换单调度等家政服务排班经验。\n3. **基础培训能力：2/5分。依据：有商户宣贯、活动培训经历，但无面向一线服务人员的非专业培训经验；母婴护理知识空白。\n4. **应急对接能力：3/5分。依据：有突发问题处理、客诉工单跟进、售后监督经验；但急单对接的时效压力场景未验证。\n5. **沟通协作能力：4/5分。依据：简历自述\"沟通协调能力突出\"\"性格开朗善于沟通\"；有商户常态化沟通、跨部门协作、团队管理经验。",
    "created": ""
  },
  {
    "id": 161,
    "name": "好想上班",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "好",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备电商运营经验，有库存管理、活动统筹、数据分析能力；熟练使用Excel，自我评价强调沟通协作与多任务处理；年轻（24岁），学习能力强，适应快节奏。",
    "risks": "行业经验完全不符（电商vs家政服务）；无月嫂/育婴师相关背景，缺乏母婴护理、保洁、烹饪等基础认知；性别为男，与JD偏好\"男\"存疑但非核心；工作经历时间线混乱（2025-2026年未来日期），存疑。",
    "aiEval": "- 初筛结果：淘汰\n\n- 优势分析：具备电商运营经验，有库存管理、活动统筹、数据分析能力；熟练使用Excel，自我评价强调沟通协作与多任务处理；年轻（24岁），学习能力强，适应快节奏。\n\n- 风险点：行业经验完全不符（电商vs家政服务）；无月嫂/育婴师相关背景，缺乏母婴护理、保洁、烹饪等基础认知；性别为男，与JD偏好\"男\"存疑但非核心；工作经历时间线混乱（2025-2026年未来日期），存疑。\n\n- 能力维度匹配：\n  - **人员维护能力：1/5分。依据：无直接经验。仅有电商商家入驻审核、培训经验，与月嫂薪资物料发放场景差异大。\n  - **订单安排能力：2/5分。依据：有电商订单管理、库存规划经验，但家政服务订单涉及人员调度与换单，逻辑不同。\n  - **基础培训能力：2/5分。依据：曾搭建SOP、培训商家系统操作，但对象为电商卖家，非月嫂育婴师群体。\n  - **应急对接能力：2/5分。依据：有处理韩国消费者投诉、协调供应链经验，但无家政售后或急单对接场景。\n  - **沟通协作能力：3/5分。依据：自我评价及经历体现跨部门协调、团队沟通，但缺乏非工作时间响应的实际验证。\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. 请描述一次你需要在深夜或周末紧急处理突发问题的经历，当时如何平衡个人时间与工作需求？\n    2. 请举例说明你如何向一群文化水平不高、年龄较大的服务者（如保洁阿姨）讲解新流程或系统操作，对方接受度如何？\n    3. 你过往工作周期较短（如得物3个月、网易4个月），请说明离职原因及对未来2-3年职业稳定性的规划。\n  - 技术评估问题（2个）：\n    1. 月嫂服务中常见突发状况有哪些？你认为一名合格的月嫂管家应如何预判并减少换单率？\n    2. 请现场模拟：一位月嫂因家中急事需临时下户，客户预产期临近拒绝换人，你会如何",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你需要在深夜或周末紧急处理突发问题的经历，当时如何平衡个人时间与工作需求？\n2. 请举例说明你如何向一群文化水平不高、年龄较大的服务者（如保洁阿姨）讲解新流程或系统操作，对方接受度如何？\n3. 你过往工作周期较短（如得物3个月、网易4个月），请说明离职原因及对未来2-3年职业稳定性的规划。\n4. 月嫂服务中常见突发状况有哪些？你认为一名合格的月嫂管家应如何预判并减少换单率？\n5. 请现场模拟：一位月嫂因家中急事需临时下户，客户预产期临近拒绝换人，你会如何协调三方诉求？",
    "capabilityMatch": "1. **人员维护能力：1/5分。依据：无直接经验。仅有电商商家入驻审核、培训经验，与月嫂薪资物料发放场景差异大。\n2. **订单安排能力：2/5分。依据：有电商订单管理、库存规划经验，但家政服务订单涉及人员调度与换单，逻辑不同。\n3. **基础培训能力：2/5分。依据：曾搭建SOP、培训商家系统操作，但对象为电商卖家，非月嫂育婴师群体。\n4. **应急对接能力：2/5分。依据：有处理韩国消费者投诉、协调供应链经验，但无家政售后或急单对接场景。\n5. **沟通协作能力：3/5分。依据：自我评价及经历体现跨部门协调、团队沟通，但缺乏非工作时间响应的实际验证。",
    "created": ""
  },
  {
    "id": 162,
    "name": "何宏伟",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "何",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备互联网内容运营经验，擅长用户维护、社群运营及活动策划，有数据意识（CTR分析、Excel/SQL）；跨部门协作经验丰富，沟通执行力较强；26年应届生可塑性强，薪资成本可控。",
    "risks": "无家政/母婴行业经验，人员维护场景差异大（月嫂vs创作者）；26年应届生，稳定性存疑；无明确薪资核算/物料发放实操经历；岗位需接受非工作时间回复，但简历未体现此类工作强度适应性。",
    "aiEval": "- 初筛结果：存疑\n\n- 优势分析：具备互联网内容运营经验，擅长用户维护、社群运营及活动策划，有数据意识（CTR分析、Excel/SQL）；跨部门协作经验丰富，沟通执行力较强；26年应届生可塑性强，薪资成本可控。\n\n- 风险点：无家政/月嫂行业经验，人员维护、订单安排等核心能力为零基础；岗位需\"非工作时间信息回复\"，但简历未体现抗压/服务意愿；视觉设计背景与家政运营关联度低，存在职业动机存疑。\n\n- 能力维度匹配：\n  - **人员维护能力：1/5分。依据：无薪资发放、物料管理经验；仅有创作者激励（非物质激励），与月嫂日常事务管理场景差异大。\n  - **订单安排能力：0/5分。依据：简历无任何订单调度、资源匹配经验；社区运营与家政服务排期逻辑完全不同。\n  - **基础培训能力：2/5分。依据：有话题策划、UGC引导经验，但属线上内容运营；无线下培训、家政服务者面对面带教经历。\n  - **应急对接能力：2/5分。依据：有热点快速响应、售后反馈收集经验；但无急单对接、客诉处理等高压场景实战。\n  - **沟通协作能力：4/5分。依据：跨部门项目推动、社群运营、创作者建联均体现强沟通；性格开朗需面试验证，接受非工作时间回复未明确。\n\n- 建议追问的面试问题：\n  - 行为面试问题1：请描述一次你处理多方冲突或紧急协调的经历——当时涉及哪些角色？你具体如何推动解决？\n  - 行为面试问题2：你的创作者/用户曾提出过最苛刻的诉求是什么？你如何平衡对方期望与平台规则？\n  - 行为面试问题3：为什么选择从互联网运营转向家政服务运营？能否接受24小时内响应月嫂/客户消息的工作节奏？\n  - 技术评估问题1：如果一位月嫂临时因家人生病无法上户，客户次日急需用人，你会如何协调资源？请分步骤说明。\n  - 技术评估问题2：设计一个10分钟的新人月嫂入职培训大纲，需包含非专业技能（如服务礼",
    "aiScreen": "存疑",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你处理多方冲突或紧急协调的经历——当时涉及哪些角色？你具体如何推动解决？\n2. 你的创作者/用户曾提出过最苛刻的诉求是什么？你如何平衡对方期望与平台规则？\n3. 为什么选择从互联网运营转向家政服务运营？能否接受24小时内响应月嫂/客户消息的工作节奏？\n4. 如果一位月嫂临时因家人生病无法上户，客户次日急需用人，你会如何协调资源？请分步骤说明。\n5. 设计一个10分钟的新人月嫂入职培训大纲，需包含非专业技能（如服务礼仪、客户沟通、平台规则）。\n6. 今天交流下来，我想你已经感受到这个岗位需要很强的服务耐心和即时响应——关于天鹅到家的月嫂运营体系、团队支持机制，或者你未来3个月的成长路径，有没有什么问题想深入了解？",
    "capabilityMatch": "1. **人员维护能力：1/5分。依据：无薪资发放、物料管理经验；仅有创作者激励（非物质激励），与月嫂日常事务管理场景差异大。\n2. **订单安排能力：0/5分。依据：简历无任何订单调度、资源匹配经验；社区运营与家政服务排期逻辑完全不同。\n3. **基础培训能力：2/5分。依据：有话题策划、UGC引导经验，但属线上内容运营；无线下培训、家政服务者面对面带教经历。\n4. **应急对接能力：2/5分。依据：有热点快速响应、售后反馈收集经验；但无急单对接、客诉处理等高压场景实战。\n5. **沟通协作能力：4/5分。依据：跨部门项目推动、社群运营、创作者建联均体现强沟通；性格开朗需面试验证，接受非工作时间回复未明确。",
    "created": ""
  },
  {
    "id": 163,
    "name": "黄勤",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "黄",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备跨境电商运营经验，熟悉SHEIN/TEMU平台规则，擅长数据追踪、异常订单处理及供应商协调；Excel函数熟练，有供应链库存管理经验；性格开朗、沟通能力强，符合家政服务数字化运营需求。",
    "risks": "无家政/母婴行业背景，需从零学习月嫂育婴师专业知识；工程管理专业与岗位关联度低；应届生稳定性存疑，且未明确接受非工作时间回复的意愿。",
    "aiEval": "- 初筛结果：通过\n- 优势分析：具备跨境电商运营经验，熟悉SHEIN/TEMU平台规则，擅长数据追踪、异常订单处理及供应商协调；Excel函数熟练，有供应链库存管理经验；性格开朗、沟通能力强，符合家政服务数字化运营需求。\n- 风险点：无家政/母婴行业背景，需从零学习月嫂育婴师专业知识；工程管理专业与岗位关联度低；应届生稳定性存疑，且未明确接受非工作时间回复的意愿。\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：无直接薪资发放或人员管理经验，但有供应商沟通、库存协调及异常订单跟进经验，可迁移至物料与费用对接场景。\n  - **订单安排能力：3/5分。依据：负责SHEIN/TEMU订单履约全流程，协调供应链保障发货时效，具备多线程任务调度与资源匹配能力。\n  - **基础培训能力：1/5分。依据：无培训相关经验，仅在校组织过5次团干培训（50人），与月嫂育婴师非专业培训场景差异较大。\n  - **应急对接能力：3/5分。依据：处理过少件、退款、客诉等异常订单，协调多方解决问题并输出优化建议，售后响应与问题闭环能力可迁移。\n  - **沟通协作能力：4/5分。依据：自我评价明确\"性格开朗、沟通能力良好、注重团队协作\"，且有跨部门协调仓库、客服、供应商的实操记录。\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    - 请描述一次你协调多个部门解决紧急客诉的经历，当时各方诉求冲突时你如何推动共识？\n    - 跨境电商运营常需应对平台规则突变，你曾如何快速适应变化并稳定团队/供应商情绪？\n    - 你提到能承受一定压力，能否举例说明非工作时间处理紧急事务的具体情况，当时如何平衡个人生活？\n  - 技术评估问题（2个）：\n    - 月嫂服务涉及26天/42天周期排班，若同时管理50位月嫂的档期，你会如何设计Excel工具避免撞单？\n    - 假设",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你协调多个部门解决紧急客诉的经历，当时各方诉求冲突时你如何推动共识？\n2. 跨境电商运营常需应对平台规则突变，你曾如何快速适应变化并稳定团队/供应商情绪？\n3. 你提到能承受一定压力，能否举例说明非工作时间处理紧急事务的具体情况，当时如何平衡个人生活？\n4. 月嫂服务涉及26天/42天周期排班，若同时管理50位月嫂的档期，你会如何设计Excel工具避免撞单？\n5. 假设一位月嫂因家庭突发状况需临时下户，客户要求2小时内换人，你当时的应急处理步骤是什么？",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：无直接薪资发放或人员管理经验，但有供应商沟通、库存协调及异常订单跟进经验，可迁移至物料与费用对接场景。\n2. **订单安排能力：3/5分。依据：负责SHEIN/TEMU订单履约全流程，协调供应链保障发货时效，具备多线程任务调度与资源匹配能力。\n3. **基础培训能力：1/5分。依据：无培训相关经验，仅在校组织过5次团干培训（50人），与月嫂育婴师非专业培训场景差异较大。\n4. **应急对接能力：3/5分。依据：处理过少件、退款、客诉等异常订单，协调多方解决问题并输出优化建议，售后响应与问题闭环能力可迁移。\n5. **沟通协作能力：4/5分。依据：自我评价明确\"性格开朗、沟通能力良好、注重团队协作\"，且有跨部门协调仓库、客服、供应商的实操记录。",
    "created": ""
  },
  {
    "id": 164,
    "name": "黄鑫",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "黄",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备标准化培训体系搭建经验（开发课件覆盖500+人）、数据化运营思维（日报/周报体系搭建100%精准同步）、跨部门协同能力（统筹政策返款审核），与天鹅到家\"家政服务标准化、数字化\"业务方向有契合点；有终端赋能闭环管理经验（训后跟踪-落地督导-效果复盘）。",
    "risks": "行业跨度大（家居定制→家政服务），无母婴/家政行业背景；简历存在时间矛盾（2025.01-2025.12为未来时间）；年龄信息缺失（JD要求21-28岁）；稳定性存疑（3段经历均约2年，最近一段仅1年）；无薪资核算、物料发放等事务性工作经验。",
    "aiEval": "- 初筛结果：存疑\n- 优势分析：具备标准化培训体系搭建经验（开发课件覆盖500+人）、数据化运营思维（日报/周报体系搭建100%精准同步）、跨部门协同能力（统筹政策返款审核），与天鹅到家\"家政服务标准化、数字化\"业务方向有契合点；有终端赋能闭环管理经验（训后跟踪-落地督导-效果复盘）。\n- 风险点：行业跨度大（家居定制→家政服务），无母婴/家政行业背景；简历存在时间矛盾（2025.01-2025.12为未来时间）；年龄信息缺失（JD要求21-28岁）；稳定性存疑（3段经历均约2年，最近一段仅1年）；无薪资核算、物料发放等事务性工作经验。\n- 能力维度匹配：\n  - **人员维护能力：1/5分。依据：无月嫂/家政人员管理经验，无薪资、物料发放相关经历，仅有家居行业\"政策返款审核\"间接涉及财务对账，场景差异大。\n  - **订单安排能力：1/5分。依据：无订单调度、人员匹配经验；家居行业\"订单、回款、出货\"为商品流转，与家政服务人员订单安排逻辑不同。\n  - **基础培训能力：4/5分。依据：独立开发标准化课件，线上线下培训覆盖500+人，建立训后跟踪-督导-复盘闭环，培训方法论可直接迁移。\n  - **应急对接能力：2/5分。依据：无急单处理、售后客服经验；仅有\"跨部门协同推进工作\"泛化描述，未涉及高压场景下的客户问题响应。\n  - **沟通协作能力：3/5分。依据：多次提及\"跨部门协同\"\"统筹多部门\"，有终端门店驻店赋能经验；但缺乏家政服务场景下的顾问-客户-服务人员三方沟通证据。\n- 建议追问的面试问题：\n  - 行为面试问题1：请描述一次你需要在短时间内协调多方资源解决突发问题的经历，当时涉及哪些角色？你具体做了什么？\n  - 行为面试问题2：家居定制与家政服务都需要面向终端客户提供服务，你认为两者在\"客户满意度管理\"上最大的差异是什么？你会如何快速适应？\n  - 行",
    "aiScreen": "存疑",
    "hrReview": "淘汰",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你需要在短时间内协调多方资源解决突发问题的经历，当时涉及哪些角色？你具体做了什么？\n2. 家居定制与家政服务都需要面向终端客户提供服务，你认为两者在\"客户满意度管理\"上最大的差异是什么？你会如何快速适应？\n3. 你的工作经历中每段时长约1-2年，选择离开的主要原因是什么？对天鹅到家这个岗位，你期望的职业发展路径是怎样的？\n4. 月嫂工资通常包含基础工资、奖金、路费报销等多项，如果一位月嫂对奖金计算结果提出异议，你会如何核实并沟通处理？\n5. 假设顾问临时推送一个急单，需要2小时内匹配到可用月嫂，但系统显示档期冲突，你会采取哪些步骤尝试解决？",
    "capabilityMatch": "1. **人员维护能力：1/5分。依据：无月嫂/家政人员管理经验，无薪资、物料发放相关经历，仅有家居行业\"政策返款审核\"间接涉及财务对账，场景差异大。\n2. **订单安排能力：1/5分。依据：无订单调度、人员匹配经验；家居行业\"订单、回款、出货\"为商品流转，与家政服务人员订单安排逻辑不同。\n3. **基础培训能力：4/5分。依据：独立开发标准化课件，线上线下培训覆盖500+人，建立训后跟踪-督导-复盘闭环，培训方法论可直接迁移。\n4. **应急对接能力：2/5分。依据：无急单处理、售后客服经验；仅有\"跨部门协同推进工作\"泛化描述，未涉及高压场景下的客户问题响应。\n5. **沟通协作能力：3/5分。依据：多次提及\"跨部门协同\"\"统筹多部门\"，有终端门店驻店赋能经验；但缺乏家政服务场景下的顾问-客户-服务人员三方沟通证据。",
    "created": ""
  },
  {
    "id": 165,
    "name": "佳佳",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "佳",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "2年B端销售及运营经验，具备客户全生命周期管理、跨部门协同及标准化流程搭建能力；擅长Excel数据分析与ERP系统操作，契合家政数字化运营需求；沟通能力强、抗压性好，能接受非工作时间响应。",
    "risks": "专业背景为学前教育而非家政/母婴，缺乏月嫂育婴师行业认知；工作经历时间线存疑（2025-2026年未来日期），需核实真实性；本科应届转销售运营，职业稳定性待观察。",
    "aiEval": "- 初筛结果：通过\n- 优势分析：2年B端销售及运营经验，具备客户全生命周期管理、跨部门协同及标准化流程搭建能力；擅长Excel数据分析与ERP系统操作，契合家政数字化运营需求；沟通能力强、抗压性好，能接受非工作时间响应。\n- 风险点：专业背景为学前教育而非家政/母婴，缺乏月嫂育婴师行业认知；工作经历时间线存疑（2025-2026年未来日期），需核实真实性；本科应届转销售运营，职业稳定性待观察。\n- 能力维度匹配：\n  - **人员维护能力：3/5分。依据：有员工入离职、社保公积金办理及行政后勤统筹经验，但未涉及家政人员薪资物料发放场景。\n  - **订单安排能力：2/5分。依据：无直接订单调度经验，仅有B端客户方案匹配经历，家政服务排期换单逻辑需从零学习。\n  - **基础培训能力：3/5分。依据：学前教育本科+教师资格证，具备培训设计基础；曾任新媒体部长有内容输出经验，但缺乏家政实操培训经历。\n  - **应急对接能力：3/5分。依据：有售后跟进、客户投诉处理及急单协调经验，但云管家系统及家政售后场景未接触过。\n  - **沟通协作能力：4/5分。依据：简历明确标注\"沟通能力强\"\"跨部门核心沟通枢纽\"，有销售、财务、人事多部门协同实证，接受非工作时间响应意愿明确。\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. 请描述一次你处理客户紧急投诉或突发需求的经历，当时如何协调资源、安抚情绪并推动解决？\n    2. 销售工作中常需同时跟进多个客户，你如何优先级排序并确保不遗漏？若换成月嫂档期冲突的场景，你会怎么处理？\n    3. 你提到接受非工作时间信息回复，能否举例说明过往工作中最晚/最早处理工作事务的经历，以及如何平衡工作与生活？\n  - 技术评估问题（2个）：\n    1. 假设一位月嫂因家中突发情况需临时下户，客户次日就要生产，你如何在系统中",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你处理客户紧急投诉或突发需求的经历，当时如何协调资源、安抚情绪并推动解决？\n2. 销售工作中常需同时跟进多个客户，你如何优先级排序并确保不遗漏？若换成月嫂档期冲突的场景，你会怎么处理？\n3. 你提到接受非工作时间信息回复，能否举例说明过往工作中最晚/最早处理工作事务的经历，以及如何平衡工作与生活？\n4. 假设一位月嫂因家中突发情况需临时下户，客户次日就要生产，你如何在系统中快速匹配备选人员并完成换单？请描述操作步骤。\n5. 月嫂对工资计算方式有异议，认为奖金少发了200元，你如何通过Excel核对并解释清楚？请现场演示数据透视或公式思路。",
    "capabilityMatch": "1. **人员维护能力：3/5分。依据：有员工入离职、社保公积金办理及行政后勤统筹经验，但未涉及家政人员薪资物料发放场景。\n2. **订单安排能力：2/5分。依据：无直接订单调度经验，仅有B端客户方案匹配经历，家政服务排期换单逻辑需从零学习。\n3. **基础培训能力：3/5分。依据：学前教育本科+教师资格证，具备培训设计基础；曾任新媒体部长有内容输出经验，但缺乏家政实操培训经历。\n4. **应急对接能力：3/5分。依据：有售后跟进、客户投诉处理及急单协调经验，但云管家系统及家政售后场景未接触过。\n5. **沟通协作能力：4/5分。依据：简历明确标注\"沟通能力强\"\"跨部门核心沟通枢纽\"，有销售、财务、人事多部门协同实证，接受非工作时间响应意愿明确。",
    "created": ""
  },
  {
    "id": 166,
    "name": "贾云玲",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "贾",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "2年妇产科医院导乐经验体现基础母婴服务场景认知，具备\"细心、能干\"特质与\"较好沟通能力\"，与月嫂/育婴师服务对象存在交集，对家政行业一线劳动者有初步理解。",
    "risks": "求职意向为\"护士\"而非\"商家运营专员\"，岗位目标严重错位；简历无电脑操作、订单管理、薪资核算、培训组织等任何相关经验；年龄23岁但工作年限存疑，稳定性存疑；完全未提及团队精神、非工作时间响应等关键要求。",
    "aiEval": "- 初筛结果：淘汰\n\n- 优势分析：2年妇产科医院导乐经验体现基础母婴服务场景认知，具备\"细心、能干\"特质与\"较好沟通能力\"，与月嫂/育婴师服务对象存在交集，对家政行业一线劳动者有初步理解。\n\n- 风险点：求职意向为\"护士\"而非\"商家运营专员\"，岗位目标严重错位；简历无电脑操作、订单管理、薪资核算、培训组织等任何相关经验；年龄23岁但工作年限存疑，稳定性存疑；完全未提及团队精神、非工作时间响应等关键要求。\n\n- 能力维度匹配：\n  - **人员维护能力：1/5分。依据：仅有医院导乐经验，无薪资物料发放、劳动者日常管理相关经历，能力空白。\n  - **订单安排能力：0/5分。依据：简历无任何订单调度、资源匹配、换单协调等行为描述，完全缺失。\n  - **基础培训能力：0/5分。依据：未体现培训组织、课程讲授、人员带教等经验，无相关能力证据。\n  - **应急对接能力：1/5分。依据：导乐工作可能涉及产程突发情况配合，但无售后处理、急单对接等商业化服务经验。\n  - **沟通协作能力：2/5分。依据：自述\"较好沟通能力，与人相处友好\"，但缺乏团队协作、跨部门配合、非工作时间响应的实证。\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. 你目前的求职意向是护士，是什么原因让你考虑商家运营专员这个岗位？请具体说明你对该岗位工作内容的理解。\n    2. 导乐工作中曾遇到产妇或家属突发情绪激动的情况，你是如何沟通协调的？结果如何？\n    3. 过去两年中，是否有因个人原因中断工作或计划转行的经历？未来2-3年的职业规划是什么？\n  - 技术评估问题（2个）：\n    1. 假设需要给50位月嫂核算本月工资（含基础工资、好评奖金、路费补贴），你会如何设计表格或流程确保准确高效？\n    2. 一位月嫂因家中急事要求临时下户，但客户订单已排期，你会如何协调换单并",
    "aiScreen": "淘汰",
    "hrReview": "淘汰",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 你目前的求职意向是护士，是什么原因让你考虑商家运营专员这个岗位？请具体说明你对该岗位工作内容的理解。\n2. 导乐工作中曾遇到产妇或家属突发情绪激动的情况，你是如何沟通协调的？结果如何？\n3. 过去两年中，是否有因个人原因中断工作或计划转行的经历？未来2-3年的职业规划是什么？\n4. 假设需要给50位月嫂核算本月工资（含基础工资、好评奖金、路费补贴），你会如何设计表格或流程确保准确高效？\n5. 一位月嫂因家中急事要求临时下户，但客户订单已排期，你会如何协调换单并安抚双方？",
    "capabilityMatch": "1. **人员维护能力：1/5分。依据：仅有医院导乐经验，无薪资物料发放、劳动者日常管理相关经历，能力空白。\n2. **订单安排能力：0/5分。依据：简历无任何订单调度、资源匹配、换单协调等行为描述，完全缺失。\n3. **基础培训能力：0/5分。依据：未体现培训组织、课程讲授、人员带教等经验，无相关能力证据。\n4. **应急对接能力：1/5分。依据：导乐工作可能涉及产程突发情况配合，但无售后处理、急单对接等商业化服务经验。\n5. **沟通协作能力：2/5分。依据：自述\"较好沟通能力，与人相处友好\"，但缺乏团队协作、跨部门配合、非工作时间响应的实证。",
    "created": ""
  },
  {
    "id": 167,
    "name": "蒋慧琳",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "蒋",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备基础运营经验（商品上架、内容编辑、活动策划），沟通协调能力标注\"精通\"，文案策划良好，有用户思维与社群维护意识，符合数字化运营基础要求；计算机一级证书满足电脑操作要求。",
    "risks": "零家政/母婴行业经验，无薪资核算、人员管理实操经历；26年应届生（预计2026年6月毕业），到岗时间（2025.09-2026.12实习经历）与岗位即时需求冲突；性别女与JD\"男性\"要求不符；未体现非工作时间响应经历。",
    "aiEval": "- 初筛结果：存疑\n- 优势分析：具备基础运营经验（商品上架、内容编辑、活动策划），沟通协调能力标注\"精通\"，文案策划良好，有用户思维与社群维护意识，符合数字化运营基础要求；计算机一级证书满足电脑操作要求。\n- 风险点：零家政/母婴行业经验，无薪资核算、人员管理实操经历；26年应届生（预计2026年6月毕业），到岗时间（2025.09-2026.12实习经历）与岗位即时需求冲突；性别女与JD\"男性\"要求不符；未体现非工作时间响应经历。\n- 能力维度匹配：\n  - **人员维护能力：1/5分。依据：仅有财务档案整理、发票开具经历，无人员薪资奖金发放经验，未涉及月嫂群体管理。\n  - **订单安排能力：1/5分。依据：无订单调度、换单处理经验；海拍客经历含\"商品上架\"但属电商SKU管理，与家政服务订单逻辑差异大。\n  - **基础培训能力：0/5分。依据：简历未体现任何培训授课、课程组织经历，无月嫂/育婴师相关知识储备。\n  - **应急对接能力：1/5分。依据：有\"整理用户反馈并同步对接相关部门\"描述，但属电商运营场景，无急单响应、售后处理深度经验。\n  - **沟通协作能力：3/5分。依据：自评\"沟通协调能力精通\"\"善于沟通协作\"，有跨部门对接（财务、运营）经历，但缺乏家政服务者（月嫂）沟通场景验证。\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. 请描述一次你需要在非工作时间（如晚间/周末）处理紧急事务的经历，当时如何平衡个人时间与工作需求？\n    2. 海拍客实习中\"整理用户反馈并对接相关部门\"的具体案例是什么？如何确保信息传递准确且推动问题解决？\n    3. 作为应届生同时有实习经历，未来3年职业规划是什么？如何看待家政行业基层岗位的发展路径？\n  - 技术评估问题（2个）：\n    1. 假设月嫂因突发疾病无法上户，需紧急调换人员，你会如",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你需要在非工作时间（如晚间/周末）处理紧急事务的经历，当时如何平衡个人时间与工作需求？\n2. 海拍客实习中\"整理用户反馈并对接相关部门\"的具体案例是什么？如何确保信息传递准确且推动问题解决？\n3. 作为应届生同时有实习经历，未来3年职业规划是什么？如何看待家政行业基层岗位的发展路径？\n4. 假设月嫂因突发疾病无法上户，需紧急调换人员，你会如何快速协调？请列出关键步骤。\n5. 请用Excel设计一个月嫂薪资计算表框架，需包含基本工资、奖金、路费扣减项，并说明公式逻辑。",
    "capabilityMatch": "1. **人员维护能力：1/5分。依据：仅有财务档案整理、发票开具经历，无人员薪资奖金发放经验，未涉及月嫂群体管理。\n2. **订单安排能力：1/5分。依据：无订单调度、换单处理经验；海拍客经历含\"商品上架\"但属电商SKU管理，与家政服务订单逻辑差异大。\n3. **基础培训能力：0/5分。依据：简历未体现任何培训授课、课程组织经历，无月嫂/育婴师相关知识储备。\n4. **应急对接能力：1/5分。依据：有\"整理用户反馈并同步对接相关部门\"描述，但属电商运营场景，无急单响应、售后处理深度经验。\n5. **沟通协作能力：3/5分。依据：自评\"沟通协调能力精通\"\"善于沟通协作\"，有跨部门对接（财务、运营）经历，但缺乏家政服务者（月嫂）沟通场景验证。",
    "created": ""
  },
  {
    "id": 168,
    "name": "金若仪",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "金",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备电商运营标准化经验，擅长数据监控、库存动态调整及大促资源协调；跨部门协作成熟，有市场部/设计部/财务联动经验；熟练使用Excel数据工具，契合家政数字化管理需求；自我评价突出多任务规划与优先级划分能力。",
    "risks": "无家政/母婴行业背景，人员维护与培训场景差异大；工作经验时间标注存疑（2025.10-2026.04为未来时段，可能为实习/预测性表述需核实）；23岁年龄接近下限，稳定性待观察；未明确提及非工作时间响应的实际经历。",
    "aiEval": "- 初筛结果：通过\n- 优势分析：具备电商运营标准化经验，擅长数据监控、库存动态调整及大促资源协调；跨部门协作成熟，有市场部/设计部/财务联动经验；熟练使用Excel数据工具，契合家政数字化管理需求；自我评价突出多任务规划与优先级划分能力。\n- 风险点：无家政/母婴行业背景，人员维护与培训场景差异大；工作经验时间标注存疑（2025.10-2026.04为未来时段，可能为实习/预测性表述需核实）；23岁年龄接近下限，稳定性待观察；未明确提及非工作时间响应的实际经历。\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：无直接经验。仅有财务对账中制作收支明细表、排查异常订单的经验，涉及薪资核算但非\"发放\"执行主体，未接触月嫂群体管理。**\n  - **订单安排能力：3/5分。依据：有酒店套餐产品筛选、上下架、库存/房量/房态动态调整经验，具备资源调度意识；但酒店房态与月嫂\"人\"的订单安排逻辑差异显著，换单场景无涉及。**\n  - **基础培训能力：1/5分。依据：简历未体现任何培训授课、课程开发或带教经验；电商运营背景与母婴护理/家政服务培训内容无交集。**\n  - **应急对接能力：3/5分。依据：有大促期间实时监控数据、识别风险并灵活调整策略的经验；协助处理过推广异常、佣金差额等问题订单；但\"急单\"场景为商业促销而非客户服务危机，售后处理对象为账务而非云管家客诉。**\n  - **沟通协作能力：4/5分。依据：自我评价明确\"性格开朗善于沟通\"；有联动市场部、设计师、财务完成资源提报、页面设计与对账的实证；项目期间确保全流程活动落地的跨部门协作记录；接受非工作时间信息回复的意愿需面试确认。**\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    - 请描述一次你需要同时处理多个紧急任务的经历，当时如何划分优先级并最终确保各项任务按时完成？（考察多任务规",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你需要同时处理多个紧急任务的经历，当时如何划分优先级并最终确保各项任务按时完成？\n2. 在飞猪工作期间，是否遇到过需要在非工作时间响应紧急工作需求的情况？具体是如何处理的？\n3. 请举例说明你与不同部门（如市场、设计、财务）协作时，遇到过最大的分歧是什么，如何推动达成共识？\n4. 月嫂/育婴师订单安排涉及\"人\"而非\"库存\"，若一位月嫂因突发疾病无法上户，你会如何在短时间内协调替换并安抚客户情绪？请描述具体步骤。\n5. 假设需要为月嫂群体设计一场关于\"客户沟通礼仪\"的非专业培训，你会如何规划课程大纲和互动环节？",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：无直接经验。仅有财务对账中制作收支明细表、排查异常订单的经验，涉及薪资核算但非\"发放\"执行主体，未接触月嫂群体管理。**\n2. **订单安排能力：3/5分。依据：有酒店套餐产品筛选、上下架、库存/房量/房态动态调整经验，具备资源调度意识；但酒店房态与月嫂\"人\"的订单安排逻辑差异显著，换单场景无涉及。**\n3. **基础培训能力：1/5分。依据：简历未体现任何培训授课、课程开发或带教经验；电商运营背景与母婴护理/家政服务培训内容无交集。**\n4. **应急对接能力：3/5分。依据：有大促期间实时监控数据、识别风险并灵活调整策略的经验；协助处理过推广异常、佣金差额等问题订单；但\"急单\"场景为商业促销而非客户服务危机，售后处理对象为账务而非云管家客诉。**\n5. **沟通协作能力：4/5分。依据：自我评价明确\"性格开朗善于沟通\"；有联动市场部、设计师、财务完成资源提报、页面设计与对账的实证；项目期间确保全流程活动落地的跨部门协作记录；接受非工作时间信息回复的意愿需面试确认。**",
    "created": ""
  },
  {
    "id": 169,
    "name": "金炜淇",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "金",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备电商平台商家运营经验，熟悉商品上下架、商家对接、活动执行及售后处理；有客服与多岗位轮岗背景，沟通执行能力较强；药学背景体现细致规范意识，可迁移至服务标准化管理。",
    "risks": "无家政/母婴行业经验，月嫂育婴师专业知识空白；简历时间线存疑（2024.04-2025.09、2025.10-2026.06为未来日期），稳定性需核实；男性候选人与月嫂群体沟通或存障碍，非工作时间响应意愿未经验证。",
    "aiEval": "- 初筛结果：存疑\n- 优势分析：具备电商平台商家运营经验，熟悉商品上下架、商家对接、活动执行及售后处理；有客服与多岗位轮岗背景，沟通执行能力较强；药学背景体现细致规范意识，可迁移至服务标准化管理。\n- 风险点：无家政/母婴行业经验，月嫂育婴师专业知识空白；简历时间线存疑（2024.04-2025.09、2025.10-2026.06为未来日期），稳定性需核实；男性候选人与月嫂群体沟通或存障碍，非工作时间响应意愿未经验证。\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：有薪资物料发放经验（静配中心盘点、医药运营商品管理），但无家政人员管理经验，未涉及工资奖金路费发放场景。\n  - **订单安排能力：3/5分。依据：具备订单处理、商品审核、商家换单对接经验（速卖通、医药运营），逻辑调度能力可迁移，但无月嫂育婴师排单实操。\n  - **基础培训能力：1/5分。依据：无任何培训授课或课程组织经验，药学背景与母婴护理培训关联度低。\n  - **应急对接能力：3/5分。依据：有售后客服（空调售后回访）、急单协调（安装维修节点跟进）及平台合规整改经验，云管家售后场景需适应。\n  - **沟通协作能力：4/5分。依据：自我评价明确\"性格开朗善于人际沟通\"，多岗位涉及商家/客户/网点对接，兼职经历体现销售推广中的主动沟通。\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    - 请描述一次你处理商家紧急投诉或售后纠纷的具体案例，当时如何协调多方资源解决？结果如何？\n    - 你曾在多个岗位间切换（医院、电商、客服），请分享一次快速适应新领域的方法，如何建立信任关系？\n    - 岗位需随时响应月嫂夜间突发状况，你过往经历中是否有非工作时间处理紧急事务的实例？如何平衡工作与生活？\n  - 技术评估问题（2个）：\n    - 假设月嫂因突发疾病需临时换单，现有3",
    "aiScreen": "存疑",
    "hrReview": "淘汰",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你处理商家紧急投诉或售后纠纷的具体案例，当时如何协调多方资源解决？结果如何？\n2. 你曾在多个岗位间切换（医院、电商、客服），请分享一次快速适应新领域的方法，如何建立信任关系？\n3. 岗位需随时响应月嫂夜间突发状况，你过往经历中是否有非工作时间处理紧急事务的实例？如何平衡工作与生活？\n4. 假设月嫂因突发疾病需临时换单，现有3位待岗月嫂技能等级、档期各异，你会如何快速评估并安排？请说明决策优先级。\n5. 请设计一个10分钟的新入职月嫂\"客户沟通礼仪\"微培训大纲，需包含关键要点与互动形式。",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：有薪资物料发放经验（静配中心盘点、医药运营商品管理），但无家政人员管理经验，未涉及工资奖金路费发放场景。\n2. **订单安排能力：3/5分。依据：具备订单处理、商品审核、商家换单对接经验（速卖通、医药运营），逻辑调度能力可迁移，但无月嫂育婴师排单实操。\n3. **基础培训能力：1/5分。依据：无任何培训授课或课程组织经验，药学背景与母婴护理培训关联度低。\n4. **应急对接能力：3/5分。依据：有售后客服（空调售后回访）、急单协调（安装维修节点跟进）及平台合规整改经验，云管家售后场景需适应。\n5. **沟通协作能力：4/5分。依据：自我评价明确\"性格开朗善于人际沟通\"，多岗位涉及商家/客户/网点对接，兼职经历体现销售推广中的主动沟通。",
    "created": ""
  },
  {
    "id": 170,
    "name": "金先生",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "金",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "武警服役经历体现强执行力、抗压能力与责任心；班级骨干经历显示基础组织协调能力；Python及BIM学习背景对数字化工具上手有潜在帮助。",
    "risks": "意向岗位为建筑工程师，与家政运营完全错位；26年应届生无家政/服务/运营经验；土木工程专业与母婴护理、人员管理无关联；男性身份与月嫂群体管理存在客观场景障碍。",
    "aiEval": "- 初筛结果：淘汰\n\n- 优势分析：武警服役经历体现强执行力、抗压能力与责任心；班级骨干经历显示基础组织协调能力；Python及BIM学习背景对数字化工具上手有潜在帮助。\n\n- 风险点：意向岗位为建筑工程师，与家政运营完全错位；26年应届生无家政/服务/运营经验；土木工程专业与母婴护理、人员管理无关联；男性身份与月嫂群体管理存在客观场景障碍。\n\n- 能力维度匹配：\n  - **人员维护能力：0/5分。依据：零家政行业背景，无薪资发放、物料管理经验，未接触女性家政从业者群体管理场景。\n  - **订单安排能力：0/5分。依据：无服务调度、订单匹配经验，简历未体现任何排班、资源协调类工作。\n  - **基础培训能力：0/5分。依据：无培训授课经历，未涉及母婴护理、育婴知识领域，专业壁垒显著。\n  - **应急对接能力：1/5分。依据：仅武警执勤零差错体现基础应急意识，但无客户服务、售后处理经验，场景差异大。\n  - **沟通协作能力：2/5分。依据：班级骨干、测量员配合施工体现基础沟通，但缺乏服务导向的柔性沟通经验，未验证非工作时间响应意愿。\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. 你目前意向是建筑工程师，如果加入家政行业，如何说服自己完成职业转型？请举例说明你曾经主动适应陌生环境的经历。\n    2. 月嫂群体以中年女性为主，作为年轻男性，你计划如何建立信任并有效管理她们的日常事务？描述一次你与差异较大群体协作的案例。\n    3. 岗位需随时响应月嫂突发需求，结合你服役期间的经历，谈谈如何处理个人休息与紧急任务的冲突？\n  - 技术评估问题（2个）：\n    1. 请简述你对月嫂服务流程的理解，并设计一个简单的Excel表格框架用于记录月嫂档期与订单匹配状态。\n    2. 假设一位月嫂因家庭急事需临时下户，客户次日就要生产，你会如何协调资",
    "aiScreen": "淘汰",
    "hrReview": "淘汰",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 你目前意向是建筑工程师，如果加入家政行业，如何说服自己完成职业转型？请举例说明你曾经主动适应陌生环境的经历。\n2. 月嫂群体以中年女性为主，作为年轻男性，你计划如何建立信任并有效管理她们的日常事务？描述一次你与差异较大群体协作的案例。\n3. 岗位需随时响应月嫂突发需求，结合你服役期间的经历，谈谈如何处理个人休息与紧急任务的冲突？\n4. 请简述你对月嫂服务流程的理解，并设计一个简单的Excel表格框架用于记录月嫂档期与订单匹配状态。\n5. 假设一位月嫂因家庭急事需临时下户，客户次日就要生产，你会如何协调资源？请分步骤说明。",
    "capabilityMatch": "1. **人员维护能力：0/5分。依据：零家政行业背景，无薪资发放、物料管理经验，未接触女性家政从业者群体管理场景。\n2. **订单安排能力：0/5分。依据：无服务调度、订单匹配经验，简历未体现任何排班、资源协调类工作。\n3. **基础培训能力：0/5分。依据：无培训授课经历，未涉及母婴护理、育婴知识领域，专业壁垒显著。\n4. **应急对接能力：1/5分。依据：仅武警执勤零差错体现基础应急意识，但无客户服务、售后处理经验，场景差异大。\n5. **沟通协作能力：2/5分。依据：班级骨干、测量员配合施工体现基础沟通，但缺乏服务导向的柔性沟通经验，未验证非工作时间响应意愿。",
    "created": ""
  },
  {
    "id": 171,
    "name": "琚胡峰",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "琚",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "3年电商运营经验，具备强数据整理、活动策划与执行能力；Excel熟练，擅长量化分析与复盘；性格乐观开朗、踏实肯干，符合家政服务标准化、数字化运营需求；有客服售后处理经验，可迁移至云管家售后场景。",
    "risks": "无家政/母婴行业背景，月嫂育婴师专业知识为零；求职意向为直播运营，与家政运营专员岗位偏差较大；薪资期望8-12K高于基础运营岗，存在动机存疑；过往经历均为互联网电商，行业稳定性待验证。",
    "aiEval": "- 初筛结果：通过\n- 优势分析：3年电商运营经验，具备强数据整理、活动策划与执行能力；Excel熟练，擅长量化分析与复盘；性格乐观开朗、踏实肯干，符合家政服务标准化、数字化运营需求；有客服售后处理经验，可迁移至云管家售后场景。\n- 风险点：无家政/母婴行业背景，月嫂育婴师专业知识为零；求职意向为直播运营，与家政运营专员岗位偏差较大；薪资期望8-12K高于基础运营岗，存在动机存疑；过往经历均为互联网电商，行业稳定性待验证。\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：无直接薪资物料发放经验，但直播运营涉及选品排款、投放预算管理，有基础财务流程意识；需从零学习月嫂管理体系。\n  - **订单安排能力：3/5分。依据：直播运营中负责排期、排款顺序优化，具备资源调度与流程优化经验；可迁移至月嫂订单排期，但缺乏家政服务换单场景实操。\n  - **基础培训能力：2/5分。依据：无培训相关经验；直播话术优化经历可支撑基础内容梳理，但非专业培训（如服务意识、沟通规范）需从头建立。\n  - **应急对接能力：3/5分。依据：天猫售后客服经历（处理过敏、物流、客诉）与直播大促应急经验，具备客户情绪安抚与问题解决能力；可迁移至急单对接与售后处理。\n  - **沟通协作能力：4/5分。依据：简历自述\"性格开朗善于沟通\"，直播中控需实时配合主播、多部门协作，私域运营维护买家群，团队精神与沟通场景丰富；接受非工作时间回复需确认。\n- 建议追问的面试问题：\n  - 行为面试问题1（沟通协调）：请描述一次直播中你与主播发生节奏冲突的场景，你如何实时调整并达成目标？——考察高压即时沟通与协作能力。\n  - 行为面试问题2（客户服务）：在天猫售后处理客户过敏投诉时，你如何平衡公司政策与客户情绪，最终如何解决的？——考察售后应急与服务意识。\n  - 行为面试问题3（稳定性）：你的职业路径从客",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次直播中你与主播发生节奏冲突的场景，你如何实时调整并达成目标？\n2. 在天猫售后处理客户过敏投诉时，你如何平衡公司政策与客户情绪，最终如何解决的？\n3. 你的职业路径从客服到直播运营，现在投递家政运营，请具体说明行业转换的动机与长期规划？\n4. 假设一位月嫂因突发疾病需临时换单，客户次日就要生产，你会如何协调资源并沟通客户？\n5. 请用Excel设计一张月嫂薪资计算表，需包含基本工资、奖金、路费扣减、物料发放字段，并说明如何核对避免差错。",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：无直接薪资物料发放经验，但直播运营涉及选品排款、投放预算管理，有基础财务流程意识；需从零学习月嫂管理体系。\n2. **订单安排能力：3/5分。依据：直播运营中负责排期、排款顺序优化，具备资源调度与流程优化经验；可迁移至月嫂订单排期，但缺乏家政服务换单场景实操。\n3. **基础培训能力：2/5分。依据：无培训相关经验；直播话术优化经历可支撑基础内容梳理，但非专业培训（如服务意识、沟通规范）需从头建立。\n4. **应急对接能力：3/5分。依据：天猫售后客服经历（处理过敏、物流、客诉）与直播大促应急经验，具备客户情绪安抚与问题解决能力；可迁移至急单对接与售后处理。\n5. **沟通协作能力：4/5分。依据：简历自述\"性格开朗善于沟通\"，直播中控需实时配合主播、多部门协作，私域运营维护买家群，团队精神与沟通场景丰富；接受非工作时间回复需确认。",
    "created": ""
  },
  {
    "id": 172,
    "name": "李杰",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "李",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备基础办公技能（Word/Excel/PPT）及客户对接经验；售后维修经历体现服务意识与问题解决能力；性格开朗、善于沟通，符合岗位沟通协作要求；应届生可塑性强，年龄符合21-28岁区间。",
    "risks": "无家政/母婴行业经验，人员维护、订单安排、基础培训等核心能力无直接证据；两段实习均为销售/技术岗，与月嫂育婴师管理场景差异大；环境设计专业背景关联度低；未明确提及\"接受非工作时间信息回复\"的意愿。",
    "aiEval": "- 初筛结果：存疑\n- 优势分析：具备基础办公技能（Word/Excel/PPT）及客户对接经验；售后维修经历体现服务意识与问题解决能力；性格开朗、善于沟通，符合岗位沟通协作要求；应届生可塑性强，年龄符合21-28岁区间。\n- 风险点：无家政/母婴行业经验，人员维护、订单安排、基础培训等核心能力无直接证据；两段实习均为销售/技术岗，与月嫂育婴师管理场景差异大；环境设计专业背景关联度低；未明确提及\"接受非工作时间信息回复\"的意愿。\n- 能力维度匹配：\n  - **人员维护能力：1/5分。依据：无薪资物料发放、人员管理经验，仅有基础信息统计经历，与月嫂日常事务管理场景差异显著。\n  - **订单安排能力：1/5分。依据：无订单调度、换单安排经验；地产销售涉及房源匹配，但家政服务订单的时效性、人员流动性特点未触及。\n  - **基础培训能力：0/5分。依据：简历未体现任何培训组织、授课或知识传递经历，该维度完全空白。\n  - **应急对接能力：2/5分。依据：售后维修经历涉及客户问题响应与处理，具备基础应急意识；但\"急单对接\"的高时效压力场景未验证。\n  - **沟通协作能力：3/5分。依据：自我评价及实习经历均强调沟通能力、团队协作；客户接待、售后对接经验支撑该维度，但缺乏家政服务者（月嫂/育婴师）这类特殊群体的沟通经验。\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. 请描述一次你需要同时处理多位客户紧急需求并协调资源解决的经历，当时如何排序优先级、沟通推进的？\n    2. 你的实习中涉及较多技术/销售场景，若转岗管理月嫂群体（多为35-50岁女性、文化背景多元），你认为沟通方式需要哪些调整？请举例说明你快速适应陌生群体沟通风格的经验。\n    3. 该岗位需随时响应月嫂突发状况（如夜间急病、客户投诉），你目前对\"非工作时间信息回复\"的接受度如何？过",
    "aiScreen": "存疑",
    "hrReview": "通过",
    "interviewPos": "商家运营专员",
    "interviewQ": "1. 请描述一次你需要同时处理多位客户紧急需求并协调资源解决的经历，当时如何排序优先级、沟通推进的？\n2. 你的实习中涉及较多技术/销售场景，若转岗管理月嫂群体（多为35-50岁女性、文化背景多元），你认为沟通方式需要哪些调整？请举例说明你快速适应陌生群体沟通风格的经验。\n3. 该岗位需随时响应月嫂突发状况（如夜间急病、客户投诉），你目前对\"非工作时间信息回复\"的接受度如何？过往经历中是否有类似高强度待命的经历？\n4. 假设一位月嫂因家中急事需临时下户，客户次日生产无替代人选，你会如何紧急协调？请简述步骤。\n5. 请用Excel设计一张简易的月嫂工资计算表框架（含基本工资、奖金、路费扣减项），现场口述字段逻辑。",
    "capabilityMatch": "1. **人员维护能力：1/5分。依据：无薪资物料发放、人员管理经验，仅有基础信息统计经历，与月嫂日常事务管理场景差异显著。\n2. **订单安排能力：1/5分。依据：无订单调度、换单安排经验；地产销售涉及房源匹配，但家政服务订单的时效性、人员流动性特点未触及。\n3. **基础培训能力：0/5分。依据：简历未体现任何培训组织、授课或知识传递经历，该维度完全空白。\n4. **应急对接能力：2/5分。依据：售后维修经历涉及客户问题响应与处理，具备基础应急意识；但\"急单对接\"的高时效压力场景未验证。\n5. **沟通协作能力：3/5分。依据：自我评价及实习经历均强调沟通能力、团队协作；客户接待、售后对接经验支撑该维度，但缺乏家政服务者（月嫂/育婴师）这类特殊群体的沟通经验。",
    "created": ""
  },
  {
    "id": 173,
    "name": "李金萍",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "李",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备IDC资产全流程管理经验（采购、出入库、调拨报废），与月嫂人员维护中的薪资物料发放逻辑高度相通；熟练使用RPA自动化工具及AI排错，契合天鹅到家数字化运营需求；跨团队协作经验丰富，能快速对接顾问与技术团队。",
    "risks": "云计算专业背景与家政服务场景存在行业跨度，需验证服务者同理心；26年应届生身份（预计2026年6月毕业）与JD要求的\"21-28岁\"存疑，当前年龄21岁但入职时可能超龄边界；无母婴/家政行业经验，基础培训能力需从零培养。",
    "aiEval": "- 初筛结果：通过\n- 优势分析：具备IDC资产全流程管理经验（采购、出入库、调拨报废），与月嫂人员维护中的薪资物料发放逻辑高度相通；熟练使用RPA自动化工具及AI排错，契合天鹅到家数字化运营需求；跨团队协作经验丰富，能快速对接顾问与技术团队。\n- 风险点：云计算专业背景与家政服务场景存在行业跨度，需验证服务者同理心；26年应届生身份（预计2026年6月毕业）与JD要求的\"21-28岁\"存疑，当前年龄21岁但入职时可能超龄边界；无母婴/家政行业经验，基础培训能力需从零培养。\n- 能力维度匹配：\n  - **人员维护能力：3/5分。依据：IDC资产全生命周期管理经验（登记、调拨、报废）可迁移至薪资物料发放，但缺乏直接的人员工资奖金实操经历。\n  - **订单安排能力：2/5分。依据：无直接订单调度经验；RPA工具使用体现流程优化意识，但月嫂换单涉及人际协调，未经验证。\n  - **基础培训能力：1/5分。依据：简历未体现任何培训授课经历；华为专项培训为学生身份受训，非组织培训者。\n  - **应急对接能力：3/5分。依据：RPA报错时运用AI工具排错体现应急处理能力；数据标注岗位的跨团队协作经验可迁移至急单对接。\n  - **沟通协作能力：4/5分。依据：射箭锦标赛志愿者负责赛事引导及积分统计，需高频沟通；团队获志愿交流分享优胜奖，团队精神获外部认可；自我评价明确提及\"跨团队协作能力\"。\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. 请描述一次你在华为IDC培训或知衣科技实习中，协调多方资源解决突发问题的具体经历，当时涉及哪些角色？你如何推动问题解决？\n    2. 数据标注工作需要反复校验准确性，这与月嫂薪资核算的严谨性要求类似，请举例说明你如何保证高频重复工作的零差错？\n    3. 岗位需要非工作时间响应月嫂/育婴师紧急需求，你目前的学业安排（",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你在华为IDC培训或知衣科技实习中，协调多方资源解决突发问题的具体经历，当时涉及哪些角色？你如何推动问题解决？\n2. 数据标注工作需要反复校验准确性，这与月嫂薪资核算的严谨性要求类似，请举例说明你如何保证高频重复工作的零差错？\n3. 岗位需要非工作时间响应月嫂/育婴师紧急需求，你目前的学业安排（2026年6月毕业）如何保障实习/全职工作的稳定性与投入度？\n4. 假设一位月嫂因突发疾病需紧急换单，原订单3天后上户，你会如何快速在系统中标记状态并协调顾问寻找替补？请描述你的操作步骤。\n5. 请用Excel模拟设计一个月嫂工资核算表，需包含基本工资、奖金、路费扣减项，并说明如何用VLOOKUP或数据透视表实现自动汇总。",
    "capabilityMatch": "1. **人员维护能力：3/5分。依据：IDC资产全生命周期管理经验（登记、调拨、报废）可迁移至薪资物料发放，但缺乏直接的人员工资奖金实操经历。\n2. **订单安排能力：2/5分。依据：无直接订单调度经验；RPA工具使用体现流程优化意识，但月嫂换单涉及人际协调，未经验证。\n3. **基础培训能力：1/5分。依据：简历未体现任何培训授课经历；华为专项培训为学生身份受训，非组织培训者。\n4. **应急对接能力：3/5分。依据：RPA报错时运用AI工具排错体现应急处理能力；数据标注岗位的跨团队协作经验可迁移至急单对接。\n5. **沟通协作能力：4/5分。依据：射箭锦标赛志愿者负责赛事引导及积分统计，需高频沟通；团队获志愿交流分享优胜奖，团队精神获外部认可；自我评价明确提及\"跨团队协作能力\"。",
    "created": ""
  },
  {
    "id": 174,
    "name": "李女士",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "李",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备私域运营从0-1搭建经验（近千人规模），直播实战及强沟通能力；持有幼教资格证，对母婴群体有耐心；有基础视频剪辑与文案能力，可辅助月嫂培训素材制作；组织过大型校内活动，具备多线程协调能力。",
    "risks": "无家政/月嫂行业经验，人员维护与订单安排能力未验证；简历显示\"4年工作经验\"但教育经历2020-2023年，时间线存疑且2025-2026为未来日期，稳定性需核实；期望薪资7-8K与JD 8-10K倒挂，动机待探；无男性候选人优势（JD倾向男性）。",
    "aiEval": "- 初筛结果：存疑\n\n- 优势分析：具备私域运营从0-1搭建经验（近千人规模），直播实战及强沟通能力；持有幼教资格证，对母婴群体有耐心；有基础视频剪辑与文案能力，可辅助月嫂培训素材制作；组织过大型校内活动，具备多线程协调能力。\n\n- 风险点：无家政/月嫂行业经验，人员维护与订单安排能力未验证；简历显示\"4年工作经验\"但教育经历2020-2023年，时间线存疑且2025-2026为未来日期，稳定性需核实；期望薪资7-8K与JD 8-10K倒挂，动机待探；无男性候选人优势（JD倾向男性）。\n\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：仅有私域用户运营经验，无薪资核算、物料发放等事务性工作经历；但网络客服经历涉及客户信息管理与跟进，基础事务处理能力可迁移。\n  - **订单安排能力：1/5分。依据：简历未体现任何排班、调度、资源匹配经验；私域运营与订单安排的逻辑差异较大，需从零培养。\n  - **基础培训能力：3/5分。依据：持有幼教资格证，具备培训耐心与表达基础；有短视频文案撰写经验，可辅助培训内容产出；但无成人培训及家政专业内容经验。\n  - **应急对接能力：2/5分。依据：网络客服经历包含后台答疑与引流，有一定客户问题响应经验；但未体现急单处理、售后纠纷解决等高压场景。\n  - **沟通协作能力：4/5分。依据：直播实战、跨校漫展组织、私域运营均验证强沟通能力；简历自述\"极强的与人沟通能力\"；需核实非工作时间响应意愿。\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. \"请描述一次你需要同时协调多方资源完成活动的经历（如漫展），当时遇到了什么冲突，如何解决的？\"\n    2. \"私域运营中是否遇到过客户投诉或突发负面情况？具体如何处理，结果如何？\"\n    3. \"简历显示4年工作经验，但教育时间为2020-2023年，能否详细",
    "aiScreen": "存疑",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"请描述一次你需要同时协调多方资源完成活动的经历（如漫展），当时遇到了什么冲突，如何解决的？\"\n2. \"私域运营中是否遇到过客户投诉或突发负面情况？具体如何处理，结果如何？\"\n3. \"简历显示4年工作经验，但教育时间为2020-2023年，能否详细说明工作经历的具体时间段？未来是否有考研、考编等计划？\"\n4. \"假设一位月嫂因突发疾病需临时下户，客户次日就要生产，你会如何快速协调替换人员并安抚客户？\"\n5. \"请现场设计一个针对新入职月嫂的'上户礼仪'培训课程大纲，限时3分钟。\"",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：仅有私域用户运营经验，无薪资核算、物料发放等事务性工作经历；但网络客服经历涉及客户信息管理与跟进，基础事务处理能力可迁移。\n2. **订单安排能力：1/5分。依据：简历未体现任何排班、调度、资源匹配经验；私域运营与订单安排的逻辑差异较大，需从零培养。\n3. **基础培训能力：3/5分。依据：持有幼教资格证，具备培训耐心与表达基础；有短视频文案撰写经验，可辅助培训内容产出；但无成人培训及家政专业内容经验。\n4. **应急对接能力：2/5分。依据：网络客服经历包含后台答疑与引流，有一定客户问题响应经验；但未体现急单处理、售后纠纷解决等高压场景。\n5. **沟通协作能力：4/5分。依据：直播实战、跨校漫展组织、私域运营均验证强沟通能力；简历自述\"极强的与人沟通能力\"；需核实非工作时间响应意愿。",
    "created": ""
  },
  {
    "id": 175,
    "name": "李阳",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "李",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备数据可视化与报告撰写能力，熟练使用Excel、FineBI等工具，有跨部门协作经验；数字化工具应用能力可迁移至家政服务标准化管理，学习能力强。",
    "risks": "求职意向为数据分析师，与商家运营专员岗位偏差大；零家政/母婴行业经验，无人员管理、薪资发放、订单调度实操背景；简历未体现\"性格开朗善于沟通\"等软性特质，文化匹配度存疑。",
    "aiEval": "- 初筛结果：淘汰\n\n- 优势分析：具备数据可视化与报告撰写能力，熟练使用Excel、FineBI等工具，有跨部门协作经验；数字化工具应用能力可迁移至家政服务标准化管理，学习能力强。\n\n- 风险点：求职意向为数据分析师，与商家运营专员岗位偏差大；零家政/母婴行业经验，无人员管理、薪资发放、订单调度实操背景；简历未体现\"性格开朗善于沟通\"等软性特质，文化匹配度存疑。\n\n- 能力维度匹配：\n  - **人员维护能力：1/5分。依据：仅有数据处理经验，无薪资核算、物料发放、人员日常管理等实操经历，行业场景完全陌生。\n  - **订单安排能力：0/5分。依据：简历无任何订单调度、资源匹配、换单协调相关经验，核心职能缺失。\n  - **基础培训能力：0/5分。依据：无培训组织、课程开发、人员带教经验，未体现面向一线服务者的沟通能力。\n  - **应急对接能力：1/5分。依据：仅有\"响应业务部门临时数据需求\"经历，无客户售后、急单处理等高压场景经验。\n  - **沟通协作能力：2/5分。依据：跨部门协作取数属被动响应，未主动展示\"性格开朗、善于沟通\"特质；无证据支持非工作时间响应意愿。\n\n- 建议追问的面试问题：\n  - 行为面试问题1：请描述一次你主动协调多方资源解决突发问题的经历，当时各方诉求冲突吗？你如何平衡？\n  - 行为面试问题2：过往工作中是否有过服务对象（如客户、供应商）情绪激动或投诉的情况？你如何处理并跟进？\n  - 行为面试问题3：你的职业规划是数据分析师，如何看待商家运营专员偏执行、服务属性的工作？若入职后1-2年仍在此岗位，你会如何调整心态？\n  - 技术评估问题1：假设一位月嫂因家中急事需临时下户，客户次日就要生产，你如何在现有资源库中快速匹配替换人选？请描述你的思路和操作步骤。\n  - 技术评估问题2：公司要求每月5日前完成上月月嫂工资、奖金、路费核算发放，但",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你主动协调多方资源解决突发问题的经历，当时各方诉求冲突吗？你如何平衡？\n2. 过往工作中是否有过服务对象（如客户、供应商）情绪激动或投诉的情况？你如何处理并跟进？\n3. 你的职业规划是数据分析师，如何看待商家运营专员偏执行、服务属性的工作？若入职后1-2年仍在此岗位，你会如何调整心态？\n4. 假设一位月嫂因家中急事需临时下户，客户次日就要生产，你如何在现有资源库中快速匹配替换人选？请描述你的思路和操作步骤。\n5. 公司要求每月5日前完成上月月嫂工资、奖金、路费核算发放，但部分月嫂提交票据不全、信息有误，你会如何设计流程减少差错并保证时效？\n6. 关于天鹅到家的业务模式、这个岗位的日常挑战，或者你未来可能加入的团队，有什么特别想了解的吗？",
    "capabilityMatch": "1. **人员维护能力：1/5分。依据：仅有数据处理经验，无薪资核算、物料发放、人员日常管理等实操经历，行业场景完全陌生。\n2. **订单安排能力：0/5分。依据：简历无任何订单调度、资源匹配、换单协调相关经验，核心职能缺失。\n3. **基础培训能力：0/5分。依据：无培训组织、课程开发、人员带教经验，未体现面向一线服务者的沟通能力。\n4. **应急对接能力：1/5分。依据：仅有\"响应业务部门临时数据需求\"经历，无客户售后、急单处理等高压场景经验。\n5. **沟通协作能力：2/5分。依据：跨部门协作取数属被动响应，未主动展示\"性格开朗、善于沟通\"特质；无证据支持非工作时间响应意愿。",
    "created": ""
  },
  {
    "id": 176,
    "name": "李卓",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "李",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "4年电商运营经验，具备强跨部门协调能力（两周内拉通6部门完成0-1搭建），擅长人员对接与资源管理（拓展达人、跟进MCN），数据敏感度高，熟练使用数字化工具（蝉妈妈/飞瓜），契合家政服务数字化运营需求。",
    "risks": "行业经验断层（互联网电商→家政服务），无母婴/家政领域知识储备；履历稳定性存疑（2022年3段工作，最长16个月）；性别与JD隐含偏好冲突（\"男\"为任职要求，候选人为女性）；薪资预期8-10K可能高于家政运营岗预算。",
    "aiEval": "- 初筛结果：存疑\n\n- 优势分析：4年电商运营经验，具备强跨部门协调能力（两周内拉通6部门完成0-1搭建），擅长人员对接与资源管理（拓展达人、跟进MCN），数据敏感度高，熟练使用数字化工具（蝉妈妈/飞瓜），契合家政服务数字化运营需求。\n\n- 风险点：行业经验断层（互联网电商→家政服务），无母婴/家政领域知识储备；履历稳定性存疑（2022年3段工作，最长16个月）；性别与JD隐含偏好冲突（\"男\"为任职要求，候选人为女性）；薪资预期8-10K可能高于家政运营岗预算。\n\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：无直接薪资发放或一线人员管理经验，仅有达人资源维护经验，家政人员管理场景差异大。**\n  - **订单安排能力：3/5分。依据：具备直播排期、达人档期协调经验，但无家政服务订单调度或换单处理经验，可迁移性中等。**\n  - **基础培训能力：1/5分。依据：简历未体现任何培训经验，电商运营背景与月嫂育婴师培训场景无关联。**\n  - **应急对接能力：3/5分。依据：有明星直播专场应急执行经验（单场GMV250w+），具备高压下多线程处理能力，但无售后客诉处理经验。**\n  - **沟通协作能力：4/5分。依据：自我评价明确\"高度责任心、跨部门协作沟通能力\"，经历中多次验证（拉通6部门、对接品牌方/达人/MCN/小二）。**\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. \"请描述一次你需要在非工作时间紧急协调多方资源解决问题的经历，当时如何处理工作与生活的边界？\"\n    2. \"电商运营中常需处理达人临时违约或直播事故，请举例说明你如何快速响应并降低损失，这与家政急单场景有何相似性？\"\n    3. \"你近3份工作平均在职时长约12个月，加入家政行业作为新赛道，你如何规划未来2-3年的职业发展以保障稳定性？\"\n  - 技",
    "aiScreen": "存疑",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"请描述一次你需要在非工作时间紧急协调多方资源解决问题的经历，当时如何处理工作与生活的边界？\"\n2. \"电商运营中常需处理达人临时违约或直播事故，请举例说明你如何快速响应并降低损失，这与家政急单场景有何相似性？\"\n3. \"你近3份工作平均在职时长约12个月，加入家政行业作为新赛道，你如何规划未来2-3年的职业发展以保障稳定性？\"\n4. \"假设一位月嫂因突发疾病无法上户，距客户预产期仅剩2天，请简述你的应急处理流程（无需专业护理知识，侧重协调逻辑）。\"\n5. \"Excel中需统计30位月嫂的工时、绩效奖金及路费报销，你会如何设计表格结构确保高效准确发放？请现场描述关键字段和公式思路。\"",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：无直接薪资发放或一线人员管理经验，仅有达人资源维护经验，家政人员管理场景差异大。**\n2. **订单安排能力：3/5分。依据：具备直播排期、达人档期协调经验，但无家政服务订单调度或换单处理经验，可迁移性中等。**\n3. **基础培训能力：1/5分。依据：简历未体现任何培训经验，电商运营背景与月嫂育婴师培训场景无关联。**\n4. **应急对接能力：3/5分。依据：有明星直播专场应急执行经验（单场GMV250w+），具备高压下多线程处理能力，但无售后客诉处理经验。**\n5. **沟通协作能力：4/5分。依据：自我评价明确\"高度责任心、跨部门协作沟通能力\"，经历中多次验证（拉通6部门、对接品牌方/达人/MCN/小二）。**",
    "created": ""
  },
  {
    "id": 177,
    "name": "廖运婷",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "廖",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "4年数据审核经验，月均处理40000+单据准确率98%+，具备流程标准化与SOP搭建能力；有用户反馈收集、问题跟进及电话回访经验，服务意识与执行力强；27岁大专学历符合基础门槛，可快速上手事务性运营工作。",
    "risks": "无家政/母婴行业经验，月嫂薪资物料发放、订单调度等场景需从零学习；简历求职意向为\"运营助理\"而非本岗，动机存疑；过往工作均为后台审核/助理岗，未验证非工作时间响应意愿及一线服务承压能力。",
    "aiEval": "- 初筛结果：存疑\n- 优势分析：4年数据审核经验，月均处理40000+单据准确率98%+，具备流程标准化与SOP搭建能力；有用户反馈收集、问题跟进及电话回访经验，服务意识与执行力强；27岁大专学历符合基础门槛，可快速上手事务性运营工作。\n- 风险点：无家政/母婴行业经验，月嫂薪资物料发放、订单调度等场景需从零学习；简历求职意向为\"运营助理\"而非本岗，动机存疑；过往工作均为后台审核/助理岗，未验证非工作时间响应意愿及一线服务承压能力。\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：无月嫂/家政人员管理经验，但有4年费用结算审核经验，涉及工资奖金类数据核对，可迁移至薪资发放场景，需培训上岗。\n  - **订单安排能力：1/5分。依据：简历未体现任何订单调度、资源匹配或排期管理经验，此为核心技能缺口。\n  - **基础培训能力：2/5分。依据：无培训授课经验，但有流程标准化与SOP沉淀经验，曾将分散经验转化为可复用规则，具备培训素材整理基础。\n  - **应急对接能力：3/5分。依据：审核岗中快速识别异常、追溯原因并推动解决，有较强风险意识与问题闭环能力；协助推进每月核心业务节点，适配急单响应节奏。\n  - **沟通协作能力：3/5分。依据：有电话回访用户、收集反馈并跨部门同步经验；自我评价强调\"沟通耐心\"，但未明确体现\"性格开朗\"及非工作时间响应意愿，需面试验证。\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. 请描述一次你处理大量紧急单据或任务的经历，当时如何分配优先级并确保零差错？（验证抗压与多任务处理）\n    2. 审核岗常需跨部门推动问题解决，请举例说明你如何说服不配合的同事或外部方配合完成目标？（验证沟通协调）\n    3. 你过往岗位多为后台支持，本岗需直接服务月嫂并随时响应，是什么吸引你转向一线服务岗？（验证动机与稳定性",
    "aiScreen": "存疑",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你处理大量紧急单据或任务的经历，当时如何分配优先级并确保零差错？（验证抗压与多任务处理）\n2. 审核岗常需跨部门推动问题解决，请举例说明你如何说服不配合的同事或外部方配合完成目标？（验证沟通协调）\n3. 你过往岗位多为后台支持，本岗需直接服务月嫂并随时响应，是什么吸引你转向一线服务岗？（验证动机与稳定性）\n4. 假设一位月嫂因薪资计算错误情绪激动来电，请模拟你的沟通话术及处理步骤。（验证人员维护与应急对接）\n5. 现有5位月嫂档期冲突，3个急单需当日匹配，你会如何快速决策并沟通安排？（验证订单安排能力）",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：无月嫂/家政人员管理经验，但有4年费用结算审核经验，涉及工资奖金类数据核对，可迁移至薪资发放场景，需培训上岗。\n2. **订单安排能力：1/5分。依据：简历未体现任何订单调度、资源匹配或排期管理经验，此为核心技能缺口。\n3. **基础培训能力：2/5分。依据：无培训授课经验，但有流程标准化与SOP沉淀经验，曾将分散经验转化为可复用规则，具备培训素材整理基础。\n4. **应急对接能力：3/5分。依据：审核岗中快速识别异常、追溯原因并推动解决，有较强风险意识与问题闭环能力；协助推进每月核心业务节点，适配急单响应节奏。\n5. **沟通协作能力：3/5分。依据：有电话回访用户、收集反馈并跨部门同步经验；自我评价强调\"沟通耐心\"，但未明确体现\"性格开朗\"及非工作时间响应意愿，需面试验证。",
    "created": ""
  },
  {
    "id": 178,
    "name": "刘佳凝",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "刘",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "财务管理背景+双段市场运营经验，具备薪资核算、数据对账基础（匹配人员维护）；擅长社群运营、渠道对接与活动落地（匹配订单安排与沟通协作）；学生会干部经历体现多线程事务管理与团队协调能力；性格开朗、接受非工作时间响应，契合家政服务弹性需求。",
    "risks": "零家政/母婴行业经验，基础培训能力存疑；2026年应届生，实习结束于2025年12月，当前求职稳定性需验证；风控审核岗强调\"降低差错\"，与家政服务\"温度感\"文化或存张力；性别女与JD偏好\"男\"存在隐性冲突。",
    "aiEval": "- 初筛结果：通过\n- 优势分析：财务管理背景+双段市场运营经验，具备薪资核算、数据对账基础（匹配人员维护）；擅长社群运营、渠道对接与活动落地（匹配订单安排与沟通协作）；学生会干部经历体现多线程事务管理与团队协调能力；性格开朗、接受非工作时间响应，契合家政服务弹性需求。\n- 风险点：零家政/母婴行业经验，基础培训能力存疑；2026年应届生，实习结束于2025年12月，当前求职稳定性需验证；风控审核岗强调\"降低差错\"，与家政服务\"温度感\"文化或存张力；性别女与JD偏好\"男\"存在隐性冲突。\n- 能力维度匹配：\n  - **人员维护能力：3/5分。依据：财务对账、营收数据处理经验丰富，具备薪资核算敏感度；但无月嫂群体管理经验，物料发放、路费报销等场景未涉及。\n  - **订单安排能力：3/5分。依据：高顿/电信实习中统筹活动、对接渠道、协调现场流程，具备多线程调度意识；但无家政订单匹配、换单协调等垂直场景实践。\n  - **基础培训能力：1/5分。依据：简历无培训授课、课程设计、知识传递相关经历；校内活动侧重\"策划执行\"而非\"人员培训\"，母婴护理知识储备为零。\n  - **应急对接能力：3/5分。依据：风控岗识别资质异常、输出风险评估，电信实习处理售前咨询与售后维护，具备问题响应与多方协调经验；但无急单对接、售后投诉处理等高压场景验证。\n  - **沟通协作能力：4/5分。依据：学生会干部+班长+社团部长三重身份，独立策划10+场活动，渠道拓展与团队协同经验丰富；性格开朗、善于沟通为自我明确特质，接受非工作时间回复意愿需面试确认。\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. \"请描述一次你需要同时处理多个紧急任务的经历，当时如何排序优先级并确保不出差错？\"\n    2. \"在你的实习中，遇到过客户或合作方情绪激动的情况吗？你是如何安抚并解决问题的？\"\n",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"请描述一次你需要同时处理多个紧急任务的经历，当时如何排序优先级并确保不出差错？\"\n2. \"在你的实习中，遇到过客户或合作方情绪激动的情况吗？你是如何安抚并解决问题的？\"\n3. \"家政服务顾问常需在深夜或节假日响应月嫂/客户需求，你过往经历中是否有类似非工作时间待命的经验？如何平衡工作与生活？\"\n4. \"假设一位月嫂因突发疾病无法上户，客户次日急需用人，你会如何快速协调换单？请描述具体步骤。\"\n5. \"月嫂群体普遍年龄偏大、流动性高，你认为开展'非专业培训'（如服务礼仪、平台规则）时，如何设计内容才能让他们愿意听、听得懂？\"",
    "capabilityMatch": "1. **人员维护能力：3/5分。依据：财务对账、营收数据处理经验丰富，具备薪资核算敏感度；但无月嫂群体管理经验，物料发放、路费报销等场景未涉及。\n2. **订单安排能力：3/5分。依据：高顿/电信实习中统筹活动、对接渠道、协调现场流程，具备多线程调度意识；但无家政订单匹配、换单协调等垂直场景实践。\n3. **基础培训能力：1/5分。依据：简历无培训授课、课程设计、知识传递相关经历；校内活动侧重\"策划执行\"而非\"人员培训\"，母婴护理知识储备为零。\n4. **应急对接能力：3/5分。依据：风控岗识别资质异常、输出风险评估，电信实习处理售前咨询与售后维护，具备问题响应与多方协调经验；但无急单对接、售后投诉处理等高压场景验证。\n5. **沟通协作能力：4/5分。依据：学生会干部+班长+社团部长三重身份，独立策划10+场活动，渠道拓展与团队协同经验丰富；性格开朗、善于沟通为自我明确特质，接受非工作时间回复意愿需面试确认。",
    "created": ""
  },
  {
    "id": 179,
    "name": "刘玉碧",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "刘",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备平台运营与客户全生命周期管理经验，擅长资源协调、活动策划及跨部门协作；数据敏感度高，能实时监控优化效果；有社群运营及SOP文档撰写经验，契合家政服务标准化、数字化需求。",
    "risks": "无家政/母婴行业背景，人员维护与基础培训能力待验证；工作经历仅1年且时间存疑（2024.07-2025.08为未来时段），稳定性需确认；接受非工作时间回复的意愿未明确体现。",
    "aiEval": "- 初筛结果：通过\n- 优势分析：具备平台运营与客户全生命周期管理经验，擅长资源协调、活动策划及跨部门协作；数据敏感度高，能实时监控优化效果；有社群运营及SOP文档撰写经验，契合家政服务标准化、数字化需求。\n- 风险点：无家政/母婴行业背景，人员维护与基础培训能力待验证；工作经历仅1年且时间存疑（2024.07-2025.08为未来时段），稳定性需确认；接受非工作时间回复的意愿未明确体现。\n- 能力维度匹配：\n  - **能力1-人员维护能力：2/5分。依据：无直接薪资物料发放经验，但有会员权益体系运营及精细化分层运营经验，可迁移至月嫂日常事务管理。**\n  - **能力2-订单安排能力：3/5分。依据：主导月度营销活动排期与资源位规划，具备多任务协调与流程管理能力，但无家政订单匹配经验。**\n  - **能力3-基础培训能力：2/5分。依据：撰写SOP文档、参与账号运营策略制定，有知识沉淀意识，但无面向服务人员培训的直接经验。**\n  - **能力4-应急对接能力：3/5分。依据：处理异常订单、协同客服团队快速响应，具备售后问题处理与跨部门协作经验。**\n  - **能力5-沟通协作能力：4/5分。依据：多次强调协同客服、销售、设计团队，通过多渠道精准触达用户，性格开朗善于沟通符合任职要求。**\n- 建议追问的面试问题：\n  - 行为面试问题1：请描述一次你需要协调多个部门解决突发问题的经历，当时如何推动各方达成一致？\n  - 行为面试问题2：过往工作中是否有过非工作时间处理紧急事务的情况，你如何平衡工作与生活？\n  - 行为面试问题3：面对服务人员（如月嫂）对薪资或安排不满的投诉，你会如何沟通处理？\n  - 技术评估问题1：家政服务人员流动性高，你会如何设计机制提升其留存率？请结合过往会员运营经验说明。\n  - 技术评估问题2：若需为月嫂制定一份\"上户服务标准\"非专业培",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你需要协调多个部门解决突发问题的经历，当时如何推动各方达成一致？\n2. 过往工作中是否有过非工作时间处理紧急事务的情况，你如何平衡工作与生活？\n3. 面对服务人员（如月嫂）对薪资或安排不满的投诉，你会如何沟通处理？\n4. 家政服务人员流动性高，你会如何设计机制提升其留存率？请结合过往会员运营经验说明。\n5. 若需为月嫂制定一份\"上户服务标准\"非专业培训材料，你的撰写思路是什么？",
    "capabilityMatch": "1. **能力1-人员维护能力：2/5分。依据：无直接薪资物料发放经验，但有会员权益体系运营及精细化分层运营经验，可迁移至月嫂日常事务管理。**\n2. **能力2-订单安排能力：3/5分。依据：主导月度营销活动排期与资源位规划，具备多任务协调与流程管理能力，但无家政订单匹配经验。**\n3. **能力3-基础培训能力：2/5分。依据：撰写SOP文档、参与账号运营策略制定，有知识沉淀意识，但无面向服务人员培训的直接经验。**\n4. **能力4-应急对接能力：3/5分。依据：处理异常订单、协同客服团队快速响应，具备售后问题处理与跨部门协作经验。**\n5. **能力5-沟通协作能力：4/5分。依据：多次强调协同客服、销售、设计团队，通过多渠道精准触达用户，性格开朗善于沟通符合任职要求。**",
    "created": ""
  },
  {
    "id": 180,
    "name": "刘云栖",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "刘",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "26届应届生，会计专业背景契合薪资物料发放与数据管理需求；私域运营经验锻炼了一对一沟通与需求挖掘能力；小红书运营验证内容策划与数据分析能力；ERP系统实操经历直接匹配订单流程管理；性格外向、抗压能力强，适应家政服务高频沟通场景。",
    "risks": "无家政/母婴行业经验，需从零学习业务知识；2026年6月才毕业，到岗时间可能不匹配；月休8天期望与岗位非工作时间信息回复要求存在潜在冲突；男性候选人在月嫂/育婴师服务场景中可能面临服务人员信任建立挑战。",
    "aiEval": "- 初筛结果：通过\n- 优势分析：26届应届生，会计专业背景契合薪资物料发放与数据管理需求；私域运营经验锻炼了一对一沟通与需求挖掘能力；小红书运营验证内容策划与数据分析能力；ERP系统实操经历直接匹配订单流程管理；性格外向、抗压能力强，适应家政服务高频沟通场景。\n- 风险点：无家政/母婴行业经验，需从零学习业务知识；2026年6月才毕业，到岗时间可能不匹配；月休8天期望与岗位非工作时间信息回复要求存在潜在冲突；男性候选人在月嫂/育婴师服务场景中可能面临服务人员信任建立挑战。\n- 能力维度匹配：\n  - **人员维护能力：3/5分。依据：会计专业训练具备薪资核算基础，ERP实训有账务处理经验，但无实际工资发放或物料管理经验，缺乏家政服务人员管理场景实践。\n  - **订单安排能力：3/5分。依据：ERP系统全流程操作经历覆盖订单-库存-收款链条，能快速上手系统；但无实际排班、换单调度经验，家政服务动态匹配复杂度更高。\n  - **基础培训能力：2/5分。依据：私域运营中有产品讲解与用户引导经验，校园经历含活动策划；但无面向成人劳动者培训经验，母婴护理等非专业内容需从零学习。\n  - **应急对接能力：2/5分。依据：实习中处理过用户疑问与突发反馈，具备基础问题解决意识；但无急单对接、售后纠纷处理经验，家政服务售后场景复杂度未经验证。\n  - **沟通协作能力：4/5分。依据：简历多次强调\"性格外向开朗\"\"善于与不同角色建立有效沟通\"，私域运营、权益部谈判、跨部门对接均有实证，高度匹配岗位核心要求。\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    - 请描述一次你需要同时处理多位用户/客户紧急需求并协调资源的经历，当时如何排序优先级并确保各方满意？\n    - 权益部对接食堂管理方时，遇到双方诉求冲突无法快速达成共识的情况，你具体如何推动解决？最终结果如何？\n",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你需要同时处理多位用户/客户紧急需求并协调资源的经历，当时如何排序优先级并确保各方满意？\n2. 权益部对接食堂管理方时，遇到双方诉求冲突无法快速达成共识的情况，你具体如何推动解决？最终结果如何？\n3. 该岗位需要非工作时间响应信息，结合你的作息习惯，请举例说明你曾如何在高强度或弹性工作节奏下保持长期投入？\n4. 假设一位月嫂因突发家庭原因需紧急下户，客户订单次日就要生效，你会如何快速协调换单并安抚客户情绪？请描述具体步骤。\n5. 请用Excel设计一张简单的月嫂工资核算表框架，需包含基本工资、奖金、路费扣减项，并说明如何用函数避免计算错误。",
    "capabilityMatch": "1. **人员维护能力：3/5分。依据：会计专业训练具备薪资核算基础，ERP实训有账务处理经验，但无实际工资发放或物料管理经验，缺乏家政服务人员管理场景实践。\n2. **订单安排能力：3/5分。依据：ERP系统全流程操作经历覆盖订单-库存-收款链条，能快速上手系统；但无实际排班、换单调度经验，家政服务动态匹配复杂度更高。\n3. **基础培训能力：2/5分。依据：私域运营中有产品讲解与用户引导经验，校园经历含活动策划；但无面向成人劳动者培训经验，母婴护理等非专业内容需从零学习。\n4. **应急对接能力：2/5分。依据：实习中处理过用户疑问与突发反馈，具备基础问题解决意识；但无急单对接、售后纠纷处理经验，家政服务售后场景复杂度未经验证。\n5. **沟通协作能力：4/5分。依据：简历多次强调\"性格外向开朗\"\"善于与不同角色建立有效沟通\"，私域运营、权益部谈判、跨部门对接均有实证，高度匹配岗位核心要求。",
    "created": ""
  },
  {
    "id": 181,
    "name": "柳静雨",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "柳",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备网约车平台运力运营经验，熟悉双边用户维护、激励活动落地及数据复盘；有线下门店运营与高强度服务经验，抗压能力与执行力较强；擅长数据整理与报表制作，可支撑数字化运营；沟通表达与客户服务意识经瑞幸咖啡师岗位验证。",
    "risks": "求职意向为\"运营助理/文员/信息流投放\"，与家政服务运营匹配度存疑；简历显示2026年1月才入职现公司，距今不足半年，稳定性待观察；无母婴/家政行业背景，月嫂育婴师专业知识为零；年龄20岁低于任职要求下限21岁；性别为女，与JD\"男\"冲突。",
    "aiEval": "- 初筛结果：存疑\n- 优势分析：具备网约车平台运力运营经验，熟悉双边用户维护、激励活动落地及数据复盘；有线下门店运营与高强度服务经验，抗压能力与执行力较强；擅长数据整理与报表制作，可支撑数字化运营；沟通表达与客户服务意识经瑞幸咖啡师岗位验证。\n- 风险点：求职意向为\"运营助理/文员/信息流投放\"，与家政服务运营匹配度存疑；简历显示2026年1月才入职现公司，距今不足半年，稳定性待观察；无母婴/家政行业背景，月嫂育婴师专业知识为零；年龄20岁低于任职要求下限21岁；性别为女，与JD\"男\"冲突。\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：有网约车司机端招募、资质审核、日常运维及社群维护经验，但无薪资物料发放实操；家政服务人员管理场景差异大，需从零学习。\n  - **订单安排能力：2/5分。依据：负责网约车派单规则优化，但\"换单\"涉及人员档期协调与突发调整，无直接经验；家政服务非标属性强，匹配逻辑不同。\n  - **基础培训能力：1/5分。依据：无培训相关经历；商务数据分析专业背景与月嫂育婴师非专业培训（如服务礼仪、沟通技巧）关联度低。\n  - **应急对接能力：3/5分。依据：处理过网约车客诉与出行纠纷，有售后问题响应经验；但\"急单对接\"需快速匹配人力，家政服务时效压力与出行场景差异显著。\n  - **沟通协作能力：4/5分。依据：简历明确\"性格开朗善于沟通\"，瑞幸与网约车岗位均验证高强度服务中的客户沟通与团队协作能力；接受非工作时间信息回复的意愿需面试确认。\n- 建议追问的面试问题：\n  - 行为面试问题1（沟通协调）：在网约车平台处理司机与乘客纠纷时，请描述一次双方诉求冲突激烈的具体案例，你如何平衡双边利益达成和解？\n  - 行为面试问题2（客户服务）：瑞幸咖啡高峰时段常出现排队与客诉，请举例说明你如何在高压下同时保障出品效率与顾客满意度？\n  - 行",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 在网约车平台处理司机与乘客纠纷时，请描述一次双方诉求冲突激烈的具体案例，你如何平衡双边利益达成和解？\n2. 瑞幸咖啡高峰时段常出现排队与客诉，请举例说明你如何在高压下同时保障出品效率与顾客满意度？\n3. 你目前的求职意向集中在运营助理/文员/信息流投放，为何考虑转向家政服务行业？如何看待该岗位与职业规划的关联？\n4. 月嫂服务中常出现客户临时要求更换服务人员的情况，请结合你的订单安排经验，说明你会如何快速响应并重新匹配？\n5. 假设一位月嫂因家庭突发状况需紧急下户，而客户次日即生产，你会如何协调资源确保服务不中断？",
    "capabilityMatch": "1. **人员维护能力：3/5分。依据：有网约车司机端招募、资质审核、社群运维及激励发放经验，但无月嫂薪资物料实操经验，行业场景差异大。\n2. **订单安排能力：3/5分。依据：负责网约车派单优化与运力调度，逻辑可迁移；但未涉及家政服务换单、档期协调等复杂人际匹配场景。\n3. **基础培训能力：2/5分。依据：无直接培训经验，仅提及\"解答各类问题\"；商务数据分析专业背景或可复制为数据化培训辅助，但非专业培训（如服务礼仪）无证据。\n4. **应急对接能力：3/5分。依据：处理过出行纠纷与客诉，具备售后响应意识；但\"急单对接\"涉及母婴服务紧急性，行业敏感度不足。\n5. **沟通协作能力：4/5分。依据：明确具备\"良好沟通表达、客户服务能力\"，有高强度服务行业团队协作经验，接受非工作时间响应在网约车经历中有体现。",
    "created": ""
  },
  {
    "id": 182,
    "name": "柳思林",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "柳",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "5年国企运营经验，具备标准化管理体系（QHSE）实操背景，与天鹅到家\"服务标准化\"高度契合；擅长人员排班、数据统计、报表处理，电脑操作熟练；执行力强，获\"青年岗位能手\"称号，责任心与抗压能力经国企验证。",
    "risks": "行业跨度大（石油能源→家政服务），无母婴/家政领域经验；28岁年龄接近上限边缘；期望薪资6-8K与岗位8-10K存在倒挂，需确认真实动机；男性身份在家政月嫂维护场景中或存在客户/从业者信任建立挑战。",
    "aiEval": "- 初筛结果：存疑\n\n- 优势分析：5年国企运营经验，具备标准化管理体系（QHSE）实操背景，与天鹅到家\"服务标准化\"高度契合；擅长人员排班、数据统计、报表处理，电脑操作熟练；执行力强，获\"青年岗位能手\"称号，责任心与抗压能力经国企验证。\n\n- 风险点：行业跨度大（石油能源→家政服务），无母婴/家政领域经验；28岁年龄接近上限边缘；期望薪资6-8K与岗位8-10K存在倒挂，需确认真实动机；男性身份在家政月嫂维护场景中或存在客户/从业者信任建立挑战。\n\n- 能力维度匹配：\n  - **人员维护能力：3/5分。依据：有加油站人员排班、薪资核算、物料管理经验，但服务对象为加油站员工而非家政劳动者，场景差异较大。\n  - **订单安排能力：2/5分。依据：涉及油品进销存管理，具备基础资源调度意识，但无服务类订单匹配或换单处理经验。\n  - **基础培训能力：3/5分。依据：开展过员工服务规范、安全操作培训，具备培训组织经验，但缺乏母婴/家政非专业培训内容。\n  - **应急对接能力：3/5分。依据：处理过站点突发情况、应急演练组织，有应急响应意识，但无客户服务售后或急单对接场景。\n  - **沟通协作能力：4/5分。依据：简历自述\"性格开朗善于沟通\"，有团队管理、跨部门协作经历，接受非工作时间信息回复意愿需确认。\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. \"请描述一次您处理员工对排班或薪资发放产生强烈不满的经历，您如何沟通化解？\"\n    2. \"国企工作5年后选择转行家政行业，请分享这一决策背后的具体考量，您如何看待行业落差？\"\n    3. \"请举例说明您在非工作时间处理紧急事务的经历，如何平衡工作与生活边界？\"\n  - 技术评估问题（2个）：\n    1. \"假设一位月嫂因客户投诉被临时换单，情绪激烈拒绝配合，您会如何一步步处理？\"\n    2",
    "aiScreen": "存疑",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"请描述一次您处理员工对排班或薪资发放产生强烈不满的经历，您如何沟通化解？\"\n2. \"国企工作5年后选择转行家政行业，请分享这一决策背后的具体考量，您如何看待行业落差？\"\n3. \"请举例说明您在非工作时间处理紧急事务的经历，如何平衡工作与生活边界？\"\n4. \"假设一位月嫂因客户投诉被临时换单，情绪激烈拒绝配合，您会如何一步步处理？\"\n5. \"请设计一个针对新入职月嫂的'非专业培训'30分钟课程大纲，主题自选。\"",
    "capabilityMatch": "1. **人员维护能力：3/5分。依据：有加油站人员排班、薪资核算、物料管理经验，但服务对象为加油站员工而非家政劳动者，场景差异较大。\n2. **订单安排能力：2/5分。依据：涉及油品进销存管理，具备基础资源调度意识，但无服务类订单匹配或换单处理经验。\n3. **基础培训能力：3/5分。依据：开展过员工服务规范、安全操作培训，具备培训组织经验，但缺乏母婴/家政非专业培训内容。\n4. **应急对接能力：3/5分。依据：处理过站点突发情况、应急演练组织，有应急响应意识，但无客户服务售后或急单对接场景。\n5. **沟通协作能力：4/5分。依据：简历自述\"性格开朗善于沟通\"，有团队管理、跨部门协作经历，接受非工作时间信息回复意愿需确认。",
    "created": ""
  },
  {
    "id": 183,
    "name": "陆女士",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "陆",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备1年商品运营实操经验，熟悉全链路管理与数据复盘，擅长跨部门协同与精细化运营；有即时零售/电商背景，对标准化流程、数字化工具敏感度高，可迁移至家政服务数字化管理。",
    "risks": "无家政/母婴行业经验，人员维护、订单调度等核心技能为零；简历时间线存疑（2025.8-2026.5为\"未来\"经历）；期望薪资6-8K与JD定位匹配度不明；测控技术专业背景与岗位关联弱，稳定性待验证。",
    "aiEval": "- 初筛结果：存疑\n\n- 优势分析：具备1年商品运营实操经验，熟悉全链路管理与数据复盘，擅长跨部门协同与精细化运营；有即时零售/电商背景，对标准化流程、数字化工具敏感度高，可迁移至家政服务数字化管理。\n\n- 风险点：无家政/母婴行业经验，人员维护、订单调度等核心技能为零；简历时间线存疑（2025.8-2026.5为\"未来\"经历）；期望薪资6-8K与JD定位匹配度不明；测控技术专业背景与岗位关联弱，稳定性待验证。\n\n- 能力维度匹配：\n  - **人员维护能力：1/5分。依据：无月嫂/育婴师管理经验，仅有商品库存监控经历，薪资发放对象为商品非人员，场景差异大。**\n  - **订单安排能力：1/5分。依据：无服务类订单调度经验，电商商品上下架与月嫂换单逻辑不同，未体现复杂资源匹配能力。**\n  - **基础培训能力：0/5分。依据：简历未提及任何培训相关经历，非专业培训（如企业文化、服务规范）亦无佐证。**\n  - **应急对接能力：2/5分。依据：有营销活动执行与数据复盘经验，具备基础问题响应意识，但无急单处理、售后纠纷解决等家政场景实战。**\n  - **沟通协作能力：3/5分。依据：多次强调\"协同跨部门\"\"对接品牌资源\"，具备基础沟通协作意识；但\"性格开朗\"等软性特质无文本证据，非工作时间响应意愿未验证。**\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. \"请描述一次你需要同时协调多个部门、在紧迫时间内完成资源调配的经历，当时如何确保信息同步与执行落地？\"\n    2. \"电商运营中常遇突发库存或客诉问题，请举例说明你如何处理紧急状况并安抚相关方情绪？\"\n    3. \"你期望在一份工作中持续深耕多久？过往实习/工作中，什么情况下会选择离开？\"\n  - 技术评估问题（2个）：\n    1. \"月嫂服务中常出现客户临时更换需求或阿姨突发状况，你",
    "aiScreen": "淘汰",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"请描述一次你需要同时协调多个部门、在紧迫时间内完成资源调配的经历，当时如何确保信息同步与执行落地？\"\n2. \"电商运营中常遇突发库存或客诉问题，请举例说明你如何处理紧急状况并安抚相关方情绪？\"\n3. \"你期望在一份工作中持续深耕多久？过往实习/工作中，什么情况下会选择离开？\"\n4. \"月嫂服务中常出现客户临时更换需求或阿姨突发状况，你会如何快速重新匹配资源并降低各方损失？\"\n5. \"假设需为新手月嫂设计一节'上户服务规范'非专业培训课，请简述你的课程框架设计思路。\"",
    "capabilityMatch": "1. **人员维护能力：1/5分。依据：无月嫂/育婴师管理经验，仅有商品库存监控经历，薪资发放对象为商品非人员，场景差异大。**\n2. **订单安排能力：1/5分。依据：无服务类订单调度经验，电商商品上下架与月嫂换单逻辑不同，未体现复杂资源匹配能力。**\n3. **基础培训能力：0/5分。依据：简历未提及任何培训相关经历，非专业培训（如企业文化、服务规范）亦无佐证。**\n4. **应急对接能力：2/5分。依据：有营销活动执行与数据复盘经验，具备基础问题响应意识，但无急单处理、售后纠纷解决等家政场景实战。**\n5. **沟通协作能力：3/5分。依据：多次强调\"协同跨部门\"\"对接品牌资源\"，具备基础沟通协作意识；但\"性格开朗\"等软性特质无文本证据，非工作时间响应意愿未验证。**",
    "created": ""
  },
  {
    "id": 184,
    "name": "罗露",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "罗",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备风险防控与产品运营经验，有数字化工具应用能力（AI模型训练），沟通协调与跨部门协作能力有文本支撑，学习意愿强。但核心优势与家政服务场景关联度低。",
    "risks": "①行业经验断层：6年工作经历集中于互联网风控/运营，无家政、母婴、蓝领劳动者管理背景；②技能错配：JD要求月嫂薪资发放、订单调度、售后处理等实操性工作，候选人经验偏向规则制定、模型训练等中后台职能；③稳定性存疑：26岁、4年经验、期望8-11K，与岗位定位（基础执行岗、大专学历门槛）存在预期落差。",
    "aiEval": "- 初筛结果：淘汰\n\n- 优势分析：具备风险防控与产品运营经验，有数字化工具应用能力（AI模型训练），沟通协调与跨部门协作能力有文本支撑，学习意愿强。但核心优势与家政服务场景关联度低。\n\n- 风险点：①行业经验断层：6年工作经历集中于互联网风控/运营，无家政、母婴、蓝领劳动者管理背景；②技能错配：JD要求月嫂薪资发放、订单调度、售后处理等实操性工作，候选人经验偏向规则制定、模型训练等中后台职能；③稳定性存疑：26岁、4年经验、期望8-11K，与岗位定位（基础执行岗、大专学历门槛）存在预期落差。\n\n- 能力维度匹配：\n  - **人员维护能力：1/5分。依据**：简历无薪资核算、物料管理、蓝领群体服务经验，仅\"产品运营\"中提及\"用户反馈\"，场景不匹配。\n  - **订单安排能力：0/5分。依据**：无排班调度、资源匹配、订单履约相关经验，工作内容以风控规则、AI模型为主。\n  - **基础培训能力：1/5分。依据**：无法务/家政领域培训经验，\"法律知识图谱\"项目属技术工具开发，非面向劳动者培训。\n  - **应急对接能力：2/5分。依据**：\"风险防控\"涉及事中规则与事后监测，有一定问题响应意识，但无客户服务、售后处理实操，\"急单\"场景零经验。\n  - **沟通协作能力：3/5分。依据**：自述\"良好沟通协调能力\"\"跨部门合作\"，但缺乏具体案例支撑，且未体现\"非工作时间响应\"的适应性验证。\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. 请描述一次你需要在深夜或节假日处理紧急工作需求的经历，当时如何平衡个人时间与工作响应？\n    2. 你过往服务的人群以互联网用户或企业客户为主，若转向服务学历背景多元、年龄偏大的月嫂群体，你会如何调整沟通方式？请举例说明。\n    3. 你的职业路径从风控转向运营再到求职家政行业，请分享这一转变的核心动机，以及如",
    "aiScreen": "淘汰",
    "hrReview": "淘汰",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你需要在深夜或节假日处理紧急工作需求的经历，当时如何平衡个人时间与工作响应？\n2. 你过往服务的人群以互联网用户或企业客户为主，若转向服务学历背景多元、年龄偏大的月嫂群体，你会如何调整沟通方式？请举例说明。\n3. 你的职业路径从风控转向运营再到求职家政行业，请分享这一转变的核心动机，以及如何看待基层执行岗与过往中后台角色的差异？\n4. 月嫂因突发疾病需临时换单，但备选人员档期冲突，你会如何快速协调资源并安抚客户情绪？请分步骤说明。\n5. 请现场演示：用Excel设计一张月嫂月度薪资计算表，需包含基础工资、订单提成、路费补贴、扣款项及实发金额字段。",
    "capabilityMatch": "1. **人员维护能力：1/5分。依据**：简历无薪资核算、物料管理、蓝领群体服务经验，仅\"产品运营\"中提及\"用户反馈\"，场景不匹配。\n2. **订单安排能力：0/5分。依据**：无排班调度、资源匹配、订单履约相关经验，工作内容以风控规则、AI模型为主。\n3. **基础培训能力：1/5分。依据**：无法务/家政领域培训经验，\"法律知识图谱\"项目属技术工具开发，非面向劳动者培训。\n4. **应急对接能力：2/5分。依据**：\"风险防控\"涉及事中规则与事后监测，有一定问题响应意识，但无客户服务、售后处理实操，\"急单\"场景零经验。\n5. **沟通协作能力：3/5分。依据**：自述\"良好沟通协调能力\"\"跨部门合作\"，但缺乏具体案例支撑，且未体现\"非工作时间响应\"的适应性验证。",
    "created": ""
  },
  {
    "id": 185,
    "name": "吕扬涛",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "吕",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备3年电商运营与客服经验，熟悉千牛等数字化工具，擅长客户沟通、订单跟踪及售后处理，与天鹅到家\"服务标准化+数字化\"业务高度契合；有社群运营及分销商维护经验，人员维护与多线程协调能力可迁移；自我评价强调抗压性、团队协作，匹配非工作时间响应要求。",
    "risks": "家政行业经验空白，母婴护理专业知识缺失；履历显示3段工作经历均不足1年（最长10个月），存在稳定性疑虑；物流管理专业与岗位关联度低，需验证转行动机；男性身份在家政服务场景中或面临月嫂/育婴师沟通信任壁垒。",
    "aiEval": "- 初筛结果：通过\n\n- 优势分析：具备3年电商运营与客服经验，熟悉千牛等数字化工具，擅长客户沟通、订单跟踪及售后处理，与天鹅到家\"服务标准化+数字化\"业务高度契合；有社群运营及分销商维护经验，人员维护与多线程协调能力可迁移；自我评价强调抗压性、团队协作，匹配非工作时间响应要求。\n\n- 风险点：家政行业经验空白，母婴护理专业知识缺失；履历显示3段工作经历均不足1年（最长10个月），存在稳定性疑虑；物流管理专业与岗位关联度低，需验证转行动机；男性身份在家政服务场景中或面临月嫂/育婴师沟通信任壁垒。\n\n- 能力维度匹配：\n  - **人员维护能力：3/5分。依据：有分销商关系维护、客户回访经验，但无薪资核算、物料发放等具体场景；电商客服与家政服务人员管理差异较大，需验证 transferable skills。\n  - **订单安排能力：4/5分。依据：售后客服阶段处理退款退货订单分级、物流跟踪；运营助理阶段负责货品物流及发货动向跟踪，订单全流程管理经验丰富，换单场景可类比电商退换货处理。\n  - **基础培训能力：2/5分。依据：仅有安全生产培训经验（顺丰稽查员），对象为快递员而非服务人员；无月嫂/育婴师群体培训经历，非专业培训能力待验证。\n  - **应急对接能力：4/5分。依据：太平鸟双十一大流量应急处理、售后客诉跟踪解决；博津电器每日100-200接待量、丢件/机器问题处理，高压售后场景成熟，云管家售后可迁移。\n  - **沟通协作能力：4/5分。依据：简历自述\"性格开朗善于沟通\"\"较强抗压性\"\"团队协作\"，多段经历涉及跨部门对接（运营-客服-物流）；但缺乏家政服务者（女性为主）沟通实证，性别因素或成隐性障碍。\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. \"请描述一次你同时处理多个紧急客户投诉的经历，当时如何优先级排序并确保每个问题闭环？\"",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你处理客户紧急投诉并成功化解危机的具体案例，当时的时间压力有多大？你如何在非工作时间响应？\n2. 你过往经历中需要协调多方资源解决复杂问题的场景是什么？请举例说明如何说服不配合的对方达成共识。\n3. 你的工作经历中每段时长较短，能否说明离职原因？如果加入天鹅到家，你计划如何保持稳定？\n4. 月嫂群体以中年女性为主，作为男性管理者，你计划如何快速建立信任并有效开展日常沟通？请给出具体策略。\n5. 假设一位月嫂因突发疾病无法上户，客户要求立即更换且态度激烈，顾问暂时无法响应，你会如何一步步处理？",
    "capabilityMatch": "1. **人员维护能力：3/5分。依据：有分销商关系维护、客户回访经验，但无薪资核算、物料发放等具体场景；电商客服与家政服务人员管理差异较大，需验证 transferable skills。\n2. **订单安排能力：4/5分。依据：售后客服阶段处理退款退货订单分级、物流跟踪；运营助理阶段负责货品物流及发货动向跟踪，订单全流程管理经验丰富，换单场景可类比电商退换货处理。\n3. **基础培训能力：2/5分。依据：仅有安全生产培训经验（顺丰稽查员），对象为快递员而非服务人员；无月嫂/育婴师群体培训经历，非专业培训能力待验证。\n4. **应急对接能力：4/5分。依据：太平鸟双十一大流量应急处理、售后客诉跟踪解决；博津电器每日100-200接待量、丢件/机器问题处理，高压售后场景成熟，云管家售后可迁移。\n5. **沟通协作能力：4/5分。依据：简历自述\"性格开朗善于沟通\"\"较强抗压性\"\"团队协作\"，多段经历涉及跨部门对接（运营-客服-物流）；但缺乏家政服务者（女性为主）沟通实证，性别因素或成隐性障碍。",
    "created": ""
  },
  {
    "id": 186,
    "name": "茅俊鹏",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "茅",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "大专学历符合要求，专业排名前15%体现学习能力；多段销售/客服经历（电话销售、调解员）锻炼沟通与冲突处理能力；社团管理30人街舞社、组织10余次活动，具备基础人员协调与活动组织经验；熟练使用电脑（计算机一级、数据应用与开发服务中级）。",
    "risks": "零家政/母婴行业背景，岗位认知空白；4段实习均在3个月内，最长4个月，稳定性存疑；期望岗位为\"商家运营专员\"与月嫂运营岗偏差大，投递动机不明确；24年毕业仅1年工作经验，却期望8-11K薪资，与岗位定位可能错配。",
    "aiEval": "- 初筛结果：存疑\n- 优势分析：大专学历符合要求，专业排名前15%体现学习能力；多段销售/客服经历（电话销售、调解员）锻炼沟通与冲突处理能力；社团管理30人街舞社、组织10余次活动，具备基础人员协调与活动组织经验；熟练使用电脑（计算机一级、数据应用与开发服务中级）。\n- 风险点：零家政/母婴行业背景，岗位认知空白；4段实习均在3个月内，最长4个月，稳定性存疑；期望岗位为\"商家运营专员\"与月嫂运营岗偏差大，投递动机不明确；24年毕业仅1年工作经验，却期望8-11K薪资，与岗位定位可能错配。\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：无薪资发放、物料管理经验；仅社团管理30人成员，无正式员工关系处理经验，需从零学习。\n  - **订单安排能力：1/5分。依据：无排班、调度、订单匹配经验；销售岗侧重客户开发而非服务资源协调，能力空白。\n  - **基础培训能力：2/5分。依据：有街舞/爵士舞教学经验（社团），具备基础授课能力；但无成人职业培训经验，母婴知识零基础。\n  - **应急对接能力：2/5分。依据：调解员经历有金融纠纷处理经验，具备基础冲突沟通技巧；但无家政售后、急单响应场景经验。\n  - **沟通协作能力：3/5分。依据：多段销售/客服岗验证沟通能力；自我描述\"善于沟通、团队精神\"；但\"接受非工作时间信息回复\"意愿未经验证，销售岗与家政服务者管理的沟通对象差异大。\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    - 请描述一次你同时处理多位成员不同需求并协调资源的经历（如社团活动中），当时如何确保各方满意？\n    - 调解金融纠纷时，遇到情绪激动的当事人，你具体采取了哪些步骤平息冲突并推动解决？\n    - 你的实习经历普遍较短，如果加入天鹅到家需要长期深耕家政行业，你如何规划自己的职业发展？\n  - 技术评估问题（2个）：\n ",
    "aiScreen": "淘汰",
    "hrReview": "淘汰",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你同时处理多位成员不同需求并协调资源的经历（如社团活动中），当时如何确保各方满意？\n2. 调解金融纠纷时，遇到情绪激动的当事人，你具体采取了哪些步骤平息冲突并推动解决？\n3. 你的实习经历普遍较短，如果加入天鹅到家需要长期深耕家政行业，你如何规划自己的职业发展？\n4. 假设一位月嫂因客户投诉被临时换单，情绪非常激动，你会如何电话沟通处理？请模拟关键话术。\n5. 月嫂工资计算涉及天数、节假日、客户评价等多因素，你如何用Excel设计一张工资核算表？请简述字段和公式思路。",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：无薪资发放、物料管理经验；仅社团管理30人成员，无正式员工关系处理经验，需从零学习。\n2. **订单安排能力：1/5分。依据：无排班、调度、订单匹配经验；销售岗侧重客户开发而非服务资源协调，能力空白。\n3. **基础培训能力：2/5分。依据：有街舞/爵士舞教学经验（社团），具备基础授课能力；但无成人职业培训经验，母婴知识零基础。\n4. **应急对接能力：2/5分。依据：调解员经历有金融纠纷处理经验，具备基础冲突沟通技巧；但无家政售后、急单响应场景经验。\n5. **沟通协作能力：3/5分。依据：多段销售/客服岗验证沟通能力；自我描述\"善于沟通、团队精神\"；但\"接受非工作时间信息回复\"意愿未经验证，销售岗与家政服务者管理的沟通对象差异大。",
    "created": ""
  },
  {
    "id": 187,
    "name": "闵先生",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "闵",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备商户运营与人员维护实战经验，在饿了么、德保膳食负责过商户日常管理、薪资物料发放、订单履约跟进；擅长数据整理与标准化流程搭建，能快速适配家政数字化运营；跨部门协作与应急响应能力经校园LED大屏、活动执行验证，沟通清晰流畅。",
    "risks": "行业跨度大（餐饮/零售→家政服务），母婴护理专业知识为零，基础培训能力存缺口；简历显示2025年10月-2026年1月为\"未来实习\"，实际到岗稳定性待验证；男性身份在月嫂维护场景中可能面临服务人员信任建立挑战；接受非工作时间回复的意愿未明确体现。",
    "aiEval": "- 初筛结果：存疑\n\n- 优势分析：具备商户运营与人员维护实战经验，在饿了么、德保膳食负责过商户日常管理、薪资物料发放、订单履约跟进；擅长数据整理与标准化流程搭建，能快速适配家政数字化运营；跨部门协作与应急响应能力经校园LED大屏、活动执行验证，沟通清晰流畅。\n\n- 风险点：行业跨度大（餐饮/零售→家政服务），母婴护理专业知识为零，基础培训能力存缺口；简历显示2025年10月-2026年1月为\"未来实习\"，实际到岗稳定性待验证；男性身份在月嫂维护场景中可能面临服务人员信任建立挑战；接受非工作时间回复的意愿未明确体现。\n\n- 能力维度匹配：\n  - **人员维护能力：3/5分。依据：在德保膳食负责合作商户日常维护、巡检台账、商品储存管理，饿了么负责商户信息审核与订单履约跟进，有标准化流程经验，但无直接薪资发放经历，且对象为商户非个人服务人员。\n  - **订单安排能力：3/5分。依据：饿了么BD经历涉及订单全流程跟进、异常处理与换单协调，德保膳食有活动落地监督经验，具备订单调度基础，但未涉及月嫂/育婴师这类高情感粘性服务的排期管理。\n  - **基础培训能力：1/5分。依据：简历无任何培训授课、课程开发或知识传递经历，食品专业背景与母婴护理培训内容无关联，该维度为明显短板。\n  - **应急对接能力：3/5分。依据：校园LED大屏运维建立应急处理机制保障重大活动零失误，饿了么处理客户投诉与订单异常，具备快速响应意识，但未涉及家政售后场景。\n  - **沟通协作能力：4/5分。依据：跨部门对接（党宣部与校内各部门）、商户拓展维护、客户社群运营多场景验证，持普通话二甲证书，性格开朗特质经多段经历侧面印证。\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. 请描述一次你处理商户/客户紧急投诉并协调多方资源解决的具体案例，当时如何平衡平台规则与客户情绪？\n  ",
    "aiScreen": "存疑",
    "hrReview": "通过",
    "interviewPos": "商家运营专员",
    "interviewQ": "1. 请描述一次你处理商户/客户紧急投诉并协调多方资源解决的具体案例，当时如何平衡平台规则与客户情绪？\n2. 在饿了么做BD时，如何维护与高频更换对接人的小微商户的长期合作关系？遇到商户突然终止合作时如何应对？\n3. 简历中多段经历集中在2024-2025年，请说明职业选择从餐饮零售转向家政服务的动机，以及未来2-3年的职业规划。\n4. 假设一位月嫂因突发疾病需临时下户，客户次日即生产，你会如何快速协调换单？请列出具体步骤与沟通话术要点。\n5. 家政服务人员多为中年女性，作为年轻男性运营，设计一个破冰方案建立首批10位月嫂的信任关系。",
    "capabilityMatch": "1. **人员维护能力：3/5分。依据：在德保膳食负责合作商户日常维护、巡检台账、商品储存管理，饿了么负责商户信息审核与订单履约跟进，有标准化流程经验，但无直接薪资发放经历，且对象为商户非个人服务人员。\n2. **订单安排能力：3/5分。依据：饿了么BD经历涉及订单全流程跟进、异常处理与换单协调，德保膳食有活动落地监督经验，具备订单调度基础，但未涉及月嫂/育婴师这类高情感粘性服务的排期管理。\n3. **基础培训能力：1/5分。依据：简历无任何培训授课、课程开发或知识传递经历，食品专业背景与母婴护理培训内容无关联，该维度为明显短板。\n4. **应急对接能力：3/5分。依据：校园LED大屏运维建立应急处理机制保障重大活动零失误，饿了么处理客户投诉与订单异常，具备快速响应意识，但未涉及家政售后场景。\n5. **沟通协作能力：4/5分。依据：跨部门对接（党宣部与校内各部门）、商户拓展维护、客户社群运营多场景验证，持普通话二甲证书，性格开朗特质经多段经历侧面印证。",
    "created": ""
  },
  {
    "id": 188,
    "name": "泮莹洁",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "泮",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "1年数据BA经验，熟练Excel高级函数与多平台运营，具备数据通报、绩效考核、培训组织等实操经历；性格开朗、善于沟通、接受非工作时间响应，与岗位\"沟通协作\"\"应急对接\"要求高度契合；年龄23岁（2001年生），符合21-28岁区间。",
    "risks": "无家政/母婴行业背景，人员维护、订单安排等垂直场景需从零学习；1年工作经验较短，稳定性待验证；简历未体现\"团队精神\"具体案例，文化匹配深度不足；金融专业背景与家政运营关联度弱。",
    "aiEval": "- 初筛结果：通过\n- 优势分析：1年数据BA经验，熟练Excel高级函数与多平台运营，具备数据通报、绩效考核、培训组织等实操经历；性格开朗、善于沟通、接受非工作时间响应，与岗位\"沟通协作\"\"应急对接\"要求高度契合；年龄23岁（2001年生），符合21-28岁区间。\n- 风险点：无家政/母婴行业背景，人员维护、订单安排等垂直场景需从零学习；1年工作经验较短，稳定性待验证；简历未体现\"团队精神\"具体案例，文化匹配深度不足；金融专业背景与家政运营关联度弱。\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：无月嫂/家政人员管理经验，但有绩效考核审核、培训后勤保障经历，可迁移至薪资物料发放场景。\n  - **订单安排能力：2/5分。依据：无订单调度经验，但有即时零售平台运营、销售竞赛策划经历，具备基础资源协调能力。\n  - **基础培训能力：3/5分。依据：明确负责新员工培训的后勤保障与排课协调，含场地、讲师、课程表制作，与\"非专业培训\"组织要求直接匹配。\n  - **应急对接能力：3/5分。依据：主导每日数据通报及三日复盘，审核小红书内容合规性，具备高频响应与问题处理习惯；接受非工作时间信息回复。\n  - **沟通协作能力：4/5分。依据：简历自述\"性格开朗善于沟通\"，有跨部门培训协调、多平台对接经历；但缺乏团队冲突解决或协作成果的具体案例。\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. 请描述一次你需要在非工作时间紧急处理突发任务的经历，当时如何平衡个人安排与工作需求？结果如何？\n    2. 在培训组织或数据通报工作中，是否遇到过多方意见冲突或资源协调困难？你如何推动达成一致？\n    3. 过去1年更换工作的原因是什么？未来2-3年对职业发展的规划是什么？如何看待家政行业的长期发展？\n  - 技术评估问题（2个）：\n    1. 月嫂",
    "aiScreen": "通过",
    "hrReview": "",
    "interviewPos": "商家运营专员",
    "interviewQ": "1. 请描述一次你需要在非工作时间紧急处理突发任务的经历，当时如何平衡个人安排与工作需求？结果如何？\n2. 在培训组织或数据通报工作中，是否遇到过多方意见冲突或资源协调困难？你如何推动达成一致？\n3. 过去1年更换工作的原因是什么？未来2-3年对职业发展的规划是什么？如何看待家政行业的长期发展？\n4. 月嫂工资结构通常包含底薪、提成、路费补贴等，若用Excel设计一张自动计算表，你会用到哪些函数确保准确性和效率？\n5. 假设一位月嫂因突发疾病需临时换单，但备选人员档期冲突，你会如何快速协调并安抚客户情绪？请分步骤说明。",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：无月嫂/家政人员管理经验，但有绩效考核审核、培训后勤保障经历，可迁移至薪资物料发放场景。\n2. **订单安排能力：2/5分。依据：无订单调度经验，但有即时零售平台运营、销售竞赛策划经历，具备基础资源协调能力。\n3. **基础培训能力：3/5分。依据：明确负责新员工培训的后勤保障与排课协调，含场地、讲师、课程表制作，与\"非专业培训\"组织要求直接匹配。\n4. **应急对接能力：3/5分。依据：主导每日数据通报及三日复盘，审核小红书内容合规性，具备高频响应与问题处理习惯；接受非工作时间信息回复。\n5. **沟通协作能力：4/5分。依据：简历自述\"性格开朗善于沟通\"，有跨部门培训协调、多平台对接经历；但缺乏团队冲突解决或协作成果的具体案例。",
    "created": ""
  },
  {
    "id": 189,
    "name": "裴泽茹",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "裴",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "候选人具备标准化文档输出与流程梳理能力，沟通协调能力经咨询项目验证，工具技能（Office/Visio）匹配基础办公需求。内控体系搭建经验与家政服务标准化、数字化方向有一定契合度。",
    "risks": "性别不符（JD明确要求男性）；无家政/母婴行业背景，人员维护、订单安排、应急对接等核心业务场景零经验；24岁年龄接近上限但非关键矛盾；咨询行业背景与一线运营执行岗位落差显著，稳定性存疑。",
    "aiEval": "- 初筛结果：淘汰\n\n- 优势分析：候选人具备标准化文档输出与流程梳理能力，沟通协调能力经咨询项目验证，工具技能（Office/Visio）匹配基础办公需求。内控体系搭建经验与家政服务标准化、数字化方向有一定契合度。\n\n- 风险点：性别不符（JD明确要求男性）；无家政/母婴行业背景，人员维护、订单安排、应急对接等核心业务场景零经验；24岁年龄接近上限但非关键矛盾；咨询行业背景与一线运营执行岗位落差显著，稳定性存疑。\n\n- 能力维度匹配：\n  - **人员维护能力：0/5分。依据：简历无任何薪酬核算、物料管理、一线服务人员日常维护经验，内控咨询侧重制度设计而非执行落地。**\n  - **订单安排能力：0/5分。依据：无订单调度、资源匹配、换单协调等相关经历，流程梳理经验不直接转化为实操调度能力。**\n  - **基础培训能力：2/5分。依据：具备\"面向客户侧的内控体系培训\"经验，但属专业制度培训，与月嫂/育婴师非专业培训场景差异大。**\n  - **应急对接能力：1/5分。依据：有客户对接与项目交付支持经验，但无急单响应、售后处理等高压场景历练，行业语境完全不同。**\n  - **沟通协作能力：4/5分。依据：简历多次强调\"高效对接客户多层级人员\"\"跨部门协作\"\"精准挖掘需求\"，且接受出差，适配沟通协作要求。**\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. \"请描述一次你需在非工作时间响应客户紧急需求的经历，当时如何处理工作与生活边界的冲突？\"\n    2. \"咨询项目中若客户对交付成果强烈不满，你具体采取了哪些步骤化解矛盾并推进共识？\"\n    3. \"你的职业规划显示深耕内控咨询方向，如何看待转向一线运营执行岗位可能带来的落差感？\"\n  - 技术评估问题（2个）：\n    1. \"假设月嫂因突发疾病需紧急换单，但备选人员均档期冲突，你会如何协",
    "aiScreen": "淘汰",
    "hrReview": "淘汰",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"请描述一次你需在非工作时间响应客户紧急需求的经历，当时如何处理工作与生活边界的冲突？\"\n2. \"咨询项目中若客户对交付成果强烈不满，你具体采取了哪些步骤化解矛盾并推进共识？\"\n3. \"你的职业规划显示深耕内控咨询方向，如何看待转向一线运营执行岗位可能带来的落差感？\"\n4. \"假设月嫂因突发疾病需紧急换单，但备选人员均档期冲突，你会如何协调资源并安抚客户？\"\n5. \"请现场设计一份月嫂工资核算表的结构框架，需包含基本项、浮动项及常见扣款项。\"",
    "capabilityMatch": "1. **人员维护能力：0/5分。依据：简历无任何薪酬核算、物料管理、一线服务人员日常维护经验，内控咨询侧重制度设计而非执行落地。**\n2. **订单安排能力：0/5分。依据：无订单调度、资源匹配、换单协调等相关经历，流程梳理经验不直接转化为实操调度能力。**\n3. **基础培训能力：2/5分。依据：具备\"面向客户侧的内控体系培训\"经验，但属专业制度培训，与月嫂/育婴师非专业培训场景差异大。**\n4. **应急对接能力：1/5分。依据：有客户对接与项目交付支持经验，但无急单响应、售后处理等高压场景历练，行业语境完全不同。**\n5. **沟通协作能力：4/5分。依据：简历多次强调\"高效对接客户多层级人员\"\"跨部门协作\"\"精准挖掘需求\"，且接受出差，适配沟通协作要求。**",
    "created": ""
  },
  {
    "id": 190,
    "name": "齐恩慧",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "齐",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "经济学专业背景具备数据分析基础，Excel数据处理与财务核对经验可直接迁移至薪资物料发放；第二课堂负责人经历体现政策设计、资源协调与大型活动执行能力，契合家政服务标准化运营需求；学生会安教部副部经历证明安全培训体系搭建经验，与月嫂非专业培训场景高度相关。",
    "risks": "2026年应届生身份与\"26年3-4月仅1个月实习\"存在时间矛盾，实际到岗时间存疑；零家政/母婴行业背景，月嫂育婴师订单调度、急单售后等核心业务无直接经验；审计助理岗位偏后台数据，与一线服务人员高频沟通场景差异较大；性别女与JD隐含偏好（\"男\"）冲突，需确认是否为硬性要求。",
    "aiEval": "- 初筛结果：存疑\n\n- 优势分析：经济学专业背景具备数据分析基础，Excel数据处理与财务核对经验可直接迁移至薪资物料发放；第二课堂负责人经历体现政策设计、资源协调与大型活动执行能力，契合家政服务标准化运营需求；学生会安教部副部经历证明安全培训体系搭建经验，与月嫂非专业培训场景高度相关。\n\n- 风险点：2026年应届生身份与\"26年3-4月仅1个月实习\"存在时间矛盾，实际到岗时间存疑；零家政/母婴行业背景，月嫂育婴师订单调度、急单售后等核心业务无直接经验；审计助理岗位偏后台数据，与一线服务人员高频沟通场景差异较大；性别女与JD隐含偏好（\"男\"）冲突，需确认是否为硬性要求。\n\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：天健审计助理经历涉及财务数据核对，但无薪资发放实操；学生会资源协调经验可部分迁移，缺家政服务人员管理经验。\n  - **订单安排能力：1/5分。依据：简历无订单调度、资源匹配相关经历；第二课堂活动审批流程优化属于静态管理，与动态月嫂换单场景差异显著。\n  - **基础培训能力：3/5分。依据：安教部副部主导安全教育课程开发、培训组织，方法论可迁移；但缺母婴护理知识储备，需评估非专业培训（如服务规范）执行能力。\n  - **应急对接能力：1/5分。依据：无售后处理、客诉响应或紧急事务协调经验；审计工作节奏偏计划性，与家政急单高频突发特性匹配度低。\n  - **沟通协作能力：4/5分。依据：自我评价明确\"沟通表达能力强\"，第二课堂多方资源协调、审计团队对接经历佐证；但\"非工作时间信息回复\"接受度未经验证。\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. \"请描述一次你同时协调多个利益相关方（如校团委、社团、赞助商）完成紧急任务的经历，当时如何平衡各方诉求并确保结果落地？\"\n    2. \"审计工作中若发现被审计单位数据",
    "aiScreen": "存疑",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"请描述一次你同时协调多个利益相关方（如校团委、社团、赞助商）完成紧急任务的经历，当时如何平衡各方诉求并确保结果落地？\"\n2. \"审计工作中若发现被审计单位数据重大异常且对方不配合，你如何沟通推进？这与月嫂对薪资核算有异议的场景有何异同？\"\n3. \"你提到'快速适应多变环境'，请举例说明面对计划外突发状况（如活动临时取消、人员缺席）的具体应对，事后如何复盘？\"\n4. \"假设一位月嫂因客户临时要求提前下户，需紧急匹配新订单，你会如何快速梳理现有资源并完成调度？请分步骤说明。\"\n5. \"若月嫂投诉物料发放延迟影响上户，同时顾问催促急单对接，你如何在10分钟内优先级排序并回应双方？\"",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：天健审计助理经历涉及财务数据核对，但无薪资发放实操；学生会资源协调经验可部分迁移，缺家政服务人员管理经验。\n2. **订单安排能力：1/5分。依据：简历无订单调度、资源匹配相关经历；第二课堂活动审批流程优化属于静态管理，与动态月嫂换单场景差异显著。\n3. **基础培训能力：3/5分。依据：安教部副部主导安全教育课程开发、培训组织，方法论可迁移；但缺母婴护理知识储备，需评估非专业培训（如服务规范）执行能力。\n4. **应急对接能力：1/5分。依据：无售后处理、客诉响应或紧急事务协调经验；审计工作节奏偏计划性，与家政急单高频突发特性匹配度低。\n5. **沟通协作能力：4/5分。依据：自我评价明确\"沟通表达能力强\"，第二课堂多方资源协调、审计团队对接经历佐证；但\"非工作时间信息回复\"接受度未经验证。",
    "created": ""
  },
  {
    "id": 191,
    "name": "钱美静",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "钱",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "电商专业背景具备基础数字化运营思维，实习经历涉及客服工单系统操作、售后问题处理及跨部门协调，与\"应急对接\"\"沟通协作\"有迁移基础；学习能力强，能快速适应新系统；性格描述\"开朗善于沟通\"符合岗位软性要求。",
    "risks": "求职意向为\"行政/5-8K\"与\"商家运营专员\"岗位名称及家政业务场景存在认知偏差；零家政/母婴行业经验，\"非专业培训\"能力无直接支撑；实习经历均为客服执行层，未体现\"人员维护\"\"订单安排\"等主动管理行为；期望薪资低于JD标注的8-10K，需确认职业动机。",
    "aiEval": "- 初筛结果：存疑\n- 优势分析：电商专业背景具备基础数字化运营思维，实习经历涉及客服工单系统操作、售后问题处理及跨部门协调，与\"应急对接\"\"沟通协作\"有迁移基础；学习能力强，能快速适应新系统；性格描述\"开朗善于沟通\"符合岗位软性要求。\n- 风险点：求职意向为\"行政/5-8K\"与\"商家运营专员\"岗位名称及家政业务场景存在认知偏差；零家政/母婴行业经验，\"非专业培训\"能力无直接支撑；实习经历均为客服执行层，未体现\"人员维护\"\"订单安排\"等主动管理行为；期望薪资低于JD标注的8-10K，需确认职业动机。\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：无直接经验。仅有银行客服\"分期退款\"物料操作经历，未涉及人员日常管理、薪资核算发放等复杂事务，家政服务人员管理场景差异大。**\n  - **订单安排能力：1/5分。依据：无相关经验。电商比赛涉及商品上架，但\"订单安排\"指服务人员调度排期，与商品订单逻辑不同；实习无排班、资源协调经历。**\n  - **基础培训能力：1/5分。依据：无培训经验。简历未体现任何授课、带教、内容输出经历；\"非专业培训\"需面向月嫂群体，沟通对象与过往客服客户差异显著。**\n  - **应急对接能力：3/5分。依据：有客服售后处理基础。海尔售后\"联系师傅上门、配件调取、退换货跟踪\"与\"急单对接、云管家售后\"场景部分相似；银行客服处理客户投诉及系统操作具备一定应急响应意识。**\n  - **沟通协作能力：3/5分。依据：自我评价\"开朗善于沟通\"，客服岗位需高频沟通；银行实习\"质检通话录音\"体现跨部门协作意识；但\"非工作时间信息回复\"的接受度需验证，过往实习均为标准排班。**\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    - \"请描述一次你同时处理多位客户紧急诉求的经历，当时如何排序优先级并协调资源？结果如何？\"（应急对接+沟通",
    "aiScreen": "存疑",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"请描述一次你同时处理多位客户紧急诉求的经历，当时如何排序优先级并协调资源？结果如何？\"\n2. \"你的实习经历以标准班次为主，本岗位需要非工作时间响应月嫂/顾问信息，你如何看待工作与生活边界的调整？能否举例说明你为工作额外付出的情况？\"\n3. \"你求职意向写的是行政岗，薪资期望5-8K，而我们岗位是商家运营方向、标注8-10K，请说明你对这个岗位的理解以及职业选择的考虑。\"\n4. \"假设一位月嫂因突发疾病需临时下户，客户次日就要生产，你会如何快速协调替换人员并安抚客户？请分步骤说明。\"\n5. \"月嫂群体年龄普遍40-50岁、文化水平参差，若需组织一场'上户礼仪规范'的非专业培训，你会如何设计内容并确保她们听懂、愿意配合？\"",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：无直接薪资物料发放经验，但客服工作涉及账单查询、退款处理，具备基础财务操作意识。**\n2. **订单安排能力：2/5分。依据：无月嫂/育婴师调度经验，电商实训中涉及商品上架、发货流程，有一定订单逻辑理解。**\n3. **基础培训能力：1/5分。依据：简历未体现任何培训授课或知识传递经历，此维度为明显空白。**\n4. **应急对接能力：3/5分。依据：海尔售后客服经历包含异常处理、配件调取、退换货跟踪，具备售后问题响应经验。**\n5. **沟通协作能力：3/5分。依据：两段客服实习均强调客户沟通，自我评价\"性格开朗善于沟通\"，但未明确体现团队协作案例。**",
    "created": ""
  },
  {
    "id": 192,
    "name": "邱艳林",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "邱",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备电商运营全流程经验，擅长供应商/主播资源维护、订单排期协调及数据复盘，与家政服务人员调度、薪资核算有迁移性；Excel熟练，有SOP优化意识；学生会部长经历体现团队沟通与活动组织能力。",
    "risks": "无家政/母婴行业背景，人员维护对象从\"品牌方/主播\"转为\"月嫂\"需适应；简历显示2025-2026年时间线存疑（当前2024年），稳定性待核实；未明确接受非工作时间回复，需确认意愿。",
    "aiEval": "- 初筛结果：存疑\n\n- 优势分析：具备电商运营全流程经验，擅长供应商/主播资源维护、订单排期协调及数据复盘，与家政服务人员调度、薪资核算有迁移性；Excel熟练，有SOP优化意识；学生会部长经历体现团队沟通与活动组织能力。\n\n- 风险点：无家政/母婴行业背景，人员维护对象从\"品牌方/主播\"转为\"月嫂\"需适应；简历显示2025-2026年时间线存疑（当前2024年），稳定性待核实；未明确接受非工作时间回复，需确认意愿。\n\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：有商务AE薪资谈判、合同跟进经验，但对象为品牌方非一线服务人员，无工资/物料发放实操，月嫂情绪管理场景缺失。\n  - **订单安排能力：3/5分。依据：高频处理50+主播排期匹配、换主播协调，逻辑可迁移至月嫂订单调度；但家政服务\"换单\"涉及人员突发状况，应急复杂度更高。\n  - **基础培训能力：1/5分。依据：简历未体现任何培训授课、SOP输出或带教经验，仅参与过活动策划，培训能力空白。\n  - **应急对接能力：2/5分。依据：有直播当天链接核对、播后复盘等即时响应经验，但\"售后\"对象为数据结果非客诉；云管家售后需家政服务纠纷处理，场景差异大。\n  - **沟通协作能力：4/5分。依据：自我评价\"沟通理解能力强\"，学生会部长统筹千人活动，商务岗位需高频多方协调；但未验证非工作时间响应意愿。\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. 请描述一次你处理合作方突发紧急需求（如临时换主播/改机制）的经历，当时如何协调多方资源？结果如何？\n    2. 月嫂群体年龄偏大、流动性高，若一位月嫂因家庭突发状况需临时下户，你如何与顾问、客户同步信息并安抚各方情绪？\n    3. 你简历中2025-2026年的工作经历，实际入职和离职时间能否具体说明？近2年是否有超过6个月的职",
    "aiScreen": "存疑",
    "hrReview": "淘汰",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你处理合作方突发紧急需求（如临时换主播/改机制）的经历，当时如何协调多方资源？结果如何？\n2. 月嫂群体年龄偏大、流动性高，若一位月嫂因家庭突发状况需临时下户，你如何与顾问、客户同步信息并安抚各方情绪？\n3. 你简历中2025-2026年的工作经历，实际入职和离职时间能否具体说明？近2年是否有超过6个月的职业空窗期？\n4. 假设需为30位月嫂核算本月工资（含基础工资+客户好评奖金-物料扣款），请用Excel简述你会如何设计表格结构及核心函数？\n5. 家政服务中客户投诉\"月嫂夜间照护响应慢\"，你会如何向月嫂了解情况、记录反馈并同步给顾问？请模拟沟通话术。",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：有商务AE薪资谈判、合同跟进经验，但对象为品牌方非一线服务人员，无工资/物料发放实操，月嫂情绪管理场景缺失。\n2. **订单安排能力：3/5分。依据：高频处理50+主播排期匹配、换主播协调，逻辑可迁移至月嫂订单调度；但家政服务\"换单\"涉及人员突发状况，应急复杂度更高。\n3. **基础培训能力：1/5分。依据：简历未体现任何培训授课、SOP输出或带教经验，仅参与过活动策划，培训能力空白。\n4. **应急对接能力：2/5分。依据：有直播当天链接核对、播后复盘等即时响应经验，但\"售后\"对象为数据结果非客诉；云管家售后需家政服务纠纷处理，场景差异大。\n5. **沟通协作能力：4/5分。依据：自我评价\"沟通理解能力强\"，学生会部长统筹千人活动，商务岗位需高频多方协调；但未验证非工作时间响应意愿。",
    "created": ""
  },
  {
    "id": 193,
    "name": "邱益哨",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "邱",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "22岁大专学历符合硬性门槛；有1688平台运营助理经验，熟悉后台数据整理、客户咨询处理、售后争议解决，与云管家售后、订单对接场景高度可迁移；自我评价强调时间管理、条理性和团队协作，匹配家政服务标准化流程需求。",
    "risks": "无家政/母婴行业背景，月嫂育婴师专业培训需从零学习；实习仅3个月（2024.8-2024.11），稳定性存疑；简历未体现非工作时间响应的实际经历，需验证接受度；性别男，与月嫂群体（女性为主）日常维护的亲和力建立或存挑战。",
    "aiEval": "- 初筛结果：通过\n- 优势分析：22岁大专学历符合硬性门槛；有1688平台运营助理经验，熟悉后台数据整理、客户咨询处理、售后争议解决，与云管家售后、订单对接场景高度可迁移；自我评价强调时间管理、条理性和团队协作，匹配家政服务标准化流程需求。\n- 风险点：无家政/母婴行业背景，月嫂育婴师专业培训需从零学习；实习仅3个月（2024.8-2024.11），稳定性存疑；简历未体现非工作时间响应的实际经历，需验证接受度；性别男，与月嫂群体（女性为主）日常维护的亲和力建立或存挑战。\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：无直接薪资发放或人员管理经验，但1688平台有客户问题处理及数据整理经验，可部分迁移至物料与费用台账管理。\n  - **订单安排能力：3/5分。依据：1688运营涉及产品上架、属性优化、询盘匹配，逻辑与订单-人员撮合相似；无家政换单场景经验，需培训。\n  - **基础培训能力：1/5分。依据：简历未体现任何培训授课或课程组织经历，该维度为明显缺口。\n  - **应急对接能力：3/5分。依据：实习中\"及时处理账号突发情况\"\"处理客户争议\"与急单对接、售后处理场景高度相关，具备基础应激响应意识。\n  - **沟通协作能力：4/5分。依据：自我评价明确\"性格开朗善于沟通\"\"团队合作精神\"\"领导团队发展意识\"，且有客户答疑、询盘对接的实操验证。\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. \"请描述一次你在非工作时间（如晚间或周末）处理紧急客户问题的经历，当时如何平衡个人时间与工作需求？\"\n    2. \"1688运营中遇到最难缠的客户争议是什么？你具体如何沟通解决，最终结果如何？\"\n    3. \"你的实习仅持续3个月，请说明离职原因；若加入天鹅到家，如何看待家政行业人员流动率高这一特点，你计划如何保持稳定性？\"\n  - 技",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员",
    "interviewQ": "1. \"请描述一次你在非工作时间（如晚间或周末）处理紧急客户问题的经历，当时如何平衡个人时间与工作需求？\"\n2. \"1688运营中遇到最难缠的客户争议是什么？你具体如何沟通解决，最终结果如何？\"\n3. \"你的实习仅持续3个月，请说明离职原因；若加入天鹅到家，如何看待家政行业人员流动率高这一特点，你计划如何保持稳定性？\"\n4. \"假设一位月嫂因突发疾病需临时下户，客户次日就要用人，你会如何快速协调换单？请分步骤说明思路。\"\n5. \"请现场模拟：向一位50岁、仅会使用微信语音的月嫂，讲解如何通过小程序查看工资明细，你会如何表达？\"",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：无直接薪资发放或人员管理经验，但1688平台有客户问题处理及数据整理经验，可部分迁移至物料与费用台账管理。\n2. **订单安排能力：3/5分。依据：1688运营涉及产品上架、属性优化、询盘匹配，逻辑与订单-人员撮合相似；无家政换单场景经验，需培训。\n3. **基础培训能力：1/5分。依据：简历未体现任何培训授课或课程组织经历，该维度为明显缺口。\n4. **应急对接能力：3/5分。依据：实习中\"及时处理账号突发情况\"\"处理客户争议\"与急单对接、售后处理场景高度相关，具备基础应激响应意识。\n5. **沟通协作能力：4/5分。依据：自我评价明确\"性格开朗善于沟通\"\"团队合作精神\"\"领导团队发展意识\"，且有客户答疑、询盘对接的实操验证。",
    "created": ""
  },
  {
    "id": 194,
    "name": "荣翔",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "荣",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "4年电商运营经验，具备标准化流程管理（商品上下架、数据复盘）、多角色协调（客服/供应链）及数字化工具（直通车/万相台）使用能力，与天鹅到家数字化运营方向有一定契合；性格开朗、沟通推动能力强，符合岗位沟通协作要求。",
    "risks": "无家政/母婴行业背景，人员维护、订单安排等核心能力无直接经验；简历时间线混乱（2025.07-2026.05为未来时间），稳定性存疑；性别男与\"月嫂日常维护\"场景可能存在文化适配挑战；未明确体现非工作时间信息回复的接受度。",
    "aiEval": "- 初筛结果：存疑\n\n- 优势分析：具备电商运营经验，熟悉数据复盘、活动策划与跨部门协调；性格开朗、沟通推动能力强，符合\"沟通协作能力\"要求；年龄27岁符合21-28岁区间，本科学历达标。\n\n- 风险点：无家政/母婴行业背景，人员维护、订单安排等核心能力无直接经验；简历时间线混乱（2025.07-2026.05为未来时间），稳定性存疑；性别男与\"月嫂日常维护\"场景可能存在文化适配挑战；未明确体现非工作时间信息回复的接受度。\n\n- 能力维度匹配：\n  - **人员维护能力：1/5分。依据：仅有电商商品上下架经验，无薪资发放、物料管理或人员服务经历，行业场景差异大。\n  - **订单安排能力：2/5分。依据：具备电商订单处理与供应链协调经验，但家政服务\"换单\"涉及人的调度，逻辑不同。\n  - **基础培训能力：1/5分。依据：无培训相关经验，电商运营中的\"需求文档撰写\"与人员培训场景不匹配。\n  - **应急对接能力：2/5分。依据：有售后协调与跨部门沟通经验，但\"云管家售后\"和母婴急单场景无涉及。\n  - **沟通协作能力：4/5分。依据：简历明确\"较强的沟通和推动能力\"\"性格开朗\"，且电商运营需多角色协作，匹配度高。\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. 请描述一次你需要在非工作时间紧急处理突发问题的经历，当时如何平衡个人时间与工作需求？\n    2. 电商运营中常需协调多方资源，请举例说明你如何推动一个跨部门项目，遇到阻力时如何解决？\n    3. 你的职业规划是什么？如何看待从电商运营转向家政服务行业的职业转换？\n  - 技术评估问题（2个）：\n    1. 假设一位月嫂因突发疾病无法上户，客户次日急需用人，你会如何快速协调资源？请描述具体步骤。\n    2. 月嫂对薪资计算有异议，情绪激动，你如何运用Excel和数据说明进行安抚与解",
    "aiScreen": "存疑",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你需要在非工作时间紧急处理突发问题的经历，当时如何平衡个人时间与工作需求？\n2. 电商运营中常需协调多方资源，请举例说明你如何推动一个跨部门项目，遇到阻力时如何解决？\n3. 你的职业规划是什么？如何看待从电商运营转向家政服务行业的职业转换？\n4. 假设一位月嫂因突发疾病无法上户，客户次日急需用人，你会如何快速协调资源？请描述具体步骤。\n5. 月嫂对薪资计算有异议，情绪激动，你如何运用Excel和数据说明进行安抚与解释？",
    "capabilityMatch": "1. **人员维护能力：1/5分。依据：仅有电商商品上下架经验，无薪资发放、物料管理或人员服务经历，行业场景差异大。\n2. **订单安排能力：2/5分。依据：具备电商订单处理与供应链协调经验，但家政服务\"换单\"涉及人的调度，逻辑不同。\n3. **基础培训能力：1/5分。依据：无培训相关经验，电商运营中的\"需求文档撰写\"与人员培训场景不匹配。\n4. **应急对接能力：2/5分。依据：有售后协调与跨部门沟通经验，但\"云管家售后\"和母婴急单场景无涉及。\n5. **沟通协作能力：4/5分。依据：简历明确\"较强的沟通和推动能力\"\"性格开朗\"，且电商运营需多角色协作，匹配度高。",
    "created": ""
  },
  {
    "id": 195,
    "name": "沈利",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "沈",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "6年客服/运营经验，覆盖热线、在线、社群多渠道服务场景；具备成熟的售后投诉处理、订单退款对接经验；自我评价强调抗压能力、快速学习能力及时间规划能力，与家政服务高强度、多线程工作特性契合；大专学历符合硬性门槛。",
    "risks": "求职意向为\"售后客服\"与\"商家运营专员\"岗位存在偏差，需确认职业动机；过往经历集中于互联网/科技公司，无家政/母婴行业背景，行业切换存在适应期；简历未体现薪资核算、物料管理等财务类操作经验；年龄26岁接近上限28岁，需关注长期稳定性。",
    "aiEval": "- 初筛结果：通过\n- 优势分析：6年客服/运营经验，覆盖热线、在线、社群多渠道服务场景；具备成熟的售后投诉处理、订单退款对接经验；自我评价强调抗压能力、快速学习能力及时间规划能力，与家政服务高强度、多线程工作特性契合；大专学历符合硬性门槛。\n- 风险点：求职意向为\"售后客服\"与\"商家运营专员\"岗位存在偏差，需确认职业动机；过往经历集中于互联网/科技公司，无家政/母婴行业背景，行业切换存在适应期；简历未体现薪资核算、物料管理等财务类操作经验；年龄26岁接近上限28岁，需关注长期稳定性。\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：无月嫂/育婴师管理经验，但有用户日常维护、信息查询、评价管理经验，薪资物料发放经验未体现，需培训上手。**\n  - **订单安排能力：3/5分。依据：具备订单处理、退款对接、换单协调经验（杭州优频科技），逻辑可迁移，但无家政服务排期特殊性认知。**\n  - **基础培训能力：2/5分。依据：无培训执行经验，但社群客服经历涉及用户答疑、信息传递，具备基础表达能力，需开发培训技能。**\n  - **应急对接能力：4/5分。依据：热线/在线处理售后投诉为核心经验，明确提及\"急单对接\"\"BUG跟进至解决\"，与云管家售后处理高度匹配。**\n  - **沟通协作能力：4/5分。依据：自我评价明确\"善于沟通\"\"团队精神\"，6年跨公司协作经历佐证；需验证非工作时间响应意愿（仅书面接受）。**\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    - 请描述一次你同时处理多个紧急客户投诉的经历，当时如何排序优先级并协调资源解决？\n    - 你过往经历主要在科技行业，为什么选择转入家政服务领域？如何看待服务阿姨（劳动者）与服务客户双重沟通的挑战？\n    - 你的简历显示期望薪资6-8K，该岗位预算8-10K，但需频繁非工作时间响应，你",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你同时处理多个紧急客户投诉的经历，当时如何排序优先级并协调资源解决？\n2. 你过往经历主要在科技行业，为什么选择转入家政服务领域？如何看待服务阿姨（劳动者）与服务客户双重沟通的挑战？\n3. 你的简历显示期望薪资6-8K，该岗位预算8-10K，但需频繁非工作时间响应，你对此工作模式的接受度如何？过往有无类似经历？\n4. 假设一位月嫂因突发疾病需紧急下户，客户次日即生产，你如何在短时间内完成换单对接？请描述关键步骤。\n5. 月嫂对工资核算结果有异议，情绪激动致电，你如何安抚并核实处理？请模拟对话开场。",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：无月嫂/育婴师管理经验，但有用户日常维护、信息查询、评价管理经验，薪资物料发放经验未体现，需培训上手。**\n2. **订单安排能力：3/5分。依据：具备订单处理、退款对接、换单协调经验（杭州优频科技），逻辑可迁移，但无家政服务排期特殊性认知。**\n3. **基础培训能力：2/5分。依据：无培训执行经验，但社群客服经历涉及用户答疑、信息传递，具备基础表达能力，需开发培训技能。**\n4. **应急对接能力：4/5分。依据：热线/在线处理售后投诉为核心经验，明确提及\"急单对接\"\"BUG跟进至解决\"，与云管家售后处理高度匹配。**\n5. **沟通协作能力：4/5分。依据：自我评价明确\"善于沟通\"\"团队精神\"，6年跨公司协作经历佐证；需验证非工作时间响应意愿（仅书面接受）。**",
    "created": ""
  },
  {
    "id": 196,
    "name": "孙蔓漫",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "淘汰",
    "star": 0,
    "avatar": "孙",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备基础数字化工具使用能力（Python、MySQL、数据可视化），有用户沟通与销售转化经验；社团社长及学习委员经历体现组织协调与信息传达能力；性格外向善于沟通，符合岗位对沟通协作的基础要求。",
    "risks": "无家政/母婴行业经验，人员维护、订单安排、应急处理等核心能力无直接验证；简历时间存在明显异常（2025.07-2026.03工作经历为未来日期），稳定性存疑；性别与JD隐含偏好（男）不符，且未体现接受非工作时间回复的意愿。",
    "aiEval": "- 初筛结果：存疑\n\n- 优势分析：具备基础数字化工具使用能力（Python、MySQL、数据可视化），有用户沟通与销售转化经验；社团社长及学习委员经历体现组织协调与信息传达能力；性格外向善于沟通，符合岗位对沟通协作的基础要求。\n\n- 风险点：无家政/母婴行业经验，人员维护、订单安排、应急处理等核心能力无直接验证；简历时间存在明显异常（2025.07-2026.03工作经历为未来日期），稳定性存疑；性别与JD隐含偏好（男）不符，且未体现接受非工作时间回复的意愿。\n\n- 能力维度匹配：\n  - **人员维护能力：1/5分。依据：无月嫂/家政人员管理经验，仅京东订单检验涉及基础售后，与薪资物料发放场景差异大。**\n  - **订单安排能力：1/5分。依据：无订单调度或资源匹配经验，销售工作为客户对接而非服务人员排班管理。**\n  - **基础培训能力：2/5分。依据：英语社团有人员招新与活动统筹经验，但未涉及培训设计或知识传递，与月嫂培训场景关联弱。**\n  - **应急对接能力：1/5分。依据：京东售后跟进有基础客诉处理经验，但无急单响应或复杂协调场景验证。**\n  - **沟通协作能力：3/5分。依据：销售岗位需建立客户信任、处理异议，社团管理体现团队协调，但未验证非工作时间响应意愿。**\n\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. \"请描述一次你需要在有限时间内协调多方资源解决突发问题的经历，当时如何分工推进？\"\n    2. \"销售工作中遇到客户强烈异议时，你通常如何倾听并转化？举例说明。\"\n    3. \"你的简历显示2025年已有工作经历，能否澄清时间线？未来2-3年职业规划是否倾向长期深耕家政运营？\"\n  - 技术评估问题（2个）：\n    1. \"假设一位月嫂因突发疾病需临时下户，客户次日急需用人，你会如何协调换单并安抚双方？\"\n ",
    "aiScreen": "存疑",
    "hrReview": "淘汰",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. \"请描述一次你需要在有限时间内协调多方资源解决突发问题的经历，当时如何分工推进？\"\n2. \"销售工作中遇到客户强烈异议时，你通常如何倾听并转化？举例说明。\"\n3. \"你的简历显示2025年已有工作经历，能否澄清时间线？未来2-3年职业规划是否倾向长期深耕家政运营？\"\n4. \"假设一位月嫂因突发疾病需临时下户，客户次日急需用人，你会如何协调换单并安抚双方？\"\n5. \"如需向新入职月嫂讲解公司考勤与薪资发放规则，你会如何设计10分钟快速培训？\"",
    "capabilityMatch": "1. **人员维护能力：1/5分。依据：无月嫂/家政人员管理经验，仅京东订单检验涉及基础售后，与薪资物料发放场景差异大。**\n2. **订单安排能力：1/5分。依据：无订单调度或资源匹配经验，销售工作为客户对接而非服务人员排班管理。**\n3. **基础培训能力：2/5分。依据：英语社团有人员招新与活动统筹经验，但未涉及培训设计或知识传递，与月嫂培训场景关联弱。**\n4. **应急对接能力：1/5分。依据：京东售后跟进有基础客诉处理经验，但无急单响应或复杂协调场景验证。**\n5. **沟通协作能力：3/5分。依据：销售岗位需建立客户信任、处理异议，社团管理体现团队协调，但未验证非工作时间响应意愿。**",
    "created": ""
  },
  {
    "id": 197,
    "name": "谭圻琪",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "谭",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备多岗位服务协调经验（酒店工程部、旅行社计调、养老运营），擅长客户维护与突发状况处理，有微信群运营及线下活动主持经验，沟通表达与抗压能力可迁移至月嫂维护场景；熟练使用办公软件，符合数字化运营基础要求。",
    "risks": "无家政/母婴行业背景，人员维护与订单安排能力未经实证；23岁年龄与月嫂群体（通常35-50岁）存在代际沟通障碍；3段工作均不满1年，稳定性存疑；简历未体现非工作时间响应的实际经历。",
    "aiEval": "- 初筛结果：存疑\n- 优势分析：具备多岗位服务协调经验（酒店工程部、旅行社计调、养老运营），擅长客户维护与突发状况处理，有微信群运营及线下活动主持经验，沟通表达与抗压能力可迁移至月嫂维护场景；熟练使用办公软件，符合数字化运营基础要求。\n- 风险点：无家政/母婴行业背景，人员维护与订单安排能力未经实证；23岁年龄与月嫂群体（通常35-50岁）存在代际沟通障碍；3段工作均不满1年，稳定性存疑；简历未体现非工作时间响应的实际经历。\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：有养老用户微信群维护、考勤登记、办公用品发放经验，但无薪资核算及家政服务人员管理经历，月嫂群体特殊性未验证。\n  - **订单安排能力：2/5分。依据：旅行社计调涉及签证进度跟踪与行程协调，逻辑可迁移，但无服务人员排班、换单调度等同类场景实操。\n  - **基础培训能力：1/5分。依据：简历未体现任何培训授课经历，养老公司\"宣传新产品\"不等于人员培训，能力缺口明显。\n  - **应急对接能力：3/5分。依据：旅游团\"处理突发状况并安抚客人情绪\"、养老\"生活疑问解答\"与售后应急场景高度相关，有实际案例支撑。\n  - **沟通协作能力：4/5分。依据：自我评价及多岗位经历均强调沟通协调，跨部门协作（工程部/旅行社/运营）经验丰富，性格匹配度高。\n- 建议追问的面试问题：\n  - 行为面试问题1：请描述一次你处理客户突发投诉或紧急需求的具体经历，当时如何安抚对方情绪并推动问题解决？\n  - 行为面试问题2：过往工作中是否需要在非工作时间响应客户或同事信息？请举例说明频率及你的应对方式，如何平衡工作与生活？\n  - 行为面试问题3：你过往三段工作经历均不满一年，请说明离职原因，并谈谈对家政行业服务人员流动性高这一特点的理解与应对思路。\n  - 技术评估问题1：假设一位月嫂因家庭急事需临时下户，客户",
    "aiScreen": "存疑",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你处理客户突发投诉或紧急需求的具体经历，当时如何安抚对方情绪并推动问题解决？\n2. 过往工作中是否需要在非工作时间响应客户或同事信息？请举例说明频率及你的应对方式，如何平衡工作与生活？\n3. 你过往三段工作经历均不满一年，请说明离职原因，并谈谈对家政行业服务人员流动性高这一特点的理解与应对思路。\n4. 假设一位月嫂因家庭急事需临时下户，客户预产期临近且指定该月嫂，你会如何协调换单并安抚双方情绪？请分步骤说明。\n5. 月嫂群体普遍年龄较大、文化背景多样，你认为与她们建立信任关系的关键是什么？若遇到对数字化工具（如APP打卡）抵触的月嫂，如何推动其配合？",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：有养老用户微信群维护、考勤登记、办公用品发放经验，但无薪资核算及家政服务人员管理经历，月嫂群体特殊性未验证。\n2. **订单安排能力：2/5分。依据：旅行社计调涉及签证进度跟踪与行程协调，逻辑可迁移，但无服务人员排班、换单调度等同类场景实操。\n3. **基础培训能力：1/5分。依据：简历未体现任何培训授课经历，养老公司\"宣传新产品\"不等于人员培训，能力缺口明显。\n4. **应急对接能力：3/5分。依据：旅游团\"处理突发状况并安抚客人情绪\"、养老\"生活疑问解答\"与售后应急场景高度相关，有实际案例支撑。\n5. **沟通协作能力：4/5分。依据：自我评价及多岗位经历均强调沟通协调，跨部门协作（工程部/旅行社/运营）经验丰富，性格匹配度高。",
    "created": ""
  },
  {
    "id": 198,
    "name": "田辉",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "田",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备标准化运营与一线人员管理经验，擅长搭建培训体系（带教90+人次）、数据驱动决策（片区销量提升48%）及应急处理（客诉办结率100%），契合家政服务数字化、职业化需求；政企对接经验可迁移至月嫂/顾问多方协调场景。",
    "risks": "简历时间线存疑（2025/12-2026/03为未来日期），需核实真实性；无家政/母婴行业背景，专业培训能力待验证；24岁男性候选人与月嫂群体（女性为主）的日常维护场景存在文化适配挑战。",
    "aiEval": "- 初筛结果：通过\n- 优势分析：具备标准化运营与一线人员管理经验，擅长搭建培训体系（带教90+人次）、数据驱动决策（片区销量提升48%）及应急处理（客诉办结率100%），契合家政服务数字化、职业化需求；政企对接经验可迁移至月嫂/顾问多方协调场景。\n- 风险点：简历时间线存疑（2025/12-2026/03为未来日期），需核实真实性；无家政/母婴行业背景，专业培训能力待验证；24岁男性候选人与月嫂群体（女性为主）的日常维护场景存在文化适配挑战。\n- 能力维度匹配：\n  - **人员维护能力：3/5分。依据：统筹巡店、物资调配、资产盘点经验可迁移至月嫂工资物料发放，但无直接薪酬核算经历，需确认财务系统操作熟练度。\n  - **订单安排能力：4/5分。依据：主导千余台电单车调度、优化120+点位、日均500+台调度，资源匹配与动态调整能力突出，可迁移至月嫂订单排期与换单管理。\n  - **基础培训能力：4/5分。依据：累计培训导购90+人次、新员工带教通过率100%、搭建标准化巡检制度，培训体系设计与落地经验丰富，契合非专业培训场景。\n  - **应急对接能力：4/5分。依据：处理城管收车等突发问题取回80辆车、客诉120+次30分钟响应办结率100%、推动NPS从28%提升至40%，应急闭环与多方协调能力成熟。\n  - **沟通协作能力：4/5分。依据：常态化对接城管/交警/街道、化解政企矛盾、管辖期收车费用减少50%，跨部门协作与冲突处理能力经实证；简历未直接体现\"非工作时间信息回复\"接受度，需面试确认。\n- 建议追问的面试问题：\n  - 行为面试问题（3个）：\n    1. \"请描述一次你协调多方利益冲突的经历（如政企矛盾或客户投诉），当时各方诉求是什么？你采取了哪些步骤推动共识？\"\n    2. \"在你的经历中，是否有需要在非工作时间处理紧急事务的情况？请举例说明频率、",
    "aiScreen": "通过",
    "hrReview": "通过",
    "interviewPos": "商家运营专员",
    "interviewQ": "1. \"请描述一次你协调多方利益冲突的经历（如政企矛盾或客户投诉），当时各方诉求是什么？你采取了哪些步骤推动共识？\"\n2. \"在你的经历中，是否有需要在非工作时间处理紧急事务的情况？请举例说明频率、你的响应方式及如何平衡个人生活。\"\n3. \"你培训过90+人次新员工，其中是否有特别难带教或考核未通过的案例？你如何判断'不适合'并做出决策？\"\n4. \"假设一位月嫂因家庭突发状况需临时换单，但备选月嫂档期冲突、客户要求不降标，你会如何48小时内完成重新匹配并安抚双方？\"\n5. \"请用Excel或口述方式，说明如何设计一张月嫂月度工资表，需包含底薪、订单提成、全勤奖、物料扣款等字段，并解释如何避免核算错误。\"\n6. \"今天的交流到此，我想把话筒交给你——基于刚才我们对岗位的介绍，关于天鹅到家的业务模式、这个岗位的真实挑战、或者你未来直属团队的协作风格，有什么是你特别想了解或确认的吗？\"",
    "capabilityMatch": "1. **人员维护能力：3/5分。依据：统筹巡店、物资调配、资产盘点经验可迁移至月嫂工资物料发放，但无直接薪酬核算经历，需确认财务系统操作熟练度。\n2. **订单安排能力：4/5分。依据：主导千余台电单车调度、优化120+点位、日均500+台调度，资源匹配与动态调整能力突出，可迁移至月嫂订单排期与换单管理。\n3. **基础培训能力：4/5分。依据：累计培训导购90+人次、新员工带教通过率100%、搭建标准化巡检制度，培训体系设计与落地经验丰富，契合非专业培训场景。\n4. **应急对接能力：4/5分。依据：处理城管收车等突发问题取回80辆车、客诉120+次30分钟响应办结率100%、推动NPS从28%提升至40%，应急闭环与多方协调能力成熟。\n5. **沟通协作能力：4/5分。依据：常态化对接城管/交警/街道、化解政企矛盾、管辖期收车费用减少50%，跨部门协作与冲突处理能力经实证；简历未直接体现\"非工作时间信息回复\"接受度，需面试确认。",
    "created": ""
  },
  {
    "id": 199,
    "name": "屠佳文",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "屠",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备2年后台运营经验，熟悉活动全案策划与产销协同管理，擅长供应商对接（16家）及客户维护；执行力强，能快速适应多线程工作；熟练使用Office，符合数字化运营基础要求。",
    "risks": "无家政/母婴行业背景，月嫂育婴师专业知识为零基础；学历专科踩线满足；工作经历与\"非工作时间信息回复\"的强服务属性匹配度未验证；22岁年龄偏小，面对高情绪劳动的月嫂群体管理经验不足。",
    "aiEval": "- 初筛结果：通过\n- 优势分析：具备2年后台运营经验，熟悉活动全案策划与产销协同管理，擅长供应商对接（16家）及客户维护；执行力强，能快速适应多线程工作；熟练使用Office，符合数字化运营基础要求。\n- 风险点：专业背景为城市轨道交通，无家政/母婴行业经验；年龄21岁（2002年生），职场成熟度待观察；简历时间线存疑（2024.07-2026.04），需核实实际工作时长；仅2年经验需快速学习行业知识。\n- 能力维度匹配：\n  - **人员维护能力：3/5分。依据：有客户咨询反馈跟进、供应商合作维护经验，但无薪资物料发放、人员日常管理直接经验，需培训上手。\n  - **订单安排能力：3/5分。依据：具备产销协同、货品调配经验，逻辑清晰，但月嫂/育婴师订单调度场景差异大，行业知识为零。\n  - **基础培训能力：2/5分。依据：无培训相关经验；自我评价称\"善于倾听与落地执行\"，但培训能力需从零培养。\n  - **应急对接能力：3/5分。依据：有活动执行现场问题处理、客户反馈跟进经验，具备基础应变能力，但售后处理场景不同。\n  - **沟通协作能力：4/5分。依据：简历明确\"性格开朗善于沟通\"\"注重团队协作\"，有线上线下联动、多渠道沟通实证，匹配度高。\n- 建议追问的面试问题（5个）：\n  - 行为面试问题（3个）：\n    1. 请描述一次你与多方（如供应商、客户、内部团队）协调完成紧急任务的经历，具体如何分工和推进？\n    2. 在天台贝嘉姆工作期间，是否遇到过客户投诉或突发状况？当时如何处理，结果如何？\n    3. 你提到能接受非工作时间信息回复，能否举例说明你过往工作中如何平衡工作与生活，确保响应及时性的？\n  - 技术评估问题（2个）：\n    1. 假设一位月嫂因突发情况无法按约定上户，你会如何快速协调替换人员并与客户沟通？请分步骤说明。\n    2. 你认为",
    "aiScreen": "通过",
    "hrReview": "淘汰",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你与多方（如供应商、客户、内部团队）协调完成紧急任务的经历，具体如何分工和推进？\n2. 在天台贝嘉姆工作期间，是否遇到过客户投诉或突发状况？当时如何处理，结果如何？\n3. 你提到能接受非工作时间信息回复，能否举例说明你过往工作中如何平衡工作与生活，确保响应及时性的？\n4. 假设一位月嫂因突发情况无法按约定上户，你会如何快速协调替换人员并与客户沟通？请分步骤说明。\n5. 你认为月嫂/育婴师非专业培训（如服务礼仪、沟通规范）应包含哪些核心模块？如何设计让阿姨们愿意参与的培训形式？",
    "capabilityMatch": "1. **人员维护能力：3/5分。依据：有客户咨询反馈跟进、供应商合作维护经验，但无薪资物料发放、人员日常管理直接经验，需培训上手。\n2. **订单安排能力：3/5分。依据：具备产销协同、货品调配经验，逻辑清晰，但月嫂/育婴师订单调度场景差异大，行业知识为零。\n3. **基础培训能力：2/5分。依据：无培训相关经验；自我评价称\"善于倾听与落地执行\"，但培训能力需从零培养。\n4. **应急对接能力：3/5分。依据：有活动执行现场问题处理、客户反馈跟进经验，具备基础应变能力，但售后处理场景不同。\n5. **沟通协作能力：4/5分。依据：简历明确\"性格开朗善于沟通\"\"注重团队协作\"，有线上线下联动、多渠道沟通实证，匹配度高。",
    "created": ""
  },
  {
    "id": 200,
    "name": "汪涵勇",
    "role": "商家运营专员",
    "company": "商家运营部",
    "years": 0,
    "edu": "",
    "salary": "",
    "match": 0,
    "tags": [],
    "stage": "通过",
    "star": 1,
    "avatar": "汪",
    "dept": "雏渐肥事业部",
    "city": "杭州",
    "age": "",
    "gender": "",
    "strengths": "具备客户分层运营与社群管理经验，曾搭建500+人学员社群并维持40%活跃度；擅长标准化流程搭建，建立客户资质初筛标准使无效申请率降13个百分点；有从0到1运营企业微信社群经验，客户续签率从55%提升至85%，与家政服务人员的维护逻辑相通。",
    "risks": "行业跨度大（金融担保/在线教育→家政服务），无母婴护理、保洁等家政领域经验；简历未体现\"非工作时间响应\"的实际经历，仅在职担保公司期间有贷后客户维护；性别男（JD隐含偏好女性），年龄24岁（1999年生）符合21-28岁区间但偏年轻，稳定性待验证。",
    "aiEval": "- 初筛结果：**存疑**\n\n- 优势分析：具备客户分层运营与社群管理经验，曾搭建500+人学员社群并维持40%活跃度；擅长标准化流程搭建，建立客户资质初筛标准使无效申请率降13个百分点；有从0到1运营企业微信社群经验，客户续签率从55%提升至85%，与家政服务人员的维护逻辑相通。\n\n- 风险点：行业跨度大（金融担保/在线教育→家政服务），无母婴护理、保洁等家政领域经验；简历未体现\"非工作时间响应\"的实际经历，仅在职担保公司期间有贷后客户维护；性别男（JD隐含偏好女性），年龄24岁（1999年生）符合21-28岁区间但偏年轻，稳定性待验证。\n\n- 能力维度匹配：\n  - **人员维护能力：2/5分。依据：有客户社群运营与定期回访经验，但无薪资核算、物料发放等具体事务性操作经历，家政服务人员维护场景差异较大。\n  - **订单安排能力：2/5分。依据：曾协调客户与银行对接节奏缩短业务周期30%，具备基础调度意识，但无服务人员排班、换单调配的实际经验。\n  - **基础培训能力：2/5分。依据：负责过\"基金实战进阶私教班\"产品交付与教学内容优化，有培训体系搭建经验，但属专业知识培训，非家政非专业培训场景。\n  - **应急对接能力：3/5分。依据：贷后管理中识别18次逾期风险预警并协助制定风控方案，有售后问题处理与危机响应经验，但无急单对接的时效性压力测试。\n  - **沟通协作能力：4/5分。依据：自我评价明确\"性格开朗善于沟通\"，跨部门协作经验丰富（协同产品/教学/风控/法务），客户满意度达98%，续费率提升数据佐证沟通成效。\n\n- 建议追问的面试问题：\n  - 行为面试问题1：请描述一次你需要在深夜或周末紧急响应客户需求的经历，当时如何处理工作与个人时间的冲突？\n  - 行为面试问题2：在你维护的社群中，曾遇到客户强烈不满或投诉的情况吗？具体如何安抚并解决问题，最终结果如",
    "aiScreen": "存疑",
    "hrReview": "通过",
    "interviewPos": "商家运营专员（月休8天）",
    "interviewQ": "1. 请描述一次你需要在深夜或周末紧急响应客户需求的经历，当时如何处理工作与个人时间的冲突？\n2. 在你维护的社群中，曾遇到客户强烈不满或投诉的情况吗？具体如何安抚并解决问题，最终结果如何？\n3. 你的两份工作持续时间分别为20个月和7个月，请说明离职原因，并谈谈对家政行业基层岗位流动率高的看法。\n4. 假设一位月嫂因家中突发急事需临时下户，而客户预产期就在3天后，你会如何协调换单并安抚双方情绪？请分步骤说明。\n5. 家政服务人员常对薪资计算方式存在疑问，请设计一个清晰的工资条说明模板（口述框架），并说明如何向文化水平不高的月嫂解释绩效奖金规则。",
    "capabilityMatch": "1. **人员维护能力：2/5分。依据：有客户社群运营与定期回访经验，但无薪资核算、物料发放等具体事务性操作经历，家政服务人员维护场景差异较大。\n2. **订单安排能力：2/5分。依据：曾协调客户与银行对接节奏缩短业务周期30%，具备基础调度意识，但无服务人员排班、换单调配的实际经验。\n3. **基础培训能力：2/5分。依据：负责过\"基金实战进阶私教班\"产品交付与教学内容优化，有培训体系搭建经验，但属专业知识培训，非家政非专业培训场景。\n4. **应急对接能力：3/5分。依据：贷后管理中识别18次逾期风险预警并协助制定风控方案，有售后问题处理与危机响应经验，但无急单对接的时效性压力测试。\n5. **沟通协作能力：4/5分。依据：自我评价明确\"性格开朗善于沟通\"，跨部门协作经验丰富（协同产品/教学/风控/法务），客户满意度达98%，续费率提升数据佐证沟通成效。",
    "created": ""
  }
];
